(() => {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("YChVI", function(module, exports) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    "use strict";
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === "[object Array]";
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === "[object Object]";
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === "number" || Object.prototype.toString.call(input) === "[object Number]";
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === "[object Date]";
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, "toString")) a.toString = b.toString;
        if (hasOwnProp(b, "valueOf")) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== "undefined" && console.warn) console.warn("Deprecation warning: " + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = "";
                    if (typeof arguments[i] === "object") {
                        arg += "\n[" + i + "] ";
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ": " + arguments[0][key] + ", ";
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + "\nArguments: " + Array.prototype.slice.call(args).join("") + "\n" + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== "undefined" && input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this["_" + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: "[Today at] LT",
        nextDay: "[Tomorrow at] LT",
        nextWeek: "dddd [at] LT",
        lastDay: "[Yesterday at] LT",
        lastWeek: "[Last] dddd [at] LT",
        sameElse: "L"
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar["sameElse"];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = "" + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? "+" : "" : "-") + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === "string") func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, "");
        return input.replace(/\\/g, "");
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = "", i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === "MMMM" || tok === "MM" || tok === "DD" || tok === "dddd") return tok.slice(1);
            return tok;
        }).join("");
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = "Invalid date";
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace("%d", number);
    }
    var defaultRelativeTime = {
        future: "in %s",
        past: "%s ago",
        s: "a few seconds",
        ss: "%d seconds",
        m: "a minute",
        mm: "%d minutes",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        w: "a week",
        ww: "%d weeks",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? "future" : "past"];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: "date",
        dates: "date",
        date: "date",
        d: "day",
        days: "day",
        day: "day",
        e: "weekday",
        weekdays: "weekday",
        weekday: "weekday",
        E: "isoWeekday",
        isoweekdays: "isoWeekday",
        isoweekday: "isoWeekday",
        DDD: "dayOfYear",
        dayofyears: "dayOfYear",
        dayofyear: "dayOfYear",
        h: "hour",
        hours: "hour",
        hour: "hour",
        ms: "millisecond",
        milliseconds: "millisecond",
        millisecond: "millisecond",
        m: "minute",
        minutes: "minute",
        minute: "minute",
        M: "month",
        months: "month",
        month: "month",
        Q: "quarter",
        quarters: "quarter",
        quarter: "quarter",
        s: "second",
        seconds: "second",
        second: "second",
        gg: "weekYear",
        weekyears: "weekYear",
        weekyear: "weekYear",
        GG: "isoWeekYear",
        isoweekyears: "isoWeekYear",
        isoweekyear: "isoWeekYear",
        w: "week",
        weeks: "week",
        week: "week",
        W: "isoWeek",
        isoweeks: "isoWeek",
        isoweek: "isoWeek",
        y: "year",
        years: "year",
        year: "year"
    };
    function normalizeUnits(units) {
        return typeof units === "string" ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === "string") token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken("Y", 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : "+" + y;
    });
    addFormatToken(0, [
        "YY",
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        "YYYY",
        4
    ], 0, "year");
    addFormatToken(0, [
        "YYYYY",
        5
    ], 0, "year");
    addFormatToken(0, [
        "YYYYYY",
        6,
        true
    ], 0, "year");
    // PARSING
    addRegexToken("Y", matchSigned);
    addRegexToken("YY", match1to2, match2);
    addRegexToken("YYYY", match1to4, match4);
    addRegexToken("YYYYY", match1to6, match6);
    addRegexToken("YYYYYY", match1to6, match6);
    addParseToken([
        "YYYYY",
        "YYYYYY"
    ], YEAR);
    addParseToken("YYYY", function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken("YY", function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken("Y", function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet("FullYear", true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case "Milliseconds":
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case "Seconds":
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case "Minutes":
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case "Hours":
                return isUTC ? d.getUTCHours() : d.getHours();
            case "Date":
                return isUTC ? d.getUTCDate() : d.getDate();
            case "Day":
                return isUTC ? d.getUTCDay() : d.getDay();
            case "Month":
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case "FullYear":
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case "Milliseconds":
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case "Seconds":
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case "Minutes":
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case "Hours":
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case "Date":
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case "FullYear":
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === "object") {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken("M", [
        "MM",
        2
    ], "Mo", function() {
        return this.month() + 1;
    });
    addFormatToken("MMM", 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken("MMMM", 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken("M", match1to2, match1to2NoLeadingZero);
    addRegexToken("MM", match1to2, match2);
    addRegexToken("MMM", function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken("MMMM", function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        "M",
        "MM"
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        "MMM",
        "MMMM"
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months["standalone"];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? "format" : "standalone"][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort["standalone"];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? "format" : "standalone"][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, "").toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "MMM") {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === "MMM") {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp("^" + this.months(mom, "").replace(".", "") + "$", "i");
                this._shortMonthsParse[i] = new RegExp("^" + this.monthsShort(mom, "").replace(".", "") + "$", "i");
            }
            if (!strict && !this._monthsParse[i]) {
                regex = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
                this._monthsParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "MMMM" && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === "MMM" && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === "string") {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, "Month");
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, "_monthsShortRegex")) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, "_monthsRegex")) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ""));
            longP = regexEscape(this.months(mom, ""));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._monthsShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken("w", [
        "ww",
        2
    ], "wo", "week");
    addFormatToken("W", [
        "WW",
        2
    ], "Wo", "isoWeek");
    // PARSING
    addRegexToken("w", match1to2, match1to2NoLeadingZero);
    addRegexToken("ww", match1to2, match2);
    addRegexToken("W", match1to2, match1to2NoLeadingZero);
    addRegexToken("WW", match1to2, match2);
    addWeekParseToken([
        "w",
        "ww",
        "W",
        "WW"
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    // FORMATTING
    addFormatToken("d", 0, "do", "day");
    addFormatToken("dd", 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken("ddd", 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken("dddd", 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken("e", 0, 0, "weekday");
    addFormatToken("E", 0, 0, "isoWeekday");
    // PARSING
    addRegexToken("d", match1to2);
    addRegexToken("e", match1to2);
    addRegexToken("E", match1to2);
    addRegexToken("dd", function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken("ddd", function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken("dddd", function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        "dd",
        "ddd",
        "dddd"
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        "d",
        "e",
        "E"
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== "string") return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === "number") return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === "string") return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? "format" : "standalone"];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, "").toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, "").toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp("^" + this.weekdays(mom, "").replace(".", "\\.?") + "$", "i");
                this._shortWeekdaysParse[i] = new RegExp("^" + this.weekdaysShort(mom, "").replace(".", "\\.?") + "$", "i");
                this._minWeekdaysParse[i] = new RegExp("^" + this.weekdaysMin(mom, "").replace(".", "\\.?") + "$", "i");
            }
            if (!this._weekdaysParse[i]) {
                regex = "^" + this.weekdays(mom, "") + "|^" + this.weekdaysShort(mom, "") + "|^" + this.weekdaysMin(mom, "");
                this._weekdaysParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "dddd" && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "ddd" && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "dd" && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, "Day");
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, "d");
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, "d");
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysRegex")) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysShortRegex")) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysMinRegex")) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ""));
            shortp = regexEscape(this.weekdaysShort(mom, ""));
            longp = regexEscape(this.weekdays(mom, ""));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._weekdaysShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
        this._weekdaysMinStrictRegex = new RegExp("^(" + minPieces.join("|") + ")", "i");
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken("H", [
        "HH",
        2
    ], 0, "hour");
    addFormatToken("h", [
        "hh",
        2
    ], 0, hFormat);
    addFormatToken("k", [
        "kk",
        2
    ], 0, kFormat);
    addFormatToken("hmm", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken("hmmss", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken("Hmm", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken("Hmmss", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem("a", true);
    meridiem("A", false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken("a", matchMeridiem);
    addRegexToken("A", matchMeridiem);
    addRegexToken("H", match1to2, match1to2HasZero);
    addRegexToken("h", match1to2, match1to2NoLeadingZero);
    addRegexToken("k", match1to2, match1to2NoLeadingZero);
    addRegexToken("HH", match1to2, match2);
    addRegexToken("hh", match1to2, match2);
    addRegexToken("kk", match1to2, match2);
    addRegexToken("hmm", match3to4);
    addRegexToken("hmmss", match5to6);
    addRegexToken("Hmm", match3to4);
    addRegexToken("Hmmss", match5to6);
    addParseToken([
        "H",
        "HH"
    ], HOUR);
    addParseToken([
        "k",
        "kk"
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        "a",
        "A"
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        "h",
        "hh"
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("Hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken("Hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + "").toLowerCase().charAt(0) === "p";
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet("Hours", true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? "pm" : "PM";
        else return isLower ? "am" : "AM";
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace("_", "-") : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split("-");
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split("-") : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join("-"));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match("^[^/\\\\]*$"));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire("./locale/" + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== "undefined" && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn("Locale " + key + " not found. Did you forget to load it?");
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            "YYYYYY-MM-DD",
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            "YYYY-MM-DD",
            /\d{4}-\d\d-\d\d/
        ],
        [
            "GGGG-[W]WW-E",
            /\d{4}-W\d\d-\d/
        ],
        [
            "GGGG-[W]WW",
            /\d{4}-W\d\d/,
            false
        ],
        [
            "YYYY-DDD",
            /\d{4}-\d{3}/
        ],
        [
            "YYYY-MM",
            /\d{4}-\d\d/,
            false
        ],
        [
            "YYYYYYMMDD",
            /[+-]\d{10}/
        ],
        [
            "YYYYMMDD",
            /\d{8}/
        ],
        [
            "GGGG[W]WWE",
            /\d{4}W\d{3}/
        ],
        [
            "GGGG[W]WW",
            /\d{4}W\d{2}/,
            false
        ],
        [
            "YYYYDDD",
            /\d{7}/
        ],
        [
            "YYYYMM",
            /\d{6}/,
            false
        ],
        [
            "YYYY",
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            "HH:mm:ss.SSSS",
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            "HH:mm:ss,SSSS",
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            "HH:mm:ss",
            /\d\d:\d\d:\d\d/
        ],
        [
            "HH:mm",
            /\d\d:\d\d/
        ],
        [
            "HHmmss.SSSS",
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            "HHmmss,SSSS",
            /\d\d\d\d\d\d,\d+/
        ],
        [
            "HHmmss",
            /\d\d\d\d\d\d/
        ],
        [
            "HHmm",
            /\d\d\d\d/
        ],
        [
            "HH",
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || " ") + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = "Z";
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || "") + (tzFormat || "");
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? " UTC" : ""));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== "undefined" && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = "" + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, "d");
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === "") return createInvalid({
            nullInput: true
        });
        if (typeof input === "string") config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === "string") configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isBefore", args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isAfter", args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        "year",
        "quarter",
        "month",
        "week",
        "day",
        "hour",
        "minute",
        "second",
        "millisecond"
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = "+";
            if (offset < 0) {
                offset = -offset;
                sign = "-";
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset("Z", ":");
    offset("ZZ", "");
    // PARSING
    addRegexToken("Z", matchShortOffset);
    addRegexToken("ZZ", matchShortOffset);
    addParseToken([
        "Z",
        "ZZ"
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || "").match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + "").match(chunkOffset) || [
            "-",
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === "+" ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === "string") {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, "m");
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, "m"), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== "string") input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), "m");
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === "string") {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === "object" && ("from" in duration || "to" in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, "_locale")) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, "_isValid")) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(",", "."));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, "M").isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, "M");
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, "moment()." + name + "(period, number) is deprecated. Please use moment()." + name + "(number, period). " + "See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.");
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, "Month") + months * isAdding);
        if (days) set$1(mom, "Date", get(mom, "Date") + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, "add"), subtract = createAdder(-1, "subtract");
    function isString(input) {
        return typeof input === "string" || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "years",
            "year",
            "y",
            "months",
            "month",
            "M",
            "days",
            "day",
            "d",
            "dates",
            "date",
            "D",
            "hours",
            "hour",
            "h",
            "minutes",
            "minute",
            "m",
            "seconds",
            "second",
            "s",
            "milliseconds",
            "millisecond",
            "ms"
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "sameDay",
            "nextDay",
            "lastDay",
            "nextWeek",
            "lastWeek",
            "sameElse"
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, "days", true);
        return diff < -6 ? "sameElse" : diff < -1 ? "lastWeek" : diff < 0 ? "lastDay" : diff < 1 ? "sameDay" : diff < 2 ? "nextDay" : diff < 7 ? "nextWeek" : "sameElse";
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf("day"), format = hooks.calendarFormat(this, sod) || "sameElse", output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || "()";
        return (inclusivity[0] === "(" ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ")" ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case "year":
                output = monthDiff(this, that) / 12;
                break;
            case "month":
                output = monthDiff(this, that);
                break;
            case "quarter":
                output = monthDiff(this, that) / 3;
                break;
            case "second":
                output = (this - that) / 1e3;
                break; // 1000
            case "minute":
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case "hour":
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case "day":
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case "week":
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, "months"), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
    hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
    function toString() {
        return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ");
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace("Z", formatMoment(m, "Z"));
        }
        return formatMoment(m, utc ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
        var func = "moment", zone = "", prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone";
            zone = "Z";
        }
        prefix = "[" + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY";
        datetime = "-MM-DD[T]HH:mm:ss.SSS";
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year(), 0, 1);
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case "month":
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case "hour":
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case "minute":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case "second":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case "month":
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case "hour":
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case "minute":
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case "second":
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken("N", 0, 0, "eraAbbr");
    addFormatToken("NN", 0, 0, "eraAbbr");
    addFormatToken("NNN", 0, 0, "eraAbbr");
    addFormatToken("NNNN", 0, 0, "eraName");
    addFormatToken("NNNNN", 0, 0, "eraNarrow");
    addFormatToken("y", [
        "y",
        1
    ], "yo", "eraYear");
    addFormatToken("y", [
        "yy",
        2
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyy",
        3
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyyy",
        4
    ], 0, "eraYear");
    addRegexToken("N", matchEraAbbr);
    addRegexToken("NN", matchEraAbbr);
    addRegexToken("NNN", matchEraAbbr);
    addRegexToken("NNNN", matchEraName);
    addRegexToken("NNNNN", matchEraNarrow);
    addParseToken([
        "N",
        "NN",
        "NNN",
        "NNNN",
        "NNNNN"
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken("y", matchUnsigned);
    addRegexToken("yy", matchUnsigned);
    addRegexToken("yyy", matchUnsigned);
    addRegexToken("yyyy", matchUnsigned);
    addRegexToken("yo", matchEraYearOrdinal);
    addParseToken([
        "y",
        "yy",
        "yyy",
        "yyyy"
    ], YEAR);
    addParseToken([
        "yo"
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale("en")._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case "string":
                    // truncate time
                    date = hooks(eras[i].since).startOf("day");
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case "undefined":
                    eras[i].until = Infinity;
                    break;
                case "string":
                    // truncate time
                    date = hooks(eras[i].until).startOf("day").valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case "N":
                case "NN":
                case "NNN":
                    if (abbr === eraName) return eras[i];
                    break;
                case "NNNN":
                    if (name === eraName) return eras[i];
                    break;
                case "NNNNN":
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return "";
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return "";
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return "";
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNameRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, "_erasAbbrRegex")) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNarrowRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._erasNameRegex = new RegExp("^(" + namePieces.join("|") + ")", "i");
        this._erasAbbrRegex = new RegExp("^(" + abbrPieces.join("|") + ")", "i");
        this._erasNarrowRegex = new RegExp("^(" + narrowPieces.join("|") + ")", "i");
    }
    // FORMATTING
    addFormatToken(0, [
        "gg",
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        "GG",
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken("gggg", "weekYear");
    addWeekYearFormatToken("ggggg", "weekYear");
    addWeekYearFormatToken("GGGG", "isoWeekYear");
    addWeekYearFormatToken("GGGGG", "isoWeekYear");
    // ALIASES
    // PARSING
    addRegexToken("G", matchSigned);
    addRegexToken("g", matchSigned);
    addRegexToken("GG", match1to2, match2);
    addRegexToken("gg", match1to2, match2);
    addRegexToken("GGGG", match1to4, match4);
    addRegexToken("gggg", match1to4, match4);
    addRegexToken("GGGGG", match1to6, match6);
    addRegexToken("ggggg", match1to6, match6);
    addWeekParseToken([
        "gggg",
        "ggggg",
        "GGGG",
        "GGGGG"
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        "gg",
        "GG"
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken("Q", 0, "Qo", "quarter");
    // PARSING
    addRegexToken("Q", match1);
    addParseToken("Q", function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken("D", [
        "DD",
        2
    ], "Do", "date");
    // PARSING
    addRegexToken("D", match1to2, match1to2NoLeadingZero);
    addRegexToken("DD", match1to2, match2);
    addRegexToken("Do", function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        "D",
        "DD"
    ], DATE);
    addParseToken("Do", function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet("Date", true);
    // FORMATTING
    addFormatToken("DDD", [
        "DDDD",
        3
    ], "DDDo", "dayOfYear");
    // PARSING
    addRegexToken("DDD", match1to3);
    addRegexToken("DDDD", match3);
    addParseToken([
        "DDD",
        "DDDD"
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, "d");
    }
    // FORMATTING
    addFormatToken("m", [
        "mm",
        2
    ], 0, "minute");
    // PARSING
    addRegexToken("m", match1to2, match1to2HasZero);
    addRegexToken("mm", match1to2, match2);
    addParseToken([
        "m",
        "mm"
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet("Minutes", false);
    // FORMATTING
    addFormatToken("s", [
        "ss",
        2
    ], 0, "second");
    // PARSING
    addRegexToken("s", match1to2, match1to2HasZero);
    addRegexToken("ss", match1to2, match2);
    addParseToken([
        "s",
        "ss"
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet("Seconds", false);
    // FORMATTING
    addFormatToken("S", 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        "SS",
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        "SSS",
        3
    ], 0, "millisecond");
    addFormatToken(0, [
        "SSSS",
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        "SSSSS",
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        "SSSSSS",
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        "SSSSSSS",
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        "SSSSSSSS",
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        "SSSSSSSSS",
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken("S", match1to3, match1);
    addRegexToken("SS", match1to3, match2);
    addRegexToken("SSS", match1to3, match3);
    var token, getSetMillisecond;
    for(token = "SSSS"; token.length <= 9; token += "S")addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(("0." + input) * 1000);
    }
    for(token = "S"; token.length <= 9; token += "S")addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet("Milliseconds", false);
    // FORMATTING
    addFormatToken("z", 0, 0, "zoneAbbr");
    addFormatToken("zz", 0, 0, "zoneName");
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? "UTC" : "";
    }
    function getZoneName() {
        return this._isUTC ? "Coordinated Universal Time" : "";
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== "undefined" && Symbol.for != null) proto[Symbol.for("nodejs.util.inspect.custom")] = function() {
        return "Moment<" + this.format() + ">";
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate("dates accessor is deprecated. Use date instead.", getSetDayOfMonth);
    proto.months = deprecate("months accessor is deprecated. Use month instead", getSetMonth);
    proto.years = deprecate("years accessor is deprecated. Use year instead", getSetYear);
    proto.zone = deprecate("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", getSetZone);
    proto.isDSTShifted = deprecate("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || "";
        if (index != null) return get$1(format, index, field, "month");
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, "month");
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === "boolean") {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, "day");
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, "day");
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, "months");
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, "monthsShort");
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdays");
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysShort");
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysMin");
    }
    getSetGlobalLocale("en", {
        eras: [
            {
                since: "0001-01-01",
                until: Infinity,
                offset: 1,
                name: "Anno Domini",
                narrow: "AD",
                abbr: "AD"
            },
            {
                since: "0000-12-31",
                until: -Infinity,
                offset: 1,
                name: "Before Christ",
                narrow: "BC",
                abbr: "BC"
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate("moment.lang is deprecated. Use moment.locale instead.", getSetGlobalLocale);
    hooks.langData = deprecate("moment.langData is deprecated. Use moment.localeData instead.", getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === "month" || units === "quarter" || units === "year") {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case "month":
                    return months;
                case "quarter":
                    return months / 3;
                case "year":
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case "week":
                    return days / 7 + milliseconds / 6048e5;
                case "day":
                    return days + milliseconds / 864e5;
                case "hour":
                    return days * 24 + milliseconds / 36e5;
                case "minute":
                    return days * 1440 + milliseconds / 6e4;
                case "second":
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case "millisecond":
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error("Unknown unit " + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y"), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + "s"]() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter("milliseconds"), seconds = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months = makeGetter("months"), years = makeGetter("years");
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as("s")), minutes = round(duration.as("m")), hours = round(duration.as("h")), days = round(duration.as("d")), months = round(duration.as("M")), weeks = round(duration.as("w")), years = round(duration.as("y")), a = seconds <= thresholds.ss && [
            "s",
            seconds
        ] || seconds < thresholds.s && [
            "ss",
            seconds
        ] || minutes <= 1 && [
            "m"
        ] || minutes < thresholds.m && [
            "mm",
            minutes
        ] || hours <= 1 && [
            "h"
        ] || hours < thresholds.h && [
            "hh",
            hours
        ] || days <= 1 && [
            "d"
        ] || days < thresholds.d && [
            "dd",
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            "w"
        ] || weeks < thresholds.w && [
            "ww",
            weeks
        ];
        a = a || months <= 1 && [
            "M"
        ] || months < thresholds.M && [
            "MM",
            months
        ] || years <= 1 && [
            "y"
        ] || [
            "yy",
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === "function") {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === "s") thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === "object") {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === "boolean") withSuffix = argWithSuffix;
        if (typeof argThresholds === "object") {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return "P0D";
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, "") : "";
        totalSign = total < 0 ? "-" : "";
        ymSign = sign(this._months) !== sign(total) ? "-" : "";
        daysSign = sign(this._days) !== sign(total) ? "-" : "";
        hmsSign = sign(this._milliseconds) !== sign(total) ? "-" : "";
        return totalSign + "P" + (years ? ymSign + years + "Y" : "") + (months ? ymSign + months + "M" : "") + (days ? daysSign + days + "D" : "") + (hours || minutes || seconds ? "T" : "") + (hours ? hmsSign + hours + "H" : "") + (minutes ? hmsSign + minutes + "M" : "") + (seconds ? hmsSign + s + "S" : "");
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken("X", 0, 0, "unix");
    addFormatToken("x", 0, 0, "valueOf");
    // PARSING
    addRegexToken("x", matchSigned);
    addRegexToken("X", matchTimestamp);
    addParseToken("X", function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken("x", function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = "2.30.1";
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
        DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
        DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
        DATE: "YYYY-MM-DD",
        TIME: "HH:mm",
        TIME_SECONDS: "HH:mm:ss",
        TIME_MS: "HH:mm:ss.SSS",
        WEEK: "GGGG-[W]WW",
        MONTH: "YYYY-MM"
    };
    return hooks;
});

});

var $450fc775b2f7950e$var$n, $450fc775b2f7950e$export$41c562ebe57d11e2, $450fc775b2f7950e$var$u, $450fc775b2f7950e$export$a8257692ac88316c, $450fc775b2f7950e$var$t, $450fc775b2f7950e$var$r, $450fc775b2f7950e$var$o, $450fc775b2f7950e$var$f, $450fc775b2f7950e$var$e, $450fc775b2f7950e$var$c = {}, $450fc775b2f7950e$var$s = [], $450fc775b2f7950e$var$a = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
function $450fc775b2f7950e$var$h(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $450fc775b2f7950e$var$v(n) {
    var l = n.parentNode;
    l && l.removeChild(n);
}
function $450fc775b2f7950e$export$c8a8987d4410bf2d(l, u, i) {
    var t, r, o, f = {};
    for(o in u)"key" == o ? t = u[o] : "ref" == o ? r = u[o] : f[o] = u[o];
    if (arguments.length > 2 && (f.children = arguments.length > 3 ? $450fc775b2f7950e$var$n.call(arguments, 2) : i), "function" == typeof l && null != l.defaultProps) for(o in l.defaultProps)void 0 === f[o] && (f[o] = l.defaultProps[o]);
    return $450fc775b2f7950e$var$p(l, f, t, r, null);
}
function $450fc775b2f7950e$var$p(n, i, t, r, o) {
    var f = {
        type: n,
        props: i,
        key: t,
        ref: r,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        __h: null,
        constructor: void 0,
        __v: null == o ? ++$450fc775b2f7950e$var$u : o
    };
    return null == o && null != $450fc775b2f7950e$export$41c562ebe57d11e2.vnode && $450fc775b2f7950e$export$41c562ebe57d11e2.vnode(f), f;
}
function $450fc775b2f7950e$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $450fc775b2f7950e$export$ffb0004e005737fa(n) {
    return n.children;
}
function $450fc775b2f7950e$var$k(n, l, u, i, t) {
    var r;
    for(r in u)"children" === r || "key" === r || r in l || $450fc775b2f7950e$var$g(n, r, null, u[r], i);
    for(r in l)t && "function" != typeof l[r] || "children" === r || "key" === r || "value" === r || "checked" === r || u[r] === l[r] || $450fc775b2f7950e$var$g(n, r, l[r], u[r], i);
}
function $450fc775b2f7950e$var$b(n, l, u) {
    "-" === l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || $450fc775b2f7950e$var$a.test(l) ? u : u + "px";
}
function $450fc775b2f7950e$var$g(n, l, u, i, t) {
    var r;
    n: if ("style" === l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof i && (n.style.cssText = i = ""), i) for(l in i)u && l in u || $450fc775b2f7950e$var$b(n.style, l, "");
            if (u) for(l in u)i && u[l] === i[l] || $450fc775b2f7950e$var$b(n.style, l, u[l]);
        }
    } else if ("o" === l[0] && "n" === l[1]) r = l !== (l = l.replace(/Capture$/, "")), l = l.toLowerCase() in n ? l.toLowerCase().slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + r] = u, u ? i || n.addEventListener(l, r ? $450fc775b2f7950e$var$w : $450fc775b2f7950e$var$m, r) : n.removeEventListener(l, r ? $450fc775b2f7950e$var$w : $450fc775b2f7950e$var$m, r);
    else if ("dangerouslySetInnerHTML" !== l) {
        if (t) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" !== l && "height" !== l && "href" !== l && "list" !== l && "form" !== l && "tabIndex" !== l && "download" !== l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || !1 === u && -1 == l.indexOf("-") ? n.removeAttribute(l) : n.setAttribute(l, u));
    }
}
function $450fc775b2f7950e$var$m(n) {
    $450fc775b2f7950e$var$t = !0;
    try {
        return this.l[n.type + !1]($450fc775b2f7950e$export$41c562ebe57d11e2.event ? $450fc775b2f7950e$export$41c562ebe57d11e2.event(n) : n);
    } finally{
        $450fc775b2f7950e$var$t = !1;
    }
}
function $450fc775b2f7950e$var$w(n) {
    $450fc775b2f7950e$var$t = !0;
    try {
        return this.l[n.type + !0]($450fc775b2f7950e$export$41c562ebe57d11e2.event ? $450fc775b2f7950e$export$41c562ebe57d11e2.event(n) : n);
    } finally{
        $450fc775b2f7950e$var$t = !1;
    }
}
function $450fc775b2f7950e$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $450fc775b2f7950e$var$A(n, l) {
    if (null == l) return n.__ ? $450fc775b2f7950e$var$A(n.__, n.__.__k.indexOf(n) + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $450fc775b2f7950e$var$A(n) : null;
}
function $450fc775b2f7950e$var$P(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $450fc775b2f7950e$var$P(n);
    }
}
function $450fc775b2f7950e$var$C(n) {
    $450fc775b2f7950e$var$t ? setTimeout(n) : $450fc775b2f7950e$var$f(n);
}
function $450fc775b2f7950e$var$T(n) {
    (!n.__d && (n.__d = !0) && $450fc775b2f7950e$var$r.push(n) && !$450fc775b2f7950e$var$$.__r++ || $450fc775b2f7950e$var$o !== $450fc775b2f7950e$export$41c562ebe57d11e2.debounceRendering) && (($450fc775b2f7950e$var$o = $450fc775b2f7950e$export$41c562ebe57d11e2.debounceRendering) || $450fc775b2f7950e$var$C)($450fc775b2f7950e$var$$);
}
function $450fc775b2f7950e$var$$() {
    var n, l, u, i, t, o, f, e;
    for($450fc775b2f7950e$var$r.sort(function(n, l) {
        return n.__v.__b - l.__v.__b;
    }); n = $450fc775b2f7950e$var$r.shift();)n.__d && (l = $450fc775b2f7950e$var$r.length, i = void 0, t = void 0, f = (o = (u = n).__v).__e, (e = u.__P) && (i = [], (t = $450fc775b2f7950e$var$h({}, o)).__v = o.__v + 1, $450fc775b2f7950e$var$M(e, o, t, u.__n, void 0 !== e.ownerSVGElement, null != o.__h ? [
        f
    ] : null, i, null == f ? $450fc775b2f7950e$var$A(o) : f, o.__h), $450fc775b2f7950e$var$N(i, o), o.__e != f && $450fc775b2f7950e$var$P(o)), $450fc775b2f7950e$var$r.length > l && $450fc775b2f7950e$var$r.sort(function(n, l) {
        return n.__v.__b - l.__v.__b;
    }));
    $450fc775b2f7950e$var$$.__r = 0;
}
function $450fc775b2f7950e$var$H(n, l, u, i, t, r, o, f, e, a) {
    var h, v, y, d, k, b, g, m = i && i.__k || $450fc775b2f7950e$var$s, w = m.length;
    for(u.__k = [], h = 0; h < l.length; h++)if (null != (d = u.__k[h] = null == (d = l[h]) || "boolean" == typeof d ? null : "string" == typeof d || "number" == typeof d || "bigint" == typeof d ? $450fc775b2f7950e$var$p(null, d, null, null, d) : Array.isArray(d) ? $450fc775b2f7950e$var$p($450fc775b2f7950e$export$ffb0004e005737fa, {
        children: d
    }, null, null, null) : d.__b > 0 ? $450fc775b2f7950e$var$p(d.type, d.props, d.key, d.ref ? d.ref : null, d.__v) : d)) {
        if (d.__ = u, d.__b = u.__b + 1, null === (y = m[h]) || y && d.key == y.key && d.type === y.type) m[h] = void 0;
        else for(v = 0; v < w; v++){
            if ((y = m[v]) && d.key == y.key && d.type === y.type) {
                m[v] = void 0;
                break;
            }
            y = null;
        }
        $450fc775b2f7950e$var$M(n, d, y = y || $450fc775b2f7950e$var$c, t, r, o, f, e, a), k = d.__e, (v = d.ref) && y.ref != v && (g || (g = []), y.ref && g.push(y.ref, null, d), g.push(v, d.__c || k, d)), null != k ? (null == b && (b = k), "function" == typeof d.type && d.__k === y.__k ? d.__d = e = $450fc775b2f7950e$var$I(d, e, n) : e = $450fc775b2f7950e$var$z(n, d, y, m, k, e), "function" == typeof u.type && (u.__d = e)) : e && y.__e == e && e.parentNode != n && (e = $450fc775b2f7950e$var$A(y));
    }
    for(u.__e = b, h = w; h--;)null != m[h] && ("function" == typeof u.type && null != m[h].__e && m[h].__e == u.__d && (u.__d = $450fc775b2f7950e$var$L(i).nextSibling), $450fc775b2f7950e$var$q(m[h], m[h]));
    if (g) for(h = 0; h < g.length; h++)$450fc775b2f7950e$var$S(g[h], g[++h], g[++h]);
}
function $450fc775b2f7950e$var$I(n, l, u) {
    for(var i, t = n.__k, r = 0; t && r < t.length; r++)(i = t[r]) && (i.__ = n, l = "function" == typeof i.type ? $450fc775b2f7950e$var$I(i, l, u) : $450fc775b2f7950e$var$z(u, i, i, t, i.__e, l));
    return l;
}
function $450fc775b2f7950e$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || (Array.isArray(n) ? n.some(function(n) {
        $450fc775b2f7950e$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $450fc775b2f7950e$var$z(n, l, u, i, t, r) {
    var o, f, e;
    if (void 0 !== l.__d) o = l.__d, l.__d = void 0;
    else if (null == u || t != r || null == t.parentNode) n: if (null == r || r.parentNode !== n) n.appendChild(t), o = null;
    else {
        for(f = r, e = 0; (f = f.nextSibling) && e < i.length; e += 1)if (f == t) break n;
        n.insertBefore(t, r), o = r;
    }
    return void 0 !== o ? o : t.nextSibling;
}
function $450fc775b2f7950e$var$L(n) {
    var l, u, i;
    if (null == n.type || "string" == typeof n.type) return n.__e;
    if (n.__k) {
        for(l = n.__k.length - 1; l >= 0; l--)if ((u = n.__k[l]) && (i = $450fc775b2f7950e$var$L(u))) return i;
    }
    return null;
}
function $450fc775b2f7950e$var$M(n, u, i, t, r, o, f, e, c) {
    var s, a, v, y, p, d, k, b, g, m, w, A, P, C, T, $ = u.type;
    if (void 0 !== u.constructor) return null;
    null != i.__h && (c = i.__h, e = u.__e = i.__e, u.__h = null, o = [
        e
    ]), (s = $450fc775b2f7950e$export$41c562ebe57d11e2.__b) && s(u);
    try {
        n: if ("function" == typeof $) {
            if (b = u.props, g = (s = $.contextType) && t[s.__c], m = s ? g ? g.props.value : s.__ : t, i.__c ? k = (a = u.__c = i.__c).__ = a.__E : ("prototype" in $ && $.prototype.render ? u.__c = a = new $(b, m) : (u.__c = a = new $450fc775b2f7950e$export$16fa2f45be04daa8(b, m), a.constructor = $, a.render = $450fc775b2f7950e$var$B), g && g.sub(a), a.props = b, a.state || (a.state = {}), a.context = m, a.__n = t, v = a.__d = !0, a.__h = [], a._sb = []), null == a.__s && (a.__s = a.state), null != $.getDerivedStateFromProps && (a.__s == a.state && (a.__s = $450fc775b2f7950e$var$h({}, a.__s)), $450fc775b2f7950e$var$h(a.__s, $.getDerivedStateFromProps(b, a.__s))), y = a.props, p = a.state, a.__v = u, v) null == $.getDerivedStateFromProps && null != a.componentWillMount && a.componentWillMount(), null != a.componentDidMount && a.__h.push(a.componentDidMount);
            else {
                if (null == $.getDerivedStateFromProps && b !== y && null != a.componentWillReceiveProps && a.componentWillReceiveProps(b, m), !a.__e && null != a.shouldComponentUpdate && !1 === a.shouldComponentUpdate(b, a.__s, m) || u.__v === i.__v) {
                    for(u.__v !== i.__v && (a.props = b, a.state = a.__s, a.__d = !1), u.__e = i.__e, u.__k = i.__k, u.__k.forEach(function(n) {
                        n && (n.__ = u);
                    }), w = 0; w < a._sb.length; w++)a.__h.push(a._sb[w]);
                    a._sb = [], a.__h.length && f.push(a);
                    break n;
                }
                null != a.componentWillUpdate && a.componentWillUpdate(b, a.__s, m), null != a.componentDidUpdate && a.__h.push(function() {
                    a.componentDidUpdate(y, p, d);
                });
            }
            if (a.context = m, a.props = b, a.__P = n, A = $450fc775b2f7950e$export$41c562ebe57d11e2.__r, P = 0, "prototype" in $ && $.prototype.render) {
                for(a.state = a.__s, a.__d = !1, A && A(u), s = a.render(a.props, a.state, a.context), C = 0; C < a._sb.length; C++)a.__h.push(a._sb[C]);
                a._sb = [];
            } else do a.__d = !1, A && A(u), s = a.render(a.props, a.state, a.context), a.state = a.__s;
            while (a.__d && ++P < 25);
            a.state = a.__s, null != a.getChildContext && (t = $450fc775b2f7950e$var$h($450fc775b2f7950e$var$h({}, t), a.getChildContext())), v || null == a.getSnapshotBeforeUpdate || (d = a.getSnapshotBeforeUpdate(y, p)), T = null != s && s.type === $450fc775b2f7950e$export$ffb0004e005737fa && null == s.key ? s.props.children : s, $450fc775b2f7950e$var$H(n, Array.isArray(T) ? T : [
                T
            ], u, i, t, r, o, f, e, c), a.base = u.__e, u.__h = null, a.__h.length && f.push(a), k && (a.__E = a.__ = null), a.__e = !1;
        } else null == o && u.__v === i.__v ? (u.__k = i.__k, u.__e = i.__e) : u.__e = $450fc775b2f7950e$var$O(i.__e, u, i, t, r, o, f, c);
        (s = $450fc775b2f7950e$export$41c562ebe57d11e2.diffed) && s(u);
    } catch (n) {
        u.__v = null, (c || null != o) && (u.__e = e, u.__h = !!c, o[o.indexOf(e)] = null), $450fc775b2f7950e$export$41c562ebe57d11e2.__e(n, u, i);
    }
}
function $450fc775b2f7950e$var$N(n, u) {
    $450fc775b2f7950e$export$41c562ebe57d11e2.__c && $450fc775b2f7950e$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $450fc775b2f7950e$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $450fc775b2f7950e$var$O(l, u, i, t, r, o, f, e) {
    var s, a, h, y = i.props, p = u.props, d = u.type, _ = 0;
    if ("svg" === d && (r = !0), null != o) {
        for(; _ < o.length; _++)if ((s = o[_]) && "setAttribute" in s == !!d && (d ? s.localName === d : 3 === s.nodeType)) {
            l = s, o[_] = null;
            break;
        }
    }
    if (null == l) {
        if (null === d) return document.createTextNode(p);
        l = r ? document.createElementNS("http://www.w3.org/2000/svg", d) : document.createElement(d, p.is && p), o = null, e = !1;
    }
    if (null === d) y === p || e && l.data === p || (l.data = p);
    else {
        if (o = o && $450fc775b2f7950e$var$n.call(l.childNodes), a = (y = i.props || $450fc775b2f7950e$var$c).dangerouslySetInnerHTML, h = p.dangerouslySetInnerHTML, !e) {
            if (null != o) for(y = {}, _ = 0; _ < l.attributes.length; _++)y[l.attributes[_].name] = l.attributes[_].value;
            (h || a) && (h && (a && h.__html == a.__html || h.__html === l.innerHTML) || (l.innerHTML = h && h.__html || ""));
        }
        if ($450fc775b2f7950e$var$k(l, p, y, r, e), h) u.__k = [];
        else if (_ = u.props.children, $450fc775b2f7950e$var$H(l, Array.isArray(_) ? _ : [
            _
        ], u, i, t, r && "foreignObject" !== d, o, f, o ? o[0] : i.__k && $450fc775b2f7950e$var$A(i, 0), e), null != o) for(_ = o.length; _--;)null != o[_] && $450fc775b2f7950e$var$v(o[_]);
        e || ("value" in p && void 0 !== (_ = p.value) && (_ !== l.value || "progress" === d && !_ || "option" === d && _ !== y.value) && $450fc775b2f7950e$var$g(l, "value", _, y.value, !1), "checked" in p && void 0 !== (_ = p.checked) && _ !== l.checked && $450fc775b2f7950e$var$g(l, "checked", _, y.checked, !1));
    }
    return l;
}
function $450fc775b2f7950e$var$S(n, u, i) {
    try {
        "function" == typeof n ? n(u) : n.current = u;
    } catch (n) {
        $450fc775b2f7950e$export$41c562ebe57d11e2.__e(n, i);
    }
}
function $450fc775b2f7950e$var$q(n, u, i) {
    var t, r;
    if ($450fc775b2f7950e$export$41c562ebe57d11e2.unmount && $450fc775b2f7950e$export$41c562ebe57d11e2.unmount(n), (t = n.ref) && (t.current && t.current !== n.__e || $450fc775b2f7950e$var$S(t, null, u)), null != (t = n.__c)) {
        if (t.componentWillUnmount) try {
            t.componentWillUnmount();
        } catch (n) {
            $450fc775b2f7950e$export$41c562ebe57d11e2.__e(n, u);
        }
        t.base = t.__P = null, n.__c = void 0;
    }
    if (t = n.__k) for(r = 0; r < t.length; r++)t[r] && $450fc775b2f7950e$var$q(t[r], u, i || "function" != typeof n.type);
    i || null == n.__e || $450fc775b2f7950e$var$v(n.__e), n.__ = n.__e = n.__d = void 0;
}
function $450fc775b2f7950e$var$B(n, l, u) {
    return this.constructor(n, u);
}
function $450fc775b2f7950e$export$b3890eb0ae9dca99(u, i, t) {
    var r, o, f;
    $450fc775b2f7950e$export$41c562ebe57d11e2.__ && $450fc775b2f7950e$export$41c562ebe57d11e2.__(u, i), o = (r = "function" == typeof t) ? null : t && t.__k || i.__k, f = [], $450fc775b2f7950e$var$M(i, u = (!r && t || i).__k = $450fc775b2f7950e$export$c8a8987d4410bf2d($450fc775b2f7950e$export$ffb0004e005737fa, null, [
        u
    ]), o || $450fc775b2f7950e$var$c, $450fc775b2f7950e$var$c, void 0 !== i.ownerSVGElement, !r && t ? [
        t
    ] : o ? null : i.firstChild ? $450fc775b2f7950e$var$n.call(i.childNodes) : null, f, !r && t ? t : o ? o.__e : i.firstChild, r), $450fc775b2f7950e$var$N(f, u);
}
function $450fc775b2f7950e$export$fa8d919ba61d84db(n, l) {
    $450fc775b2f7950e$export$b3890eb0ae9dca99(n, l, $450fc775b2f7950e$export$fa8d919ba61d84db);
}
function $450fc775b2f7950e$export$e530037191fcd5d7(l, u, i) {
    var t, r, o, f = $450fc775b2f7950e$var$h({}, l.props);
    for(o in u)"key" == o ? t = u[o] : "ref" == o ? r = u[o] : f[o] = u[o];
    return arguments.length > 2 && (f.children = arguments.length > 3 ? $450fc775b2f7950e$var$n.call(arguments, 2) : i), $450fc775b2f7950e$var$p(l.type, f, t || l.key, r || l.ref, null);
}
function $450fc775b2f7950e$export$fd42f52fd3ae1109(n, l) {
    var u = {
        __c: l = "__cC" + $450fc775b2f7950e$var$e++,
        __: n,
        Consumer: function(n, l) {
            return n.children(l);
        },
        Provider: function(n) {
            var u, i;
            return this.getChildContext || (u = [], (i = {})[l] = this, this.getChildContext = function() {
                return i;
            }, this.shouldComponentUpdate = function(n) {
                this.props.value !== n.value && u.some(function(n) {
                    n.__e = !0, $450fc775b2f7950e$var$T(n);
                });
            }, this.sub = function(n) {
                u.push(n);
                var l = n.componentWillUnmount;
                n.componentWillUnmount = function() {
                    u.splice(u.indexOf(n), 1), l && l.call(n);
                };
            }), n.children;
        }
    };
    return u.Provider.__ = u.Consumer.contextType = u;
}
$450fc775b2f7950e$var$n = $450fc775b2f7950e$var$s.slice, $450fc775b2f7950e$export$41c562ebe57d11e2 = {
    __e: function(n, l, u, i) {
        for(var t, r, o; l = l.__;)if ((t = l.__c) && !t.__) try {
            if ((r = t.constructor) && null != r.getDerivedStateFromError && (t.setState(r.getDerivedStateFromError(n)), o = t.__d), null != t.componentDidCatch && (t.componentDidCatch(n, i || {}), o = t.__d), o) return t.__E = t;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $450fc775b2f7950e$var$u = 0, $450fc775b2f7950e$export$a8257692ac88316c = function(n) {
    return null != n && void 0 === n.constructor;
}, $450fc775b2f7950e$var$t = !1, $450fc775b2f7950e$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s !== this.state ? this.__s : this.__s = $450fc775b2f7950e$var$h({}, this.state), "function" == typeof n && (n = n($450fc775b2f7950e$var$h({}, u), this.props)), n && $450fc775b2f7950e$var$h(u, n), null != n && this.__v && (l && this._sb.push(l), $450fc775b2f7950e$var$T(this));
}, $450fc775b2f7950e$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $450fc775b2f7950e$var$T(this));
}, $450fc775b2f7950e$export$16fa2f45be04daa8.prototype.render = $450fc775b2f7950e$export$ffb0004e005737fa, $450fc775b2f7950e$var$r = [], $450fc775b2f7950e$var$f = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $450fc775b2f7950e$var$$.__r = 0, $450fc775b2f7950e$var$e = 0;




var $d6bdfea1a1e13052$var$t, $d6bdfea1a1e13052$var$r, $d6bdfea1a1e13052$var$u, $d6bdfea1a1e13052$var$i, $d6bdfea1a1e13052$var$o = 0, $d6bdfea1a1e13052$var$f = [], $d6bdfea1a1e13052$var$c = [], $d6bdfea1a1e13052$var$e = (0, $450fc775b2f7950e$export$41c562ebe57d11e2).__b, $d6bdfea1a1e13052$var$a = (0, $450fc775b2f7950e$export$41c562ebe57d11e2).__r, $d6bdfea1a1e13052$var$v = (0, $450fc775b2f7950e$export$41c562ebe57d11e2).diffed, $d6bdfea1a1e13052$var$l = (0, $450fc775b2f7950e$export$41c562ebe57d11e2).__c, $d6bdfea1a1e13052$var$m = (0, $450fc775b2f7950e$export$41c562ebe57d11e2).unmount;
function $d6bdfea1a1e13052$var$d(t, u) {
    (0, $450fc775b2f7950e$export$41c562ebe57d11e2).__h && (0, $450fc775b2f7950e$export$41c562ebe57d11e2).__h($d6bdfea1a1e13052$var$r, t, $d6bdfea1a1e13052$var$o || u), $d6bdfea1a1e13052$var$o = 0;
    var i = $d6bdfea1a1e13052$var$r.__H || ($d6bdfea1a1e13052$var$r.__H = {
        __: [],
        __h: []
    });
    return t >= i.__.length && i.__.push({
        __V: $d6bdfea1a1e13052$var$c
    }), i.__[t];
}
function $d6bdfea1a1e13052$export$60241385465d0a34(n) {
    return $d6bdfea1a1e13052$var$o = 1, $d6bdfea1a1e13052$export$13e3392192263954($d6bdfea1a1e13052$var$B, n);
}
function $d6bdfea1a1e13052$export$13e3392192263954(n, u, i) {
    var o = $d6bdfea1a1e13052$var$d($d6bdfea1a1e13052$var$t++, 2);
    if (o.t = n, !o.__c && (o.__ = [
        i ? i(u) : $d6bdfea1a1e13052$var$B(void 0, u),
        function(n) {
            var t = o.__N ? o.__N[0] : o.__[0], r = o.t(t, n);
            t !== r && (o.__N = [
                r,
                o.__[1]
            ], o.__c.setState({}));
        }
    ], o.__c = $d6bdfea1a1e13052$var$r, !$d6bdfea1a1e13052$var$r.u)) {
        $d6bdfea1a1e13052$var$r.u = !0;
        var f = $d6bdfea1a1e13052$var$r.shouldComponentUpdate;
        $d6bdfea1a1e13052$var$r.shouldComponentUpdate = function(n, t, r) {
            if (!o.__c.__H) return !0;
            var u = o.__c.__H.__.filter(function(n) {
                return n.__c;
            });
            if (u.every(function(n) {
                return !n.__N;
            })) return !f || f.call(this, n, t, r);
            var i = !1;
            return u.forEach(function(n) {
                if (n.__N) {
                    var t = n.__[0];
                    n.__ = n.__N, n.__N = void 0, t !== n.__[0] && (i = !0);
                }
            }), !(!i && o.__c.props === n) && (!f || f.call(this, n, t, r));
        };
    }
    return o.__N || o.__;
}
function $d6bdfea1a1e13052$export$6d9c69b0de29b591(u, i) {
    var o = $d6bdfea1a1e13052$var$d($d6bdfea1a1e13052$var$t++, 3);
    !(0, $450fc775b2f7950e$export$41c562ebe57d11e2).__s && $d6bdfea1a1e13052$var$z(o.__H, i) && (o.__ = u, o.i = i, $d6bdfea1a1e13052$var$r.__H.__h.push(o));
}
function $d6bdfea1a1e13052$export$e5c5a5f917a5871c(u, i) {
    var o = $d6bdfea1a1e13052$var$d($d6bdfea1a1e13052$var$t++, 4);
    !(0, $450fc775b2f7950e$export$41c562ebe57d11e2).__s && $d6bdfea1a1e13052$var$z(o.__H, i) && (o.__ = u, o.i = i, $d6bdfea1a1e13052$var$r.__h.push(o));
}
function $d6bdfea1a1e13052$export$b8f5890fc79d6aca(n) {
    return $d6bdfea1a1e13052$var$o = 5, $d6bdfea1a1e13052$export$1538c33de8887b59(function() {
        return {
            current: n
        };
    }, []);
}
function $d6bdfea1a1e13052$export$d5a552a76deda3c2(n, t, r) {
    $d6bdfea1a1e13052$var$o = 6, $d6bdfea1a1e13052$export$e5c5a5f917a5871c(function() {
        return "function" == typeof n ? (n(t()), function() {
            return n(null);
        }) : n ? (n.current = t(), function() {
            return n.current = null;
        }) : void 0;
    }, null == r ? r : r.concat(n));
}
function $d6bdfea1a1e13052$export$1538c33de8887b59(n, r) {
    var u = $d6bdfea1a1e13052$var$d($d6bdfea1a1e13052$var$t++, 7);
    return $d6bdfea1a1e13052$var$z(u.__H, r) ? (u.__V = n(), u.i = r, u.__h = n, u.__V) : u.__;
}
function $d6bdfea1a1e13052$export$35808ee640e87ca7(n, t) {
    return $d6bdfea1a1e13052$var$o = 8, $d6bdfea1a1e13052$export$1538c33de8887b59(function() {
        return n;
    }, t);
}
function $d6bdfea1a1e13052$export$fae74005e78b1a27(n) {
    var u = $d6bdfea1a1e13052$var$r.context[n.__c], i = $d6bdfea1a1e13052$var$d($d6bdfea1a1e13052$var$t++, 9);
    return i.c = n, u ? (null == i.__ && (i.__ = !0, u.sub($d6bdfea1a1e13052$var$r)), u.props.value) : n.__;
}
function $d6bdfea1a1e13052$export$dc8fbce3eb94dc1e(t, r) {
    (0, $450fc775b2f7950e$export$41c562ebe57d11e2).useDebugValue && (0, $450fc775b2f7950e$export$41c562ebe57d11e2).useDebugValue(r ? r(t) : t);
}
function $d6bdfea1a1e13052$export$c052f6604b7d51fe(n) {
    var u = $d6bdfea1a1e13052$var$d($d6bdfea1a1e13052$var$t++, 10), i = $d6bdfea1a1e13052$export$60241385465d0a34();
    return u.__ = n, $d6bdfea1a1e13052$var$r.componentDidCatch || ($d6bdfea1a1e13052$var$r.componentDidCatch = function(n, t) {
        u.__ && u.__(n, t), i[1](n);
    }), [
        i[0],
        function() {
            i[1](void 0);
        }
    ];
}
function $d6bdfea1a1e13052$export$f680877a34711e37() {
    var n = $d6bdfea1a1e13052$var$d($d6bdfea1a1e13052$var$t++, 11);
    if (!n.__) {
        for(var u = $d6bdfea1a1e13052$var$r.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        var i = u.__m || (u.__m = [
            0,
            0
        ]);
        n.__ = "P" + i[0] + "-" + i[1]++;
    }
    return n.__;
}
function $d6bdfea1a1e13052$var$b() {
    for(var t; t = $d6bdfea1a1e13052$var$f.shift();)if (t.__P && t.__H) try {
        t.__H.__h.forEach($d6bdfea1a1e13052$var$k), t.__H.__h.forEach($d6bdfea1a1e13052$var$w), t.__H.__h = [];
    } catch (r) {
        t.__H.__h = [], (0, $450fc775b2f7950e$export$41c562ebe57d11e2).__e(r, t.__v);
    }
}
(0, $450fc775b2f7950e$export$41c562ebe57d11e2).__b = function(n) {
    $d6bdfea1a1e13052$var$r = null, $d6bdfea1a1e13052$var$e && $d6bdfea1a1e13052$var$e(n);
}, (0, $450fc775b2f7950e$export$41c562ebe57d11e2).__r = function(n) {
    $d6bdfea1a1e13052$var$a && $d6bdfea1a1e13052$var$a(n), $d6bdfea1a1e13052$var$t = 0;
    var i = ($d6bdfea1a1e13052$var$r = n.__c).__H;
    i && ($d6bdfea1a1e13052$var$u === $d6bdfea1a1e13052$var$r ? (i.__h = [], $d6bdfea1a1e13052$var$r.__h = [], i.__.forEach(function(n) {
        n.__N && (n.__ = n.__N), n.__V = $d6bdfea1a1e13052$var$c, n.__N = n.i = void 0;
    })) : (i.__h.forEach($d6bdfea1a1e13052$var$k), i.__h.forEach($d6bdfea1a1e13052$var$w), i.__h = [])), $d6bdfea1a1e13052$var$u = $d6bdfea1a1e13052$var$r;
}, (0, $450fc775b2f7950e$export$41c562ebe57d11e2).diffed = function(t) {
    $d6bdfea1a1e13052$var$v && $d6bdfea1a1e13052$var$v(t);
    var o = t.__c;
    o && o.__H && (o.__H.__h.length && (1 !== $d6bdfea1a1e13052$var$f.push(o) && $d6bdfea1a1e13052$var$i === (0, $450fc775b2f7950e$export$41c562ebe57d11e2).requestAnimationFrame || (($d6bdfea1a1e13052$var$i = (0, $450fc775b2f7950e$export$41c562ebe57d11e2).requestAnimationFrame) || $d6bdfea1a1e13052$var$j)($d6bdfea1a1e13052$var$b)), o.__H.__.forEach(function(n) {
        n.i && (n.__H = n.i), n.__V !== $d6bdfea1a1e13052$var$c && (n.__ = n.__V), n.i = void 0, n.__V = $d6bdfea1a1e13052$var$c;
    })), $d6bdfea1a1e13052$var$u = $d6bdfea1a1e13052$var$r = null;
}, (0, $450fc775b2f7950e$export$41c562ebe57d11e2).__c = function(t, r) {
    r.some(function(t) {
        try {
            t.__h.forEach($d6bdfea1a1e13052$var$k), t.__h = t.__h.filter(function(n) {
                return !n.__ || $d6bdfea1a1e13052$var$w(n);
            });
        } catch (u) {
            r.some(function(n) {
                n.__h && (n.__h = []);
            }), r = [], (0, $450fc775b2f7950e$export$41c562ebe57d11e2).__e(u, t.__v);
        }
    }), $d6bdfea1a1e13052$var$l && $d6bdfea1a1e13052$var$l(t, r);
}, (0, $450fc775b2f7950e$export$41c562ebe57d11e2).unmount = function(t) {
    $d6bdfea1a1e13052$var$m && $d6bdfea1a1e13052$var$m(t);
    var r, u = t.__c;
    u && u.__H && (u.__H.__.forEach(function(n) {
        try {
            $d6bdfea1a1e13052$var$k(n);
        } catch (n) {
            r = n;
        }
    }), u.__H = void 0, r && (0, $450fc775b2f7950e$export$41c562ebe57d11e2).__e(r, u.__v));
};
var $d6bdfea1a1e13052$var$g = "function" == typeof requestAnimationFrame;
function $d6bdfea1a1e13052$var$j(n) {
    var t, r = function() {
        clearTimeout(u), $d6bdfea1a1e13052$var$g && cancelAnimationFrame(t), setTimeout(n);
    }, u = setTimeout(r, 100);
    $d6bdfea1a1e13052$var$g && (t = requestAnimationFrame(r));
}
function $d6bdfea1a1e13052$var$k(n) {
    var t = $d6bdfea1a1e13052$var$r, u = n.__c;
    "function" == typeof u && (n.__c = void 0, u()), $d6bdfea1a1e13052$var$r = t;
}
function $d6bdfea1a1e13052$var$w(n) {
    var t = $d6bdfea1a1e13052$var$r;
    n.__c = n.__(), $d6bdfea1a1e13052$var$r = t;
}
function $d6bdfea1a1e13052$var$z(n, t) {
    return !n || n.length !== t.length || t.some(function(t, r) {
        return t !== n[r];
    });
}
function $d6bdfea1a1e13052$var$B(n, t) {
    return "function" == typeof t ? t(n) : t;
}


function $a35043596f133777$var$g(n, t) {
    for(var e in t)n[e] = t[e];
    return n;
}
function $a35043596f133777$var$C(n, t) {
    for(var e in n)if ("__source" !== e && !(e in t)) return !0;
    for(var r in t)if ("__source" !== r && n[r] !== t[r]) return !0;
    return !1;
}
function $a35043596f133777$var$E(n, t) {
    return n === t && (0 !== n || 1 / n == 1 / t) || n != n && t != t;
}
function $a35043596f133777$export$221d75b3f55bb0bd(n) {
    this.props = n;
}
function $a35043596f133777$export$7c73462e0d25e514(n, e) {
    function r(n) {
        var t = this.props.ref, r = t == n.ref;
        return !r && t && (t.call ? t(null) : t.current = null), e ? !e(this.props, n) || !r : $a35043596f133777$var$C(this.props, n);
    }
    function u(e) {
        return this.shouldComponentUpdate = r, (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)(n, e);
    }
    return u.displayName = "Memo(" + (n.displayName || n.name) + ")", u.prototype.isReactComponent = !0, u.__f = !0, u;
}
($a35043596f133777$export$221d75b3f55bb0bd.prototype = new (0, $450fc775b2f7950e$export$16fa2f45be04daa8)).isPureReactComponent = !0, $a35043596f133777$export$221d75b3f55bb0bd.prototype.shouldComponentUpdate = function(n, t) {
    return $a35043596f133777$var$C(this.props, n) || $a35043596f133777$var$C(this.state, t);
};
var $a35043596f133777$var$x = (0, $450fc775b2f7950e$export$41c562ebe57d11e2).__b;
(0, $450fc775b2f7950e$export$41c562ebe57d11e2).__b = function(n) {
    n.type && n.type.__f && n.ref && (n.props.ref = n.ref, n.ref = null), $a35043596f133777$var$x && $a35043596f133777$var$x(n);
};
var $a35043596f133777$var$N = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.forward_ref") || 3911;
function $a35043596f133777$export$257a8862b851cb5b(n) {
    function t(t) {
        var e = $a35043596f133777$var$g({}, t);
        return delete e.ref, n(e, t.ref || null);
    }
    return t.$$typeof = $a35043596f133777$var$N, t.render = t, t.prototype.isReactComponent = t.__f = !0, t.displayName = "ForwardRef(" + (n.displayName || n.name) + ")", t;
}
var $a35043596f133777$var$A = function(n, t) {
    return null == n ? null : (0, $450fc775b2f7950e$export$47e4c5b300681277)((0, $450fc775b2f7950e$export$47e4c5b300681277)(n).map(t));
}, $a35043596f133777$export$dca3b0875bd9a954 = {
    map: $a35043596f133777$var$A,
    forEach: $a35043596f133777$var$A,
    count: function(n) {
        return n ? (0, $450fc775b2f7950e$export$47e4c5b300681277)(n).length : 0;
    },
    only: function(n) {
        var t = (0, $450fc775b2f7950e$export$47e4c5b300681277)(n);
        if (1 !== t.length) throw "Children.only";
        return t[0];
    },
    toArray: (0, $450fc775b2f7950e$export$47e4c5b300681277)
}, $a35043596f133777$var$T = (0, $450fc775b2f7950e$export$41c562ebe57d11e2).__e;
(0, $450fc775b2f7950e$export$41c562ebe57d11e2).__e = function(n, t, e, r) {
    if (n.then) {
        for(var u, o = t; o = o.__;)if ((u = o.__c) && u.__c) return null == t.__e && (t.__e = e.__e, t.__k = e.__k), u.__c(n, t);
    }
    $a35043596f133777$var$T(n, t, e, r);
};
var $a35043596f133777$var$I = (0, $450fc775b2f7950e$export$41c562ebe57d11e2).unmount;
function $a35043596f133777$var$L(n, t, e) {
    return n && (n.__c && n.__c.__H && (n.__c.__H.__.forEach(function(n) {
        "function" == typeof n.__c && n.__c();
    }), n.__c.__H = null), null != (n = $a35043596f133777$var$g({}, n)).__c && (n.__c.__P === e && (n.__c.__P = t), n.__c = null), n.__k = n.__k && n.__k.map(function(n) {
        return $a35043596f133777$var$L(n, t, e);
    })), n;
}
function $a35043596f133777$var$U(n, t, e) {
    return n && (n.__v = null, n.__k = n.__k && n.__k.map(function(n) {
        return $a35043596f133777$var$U(n, t, e);
    }), n.__c && n.__c.__P === t && (n.__e && e.insertBefore(n.__e, n.__d), n.__c.__e = !0, n.__c.__P = e)), n;
}
function $a35043596f133777$export$74bf444e3cd11ea5() {
    this.__u = 0, this.t = null, this.__b = null;
}
function $a35043596f133777$var$F(n) {
    var t = n.__.__c;
    return t && t.__a && t.__a(n);
}
function $a35043596f133777$export$488013bae63b21da(n) {
    var e, r, u;
    function o(o) {
        if (e || (e = n()).then(function(n) {
            r = n.default || n;
        }, function(n) {
            u = n;
        }), u) throw u;
        if (!r) throw e;
        return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)(r, o);
    }
    return o.displayName = "Lazy", o.__f = !0, o;
}
function $a35043596f133777$export$998bcd577473dd93() {
    this.u = null, this.o = null;
}
(0, $450fc775b2f7950e$export$41c562ebe57d11e2).unmount = function(n) {
    var t = n.__c;
    t && t.__R && t.__R(), t && !0 === n.__h && (n.type = null), $a35043596f133777$var$I && $a35043596f133777$var$I(n);
}, ($a35043596f133777$export$74bf444e3cd11ea5.prototype = new (0, $450fc775b2f7950e$export$16fa2f45be04daa8)).__c = function(n, t) {
    var e = t.__c, r = this;
    null == r.t && (r.t = []), r.t.push(e);
    var u = $a35043596f133777$var$F(r.__v), o = !1, i = function() {
        o || (o = !0, e.__R = null, u ? u(l) : l());
    };
    e.__R = i;
    var l = function() {
        if (!--r.__u) {
            if (r.state.__a) {
                var n = r.state.__a;
                r.__v.__k[0] = $a35043596f133777$var$U(n, n.__c.__P, n.__c.__O);
            }
            var t;
            for(r.setState({
                __a: r.__b = null
            }); t = r.t.pop();)t.forceUpdate();
        }
    }, c = !0 === t.__h;
    r.__u++ || c || r.setState({
        __a: r.__b = r.__v.__k[0]
    }), n.then(i, i);
}, $a35043596f133777$export$74bf444e3cd11ea5.prototype.componentWillUnmount = function() {
    this.t = [];
}, $a35043596f133777$export$74bf444e3cd11ea5.prototype.render = function(n, e) {
    if (this.__b) {
        if (this.__v.__k) {
            var r = document.createElement("div"), o = this.__v.__k[0].__c;
            this.__v.__k[0] = $a35043596f133777$var$L(this.__b, r, o.__O = o.__P);
        }
        this.__b = null;
    }
    var i = e.__a && (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)((0, $450fc775b2f7950e$export$ffb0004e005737fa), null, n.fallback);
    return i && (i.__h = null), [
        (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)((0, $450fc775b2f7950e$export$ffb0004e005737fa), null, e.__a ? null : n.children),
        i
    ];
};
var $a35043596f133777$var$W = function(n, t, e) {
    if (++e[1] === e[0] && n.o.delete(t), n.props.revealOrder && ("t" !== n.props.revealOrder[0] || !n.o.size)) for(e = n.u; e;){
        for(; e.length > 3;)e.pop()();
        if (e[1] < e[0]) break;
        n.u = e = e[2];
    }
};
function $a35043596f133777$var$P(n) {
    return this.getChildContext = function() {
        return n.context;
    }, n.children;
}
function $a35043596f133777$var$$(n) {
    var e = this, r = n.i;
    e.componentWillUnmount = function() {
        (0, $450fc775b2f7950e$export$b3890eb0ae9dca99)(null, e.l), e.l = null, e.i = null;
    }, e.i && e.i !== r && e.componentWillUnmount(), n.__v ? (e.l || (e.i = r, e.l = {
        nodeType: 1,
        parentNode: r,
        childNodes: [],
        appendChild: function(n) {
            this.childNodes.push(n), e.i.appendChild(n);
        },
        insertBefore: function(n, t) {
            this.childNodes.push(n), e.i.appendChild(n);
        },
        removeChild: function(n) {
            this.childNodes.splice(this.childNodes.indexOf(n) >>> 1, 1), e.i.removeChild(n);
        }
    }), (0, $450fc775b2f7950e$export$b3890eb0ae9dca99)((0, $450fc775b2f7950e$export$c8a8987d4410bf2d)($a35043596f133777$var$P, {
        context: e.context
    }, n.__v), e.l)) : e.l && e.componentWillUnmount();
}
function $a35043596f133777$export$d39a5bbd09211389(n, e) {
    var r = (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)($a35043596f133777$var$$, {
        __v: n,
        i: e
    });
    return r.containerInfo = e, r;
}
($a35043596f133777$export$998bcd577473dd93.prototype = new (0, $450fc775b2f7950e$export$16fa2f45be04daa8)).__a = function(n) {
    var t = this, e = $a35043596f133777$var$F(t.__v), r = t.o.get(n);
    return r[0]++, function(u) {
        var o = function() {
            t.props.revealOrder ? (r.push(u), $a35043596f133777$var$W(t, n, r)) : u();
        };
        e ? e(o) : o();
    };
}, $a35043596f133777$export$998bcd577473dd93.prototype.render = function(n) {
    this.u = null, this.o = new Map;
    var t = (0, $450fc775b2f7950e$export$47e4c5b300681277)(n.children);
    n.revealOrder && "b" === n.revealOrder[0] && t.reverse();
    for(var e = t.length; e--;)this.o.set(t[e], this.u = [
        1,
        0,
        this.u
    ]);
    return n.children;
}, $a35043596f133777$export$998bcd577473dd93.prototype.componentDidUpdate = $a35043596f133777$export$998bcd577473dd93.prototype.componentDidMount = function() {
    var n = this;
    this.o.forEach(function(t, e) {
        $a35043596f133777$var$W(n, e, t);
    });
};
var $a35043596f133777$var$z = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103, $a35043596f133777$var$B = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, $a35043596f133777$var$H = "undefined" != typeof document, $a35043596f133777$var$Z = function(n) {
    return ("undefined" != typeof Symbol && "symbol" == typeof Symbol() ? /fil|che|rad/i : /fil|che|ra/i).test(n);
};
function $a35043596f133777$export$b3890eb0ae9dca99(n, t, e) {
    return null == t.__k && (t.textContent = ""), (0, $450fc775b2f7950e$export$b3890eb0ae9dca99)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
function $a35043596f133777$export$fa8d919ba61d84db(n, t, e) {
    return (0, $450fc775b2f7950e$export$fa8d919ba61d84db)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
(0, $450fc775b2f7950e$export$16fa2f45be04daa8).prototype.isReactComponent = {}, [
    "componentWillMount",
    "componentWillReceiveProps",
    "componentWillUpdate"
].forEach(function(t) {
    Object.defineProperty((0, $450fc775b2f7950e$export$16fa2f45be04daa8).prototype, t, {
        configurable: !0,
        get: function() {
            return this["UNSAFE_" + t];
        },
        set: function(n) {
            Object.defineProperty(this, t, {
                configurable: !0,
                writable: !0,
                value: n
            });
        }
    });
});
var $a35043596f133777$var$G = (0, $450fc775b2f7950e$export$41c562ebe57d11e2).event;
function $a35043596f133777$var$J() {}
function $a35043596f133777$var$K() {
    return this.cancelBubble;
}
function $a35043596f133777$var$Q() {
    return this.defaultPrevented;
}
(0, $450fc775b2f7950e$export$41c562ebe57d11e2).event = function(n) {
    return $a35043596f133777$var$G && (n = $a35043596f133777$var$G(n)), n.persist = $a35043596f133777$var$J, n.isPropagationStopped = $a35043596f133777$var$K, n.isDefaultPrevented = $a35043596f133777$var$Q, n.nativeEvent = n;
};
var $a35043596f133777$var$X, $a35043596f133777$var$nn = {
    configurable: !0,
    get: function() {
        return this.class;
    }
}, $a35043596f133777$var$tn = (0, $450fc775b2f7950e$export$41c562ebe57d11e2).vnode;
(0, $450fc775b2f7950e$export$41c562ebe57d11e2).vnode = function(n) {
    var t = n.type, e = n.props, u = e;
    if ("string" == typeof t) {
        var o = -1 === t.indexOf("-");
        for(var i in u = {}, e){
            var l = e[i];
            $a35043596f133777$var$H && "children" === i && "noscript" === t || "value" === i && "defaultValue" in e && null == l || ("defaultValue" === i && "value" in e && null == e.value ? i = "value" : "download" === i && !0 === l ? l = "" : /ondoubleclick/i.test(i) ? i = "ondblclick" : /^onchange(textarea|input)/i.test(i + t) && !$a35043596f133777$var$Z(e.type) ? i = "oninput" : /^onfocus$/i.test(i) ? i = "onfocusin" : /^onblur$/i.test(i) ? i = "onfocusout" : /^on(Ani|Tra|Tou|BeforeInp|Compo)/.test(i) ? i = i.toLowerCase() : o && $a35043596f133777$var$B.test(i) ? i = i.replace(/[A-Z0-9]/g, "-$&").toLowerCase() : null === l && (l = void 0), /^oninput$/i.test(i) && (i = i.toLowerCase(), u[i] && (i = "oninputCapture")), u[i] = l);
        }
        "select" == t && u.multiple && Array.isArray(u.value) && (u.value = (0, $450fc775b2f7950e$export$47e4c5b300681277)(e.children).forEach(function(n) {
            n.props.selected = -1 != u.value.indexOf(n.props.value);
        })), "select" == t && null != u.defaultValue && (u.value = (0, $450fc775b2f7950e$export$47e4c5b300681277)(e.children).forEach(function(n) {
            n.props.selected = u.multiple ? -1 != u.defaultValue.indexOf(n.props.value) : u.defaultValue == n.props.value;
        })), n.props = u, e.class != e.className && ($a35043596f133777$var$nn.enumerable = "className" in e, null != e.className && (u.class = e.className), Object.defineProperty(u, "className", $a35043596f133777$var$nn));
    }
    n.$$typeof = $a35043596f133777$var$z, $a35043596f133777$var$tn && $a35043596f133777$var$tn(n);
};
var $a35043596f133777$var$en = (0, $450fc775b2f7950e$export$41c562ebe57d11e2).__r;
(0, $450fc775b2f7950e$export$41c562ebe57d11e2).__r = function(n) {
    $a35043596f133777$var$en && $a35043596f133777$var$en(n), $a35043596f133777$var$X = n.__c;
};
var $a35043596f133777$export$ae55be85d98224ed = {
    ReactCurrentDispatcher: {
        current: {
            readContext: function(n) {
                return $a35043596f133777$var$X.__n[n.__c].props.value;
            }
        }
    }
}, $a35043596f133777$export$83d89fbfd8236492 = "17.0.2";
function $a35043596f133777$export$d38cd72104c1f0e9(n) {
    return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d).bind(null, n);
}
function $a35043596f133777$export$a8257692ac88316c(n) {
    return !!n && n.$$typeof === $a35043596f133777$var$z;
}
function $a35043596f133777$export$e530037191fcd5d7(n) {
    return $a35043596f133777$export$a8257692ac88316c(n) ? (0, $450fc775b2f7950e$export$e530037191fcd5d7).apply(null, arguments) : n;
}
function $a35043596f133777$export$502457920280e6be(n) {
    return !!n.__k && ((0, $450fc775b2f7950e$export$b3890eb0ae9dca99)(null, n), !0);
}
function $a35043596f133777$export$466bfc07425424d5(n) {
    return n && (n.base || 1 === n.nodeType && n) || null;
}
var $a35043596f133777$export$c78a37762a8d58e1 = function(n, t) {
    return n(t);
}, $a35043596f133777$export$cd75ccfd720a3cd4 = function(n, t) {
    return n(t);
}, $a35043596f133777$export$5f8d39834fd61797 = (0, $450fc775b2f7950e$export$ffb0004e005737fa);
function $a35043596f133777$export$7568632d0d33d16d(n) {
    n();
}
function $a35043596f133777$export$6a7bc4e911dc01cf(n) {
    return n;
}
function $a35043596f133777$export$7b286972b8d8ccbf() {
    return [
        !1,
        $a35043596f133777$export$7568632d0d33d16d
    ];
}
var $a35043596f133777$export$aaabe4eda9ed9969 = (0, $d6bdfea1a1e13052$export$e5c5a5f917a5871c);
function $a35043596f133777$export$306c0aa65ff9ec16(n, t) {
    var e = t(), r = (0, $d6bdfea1a1e13052$export$60241385465d0a34)({
        h: {
            __: e,
            v: t
        }
    }), u = r[0].h, o = r[1];
    return (0, $d6bdfea1a1e13052$export$e5c5a5f917a5871c)(function() {
        u.__ = e, u.v = t, $a35043596f133777$var$E(u.__, t()) || o({
            h: u
        });
    }, [
        n,
        e,
        t
    ]), (0, $d6bdfea1a1e13052$export$6d9c69b0de29b591)(function() {
        return $a35043596f133777$var$E(u.__, u.v()) || o({
            h: u
        }), n(function() {
            $a35043596f133777$var$E(u.__, u.v()) || o({
                h: u
            });
        });
    }, [
        n
    ]), e;
}
var $a35043596f133777$export$2e2bcd8739ae039 = {
    useState: (0, $d6bdfea1a1e13052$export$60241385465d0a34),
    useId: (0, $d6bdfea1a1e13052$export$f680877a34711e37),
    useReducer: (0, $d6bdfea1a1e13052$export$13e3392192263954),
    useEffect: (0, $d6bdfea1a1e13052$export$6d9c69b0de29b591),
    useLayoutEffect: (0, $d6bdfea1a1e13052$export$e5c5a5f917a5871c),
    useInsertionEffect: $a35043596f133777$export$aaabe4eda9ed9969,
    useTransition: $a35043596f133777$export$7b286972b8d8ccbf,
    useDeferredValue: $a35043596f133777$export$6a7bc4e911dc01cf,
    useSyncExternalStore: $a35043596f133777$export$306c0aa65ff9ec16,
    startTransition: $a35043596f133777$export$7568632d0d33d16d,
    useRef: (0, $d6bdfea1a1e13052$export$b8f5890fc79d6aca),
    useImperativeHandle: (0, $d6bdfea1a1e13052$export$d5a552a76deda3c2),
    useMemo: (0, $d6bdfea1a1e13052$export$1538c33de8887b59),
    useCallback: (0, $d6bdfea1a1e13052$export$35808ee640e87ca7),
    useContext: (0, $d6bdfea1a1e13052$export$fae74005e78b1a27),
    useDebugValue: (0, $d6bdfea1a1e13052$export$dc8fbce3eb94dc1e),
    version: "17.0.2",
    Children: $a35043596f133777$export$dca3b0875bd9a954,
    render: $a35043596f133777$export$b3890eb0ae9dca99,
    hydrate: $a35043596f133777$export$fa8d919ba61d84db,
    unmountComponentAtNode: $a35043596f133777$export$502457920280e6be,
    createPortal: $a35043596f133777$export$d39a5bbd09211389,
    createElement: (0, $450fc775b2f7950e$export$c8a8987d4410bf2d),
    createContext: (0, $450fc775b2f7950e$export$fd42f52fd3ae1109),
    createFactory: $a35043596f133777$export$d38cd72104c1f0e9,
    cloneElement: $a35043596f133777$export$e530037191fcd5d7,
    createRef: (0, $450fc775b2f7950e$export$7d1e3a5e95ceca43),
    Fragment: (0, $450fc775b2f7950e$export$ffb0004e005737fa),
    isValidElement: $a35043596f133777$export$a8257692ac88316c,
    findDOMNode: $a35043596f133777$export$466bfc07425424d5,
    Component: (0, $450fc775b2f7950e$export$16fa2f45be04daa8),
    PureComponent: $a35043596f133777$export$221d75b3f55bb0bd,
    memo: $a35043596f133777$export$7c73462e0d25e514,
    forwardRef: $a35043596f133777$export$257a8862b851cb5b,
    flushSync: $a35043596f133777$export$cd75ccfd720a3cd4,
    unstable_batchedUpdates: $a35043596f133777$export$c78a37762a8d58e1,
    StrictMode: $a35043596f133777$export$5f8d39834fd61797,
    Suspense: $a35043596f133777$export$74bf444e3cd11ea5,
    SuspenseList: $a35043596f133777$export$998bcd577473dd93,
    lazy: $a35043596f133777$export$488013bae63b21da,
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: $a35043596f133777$export$ae55be85d98224ed
};


const $5913100b2ed0f596$var$styleTexts = [];
const $5913100b2ed0f596$var$styleEls = new Map();
function $5913100b2ed0f596$export$c373adc892eb6355(styleText) {
    $5913100b2ed0f596$var$styleTexts.push(styleText);
    $5913100b2ed0f596$var$styleEls.forEach((styleEl)=>{
        $5913100b2ed0f596$var$appendStylesTo(styleEl, styleText);
    });
}
function $5913100b2ed0f596$export$4c3d22f3d993c33f(el) {
    if (el.isConnected && // sometimes true if SSR system simulates DOM
    el.getRootNode // sometimes undefined if SSR system simulates DOM
    ) $5913100b2ed0f596$var$registerStylesRoot(el.getRootNode());
}
function $5913100b2ed0f596$var$registerStylesRoot(rootNode) {
    let styleEl = $5913100b2ed0f596$var$styleEls.get(rootNode);
    if (!styleEl || !styleEl.isConnected) {
        styleEl = rootNode.querySelector("style[data-fullcalendar]");
        if (!styleEl) {
            styleEl = document.createElement("style");
            styleEl.setAttribute("data-fullcalendar", "");
            const nonce = $5913100b2ed0f596$var$getNonceValue();
            if (nonce) styleEl.nonce = nonce;
            const parentEl = rootNode === document ? document.head : rootNode;
            const insertBefore = rootNode === document ? parentEl.querySelector("script,link[rel=stylesheet],link[as=style],style") : parentEl.firstChild;
            parentEl.insertBefore(styleEl, insertBefore);
        }
        $5913100b2ed0f596$var$styleEls.set(rootNode, styleEl);
        $5913100b2ed0f596$var$hydrateStylesRoot(styleEl);
    }
}
function $5913100b2ed0f596$var$hydrateStylesRoot(styleEl) {
    for (const styleText of $5913100b2ed0f596$var$styleTexts)$5913100b2ed0f596$var$appendStylesTo(styleEl, styleText);
}
function $5913100b2ed0f596$var$appendStylesTo(styleEl, styleText) {
    const { sheet: sheet } = styleEl;
    const ruleCnt = sheet.cssRules.length;
    styleText.split("}").forEach((styleStr, i)=>{
        styleStr = styleStr.trim();
        if (styleStr) sheet.insertRule(styleStr + "}", ruleCnt + i);
    });
}
// nonce
// -------------------------------------------------------------------------------------------------
let $5913100b2ed0f596$var$queriedNonceValue;
function $5913100b2ed0f596$var$getNonceValue() {
    if ($5913100b2ed0f596$var$queriedNonceValue === undefined) $5913100b2ed0f596$var$queriedNonceValue = $5913100b2ed0f596$var$queryNonceValue();
    return $5913100b2ed0f596$var$queriedNonceValue;
}
/*
TODO: discourage meta tag and instead put nonce attribute on placeholder <style> tag
*/ function $5913100b2ed0f596$var$queryNonceValue() {
    const metaWithNonce = document.querySelector('meta[name="csp-nonce"]');
    if (metaWithNonce && metaWithNonce.hasAttribute("content")) return metaWithNonce.getAttribute("content");
    const elWithNonce = document.querySelector("script[nonce]");
    if (elWithNonce) return elWithNonce.nonce || "";
    return "";
}
// main
// -------------------------------------------------------------------------------------------------
if (typeof document !== "undefined") $5913100b2ed0f596$var$registerStylesRoot(document);
var $5913100b2ed0f596$var$css_248z = ':root{--fc-small-font-size:.85em;--fc-page-bg-color:#fff;--fc-neutral-bg-color:hsla(0,0%,82%,.3);--fc-neutral-text-color:grey;--fc-border-color:#ddd;--fc-button-text-color:#fff;--fc-button-bg-color:#2c3e50;--fc-button-border-color:#2c3e50;--fc-button-hover-bg-color:#1e2b37;--fc-button-hover-border-color:#1a252f;--fc-button-active-bg-color:#1a252f;--fc-button-active-border-color:#151e27;--fc-event-bg-color:#3788d8;--fc-event-border-color:#3788d8;--fc-event-text-color:#fff;--fc-event-selected-overlay-color:rgba(0,0,0,.25);--fc-more-link-bg-color:#d0d0d0;--fc-more-link-text-color:inherit;--fc-event-resizer-thickness:8px;--fc-event-resizer-dot-total-width:8px;--fc-event-resizer-dot-border-width:1px;--fc-non-business-color:hsla(0,0%,84%,.3);--fc-bg-event-color:#8fdf82;--fc-bg-event-opacity:0.3;--fc-highlight-color:rgba(188,232,241,.3);--fc-today-bg-color:rgba(255,220,40,.15);--fc-now-indicator-color:red}.fc-not-allowed,.fc-not-allowed .fc-event{cursor:not-allowed}.fc{display:flex;flex-direction:column;font-size:1em}.fc,.fc *,.fc :after,.fc :before{box-sizing:border-box}.fc table{border-collapse:collapse;border-spacing:0;font-size:1em}.fc th{text-align:center}.fc td,.fc th{padding:0;vertical-align:top}.fc a[data-navlink]{cursor:pointer}.fc a[data-navlink]:hover{text-decoration:underline}.fc-direction-ltr{direction:ltr;text-align:left}.fc-direction-rtl{direction:rtl;text-align:right}.fc-theme-standard td,.fc-theme-standard th{border:1px solid var(--fc-border-color)}.fc-liquid-hack td,.fc-liquid-hack th{position:relative}@font-face{font-family:fcicons;font-style:normal;font-weight:400;src:url("data:application/x-font-ttf;charset=utf-8;base64,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") format("truetype")}.fc-icon{speak:none;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;display:inline-block;font-family:fcicons!important;font-style:normal;font-variant:normal;font-weight:400;height:1em;line-height:1;text-align:center;text-transform:none;-webkit-user-select:none;-moz-user-select:none;user-select:none;width:1em}.fc-icon-chevron-left:before{content:"\\e900"}.fc-icon-chevron-right:before{content:"\\e901"}.fc-icon-chevrons-left:before{content:"\\e902"}.fc-icon-chevrons-right:before{content:"\\e903"}.fc-icon-minus-square:before{content:"\\e904"}.fc-icon-plus-square:before{content:"\\e905"}.fc-icon-x:before{content:"\\e906"}.fc .fc-button{border-radius:0;font-family:inherit;font-size:inherit;line-height:inherit;margin:0;overflow:visible;text-transform:none}.fc .fc-button:focus{outline:1px dotted;outline:5px auto -webkit-focus-ring-color}.fc .fc-button{-webkit-appearance:button}.fc .fc-button:not(:disabled){cursor:pointer}.fc .fc-button{background-color:transparent;border:1px solid transparent;border-radius:.25em;display:inline-block;font-size:1em;font-weight:400;line-height:1.5;padding:.4em .65em;text-align:center;-webkit-user-select:none;-moz-user-select:none;user-select:none;vertical-align:middle}.fc .fc-button:hover{text-decoration:none}.fc .fc-button:focus{box-shadow:0 0 0 .2rem rgba(44,62,80,.25);outline:0}.fc .fc-button:disabled{opacity:.65}.fc .fc-button-primary{background-color:var(--fc-button-bg-color);border-color:var(--fc-button-border-color);color:var(--fc-button-text-color)}.fc .fc-button-primary:hover{background-color:var(--fc-button-hover-bg-color);border-color:var(--fc-button-hover-border-color);color:var(--fc-button-text-color)}.fc .fc-button-primary:disabled{background-color:var(--fc-button-bg-color);border-color:var(--fc-button-border-color);color:var(--fc-button-text-color)}.fc .fc-button-primary:focus{box-shadow:0 0 0 .2rem rgba(76,91,106,.5)}.fc .fc-button-primary:not(:disabled).fc-button-active,.fc .fc-button-primary:not(:disabled):active{background-color:var(--fc-button-active-bg-color);border-color:var(--fc-button-active-border-color);color:var(--fc-button-text-color)}.fc .fc-button-primary:not(:disabled).fc-button-active:focus,.fc .fc-button-primary:not(:disabled):active:focus{box-shadow:0 0 0 .2rem rgba(76,91,106,.5)}.fc .fc-button .fc-icon{font-size:1.5em;vertical-align:middle}.fc .fc-button-group{display:inline-flex;position:relative;vertical-align:middle}.fc .fc-button-group>.fc-button{flex:1 1 auto;position:relative}.fc .fc-button-group>.fc-button.fc-button-active,.fc .fc-button-group>.fc-button:active,.fc .fc-button-group>.fc-button:focus,.fc .fc-button-group>.fc-button:hover{z-index:1}.fc-direction-ltr .fc-button-group>.fc-button:not(:first-child){border-bottom-left-radius:0;border-top-left-radius:0;margin-left:-1px}.fc-direction-ltr .fc-button-group>.fc-button:not(:last-child){border-bottom-right-radius:0;border-top-right-radius:0}.fc-direction-rtl .fc-button-group>.fc-button:not(:first-child){border-bottom-right-radius:0;border-top-right-radius:0;margin-right:-1px}.fc-direction-rtl .fc-button-group>.fc-button:not(:last-child){border-bottom-left-radius:0;border-top-left-radius:0}.fc .fc-toolbar{align-items:center;display:flex;justify-content:space-between}.fc .fc-toolbar.fc-header-toolbar{margin-bottom:1.5em}.fc .fc-toolbar.fc-footer-toolbar{margin-top:1.5em}.fc .fc-toolbar-title{font-size:1.75em;margin:0}.fc-direction-ltr .fc-toolbar>*>:not(:first-child){margin-left:.75em}.fc-direction-rtl .fc-toolbar>*>:not(:first-child){margin-right:.75em}.fc-direction-rtl .fc-toolbar-ltr{flex-direction:row-reverse}.fc .fc-scroller{-webkit-overflow-scrolling:touch;position:relative}.fc .fc-scroller-liquid{height:100%}.fc .fc-scroller-liquid-absolute{bottom:0;left:0;position:absolute;right:0;top:0}.fc .fc-scroller-harness{direction:ltr;overflow:hidden;position:relative}.fc .fc-scroller-harness-liquid{height:100%}.fc-direction-rtl .fc-scroller-harness>.fc-scroller{direction:rtl}.fc-theme-standard .fc-scrollgrid{border:1px solid var(--fc-border-color)}.fc .fc-scrollgrid,.fc .fc-scrollgrid table{table-layout:fixed;width:100%}.fc .fc-scrollgrid table{border-left-style:hidden;border-right-style:hidden;border-top-style:hidden}.fc .fc-scrollgrid{border-bottom-width:0;border-collapse:separate;border-right-width:0}.fc .fc-scrollgrid-liquid{height:100%}.fc .fc-scrollgrid-section,.fc .fc-scrollgrid-section table,.fc .fc-scrollgrid-section>td{height:1px}.fc .fc-scrollgrid-section-liquid>td{height:100%}.fc .fc-scrollgrid-section>*{border-left-width:0;border-top-width:0}.fc .fc-scrollgrid-section-footer>*,.fc .fc-scrollgrid-section-header>*{border-bottom-width:0}.fc .fc-scrollgrid-section-body table,.fc .fc-scrollgrid-section-footer table{border-bottom-style:hidden}.fc .fc-scrollgrid-section-sticky>*{background:var(--fc-page-bg-color);position:sticky;z-index:3}.fc .fc-scrollgrid-section-header.fc-scrollgrid-section-sticky>*{top:0}.fc .fc-scrollgrid-section-footer.fc-scrollgrid-section-sticky>*{bottom:0}.fc .fc-scrollgrid-sticky-shim{height:1px;margin-bottom:-1px}.fc-sticky{position:sticky}.fc .fc-view-harness{flex-grow:1;position:relative}.fc .fc-view-harness-active>.fc-view{bottom:0;left:0;position:absolute;right:0;top:0}.fc .fc-col-header-cell-cushion{display:inline-block;padding:2px 4px}.fc .fc-bg-event,.fc .fc-highlight,.fc .fc-non-business{bottom:0;left:0;position:absolute;right:0;top:0}.fc .fc-non-business{background:var(--fc-non-business-color)}.fc .fc-bg-event{background:var(--fc-bg-event-color);opacity:var(--fc-bg-event-opacity)}.fc .fc-bg-event .fc-event-title{font-size:var(--fc-small-font-size);font-style:italic;margin:.5em}.fc .fc-highlight{background:var(--fc-highlight-color)}.fc .fc-cell-shaded,.fc .fc-day-disabled{background:var(--fc-neutral-bg-color)}a.fc-event,a.fc-event:hover{text-decoration:none}.fc-event.fc-event-draggable,.fc-event[href]{cursor:pointer}.fc-event .fc-event-main{position:relative;z-index:2}.fc-event-dragging:not(.fc-event-selected){opacity:.75}.fc-event-dragging.fc-event-selected{box-shadow:0 2px 7px rgba(0,0,0,.3)}.fc-event .fc-event-resizer{display:none;position:absolute;z-index:4}.fc-event-selected .fc-event-resizer,.fc-event:hover .fc-event-resizer{display:block}.fc-event-selected .fc-event-resizer{background:var(--fc-page-bg-color);border-color:inherit;border-radius:calc(var(--fc-event-resizer-dot-total-width)/2);border-style:solid;border-width:var(--fc-event-resizer-dot-border-width);height:var(--fc-event-resizer-dot-total-width);width:var(--fc-event-resizer-dot-total-width)}.fc-event-selected .fc-event-resizer:before{bottom:-20px;content:"";left:-20px;position:absolute;right:-20px;top:-20px}.fc-event-selected,.fc-event:focus{box-shadow:0 2px 5px rgba(0,0,0,.2)}.fc-event-selected:before,.fc-event:focus:before{bottom:0;content:"";left:0;position:absolute;right:0;top:0;z-index:3}.fc-event-selected:after,.fc-event:focus:after{background:var(--fc-event-selected-overlay-color);bottom:-1px;content:"";left:-1px;position:absolute;right:-1px;top:-1px;z-index:1}.fc-h-event{background-color:var(--fc-event-bg-color);border:1px solid var(--fc-event-border-color);display:block}.fc-h-event .fc-event-main{color:var(--fc-event-text-color)}.fc-h-event .fc-event-main-frame{display:flex}.fc-h-event .fc-event-time{max-width:100%;overflow:hidden}.fc-h-event .fc-event-title-container{flex-grow:1;flex-shrink:1;min-width:0}.fc-h-event .fc-event-title{display:inline-block;left:0;max-width:100%;overflow:hidden;right:0;vertical-align:top}.fc-h-event.fc-event-selected:before{bottom:-10px;top:-10px}.fc-direction-ltr .fc-daygrid-block-event:not(.fc-event-start),.fc-direction-rtl .fc-daygrid-block-event:not(.fc-event-end){border-bottom-left-radius:0;border-left-width:0;border-top-left-radius:0}.fc-direction-ltr .fc-daygrid-block-event:not(.fc-event-end),.fc-direction-rtl .fc-daygrid-block-event:not(.fc-event-start){border-bottom-right-radius:0;border-right-width:0;border-top-right-radius:0}.fc-h-event:not(.fc-event-selected) .fc-event-resizer{bottom:0;top:0;width:var(--fc-event-resizer-thickness)}.fc-direction-ltr .fc-h-event:not(.fc-event-selected) .fc-event-resizer-start,.fc-direction-rtl .fc-h-event:not(.fc-event-selected) .fc-event-resizer-end{cursor:w-resize;left:calc(var(--fc-event-resizer-thickness)*-.5)}.fc-direction-ltr .fc-h-event:not(.fc-event-selected) .fc-event-resizer-end,.fc-direction-rtl .fc-h-event:not(.fc-event-selected) .fc-event-resizer-start{cursor:e-resize;right:calc(var(--fc-event-resizer-thickness)*-.5)}.fc-h-event.fc-event-selected .fc-event-resizer{margin-top:calc(var(--fc-event-resizer-dot-total-width)*-.5);top:50%}.fc-direction-ltr .fc-h-event.fc-event-selected .fc-event-resizer-start,.fc-direction-rtl .fc-h-event.fc-event-selected .fc-event-resizer-end{left:calc(var(--fc-event-resizer-dot-total-width)*-.5)}.fc-direction-ltr .fc-h-event.fc-event-selected .fc-event-resizer-end,.fc-direction-rtl .fc-h-event.fc-event-selected .fc-event-resizer-start{right:calc(var(--fc-event-resizer-dot-total-width)*-.5)}.fc .fc-popover{box-shadow:0 2px 6px rgba(0,0,0,.15);position:absolute;z-index:9999}.fc .fc-popover-header{align-items:center;display:flex;flex-direction:row;justify-content:space-between;padding:3px 4px}.fc .fc-popover-title{margin:0 2px}.fc .fc-popover-close{cursor:pointer;font-size:1.1em;opacity:.65}.fc-theme-standard .fc-popover{background:var(--fc-page-bg-color);border:1px solid var(--fc-border-color)}.fc-theme-standard .fc-popover-header{background:var(--fc-neutral-bg-color)}';
$5913100b2ed0f596$export$c373adc892eb6355($5913100b2ed0f596$var$css_248z);
class $5913100b2ed0f596$export$96f57966bedc81b4 {
    constructor(drainedOption){
        this.drainedOption = drainedOption;
        this.isRunning = false;
        this.isDirty = false;
        this.pauseDepths = {};
        this.timeoutId = 0;
    }
    request(delay) {
        this.isDirty = true;
        if (!this.isPaused()) {
            this.clearTimeout();
            if (delay == null) this.tryDrain();
            else this.timeoutId = setTimeout(this.tryDrain.bind(this), delay);
        }
    }
    pause(scope = "") {
        let { pauseDepths: pauseDepths } = this;
        pauseDepths[scope] = (pauseDepths[scope] || 0) + 1;
        this.clearTimeout();
    }
    resume(scope = "", force) {
        let { pauseDepths: pauseDepths } = this;
        if (scope in pauseDepths) {
            if (force) delete pauseDepths[scope];
            else {
                pauseDepths[scope] -= 1;
                let depth = pauseDepths[scope];
                if (depth <= 0) delete pauseDepths[scope];
            }
            this.tryDrain();
        }
    }
    isPaused() {
        return Object.keys(this.pauseDepths).length;
    }
    tryDrain() {
        if (!this.isRunning && !this.isPaused()) {
            this.isRunning = true;
            while(this.isDirty){
                this.isDirty = false;
                this.drained(); // might set isDirty to true again
            }
            this.isRunning = false;
        }
    }
    clear() {
        this.clearTimeout();
        this.isDirty = false;
        this.pauseDepths = {};
    }
    clearTimeout() {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
            this.timeoutId = 0;
        }
    }
    drained() {
        if (this.drainedOption) this.drainedOption();
    }
}
function $5913100b2ed0f596$export$c03999cb2f36933f(el) {
    if (el.parentNode) el.parentNode.removeChild(el);
}
// Querying
// ----------------------------------------------------------------------------------------------------------------
function $5913100b2ed0f596$export$3d8c2f653ac9d0b9(el, selector) {
    if (el.closest) return el.closest(selector);
    if (!document.documentElement.contains(el)) return null;
    do {
        if ($5913100b2ed0f596$export$f96d196f7728bb5(el, selector)) return el;
        el = el.parentElement || el.parentNode;
    }while (el !== null && el.nodeType === 1);
    return null;
}
function $5913100b2ed0f596$export$f96d196f7728bb5(el, selector) {
    let method = el.matches || el.matchesSelector || el.msMatchesSelector;
    return method.call(el, selector);
}
// accepts multiple subject els
// returns a real array. good for methods like forEach
// TODO: accept the document
function $5913100b2ed0f596$export$9f4f30ee63539e24(container, selector) {
    let containers = container instanceof HTMLElement ? [
        container
    ] : container;
    let allMatches = [];
    for(let i = 0; i < containers.length; i += 1){
        let matches = containers[i].querySelectorAll(selector);
        for(let j = 0; j < matches.length; j += 1)allMatches.push(matches[j]);
    }
    return allMatches;
}
// accepts multiple subject els
// only queries direct child elements // TODO: rename to findDirectChildren!
function $5913100b2ed0f596$export$faec65b429be379(parent, selector) {
    let parents = parent instanceof HTMLElement ? [
        parent
    ] : parent;
    let allMatches = [];
    for(let i = 0; i < parents.length; i += 1){
        let childNodes = parents[i].children; // only ever elements
        for(let j = 0; j < childNodes.length; j += 1){
            let childNode = childNodes[j];
            if (!selector || $5913100b2ed0f596$export$f96d196f7728bb5(childNode, selector)) allMatches.push(childNode);
        }
    }
    return allMatches;
}
// Style
// ----------------------------------------------------------------------------------------------------------------
const $5913100b2ed0f596$var$PIXEL_PROP_RE = /(top|left|right|bottom|width|height)$/i;
function $5913100b2ed0f596$export$2ed0fc6709e59212(el, props) {
    for(let propName in props)$5913100b2ed0f596$export$f787f51d84a910ad(el, propName, props[propName]);
}
function $5913100b2ed0f596$export$f787f51d84a910ad(el, name, val) {
    if (val == null) el.style[name] = "";
    else if (typeof val === "number" && $5913100b2ed0f596$var$PIXEL_PROP_RE.test(name)) el.style[name] = `${val}px`;
    else el.style[name] = val;
}
// Event Handling
// ----------------------------------------------------------------------------------------------------------------
// if intercepting bubbled events at the document/window/body level,
// and want to see originating element (the 'target'), use this util instead
// of `ev.target` because it goes within web-component boundaries.
function $5913100b2ed0f596$export$738ab4df8bf92ae9(ev) {
    var _a, _b;
    return (_b = (_a = ev.composedPath) === null || _a === void 0 ? void 0 : _a.call(ev)[0]) !== null && _b !== void 0 ? _b : ev.target;
}
// Unique ID for DOM attribute
let $5913100b2ed0f596$var$guid$1 = 0;
function $5913100b2ed0f596$export$a8550f7dbe79f93a() {
    $5913100b2ed0f596$var$guid$1 += 1;
    return "fc-dom-" + $5913100b2ed0f596$var$guid$1;
}
// Stops a mouse/touch event from doing it's native browser action
function $5913100b2ed0f596$export$d29e374196577086(ev) {
    ev.preventDefault();
}
// Event Delegation
// ----------------------------------------------------------------------------------------------------------------
function $5913100b2ed0f596$var$buildDelegationHandler(selector, handler) {
    return (ev)=>{
        let matchedChild = $5913100b2ed0f596$export$3d8c2f653ac9d0b9(ev.target, selector);
        if (matchedChild) handler.call(matchedChild, ev, matchedChild);
    };
}
function $5913100b2ed0f596$export$3c2fa207a37baaea(container, eventType, selector, handler) {
    let attachedHandler = $5913100b2ed0f596$var$buildDelegationHandler(selector, handler);
    container.addEventListener(eventType, attachedHandler);
    return ()=>{
        container.removeEventListener(eventType, attachedHandler);
    };
}
function $5913100b2ed0f596$export$ce26c07117d59d6a(container, selector, onMouseEnter, onMouseLeave) {
    let currentMatchedChild;
    return $5913100b2ed0f596$export$3c2fa207a37baaea(container, "mouseover", selector, (mouseOverEv, matchedChild)=>{
        if (matchedChild !== currentMatchedChild) {
            currentMatchedChild = matchedChild;
            onMouseEnter(mouseOverEv, matchedChild);
            let realOnMouseLeave = (mouseLeaveEv)=>{
                currentMatchedChild = null;
                onMouseLeave(mouseLeaveEv, matchedChild);
                matchedChild.removeEventListener("mouseleave", realOnMouseLeave);
            };
            // listen to the next mouseleave, and then unattach
            matchedChild.addEventListener("mouseleave", realOnMouseLeave);
        }
    });
}
// Animation
// ----------------------------------------------------------------------------------------------------------------
const $5913100b2ed0f596$var$transitionEventNames = [
    "webkitTransitionEnd",
    "otransitionend",
    "oTransitionEnd",
    "msTransitionEnd",
    "transitionend"
];
// triggered only when the next single subsequent transition finishes
function $5913100b2ed0f596$export$2ec5befb9e6c97d4(el, callback) {
    let realCallback = (ev)=>{
        callback(ev);
        $5913100b2ed0f596$var$transitionEventNames.forEach((eventName)=>{
            el.removeEventListener(eventName, realCallback);
        });
    };
    $5913100b2ed0f596$var$transitionEventNames.forEach((eventName)=>{
        el.addEventListener(eventName, realCallback); // cross-browser way to determine when the transition finishes
    });
}
// ARIA workarounds
// ----------------------------------------------------------------------------------------------------------------
function $5913100b2ed0f596$var$createAriaClickAttrs(handler) {
    return Object.assign({
        onClick: handler
    }, $5913100b2ed0f596$var$createAriaKeyboardAttrs(handler));
}
function $5913100b2ed0f596$var$createAriaKeyboardAttrs(handler) {
    return {
        tabIndex: 0,
        onKeyDown (ev) {
            if (ev.key === "Enter" || ev.key === " ") {
                handler(ev);
                ev.preventDefault(); // if space, don't scroll down page
            }
        }
    };
}
let $5913100b2ed0f596$var$guidNumber = 0;
function $5913100b2ed0f596$export$39b482c5e57630a8() {
    $5913100b2ed0f596$var$guidNumber += 1;
    return String($5913100b2ed0f596$var$guidNumber);
}
/* FullCalendar-specific DOM Utilities
----------------------------------------------------------------------------------------------------------------------*/ // Make the mouse cursor express that an event is not allowed in the current area
function $5913100b2ed0f596$export$9fa96a7d116ea3ce() {
    document.body.classList.add("fc-not-allowed");
}
// Returns the mouse cursor to its original look
function $5913100b2ed0f596$export$92108d983e8ee699() {
    document.body.classList.remove("fc-not-allowed");
}
/* Selection
----------------------------------------------------------------------------------------------------------------------*/ function $5913100b2ed0f596$export$d24c54395ce0c509(el) {
    el.style.userSelect = "none";
    el.style.webkitUserSelect = "none";
    el.addEventListener("selectstart", $5913100b2ed0f596$export$d29e374196577086);
}
function $5913100b2ed0f596$export$6554612db691658e(el) {
    el.style.userSelect = "";
    el.style.webkitUserSelect = "";
    el.removeEventListener("selectstart", $5913100b2ed0f596$export$d29e374196577086);
}
/* Context Menu
----------------------------------------------------------------------------------------------------------------------*/ function $5913100b2ed0f596$export$493d36ec626b6698(el) {
    el.addEventListener("contextmenu", $5913100b2ed0f596$export$d29e374196577086);
}
function $5913100b2ed0f596$export$1fbe638ecf81657e(el) {
    el.removeEventListener("contextmenu", $5913100b2ed0f596$export$d29e374196577086);
}
function $5913100b2ed0f596$export$7a38258bbe170828(input) {
    let specs = [];
    let tokens = [];
    let i;
    let token;
    if (typeof input === "string") tokens = input.split(/\s*,\s*/);
    else if (typeof input === "function") tokens = [
        input
    ];
    else if (Array.isArray(input)) tokens = input;
    for(i = 0; i < tokens.length; i += 1){
        token = tokens[i];
        if (typeof token === "string") specs.push(token.charAt(0) === "-" ? {
            field: token.substring(1),
            order: -1
        } : {
            field: token,
            order: 1
        });
        else if (typeof token === "function") specs.push({
            func: token
        });
    }
    return specs;
}
function $5913100b2ed0f596$export$2f6ca3d3b1f80bf5(obj0, obj1, fieldSpecs) {
    let i;
    let cmp;
    for(i = 0; i < fieldSpecs.length; i += 1){
        cmp = $5913100b2ed0f596$var$compareByFieldSpec(obj0, obj1, fieldSpecs[i]);
        if (cmp) return cmp;
    }
    return 0;
}
function $5913100b2ed0f596$var$compareByFieldSpec(obj0, obj1, fieldSpec) {
    if (fieldSpec.func) return fieldSpec.func(obj0, obj1);
    return $5913100b2ed0f596$export$8a5498727ef6be21(obj0[fieldSpec.field], obj1[fieldSpec.field]) * (fieldSpec.order || 1);
}
function $5913100b2ed0f596$export$8a5498727ef6be21(a, b) {
    if (!a && !b) return 0;
    if (b == null) return -1;
    if (a == null) return 1;
    if (typeof a === "string" || typeof b === "string") return String(a).localeCompare(String(b));
    return a - b;
}
/* String Utilities
----------------------------------------------------------------------------------------------------------------------*/ function $5913100b2ed0f596$export$1a82df3d29112e01(val, len) {
    let s = String(val);
    return "000".substr(0, len - s.length) + s;
}
function $5913100b2ed0f596$export$342063e11d6c3cad(formatter, args, fallbackText) {
    if (typeof formatter === "function") return formatter(...args);
    if (typeof formatter === "string") return args.reduce((str, arg, index)=>str.replace("$" + index, arg || ""), formatter);
    return fallbackText;
}
/* Number Utilities
----------------------------------------------------------------------------------------------------------------------*/ function $5913100b2ed0f596$export$d66dc83d8cfc8dd(a, b) {
    return a - b;
}
function $5913100b2ed0f596$export$306ddfe3a8403e2(n) {
    return n % 1 === 0;
}
/* FC-specific DOM dimension stuff
----------------------------------------------------------------------------------------------------------------------*/ function $5913100b2ed0f596$var$computeSmallestCellWidth(cellEl) {
    let allWidthEl = cellEl.querySelector(".fc-scrollgrid-shrink-frame");
    let contentWidthEl = cellEl.querySelector(".fc-scrollgrid-shrink-cushion");
    if (!allWidthEl) throw new Error("needs fc-scrollgrid-shrink-frame className"); // TODO: use const
    if (!contentWidthEl) throw new Error("needs fc-scrollgrid-shrink-cushion className");
    return cellEl.getBoundingClientRect().width - allWidthEl.getBoundingClientRect().width + // the cell padding+border
    contentWidthEl.getBoundingClientRect().width;
}
const $5913100b2ed0f596$var$INTERNAL_UNITS = [
    "years",
    "months",
    "days",
    "milliseconds"
];
const $5913100b2ed0f596$var$PARSE_RE = /^(-?)(?:(\d+)\.)?(\d+):(\d\d)(?::(\d\d)(?:\.(\d\d\d))?)?/;
// Parsing and Creation
function $5913100b2ed0f596$export$4368d992c4eafac0(input, unit) {
    if (typeof input === "string") return $5913100b2ed0f596$var$parseString(input);
    if (typeof input === "object" && input) return $5913100b2ed0f596$var$parseObject(input);
    if (typeof input === "number") return $5913100b2ed0f596$var$parseObject({
        [unit || "milliseconds"]: input
    });
    return null;
}
function $5913100b2ed0f596$var$parseString(s) {
    let m = $5913100b2ed0f596$var$PARSE_RE.exec(s);
    if (m) {
        let sign = m[1] ? -1 : 1;
        return {
            years: 0,
            months: 0,
            days: sign * (m[2] ? parseInt(m[2], 10) : 0),
            milliseconds: sign * ((m[3] ? parseInt(m[3], 10) : 0) * 3600000 + // hours
            (m[4] ? parseInt(m[4], 10) : 0) * 60000 + // minutes
            (m[5] ? parseInt(m[5], 10) : 0) * 1000 + // seconds
            (m[6] ? parseInt(m[6], 10) : 0 // ms
            ))
        };
    }
    return null;
}
function $5913100b2ed0f596$var$parseObject(obj) {
    let duration = {
        years: obj.years || obj.year || 0,
        months: obj.months || obj.month || 0,
        days: obj.days || obj.day || 0,
        milliseconds: (obj.hours || obj.hour || 0) * 3600000 + // hours
        (obj.minutes || obj.minute || 0) * 60000 + // minutes
        (obj.seconds || obj.second || 0) * 1000 + // seconds
        (obj.milliseconds || obj.millisecond || obj.ms || 0)
    };
    let weeks = obj.weeks || obj.week;
    if (weeks) {
        duration.days += weeks * 7;
        duration.specifiedWeeks = true;
    }
    return duration;
}
// Equality
function $5913100b2ed0f596$var$durationsEqual(d0, d1) {
    return d0.years === d1.years && d0.months === d1.months && d0.days === d1.days && d0.milliseconds === d1.milliseconds;
}
function $5913100b2ed0f596$export$acf3ba20e47771d(dur) {
    if (!dur.years && !dur.months && !dur.milliseconds) return dur.days;
    return 0;
}
// Simple Math
function $5913100b2ed0f596$export$b169257caa88022a(d0, d1) {
    return {
        years: d0.years + d1.years,
        months: d0.months + d1.months,
        days: d0.days + d1.days,
        milliseconds: d0.milliseconds + d1.milliseconds
    };
}
function $5913100b2ed0f596$export$2408f22a0fab9ae5(d1, d0) {
    return {
        years: d1.years - d0.years,
        months: d1.months - d0.months,
        days: d1.days - d0.days,
        milliseconds: d1.milliseconds - d0.milliseconds
    };
}
function $5913100b2ed0f596$export$847533e5bf524f5f(d, n) {
    return {
        years: d.years * n,
        months: d.months * n,
        days: d.days * n,
        milliseconds: d.milliseconds * n
    };
}
// Conversions
// "Rough" because they are based on average-case Gregorian months/years
function $5913100b2ed0f596$var$asRoughYears(dur) {
    return $5913100b2ed0f596$var$asRoughDays(dur) / 365;
}
function $5913100b2ed0f596$var$asRoughMonths(dur) {
    return $5913100b2ed0f596$var$asRoughDays(dur) / 30;
}
function $5913100b2ed0f596$var$asRoughDays(dur) {
    return $5913100b2ed0f596$export$4e222d082f82ee97(dur) / 864e5;
}
function $5913100b2ed0f596$export$4b170465d7badfa1(dur) {
    return $5913100b2ed0f596$export$4e222d082f82ee97(dur) / 60000;
}
function $5913100b2ed0f596$export$479ac0420f53ed26(dur) {
    return $5913100b2ed0f596$export$4e222d082f82ee97(dur) / 1000;
}
function $5913100b2ed0f596$export$4e222d082f82ee97(dur) {
    return dur.years * (365 * 864e5) + dur.months * (30 * 864e5) + dur.days * 864e5 + dur.milliseconds;
}
// Advanced Math
function $5913100b2ed0f596$export$56350196709588fc(numerator, denominator) {
    let res = null;
    for(let i = 0; i < $5913100b2ed0f596$var$INTERNAL_UNITS.length; i += 1){
        let unit = $5913100b2ed0f596$var$INTERNAL_UNITS[i];
        if (denominator[unit]) {
            let localRes = numerator[unit] / denominator[unit];
            if (!$5913100b2ed0f596$export$306ddfe3a8403e2(localRes) || res !== null && res !== localRes) return null;
            res = localRes;
        } else if (numerator[unit]) // needs to divide by something but can't!
        return null;
    }
    return res;
}
function $5913100b2ed0f596$export$db3b6bfb95261072(dur) {
    let ms = dur.milliseconds;
    if (ms) {
        if (ms % 1000 !== 0) return {
            unit: "millisecond",
            value: ms
        };
        if (ms % 60000 !== 0) return {
            unit: "second",
            value: ms / 1000
        };
        if (ms % 3600000 !== 0) return {
            unit: "minute",
            value: ms / 60000
        };
        if (ms) return {
            unit: "hour",
            value: ms / 3600000
        };
    }
    if (dur.days) {
        if (dur.specifiedWeeks && dur.days % 7 === 0) return {
            unit: "week",
            value: dur.days / 7
        };
        return {
            unit: "day",
            value: dur.days
        };
    }
    if (dur.months) return {
        unit: "month",
        value: dur.months
    };
    if (dur.years) return {
        unit: "year",
        value: dur.years
    };
    return {
        unit: "millisecond",
        value: 0
    };
}
// TODO: new util arrayify?
function $5913100b2ed0f596$export$9d398bebfec1c039(array, exactVal) {
    let removeCnt = 0;
    let i = 0;
    while(i < array.length)if (array[i] === exactVal) {
        array.splice(i, 1);
        removeCnt += 1;
    } else i += 1;
    return removeCnt;
}
function $5913100b2ed0f596$export$23f2a1d2818174ef(a0, a1, equalityFunc) {
    if (a0 === a1) return true;
    let len = a0.length;
    let i;
    if (len !== a1.length) return false;
    for(i = 0; i < len; i += 1){
        if (!(equalityFunc ? equalityFunc(a0[i], a1[i]) : a0[i] === a1[i])) return false;
    }
    return true;
}
const $5913100b2ed0f596$var$DAY_IDS = [
    "sun",
    "mon",
    "tue",
    "wed",
    "thu",
    "fri",
    "sat"
];
// Adding
function $5913100b2ed0f596$export$31e67cf12fc9668(m, n) {
    let a = $5913100b2ed0f596$var$dateToUtcArray(m);
    a[2] += n * 7;
    return $5913100b2ed0f596$var$arrayToUtcDate(a);
}
function $5913100b2ed0f596$export$625550452a3fa3ec(m, n) {
    let a = $5913100b2ed0f596$var$dateToUtcArray(m);
    a[2] += n;
    return $5913100b2ed0f596$var$arrayToUtcDate(a);
}
function $5913100b2ed0f596$export$136fd86de524d3c2(m, n) {
    let a = $5913100b2ed0f596$var$dateToUtcArray(m);
    a[6] += n;
    return $5913100b2ed0f596$var$arrayToUtcDate(a);
}
// Diffing (all return floats)
// TODO: why not use ranges?
function $5913100b2ed0f596$export$62d08d6fa708df47(m0, m1) {
    return $5913100b2ed0f596$export$a36fb7d24305ed9d(m0, m1) / 7;
}
function $5913100b2ed0f596$export$a36fb7d24305ed9d(m0, m1) {
    return (m1.valueOf() - m0.valueOf()) / 86400000;
}
function $5913100b2ed0f596$var$diffHours(m0, m1) {
    return (m1.valueOf() - m0.valueOf()) / 3600000;
}
function $5913100b2ed0f596$var$diffMinutes(m0, m1) {
    return (m1.valueOf() - m0.valueOf()) / 60000;
}
function $5913100b2ed0f596$var$diffSeconds(m0, m1) {
    return (m1.valueOf() - m0.valueOf()) / 1000;
}
function $5913100b2ed0f596$export$5521614468b862fb(m0, m1) {
    let m0day = $5913100b2ed0f596$export$9e5f44173e64f162(m0);
    let m1day = $5913100b2ed0f596$export$9e5f44173e64f162(m1);
    return {
        years: 0,
        months: 0,
        days: Math.round($5913100b2ed0f596$export$a36fb7d24305ed9d(m0day, m1day)),
        milliseconds: m1.valueOf() - m1day.valueOf() - (m0.valueOf() - m0day.valueOf())
    };
}
// Diffing Whole Units
function $5913100b2ed0f596$export$b4d5ecaefe2b27f3(m0, m1) {
    let d = $5913100b2ed0f596$export$4a5767248b18ef41(m0, m1);
    if (d !== null && d % 7 === 0) return d / 7;
    return null;
}
function $5913100b2ed0f596$export$4a5767248b18ef41(m0, m1) {
    if ($5913100b2ed0f596$var$timeAsMs(m0) === $5913100b2ed0f596$var$timeAsMs(m1)) return Math.round($5913100b2ed0f596$export$a36fb7d24305ed9d(m0, m1));
    return null;
}
// Start-Of
function $5913100b2ed0f596$export$9e5f44173e64f162(m) {
    return $5913100b2ed0f596$var$arrayToUtcDate([
        m.getUTCFullYear(),
        m.getUTCMonth(),
        m.getUTCDate()
    ]);
}
function $5913100b2ed0f596$var$startOfHour(m) {
    return $5913100b2ed0f596$var$arrayToUtcDate([
        m.getUTCFullYear(),
        m.getUTCMonth(),
        m.getUTCDate(),
        m.getUTCHours()
    ]);
}
function $5913100b2ed0f596$var$startOfMinute(m) {
    return $5913100b2ed0f596$var$arrayToUtcDate([
        m.getUTCFullYear(),
        m.getUTCMonth(),
        m.getUTCDate(),
        m.getUTCHours(),
        m.getUTCMinutes()
    ]);
}
function $5913100b2ed0f596$var$startOfSecond(m) {
    return $5913100b2ed0f596$var$arrayToUtcDate([
        m.getUTCFullYear(),
        m.getUTCMonth(),
        m.getUTCDate(),
        m.getUTCHours(),
        m.getUTCMinutes(),
        m.getUTCSeconds()
    ]);
}
// Week Computation
function $5913100b2ed0f596$var$weekOfYear(marker, dow, doy) {
    let y = marker.getUTCFullYear();
    let w = $5913100b2ed0f596$var$weekOfGivenYear(marker, y, dow, doy);
    if (w < 1) return $5913100b2ed0f596$var$weekOfGivenYear(marker, y - 1, dow, doy);
    let nextW = $5913100b2ed0f596$var$weekOfGivenYear(marker, y + 1, dow, doy);
    if (nextW >= 1) return Math.min(w, nextW);
    return w;
}
function $5913100b2ed0f596$var$weekOfGivenYear(marker, year, dow, doy) {
    let firstWeekStart = $5913100b2ed0f596$var$arrayToUtcDate([
        year,
        0,
        1 + $5913100b2ed0f596$var$firstWeekOffset(year, dow, doy)
    ]);
    let dayStart = $5913100b2ed0f596$export$9e5f44173e64f162(marker);
    let days = Math.round($5913100b2ed0f596$export$a36fb7d24305ed9d(firstWeekStart, dayStart));
    return Math.floor(days / 7) + 1; // zero-indexed
}
// start-of-first-week - start-of-year
function $5913100b2ed0f596$var$firstWeekOffset(year, dow, doy) {
    // first-week day -- which january is always in the first week (4 for iso, 1 for other)
    let fwd = 7 + dow - doy;
    // first-week day local weekday -- which local weekday is fwd
    let fwdlw = (7 + $5913100b2ed0f596$var$arrayToUtcDate([
        year,
        0,
        fwd
    ]).getUTCDay() - dow) % 7;
    return -fwdlw + fwd - 1;
}
// Array Conversion
function $5913100b2ed0f596$var$dateToLocalArray(date) {
    return [
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds(),
        date.getMilliseconds()
    ];
}
function $5913100b2ed0f596$var$arrayToLocalDate(a) {
    return new Date(a[0], a[1] || 0, a[2] == null ? 1 : a[2], a[3] || 0, a[4] || 0, a[5] || 0);
}
function $5913100b2ed0f596$var$dateToUtcArray(date) {
    return [
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        date.getUTCHours(),
        date.getUTCMinutes(),
        date.getUTCSeconds(),
        date.getUTCMilliseconds()
    ];
}
function $5913100b2ed0f596$var$arrayToUtcDate(a) {
    // according to web standards (and Safari), a month index is required.
    // massage if only given a year.
    if (a.length === 1) a = a.concat([
        0
    ]);
    return new Date(Date.UTC(...a));
}
// Other Utils
function $5913100b2ed0f596$export$55ff3cc1821e8445(m) {
    return !isNaN(m.valueOf());
}
function $5913100b2ed0f596$var$timeAsMs(m) {
    return m.getUTCHours() * 3600000 + m.getUTCMinutes() * 60000 + m.getUTCSeconds() * 1000 + m.getUTCMilliseconds();
}
// timeZoneOffset is in minutes
function $5913100b2ed0f596$export$45d219bdcd8ac53c(marker, timeZoneOffset, stripZeroTime = false) {
    let s = marker.toISOString();
    s = s.replace(".000", "");
    if (stripZeroTime) s = s.replace("T00:00:00Z", "");
    if (s.length > 10) {
        if (timeZoneOffset == null) s = s.replace("Z", "");
        else if (timeZoneOffset !== 0) s = s.replace("Z", $5913100b2ed0f596$var$formatTimeZoneOffset(timeZoneOffset, true));
    // otherwise, its UTC-0 and we want to keep the Z
    }
    return s;
}
// formats the date, but with no time part
// TODO: somehow merge with buildIsoString and stripZeroTime
// TODO: rename. omit "string"
function $5913100b2ed0f596$export$5dbe06c6d8c68cfb(marker) {
    return marker.toISOString().replace(/T.*$/, "");
}
function $5913100b2ed0f596$export$26a0a7676ca7aa04(marker) {
    return marker.toISOString().match(/^\d{4}-\d{2}/)[0];
}
// TODO: use Date::toISOString and use everything after the T?
function $5913100b2ed0f596$export$f438b12253c2b499(marker) {
    return $5913100b2ed0f596$export$1a82df3d29112e01(marker.getUTCHours(), 2) + ":" + $5913100b2ed0f596$export$1a82df3d29112e01(marker.getUTCMinutes(), 2) + ":" + $5913100b2ed0f596$export$1a82df3d29112e01(marker.getUTCSeconds(), 2);
}
function $5913100b2ed0f596$var$formatTimeZoneOffset(minutes, doIso = false) {
    let sign = minutes < 0 ? "-" : "+";
    let abs = Math.abs(minutes);
    let hours = Math.floor(abs / 60);
    let mins = Math.round(abs % 60);
    if (doIso) return `${sign + $5913100b2ed0f596$export$1a82df3d29112e01(hours, 2)}:${$5913100b2ed0f596$export$1a82df3d29112e01(mins, 2)}`;
    return `GMT${sign}${hours}${mins ? `:${$5913100b2ed0f596$export$1a82df3d29112e01(mins, 2)}` : ""}`;
}
function $5913100b2ed0f596$export$df995fae86a55f06(workerFunc, resEquality, teardownFunc) {
    let currentArgs;
    let currentRes;
    return function(...newArgs) {
        if (!currentArgs) currentRes = workerFunc.apply(this, newArgs);
        else if (!$5913100b2ed0f596$export$23f2a1d2818174ef(currentArgs, newArgs)) {
            if (teardownFunc) teardownFunc(currentRes);
            let res = workerFunc.apply(this, newArgs);
            if (!resEquality || !resEquality(res, currentRes)) currentRes = res;
        }
        currentArgs = newArgs;
        return currentRes;
    };
}
function $5913100b2ed0f596$export$ebd11618f299a286(workerFunc, resEquality, teardownFunc) {
    let currentArg;
    let currentRes;
    return (newArg)=>{
        if (!currentArg) currentRes = workerFunc.call(this, newArg);
        else if (!$5913100b2ed0f596$export$a9c23c6ac3fc3eca(currentArg, newArg)) {
            if (teardownFunc) teardownFunc(currentRes);
            let res = workerFunc.call(this, newArg);
            if (!resEquality || !resEquality(res, currentRes)) currentRes = res;
        }
        currentArg = newArg;
        return currentRes;
    };
}
function $5913100b2ed0f596$export$890c4ad488842ce7(workerFunc, resEquality, teardownFunc) {
    let currentArgSets = [];
    let currentResults = [];
    return (newArgSets)=>{
        let currentLen = currentArgSets.length;
        let newLen = newArgSets.length;
        let i = 0;
        for(; i < currentLen; i += 1){
            if (!newArgSets[i]) {
                if (teardownFunc) teardownFunc(currentResults[i]);
            } else if (!$5913100b2ed0f596$export$23f2a1d2818174ef(currentArgSets[i], newArgSets[i])) {
                if (teardownFunc) teardownFunc(currentResults[i]);
                let res = workerFunc.apply(this, newArgSets[i]);
                if (!resEquality || !resEquality(res, currentResults[i])) currentResults[i] = res;
            }
        }
        for(; i < newLen; i += 1)currentResults[i] = workerFunc.apply(this, newArgSets[i]);
        currentArgSets = newArgSets;
        currentResults.splice(newLen); // remove excess
        return currentResults;
    };
}
function $5913100b2ed0f596$export$24baa2b76016ce0e(workerFunc, resEquality, teardownFunc) {
    let currentArgHash = {};
    let currentResHash = {};
    return (newArgHash)=>{
        let newResHash = {};
        for(let key in newArgHash){
            if (!currentResHash[key]) newResHash[key] = workerFunc.apply(this, newArgHash[key]);
            else if (!$5913100b2ed0f596$export$23f2a1d2818174ef(currentArgHash[key], newArgHash[key])) {
                if (teardownFunc) teardownFunc(currentResHash[key]);
                let res = workerFunc.apply(this, newArgHash[key]);
                newResHash[key] = resEquality && resEquality(res, currentResHash[key]) ? currentResHash[key] : res;
            } else newResHash[key] = currentResHash[key];
        }
        currentArgHash = newArgHash;
        currentResHash = newResHash;
        return newResHash;
    };
}
const $5913100b2ed0f596$var$EXTENDED_SETTINGS_AND_SEVERITIES = {
    week: 3,
    separator: 0,
    omitZeroMinute: 0,
    meridiem: 0,
    omitCommas: 0
};
const $5913100b2ed0f596$var$STANDARD_DATE_PROP_SEVERITIES = {
    timeZoneName: 7,
    era: 6,
    year: 5,
    month: 4,
    day: 2,
    weekday: 2,
    hour: 1,
    minute: 1,
    second: 1
};
const $5913100b2ed0f596$var$MERIDIEM_RE = /\s*([ap])\.?m\.?/i; // eats up leading spaces too
const $5913100b2ed0f596$var$COMMA_RE = /,/g; // we need re for globalness
const $5913100b2ed0f596$var$MULTI_SPACE_RE = /\s+/g;
const $5913100b2ed0f596$var$LTR_RE = /\u200e/g; // control character
const $5913100b2ed0f596$var$UTC_RE = /UTC|GMT/;
class $5913100b2ed0f596$var$NativeFormatter {
    constructor(formatSettings){
        let standardDateProps = {};
        let extendedSettings = {};
        let severity = 0;
        for(let name in formatSettings)if (name in $5913100b2ed0f596$var$EXTENDED_SETTINGS_AND_SEVERITIES) {
            extendedSettings[name] = formatSettings[name];
            severity = Math.max($5913100b2ed0f596$var$EXTENDED_SETTINGS_AND_SEVERITIES[name], severity);
        } else {
            standardDateProps[name] = formatSettings[name];
            if (name in $5913100b2ed0f596$var$STANDARD_DATE_PROP_SEVERITIES) severity = Math.max($5913100b2ed0f596$var$STANDARD_DATE_PROP_SEVERITIES[name], severity);
        }
        this.standardDateProps = standardDateProps;
        this.extendedSettings = extendedSettings;
        this.severity = severity;
        this.buildFormattingFunc = $5913100b2ed0f596$export$df995fae86a55f06($5913100b2ed0f596$var$buildFormattingFunc);
    }
    format(date, context) {
        return this.buildFormattingFunc(this.standardDateProps, this.extendedSettings, context)(date);
    }
    formatRange(start, end, context, betterDefaultSeparator) {
        let { standardDateProps: standardDateProps, extendedSettings: extendedSettings } = this;
        let diffSeverity = $5913100b2ed0f596$var$computeMarkerDiffSeverity(start.marker, end.marker, context.calendarSystem);
        if (!diffSeverity) return this.format(start, context);
        let biggestUnitForPartial = diffSeverity;
        if (biggestUnitForPartial > 1 && // the two dates are different in a way that's larger scale than time
        (standardDateProps.year === "numeric" || standardDateProps.year === "2-digit") && (standardDateProps.month === "numeric" || standardDateProps.month === "2-digit") && (standardDateProps.day === "numeric" || standardDateProps.day === "2-digit")) biggestUnitForPartial = 1; // make it look like the dates are only different in terms of time
        let full0 = this.format(start, context);
        let full1 = this.format(end, context);
        if (full0 === full1) return full0;
        let partialDateProps = $5913100b2ed0f596$var$computePartialFormattingOptions(standardDateProps, biggestUnitForPartial);
        let partialFormattingFunc = $5913100b2ed0f596$var$buildFormattingFunc(partialDateProps, extendedSettings, context);
        let partial0 = partialFormattingFunc(start);
        let partial1 = partialFormattingFunc(end);
        let insertion = $5913100b2ed0f596$var$findCommonInsertion(full0, partial0, full1, partial1);
        let separator = extendedSettings.separator || betterDefaultSeparator || context.defaultSeparator || "";
        if (insertion) return insertion.before + partial0 + separator + partial1 + insertion.after;
        return full0 + separator + full1;
    }
    getLargestUnit() {
        switch(this.severity){
            case 7:
            case 6:
            case 5:
                return "year";
            case 4:
                return "month";
            case 3:
                return "week";
            case 2:
                return "day";
            default:
                return "time"; // really?
        }
    }
}
function $5913100b2ed0f596$var$buildFormattingFunc(standardDateProps, extendedSettings, context) {
    let standardDatePropCnt = Object.keys(standardDateProps).length;
    if (standardDatePropCnt === 1 && standardDateProps.timeZoneName === "short") return (date)=>$5913100b2ed0f596$var$formatTimeZoneOffset(date.timeZoneOffset);
    if (standardDatePropCnt === 0 && extendedSettings.week) return (date)=>$5913100b2ed0f596$var$formatWeekNumber(context.computeWeekNumber(date.marker), context.weekText, context.weekTextLong, context.locale, extendedSettings.week);
    return $5913100b2ed0f596$var$buildNativeFormattingFunc(standardDateProps, extendedSettings, context);
}
function $5913100b2ed0f596$var$buildNativeFormattingFunc(standardDateProps, extendedSettings, context) {
    standardDateProps = Object.assign({}, standardDateProps); // copy
    extendedSettings = Object.assign({}, extendedSettings); // copy
    $5913100b2ed0f596$var$sanitizeSettings(standardDateProps, extendedSettings);
    standardDateProps.timeZone = "UTC"; // we leverage the only guaranteed timeZone for our UTC markers
    let normalFormat = new Intl.DateTimeFormat(context.locale.codes, standardDateProps);
    let zeroFormat; // needed?
    if (extendedSettings.omitZeroMinute) {
        let zeroProps = Object.assign({}, standardDateProps);
        delete zeroProps.minute; // seconds and ms were already considered in sanitizeSettings
        zeroFormat = new Intl.DateTimeFormat(context.locale.codes, zeroProps);
    }
    return (date)=>{
        let { marker: marker } = date;
        let format;
        if (zeroFormat && !marker.getUTCMinutes()) format = zeroFormat;
        else format = normalFormat;
        let s = format.format(marker);
        return $5913100b2ed0f596$var$postProcess(s, date, standardDateProps, extendedSettings, context);
    };
}
function $5913100b2ed0f596$var$sanitizeSettings(standardDateProps, extendedSettings) {
    // deal with a browser inconsistency where formatting the timezone
    // requires that the hour/minute be present.
    if (standardDateProps.timeZoneName) {
        if (!standardDateProps.hour) standardDateProps.hour = "2-digit";
        if (!standardDateProps.minute) standardDateProps.minute = "2-digit";
    }
    // only support short timezone names
    if (standardDateProps.timeZoneName === "long") standardDateProps.timeZoneName = "short";
    // if requesting to display seconds, MUST display minutes
    if (extendedSettings.omitZeroMinute && (standardDateProps.second || standardDateProps.millisecond)) delete extendedSettings.omitZeroMinute;
}
function $5913100b2ed0f596$var$postProcess(s, date, standardDateProps, extendedSettings, context) {
    s = s.replace($5913100b2ed0f596$var$LTR_RE, ""); // remove left-to-right control chars. do first. good for other regexes
    if (standardDateProps.timeZoneName === "short") s = $5913100b2ed0f596$var$injectTzoStr(s, context.timeZone === "UTC" || date.timeZoneOffset == null ? "UTC" : $5913100b2ed0f596$var$formatTimeZoneOffset(date.timeZoneOffset));
    if (extendedSettings.omitCommas) s = s.replace($5913100b2ed0f596$var$COMMA_RE, "").trim();
    if (extendedSettings.omitZeroMinute) s = s.replace(":00", ""); // zeroFormat doesn't always achieve this
    // ^ do anything that might create adjacent spaces before this point,
    // because MERIDIEM_RE likes to eat up loading spaces
    if (extendedSettings.meridiem === false) s = s.replace($5913100b2ed0f596$var$MERIDIEM_RE, "").trim();
    else if (extendedSettings.meridiem === "narrow") s = s.replace($5913100b2ed0f596$var$MERIDIEM_RE, (m0, m1)=>m1.toLocaleLowerCase());
    else if (extendedSettings.meridiem === "short") s = s.replace($5913100b2ed0f596$var$MERIDIEM_RE, (m0, m1)=>`${m1.toLocaleLowerCase()}m`);
    else if (extendedSettings.meridiem === "lowercase") s = s.replace($5913100b2ed0f596$var$MERIDIEM_RE, (m0)=>m0.toLocaleLowerCase());
    s = s.replace($5913100b2ed0f596$var$MULTI_SPACE_RE, " ");
    s = s.trim();
    return s;
}
function $5913100b2ed0f596$var$injectTzoStr(s, tzoStr) {
    let replaced = false;
    s = s.replace($5913100b2ed0f596$var$UTC_RE, ()=>{
        replaced = true;
        return tzoStr;
    });
    // IE11 doesn't include UTC/GMT in the original string, so append to end
    if (!replaced) s += ` ${tzoStr}`;
    return s;
}
function $5913100b2ed0f596$var$formatWeekNumber(num, weekText, weekTextLong, locale, display) {
    let parts = [];
    if (display === "long") parts.push(weekTextLong);
    else if (display === "short" || display === "narrow") parts.push(weekText);
    if (display === "long" || display === "short") parts.push(" ");
    parts.push(locale.simpleNumberFormat.format(num));
    if (locale.options.direction === "rtl") parts.reverse();
    return parts.join("");
}
// Range Formatting Utils
// 0 = exactly the same
// 1 = different by time
// and bigger
function $5913100b2ed0f596$var$computeMarkerDiffSeverity(d0, d1, ca) {
    if (ca.getMarkerYear(d0) !== ca.getMarkerYear(d1)) return 5;
    if (ca.getMarkerMonth(d0) !== ca.getMarkerMonth(d1)) return 4;
    if (ca.getMarkerDay(d0) !== ca.getMarkerDay(d1)) return 2;
    if ($5913100b2ed0f596$var$timeAsMs(d0) !== $5913100b2ed0f596$var$timeAsMs(d1)) return 1;
    return 0;
}
function $5913100b2ed0f596$var$computePartialFormattingOptions(options, biggestUnit) {
    let partialOptions = {};
    for(let name in options)if (!(name in $5913100b2ed0f596$var$STANDARD_DATE_PROP_SEVERITIES) || // not a date part prop (like timeZone)
    $5913100b2ed0f596$var$STANDARD_DATE_PROP_SEVERITIES[name] <= biggestUnit) partialOptions[name] = options[name];
    return partialOptions;
}
function $5913100b2ed0f596$var$findCommonInsertion(full0, partial0, full1, partial1) {
    let i0 = 0;
    while(i0 < full0.length){
        let found0 = full0.indexOf(partial0, i0);
        if (found0 === -1) break;
        let before0 = full0.substr(0, found0);
        i0 = found0 + partial0.length;
        let after0 = full0.substr(i0);
        let i1 = 0;
        while(i1 < full1.length){
            let found1 = full1.indexOf(partial1, i1);
            if (found1 === -1) break;
            let before1 = full1.substr(0, found1);
            i1 = found1 + partial1.length;
            let after1 = full1.substr(i1);
            if (before0 === before1 && after0 === after1) return {
                before: before0,
                after: after0
            };
        }
    }
    return null;
}
function $5913100b2ed0f596$var$expandZonedMarker(dateInfo, calendarSystem) {
    let a = calendarSystem.markerToArray(dateInfo.marker);
    return {
        marker: dateInfo.marker,
        timeZoneOffset: dateInfo.timeZoneOffset,
        array: a,
        year: a[0],
        month: a[1],
        day: a[2],
        hour: a[3],
        minute: a[4],
        second: a[5],
        millisecond: a[6]
    };
}
function $5913100b2ed0f596$var$createVerboseFormattingArg(start, end, context, betterDefaultSeparator) {
    let startInfo = $5913100b2ed0f596$var$expandZonedMarker(start, context.calendarSystem);
    let endInfo = end ? $5913100b2ed0f596$var$expandZonedMarker(end, context.calendarSystem) : null;
    return {
        date: startInfo,
        start: startInfo,
        end: endInfo,
        timeZone: context.timeZone,
        localeCodes: context.locale.codes,
        defaultSeparator: betterDefaultSeparator || context.defaultSeparator
    };
}
/*
TODO: fix the terminology of "formatter" vs "formatting func"
*/ /*
At the time of instantiation, this object does not know which cmd-formatting system it will use.
It receives this at the time of formatting, as a setting.
*/ class $5913100b2ed0f596$var$CmdFormatter {
    constructor(cmdStr){
        this.cmdStr = cmdStr;
    }
    format(date, context, betterDefaultSeparator) {
        return context.cmdFormatter(this.cmdStr, $5913100b2ed0f596$var$createVerboseFormattingArg(date, null, context, betterDefaultSeparator));
    }
    formatRange(start, end, context, betterDefaultSeparator) {
        return context.cmdFormatter(this.cmdStr, $5913100b2ed0f596$var$createVerboseFormattingArg(start, end, context, betterDefaultSeparator));
    }
}
class $5913100b2ed0f596$var$FuncFormatter {
    constructor(func){
        this.func = func;
    }
    format(date, context, betterDefaultSeparator) {
        return this.func($5913100b2ed0f596$var$createVerboseFormattingArg(date, null, context, betterDefaultSeparator));
    }
    formatRange(start, end, context, betterDefaultSeparator) {
        return this.func($5913100b2ed0f596$var$createVerboseFormattingArg(start, end, context, betterDefaultSeparator));
    }
}
function $5913100b2ed0f596$export$d141bba7fdc215a3(input) {
    if (typeof input === "object" && input) return new $5913100b2ed0f596$var$NativeFormatter(input);
    if (typeof input === "string") return new $5913100b2ed0f596$var$CmdFormatter(input);
    if (typeof input === "function") return new $5913100b2ed0f596$var$FuncFormatter(input);
    return null;
}
// base options
// ------------
const $5913100b2ed0f596$export$a07804094c3ecf2d = {
    navLinkDayClick: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    navLinkWeekClick: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    duration: $5913100b2ed0f596$export$4368d992c4eafac0,
    bootstrapFontAwesome: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    buttonIcons: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    customButtons: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    defaultAllDayEventDuration: $5913100b2ed0f596$export$4368d992c4eafac0,
    defaultTimedEventDuration: $5913100b2ed0f596$export$4368d992c4eafac0,
    nextDayThreshold: $5913100b2ed0f596$export$4368d992c4eafac0,
    scrollTime: $5913100b2ed0f596$export$4368d992c4eafac0,
    scrollTimeReset: Boolean,
    slotMinTime: $5913100b2ed0f596$export$4368d992c4eafac0,
    slotMaxTime: $5913100b2ed0f596$export$4368d992c4eafac0,
    dayPopoverFormat: $5913100b2ed0f596$export$d141bba7fdc215a3,
    slotDuration: $5913100b2ed0f596$export$4368d992c4eafac0,
    snapDuration: $5913100b2ed0f596$export$4368d992c4eafac0,
    headerToolbar: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    footerToolbar: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    defaultRangeSeparator: String,
    titleRangeSeparator: String,
    forceEventDuration: Boolean,
    dayHeaders: Boolean,
    dayHeaderFormat: $5913100b2ed0f596$export$d141bba7fdc215a3,
    dayHeaderClassNames: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    dayHeaderContent: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    dayHeaderDidMount: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    dayHeaderWillUnmount: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    dayCellClassNames: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    dayCellContent: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    dayCellDidMount: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    dayCellWillUnmount: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    initialView: String,
    aspectRatio: Number,
    weekends: Boolean,
    weekNumberCalculation: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    weekNumbers: Boolean,
    weekNumberClassNames: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    weekNumberContent: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    weekNumberDidMount: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    weekNumberWillUnmount: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    editable: Boolean,
    viewClassNames: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    viewDidMount: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    viewWillUnmount: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    nowIndicator: Boolean,
    nowIndicatorClassNames: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    nowIndicatorContent: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    nowIndicatorDidMount: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    nowIndicatorWillUnmount: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    showNonCurrentDates: Boolean,
    lazyFetching: Boolean,
    startParam: String,
    endParam: String,
    timeZoneParam: String,
    timeZone: String,
    locales: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    locale: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    themeSystem: String,
    dragRevertDuration: Number,
    dragScroll: Boolean,
    allDayMaintainDuration: Boolean,
    unselectAuto: Boolean,
    dropAccept: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    eventOrder: $5913100b2ed0f596$export$7a38258bbe170828,
    eventOrderStrict: Boolean,
    handleWindowResize: Boolean,
    windowResizeDelay: Number,
    longPressDelay: Number,
    eventDragMinDistance: Number,
    expandRows: Boolean,
    height: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    contentHeight: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    direction: String,
    weekNumberFormat: $5913100b2ed0f596$export$d141bba7fdc215a3,
    eventResizableFromStart: Boolean,
    displayEventTime: Boolean,
    displayEventEnd: Boolean,
    weekText: String,
    weekTextLong: String,
    progressiveEventRendering: Boolean,
    businessHours: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    initialDate: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    now: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    eventDataTransform: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    stickyHeaderDates: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    stickyFooterScrollbar: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    viewHeight: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    defaultAllDay: Boolean,
    eventSourceFailure: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    eventSourceSuccess: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    eventDisplay: String,
    eventStartEditable: Boolean,
    eventDurationEditable: Boolean,
    eventOverlap: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    eventConstraint: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    eventAllow: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    eventBackgroundColor: String,
    eventBorderColor: String,
    eventTextColor: String,
    eventColor: String,
    eventClassNames: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    eventContent: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    eventDidMount: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    eventWillUnmount: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    selectConstraint: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    selectOverlap: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    selectAllow: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    droppable: Boolean,
    unselectCancel: String,
    slotLabelFormat: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    slotLaneClassNames: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    slotLaneContent: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    slotLaneDidMount: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    slotLaneWillUnmount: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    slotLabelClassNames: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    slotLabelContent: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    slotLabelDidMount: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    slotLabelWillUnmount: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    dayMaxEvents: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    dayMaxEventRows: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    dayMinWidth: Number,
    slotLabelInterval: $5913100b2ed0f596$export$4368d992c4eafac0,
    allDayText: String,
    allDayClassNames: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    allDayContent: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    allDayDidMount: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    allDayWillUnmount: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    slotMinWidth: Number,
    navLinks: Boolean,
    eventTimeFormat: $5913100b2ed0f596$export$d141bba7fdc215a3,
    rerenderDelay: Number,
    moreLinkText: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    moreLinkHint: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    selectMinDistance: Number,
    selectable: Boolean,
    selectLongPressDelay: Number,
    eventLongPressDelay: Number,
    selectMirror: Boolean,
    eventMaxStack: Number,
    eventMinHeight: Number,
    eventMinWidth: Number,
    eventShortHeight: Number,
    slotEventOverlap: Boolean,
    plugins: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    firstDay: Number,
    dayCount: Number,
    dateAlignment: String,
    dateIncrement: $5913100b2ed0f596$export$4368d992c4eafac0,
    hiddenDays: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    fixedWeekCount: Boolean,
    validRange: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    visibleRange: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    titleFormat: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    eventInteractive: Boolean,
    // only used by list-view, but languages define the value, so we need it in base options
    noEventsText: String,
    viewHint: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    navLinkHint: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    closeHint: String,
    timeHint: String,
    eventHint: String,
    moreLinkClick: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    moreLinkClassNames: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    moreLinkContent: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    moreLinkDidMount: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    moreLinkWillUnmount: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    monthStartFormat: $5913100b2ed0f596$export$d141bba7fdc215a3,
    // for connectors
    // (can't be part of plugin system b/c must be provided at runtime)
    handleCustomRendering: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    customRenderingMetaMap: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    customRenderingReplaces: Boolean
};
// do NOT give a type here. need `typeof BASE_OPTION_DEFAULTS` to give real results.
// raw values.
const $5913100b2ed0f596$export$f1e1789686576879 = {
    eventDisplay: "auto",
    defaultRangeSeparator: " - ",
    titleRangeSeparator: " \u2013 ",
    defaultTimedEventDuration: "01:00:00",
    defaultAllDayEventDuration: {
        day: 1
    },
    forceEventDuration: false,
    nextDayThreshold: "00:00:00",
    dayHeaders: true,
    initialView: "",
    aspectRatio: 1.35,
    headerToolbar: {
        start: "title",
        center: "",
        end: "today prev,next"
    },
    weekends: true,
    weekNumbers: false,
    weekNumberCalculation: "local",
    editable: false,
    nowIndicator: false,
    scrollTime: "06:00:00",
    scrollTimeReset: true,
    slotMinTime: "00:00:00",
    slotMaxTime: "24:00:00",
    showNonCurrentDates: true,
    lazyFetching: true,
    startParam: "start",
    endParam: "end",
    timeZoneParam: "timeZone",
    timeZone: "local",
    locales: [],
    locale: "",
    themeSystem: "standard",
    dragRevertDuration: 500,
    dragScroll: true,
    allDayMaintainDuration: false,
    unselectAuto: true,
    dropAccept: "*",
    eventOrder: "start,-duration,allDay,title",
    dayPopoverFormat: {
        month: "long",
        day: "numeric",
        year: "numeric"
    },
    handleWindowResize: true,
    windowResizeDelay: 100,
    longPressDelay: 1000,
    eventDragMinDistance: 5,
    expandRows: false,
    navLinks: false,
    selectable: false,
    eventMinHeight: 15,
    eventMinWidth: 30,
    eventShortHeight: 30,
    monthStartFormat: {
        month: "long",
        day: "numeric"
    }
};
// calendar listeners
// ------------------
const $5913100b2ed0f596$export$c4ce752e73470fba = {
    datesSet: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    eventsSet: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    eventAdd: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    eventChange: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    eventRemove: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    windowResize: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    eventClick: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    eventMouseEnter: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    eventMouseLeave: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    select: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    unselect: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    loading: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    // internal
    _unmount: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    _beforeprint: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    _afterprint: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    _noEventDrop: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    _noEventResize: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    _resize: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    _scrollRequest: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5
};
// calendar-specific options
// -------------------------
const $5913100b2ed0f596$export$56c0d5a1e737357d = {
    buttonText: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    buttonHints: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    views: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    plugins: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    initialEvents: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    events: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    eventSources: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5
};
const $5913100b2ed0f596$export$3722cfe417b6ed86 = {
    headerToolbar: $5913100b2ed0f596$var$isMaybeObjectsEqual,
    footerToolbar: $5913100b2ed0f596$var$isMaybeObjectsEqual,
    buttonText: $5913100b2ed0f596$var$isMaybeObjectsEqual,
    buttonHints: $5913100b2ed0f596$var$isMaybeObjectsEqual,
    buttonIcons: $5913100b2ed0f596$var$isMaybeObjectsEqual,
    dateIncrement: $5913100b2ed0f596$var$isMaybeObjectsEqual,
    plugins: $5913100b2ed0f596$var$isMaybeArraysEqual,
    events: $5913100b2ed0f596$var$isMaybeArraysEqual,
    eventSources: $5913100b2ed0f596$var$isMaybeArraysEqual,
    ["resources"]: $5913100b2ed0f596$var$isMaybeArraysEqual
};
function $5913100b2ed0f596$var$isMaybeObjectsEqual(a, b) {
    if (typeof a === "object" && typeof b === "object" && a && b) return $5913100b2ed0f596$export$a9c23c6ac3fc3eca(a, b);
    return a === b;
}
function $5913100b2ed0f596$var$isMaybeArraysEqual(a, b) {
    if (Array.isArray(a) && Array.isArray(b)) return $5913100b2ed0f596$export$23f2a1d2818174ef(a, b);
    return a === b;
}
// view-specific options
// ---------------------
const $5913100b2ed0f596$export$db202ddc8be9136 = {
    type: String,
    component: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    buttonText: String,
    buttonTextKey: String,
    dateProfileGeneratorClass: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    usesMinMaxTime: Boolean,
    classNames: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    content: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    didMount: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    willUnmount: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5
};
// util funcs
// ----------------------------------------------------------------------------------------------------
function $5913100b2ed0f596$export$3a1a48c8f6ef640e(optionSets) {
    return $5913100b2ed0f596$export$953cecd6e717a553(optionSets, $5913100b2ed0f596$export$3722cfe417b6ed86);
}
function $5913100b2ed0f596$export$f38c853ae54ed474(input, refiners) {
    let refined = {};
    let extra = {};
    for(let propName in refiners)if (propName in input) refined[propName] = refiners[propName](input[propName]);
    for(let propName in input)if (!(propName in refiners)) extra[propName] = input[propName];
    return {
        refined: refined,
        extra: extra
    };
}
function $5913100b2ed0f596$export$7ccc53e8f1e7dfc5(raw) {
    return raw;
}
const { hasOwnProperty: $5913100b2ed0f596$var$hasOwnProperty } = Object.prototype;
// Merges an array of objects into a single object.
// The second argument allows for an array of property names who's object values will be merged together.
function $5913100b2ed0f596$export$953cecd6e717a553(propObjs, complexPropsMap) {
    let dest = {};
    if (complexPropsMap) {
        for(let name in complexPropsMap)if (complexPropsMap[name] === $5913100b2ed0f596$var$isMaybeObjectsEqual) {
            let complexObjs = [];
            // collect the trailing object values, stopping when a non-object is discovered
            for(let i = propObjs.length - 1; i >= 0; i -= 1){
                let val = propObjs[i][name];
                if (typeof val === "object" && val) complexObjs.unshift(val);
                else if (val !== undefined) {
                    dest[name] = val; // if there were no objects, this value will be used
                    break;
                }
            }
            // if the trailing values were objects, use the merged value
            if (complexObjs.length) dest[name] = $5913100b2ed0f596$export$953cecd6e717a553(complexObjs);
        }
    }
    // copy values into the destination, going from last to first
    for(let i = propObjs.length - 1; i >= 0; i -= 1){
        let props = propObjs[i];
        for(let name in props)if (!(name in dest)) dest[name] = props[name];
    }
    return dest;
}
function $5913100b2ed0f596$export$dda1d9f60106f0e9(hash, func) {
    let filtered = {};
    for(let key in hash)if (func(hash[key], key)) filtered[key] = hash[key];
    return filtered;
}
function $5913100b2ed0f596$export$407448d2b89b1813(hash, func) {
    let newHash = {};
    for(let key in hash)newHash[key] = func(hash[key], key);
    return newHash;
}
function $5913100b2ed0f596$export$2d1720544b23b823(a) {
    let hash = {};
    for (let item of a)hash[item] = true;
    return hash;
}
// TODO: reassess browser support
// https://caniuse.com/?search=object.values
function $5913100b2ed0f596$export$90a7f3efeed30595(obj) {
    let a = [];
    for(let key in obj)a.push(obj[key]);
    return a;
}
function $5913100b2ed0f596$export$a9c23c6ac3fc3eca(obj0, obj1) {
    if (obj0 === obj1) return true;
    for(let key in obj0)if ($5913100b2ed0f596$var$hasOwnProperty.call(obj0, key)) {
        if (!(key in obj1)) return false;
    }
    for(let key in obj1)if ($5913100b2ed0f596$var$hasOwnProperty.call(obj1, key)) {
        if (obj0[key] !== obj1[key]) return false;
    }
    return true;
}
const $5913100b2ed0f596$var$HANDLER_RE = /^on[A-Z]/;
function $5913100b2ed0f596$var$isNonHandlerPropsEqual(obj0, obj1) {
    const keys = $5913100b2ed0f596$var$getUnequalProps(obj0, obj1);
    for (let key of keys){
        if (!$5913100b2ed0f596$var$HANDLER_RE.test(key)) return false;
    }
    return true;
}
function $5913100b2ed0f596$var$getUnequalProps(obj0, obj1) {
    let keys = [];
    for(let key in obj0){
        if ($5913100b2ed0f596$var$hasOwnProperty.call(obj0, key)) {
            if (!(key in obj1)) keys.push(key);
        }
    }
    for(let key in obj1){
        if ($5913100b2ed0f596$var$hasOwnProperty.call(obj1, key)) {
            if (obj0[key] !== obj1[key]) keys.push(key);
        }
    }
    return keys;
}
function $5913100b2ed0f596$export$23ebac1979863676(oldProps, newProps, equalityFuncs = {}) {
    if (oldProps === newProps) return true;
    for(let key in newProps){
        if (key in oldProps && $5913100b2ed0f596$var$isObjValsEqual(oldProps[key], newProps[key], equalityFuncs[key])) ;
        else return false;
    }
    // check for props that were omitted in the new
    for(let key in oldProps){
        if (!(key in newProps)) return false;
    }
    return true;
}
/*
assumed "true" equality for handler names like "onReceiveSomething"
*/ function $5913100b2ed0f596$var$isObjValsEqual(val0, val1, comparator) {
    if (val0 === val1 || comparator === true) return true;
    if (comparator) return comparator(val0, val1);
    return false;
}
function $5913100b2ed0f596$export$91477dc880baac21(hash, startIndex = 0, endIndex, step = 1) {
    let res = [];
    if (endIndex == null) endIndex = Object.keys(hash).length;
    for(let i = startIndex; i < endIndex; i += step){
        let val = hash[i];
        if (val !== undefined) res.push(val);
    }
    return res;
}
let $5913100b2ed0f596$var$calendarSystemClassMap = {};
function $5913100b2ed0f596$var$registerCalendarSystem(name, theClass) {
    $5913100b2ed0f596$var$calendarSystemClassMap[name] = theClass;
}
function $5913100b2ed0f596$var$createCalendarSystem(name) {
    return new $5913100b2ed0f596$var$calendarSystemClassMap[name]();
}
class $5913100b2ed0f596$var$GregorianCalendarSystem {
    getMarkerYear(d) {
        return d.getUTCFullYear();
    }
    getMarkerMonth(d) {
        return d.getUTCMonth();
    }
    getMarkerDay(d) {
        return d.getUTCDate();
    }
    arrayToMarker(arr) {
        return $5913100b2ed0f596$var$arrayToUtcDate(arr);
    }
    markerToArray(marker) {
        return $5913100b2ed0f596$var$dateToUtcArray(marker);
    }
}
$5913100b2ed0f596$var$registerCalendarSystem("gregory", $5913100b2ed0f596$var$GregorianCalendarSystem);
const $5913100b2ed0f596$var$ISO_RE = /^\s*(\d{4})(-?(\d{2})(-?(\d{2})([T ](\d{2}):?(\d{2})(:?(\d{2})(\.(\d+))?)?(Z|(([-+])(\d{2})(:?(\d{2}))?))?)?)?)?$/;
function $5913100b2ed0f596$export$674f8f4247a5112e(str) {
    let m = $5913100b2ed0f596$var$ISO_RE.exec(str);
    if (m) {
        let marker = new Date(Date.UTC(Number(m[1]), m[3] ? Number(m[3]) - 1 : 0, Number(m[5] || 1), Number(m[7] || 0), Number(m[8] || 0), Number(m[10] || 0), m[12] ? Number(`0.${m[12]}`) * 1000 : 0));
        if ($5913100b2ed0f596$export$55ff3cc1821e8445(marker)) {
            let timeZoneOffset = null;
            if (m[13]) timeZoneOffset = (m[15] === "-" ? -1 : 1) * (Number(m[16] || 0) * 60 + Number(m[18] || 0));
            return {
                marker: marker,
                isTimeUnspecified: !m[6],
                timeZoneOffset: timeZoneOffset
            };
        }
    }
    return null;
}
class $5913100b2ed0f596$export$25ce5a424b770e84 {
    constructor(settings){
        let timeZone = this.timeZone = settings.timeZone;
        let isNamedTimeZone = timeZone !== "local" && timeZone !== "UTC";
        if (settings.namedTimeZoneImpl && isNamedTimeZone) this.namedTimeZoneImpl = new settings.namedTimeZoneImpl(timeZone);
        this.canComputeOffset = Boolean(!isNamedTimeZone || this.namedTimeZoneImpl);
        this.calendarSystem = $5913100b2ed0f596$var$createCalendarSystem(settings.calendarSystem);
        this.locale = settings.locale;
        this.weekDow = settings.locale.week.dow;
        this.weekDoy = settings.locale.week.doy;
        if (settings.weekNumberCalculation === "ISO") {
            this.weekDow = 1;
            this.weekDoy = 4;
        }
        if (typeof settings.firstDay === "number") this.weekDow = settings.firstDay;
        if (typeof settings.weekNumberCalculation === "function") this.weekNumberFunc = settings.weekNumberCalculation;
        this.weekText = settings.weekText != null ? settings.weekText : settings.locale.options.weekText;
        this.weekTextLong = (settings.weekTextLong != null ? settings.weekTextLong : settings.locale.options.weekTextLong) || this.weekText;
        this.cmdFormatter = settings.cmdFormatter;
        this.defaultSeparator = settings.defaultSeparator;
    }
    // Creating / Parsing
    createMarker(input) {
        let meta = this.createMarkerMeta(input);
        if (meta === null) return null;
        return meta.marker;
    }
    createNowMarker() {
        if (this.canComputeOffset) return this.timestampToMarker(new Date().valueOf());
        // if we can't compute the current date val for a timezone,
        // better to give the current local date vals than UTC
        return $5913100b2ed0f596$var$arrayToUtcDate($5913100b2ed0f596$var$dateToLocalArray(new Date()));
    }
    createMarkerMeta(input) {
        if (typeof input === "string") return this.parse(input);
        let marker = null;
        if (typeof input === "number") marker = this.timestampToMarker(input);
        else if (input instanceof Date) {
            input = input.valueOf();
            if (!isNaN(input)) marker = this.timestampToMarker(input);
        } else if (Array.isArray(input)) marker = $5913100b2ed0f596$var$arrayToUtcDate(input);
        if (marker === null || !$5913100b2ed0f596$export$55ff3cc1821e8445(marker)) return null;
        return {
            marker: marker,
            isTimeUnspecified: false,
            forcedTzo: null
        };
    }
    parse(s) {
        let parts = $5913100b2ed0f596$export$674f8f4247a5112e(s);
        if (parts === null) return null;
        let { marker: marker } = parts;
        let forcedTzo = null;
        if (parts.timeZoneOffset !== null) {
            if (this.canComputeOffset) marker = this.timestampToMarker(marker.valueOf() - parts.timeZoneOffset * 60000);
            else forcedTzo = parts.timeZoneOffset;
        }
        return {
            marker: marker,
            isTimeUnspecified: parts.isTimeUnspecified,
            forcedTzo: forcedTzo
        };
    }
    // Accessors
    getYear(marker) {
        return this.calendarSystem.getMarkerYear(marker);
    }
    getMonth(marker) {
        return this.calendarSystem.getMarkerMonth(marker);
    }
    getDay(marker) {
        return this.calendarSystem.getMarkerDay(marker);
    }
    // Adding / Subtracting
    add(marker, dur) {
        let a = this.calendarSystem.markerToArray(marker);
        a[0] += dur.years;
        a[1] += dur.months;
        a[2] += dur.days;
        a[6] += dur.milliseconds;
        return this.calendarSystem.arrayToMarker(a);
    }
    subtract(marker, dur) {
        let a = this.calendarSystem.markerToArray(marker);
        a[0] -= dur.years;
        a[1] -= dur.months;
        a[2] -= dur.days;
        a[6] -= dur.milliseconds;
        return this.calendarSystem.arrayToMarker(a);
    }
    addYears(marker, n) {
        let a = this.calendarSystem.markerToArray(marker);
        a[0] += n;
        return this.calendarSystem.arrayToMarker(a);
    }
    addMonths(marker, n) {
        let a = this.calendarSystem.markerToArray(marker);
        a[1] += n;
        return this.calendarSystem.arrayToMarker(a);
    }
    // Diffing Whole Units
    diffWholeYears(m0, m1) {
        let { calendarSystem: calendarSystem } = this;
        if ($5913100b2ed0f596$var$timeAsMs(m0) === $5913100b2ed0f596$var$timeAsMs(m1) && calendarSystem.getMarkerDay(m0) === calendarSystem.getMarkerDay(m1) && calendarSystem.getMarkerMonth(m0) === calendarSystem.getMarkerMonth(m1)) return calendarSystem.getMarkerYear(m1) - calendarSystem.getMarkerYear(m0);
        return null;
    }
    diffWholeMonths(m0, m1) {
        let { calendarSystem: calendarSystem } = this;
        if ($5913100b2ed0f596$var$timeAsMs(m0) === $5913100b2ed0f596$var$timeAsMs(m1) && calendarSystem.getMarkerDay(m0) === calendarSystem.getMarkerDay(m1)) return calendarSystem.getMarkerMonth(m1) - calendarSystem.getMarkerMonth(m0) + (calendarSystem.getMarkerYear(m1) - calendarSystem.getMarkerYear(m0)) * 12;
        return null;
    }
    // Range / Duration
    greatestWholeUnit(m0, m1) {
        let n = this.diffWholeYears(m0, m1);
        if (n !== null) return {
            unit: "year",
            value: n
        };
        n = this.diffWholeMonths(m0, m1);
        if (n !== null) return {
            unit: "month",
            value: n
        };
        n = $5913100b2ed0f596$export$b4d5ecaefe2b27f3(m0, m1);
        if (n !== null) return {
            unit: "week",
            value: n
        };
        n = $5913100b2ed0f596$export$4a5767248b18ef41(m0, m1);
        if (n !== null) return {
            unit: "day",
            value: n
        };
        n = $5913100b2ed0f596$var$diffHours(m0, m1);
        if ($5913100b2ed0f596$export$306ddfe3a8403e2(n)) return {
            unit: "hour",
            value: n
        };
        n = $5913100b2ed0f596$var$diffMinutes(m0, m1);
        if ($5913100b2ed0f596$export$306ddfe3a8403e2(n)) return {
            unit: "minute",
            value: n
        };
        n = $5913100b2ed0f596$var$diffSeconds(m0, m1);
        if ($5913100b2ed0f596$export$306ddfe3a8403e2(n)) return {
            unit: "second",
            value: n
        };
        return {
            unit: "millisecond",
            value: m1.valueOf() - m0.valueOf()
        };
    }
    countDurationsBetween(m0, m1, d) {
        // TODO: can use greatestWholeUnit
        let diff;
        if (d.years) {
            diff = this.diffWholeYears(m0, m1);
            if (diff !== null) return diff / $5913100b2ed0f596$var$asRoughYears(d);
        }
        if (d.months) {
            diff = this.diffWholeMonths(m0, m1);
            if (diff !== null) return diff / $5913100b2ed0f596$var$asRoughMonths(d);
        }
        if (d.days) {
            diff = $5913100b2ed0f596$export$4a5767248b18ef41(m0, m1);
            if (diff !== null) return diff / $5913100b2ed0f596$var$asRoughDays(d);
        }
        return (m1.valueOf() - m0.valueOf()) / $5913100b2ed0f596$export$4e222d082f82ee97(d);
    }
    // Start-Of
    // these DON'T return zoned-dates. only UTC start-of dates
    startOf(m, unit) {
        if (unit === "year") return this.startOfYear(m);
        if (unit === "month") return this.startOfMonth(m);
        if (unit === "week") return this.startOfWeek(m);
        if (unit === "day") return $5913100b2ed0f596$export$9e5f44173e64f162(m);
        if (unit === "hour") return $5913100b2ed0f596$var$startOfHour(m);
        if (unit === "minute") return $5913100b2ed0f596$var$startOfMinute(m);
        if (unit === "second") return $5913100b2ed0f596$var$startOfSecond(m);
        return null;
    }
    startOfYear(m) {
        return this.calendarSystem.arrayToMarker([
            this.calendarSystem.getMarkerYear(m)
        ]);
    }
    startOfMonth(m) {
        return this.calendarSystem.arrayToMarker([
            this.calendarSystem.getMarkerYear(m),
            this.calendarSystem.getMarkerMonth(m)
        ]);
    }
    startOfWeek(m) {
        return this.calendarSystem.arrayToMarker([
            this.calendarSystem.getMarkerYear(m),
            this.calendarSystem.getMarkerMonth(m),
            m.getUTCDate() - (m.getUTCDay() - this.weekDow + 7) % 7
        ]);
    }
    // Week Number
    computeWeekNumber(marker) {
        if (this.weekNumberFunc) return this.weekNumberFunc(this.toDate(marker));
        return $5913100b2ed0f596$var$weekOfYear(marker, this.weekDow, this.weekDoy);
    }
    // TODO: choke on timeZoneName: long
    format(marker, formatter, dateOptions = {}) {
        return formatter.format({
            marker: marker,
            timeZoneOffset: dateOptions.forcedTzo != null ? dateOptions.forcedTzo : this.offsetForMarker(marker)
        }, this);
    }
    formatRange(start, end, formatter, dateOptions = {}) {
        if (dateOptions.isEndExclusive) end = $5913100b2ed0f596$export$136fd86de524d3c2(end, -1);
        return formatter.formatRange({
            marker: start,
            timeZoneOffset: dateOptions.forcedStartTzo != null ? dateOptions.forcedStartTzo : this.offsetForMarker(start)
        }, {
            marker: end,
            timeZoneOffset: dateOptions.forcedEndTzo != null ? dateOptions.forcedEndTzo : this.offsetForMarker(end)
        }, this, dateOptions.defaultSeparator);
    }
    /*
    DUMB: the omitTime arg is dumb. if we omit the time, we want to omit the timezone offset. and if we do that,
    might as well use buildIsoString or some other util directly
    */ formatIso(marker, extraOptions = {}) {
        let timeZoneOffset = null;
        if (!extraOptions.omitTimeZoneOffset) {
            if (extraOptions.forcedTzo != null) timeZoneOffset = extraOptions.forcedTzo;
            else timeZoneOffset = this.offsetForMarker(marker);
        }
        return $5913100b2ed0f596$export$45d219bdcd8ac53c(marker, timeZoneOffset, extraOptions.omitTime);
    }
    // TimeZone
    timestampToMarker(ms) {
        if (this.timeZone === "local") return $5913100b2ed0f596$var$arrayToUtcDate($5913100b2ed0f596$var$dateToLocalArray(new Date(ms)));
        if (this.timeZone === "UTC" || !this.namedTimeZoneImpl) return new Date(ms);
        return $5913100b2ed0f596$var$arrayToUtcDate(this.namedTimeZoneImpl.timestampToArray(ms));
    }
    offsetForMarker(m) {
        if (this.timeZone === "local") return -$5913100b2ed0f596$var$arrayToLocalDate($5913100b2ed0f596$var$dateToUtcArray(m)).getTimezoneOffset(); // convert "inverse" offset to "normal" offset
        if (this.timeZone === "UTC") return 0;
        if (this.namedTimeZoneImpl) return this.namedTimeZoneImpl.offsetForArray($5913100b2ed0f596$var$dateToUtcArray(m));
        return null;
    }
    // Conversion
    toDate(m, forcedTzo) {
        if (this.timeZone === "local") return $5913100b2ed0f596$var$arrayToLocalDate($5913100b2ed0f596$var$dateToUtcArray(m));
        if (this.timeZone === "UTC") return new Date(m.valueOf()); // make sure it's a copy
        if (!this.namedTimeZoneImpl) return new Date(m.valueOf() - (forcedTzo || 0));
        return new Date(m.valueOf() - this.namedTimeZoneImpl.offsetForArray($5913100b2ed0f596$var$dateToUtcArray(m)) * 60000);
    }
}
class $5913100b2ed0f596$export$971d5caa766a69d7 {
    constructor(calendarOptions){
        if (this.iconOverrideOption) this.setIconOverride(calendarOptions[this.iconOverrideOption]);
    }
    setIconOverride(iconOverrideHash) {
        let iconClassesCopy;
        let buttonName;
        if (typeof iconOverrideHash === "object" && iconOverrideHash) {
            iconClassesCopy = Object.assign({}, this.iconClasses);
            for(buttonName in iconOverrideHash)iconClassesCopy[buttonName] = this.applyIconOverridePrefix(iconOverrideHash[buttonName]);
            this.iconClasses = iconClassesCopy;
        } else if (iconOverrideHash === false) this.iconClasses = {};
    }
    applyIconOverridePrefix(className) {
        let prefix = this.iconOverridePrefix;
        if (prefix && className.indexOf(prefix) !== 0) className = prefix + className;
        return className;
    }
    getClass(key) {
        return this.classes[key] || "";
    }
    getIconClass(buttonName, isRtl) {
        let className;
        if (isRtl && this.rtlIconClasses) className = this.rtlIconClasses[buttonName] || this.iconClasses[buttonName];
        else className = this.iconClasses[buttonName];
        if (className) return `${this.baseIconClass} ${className}`;
        return "";
    }
    getCustomButtonIconClass(customButtonProps) {
        let className;
        if (this.iconOverrideCustomButtonOption) {
            className = customButtonProps[this.iconOverrideCustomButtonOption];
            if (className) return `${this.baseIconClass} ${this.applyIconOverridePrefix(className)}`;
        }
        return "";
    }
}
$5913100b2ed0f596$export$971d5caa766a69d7.prototype.classes = {};
$5913100b2ed0f596$export$971d5caa766a69d7.prototype.iconClasses = {};
$5913100b2ed0f596$export$971d5caa766a69d7.prototype.baseIconClass = "";
$5913100b2ed0f596$export$971d5caa766a69d7.prototype.iconOverridePrefix = "";
/*
NOTE: this can be a public API, especially createElement for hooks.
See examples/typescript-scheduler/src/index.ts
*/ function $5913100b2ed0f596$export$7910e0436ed8d1de(runBeforeFlush) {
    runBeforeFlush();
    let oldDebounceRendering = $450fc775b2f7950e$export$41c562ebe57d11e2.debounceRendering; // orig
    let callbackQ = [];
    function execCallbackSync(callback) {
        callbackQ.push(callback);
    }
    $450fc775b2f7950e$export$41c562ebe57d11e2.debounceRendering = execCallbackSync;
    $450fc775b2f7950e$export$b3890eb0ae9dca99($450fc775b2f7950e$export$c8a8987d4410bf2d($5913100b2ed0f596$var$FakeComponent, {}), document.createElement("div"));
    while(callbackQ.length)callbackQ.shift()();
    $450fc775b2f7950e$export$41c562ebe57d11e2.debounceRendering = oldDebounceRendering;
}
class $5913100b2ed0f596$var$FakeComponent extends $450fc775b2f7950e$export$16fa2f45be04daa8 {
    render() {
        return $450fc775b2f7950e$export$c8a8987d4410bf2d("div", {});
    }
    componentDidMount() {
        this.setState({});
    }
}
// TODO: use preact/compat instead?
function $5913100b2ed0f596$export$995eb9fca571757(defaultValue) {
    let ContextType = $450fc775b2f7950e$export$fd42f52fd3ae1109(defaultValue);
    let origProvider = ContextType.Provider;
    ContextType.Provider = function() {
        let isNew = !this.getChildContext;
        let children = origProvider.apply(this, arguments); // eslint-disable-line prefer-rest-params
        if (isNew) {
            let subs = [];
            this.shouldComponentUpdate = (_props)=>{
                if (this.props.value !== _props.value) subs.forEach((c)=>{
                    c.context = _props.value;
                    c.forceUpdate();
                });
            };
            this.sub = (c)=>{
                subs.push(c);
                let old = c.componentWillUnmount;
                c.componentWillUnmount = ()=>{
                    subs.splice(subs.indexOf(c), 1);
                    old && old.call(c);
                };
            };
        }
        return children;
    };
    return ContextType;
}
class $5913100b2ed0f596$export$c5d7c1ac98841e53 {
    constructor(execFunc, emitter, scrollTime, scrollTimeReset){
        this.execFunc = execFunc;
        this.emitter = emitter;
        this.scrollTime = scrollTime;
        this.scrollTimeReset = scrollTimeReset;
        this.handleScrollRequest = (request)=>{
            this.queuedRequest = Object.assign({}, this.queuedRequest || {}, request);
            this.drain();
        };
        emitter.on("_scrollRequest", this.handleScrollRequest);
        this.fireInitialScroll();
    }
    detach() {
        this.emitter.off("_scrollRequest", this.handleScrollRequest);
    }
    update(isDatesNew) {
        if (isDatesNew && this.scrollTimeReset) this.fireInitialScroll(); // will drain
        else this.drain();
    }
    fireInitialScroll() {
        this.handleScrollRequest({
            time: this.scrollTime
        });
    }
    drain() {
        if (this.queuedRequest && this.execFunc(this.queuedRequest)) this.queuedRequest = null;
    }
}
const $5913100b2ed0f596$export$e7c866399fa523f5 = $5913100b2ed0f596$export$995eb9fca571757({}); // for Components
function $5913100b2ed0f596$export$efca4cbe5dd06740(viewSpec, viewApi, viewOptions, dateProfileGenerator, dateEnv, theme, pluginHooks, dispatch, getCurrentData, emitter, calendarApi, registerInteractiveComponent, unregisterInteractiveComponent) {
    return {
        dateEnv: dateEnv,
        options: viewOptions,
        pluginHooks: pluginHooks,
        emitter: emitter,
        dispatch: dispatch,
        getCurrentData: getCurrentData,
        calendarApi: calendarApi,
        viewSpec: viewSpec,
        viewApi: viewApi,
        dateProfileGenerator: dateProfileGenerator,
        theme: theme,
        isRtl: viewOptions.direction === "rtl",
        addResizeHandler (handler) {
            emitter.on("_resize", handler);
        },
        removeResizeHandler (handler) {
            emitter.off("_resize", handler);
        },
        createScrollResponder (execFunc) {
            return new $5913100b2ed0f596$export$c5d7c1ac98841e53(execFunc, emitter, $5913100b2ed0f596$export$4368d992c4eafac0(viewOptions.scrollTime), viewOptions.scrollTimeReset);
        },
        registerInteractiveComponent: registerInteractiveComponent,
        unregisterInteractiveComponent: unregisterInteractiveComponent
    };
}
/* eslint max-classes-per-file: off */ class $5913100b2ed0f596$export$6559d589eb85fbb6 extends (0, $450fc775b2f7950e$export$16fa2f45be04daa8) {
    shouldComponentUpdate(nextProps, nextState) {
        if (this.debug) // eslint-disable-next-line no-console
        console.log($5913100b2ed0f596$var$getUnequalProps(nextProps, this.props), $5913100b2ed0f596$var$getUnequalProps(nextState, this.state));
        return !$5913100b2ed0f596$export$23ebac1979863676(this.props, nextProps, this.propEquality) || !$5913100b2ed0f596$export$23ebac1979863676(this.state, nextState, this.stateEquality);
    }
    // HACK for freakin' React StrictMode
    safeSetState(newState) {
        if (!$5913100b2ed0f596$export$23ebac1979863676(this.state, Object.assign(Object.assign({}, this.state), newState), this.stateEquality)) this.setState(newState);
    }
}
$5913100b2ed0f596$export$6559d589eb85fbb6.addPropsEquality = $5913100b2ed0f596$var$addPropsEquality;
$5913100b2ed0f596$export$6559d589eb85fbb6.addStateEquality = $5913100b2ed0f596$var$addStateEquality;
$5913100b2ed0f596$export$6559d589eb85fbb6.contextType = $5913100b2ed0f596$export$e7c866399fa523f5;
$5913100b2ed0f596$export$6559d589eb85fbb6.prototype.propEquality = {};
$5913100b2ed0f596$export$6559d589eb85fbb6.prototype.stateEquality = {};
class $5913100b2ed0f596$export$ef35774e6d314e91 extends $5913100b2ed0f596$export$6559d589eb85fbb6 {
}
$5913100b2ed0f596$export$ef35774e6d314e91.contextType = $5913100b2ed0f596$export$e7c866399fa523f5;
function $5913100b2ed0f596$var$addPropsEquality(propEquality) {
    let hash = Object.create(this.prototype.propEquality);
    Object.assign(hash, propEquality);
    this.prototype.propEquality = hash;
}
function $5913100b2ed0f596$var$addStateEquality(stateEquality) {
    let hash = Object.create(this.prototype.stateEquality);
    Object.assign(hash, stateEquality);
    this.prototype.stateEquality = hash;
}
// use other one
function $5913100b2ed0f596$export$8743009a87fcb00f(ref, current) {
    if (typeof ref === "function") ref(current);
    else if (ref) // see https://github.com/facebook/react/issues/13029
    ref.current = current;
}
class $5913100b2ed0f596$var$ContentInjector extends $5913100b2ed0f596$export$ef35774e6d314e91 {
    constructor(){
        super(...arguments);
        this.id = $5913100b2ed0f596$export$39b482c5e57630a8();
        this.queuedDomNodes = [];
        this.currentDomNodes = [];
        this.handleEl = (el)=>{
            const { options: options } = this.context;
            const { generatorName: generatorName } = this.props;
            if (!options.customRenderingReplaces || !$5913100b2ed0f596$var$hasCustomRenderingHandler(generatorName, options)) this.updateElRef(el);
        };
        this.updateElRef = (el)=>{
            if (this.props.elRef) $5913100b2ed0f596$export$8743009a87fcb00f(this.props.elRef, el);
        };
    }
    render() {
        const { props: props, context: context } = this;
        const { options: options } = context;
        const { customGenerator: customGenerator, defaultGenerator: defaultGenerator, renderProps: renderProps } = props;
        const attrs = $5913100b2ed0f596$export$a274e22fb40f762e(props, [], this.handleEl);
        let useDefault = false;
        let innerContent;
        let queuedDomNodes = [];
        let currentGeneratorMeta;
        if (customGenerator != null) {
            const customGeneratorRes = typeof customGenerator === "function" ? customGenerator(renderProps, (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)) : customGenerator;
            if (customGeneratorRes === true) useDefault = true;
            else {
                const isObject = customGeneratorRes && typeof customGeneratorRes === "object"; // non-null
                if (isObject && "html" in customGeneratorRes) attrs.dangerouslySetInnerHTML = {
                    __html: customGeneratorRes.html
                };
                else if (isObject && "domNodes" in customGeneratorRes) queuedDomNodes = Array.prototype.slice.call(customGeneratorRes.domNodes);
                else if (isObject ? (0, $450fc775b2f7950e$export$a8257692ac88316c)(customGeneratorRes) // vdom node
                 : typeof customGeneratorRes !== "function" // primitive value (like string or number)
                ) // use in vdom
                innerContent = customGeneratorRes;
                else // an exotic object for handleCustomRendering
                currentGeneratorMeta = customGeneratorRes;
            }
        } else useDefault = !$5913100b2ed0f596$var$hasCustomRenderingHandler(props.generatorName, options);
        if (useDefault && defaultGenerator) innerContent = defaultGenerator(renderProps);
        this.queuedDomNodes = queuedDomNodes;
        this.currentGeneratorMeta = currentGeneratorMeta;
        return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)(props.elTag, attrs, innerContent);
    }
    componentDidMount() {
        this.applyQueueudDomNodes();
        this.triggerCustomRendering(true);
    }
    componentDidUpdate() {
        this.applyQueueudDomNodes();
        this.triggerCustomRendering(true);
    }
    componentWillUnmount() {
        this.triggerCustomRendering(false); // TODO: different API for removal?
    }
    triggerCustomRendering(isActive) {
        var _a;
        const { props: props, context: context } = this;
        const { handleCustomRendering: handleCustomRendering, customRenderingMetaMap: customRenderingMetaMap } = context.options;
        if (handleCustomRendering) {
            const generatorMeta = (_a = this.currentGeneratorMeta) !== null && _a !== void 0 ? _a : customRenderingMetaMap === null || customRenderingMetaMap === void 0 ? void 0 : customRenderingMetaMap[props.generatorName];
            if (generatorMeta) handleCustomRendering(Object.assign(Object.assign({
                id: this.id,
                isActive: isActive,
                containerEl: this.base,
                reportNewContainerEl: this.updateElRef,
                generatorMeta: generatorMeta
            }, props), {
                elClasses: (props.elClasses || []).filter($5913100b2ed0f596$var$isTruthy)
            }));
        }
    }
    applyQueueudDomNodes() {
        const { queuedDomNodes: queuedDomNodes, currentDomNodes: currentDomNodes } = this;
        const el = this.base;
        if (!$5913100b2ed0f596$export$23f2a1d2818174ef(queuedDomNodes, currentDomNodes)) {
            currentDomNodes.forEach($5913100b2ed0f596$export$c03999cb2f36933f);
            for (let newNode of queuedDomNodes)el.appendChild(newNode);
            this.currentDomNodes = queuedDomNodes;
        }
    }
}
$5913100b2ed0f596$var$ContentInjector.addPropsEquality({
    elClasses: $5913100b2ed0f596$export$23f2a1d2818174ef,
    elStyle: $5913100b2ed0f596$export$a9c23c6ac3fc3eca,
    elAttrs: $5913100b2ed0f596$var$isNonHandlerPropsEqual,
    renderProps: $5913100b2ed0f596$export$a9c23c6ac3fc3eca
});
// Util
/*
Does UI-framework provide custom way of rendering that does not use Preact VDOM
AND does the calendar's options define custom rendering?
AKA. Should we NOT render the default content?
*/ function $5913100b2ed0f596$var$hasCustomRenderingHandler(generatorName, options) {
    var _a;
    return Boolean(options.handleCustomRendering && generatorName && ((_a = options.customRenderingMetaMap) === null || _a === void 0 ? void 0 : _a[generatorName]));
}
function $5913100b2ed0f596$export$a274e22fb40f762e(props, extraClassNames, elRef) {
    const attrs = Object.assign(Object.assign({}, props.elAttrs), {
        ref: elRef
    });
    if (props.elClasses || extraClassNames) attrs.className = (props.elClasses || []).concat(extraClassNames || []).concat(attrs.className || []).filter(Boolean).join(" ");
    if (props.elStyle) attrs.style = props.elStyle;
    return attrs;
}
function $5913100b2ed0f596$var$isTruthy(val) {
    return Boolean(val);
}
const $5913100b2ed0f596$export$2219238a014317b0 = $5913100b2ed0f596$export$995eb9fca571757(0);
class $5913100b2ed0f596$export$e7094788287c5e9b extends (0, $450fc775b2f7950e$export$16fa2f45be04daa8) {
    constructor(){
        super(...arguments);
        this.InnerContent = $5913100b2ed0f596$var$InnerContentInjector.bind(undefined, this);
        this.handleEl = (el)=>{
            this.el = el;
            if (this.props.elRef) {
                $5913100b2ed0f596$export$8743009a87fcb00f(this.props.elRef, el);
                if (el && this.didMountMisfire) this.componentDidMount();
            }
        };
    }
    render() {
        const { props: props } = this;
        const generatedClassNames = $5913100b2ed0f596$var$generateClassNames(props.classNameGenerator, props.renderProps);
        if (props.children) {
            const elAttrs = $5913100b2ed0f596$export$a274e22fb40f762e(props, generatedClassNames, this.handleEl);
            const children = props.children(this.InnerContent, props.renderProps, elAttrs);
            if (props.elTag) return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)(props.elTag, elAttrs, children);
            else return children;
        } else return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)($5913100b2ed0f596$var$ContentInjector, Object.assign(Object.assign({}, props), {
            elRef: this.handleEl,
            elTag: props.elTag || "div",
            elClasses: (props.elClasses || []).concat(generatedClassNames),
            renderId: this.context
        }));
    }
    componentDidMount() {
        var _a, _b;
        if (this.el) (_b = (_a = this.props).didMount) === null || _b === void 0 || _b.call(_a, Object.assign(Object.assign({}, this.props.renderProps), {
            el: this.el
        }));
        else this.didMountMisfire = true;
    }
    componentWillUnmount() {
        var _a, _b;
        (_b = (_a = this.props).willUnmount) === null || _b === void 0 || _b.call(_a, Object.assign(Object.assign({}, this.props.renderProps), {
            el: this.el
        }));
    }
}
$5913100b2ed0f596$export$e7094788287c5e9b.contextType = $5913100b2ed0f596$export$2219238a014317b0;
function $5913100b2ed0f596$var$InnerContentInjector(containerComponent, props) {
    const parentProps = containerComponent.props;
    return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)($5913100b2ed0f596$var$ContentInjector, Object.assign({
        renderProps: parentProps.renderProps,
        generatorName: parentProps.generatorName,
        customGenerator: parentProps.customGenerator,
        defaultGenerator: parentProps.defaultGenerator,
        renderId: containerComponent.context
    }, props));
}
// Utils
function $5913100b2ed0f596$var$generateClassNames(classNameGenerator, renderProps) {
    const classNames = typeof classNameGenerator === "function" ? classNameGenerator(renderProps) : classNameGenerator || [];
    return typeof classNames === "string" ? [
        classNames
    ] : classNames;
}
class $5913100b2ed0f596$export$e9316ff9106cdb75 extends $5913100b2ed0f596$export$ef35774e6d314e91 {
    render() {
        let { props: props, context: context } = this;
        let { options: options } = context;
        let renderProps = {
            view: context.viewApi
        };
        return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)($5913100b2ed0f596$export$e7094788287c5e9b, Object.assign({}, props, {
            elTag: props.elTag || "div",
            elClasses: [
                ...$5913100b2ed0f596$export$8b22cf2602fb60ce(props.viewSpec),
                ...props.elClasses || []
            ],
            renderProps: renderProps,
            classNameGenerator: options.viewClassNames,
            generatorName: undefined,
            didMount: options.viewDidMount,
            willUnmount: options.viewWillUnmount
        }), ()=>props.children);
    }
}
function $5913100b2ed0f596$export$8b22cf2602fb60ce(viewSpec) {
    return [
        `fc-${viewSpec.type}-view`,
        "fc-view"
    ];
}
function $5913100b2ed0f596$var$parseRange(input, dateEnv) {
    let start = null;
    let end = null;
    if (input.start) start = dateEnv.createMarker(input.start);
    if (input.end) end = dateEnv.createMarker(input.end);
    if (!start && !end) return null;
    if (start && end && end < start) return null;
    return {
        start: start,
        end: end
    };
}
// SIDE-EFFECT: will mutate ranges.
// Will return a new array result.
function $5913100b2ed0f596$var$invertRanges(ranges, constraintRange) {
    let invertedRanges = [];
    let { start: start } = constraintRange; // the end of the previous range. the start of the new range
    let i;
    let dateRange;
    // ranges need to be in order. required for our date-walking algorithm
    ranges.sort($5913100b2ed0f596$var$compareRanges);
    for(i = 0; i < ranges.length; i += 1){
        dateRange = ranges[i];
        // add the span of time before the event (if there is any)
        if (dateRange.start > start) invertedRanges.push({
            start: start,
            end: dateRange.start
        });
        if (dateRange.end > start) start = dateRange.end;
    }
    // add the span of time after the last event (if there is any)
    if (start < constraintRange.end) invertedRanges.push({
        start: start,
        end: constraintRange.end
    });
    return invertedRanges;
}
function $5913100b2ed0f596$var$compareRanges(range0, range1) {
    return range0.start.valueOf() - range1.start.valueOf(); // earlier ranges go first
}
function $5913100b2ed0f596$export$ae1af26003f05816(range0, range1) {
    let { start: start, end: end } = range0;
    let newRange = null;
    if (range1.start !== null) {
        if (start === null) start = range1.start;
        else start = new Date(Math.max(start.valueOf(), range1.start.valueOf()));
    }
    if (range1.end != null) {
        if (end === null) end = range1.end;
        else end = new Date(Math.min(end.valueOf(), range1.end.valueOf()));
    }
    if (start === null || end === null || start < end) newRange = {
        start: start,
        end: end
    };
    return newRange;
}
function $5913100b2ed0f596$export$f074adc9fbd50943(range0, range1) {
    return (range0.start === null ? null : range0.start.valueOf()) === (range1.start === null ? null : range1.start.valueOf()) && (range0.end === null ? null : range0.end.valueOf()) === (range1.end === null ? null : range1.end.valueOf());
}
function $5913100b2ed0f596$export$ad4aebacdcaf47f8(range0, range1) {
    return (range0.end === null || range1.start === null || range0.end > range1.start) && (range0.start === null || range1.end === null || range0.start < range1.end);
}
function $5913100b2ed0f596$export$4ae495d48253603d(outerRange, innerRange) {
    return (outerRange.start === null || innerRange.start !== null && innerRange.start >= outerRange.start) && (outerRange.end === null || innerRange.end !== null && innerRange.end <= outerRange.end);
}
function $5913100b2ed0f596$export$7f8ddf7c7c20b3cd(range, date) {
    return (range.start === null || date >= range.start) && (range.end === null || date < range.end);
}
// If the given date is not within the given range, move it inside.
// (If it's past the end, make it one millisecond before the end).
function $5913100b2ed0f596$var$constrainMarkerToRange(date, range) {
    if (range.start != null && date < range.start) return range.start;
    if (range.end != null && date >= range.end) return new Date(range.end.valueOf() - 1);
    return date;
}
/* Date stuff that doesn't belong in datelib core
----------------------------------------------------------------------------------------------------------------------*/ // given a timed range, computes an all-day range that has the same exact duration,
// but whose start time is aligned with the start of the day.
function $5913100b2ed0f596$var$computeAlignedDayRange(timedRange) {
    let dayCnt = Math.floor($5913100b2ed0f596$export$a36fb7d24305ed9d(timedRange.start, timedRange.end)) || 1;
    let start = $5913100b2ed0f596$export$9e5f44173e64f162(timedRange.start);
    let end = $5913100b2ed0f596$export$625550452a3fa3ec(start, dayCnt);
    return {
        start: start,
        end: end
    };
}
// given a timed range, computes an all-day range based on how for the end date bleeds into the next day
// TODO: give nextDayThreshold a default arg
function $5913100b2ed0f596$export$28f7fcd39efa255(timedRange, nextDayThreshold = $5913100b2ed0f596$export$4368d992c4eafac0(0)) {
    let startDay = null;
    let endDay = null;
    if (timedRange.end) {
        endDay = $5913100b2ed0f596$export$9e5f44173e64f162(timedRange.end);
        let endTimeMS = timedRange.end.valueOf() - endDay.valueOf(); // # of milliseconds into `endDay`
        // If the end time is actually inclusively part of the next day and is equal to or
        // beyond the next day threshold, adjust the end to be the exclusive end of `endDay`.
        // Otherwise, leaving it as inclusive will cause it to exclude `endDay`.
        if (endTimeMS && endTimeMS >= $5913100b2ed0f596$export$4e222d082f82ee97(nextDayThreshold)) endDay = $5913100b2ed0f596$export$625550452a3fa3ec(endDay, 1);
    }
    if (timedRange.start) {
        startDay = $5913100b2ed0f596$export$9e5f44173e64f162(timedRange.start); // the beginning of the day the range starts
        // If end is within `startDay` but not past nextDayThreshold, assign the default duration of one day.
        if (endDay && endDay <= startDay) endDay = $5913100b2ed0f596$export$625550452a3fa3ec(startDay, 1);
    }
    return {
        start: startDay,
        end: endDay
    };
}
// spans from one day into another?
function $5913100b2ed0f596$export$3d12bd131bb975d1(range) {
    let visibleRange = $5913100b2ed0f596$export$28f7fcd39efa255(range);
    return $5913100b2ed0f596$export$a36fb7d24305ed9d(visibleRange.start, visibleRange.end) > 1;
}
function $5913100b2ed0f596$export$91c6e00c14e7e6fd(date0, date1, dateEnv, largeUnit) {
    if (largeUnit === "year") return $5913100b2ed0f596$export$4368d992c4eafac0(dateEnv.diffWholeYears(date0, date1), "year");
    if (largeUnit === "month") return $5913100b2ed0f596$export$4368d992c4eafac0(dateEnv.diffWholeMonths(date0, date1), "month");
    return $5913100b2ed0f596$export$5521614468b862fb(date0, date1); // returns a duration
}
function $5913100b2ed0f596$export$b4171a6734a65d42(currentDate, action) {
    switch(action.type){
        case "CHANGE_DATE":
            return action.dateMarker;
        default:
            return currentDate;
    }
}
function $5913100b2ed0f596$export$2329c99376c9d0a4(options, dateEnv) {
    let initialDateInput = options.initialDate;
    // compute the initial ambig-timezone date
    if (initialDateInput != null) return dateEnv.createMarker(initialDateInput);
    return $5913100b2ed0f596$export$c3950d9923825c02(options.now, dateEnv); // getNow already returns unzoned
}
function $5913100b2ed0f596$export$c3950d9923825c02(nowInput, dateEnv) {
    if (typeof nowInput === "function") nowInput = nowInput();
    if (nowInput == null) return dateEnv.createNowMarker();
    return dateEnv.createMarker(nowInput);
}
class $5913100b2ed0f596$export$3a6d5c9ae78a2c08 {
    constructor(props){
        this.props = props;
        this.nowDate = $5913100b2ed0f596$export$c3950d9923825c02(props.nowInput, props.dateEnv);
        this.initHiddenDays();
    }
    /* Date Range Computation
    ------------------------------------------------------------------------------------------------------------------*/ // Builds a structure with info about what the dates/ranges will be for the "prev" view.
    buildPrev(currentDateProfile, currentDate, forceToValid) {
        let { dateEnv: dateEnv } = this.props;
        let prevDate = dateEnv.subtract(dateEnv.startOf(currentDate, currentDateProfile.currentRangeUnit), currentDateProfile.dateIncrement);
        return this.build(prevDate, -1, forceToValid);
    }
    // Builds a structure with info about what the dates/ranges will be for the "next" view.
    buildNext(currentDateProfile, currentDate, forceToValid) {
        let { dateEnv: dateEnv } = this.props;
        let nextDate = dateEnv.add(dateEnv.startOf(currentDate, currentDateProfile.currentRangeUnit), currentDateProfile.dateIncrement);
        return this.build(nextDate, 1, forceToValid);
    }
    // Builds a structure holding dates/ranges for rendering around the given date.
    // Optional direction param indicates whether the date is being incremented/decremented
    // from its previous value. decremented = -1, incremented = 1 (default).
    build(currentDate, direction, forceToValid = true) {
        let { props: props } = this;
        let validRange;
        let currentInfo;
        let isRangeAllDay;
        let renderRange;
        let activeRange;
        let isValid;
        validRange = this.buildValidRange();
        validRange = this.trimHiddenDays(validRange);
        if (forceToValid) currentDate = $5913100b2ed0f596$var$constrainMarkerToRange(currentDate, validRange);
        currentInfo = this.buildCurrentRangeInfo(currentDate, direction);
        isRangeAllDay = /^(year|month|week|day)$/.test(currentInfo.unit);
        renderRange = this.buildRenderRange(this.trimHiddenDays(currentInfo.range), currentInfo.unit, isRangeAllDay);
        renderRange = this.trimHiddenDays(renderRange);
        activeRange = renderRange;
        if (!props.showNonCurrentDates) activeRange = $5913100b2ed0f596$export$ae1af26003f05816(activeRange, currentInfo.range);
        activeRange = this.adjustActiveRange(activeRange);
        activeRange = $5913100b2ed0f596$export$ae1af26003f05816(activeRange, validRange); // might return null
        // it's invalid if the originally requested date is not contained,
        // or if the range is completely outside of the valid range.
        isValid = $5913100b2ed0f596$export$ad4aebacdcaf47f8(currentInfo.range, validRange);
        // HACK: constrain to render-range so `currentDate` is more useful to view rendering
        if (!$5913100b2ed0f596$export$7f8ddf7c7c20b3cd(renderRange, currentDate)) currentDate = renderRange.start;
        return {
            currentDate: currentDate,
            validRange: // constraint for where prev/next operations can go and where events can be dragged/resized to.
            // an object with optional start and end properties.
            validRange,
            // range the view is formally responsible for.
            // for example, a month view might have 1st-31st, excluding padded dates
            currentRange: currentInfo.range,
            // name of largest unit being displayed, like "month" or "week"
            currentRangeUnit: currentInfo.unit,
            isRangeAllDay: isRangeAllDay,
            activeRange: // dates that display events and accept drag-n-drop
            // will be `null` if no dates accept events
            activeRange,
            renderRange: // date range with a rendered skeleton
            // includes not-active days that need some sort of DOM
            renderRange,
            // Duration object that denotes the first visible time of any given day
            slotMinTime: props.slotMinTime,
            // Duration object that denotes the exclusive visible end time of any given day
            slotMaxTime: props.slotMaxTime,
            isValid: isValid,
            // how far the current date will move for a prev/next operation
            dateIncrement: this.buildDateIncrement(currentInfo.duration)
        };
    }
    // Builds an object with optional start/end properties.
    // Indicates the minimum/maximum dates to display.
    // not responsible for trimming hidden days.
    buildValidRange() {
        let input = this.props.validRangeInput;
        let simpleInput = typeof input === "function" ? input.call(this.props.calendarApi, this.nowDate) : input;
        return this.refineRange(simpleInput) || {
            start: null,
            end: null
        }; // completely open-ended
    }
    // Builds a structure with info about the "current" range, the range that is
    // highlighted as being the current month for example.
    // See build() for a description of `direction`.
    // Guaranteed to have `range` and `unit` properties. `duration` is optional.
    buildCurrentRangeInfo(date, direction) {
        let { props: props } = this;
        let duration = null;
        let unit = null;
        let range = null;
        let dayCount;
        if (props.duration) {
            duration = props.duration;
            unit = props.durationUnit;
            range = this.buildRangeFromDuration(date, direction, duration, unit);
        } else if (dayCount = this.props.dayCount) {
            unit = "day";
            range = this.buildRangeFromDayCount(date, direction, dayCount);
        } else if (range = this.buildCustomVisibleRange(date)) unit = props.dateEnv.greatestWholeUnit(range.start, range.end).unit;
        else {
            duration = this.getFallbackDuration();
            unit = $5913100b2ed0f596$export$db3b6bfb95261072(duration).unit;
            range = this.buildRangeFromDuration(date, direction, duration, unit);
        }
        return {
            duration: duration,
            unit: unit,
            range: range
        };
    }
    getFallbackDuration() {
        return $5913100b2ed0f596$export$4368d992c4eafac0({
            day: 1
        });
    }
    // Returns a new activeRange to have time values (un-ambiguate)
    // slotMinTime or slotMaxTime causes the range to expand.
    adjustActiveRange(range) {
        let { dateEnv: dateEnv, usesMinMaxTime: usesMinMaxTime, slotMinTime: slotMinTime, slotMaxTime: slotMaxTime } = this.props;
        let { start: start, end: end } = range;
        if (usesMinMaxTime) {
            // expand active range if slotMinTime is negative (why not when positive?)
            if ($5913100b2ed0f596$var$asRoughDays(slotMinTime) < 0) {
                start = $5913100b2ed0f596$export$9e5f44173e64f162(start); // necessary?
                start = dateEnv.add(start, slotMinTime);
            }
            // expand active range if slotMaxTime is beyond one day (why not when negative?)
            if ($5913100b2ed0f596$var$asRoughDays(slotMaxTime) > 1) {
                end = $5913100b2ed0f596$export$9e5f44173e64f162(end); // necessary?
                end = $5913100b2ed0f596$export$625550452a3fa3ec(end, -1);
                end = dateEnv.add(end, slotMaxTime);
            }
        }
        return {
            start: start,
            end: end
        };
    }
    // Builds the "current" range when it is specified as an explicit duration.
    // `unit` is the already-computed greatestDurationDenominator unit of duration.
    buildRangeFromDuration(date, direction, duration, unit) {
        let { dateEnv: dateEnv, dateAlignment: dateAlignment } = this.props;
        let start;
        let end;
        let res;
        // compute what the alignment should be
        if (!dateAlignment) {
            let { dateIncrement: dateIncrement } = this.props;
            if (dateIncrement) {
                // use the smaller of the two units
                if ($5913100b2ed0f596$export$4e222d082f82ee97(dateIncrement) < $5913100b2ed0f596$export$4e222d082f82ee97(duration)) dateAlignment = $5913100b2ed0f596$export$db3b6bfb95261072(dateIncrement).unit;
                else dateAlignment = unit;
            } else dateAlignment = unit;
        }
        // if the view displays a single day or smaller
        if ($5913100b2ed0f596$var$asRoughDays(duration) <= 1) {
            if (this.isHiddenDay(start)) {
                start = this.skipHiddenDays(start, direction);
                start = $5913100b2ed0f596$export$9e5f44173e64f162(start);
            }
        }
        function computeRes() {
            start = dateEnv.startOf(date, dateAlignment);
            end = dateEnv.add(start, duration);
            res = {
                start: start,
                end: end
            };
        }
        computeRes();
        // if range is completely enveloped by hidden days, go past the hidden days
        if (!this.trimHiddenDays(res)) {
            date = this.skipHiddenDays(date, direction);
            computeRes();
        }
        return res;
    }
    // Builds the "current" range when a dayCount is specified.
    buildRangeFromDayCount(date, direction, dayCount) {
        let { dateEnv: dateEnv, dateAlignment: dateAlignment } = this.props;
        let runningCount = 0;
        let start = date;
        let end;
        if (dateAlignment) start = dateEnv.startOf(start, dateAlignment);
        start = $5913100b2ed0f596$export$9e5f44173e64f162(start);
        start = this.skipHiddenDays(start, direction);
        end = start;
        do {
            end = $5913100b2ed0f596$export$625550452a3fa3ec(end, 1);
            if (!this.isHiddenDay(end)) runningCount += 1;
        }while (runningCount < dayCount);
        return {
            start: start,
            end: end
        };
    }
    // Builds a normalized range object for the "visible" range,
    // which is a way to define the currentRange and activeRange at the same time.
    buildCustomVisibleRange(date) {
        let { props: props } = this;
        let input = props.visibleRangeInput;
        let simpleInput = typeof input === "function" ? input.call(props.calendarApi, props.dateEnv.toDate(date)) : input;
        let range = this.refineRange(simpleInput);
        if (range && (range.start == null || range.end == null)) return null;
        return range;
    }
    // Computes the range that will represent the element/cells for *rendering*,
    // but which may have voided days/times.
    // not responsible for trimming hidden days.
    buildRenderRange(currentRange, currentRangeUnit, isRangeAllDay) {
        return currentRange;
    }
    // Compute the duration value that should be added/substracted to the current date
    // when a prev/next operation happens.
    buildDateIncrement(fallback) {
        let { dateIncrement: dateIncrement } = this.props;
        let customAlignment;
        if (dateIncrement) return dateIncrement;
        if (customAlignment = this.props.dateAlignment) return $5913100b2ed0f596$export$4368d992c4eafac0(1, customAlignment);
        if (fallback) return fallback;
        return $5913100b2ed0f596$export$4368d992c4eafac0({
            days: 1
        });
    }
    refineRange(rangeInput) {
        if (rangeInput) {
            let range = $5913100b2ed0f596$var$parseRange(rangeInput, this.props.dateEnv);
            if (range) range = $5913100b2ed0f596$export$28f7fcd39efa255(range);
            return range;
        }
        return null;
    }
    /* Hidden Days
    ------------------------------------------------------------------------------------------------------------------*/ // Initializes internal variables related to calculating hidden days-of-week
    initHiddenDays() {
        let hiddenDays = this.props.hiddenDays || []; // array of day-of-week indices that are hidden
        let isHiddenDayHash = []; // is the day-of-week hidden? (hash with day-of-week-index -> bool)
        let dayCnt = 0;
        let i;
        if (this.props.weekends === false) hiddenDays.push(0, 6); // 0=sunday, 6=saturday
        for(i = 0; i < 7; i += 1)if (!(isHiddenDayHash[i] = hiddenDays.indexOf(i) !== -1)) dayCnt += 1;
        if (!dayCnt) throw new Error("invalid hiddenDays"); // all days were hidden? bad.
        this.isHiddenDayHash = isHiddenDayHash;
    }
    // Remove days from the beginning and end of the range that are computed as hidden.
    // If the whole range is trimmed off, returns null
    trimHiddenDays(range) {
        let { start: start, end: end } = range;
        if (start) start = this.skipHiddenDays(start);
        if (end) end = this.skipHiddenDays(end, -1, true);
        if (start == null || end == null || start < end) return {
            start: start,
            end: end
        };
        return null;
    }
    // Is the current day hidden?
    // `day` is a day-of-week index (0-6), or a Date (used for UTC)
    isHiddenDay(day) {
        if (day instanceof Date) day = day.getUTCDay();
        return this.isHiddenDayHash[day];
    }
    // Incrementing the current day until it is no longer a hidden day, returning a copy.
    // DOES NOT CONSIDER validRange!
    // If the initial value of `date` is not a hidden day, don't do anything.
    // Pass `isExclusive` as `true` if you are dealing with an end date.
    // `inc` defaults to `1` (increment one day forward each time)
    skipHiddenDays(date, inc = 1, isExclusive = false) {
        while(this.isHiddenDayHash[(date.getUTCDay() + (isExclusive ? inc : 0) + 7) % 7])date = $5913100b2ed0f596$export$625550452a3fa3ec(date, inc);
        return date;
    }
}
function $5913100b2ed0f596$export$3b513254972cfc9c(defId, range, forcedStartTzo, forcedEndTzo) {
    return {
        instanceId: $5913100b2ed0f596$export$39b482c5e57630a8(),
        defId: defId,
        range: range,
        forcedStartTzo: forcedStartTzo == null ? null : forcedStartTzo,
        forcedEndTzo: forcedEndTzo == null ? null : forcedEndTzo
    };
}
function $5913100b2ed0f596$var$parseRecurring(refined, defaultAllDay, dateEnv, recurringTypes) {
    for(let i = 0; i < recurringTypes.length; i += 1){
        let parsed = recurringTypes[i].parse(refined, dateEnv);
        if (parsed) {
            let { allDay: allDay } = refined;
            if (allDay == null) {
                allDay = defaultAllDay;
                if (allDay == null) {
                    allDay = parsed.allDayGuess;
                    if (allDay == null) allDay = false;
                }
            }
            return {
                allDay: allDay,
                duration: parsed.duration,
                typeData: parsed.typeData,
                typeId: i
            };
        }
    }
    return null;
}
function $5913100b2ed0f596$var$expandRecurring(eventStore, framingRange, context) {
    let { dateEnv: dateEnv, pluginHooks: pluginHooks, options: options } = context;
    let { defs: defs, instances: instances } = eventStore;
    // remove existing recurring instances
    // TODO: bad. always expand events as a second step
    instances = $5913100b2ed0f596$export$dda1d9f60106f0e9(instances, (instance)=>!defs[instance.defId].recurringDef);
    for(let defId in defs){
        let def = defs[defId];
        if (def.recurringDef) {
            let { duration: duration } = def.recurringDef;
            if (!duration) duration = def.allDay ? options.defaultAllDayEventDuration : options.defaultTimedEventDuration;
            let starts = $5913100b2ed0f596$var$expandRecurringRanges(def, duration, framingRange, dateEnv, pluginHooks.recurringTypes);
            for (let start of starts){
                let instance = $5913100b2ed0f596$export$3b513254972cfc9c(defId, {
                    start: start,
                    end: dateEnv.add(start, duration)
                });
                instances[instance.instanceId] = instance;
            }
        }
    }
    return {
        defs: defs,
        instances: instances
    };
}
/*
Event MUST have a recurringDef
*/ function $5913100b2ed0f596$var$expandRecurringRanges(eventDef, duration, framingRange, dateEnv, recurringTypes) {
    let typeDef = recurringTypes[eventDef.recurringDef.typeId];
    let markers = typeDef.expand(eventDef.recurringDef.typeData, {
        start: dateEnv.subtract(framingRange.start, duration),
        end: framingRange.end
    }, dateEnv);
    // the recurrence plugins don't guarantee that all-day events are start-of-day, so we have to
    if (eventDef.allDay) markers = markers.map($5913100b2ed0f596$export$9e5f44173e64f162);
    return markers;
}
const $5913100b2ed0f596$var$EVENT_NON_DATE_REFINERS = {
    id: String,
    groupId: String,
    title: String,
    url: String,
    interactive: Boolean
};
const $5913100b2ed0f596$var$EVENT_DATE_REFINERS = {
    start: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    end: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    date: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    allDay: Boolean
};
const $5913100b2ed0f596$var$EVENT_REFINERS = Object.assign(Object.assign(Object.assign({}, $5913100b2ed0f596$var$EVENT_NON_DATE_REFINERS), $5913100b2ed0f596$var$EVENT_DATE_REFINERS), {
    extendedProps: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5
});
function $5913100b2ed0f596$var$parseEvent(raw, eventSource, context, allowOpenRange, refiners = $5913100b2ed0f596$var$buildEventRefiners(context), defIdMap, instanceIdMap) {
    let { refined: refined, extra: extra } = $5913100b2ed0f596$export$ab83b03e4111b1d0(raw, context, refiners);
    let defaultAllDay = $5913100b2ed0f596$var$computeIsDefaultAllDay(eventSource, context);
    let recurringRes = $5913100b2ed0f596$var$parseRecurring(refined, defaultAllDay, context.dateEnv, context.pluginHooks.recurringTypes);
    if (recurringRes) {
        let def = $5913100b2ed0f596$export$21579262ef46735b(refined, extra, eventSource ? eventSource.sourceId : "", recurringRes.allDay, Boolean(recurringRes.duration), context, defIdMap);
        def.recurringDef = {
            typeId: recurringRes.typeId,
            typeData: recurringRes.typeData,
            duration: recurringRes.duration
        };
        return {
            def: def,
            instance: null
        };
    }
    let singleRes = $5913100b2ed0f596$var$parseSingle(refined, defaultAllDay, context, allowOpenRange);
    if (singleRes) {
        let def = $5913100b2ed0f596$export$21579262ef46735b(refined, extra, eventSource ? eventSource.sourceId : "", singleRes.allDay, singleRes.hasEnd, context, defIdMap);
        let instance = $5913100b2ed0f596$export$3b513254972cfc9c(def.defId, singleRes.range, singleRes.forcedStartTzo, singleRes.forcedEndTzo);
        if (instanceIdMap && def.publicId && instanceIdMap[def.publicId]) instance.instanceId = instanceIdMap[def.publicId];
        return {
            def: def,
            instance: instance
        };
    }
    return null;
}
function $5913100b2ed0f596$export$ab83b03e4111b1d0(raw, context, refiners = $5913100b2ed0f596$var$buildEventRefiners(context)) {
    return $5913100b2ed0f596$export$f38c853ae54ed474(raw, refiners);
}
function $5913100b2ed0f596$var$buildEventRefiners(context) {
    return Object.assign(Object.assign(Object.assign({}, $5913100b2ed0f596$var$EVENT_UI_REFINERS), $5913100b2ed0f596$var$EVENT_REFINERS), context.pluginHooks.eventRefiners);
}
/*
Will NOT populate extendedProps with the leftover properties.
Will NOT populate date-related props.
*/ function $5913100b2ed0f596$export$21579262ef46735b(refined, extra, sourceId, allDay, hasEnd, context, defIdMap) {
    let def = {
        title: refined.title || "",
        groupId: refined.groupId || "",
        publicId: refined.id || "",
        url: refined.url || "",
        recurringDef: null,
        defId: (defIdMap && refined.id ? defIdMap[refined.id] : "") || $5913100b2ed0f596$export$39b482c5e57630a8(),
        sourceId: sourceId,
        allDay: allDay,
        hasEnd: hasEnd,
        interactive: refined.interactive,
        ui: $5913100b2ed0f596$export$71cec2538cb2c617(refined, context),
        extendedProps: Object.assign(Object.assign({}, refined.extendedProps || {}), extra)
    };
    for (let memberAdder of context.pluginHooks.eventDefMemberAdders)Object.assign(def, memberAdder(refined));
    // help out EventImpl from having user modify props
    Object.freeze(def.ui.classNames);
    Object.freeze(def.extendedProps);
    return def;
}
function $5913100b2ed0f596$var$parseSingle(refined, defaultAllDay, context, allowOpenRange) {
    let { allDay: allDay } = refined;
    let startMeta;
    let startMarker = null;
    let hasEnd = false;
    let endMeta;
    let endMarker = null;
    let startInput = refined.start != null ? refined.start : refined.date;
    startMeta = context.dateEnv.createMarkerMeta(startInput);
    if (startMeta) startMarker = startMeta.marker;
    else if (!allowOpenRange) return null;
    if (refined.end != null) endMeta = context.dateEnv.createMarkerMeta(refined.end);
    if (allDay == null) {
        if (defaultAllDay != null) allDay = defaultAllDay;
        else // fall back to the date props LAST
        allDay = (!startMeta || startMeta.isTimeUnspecified) && (!endMeta || endMeta.isTimeUnspecified);
    }
    if (allDay && startMarker) startMarker = $5913100b2ed0f596$export$9e5f44173e64f162(startMarker);
    if (endMeta) {
        endMarker = endMeta.marker;
        if (allDay) endMarker = $5913100b2ed0f596$export$9e5f44173e64f162(endMarker);
        if (startMarker && endMarker <= startMarker) endMarker = null;
    }
    if (endMarker) hasEnd = true;
    else if (!allowOpenRange) {
        hasEnd = context.options.forceEventDuration || false;
        endMarker = context.dateEnv.add(startMarker, allDay ? context.options.defaultAllDayEventDuration : context.options.defaultTimedEventDuration);
    }
    return {
        allDay: allDay,
        hasEnd: hasEnd,
        range: {
            start: startMarker,
            end: endMarker
        },
        forcedStartTzo: startMeta ? startMeta.forcedTzo : null,
        forcedEndTzo: endMeta ? endMeta.forcedTzo : null
    };
}
function $5913100b2ed0f596$var$computeIsDefaultAllDay(eventSource, context) {
    let res = null;
    if (eventSource) res = eventSource.defaultAllDay;
    if (res == null) res = context.options.defaultAllDay;
    return res;
}
function $5913100b2ed0f596$var$parseEvents(rawEvents, eventSource, context, allowOpenRange, defIdMap, instanceIdMap) {
    let eventStore = $5913100b2ed0f596$export$9bb611d729802a56();
    let eventRefiners = $5913100b2ed0f596$var$buildEventRefiners(context);
    for (let rawEvent of rawEvents){
        let tuple = $5913100b2ed0f596$var$parseEvent(rawEvent, eventSource, context, allowOpenRange, eventRefiners, defIdMap, instanceIdMap);
        if (tuple) $5913100b2ed0f596$export$9d0e2d13d04f7070(tuple, eventStore);
    }
    return eventStore;
}
function $5913100b2ed0f596$export$9d0e2d13d04f7070(tuple, eventStore = $5913100b2ed0f596$export$9bb611d729802a56()) {
    eventStore.defs[tuple.def.defId] = tuple.def;
    if (tuple.instance) eventStore.instances[tuple.instance.instanceId] = tuple.instance;
    return eventStore;
}
// retrieves events that have the same groupId as the instance specified by `instanceId`
// or they are the same as the instance.
// why might instanceId not be in the store? an event from another calendar?
function $5913100b2ed0f596$export$1ee57be6f6687d2c(eventStore, instanceId) {
    let instance = eventStore.instances[instanceId];
    if (instance) {
        let def = eventStore.defs[instance.defId];
        // get events/instances with same group
        let newStore = $5913100b2ed0f596$var$filterEventStoreDefs(eventStore, (lookDef)=>$5913100b2ed0f596$var$isEventDefsGrouped(def, lookDef));
        // add the original
        // TODO: wish we could use eventTupleToStore or something like it
        newStore.defs[def.defId] = def;
        newStore.instances[instance.instanceId] = instance;
        return newStore;
    }
    return $5913100b2ed0f596$export$9bb611d729802a56();
}
function $5913100b2ed0f596$var$isEventDefsGrouped(def0, def1) {
    return Boolean(def0.groupId && def0.groupId === def1.groupId);
}
function $5913100b2ed0f596$export$9bb611d729802a56() {
    return {
        defs: {},
        instances: {}
    };
}
function $5913100b2ed0f596$export$317a3d46287192d8(store0, store1) {
    return {
        defs: Object.assign(Object.assign({}, store0.defs), store1.defs),
        instances: Object.assign(Object.assign({}, store0.instances), store1.instances)
    };
}
function $5913100b2ed0f596$var$filterEventStoreDefs(eventStore, filterFunc) {
    let defs = $5913100b2ed0f596$export$dda1d9f60106f0e9(eventStore.defs, filterFunc);
    let instances = $5913100b2ed0f596$export$dda1d9f60106f0e9(eventStore.instances, (instance)=>defs[instance.defId] // still exists?
    );
    return {
        defs: defs,
        instances: instances
    };
}
function $5913100b2ed0f596$var$excludeSubEventStore(master, sub) {
    let { defs: defs, instances: instances } = master;
    let filteredDefs = {};
    let filteredInstances = {};
    for(let defId in defs)if (!sub.defs[defId]) filteredDefs[defId] = defs[defId];
    for(let instanceId in instances)if (!sub.instances[instanceId] && // not explicitly excluded
    filteredDefs[instances[instanceId].defId] // def wasn't filtered away
    ) filteredInstances[instanceId] = instances[instanceId];
    return {
        defs: filteredDefs,
        instances: filteredInstances
    };
}
function $5913100b2ed0f596$var$normalizeConstraint(input, context) {
    if (Array.isArray(input)) return $5913100b2ed0f596$var$parseEvents(input, null, context, true); // allowOpenRange=true
    if (typeof input === "object" && input) return $5913100b2ed0f596$var$parseEvents([
        input
    ], null, context, true); // allowOpenRange=true
    if (input != null) return String(input);
    return null;
}
function $5913100b2ed0f596$export$d377dcb2b61d6c4e(raw) {
    if (Array.isArray(raw)) return raw;
    if (typeof raw === "string") return raw.split(/\s+/);
    return [];
}
// TODO: better called "EventSettings" or "EventConfig"
// TODO: move this file into structs
// TODO: separate constraint/overlap/allow, because selection uses only that, not other props
const $5913100b2ed0f596$var$EVENT_UI_REFINERS = {
    display: String,
    editable: Boolean,
    startEditable: Boolean,
    durationEditable: Boolean,
    constraint: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    overlap: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    allow: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    className: $5913100b2ed0f596$export$d377dcb2b61d6c4e,
    classNames: $5913100b2ed0f596$export$d377dcb2b61d6c4e,
    color: String,
    backgroundColor: String,
    borderColor: String,
    textColor: String
};
const $5913100b2ed0f596$var$EMPTY_EVENT_UI = {
    display: null,
    startEditable: null,
    durationEditable: null,
    constraints: [],
    overlap: null,
    allows: [],
    backgroundColor: "",
    borderColor: "",
    textColor: "",
    classNames: []
};
function $5913100b2ed0f596$export$71cec2538cb2c617(refined, context) {
    let constraint = $5913100b2ed0f596$var$normalizeConstraint(refined.constraint, context);
    return {
        display: refined.display || null,
        startEditable: refined.startEditable != null ? refined.startEditable : refined.editable,
        durationEditable: refined.durationEditable != null ? refined.durationEditable : refined.editable,
        constraints: constraint != null ? [
            constraint
        ] : [],
        overlap: refined.overlap != null ? refined.overlap : null,
        allows: refined.allow != null ? [
            refined.allow
        ] : [],
        backgroundColor: refined.backgroundColor || refined.color || "",
        borderColor: refined.borderColor || refined.color || "",
        textColor: refined.textColor || "",
        classNames: (refined.className || []).concat(refined.classNames || [])
    };
}
// TODO: prevent against problems with <2 args!
function $5913100b2ed0f596$export$1a8f5705751d8277(uis) {
    return uis.reduce($5913100b2ed0f596$var$combineTwoEventUis, $5913100b2ed0f596$var$EMPTY_EVENT_UI);
}
function $5913100b2ed0f596$var$combineTwoEventUis(item0, item1) {
    return {
        display: item1.display != null ? item1.display : item0.display,
        startEditable: item1.startEditable != null ? item1.startEditable : item0.startEditable,
        durationEditable: item1.durationEditable != null ? item1.durationEditable : item0.durationEditable,
        constraints: item0.constraints.concat(item1.constraints),
        overlap: typeof item1.overlap === "boolean" ? item1.overlap : item0.overlap,
        allows: item0.allows.concat(item1.allows),
        backgroundColor: item1.backgroundColor || item0.backgroundColor,
        borderColor: item1.borderColor || item0.borderColor,
        textColor: item1.textColor || item0.textColor,
        classNames: item0.classNames.concat(item1.classNames)
    };
}
const $5913100b2ed0f596$var$EVENT_SOURCE_REFINERS = {
    id: String,
    defaultAllDay: Boolean,
    url: String,
    format: String,
    events: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    eventDataTransform: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    // for any network-related sources
    success: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    failure: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5
};
function $5913100b2ed0f596$export$ffb5f4729a158638(raw, context, refiners = $5913100b2ed0f596$export$35e795649ee09318(context)) {
    let rawObj;
    if (typeof raw === "string") rawObj = {
        url: raw
    };
    else if (typeof raw === "function" || Array.isArray(raw)) rawObj = {
        events: raw
    };
    else if (typeof raw === "object" && raw) rawObj = raw;
    if (rawObj) {
        let { refined: refined, extra: extra } = $5913100b2ed0f596$export$f38c853ae54ed474(rawObj, refiners);
        let metaRes = $5913100b2ed0f596$var$buildEventSourceMeta(refined, context);
        if (metaRes) return {
            _raw: raw,
            isFetching: false,
            latestFetchId: "",
            fetchRange: null,
            defaultAllDay: refined.defaultAllDay,
            eventDataTransform: refined.eventDataTransform,
            success: refined.success,
            failure: refined.failure,
            publicId: refined.id || "",
            sourceId: $5913100b2ed0f596$export$39b482c5e57630a8(),
            sourceDefId: metaRes.sourceDefId,
            meta: metaRes.meta,
            ui: $5913100b2ed0f596$export$71cec2538cb2c617(refined, context),
            extendedProps: extra
        };
    }
    return null;
}
function $5913100b2ed0f596$export$35e795649ee09318(context) {
    return Object.assign(Object.assign(Object.assign({}, $5913100b2ed0f596$var$EVENT_UI_REFINERS), $5913100b2ed0f596$var$EVENT_SOURCE_REFINERS), context.pluginHooks.eventSourceRefiners);
}
function $5913100b2ed0f596$var$buildEventSourceMeta(raw, context) {
    let defs = context.pluginHooks.eventSourceDefs;
    for(let i = defs.length - 1; i >= 0; i -= 1){
        let def = defs[i];
        let meta = def.parseMeta(raw);
        if (meta) return {
            sourceDefId: i,
            meta: meta
        };
    }
    return null;
}
function $5913100b2ed0f596$export$3466f893ebf79586(eventStore, action, eventSources, dateProfile, context) {
    switch(action.type){
        case "RECEIVE_EVENTS":
            return $5913100b2ed0f596$var$receiveRawEvents(eventStore, eventSources[action.sourceId], action.fetchId, action.fetchRange, action.rawEvents, context);
        case "RESET_RAW_EVENTS":
            return $5913100b2ed0f596$var$resetRawEvents(eventStore, eventSources[action.sourceId], action.rawEvents, dateProfile.activeRange, context);
        case "ADD_EVENTS":
            return $5913100b2ed0f596$var$addEvent(eventStore, action.eventStore, dateProfile ? dateProfile.activeRange : null, context);
        case "RESET_EVENTS":
            return action.eventStore;
        case "MERGE_EVENTS":
            return $5913100b2ed0f596$export$317a3d46287192d8(eventStore, action.eventStore);
        case "PREV":
        case "NEXT":
        case "CHANGE_DATE":
        case "CHANGE_VIEW_TYPE":
            if (dateProfile) return $5913100b2ed0f596$var$expandRecurring(eventStore, dateProfile.activeRange, context);
            return eventStore;
        case "REMOVE_EVENTS":
            return $5913100b2ed0f596$var$excludeSubEventStore(eventStore, action.eventStore);
        case "REMOVE_EVENT_SOURCE":
            return $5913100b2ed0f596$var$excludeEventsBySourceId(eventStore, action.sourceId);
        case "REMOVE_ALL_EVENT_SOURCES":
            return $5913100b2ed0f596$var$filterEventStoreDefs(eventStore, (eventDef)=>!eventDef.sourceId // only keep events with no source id
            );
        case "REMOVE_ALL_EVENTS":
            return $5913100b2ed0f596$export$9bb611d729802a56();
        default:
            return eventStore;
    }
}
function $5913100b2ed0f596$var$receiveRawEvents(eventStore, eventSource, fetchId, fetchRange, rawEvents, context) {
    if (eventSource && // not already removed
    fetchId === eventSource.latestFetchId // TODO: wish this logic was always in event-sources
    ) {
        let subset = $5913100b2ed0f596$var$parseEvents($5913100b2ed0f596$var$transformRawEvents(rawEvents, eventSource, context), eventSource, context);
        if (fetchRange) subset = $5913100b2ed0f596$var$expandRecurring(subset, fetchRange, context);
        return $5913100b2ed0f596$export$317a3d46287192d8($5913100b2ed0f596$var$excludeEventsBySourceId(eventStore, eventSource.sourceId), subset);
    }
    return eventStore;
}
function $5913100b2ed0f596$var$resetRawEvents(existingEventStore, eventSource, rawEvents, activeRange, context) {
    const { defIdMap: defIdMap, instanceIdMap: instanceIdMap } = $5913100b2ed0f596$var$buildPublicIdMaps(existingEventStore);
    let newEventStore = $5913100b2ed0f596$var$parseEvents($5913100b2ed0f596$var$transformRawEvents(rawEvents, eventSource, context), eventSource, context, false, defIdMap, instanceIdMap);
    return $5913100b2ed0f596$var$expandRecurring(newEventStore, activeRange, context);
}
function $5913100b2ed0f596$var$transformRawEvents(rawEvents, eventSource, context) {
    let calEachTransform = context.options.eventDataTransform;
    let sourceEachTransform = eventSource ? eventSource.eventDataTransform : null;
    if (sourceEachTransform) rawEvents = $5913100b2ed0f596$var$transformEachRawEvent(rawEvents, sourceEachTransform);
    if (calEachTransform) rawEvents = $5913100b2ed0f596$var$transformEachRawEvent(rawEvents, calEachTransform);
    return rawEvents;
}
function $5913100b2ed0f596$var$transformEachRawEvent(rawEvents, func) {
    let refinedEvents;
    if (!func) refinedEvents = rawEvents;
    else {
        refinedEvents = [];
        for (let rawEvent of rawEvents){
            let refinedEvent = func(rawEvent);
            if (refinedEvent) refinedEvents.push(refinedEvent);
            else if (refinedEvent == null) refinedEvents.push(rawEvent);
             // if a different falsy value, do nothing
        }
    }
    return refinedEvents;
}
function $5913100b2ed0f596$var$addEvent(eventStore, subset, expandRange, context) {
    if (expandRange) subset = $5913100b2ed0f596$var$expandRecurring(subset, expandRange, context);
    return $5913100b2ed0f596$export$317a3d46287192d8(eventStore, subset);
}
function $5913100b2ed0f596$export$61196ced6d74a310(eventStore, oldDateEnv, newDateEnv) {
    let { defs: defs } = eventStore;
    let instances = $5913100b2ed0f596$export$407448d2b89b1813(eventStore.instances, (instance)=>{
        let def = defs[instance.defId];
        if (def.allDay) return instance; // isn't dependent on timezone
        return Object.assign(Object.assign({}, instance), {
            range: {
                start: newDateEnv.createMarker(oldDateEnv.toDate(instance.range.start, instance.forcedStartTzo)),
                end: newDateEnv.createMarker(oldDateEnv.toDate(instance.range.end, instance.forcedEndTzo))
            },
            forcedStartTzo: newDateEnv.canComputeOffset ? null : instance.forcedStartTzo,
            forcedEndTzo: newDateEnv.canComputeOffset ? null : instance.forcedEndTzo
        });
    });
    return {
        defs: defs,
        instances: instances
    };
}
function $5913100b2ed0f596$var$excludeEventsBySourceId(eventStore, sourceId) {
    return $5913100b2ed0f596$var$filterEventStoreDefs(eventStore, (eventDef)=>eventDef.sourceId !== sourceId);
}
// QUESTION: why not just return instances? do a general object-property-exclusion util
function $5913100b2ed0f596$var$excludeInstances(eventStore, removals) {
    return {
        defs: eventStore.defs,
        instances: $5913100b2ed0f596$export$dda1d9f60106f0e9(eventStore.instances, (instance)=>!removals[instance.instanceId])
    };
}
function $5913100b2ed0f596$var$buildPublicIdMaps(eventStore) {
    const { defs: defs, instances: instances } = eventStore;
    const defIdMap = {};
    const instanceIdMap = {};
    for(let defId in defs){
        const def = defs[defId];
        const { publicId: publicId } = def;
        if (publicId) defIdMap[publicId] = defId;
    }
    for(let instanceId in instances){
        const instance = instances[instanceId];
        const def = defs[instance.defId];
        const { publicId: publicId } = def;
        if (publicId) instanceIdMap[publicId] = instanceId;
    }
    return {
        defIdMap: defIdMap,
        instanceIdMap: instanceIdMap
    };
}
class $5913100b2ed0f596$export$d66501df72047452 {
    constructor(){
        this.handlers = {};
        this.thisContext = null;
    }
    setThisContext(thisContext) {
        this.thisContext = thisContext;
    }
    setOptions(options) {
        this.options = options;
    }
    on(type, handler) {
        $5913100b2ed0f596$var$addToHash(this.handlers, type, handler);
    }
    off(type, handler) {
        $5913100b2ed0f596$var$removeFromHash(this.handlers, type, handler);
    }
    trigger(type, ...args) {
        let attachedHandlers = this.handlers[type] || [];
        let optionHandler = this.options && this.options[type];
        let handlers = [].concat(optionHandler || [], attachedHandlers);
        for (let handler of handlers)handler.apply(this.thisContext, args);
    }
    hasHandlers(type) {
        return Boolean(this.handlers[type] && this.handlers[type].length || this.options && this.options[type]);
    }
}
function $5913100b2ed0f596$var$addToHash(hash, type, handler) {
    (hash[type] || (hash[type] = [])).push(handler);
}
function $5913100b2ed0f596$var$removeFromHash(hash, type, handler) {
    if (handler) {
        if (hash[type]) hash[type] = hash[type].filter((func)=>func !== handler);
    } else delete hash[type]; // remove all handler funcs for this type
}
const $5913100b2ed0f596$var$DEF_DEFAULTS = {
    startTime: "09:00",
    endTime: "17:00",
    daysOfWeek: [
        1,
        2,
        3,
        4,
        5
    ],
    display: "inverse-background",
    classNames: "fc-non-business",
    groupId: "_businessHours"
};
/*
TODO: pass around as EventDefHash!!!
*/ function $5913100b2ed0f596$export$78acf4525d8a74c4(input, context) {
    return $5913100b2ed0f596$var$parseEvents($5913100b2ed0f596$var$refineInputs(input), null, context);
}
function $5913100b2ed0f596$var$refineInputs(input) {
    let rawDefs;
    if (input === true) rawDefs = [
        {}
    ]; // will get DEF_DEFAULTS verbatim
    else if (Array.isArray(input)) // if specifying an array, every sub-definition NEEDS a day-of-week
    rawDefs = input.filter((rawDef)=>rawDef.daysOfWeek);
    else if (typeof input === "object" && input) rawDefs = [
        input
    ];
    else rawDefs = [];
    rawDefs = rawDefs.map((rawDef)=>Object.assign(Object.assign({}, $5913100b2ed0f596$var$DEF_DEFAULTS), rawDef));
    return rawDefs;
}
function $5913100b2ed0f596$export$9ddbdd0bfc5623a(selection, pev, context) {
    context.emitter.trigger("select", Object.assign(Object.assign({}, $5913100b2ed0f596$var$buildDateSpanApiWithContext(selection, context)), {
        jsEvent: pev ? pev.origEvent : null,
        view: context.viewApi || context.calendarApi.view
    }));
}
function $5913100b2ed0f596$var$triggerDateUnselect(pev, context) {
    context.emitter.trigger("unselect", {
        jsEvent: pev ? pev.origEvent : null,
        view: context.viewApi || context.calendarApi.view
    });
}
function $5913100b2ed0f596$var$buildDateSpanApiWithContext(dateSpan, context) {
    let props = {};
    for (let transform of context.pluginHooks.dateSpanTransforms)Object.assign(props, transform(dateSpan, context));
    Object.assign(props, $5913100b2ed0f596$var$buildDateSpanApi(dateSpan, context.dateEnv));
    return props;
}
// Given an event's allDay status and start date, return what its fallback end date should be.
// TODO: rename to computeDefaultEventEnd
function $5913100b2ed0f596$export$1776704b6532a19a(allDay, marker, context) {
    let { dateEnv: dateEnv, options: options } = context;
    let end = marker;
    if (allDay) {
        end = $5913100b2ed0f596$export$9e5f44173e64f162(end);
        end = dateEnv.add(end, options.defaultAllDayEventDuration);
    } else end = dateEnv.add(end, options.defaultTimedEventDuration);
    return end;
}
// applies the mutation to ALL defs/instances within the event store
function $5913100b2ed0f596$export$6d1e945284085e64(eventStore, eventConfigBase, mutation, context) {
    let eventConfigs = $5913100b2ed0f596$var$compileEventUis(eventStore.defs, eventConfigBase);
    let dest = $5913100b2ed0f596$export$9bb611d729802a56();
    for(let defId in eventStore.defs){
        let def = eventStore.defs[defId];
        dest.defs[defId] = $5913100b2ed0f596$var$applyMutationToEventDef(def, eventConfigs[defId], mutation, context);
    }
    for(let instanceId in eventStore.instances){
        let instance = eventStore.instances[instanceId];
        let def = dest.defs[instance.defId]; // important to grab the newly modified def
        dest.instances[instanceId] = $5913100b2ed0f596$var$applyMutationToEventInstance(instance, def, eventConfigs[instance.defId], mutation, context);
    }
    return dest;
}
function $5913100b2ed0f596$var$applyMutationToEventDef(eventDef, eventConfig, mutation, context) {
    let standardProps = mutation.standardProps || {};
    // if hasEnd has not been specified, guess a good value based on deltas.
    // if duration will change, there's no way the default duration will persist,
    // and thus, we need to mark the event as having a real end
    if (standardProps.hasEnd == null && eventConfig.durationEditable && (mutation.startDelta || mutation.endDelta)) standardProps.hasEnd = true; // TODO: is this mutation okay?
    let copy = Object.assign(Object.assign(Object.assign({}, eventDef), standardProps), {
        ui: Object.assign(Object.assign({}, eventDef.ui), standardProps.ui)
    });
    if (mutation.extendedProps) copy.extendedProps = Object.assign(Object.assign({}, copy.extendedProps), mutation.extendedProps);
    for (let applier of context.pluginHooks.eventDefMutationAppliers)applier(copy, mutation, context);
    if (!copy.hasEnd && context.options.forceEventDuration) copy.hasEnd = true;
    return copy;
}
function $5913100b2ed0f596$var$applyMutationToEventInstance(eventInstance, eventDef, eventConfig, mutation, context) {
    let { dateEnv: dateEnv } = context;
    let forceAllDay = mutation.standardProps && mutation.standardProps.allDay === true;
    let clearEnd = mutation.standardProps && mutation.standardProps.hasEnd === false;
    let copy = Object.assign({}, eventInstance);
    if (forceAllDay) copy.range = $5913100b2ed0f596$var$computeAlignedDayRange(copy.range);
    if (mutation.datesDelta && eventConfig.startEditable) copy.range = {
        start: dateEnv.add(copy.range.start, mutation.datesDelta),
        end: dateEnv.add(copy.range.end, mutation.datesDelta)
    };
    if (mutation.startDelta && eventConfig.durationEditable) copy.range = {
        start: dateEnv.add(copy.range.start, mutation.startDelta),
        end: copy.range.end
    };
    if (mutation.endDelta && eventConfig.durationEditable) copy.range = {
        start: copy.range.start,
        end: dateEnv.add(copy.range.end, mutation.endDelta)
    };
    if (clearEnd) copy.range = {
        start: copy.range.start,
        end: $5913100b2ed0f596$export$1776704b6532a19a(eventDef.allDay, copy.range.start, context)
    };
    // in case event was all-day but the supplied deltas were not
    // better util for this?
    if (eventDef.allDay) copy.range = {
        start: $5913100b2ed0f596$export$9e5f44173e64f162(copy.range.start),
        end: $5913100b2ed0f596$export$9e5f44173e64f162(copy.range.end)
    };
    // handle invalid durations
    if (copy.range.end < copy.range.start) copy.range.end = $5913100b2ed0f596$export$1776704b6532a19a(eventDef.allDay, copy.range.start, context);
    return copy;
}
class $5913100b2ed0f596$var$EventSourceImpl {
    constructor(context, internalEventSource){
        this.context = context;
        this.internalEventSource = internalEventSource;
    }
    remove() {
        this.context.dispatch({
            type: "REMOVE_EVENT_SOURCE",
            sourceId: this.internalEventSource.sourceId
        });
    }
    refetch() {
        this.context.dispatch({
            type: "FETCH_EVENT_SOURCES",
            sourceIds: [
                this.internalEventSource.sourceId
            ],
            isRefetch: true
        });
    }
    get id() {
        return this.internalEventSource.publicId;
    }
    get url() {
        return this.internalEventSource.meta.url;
    }
    get format() {
        return this.internalEventSource.meta.format; // TODO: bad. not guaranteed
    }
}
class $5913100b2ed0f596$export$34aec0b863436764 {
    // instance will be null if expressing a recurring event that has no current instances,
    // OR if trying to validate an incoming external event that has no dates assigned
    constructor(context, def, instance){
        this._context = context;
        this._def = def;
        this._instance = instance || null;
    }
    /*
    TODO: make event struct more responsible for this
    */ setProp(name, val) {
        if (name in $5913100b2ed0f596$var$EVENT_DATE_REFINERS) console.warn("Could not set date-related prop 'name'. Use one of the date-related methods instead.");
        else if (name === "id") {
            val = $5913100b2ed0f596$var$EVENT_NON_DATE_REFINERS[name](val);
            this.mutate({
                standardProps: {
                    publicId: val
                }
            });
        } else if (name in $5913100b2ed0f596$var$EVENT_NON_DATE_REFINERS) {
            val = $5913100b2ed0f596$var$EVENT_NON_DATE_REFINERS[name](val);
            this.mutate({
                standardProps: {
                    [name]: val
                }
            });
        } else if (name in $5913100b2ed0f596$var$EVENT_UI_REFINERS) {
            let ui = $5913100b2ed0f596$var$EVENT_UI_REFINERS[name](val);
            if (name === "color") ui = {
                backgroundColor: val,
                borderColor: val
            };
            else if (name === "editable") ui = {
                startEditable: val,
                durationEditable: val
            };
            else ui = {
                [name]: val
            };
            this.mutate({
                standardProps: {
                    ui: ui
                }
            });
        } else console.warn(`Could not set prop '${name}'. Use setExtendedProp instead.`);
    }
    setExtendedProp(name, val) {
        this.mutate({
            extendedProps: {
                [name]: val
            }
        });
    }
    setStart(startInput, options = {}) {
        let { dateEnv: dateEnv } = this._context;
        let start = dateEnv.createMarker(startInput);
        if (start && this._instance) {
            let instanceRange = this._instance.range;
            let startDelta = $5913100b2ed0f596$export$91c6e00c14e7e6fd(instanceRange.start, start, dateEnv, options.granularity); // what if parsed bad!?
            if (options.maintainDuration) this.mutate({
                datesDelta: startDelta
            });
            else this.mutate({
                startDelta: startDelta
            });
        }
    }
    setEnd(endInput, options = {}) {
        let { dateEnv: dateEnv } = this._context;
        let end;
        if (endInput != null) {
            end = dateEnv.createMarker(endInput);
            if (!end) return; // TODO: warning if parsed bad
        }
        if (this._instance) {
            if (end) {
                let endDelta = $5913100b2ed0f596$export$91c6e00c14e7e6fd(this._instance.range.end, end, dateEnv, options.granularity);
                this.mutate({
                    endDelta: endDelta
                });
            } else this.mutate({
                standardProps: {
                    hasEnd: false
                }
            });
        }
    }
    setDates(startInput, endInput, options = {}) {
        let { dateEnv: dateEnv } = this._context;
        let standardProps = {
            allDay: options.allDay
        };
        let start = dateEnv.createMarker(startInput);
        let end;
        if (!start) return; // TODO: warning if parsed bad
        if (endInput != null) {
            end = dateEnv.createMarker(endInput);
            if (!end) return;
        }
        if (this._instance) {
            let instanceRange = this._instance.range;
            // when computing the diff for an event being converted to all-day,
            // compute diff off of the all-day values the way event-mutation does.
            if (options.allDay === true) instanceRange = $5913100b2ed0f596$var$computeAlignedDayRange(instanceRange);
            let startDelta = $5913100b2ed0f596$export$91c6e00c14e7e6fd(instanceRange.start, start, dateEnv, options.granularity);
            if (end) {
                let endDelta = $5913100b2ed0f596$export$91c6e00c14e7e6fd(instanceRange.end, end, dateEnv, options.granularity);
                if ($5913100b2ed0f596$var$durationsEqual(startDelta, endDelta)) this.mutate({
                    datesDelta: startDelta,
                    standardProps: standardProps
                });
                else this.mutate({
                    startDelta: startDelta,
                    endDelta: endDelta,
                    standardProps: standardProps
                });
            } else {
                standardProps.hasEnd = false;
                this.mutate({
                    datesDelta: startDelta,
                    standardProps: standardProps
                });
            }
        }
    }
    moveStart(deltaInput) {
        let delta = $5913100b2ed0f596$export$4368d992c4eafac0(deltaInput);
        if (delta) this.mutate({
            startDelta: delta
        });
    }
    moveEnd(deltaInput) {
        let delta = $5913100b2ed0f596$export$4368d992c4eafac0(deltaInput);
        if (delta) this.mutate({
            endDelta: delta
        });
    }
    moveDates(deltaInput) {
        let delta = $5913100b2ed0f596$export$4368d992c4eafac0(deltaInput);
        if (delta) this.mutate({
            datesDelta: delta
        });
    }
    setAllDay(allDay, options = {}) {
        let standardProps = {
            allDay: allDay
        };
        let { maintainDuration: maintainDuration } = options;
        if (maintainDuration == null) maintainDuration = this._context.options.allDayMaintainDuration;
        if (this._def.allDay !== allDay) standardProps.hasEnd = maintainDuration;
        this.mutate({
            standardProps: standardProps
        });
    }
    formatRange(formatInput) {
        let { dateEnv: dateEnv } = this._context;
        let instance = this._instance;
        let formatter = $5913100b2ed0f596$export$d141bba7fdc215a3(formatInput);
        if (this._def.hasEnd) return dateEnv.formatRange(instance.range.start, instance.range.end, formatter, {
            forcedStartTzo: instance.forcedStartTzo,
            forcedEndTzo: instance.forcedEndTzo
        });
        return dateEnv.format(instance.range.start, formatter, {
            forcedTzo: instance.forcedStartTzo
        });
    }
    mutate(mutation) {
        let instance = this._instance;
        if (instance) {
            let def = this._def;
            let context = this._context;
            let { eventStore: eventStore } = context.getCurrentData();
            let relevantEvents = $5913100b2ed0f596$export$1ee57be6f6687d2c(eventStore, instance.instanceId);
            let eventConfigBase = {
                "": {
                    display: "",
                    startEditable: true,
                    durationEditable: true,
                    constraints: [],
                    overlap: null,
                    allows: [],
                    backgroundColor: "",
                    borderColor: "",
                    textColor: "",
                    classNames: []
                }
            };
            relevantEvents = $5913100b2ed0f596$export$6d1e945284085e64(relevantEvents, eventConfigBase, mutation, context);
            let oldEvent = new $5913100b2ed0f596$export$34aec0b863436764(context, def, instance); // snapshot
            this._def = relevantEvents.defs[def.defId];
            this._instance = relevantEvents.instances[instance.instanceId];
            context.dispatch({
                type: "MERGE_EVENTS",
                eventStore: relevantEvents
            });
            context.emitter.trigger("eventChange", {
                oldEvent: oldEvent,
                event: this,
                relatedEvents: $5913100b2ed0f596$export$efccba1c4a2ef57b(relevantEvents, context, instance),
                revert () {
                    context.dispatch({
                        type: "RESET_EVENTS",
                        eventStore: eventStore
                    });
                }
            });
        }
    }
    remove() {
        let context = this._context;
        let asStore = $5913100b2ed0f596$var$eventApiToStore(this);
        context.dispatch({
            type: "REMOVE_EVENTS",
            eventStore: asStore
        });
        context.emitter.trigger("eventRemove", {
            event: this,
            relatedEvents: [],
            revert () {
                context.dispatch({
                    type: "MERGE_EVENTS",
                    eventStore: asStore
                });
            }
        });
    }
    get source() {
        let { sourceId: sourceId } = this._def;
        if (sourceId) return new $5913100b2ed0f596$var$EventSourceImpl(this._context, this._context.getCurrentData().eventSources[sourceId]);
        return null;
    }
    get start() {
        return this._instance ? this._context.dateEnv.toDate(this._instance.range.start) : null;
    }
    get end() {
        return this._instance && this._def.hasEnd ? this._context.dateEnv.toDate(this._instance.range.end) : null;
    }
    get startStr() {
        let instance = this._instance;
        if (instance) return this._context.dateEnv.formatIso(instance.range.start, {
            omitTime: this._def.allDay,
            forcedTzo: instance.forcedStartTzo
        });
        return "";
    }
    get endStr() {
        let instance = this._instance;
        if (instance && this._def.hasEnd) return this._context.dateEnv.formatIso(instance.range.end, {
            omitTime: this._def.allDay,
            forcedTzo: instance.forcedEndTzo
        });
        return "";
    }
    // computable props that all access the def
    // TODO: find a TypeScript-compatible way to do this at scale
    get id() {
        return this._def.publicId;
    }
    get groupId() {
        return this._def.groupId;
    }
    get allDay() {
        return this._def.allDay;
    }
    get title() {
        return this._def.title;
    }
    get url() {
        return this._def.url;
    }
    get display() {
        return this._def.ui.display || "auto";
    }
    get startEditable() {
        return this._def.ui.startEditable;
    }
    get durationEditable() {
        return this._def.ui.durationEditable;
    }
    get constraint() {
        return this._def.ui.constraints[0] || null;
    }
    get overlap() {
        return this._def.ui.overlap;
    }
    get allow() {
        return this._def.ui.allows[0] || null;
    }
    get backgroundColor() {
        return this._def.ui.backgroundColor;
    }
    get borderColor() {
        return this._def.ui.borderColor;
    }
    get textColor() {
        return this._def.ui.textColor;
    }
    // NOTE: user can't modify these because Object.freeze was called in event-def parsing
    get classNames() {
        return this._def.ui.classNames;
    }
    get extendedProps() {
        return this._def.extendedProps;
    }
    toPlainObject(settings = {}) {
        let def = this._def;
        let { ui: ui } = def;
        let { startStr: startStr, endStr: endStr } = this;
        let res = {
            allDay: def.allDay
        };
        if (def.title) res.title = def.title;
        if (startStr) res.start = startStr;
        if (endStr) res.end = endStr;
        if (def.publicId) res.id = def.publicId;
        if (def.groupId) res.groupId = def.groupId;
        if (def.url) res.url = def.url;
        if (ui.display && ui.display !== "auto") res.display = ui.display;
        // TODO: what about recurring-event properties???
        // TODO: include startEditable/durationEditable/constraint/overlap/allow
        if (settings.collapseColor && ui.backgroundColor && ui.backgroundColor === ui.borderColor) res.color = ui.backgroundColor;
        else {
            if (ui.backgroundColor) res.backgroundColor = ui.backgroundColor;
            if (ui.borderColor) res.borderColor = ui.borderColor;
        }
        if (ui.textColor) res.textColor = ui.textColor;
        if (ui.classNames.length) res.classNames = ui.classNames;
        if (Object.keys(def.extendedProps).length) {
            if (settings.collapseExtendedProps) Object.assign(res, def.extendedProps);
            else res.extendedProps = def.extendedProps;
        }
        return res;
    }
    toJSON() {
        return this.toPlainObject();
    }
}
function $5913100b2ed0f596$var$eventApiToStore(eventApi) {
    let def = eventApi._def;
    let instance = eventApi._instance;
    return {
        defs: {
            [def.defId]: def
        },
        instances: instance ? {
            [instance.instanceId]: instance
        } : {}
    };
}
function $5913100b2ed0f596$export$efccba1c4a2ef57b(eventStore, context, excludeInstance) {
    let { defs: defs, instances: instances } = eventStore;
    let eventApis = [];
    let excludeInstanceId = excludeInstance ? excludeInstance.instanceId : "";
    for(let id in instances){
        let instance = instances[id];
        let def = defs[instance.defId];
        if (instance.instanceId !== excludeInstanceId) eventApis.push(new $5913100b2ed0f596$export$34aec0b863436764(context, def, instance));
    }
    return eventApis;
}
/*
Specifying nextDayThreshold signals that all-day ranges should be sliced.
*/ function $5913100b2ed0f596$export$c9170ad7d4cd7e57(eventStore, eventUiBases, framingRange, nextDayThreshold) {
    let inverseBgByGroupId = {};
    let inverseBgByDefId = {};
    let defByGroupId = {};
    let bgRanges = [];
    let fgRanges = [];
    let eventUis = $5913100b2ed0f596$var$compileEventUis(eventStore.defs, eventUiBases);
    for(let defId in eventStore.defs){
        let def = eventStore.defs[defId];
        let ui = eventUis[def.defId];
        if (ui.display === "inverse-background") {
            if (def.groupId) {
                inverseBgByGroupId[def.groupId] = [];
                if (!defByGroupId[def.groupId]) defByGroupId[def.groupId] = def;
            } else inverseBgByDefId[defId] = [];
        }
    }
    for(let instanceId in eventStore.instances){
        let instance = eventStore.instances[instanceId];
        let def = eventStore.defs[instance.defId];
        let ui = eventUis[def.defId];
        let origRange = instance.range;
        let normalRange = !def.allDay && nextDayThreshold ? $5913100b2ed0f596$export$28f7fcd39efa255(origRange, nextDayThreshold) : origRange;
        let slicedRange = $5913100b2ed0f596$export$ae1af26003f05816(normalRange, framingRange);
        if (slicedRange) {
            if (ui.display === "inverse-background") {
                if (def.groupId) inverseBgByGroupId[def.groupId].push(slicedRange);
                else inverseBgByDefId[instance.defId].push(slicedRange);
            } else if (ui.display !== "none") (ui.display === "background" ? bgRanges : fgRanges).push({
                def: def,
                ui: ui,
                instance: instance,
                range: slicedRange,
                isStart: normalRange.start && normalRange.start.valueOf() === slicedRange.start.valueOf(),
                isEnd: normalRange.end && normalRange.end.valueOf() === slicedRange.end.valueOf()
            });
        }
    }
    for(let groupId in inverseBgByGroupId){
        let ranges = inverseBgByGroupId[groupId];
        let invertedRanges = $5913100b2ed0f596$var$invertRanges(ranges, framingRange);
        for (let invertedRange of invertedRanges){
            let def = defByGroupId[groupId];
            let ui = eventUis[def.defId];
            bgRanges.push({
                def: def,
                ui: ui,
                instance: null,
                range: invertedRange,
                isStart: false,
                isEnd: false
            });
        }
    }
    for(let defId in inverseBgByDefId){
        let ranges = inverseBgByDefId[defId];
        let invertedRanges = $5913100b2ed0f596$var$invertRanges(ranges, framingRange);
        for (let invertedRange of invertedRanges)bgRanges.push({
            def: eventStore.defs[defId],
            ui: eventUis[defId],
            instance: null,
            range: invertedRange,
            isStart: false,
            isEnd: false
        });
    }
    return {
        bg: bgRanges,
        fg: fgRanges
    };
}
function $5913100b2ed0f596$export$a91cd623adc48128(def) {
    return def.ui.display === "background" || def.ui.display === "inverse-background";
}
function $5913100b2ed0f596$var$setElSeg(el, seg) {
    el.fcSeg = seg;
}
function $5913100b2ed0f596$export$71511d61b312f219(el) {
    return el.fcSeg || el.parentNode.fcSeg || // for the harness
    null;
}
// event ui computation
function $5913100b2ed0f596$var$compileEventUis(eventDefs, eventUiBases) {
    return $5913100b2ed0f596$export$407448d2b89b1813(eventDefs, (eventDef)=>$5913100b2ed0f596$var$compileEventUi(eventDef, eventUiBases));
}
function $5913100b2ed0f596$var$compileEventUi(eventDef, eventUiBases) {
    let uis = [];
    if (eventUiBases[""]) uis.push(eventUiBases[""]);
    if (eventUiBases[eventDef.defId]) uis.push(eventUiBases[eventDef.defId]);
    uis.push(eventDef.ui);
    return $5913100b2ed0f596$export$1a8f5705751d8277(uis);
}
function $5913100b2ed0f596$export$4d522598b426bb73(segs, eventOrderSpecs) {
    let objs = segs.map($5913100b2ed0f596$var$buildSegCompareObj);
    objs.sort((obj0, obj1)=>$5913100b2ed0f596$export$2f6ca3d3b1f80bf5(obj0, obj1, eventOrderSpecs));
    return objs.map((c)=>c._seg);
}
// returns a object with all primitive props that can be compared
function $5913100b2ed0f596$var$buildSegCompareObj(seg) {
    let { eventRange: eventRange } = seg;
    let eventDef = eventRange.def;
    let range = eventRange.instance ? eventRange.instance.range : eventRange.range;
    let start = range.start ? range.start.valueOf() : 0; // TODO: better support for open-range events
    let end = range.end ? range.end.valueOf() : 0; // "
    return Object.assign(Object.assign(Object.assign({}, eventDef.extendedProps), eventDef), {
        id: eventDef.publicId,
        start: start,
        end: end,
        duration: end - start,
        allDay: Number(eventDef.allDay),
        _seg: seg
    });
}
function $5913100b2ed0f596$var$computeSegDraggable(seg, context) {
    let { pluginHooks: pluginHooks } = context;
    let transformers = pluginHooks.isDraggableTransformers;
    let { def: def, ui: ui } = seg.eventRange;
    let val = ui.startEditable;
    for (let transformer of transformers)val = transformer(val, def, ui, context);
    return val;
}
function $5913100b2ed0f596$var$computeSegStartResizable(seg, context) {
    return seg.isStart && seg.eventRange.ui.durationEditable && context.options.eventResizableFromStart;
}
function $5913100b2ed0f596$var$computeSegEndResizable(seg, context) {
    return seg.isEnd && seg.eventRange.ui.durationEditable;
}
function $5913100b2ed0f596$export$993a080e5cb62d74(seg, timeFormat, context, defaultDisplayEventTime, defaultDisplayEventEnd, startOverride, endOverride) {
    let { dateEnv: dateEnv, options: options } = context;
    let { displayEventTime: displayEventTime, displayEventEnd: displayEventEnd } = options;
    let eventDef = seg.eventRange.def;
    let eventInstance = seg.eventRange.instance;
    if (displayEventTime == null) displayEventTime = defaultDisplayEventTime !== false;
    if (displayEventEnd == null) displayEventEnd = defaultDisplayEventEnd !== false;
    let wholeEventStart = eventInstance.range.start;
    let wholeEventEnd = eventInstance.range.end;
    let segStart = startOverride || seg.start || seg.eventRange.range.start;
    let segEnd = endOverride || seg.end || seg.eventRange.range.end;
    let isStartDay = $5913100b2ed0f596$export$9e5f44173e64f162(wholeEventStart).valueOf() === $5913100b2ed0f596$export$9e5f44173e64f162(segStart).valueOf();
    let isEndDay = $5913100b2ed0f596$export$9e5f44173e64f162($5913100b2ed0f596$export$136fd86de524d3c2(wholeEventEnd, -1)).valueOf() === $5913100b2ed0f596$export$9e5f44173e64f162($5913100b2ed0f596$export$136fd86de524d3c2(segEnd, -1)).valueOf();
    if (displayEventTime && !eventDef.allDay && (isStartDay || isEndDay)) {
        segStart = isStartDay ? wholeEventStart : segStart;
        segEnd = isEndDay ? wholeEventEnd : segEnd;
        if (displayEventEnd && eventDef.hasEnd) return dateEnv.formatRange(segStart, segEnd, timeFormat, {
            forcedStartTzo: startOverride ? null : eventInstance.forcedStartTzo,
            forcedEndTzo: endOverride ? null : eventInstance.forcedEndTzo
        });
        return dateEnv.format(segStart, timeFormat, {
            forcedTzo: startOverride ? null : eventInstance.forcedStartTzo
        });
    }
    return "";
}
function $5913100b2ed0f596$export$6dabbe08653f866f(seg, todayRange, nowDate) {
    let segRange = seg.eventRange.range;
    return {
        isPast: segRange.end <= (nowDate || todayRange.start),
        isFuture: segRange.start >= (nowDate || todayRange.end),
        isToday: todayRange && $5913100b2ed0f596$export$7f8ddf7c7c20b3cd(todayRange, segRange.start)
    };
}
function $5913100b2ed0f596$var$getEventClassNames(props) {
    let classNames = [
        "fc-event"
    ];
    if (props.isMirror) classNames.push("fc-event-mirror");
    if (props.isDraggable) classNames.push("fc-event-draggable");
    if (props.isStartResizable || props.isEndResizable) classNames.push("fc-event-resizable");
    if (props.isDragging) classNames.push("fc-event-dragging");
    if (props.isResizing) classNames.push("fc-event-resizing");
    if (props.isSelected) classNames.push("fc-event-selected");
    if (props.isStart) classNames.push("fc-event-start");
    if (props.isEnd) classNames.push("fc-event-end");
    if (props.isPast) classNames.push("fc-event-past");
    if (props.isToday) classNames.push("fc-event-today");
    if (props.isFuture) classNames.push("fc-event-future");
    return classNames;
}
function $5913100b2ed0f596$export$1314441b8d04e1d5(eventRange) {
    return eventRange.instance ? eventRange.instance.instanceId : `${eventRange.def.defId}:${eventRange.range.start.toISOString()}`;
// inverse-background events don't have specific instances. TODO: better solution
}
function $5913100b2ed0f596$export$e0c3a065614c6254(seg, context) {
    let { def: def, instance: instance } = seg.eventRange;
    let { url: url } = def;
    if (url) return {
        href: url
    };
    let { emitter: emitter, options: options } = context;
    let { eventInteractive: eventInteractive } = options;
    if (eventInteractive == null) {
        eventInteractive = def.interactive;
        if (eventInteractive == null) eventInteractive = Boolean(emitter.hasHandlers("eventClick"));
    }
    // mock what happens in EventClicking
    if (eventInteractive) // only attach keyboard-related handlers because click handler is already done in EventClicking
    return $5913100b2ed0f596$var$createAriaKeyboardAttrs((ev)=>{
        emitter.trigger("eventClick", {
            el: ev.target,
            event: new $5913100b2ed0f596$export$34aec0b863436764(context, def, instance),
            jsEvent: ev,
            view: context.viewApi
        });
    });
    return {};
}
const $5913100b2ed0f596$var$STANDARD_PROPS = {
    start: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    end: $5913100b2ed0f596$export$7ccc53e8f1e7dfc5,
    allDay: Boolean
};
function $5913100b2ed0f596$var$parseDateSpan(raw, dateEnv, defaultDuration) {
    let span = $5913100b2ed0f596$var$parseOpenDateSpan(raw, dateEnv);
    let { range: range } = span;
    if (!range.start) return null;
    if (!range.end) {
        if (defaultDuration == null) return null;
        range.end = dateEnv.add(range.start, defaultDuration);
    }
    return span;
}
/*
TODO: somehow combine with parseRange?
Will return null if the start/end props were present but parsed invalidly.
*/ function $5913100b2ed0f596$var$parseOpenDateSpan(raw, dateEnv) {
    let { refined: standardProps, extra: extra } = $5913100b2ed0f596$export$f38c853ae54ed474(raw, $5913100b2ed0f596$var$STANDARD_PROPS);
    let startMeta = standardProps.start ? dateEnv.createMarkerMeta(standardProps.start) : null;
    let endMeta = standardProps.end ? dateEnv.createMarkerMeta(standardProps.end) : null;
    let { allDay: allDay } = standardProps;
    if (allDay == null) allDay = startMeta && startMeta.isTimeUnspecified && (!endMeta || endMeta.isTimeUnspecified);
    return Object.assign({
        range: {
            start: startMeta ? startMeta.marker : null,
            end: endMeta ? endMeta.marker : null
        },
        allDay: allDay
    }, extra);
}
function $5913100b2ed0f596$export$151db275011178c4(span0, span1) {
    return $5913100b2ed0f596$export$f074adc9fbd50943(span0.range, span1.range) && span0.allDay === span1.allDay && $5913100b2ed0f596$var$isSpanPropsEqual(span0, span1);
}
// the NON-DATE-RELATED props
function $5913100b2ed0f596$var$isSpanPropsEqual(span0, span1) {
    for(let propName in span1)if (propName !== "range" && propName !== "allDay") {
        if (span0[propName] !== span1[propName]) return false;
    }
    // are there any props that span0 has that span1 DOESN'T have?
    // both have range/allDay, so no need to special-case.
    for(let propName in span0){
        if (!(propName in span1)) return false;
    }
    return true;
}
function $5913100b2ed0f596$var$buildDateSpanApi(span, dateEnv) {
    return Object.assign(Object.assign({}, $5913100b2ed0f596$var$buildRangeApi(span.range, dateEnv, span.allDay)), {
        allDay: span.allDay
    });
}
function $5913100b2ed0f596$export$882b5998b3b9117c(range, dateEnv, omitTime) {
    return Object.assign(Object.assign({}, $5913100b2ed0f596$var$buildRangeApi(range, dateEnv, omitTime)), {
        timeZone: dateEnv.timeZone
    });
}
function $5913100b2ed0f596$var$buildRangeApi(range, dateEnv, omitTime) {
    return {
        start: dateEnv.toDate(range.start),
        end: dateEnv.toDate(range.end),
        startStr: dateEnv.formatIso(range.start, {
            omitTime: omitTime
        }),
        endStr: dateEnv.formatIso(range.end, {
            omitTime: omitTime
        })
    };
}
function $5913100b2ed0f596$var$fabricateEventRange(dateSpan, eventUiBases, context) {
    let res = $5913100b2ed0f596$export$ab83b03e4111b1d0({
        editable: false
    }, context);
    let def = $5913100b2ed0f596$export$21579262ef46735b(res.refined, res.extra, "", dateSpan.allDay, true, context);
    return {
        def: def,
        ui: $5913100b2ed0f596$var$compileEventUi(def, eventUiBases),
        instance: $5913100b2ed0f596$export$3b513254972cfc9c(def.defId, dateSpan.range),
        range: dateSpan.range,
        isStart: true,
        isEnd: true
    };
}
/*
given a function that resolves a result asynchronously.
the function can either call passed-in success and failure callbacks,
or it can return a promise.
if you need to pass additional params to func, bind them first.
*/ function $5913100b2ed0f596$export$3b14a55fb2447963(func, normalizedSuccessCallback, normalizedFailureCallback) {
    // guard against success/failure callbacks being called more than once
    // and guard against a promise AND callback being used together.
    let isResolved = false;
    let wrappedSuccess = function(res) {
        if (!isResolved) {
            isResolved = true;
            normalizedSuccessCallback(res);
        }
    };
    let wrappedFailure = function(error) {
        if (!isResolved) {
            isResolved = true;
            normalizedFailureCallback(error);
        }
    };
    let res = func(wrappedSuccess, wrappedFailure);
    if (res && typeof res.then === "function") res.then(wrappedSuccess, wrappedFailure);
}
class $5913100b2ed0f596$export$ee7c8ad385a60b7b extends Error {
    constructor(message, response){
        super(message);
        this.response = response;
    }
}
function $5913100b2ed0f596$export$43caf9889c228507(method, url, params) {
    method = method.toUpperCase();
    const fetchOptions = {
        method: method
    };
    if (method === "GET") url += (url.indexOf("?") === -1 ? "?" : "&") + new URLSearchParams(params);
    else {
        fetchOptions.body = new URLSearchParams(params);
        fetchOptions.headers = {
            "Content-Type": "application/x-www-form-urlencoded"
        };
    }
    return fetch(url, fetchOptions).then((fetchRes)=>{
        if (fetchRes.ok) return fetchRes.json().then((parsedResponse)=>{
            return [
                parsedResponse,
                fetchRes
            ];
        }, ()=>{
            throw new $5913100b2ed0f596$export$ee7c8ad385a60b7b("Failure parsing JSON", fetchRes);
        });
        else throw new $5913100b2ed0f596$export$ee7c8ad385a60b7b("Request failed", fetchRes);
    });
}
let $5913100b2ed0f596$var$canVGrowWithinCell;
function $5913100b2ed0f596$export$667d3bf0c5f83305() {
    if ($5913100b2ed0f596$var$canVGrowWithinCell == null) $5913100b2ed0f596$var$canVGrowWithinCell = $5913100b2ed0f596$var$computeCanVGrowWithinCell();
    return $5913100b2ed0f596$var$canVGrowWithinCell;
}
function $5913100b2ed0f596$var$computeCanVGrowWithinCell() {
    // for SSR, because this function is call immediately at top-level
    // TODO: just make this logic execute top-level, immediately, instead of doing lazily
    if (typeof document === "undefined") return true;
    let el = document.createElement("div");
    el.style.position = "absolute";
    el.style.top = "0px";
    el.style.left = "0px";
    el.innerHTML = "<table><tr><td><div></div></td></tr></table>";
    el.querySelector("table").style.height = "100px";
    el.querySelector("div").style.height = "100%";
    document.body.appendChild(el);
    let div = el.querySelector("div");
    let possible = div.offsetHeight > 0;
    document.body.removeChild(el);
    return possible;
}
class $5913100b2ed0f596$export$555508cbc6add439 extends $5913100b2ed0f596$export$ef35774e6d314e91 {
    constructor(){
        super(...arguments);
        this.state = {
            forPrint: false
        };
        this.handleBeforePrint = ()=>{
            $5913100b2ed0f596$export$7910e0436ed8d1de(()=>{
                this.setState({
                    forPrint: true
                });
            });
        };
        this.handleAfterPrint = ()=>{
            $5913100b2ed0f596$export$7910e0436ed8d1de(()=>{
                this.setState({
                    forPrint: false
                });
            });
        };
    }
    render() {
        let { props: props } = this;
        let { options: options } = props;
        let { forPrint: forPrint } = this.state;
        let isHeightAuto = forPrint || options.height === "auto" || options.contentHeight === "auto";
        let height = !isHeightAuto && options.height != null ? options.height : "";
        let classNames = [
            "fc",
            forPrint ? "fc-media-print" : "fc-media-screen",
            `fc-direction-${options.direction}`,
            props.theme.getClass("root")
        ];
        if (!$5913100b2ed0f596$export$667d3bf0c5f83305()) classNames.push("fc-liquid-hack");
        return props.children(classNames, height, isHeightAuto, forPrint);
    }
    componentDidMount() {
        let { emitter: emitter } = this.props;
        emitter.on("_beforeprint", this.handleBeforePrint);
        emitter.on("_afterprint", this.handleAfterPrint);
    }
    componentWillUnmount() {
        let { emitter: emitter } = this.props;
        emitter.off("_beforeprint", this.handleBeforePrint);
        emitter.off("_afterprint", this.handleAfterPrint);
    }
}
class $5913100b2ed0f596$export$dc98b0b04f4c7758 {
    constructor(settings){
        this.component = settings.component;
        this.isHitComboAllowed = settings.isHitComboAllowed || null;
    }
    destroy() {}
}
function $5913100b2ed0f596$export$2e2af4578d910ddf(component, input) {
    return {
        component: component,
        el: input.el,
        useEventCenter: input.useEventCenter != null ? input.useEventCenter : true,
        isHitComboAllowed: input.isHitComboAllowed || null
    };
}
function $5913100b2ed0f596$export$aff10ba49ece4b91(settings) {
    return {
        [settings.component.uid]: settings
    };
}
// global state
const $5913100b2ed0f596$export$a93c5207d687da10 = {};
class $5913100b2ed0f596$export$a9c996f45e5784d0 {
    getCurrentData() {
        return this.currentDataManager.getCurrentData();
    }
    dispatch(action) {
        this.currentDataManager.dispatch(action);
    }
    get view() {
        return this.getCurrentData().viewApi;
    }
    batchRendering(callback) {
        callback();
    }
    updateSize() {
        this.trigger("_resize", true);
    }
    // Options
    // -----------------------------------------------------------------------------------------------------------------
    setOption(name, val) {
        this.dispatch({
            type: "SET_OPTION",
            optionName: name,
            rawOptionValue: val
        });
    }
    getOption(name) {
        return this.currentDataManager.currentCalendarOptionsInput[name];
    }
    getAvailableLocaleCodes() {
        return Object.keys(this.getCurrentData().availableRawLocales);
    }
    // Trigger
    // -----------------------------------------------------------------------------------------------------------------
    on(handlerName, handler) {
        let { currentDataManager: currentDataManager } = this;
        if (currentDataManager.currentCalendarOptionsRefiners[handlerName]) currentDataManager.emitter.on(handlerName, handler);
        else console.warn(`Unknown listener name '${handlerName}'`);
    }
    off(handlerName, handler) {
        this.currentDataManager.emitter.off(handlerName, handler);
    }
    // not meant for public use
    trigger(handlerName, ...args) {
        this.currentDataManager.emitter.trigger(handlerName, ...args);
    }
    // View
    // -----------------------------------------------------------------------------------------------------------------
    changeView(viewType, dateOrRange) {
        this.batchRendering(()=>{
            this.unselect();
            if (dateOrRange) {
                if (dateOrRange.start && dateOrRange.end) {
                    this.dispatch({
                        type: "CHANGE_VIEW_TYPE",
                        viewType: viewType
                    });
                    this.dispatch({
                        type: "SET_OPTION",
                        optionName: "visibleRange",
                        rawOptionValue: dateOrRange
                    });
                } else {
                    let { dateEnv: dateEnv } = this.getCurrentData();
                    this.dispatch({
                        type: "CHANGE_VIEW_TYPE",
                        viewType: viewType,
                        dateMarker: dateEnv.createMarker(dateOrRange)
                    });
                }
            } else this.dispatch({
                type: "CHANGE_VIEW_TYPE",
                viewType: viewType
            });
        });
    }
    // Forces navigation to a view for the given date.
    // `viewType` can be a specific view name or a generic one like "week" or "day".
    // needs to change
    zoomTo(dateMarker, viewType) {
        let state = this.getCurrentData();
        let spec;
        viewType = viewType || "day"; // day is default zoom
        spec = state.viewSpecs[viewType] || this.getUnitViewSpec(viewType);
        this.unselect();
        if (spec) this.dispatch({
            type: "CHANGE_VIEW_TYPE",
            viewType: spec.type,
            dateMarker: dateMarker
        });
        else this.dispatch({
            type: "CHANGE_DATE",
            dateMarker: dateMarker
        });
    }
    // Given a duration singular unit, like "week" or "day", finds a matching view spec.
    // Preference is given to views that have corresponding buttons.
    getUnitViewSpec(unit) {
        let { viewSpecs: viewSpecs, toolbarConfig: toolbarConfig } = this.getCurrentData();
        let viewTypes = [].concat(toolbarConfig.header ? toolbarConfig.header.viewsWithButtons : [], toolbarConfig.footer ? toolbarConfig.footer.viewsWithButtons : []);
        let i;
        let spec;
        for(let viewType in viewSpecs)viewTypes.push(viewType);
        for(i = 0; i < viewTypes.length; i += 1){
            spec = viewSpecs[viewTypes[i]];
            if (spec) {
                if (spec.singleUnit === unit) return spec;
            }
        }
        return null;
    }
    // Current Date
    // -----------------------------------------------------------------------------------------------------------------
    prev() {
        this.unselect();
        this.dispatch({
            type: "PREV"
        });
    }
    next() {
        this.unselect();
        this.dispatch({
            type: "NEXT"
        });
    }
    prevYear() {
        let state = this.getCurrentData();
        this.unselect();
        this.dispatch({
            type: "CHANGE_DATE",
            dateMarker: state.dateEnv.addYears(state.currentDate, -1)
        });
    }
    nextYear() {
        let state = this.getCurrentData();
        this.unselect();
        this.dispatch({
            type: "CHANGE_DATE",
            dateMarker: state.dateEnv.addYears(state.currentDate, 1)
        });
    }
    today() {
        let state = this.getCurrentData();
        this.unselect();
        this.dispatch({
            type: "CHANGE_DATE",
            dateMarker: $5913100b2ed0f596$export$c3950d9923825c02(state.calendarOptions.now, state.dateEnv)
        });
    }
    gotoDate(zonedDateInput) {
        let state = this.getCurrentData();
        this.unselect();
        this.dispatch({
            type: "CHANGE_DATE",
            dateMarker: state.dateEnv.createMarker(zonedDateInput)
        });
    }
    incrementDate(deltaInput) {
        let state = this.getCurrentData();
        let delta = $5913100b2ed0f596$export$4368d992c4eafac0(deltaInput);
        if (delta) {
            this.unselect();
            this.dispatch({
                type: "CHANGE_DATE",
                dateMarker: state.dateEnv.add(state.currentDate, delta)
            });
        }
    }
    getDate() {
        let state = this.getCurrentData();
        return state.dateEnv.toDate(state.currentDate);
    }
    // Date Formatting Utils
    // -----------------------------------------------------------------------------------------------------------------
    formatDate(d, formatter) {
        let { dateEnv: dateEnv } = this.getCurrentData();
        return dateEnv.format(dateEnv.createMarker(d), $5913100b2ed0f596$export$d141bba7fdc215a3(formatter));
    }
    // `settings` is for formatter AND isEndExclusive
    formatRange(d0, d1, settings) {
        let { dateEnv: dateEnv } = this.getCurrentData();
        return dateEnv.formatRange(dateEnv.createMarker(d0), dateEnv.createMarker(d1), $5913100b2ed0f596$export$d141bba7fdc215a3(settings), settings);
    }
    formatIso(d, omitTime) {
        let { dateEnv: dateEnv } = this.getCurrentData();
        return dateEnv.formatIso(dateEnv.createMarker(d), {
            omitTime: omitTime
        });
    }
    // Date Selection / Event Selection / DayClick
    // -----------------------------------------------------------------------------------------------------------------
    select(dateOrObj, endDate) {
        let selectionInput;
        if (endDate == null) {
            if (dateOrObj.start != null) selectionInput = dateOrObj;
            else selectionInput = {
                start: dateOrObj,
                end: null
            };
        } else selectionInput = {
            start: dateOrObj,
            end: endDate
        };
        let state = this.getCurrentData();
        let selection = $5913100b2ed0f596$var$parseDateSpan(selectionInput, state.dateEnv, $5913100b2ed0f596$export$4368d992c4eafac0({
            days: 1
        }));
        if (selection) {
            this.dispatch({
                type: "SELECT_DATES",
                selection: selection
            });
            $5913100b2ed0f596$export$9ddbdd0bfc5623a(selection, null, state);
        }
    }
    unselect(pev) {
        let state = this.getCurrentData();
        if (state.dateSelection) {
            this.dispatch({
                type: "UNSELECT_DATES"
            });
            $5913100b2ed0f596$var$triggerDateUnselect(pev, state);
        }
    }
    // Public Events API
    // -----------------------------------------------------------------------------------------------------------------
    addEvent(eventInput, sourceInput) {
        if (eventInput instanceof $5913100b2ed0f596$export$34aec0b863436764) {
            let def = eventInput._def;
            let instance = eventInput._instance;
            let currentData = this.getCurrentData();
            // not already present? don't want to add an old snapshot
            if (!currentData.eventStore.defs[def.defId]) {
                this.dispatch({
                    type: "ADD_EVENTS",
                    eventStore: $5913100b2ed0f596$export$9d0e2d13d04f7070({
                        def: def,
                        instance: instance
                    })
                });
                this.triggerEventAdd(eventInput);
            }
            return eventInput;
        }
        let state = this.getCurrentData();
        let eventSource;
        if (sourceInput instanceof $5913100b2ed0f596$var$EventSourceImpl) eventSource = sourceInput.internalEventSource;
        else if (typeof sourceInput === "boolean") {
            if (sourceInput) [eventSource] = $5913100b2ed0f596$export$90a7f3efeed30595(state.eventSources);
        } else if (sourceInput != null) {
            let sourceApi = this.getEventSourceById(sourceInput); // TODO: use an internal function
            if (!sourceApi) {
                console.warn(`Could not find an event source with ID "${sourceInput}"`); // TODO: test
                return null;
            }
            eventSource = sourceApi.internalEventSource;
        }
        let tuple = $5913100b2ed0f596$var$parseEvent(eventInput, eventSource, state, false);
        if (tuple) {
            let newEventApi = new $5913100b2ed0f596$export$34aec0b863436764(state, tuple.def, tuple.def.recurringDef ? null : tuple.instance);
            this.dispatch({
                type: "ADD_EVENTS",
                eventStore: $5913100b2ed0f596$export$9d0e2d13d04f7070(tuple)
            });
            this.triggerEventAdd(newEventApi);
            return newEventApi;
        }
        return null;
    }
    triggerEventAdd(eventApi) {
        let { emitter: emitter } = this.getCurrentData();
        emitter.trigger("eventAdd", {
            event: eventApi,
            relatedEvents: [],
            revert: ()=>{
                this.dispatch({
                    type: "REMOVE_EVENTS",
                    eventStore: $5913100b2ed0f596$var$eventApiToStore(eventApi)
                });
            }
        });
    }
    // TODO: optimize
    getEventById(id) {
        let state = this.getCurrentData();
        let { defs: defs, instances: instances } = state.eventStore;
        id = String(id);
        for(let defId in defs){
            let def = defs[defId];
            if (def.publicId === id) {
                if (def.recurringDef) return new $5913100b2ed0f596$export$34aec0b863436764(state, def, null);
                for(let instanceId in instances){
                    let instance = instances[instanceId];
                    if (instance.defId === def.defId) return new $5913100b2ed0f596$export$34aec0b863436764(state, def, instance);
                }
            }
        }
        return null;
    }
    getEvents() {
        let currentData = this.getCurrentData();
        return $5913100b2ed0f596$export$efccba1c4a2ef57b(currentData.eventStore, currentData);
    }
    removeAllEvents() {
        this.dispatch({
            type: "REMOVE_ALL_EVENTS"
        });
    }
    // Public Event Sources API
    // -----------------------------------------------------------------------------------------------------------------
    getEventSources() {
        let state = this.getCurrentData();
        let sourceHash = state.eventSources;
        let sourceApis = [];
        for(let internalId in sourceHash)sourceApis.push(new $5913100b2ed0f596$var$EventSourceImpl(state, sourceHash[internalId]));
        return sourceApis;
    }
    getEventSourceById(id) {
        let state = this.getCurrentData();
        let sourceHash = state.eventSources;
        id = String(id);
        for(let sourceId in sourceHash){
            if (sourceHash[sourceId].publicId === id) return new $5913100b2ed0f596$var$EventSourceImpl(state, sourceHash[sourceId]);
        }
        return null;
    }
    addEventSource(sourceInput) {
        let state = this.getCurrentData();
        if (sourceInput instanceof $5913100b2ed0f596$var$EventSourceImpl) {
            // not already present? don't want to add an old snapshot
            if (!state.eventSources[sourceInput.internalEventSource.sourceId]) this.dispatch({
                type: "ADD_EVENT_SOURCES",
                sources: [
                    sourceInput.internalEventSource
                ]
            });
            return sourceInput;
        }
        let eventSource = $5913100b2ed0f596$export$ffb5f4729a158638(sourceInput, state);
        if (eventSource) {
            this.dispatch({
                type: "ADD_EVENT_SOURCES",
                sources: [
                    eventSource
                ]
            });
            return new $5913100b2ed0f596$var$EventSourceImpl(state, eventSource);
        }
        return null;
    }
    removeAllEventSources() {
        this.dispatch({
            type: "REMOVE_ALL_EVENT_SOURCES"
        });
    }
    refetchEvents() {
        this.dispatch({
            type: "FETCH_EVENT_SOURCES",
            isRefetch: true
        });
    }
    // Scroll
    // -----------------------------------------------------------------------------------------------------------------
    scrollToTime(timeInput) {
        let time = $5913100b2ed0f596$export$4368d992c4eafac0(timeInput);
        if (time) this.trigger("_scrollRequest", {
            time: time
        });
    }
}
function $5913100b2ed0f596$export$cf2f7c5792f80b46(point, rect) {
    return point.left >= rect.left && point.left < rect.right && point.top >= rect.top && point.top < rect.bottom;
}
// Returns a new rectangle that is the intersection of the two rectangles. If they don't intersect, returns false
function $5913100b2ed0f596$export$158acd800e1ef08b(rect1, rect2) {
    let res = {
        left: Math.max(rect1.left, rect2.left),
        right: Math.min(rect1.right, rect2.right),
        top: Math.max(rect1.top, rect2.top),
        bottom: Math.min(rect1.bottom, rect2.bottom)
    };
    if (res.left < res.right && res.top < res.bottom) return res;
    return false;
}
function $5913100b2ed0f596$export$a05254e7c3aeba6e(rect, deltaX, deltaY) {
    return {
        left: rect.left + deltaX,
        right: rect.right + deltaX,
        top: rect.top + deltaY,
        bottom: rect.bottom + deltaY
    };
}
// Returns a new point that will have been moved to reside within the given rectangle
function $5913100b2ed0f596$export$53a70dd1ebbae346(point, rect) {
    return {
        left: Math.min(Math.max(point.left, rect.left), rect.right),
        top: Math.min(Math.max(point.top, rect.top), rect.bottom)
    };
}
// Returns a point that is the center of the given rectangle
function $5913100b2ed0f596$export$a33b77bbdbb8366c(rect) {
    return {
        left: (rect.left + rect.right) / 2,
        top: (rect.top + rect.bottom) / 2
    };
}
// Subtracts point2's coordinates from point1's coordinates, returning a delta
function $5913100b2ed0f596$export$b9a6b53f9be3734(point1, point2) {
    return {
        left: point1.left - point2.left,
        top: point1.top - point2.top
    };
}
const $5913100b2ed0f596$var$EMPTY_EVENT_STORE = $5913100b2ed0f596$export$9bb611d729802a56(); // for purecomponents. TODO: keep elsewhere
class $5913100b2ed0f596$export$e171bab687b50e0 {
    constructor(){
        this.getKeysForEventDefs = $5913100b2ed0f596$export$df995fae86a55f06(this._getKeysForEventDefs);
        this.splitDateSelection = $5913100b2ed0f596$export$df995fae86a55f06(this._splitDateSpan);
        this.splitEventStore = $5913100b2ed0f596$export$df995fae86a55f06(this._splitEventStore);
        this.splitIndividualUi = $5913100b2ed0f596$export$df995fae86a55f06(this._splitIndividualUi);
        this.splitEventDrag = $5913100b2ed0f596$export$df995fae86a55f06(this._splitInteraction);
        this.splitEventResize = $5913100b2ed0f596$export$df995fae86a55f06(this._splitInteraction);
        this.eventUiBuilders = {}; // TODO: typescript protection
    }
    splitProps(props) {
        let keyInfos = this.getKeyInfo(props);
        let defKeys = this.getKeysForEventDefs(props.eventStore);
        let dateSelections = this.splitDateSelection(props.dateSelection);
        let individualUi = this.splitIndividualUi(props.eventUiBases, defKeys); // the individual *bases*
        let eventStores = this.splitEventStore(props.eventStore, defKeys);
        let eventDrags = this.splitEventDrag(props.eventDrag);
        let eventResizes = this.splitEventResize(props.eventResize);
        let splitProps = {};
        this.eventUiBuilders = $5913100b2ed0f596$export$407448d2b89b1813(keyInfos, (info, key)=>this.eventUiBuilders[key] || $5913100b2ed0f596$export$df995fae86a55f06($5913100b2ed0f596$var$buildEventUiForKey));
        for(let key in keyInfos){
            let keyInfo = keyInfos[key];
            let eventStore = eventStores[key] || $5913100b2ed0f596$var$EMPTY_EVENT_STORE;
            let buildEventUi = this.eventUiBuilders[key];
            splitProps[key] = {
                businessHours: keyInfo.businessHours || props.businessHours,
                dateSelection: dateSelections[key] || null,
                eventStore: eventStore,
                eventUiBases: buildEventUi(props.eventUiBases[""], keyInfo.ui, individualUi[key]),
                eventSelection: eventStore.instances[props.eventSelection] ? props.eventSelection : "",
                eventDrag: eventDrags[key] || null,
                eventResize: eventResizes[key] || null
            };
        }
        return splitProps;
    }
    _splitDateSpan(dateSpan) {
        let dateSpans = {};
        if (dateSpan) {
            let keys = this.getKeysForDateSpan(dateSpan);
            for (let key of keys)dateSpans[key] = dateSpan;
        }
        return dateSpans;
    }
    _getKeysForEventDefs(eventStore) {
        return $5913100b2ed0f596$export$407448d2b89b1813(eventStore.defs, (eventDef)=>this.getKeysForEventDef(eventDef));
    }
    _splitEventStore(eventStore, defKeys) {
        let { defs: defs, instances: instances } = eventStore;
        let splitStores = {};
        for(let defId in defs)for (let key of defKeys[defId]){
            if (!splitStores[key]) splitStores[key] = $5913100b2ed0f596$export$9bb611d729802a56();
            splitStores[key].defs[defId] = defs[defId];
        }
        for(let instanceId in instances){
            let instance = instances[instanceId];
            for (let key of defKeys[instance.defId])if (splitStores[key]) splitStores[key].instances[instanceId] = instance;
        }
        return splitStores;
    }
    _splitIndividualUi(eventUiBases, defKeys) {
        let splitHashes = {};
        for(let defId in eventUiBases){
            if (defId) for (let key of defKeys[defId]){
                if (!splitHashes[key]) splitHashes[key] = {};
                splitHashes[key][defId] = eventUiBases[defId];
            }
        }
        return splitHashes;
    }
    _splitInteraction(interaction) {
        let splitStates = {};
        if (interaction) {
            let affectedStores = this._splitEventStore(interaction.affectedEvents, this._getKeysForEventDefs(interaction.affectedEvents));
            // can't rely on defKeys because event data is mutated
            let mutatedKeysByDefId = this._getKeysForEventDefs(interaction.mutatedEvents);
            let mutatedStores = this._splitEventStore(interaction.mutatedEvents, mutatedKeysByDefId);
            let populate = (key)=>{
                if (!splitStates[key]) splitStates[key] = {
                    affectedEvents: affectedStores[key] || $5913100b2ed0f596$var$EMPTY_EVENT_STORE,
                    mutatedEvents: mutatedStores[key] || $5913100b2ed0f596$var$EMPTY_EVENT_STORE,
                    isEvent: interaction.isEvent
                };
            };
            for(let key in affectedStores)populate(key);
            for(let key in mutatedStores)populate(key);
        }
        return splitStates;
    }
}
function $5913100b2ed0f596$var$buildEventUiForKey(allUi, eventUiForKey, individualUi) {
    let baseParts = [];
    if (allUi) baseParts.push(allUi);
    if (eventUiForKey) baseParts.push(eventUiForKey);
    let stuff = {
        "": $5913100b2ed0f596$export$1a8f5705751d8277(baseParts)
    };
    if (individualUi) Object.assign(stuff, individualUi);
    return stuff;
}
function $5913100b2ed0f596$export$a17c37559e1db147(date, todayRange, nowDate, dateProfile) {
    return {
        dow: date.getUTCDay(),
        isDisabled: Boolean(dateProfile && !$5913100b2ed0f596$export$7f8ddf7c7c20b3cd(dateProfile.activeRange, date)),
        isOther: Boolean(dateProfile && !$5913100b2ed0f596$export$7f8ddf7c7c20b3cd(dateProfile.currentRange, date)),
        isToday: Boolean(todayRange && $5913100b2ed0f596$export$7f8ddf7c7c20b3cd(todayRange, date)),
        isPast: Boolean(nowDate ? date < nowDate : todayRange ? date < todayRange.start : false),
        isFuture: Boolean(nowDate ? date > nowDate : todayRange ? date >= todayRange.end : false)
    };
}
function $5913100b2ed0f596$export$527e9aa3390079e9(meta, theme) {
    let classNames = [
        "fc-day",
        `fc-day-${$5913100b2ed0f596$var$DAY_IDS[meta.dow]}`
    ];
    if (meta.isDisabled) classNames.push("fc-day-disabled");
    else {
        if (meta.isToday) {
            classNames.push("fc-day-today");
            classNames.push(theme.getClass("today"));
        }
        if (meta.isPast) classNames.push("fc-day-past");
        if (meta.isFuture) classNames.push("fc-day-future");
        if (meta.isOther) classNames.push("fc-day-other");
    }
    return classNames;
}
function $5913100b2ed0f596$export$fef3dfd9bad05307(meta, theme) {
    let classNames = [
        "fc-slot",
        `fc-slot-${$5913100b2ed0f596$var$DAY_IDS[meta.dow]}`
    ];
    if (meta.isDisabled) classNames.push("fc-slot-disabled");
    else {
        if (meta.isToday) {
            classNames.push("fc-slot-today");
            classNames.push(theme.getClass("today"));
        }
        if (meta.isPast) classNames.push("fc-slot-past");
        if (meta.isFuture) classNames.push("fc-slot-future");
    }
    return classNames;
}
const $5913100b2ed0f596$var$DAY_FORMAT = $5913100b2ed0f596$export$d141bba7fdc215a3({
    year: "numeric",
    month: "long",
    day: "numeric"
});
const $5913100b2ed0f596$var$WEEK_FORMAT = $5913100b2ed0f596$export$d141bba7fdc215a3({
    week: "long"
});
function $5913100b2ed0f596$export$8c78c7c36408ea29(context, dateMarker, viewType = "day", isTabbable = true) {
    const { dateEnv: dateEnv, options: options, calendarApi: calendarApi } = context;
    let dateStr = dateEnv.format(dateMarker, viewType === "week" ? $5913100b2ed0f596$var$WEEK_FORMAT : $5913100b2ed0f596$var$DAY_FORMAT);
    if (options.navLinks) {
        let zonedDate = dateEnv.toDate(dateMarker);
        const handleInteraction = (ev)=>{
            let customAction = viewType === "day" ? options.navLinkDayClick : viewType === "week" ? options.navLinkWeekClick : null;
            if (typeof customAction === "function") customAction.call(calendarApi, dateEnv.toDate(dateMarker), ev);
            else {
                if (typeof customAction === "string") viewType = customAction;
                calendarApi.zoomTo(dateMarker, viewType);
            }
        };
        return Object.assign({
            title: $5913100b2ed0f596$export$342063e11d6c3cad(options.navLinkHint, [
                dateStr,
                zonedDate
            ], dateStr),
            "data-navlink": ""
        }, isTabbable ? $5913100b2ed0f596$var$createAriaClickAttrs(handleInteraction) : {
            onClick: handleInteraction
        });
    }
    return {
        "aria-label": dateStr
    };
}
let $5913100b2ed0f596$var$_isRtlScrollbarOnLeft = null;
function $5913100b2ed0f596$export$6735ce526161c7bd() {
    if ($5913100b2ed0f596$var$_isRtlScrollbarOnLeft === null) $5913100b2ed0f596$var$_isRtlScrollbarOnLeft = $5913100b2ed0f596$var$computeIsRtlScrollbarOnLeft();
    return $5913100b2ed0f596$var$_isRtlScrollbarOnLeft;
}
function $5913100b2ed0f596$var$computeIsRtlScrollbarOnLeft() {
    let outerEl = document.createElement("div");
    $5913100b2ed0f596$export$2ed0fc6709e59212(outerEl, {
        position: "absolute",
        top: -1000,
        left: 0,
        border: 0,
        padding: 0,
        overflow: "scroll",
        direction: "rtl"
    });
    outerEl.innerHTML = "<div></div>";
    document.body.appendChild(outerEl);
    let innerEl = outerEl.firstChild;
    let res = innerEl.getBoundingClientRect().left > outerEl.getBoundingClientRect().left;
    $5913100b2ed0f596$export$c03999cb2f36933f(outerEl);
    return res;
}
let $5913100b2ed0f596$var$_scrollbarWidths;
function $5913100b2ed0f596$export$c7ca7e4bc4f8a16e() {
    if (!$5913100b2ed0f596$var$_scrollbarWidths) $5913100b2ed0f596$var$_scrollbarWidths = $5913100b2ed0f596$var$computeScrollbarWidths();
    return $5913100b2ed0f596$var$_scrollbarWidths;
}
function $5913100b2ed0f596$var$computeScrollbarWidths() {
    let el = document.createElement("div");
    el.style.overflow = "scroll";
    el.style.position = "absolute";
    el.style.top = "-9999px";
    el.style.left = "-9999px";
    document.body.appendChild(el);
    let res = $5913100b2ed0f596$var$computeScrollbarWidthsForEl(el);
    document.body.removeChild(el);
    return res;
}
// WARNING: will include border
function $5913100b2ed0f596$var$computeScrollbarWidthsForEl(el) {
    return {
        x: el.offsetHeight - el.clientHeight,
        y: el.offsetWidth - el.clientWidth
    };
}
function $5913100b2ed0f596$export$39c1cc7c062529d4(el, getPadding = false) {
    let computedStyle = window.getComputedStyle(el);
    let borderLeft = parseInt(computedStyle.borderLeftWidth, 10) || 0;
    let borderRight = parseInt(computedStyle.borderRightWidth, 10) || 0;
    let borderTop = parseInt(computedStyle.borderTopWidth, 10) || 0;
    let borderBottom = parseInt(computedStyle.borderBottomWidth, 10) || 0;
    let badScrollbarWidths = $5913100b2ed0f596$var$computeScrollbarWidthsForEl(el); // includes border!
    let scrollbarLeftRight = badScrollbarWidths.y - borderLeft - borderRight;
    let scrollbarBottom = badScrollbarWidths.x - borderTop - borderBottom;
    let res = {
        borderLeft: borderLeft,
        borderRight: borderRight,
        borderTop: borderTop,
        borderBottom: borderBottom,
        scrollbarBottom: scrollbarBottom,
        scrollbarLeft: 0,
        scrollbarRight: 0
    };
    if ($5913100b2ed0f596$export$6735ce526161c7bd() && computedStyle.direction === "rtl") res.scrollbarLeft = scrollbarLeftRight;
    else res.scrollbarRight = scrollbarLeftRight;
    if (getPadding) {
        res.paddingLeft = parseInt(computedStyle.paddingLeft, 10) || 0;
        res.paddingRight = parseInt(computedStyle.paddingRight, 10) || 0;
        res.paddingTop = parseInt(computedStyle.paddingTop, 10) || 0;
        res.paddingBottom = parseInt(computedStyle.paddingBottom, 10) || 0;
    }
    return res;
}
function $5913100b2ed0f596$export$53c86fa97d611818(el, goWithinPadding = false, doFromWindowViewport) {
    let outerRect = doFromWindowViewport ? el.getBoundingClientRect() : $5913100b2ed0f596$export$c18d01048907ea92(el);
    let edges = $5913100b2ed0f596$export$39c1cc7c062529d4(el, goWithinPadding);
    let res = {
        left: outerRect.left + edges.borderLeft + edges.scrollbarLeft,
        right: outerRect.right - edges.borderRight - edges.scrollbarRight,
        top: outerRect.top + edges.borderTop,
        bottom: outerRect.bottom - edges.borderBottom - edges.scrollbarBottom
    };
    if (goWithinPadding) {
        res.left += edges.paddingLeft;
        res.right -= edges.paddingRight;
        res.top += edges.paddingTop;
        res.bottom -= edges.paddingBottom;
    }
    return res;
}
function $5913100b2ed0f596$export$c18d01048907ea92(el) {
    let rect = el.getBoundingClientRect();
    return {
        left: rect.left + window.scrollX,
        top: rect.top + window.scrollY,
        right: rect.right + window.scrollX,
        bottom: rect.bottom + window.scrollY
    };
}
function $5913100b2ed0f596$var$computeClippedClientRect(el) {
    let clippingParents = $5913100b2ed0f596$export$7a0bdf7d4a91ea88(el);
    let rect = el.getBoundingClientRect();
    for (let clippingParent of clippingParents){
        let intersection = $5913100b2ed0f596$export$158acd800e1ef08b(rect, clippingParent.getBoundingClientRect());
        if (intersection) rect = intersection;
        else return null;
    }
    return rect;
}
// does not return window
function $5913100b2ed0f596$export$7a0bdf7d4a91ea88(el) {
    let parents = [];
    while(el instanceof HTMLElement){
        let computedStyle = window.getComputedStyle(el);
        if (computedStyle.position === "fixed") break;
        if (/(auto|scroll)/.test(computedStyle.overflow + computedStyle.overflowY + computedStyle.overflowX)) parents.push(el);
        el = el.parentNode;
    }
    return parents;
}
/*
Records offset information for a set of elements, relative to an origin element.
Can record the left/right OR the top/bottom OR both.
Provides methods for querying the cache by position.
*/ class $5913100b2ed0f596$export$7060da4b5db56fb9 {
    constructor(originEl, els, isHorizontal, isVertical){
        this.els = els;
        let originClientRect = this.originClientRect = originEl.getBoundingClientRect(); // relative to viewport top-left
        if (isHorizontal) this.buildElHorizontals(originClientRect.left);
        if (isVertical) this.buildElVerticals(originClientRect.top);
    }
    // Populates the left/right internal coordinate arrays
    buildElHorizontals(originClientLeft) {
        let lefts = [];
        let rights = [];
        for (let el of this.els){
            let rect = el.getBoundingClientRect();
            lefts.push(rect.left - originClientLeft);
            rights.push(rect.right - originClientLeft);
        }
        this.lefts = lefts;
        this.rights = rights;
    }
    // Populates the top/bottom internal coordinate arrays
    buildElVerticals(originClientTop) {
        let tops = [];
        let bottoms = [];
        for (let el of this.els){
            let rect = el.getBoundingClientRect();
            tops.push(rect.top - originClientTop);
            bottoms.push(rect.bottom - originClientTop);
        }
        this.tops = tops;
        this.bottoms = bottoms;
    }
    // Given a left offset (from document left), returns the index of the el that it horizontally intersects.
    // If no intersection is made, returns undefined.
    leftToIndex(leftPosition) {
        let { lefts: lefts, rights: rights } = this;
        let len = lefts.length;
        let i;
        for(i = 0; i < len; i += 1){
            if (leftPosition >= lefts[i] && leftPosition < rights[i]) return i;
        }
        return undefined; // TODO: better
    }
    // Given a top offset (from document top), returns the index of the el that it vertically intersects.
    // If no intersection is made, returns undefined.
    topToIndex(topPosition) {
        let { tops: tops, bottoms: bottoms } = this;
        let len = tops.length;
        let i;
        for(i = 0; i < len; i += 1){
            if (topPosition >= tops[i] && topPosition < bottoms[i]) return i;
        }
        return undefined; // TODO: better
    }
    // Gets the width of the element at the given index
    getWidth(leftIndex) {
        return this.rights[leftIndex] - this.lefts[leftIndex];
    }
    // Gets the height of the element at the given index
    getHeight(topIndex) {
        return this.bottoms[topIndex] - this.tops[topIndex];
    }
    similarTo(otherCache) {
        return $5913100b2ed0f596$var$similarNumArrays(this.tops || [], otherCache.tops || []) && $5913100b2ed0f596$var$similarNumArrays(this.bottoms || [], otherCache.bottoms || []) && $5913100b2ed0f596$var$similarNumArrays(this.lefts || [], otherCache.lefts || []) && $5913100b2ed0f596$var$similarNumArrays(this.rights || [], otherCache.rights || []);
    }
}
function $5913100b2ed0f596$var$similarNumArrays(a, b) {
    const len = a.length;
    if (len !== b.length) return false;
    for(let i = 0; i < len; i++){
        if (Math.round(a[i]) !== Math.round(b[i])) return false;
    }
    return true;
}
/* eslint max-classes-per-file: "off" */ /*
An object for getting/setting scroll-related information for an element.
Internally, this is done very differently for window versus DOM element,
so this object serves as a common interface.
*/ class $5913100b2ed0f596$export$c5d1328b37d47994 {
    getMaxScrollTop() {
        return this.getScrollHeight() - this.getClientHeight();
    }
    getMaxScrollLeft() {
        return this.getScrollWidth() - this.getClientWidth();
    }
    canScrollVertically() {
        return this.getMaxScrollTop() > 0;
    }
    canScrollHorizontally() {
        return this.getMaxScrollLeft() > 0;
    }
    canScrollUp() {
        return this.getScrollTop() > 0;
    }
    canScrollDown() {
        return this.getScrollTop() < this.getMaxScrollTop();
    }
    canScrollLeft() {
        return this.getScrollLeft() > 0;
    }
    canScrollRight() {
        return this.getScrollLeft() < this.getMaxScrollLeft();
    }
}
class $5913100b2ed0f596$export$d22783b3c2400a3a extends $5913100b2ed0f596$export$c5d1328b37d47994 {
    constructor(el){
        super();
        this.el = el;
    }
    getScrollTop() {
        return this.el.scrollTop;
    }
    getScrollLeft() {
        return this.el.scrollLeft;
    }
    setScrollTop(top) {
        this.el.scrollTop = top;
    }
    setScrollLeft(left) {
        this.el.scrollLeft = left;
    }
    getScrollWidth() {
        return this.el.scrollWidth;
    }
    getScrollHeight() {
        return this.el.scrollHeight;
    }
    getClientHeight() {
        return this.el.clientHeight;
    }
    getClientWidth() {
        return this.el.clientWidth;
    }
}
class $5913100b2ed0f596$export$7f557e5eb95176c2 extends $5913100b2ed0f596$export$c5d1328b37d47994 {
    getScrollTop() {
        return window.scrollY;
    }
    getScrollLeft() {
        return window.scrollX;
    }
    setScrollTop(n) {
        window.scroll(window.scrollX, n);
    }
    setScrollLeft(n) {
        window.scroll(n, window.scrollY);
    }
    getScrollWidth() {
        return document.documentElement.scrollWidth;
    }
    getScrollHeight() {
        return document.documentElement.scrollHeight;
    }
    getClientHeight() {
        return document.documentElement.clientHeight;
    }
    getClientWidth() {
        return document.documentElement.clientWidth;
    }
}
/*
an INTERACTABLE date component

PURPOSES:
- hook up to fg, fill, and mirror renderers
- interface for dragging and hits
*/ class $5913100b2ed0f596$export$51b138e5a065c2bb extends $5913100b2ed0f596$export$ef35774e6d314e91 {
    constructor(){
        super(...arguments);
        this.uid = $5913100b2ed0f596$export$39b482c5e57630a8();
    }
    // Hit System
    // -----------------------------------------------------------------------------------------------------------------
    prepareHits() {}
    queryHit(positionLeft, positionTop, elWidth, elHeight) {
        return null; // this should be abstract
    }
    // Pointer Interaction Utils
    // -----------------------------------------------------------------------------------------------------------------
    isValidSegDownEl(el) {
        return !this.props.eventDrag && // HACK
        !this.props.eventResize && // HACK
        !$5913100b2ed0f596$export$3d8c2f653ac9d0b9(el, ".fc-event-mirror");
    }
    isValidDateDownEl(el) {
        return !$5913100b2ed0f596$export$3d8c2f653ac9d0b9(el, ".fc-event:not(.fc-bg-event)") && !$5913100b2ed0f596$export$3d8c2f653ac9d0b9(el, ".fc-more-link") && // a "more.." link
        !$5913100b2ed0f596$export$3d8c2f653ac9d0b9(el, "a[data-navlink]") && // a clickable nav link
        !$5913100b2ed0f596$export$3d8c2f653ac9d0b9(el, ".fc-popover"); // hack
    }
}
class $5913100b2ed0f596$export$766bf7dcfb630b6c {
    constructor(timeZoneName){
        this.timeZoneName = timeZoneName;
    }
}
class $5913100b2ed0f596$export$2e63b696b2c9441b {
    constructor(getEntryThickness = (entry)=>{
        // if no thickness known, assume 1 (if 0, so small it always fits)
        return entry.thickness || 1;
    }){
        this.getEntryThickness = getEntryThickness;
        // settings
        this.strictOrder = false;
        this.allowReslicing = false;
        this.maxCoord = -1; // -1 means no max
        this.maxStackCnt = -1; // -1 means no max
        this.levelCoords = []; // ordered
        this.entriesByLevel = []; // parallel with levelCoords
        this.stackCnts = {}; // TODO: use better technique!?
    }
    addSegs(inputs) {
        let hiddenEntries = [];
        for (let input of inputs)this.insertEntry(input, hiddenEntries);
        return hiddenEntries;
    }
    insertEntry(entry, hiddenEntries) {
        let insertion = this.findInsertion(entry);
        if (this.isInsertionValid(insertion, entry)) this.insertEntryAt(entry, insertion);
        else this.handleInvalidInsertion(insertion, entry, hiddenEntries);
    }
    isInsertionValid(insertion, entry) {
        return (this.maxCoord === -1 || insertion.levelCoord + this.getEntryThickness(entry) <= this.maxCoord) && (this.maxStackCnt === -1 || insertion.stackCnt < this.maxStackCnt);
    }
    handleInvalidInsertion(insertion, entry, hiddenEntries) {
        if (this.allowReslicing && insertion.touchingEntry) {
            const hiddenEntry = Object.assign(Object.assign({}, entry), {
                span: $5913100b2ed0f596$export$b2bcef12bcefba04(entry.span, insertion.touchingEntry.span)
            });
            hiddenEntries.push(hiddenEntry);
            this.splitEntry(entry, insertion.touchingEntry, hiddenEntries);
        } else hiddenEntries.push(entry);
    }
    /*
    Does NOT add what hit the `barrier` into hiddenEntries. Should already be done.
    */ splitEntry(entry, barrier, hiddenEntries) {
        let entrySpan = entry.span;
        let barrierSpan = barrier.span;
        if (entrySpan.start < barrierSpan.start) this.insertEntry({
            index: entry.index,
            thickness: entry.thickness,
            span: {
                start: entrySpan.start,
                end: barrierSpan.start
            }
        }, hiddenEntries);
        if (entrySpan.end > barrierSpan.end) this.insertEntry({
            index: entry.index,
            thickness: entry.thickness,
            span: {
                start: barrierSpan.end,
                end: entrySpan.end
            }
        }, hiddenEntries);
    }
    insertEntryAt(entry, insertion) {
        let { entriesByLevel: entriesByLevel, levelCoords: levelCoords } = this;
        if (insertion.lateral === -1) {
            // create a new level
            $5913100b2ed0f596$var$insertAt(levelCoords, insertion.level, insertion.levelCoord);
            $5913100b2ed0f596$var$insertAt(entriesByLevel, insertion.level, [
                entry
            ]);
        } else // insert into existing level
        $5913100b2ed0f596$var$insertAt(entriesByLevel[insertion.level], insertion.lateral, entry);
        this.stackCnts[$5913100b2ed0f596$export$eb84e45a33f6ba7c(entry)] = insertion.stackCnt;
    }
    /*
    does not care about limits
    */ findInsertion(newEntry) {
        let { levelCoords: levelCoords, entriesByLevel: entriesByLevel, strictOrder: strictOrder, stackCnts: stackCnts } = this;
        let levelCnt = levelCoords.length;
        let candidateCoord = 0;
        let touchingLevel = -1;
        let touchingLateral = -1;
        let touchingEntry = null;
        let stackCnt = 0;
        for(let trackingLevel = 0; trackingLevel < levelCnt; trackingLevel += 1){
            const trackingCoord = levelCoords[trackingLevel];
            // if the current level is past the placed entry, we have found a good empty space and can stop.
            // if strictOrder, keep finding more lateral intersections.
            if (!strictOrder && trackingCoord >= candidateCoord + this.getEntryThickness(newEntry)) break;
            let trackingEntries = entriesByLevel[trackingLevel];
            let trackingEntry;
            let searchRes = $5913100b2ed0f596$export$b0165a7e514844(trackingEntries, newEntry.span.start, $5913100b2ed0f596$export$d76842aa27385215); // find first entry after newEntry's end
            let lateralIndex = searchRes[0] + searchRes[1]; // if exact match (which doesn't collide), go to next one
            while((trackingEntry = trackingEntries[lateralIndex]) && // but not past the whole entry list
            trackingEntry.span.start < newEntry.span.end // and not entirely past newEntry
            ){
                let trackingEntryBottom = trackingCoord + this.getEntryThickness(trackingEntry);
                // intersects into the top of the candidate?
                if (trackingEntryBottom > candidateCoord) {
                    candidateCoord = trackingEntryBottom;
                    touchingEntry = trackingEntry;
                    touchingLevel = trackingLevel;
                    touchingLateral = lateralIndex;
                }
                // butts up against top of candidate? (will happen if just intersected as well)
                if (trackingEntryBottom === candidateCoord) // accumulate the highest possible stackCnt of the trackingEntries that butt up
                stackCnt = Math.max(stackCnt, stackCnts[$5913100b2ed0f596$export$eb84e45a33f6ba7c(trackingEntry)] + 1);
                lateralIndex += 1;
            }
        }
        // the destination level will be after touchingEntry's level. find it
        let destLevel = 0;
        if (touchingEntry) {
            destLevel = touchingLevel + 1;
            while(destLevel < levelCnt && levelCoords[destLevel] < candidateCoord)destLevel += 1;
        }
        // if adding to an existing level, find where to insert
        let destLateral = -1;
        if (destLevel < levelCnt && levelCoords[destLevel] === candidateCoord) destLateral = $5913100b2ed0f596$export$b0165a7e514844(entriesByLevel[destLevel], newEntry.span.end, $5913100b2ed0f596$export$d76842aa27385215)[0];
        return {
            touchingLevel: touchingLevel,
            touchingLateral: touchingLateral,
            touchingEntry: touchingEntry,
            stackCnt: stackCnt,
            levelCoord: candidateCoord,
            level: destLevel,
            lateral: destLateral
        };
    }
    // sorted by levelCoord (lowest to highest)
    toRects() {
        let { entriesByLevel: entriesByLevel, levelCoords: levelCoords } = this;
        let levelCnt = entriesByLevel.length;
        let rects = [];
        for(let level = 0; level < levelCnt; level += 1){
            let entries = entriesByLevel[level];
            let levelCoord = levelCoords[level];
            for (let entry of entries)rects.push(Object.assign(Object.assign({}, entry), {
                thickness: this.getEntryThickness(entry),
                levelCoord: levelCoord
            }));
        }
        return rects;
    }
}
function $5913100b2ed0f596$export$d76842aa27385215(entry) {
    return entry.span.end;
}
function $5913100b2ed0f596$export$eb84e45a33f6ba7c(entry) {
    return entry.index + ":" + entry.span.start;
}
// returns groups with entries sorted by input order
function $5913100b2ed0f596$export$381353cf1dd55255(entries) {
    let merges = [];
    for (let entry of entries){
        let filteredMerges = [];
        let hungryMerge = {
            span: entry.span,
            entries: [
                entry
            ]
        };
        for (let merge of merges)if ($5913100b2ed0f596$export$b2bcef12bcefba04(merge.span, hungryMerge.span)) hungryMerge = {
            entries: merge.entries.concat(hungryMerge.entries),
            span: $5913100b2ed0f596$var$joinSpans(merge.span, hungryMerge.span)
        };
        else filteredMerges.push(merge);
        filteredMerges.push(hungryMerge);
        merges = filteredMerges;
    }
    return merges;
}
function $5913100b2ed0f596$var$joinSpans(span0, span1) {
    return {
        start: Math.min(span0.start, span1.start),
        end: Math.max(span0.end, span1.end)
    };
}
function $5913100b2ed0f596$export$b2bcef12bcefba04(span0, span1) {
    let start = Math.max(span0.start, span1.start);
    let end = Math.min(span0.end, span1.end);
    if (start < end) return {
        start: start,
        end: end
    };
    return null;
}
// general util
// ---------------------------------------------------------------------------------------------------------------------
function $5913100b2ed0f596$var$insertAt(arr, index, item) {
    arr.splice(index, 0, item);
}
function $5913100b2ed0f596$export$b0165a7e514844(a, searchVal, getItemVal) {
    let startIndex = 0;
    let endIndex = a.length; // exclusive
    if (!endIndex || searchVal < getItemVal(a[startIndex])) return [
        0,
        0
    ];
    if (searchVal > getItemVal(a[endIndex - 1])) return [
        endIndex,
        0
    ];
    while(startIndex < endIndex){
        let middleIndex = Math.floor(startIndex + (endIndex - startIndex) / 2);
        let middleVal = getItemVal(a[middleIndex]);
        if (searchVal < middleVal) endIndex = middleIndex;
        else if (searchVal > middleVal) startIndex = middleIndex + 1;
        else return [
            middleIndex,
            1
        ];
    }
    return [
        startIndex,
        0
    ];
}
/*
An abstraction for a dragging interaction originating on an event.
Does higher-level things than PointerDragger, such as possibly:
- a "mirror" that moves with the pointer
- a minimum number of pixels or other criteria for a true drag to begin

subclasses must emit:
- pointerdown
- dragstart
- dragmove
- pointerup
- dragend
*/ class $5913100b2ed0f596$export$60bb826a6acf3081 {
    constructor(el, selector){
        this.emitter = new $5913100b2ed0f596$export$d66501df72047452();
    }
    destroy() {}
    setMirrorIsVisible(bool) {
    // optional if subclass doesn't want to support a mirror
    }
    setMirrorNeedsRevert(bool) {
    // optional if subclass doesn't want to support a mirror
    }
    setAutoScrollEnabled(bool) {
    // optional
    }
}
// TODO: get rid of this in favor of options system,
// tho it's really easy to access this globally rather than pass thru options.
const $5913100b2ed0f596$export$27d1aff6bea49709 = {};
/*
Information about what will happen when an external element is dragged-and-dropped
onto a calendar. Contains information for creating an event.
*/ const $5913100b2ed0f596$var$DRAG_META_REFINERS = {
    startTime: $5913100b2ed0f596$export$4368d992c4eafac0,
    duration: $5913100b2ed0f596$export$4368d992c4eafac0,
    create: Boolean,
    sourceId: String
};
function $5913100b2ed0f596$export$1abb261478089fe6(raw) {
    let { refined: refined, extra: extra } = $5913100b2ed0f596$export$f38c853ae54ed474(raw, $5913100b2ed0f596$var$DRAG_META_REFINERS);
    return {
        startTime: refined.startTime || null,
        duration: refined.duration || null,
        create: refined.create != null ? refined.create : true,
        sourceId: refined.sourceId,
        leftoverProps: extra
    };
}
// Computes a default column header formatting string if `colFormat` is not explicitly defined
function $5913100b2ed0f596$export$1ddf2d01943a3512(datesRepDistinctDays, dayCnt) {
    // if more than one week row, or if there are a lot of columns with not much space,
    // put just the day numbers will be in each cell
    if (!datesRepDistinctDays || dayCnt > 10) return $5913100b2ed0f596$export$d141bba7fdc215a3({
        weekday: "short"
    }); // "Sat"
    if (dayCnt > 1) return $5913100b2ed0f596$export$d141bba7fdc215a3({
        weekday: "short",
        month: "numeric",
        day: "numeric",
        omitCommas: true
    }); // "Sat 11/12"
    return $5913100b2ed0f596$export$d141bba7fdc215a3({
        weekday: "long"
    }); // "Saturday"
}
const $5913100b2ed0f596$var$CLASS_NAME = "fc-col-header-cell"; // do the cushion too? no
function $5913100b2ed0f596$var$renderInner$1(renderProps) {
    return renderProps.text;
}
// BAD name for this class now. used in the Header
class $5913100b2ed0f596$export$ebb8f7cd71856fb9 extends $5913100b2ed0f596$export$ef35774e6d314e91 {
    render() {
        let { dateEnv: dateEnv, options: options, theme: theme, viewApi: viewApi } = this.context;
        let { props: props } = this;
        let { date: date, dateProfile: dateProfile } = props;
        let dayMeta = $5913100b2ed0f596$export$a17c37559e1db147(date, props.todayRange, null, dateProfile);
        let classNames = [
            $5913100b2ed0f596$var$CLASS_NAME
        ].concat($5913100b2ed0f596$export$527e9aa3390079e9(dayMeta, theme));
        let text = dateEnv.format(date, props.dayHeaderFormat);
        // if colCnt is 1, we are already in a day-view and don't need a navlink
        let navLinkAttrs = !dayMeta.isDisabled && props.colCnt > 1 ? $5913100b2ed0f596$export$8c78c7c36408ea29(this.context, date) : {};
        let renderProps = Object.assign(Object.assign(Object.assign({
            date: dateEnv.toDate(date),
            view: viewApi
        }, props.extraRenderProps), {
            text: text
        }), dayMeta);
        return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)($5913100b2ed0f596$export$e7094788287c5e9b, {
            elTag: "th",
            elClasses: classNames,
            elAttrs: Object.assign({
                role: "columnheader",
                colSpan: props.colSpan,
                "data-date": !dayMeta.isDisabled ? $5913100b2ed0f596$export$5dbe06c6d8c68cfb(date) : undefined
            }, props.extraDataAttrs),
            renderProps: renderProps,
            generatorName: "dayHeaderContent",
            customGenerator: options.dayHeaderContent,
            defaultGenerator: $5913100b2ed0f596$var$renderInner$1,
            classNameGenerator: options.dayHeaderClassNames,
            didMount: options.dayHeaderDidMount,
            willUnmount: options.dayHeaderWillUnmount
        }, (InnerContainer)=>(0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("div", {
                className: "fc-scrollgrid-sync-inner"
            }, !dayMeta.isDisabled && (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)(InnerContainer, {
                elTag: "a",
                elAttrs: navLinkAttrs,
                elClasses: [
                    "fc-col-header-cell-cushion",
                    props.isSticky && "fc-sticky"
                ]
            })));
    }
}
const $5913100b2ed0f596$var$WEEKDAY_FORMAT = $5913100b2ed0f596$export$d141bba7fdc215a3({
    weekday: "long"
});
class $5913100b2ed0f596$export$45aabb5431c2d04f extends $5913100b2ed0f596$export$ef35774e6d314e91 {
    render() {
        let { props: props } = this;
        let { dateEnv: dateEnv, theme: theme, viewApi: viewApi, options: options } = this.context;
        let date = $5913100b2ed0f596$export$625550452a3fa3ec(new Date(259200000), props.dow); // start with Sun, 04 Jan 1970 00:00:00 GMT
        let dateMeta = {
            dow: props.dow,
            isDisabled: false,
            isFuture: false,
            isPast: false,
            isToday: false,
            isOther: false
        };
        let text = dateEnv.format(date, props.dayHeaderFormat);
        let renderProps = Object.assign(Object.assign(Object.assign(Object.assign({
            date: date
        }, dateMeta), {
            view: viewApi
        }), props.extraRenderProps), {
            text: text
        });
        return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)($5913100b2ed0f596$export$e7094788287c5e9b, {
            elTag: "th",
            elClasses: [
                $5913100b2ed0f596$var$CLASS_NAME,
                ...$5913100b2ed0f596$export$527e9aa3390079e9(dateMeta, theme),
                ...props.extraClassNames || []
            ],
            elAttrs: Object.assign({
                role: "columnheader",
                colSpan: props.colSpan
            }, props.extraDataAttrs),
            renderProps: renderProps,
            generatorName: "dayHeaderContent",
            customGenerator: options.dayHeaderContent,
            defaultGenerator: $5913100b2ed0f596$var$renderInner$1,
            classNameGenerator: options.dayHeaderClassNames,
            didMount: options.dayHeaderDidMount,
            willUnmount: options.dayHeaderWillUnmount
        }, (InnerContent)=>(0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("div", {
                className: "fc-scrollgrid-sync-inner"
            }, (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)(InnerContent, {
                elTag: "a",
                elClasses: [
                    "fc-col-header-cell-cushion",
                    props.isSticky && "fc-sticky"
                ],
                elAttrs: {
                    "aria-label": dateEnv.format(date, $5913100b2ed0f596$var$WEEKDAY_FORMAT)
                }
            })));
    }
}
class $5913100b2ed0f596$export$6e4b1d19c6e2e012 extends (0, $450fc775b2f7950e$export$16fa2f45be04daa8) {
    constructor(props, context){
        super(props, context);
        this.initialNowDate = $5913100b2ed0f596$export$c3950d9923825c02(context.options.now, context.dateEnv);
        this.initialNowQueriedMs = new Date().valueOf();
        this.state = this.computeTiming().currentState;
    }
    render() {
        let { props: props, state: state } = this;
        return props.children(state.nowDate, state.todayRange);
    }
    componentDidMount() {
        this.setTimeout();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.unit !== this.props.unit) {
            this.clearTimeout();
            this.setTimeout();
        }
    }
    componentWillUnmount() {
        this.clearTimeout();
    }
    computeTiming() {
        let { props: props, context: context } = this;
        let unroundedNow = $5913100b2ed0f596$export$136fd86de524d3c2(this.initialNowDate, new Date().valueOf() - this.initialNowQueriedMs);
        let currentUnitStart = context.dateEnv.startOf(unroundedNow, props.unit);
        let nextUnitStart = context.dateEnv.add(currentUnitStart, $5913100b2ed0f596$export$4368d992c4eafac0(1, props.unit));
        let waitMs = nextUnitStart.valueOf() - unroundedNow.valueOf();
        // there is a max setTimeout ms value (https://stackoverflow.com/a/3468650/96342)
        // ensure no longer than a day
        waitMs = Math.min(86400000, waitMs);
        return {
            currentState: {
                nowDate: currentUnitStart,
                todayRange: $5913100b2ed0f596$var$buildDayRange(currentUnitStart)
            },
            nextState: {
                nowDate: nextUnitStart,
                todayRange: $5913100b2ed0f596$var$buildDayRange(nextUnitStart)
            },
            waitMs: waitMs
        };
    }
    setTimeout() {
        let { nextState: nextState, waitMs: waitMs } = this.computeTiming();
        this.timeoutId = setTimeout(()=>{
            this.setState(nextState, ()=>{
                this.setTimeout();
            });
        }, waitMs);
    }
    clearTimeout() {
        if (this.timeoutId) clearTimeout(this.timeoutId);
    }
}
$5913100b2ed0f596$export$6e4b1d19c6e2e012.contextType = $5913100b2ed0f596$export$e7c866399fa523f5;
function $5913100b2ed0f596$var$buildDayRange(date) {
    let start = $5913100b2ed0f596$export$9e5f44173e64f162(date);
    let end = $5913100b2ed0f596$export$625550452a3fa3ec(start, 1);
    return {
        start: start,
        end: end
    };
}
class $5913100b2ed0f596$export$ebc5e65867841cbe extends $5913100b2ed0f596$export$ef35774e6d314e91 {
    constructor(){
        super(...arguments);
        this.createDayHeaderFormatter = $5913100b2ed0f596$export$df995fae86a55f06($5913100b2ed0f596$var$createDayHeaderFormatter);
    }
    render() {
        let { context: context } = this;
        let { dates: dates, dateProfile: dateProfile, datesRepDistinctDays: datesRepDistinctDays, renderIntro: renderIntro } = this.props;
        let dayHeaderFormat = this.createDayHeaderFormatter(context.options.dayHeaderFormat, datesRepDistinctDays, dates.length);
        return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)($5913100b2ed0f596$export$6e4b1d19c6e2e012, {
            unit: "day"
        }, (nowDate, todayRange)=>(0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("tr", {
                role: "row"
            }, renderIntro && renderIntro("day"), dates.map((date)=>datesRepDistinctDays ? (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)($5913100b2ed0f596$export$ebb8f7cd71856fb9, {
                    key: date.toISOString(),
                    date: date,
                    dateProfile: dateProfile,
                    todayRange: todayRange,
                    colCnt: dates.length,
                    dayHeaderFormat: dayHeaderFormat
                }) : (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)($5913100b2ed0f596$export$45aabb5431c2d04f, {
                    key: date.getUTCDay(),
                    dow: date.getUTCDay(),
                    dayHeaderFormat: dayHeaderFormat
                }))));
    }
}
function $5913100b2ed0f596$var$createDayHeaderFormatter(explicitFormat, datesRepDistinctDays, dateCnt) {
    return explicitFormat || $5913100b2ed0f596$export$1ddf2d01943a3512(datesRepDistinctDays, dateCnt);
}
class $5913100b2ed0f596$export$2538633961795d6b {
    constructor(range, dateProfileGenerator){
        let date = range.start;
        let { end: end } = range;
        let indices = [];
        let dates = [];
        let dayIndex = -1;
        while(date < end){
            if (dateProfileGenerator.isHiddenDay(date)) indices.push(dayIndex + 0.5); // mark that it's between indices
            else {
                dayIndex += 1;
                indices.push(dayIndex);
                dates.push(date);
            }
            date = $5913100b2ed0f596$export$625550452a3fa3ec(date, 1);
        }
        this.dates = dates;
        this.indices = indices;
        this.cnt = dates.length;
    }
    sliceRange(range) {
        let firstIndex = this.getDateDayIndex(range.start); // inclusive first index
        let lastIndex = this.getDateDayIndex($5913100b2ed0f596$export$625550452a3fa3ec(range.end, -1)); // inclusive last index
        let clippedFirstIndex = Math.max(0, firstIndex);
        let clippedLastIndex = Math.min(this.cnt - 1, lastIndex);
        // deal with in-between indices
        clippedFirstIndex = Math.ceil(clippedFirstIndex); // in-between starts round to next cell
        clippedLastIndex = Math.floor(clippedLastIndex); // in-between ends round to prev cell
        if (clippedFirstIndex <= clippedLastIndex) return {
            firstIndex: clippedFirstIndex,
            lastIndex: clippedLastIndex,
            isStart: firstIndex === clippedFirstIndex,
            isEnd: lastIndex === clippedLastIndex
        };
        return null;
    }
    // Given a date, returns its chronolocial cell-index from the first cell of the grid.
    // If the date lies between cells (because of hiddenDays), returns a floating-point value between offsets.
    // If before the first offset, returns a negative number.
    // If after the last offset, returns an offset past the last cell offset.
    // Only works for *start* dates of cells. Will not work for exclusive end dates for cells.
    getDateDayIndex(date) {
        let { indices: indices } = this;
        let dayOffset = Math.floor($5913100b2ed0f596$export$a36fb7d24305ed9d(this.dates[0], date));
        if (dayOffset < 0) return indices[0] - 1;
        if (dayOffset >= indices.length) return indices[indices.length - 1] + 1;
        return indices[dayOffset];
    }
}
class $5913100b2ed0f596$export$dabba94403d45c8e {
    constructor(daySeries, breakOnWeeks){
        let { dates: dates } = daySeries;
        let daysPerRow;
        let firstDay;
        let rowCnt;
        if (breakOnWeeks) {
            // count columns until the day-of-week repeats
            firstDay = dates[0].getUTCDay();
            for(daysPerRow = 1; daysPerRow < dates.length; daysPerRow += 1){
                if (dates[daysPerRow].getUTCDay() === firstDay) break;
            }
            rowCnt = Math.ceil(dates.length / daysPerRow);
        } else {
            rowCnt = 1;
            daysPerRow = dates.length;
        }
        this.rowCnt = rowCnt;
        this.colCnt = daysPerRow;
        this.daySeries = daySeries;
        this.cells = this.buildCells();
        this.headerDates = this.buildHeaderDates();
    }
    buildCells() {
        let rows = [];
        for(let row = 0; row < this.rowCnt; row += 1){
            let cells = [];
            for(let col = 0; col < this.colCnt; col += 1)cells.push(this.buildCell(row, col));
            rows.push(cells);
        }
        return rows;
    }
    buildCell(row, col) {
        let date = this.daySeries.dates[row * this.colCnt + col];
        return {
            key: date.toISOString(),
            date: date
        };
    }
    buildHeaderDates() {
        let dates = [];
        for(let col = 0; col < this.colCnt; col += 1)dates.push(this.cells[0][col].date);
        return dates;
    }
    sliceRange(range) {
        let { colCnt: colCnt } = this;
        let seriesSeg = this.daySeries.sliceRange(range);
        let segs = [];
        if (seriesSeg) {
            let { firstIndex: firstIndex, lastIndex: lastIndex } = seriesSeg;
            let index = firstIndex;
            while(index <= lastIndex){
                let row = Math.floor(index / colCnt);
                let nextIndex = Math.min((row + 1) * colCnt, lastIndex + 1);
                segs.push({
                    row: row,
                    firstCol: index % colCnt,
                    lastCol: (nextIndex - 1) % colCnt,
                    isStart: seriesSeg.isStart && index === firstIndex,
                    isEnd: seriesSeg.isEnd && nextIndex - 1 === lastIndex
                });
                index = nextIndex;
            }
        }
        return segs;
    }
}
class $5913100b2ed0f596$export$6b179bb11f7fd3a0 {
    constructor(){
        this.sliceBusinessHours = $5913100b2ed0f596$export$df995fae86a55f06(this._sliceBusinessHours);
        this.sliceDateSelection = $5913100b2ed0f596$export$df995fae86a55f06(this._sliceDateSpan);
        this.sliceEventStore = $5913100b2ed0f596$export$df995fae86a55f06(this._sliceEventStore);
        this.sliceEventDrag = $5913100b2ed0f596$export$df995fae86a55f06(this._sliceInteraction);
        this.sliceEventResize = $5913100b2ed0f596$export$df995fae86a55f06(this._sliceInteraction);
        this.forceDayIfListItem = false; // hack
    }
    sliceProps(props, dateProfile, nextDayThreshold, context, ...extraArgs) {
        let { eventUiBases: eventUiBases } = props;
        let eventSegs = this.sliceEventStore(props.eventStore, eventUiBases, dateProfile, nextDayThreshold, ...extraArgs);
        return {
            dateSelectionSegs: this.sliceDateSelection(props.dateSelection, dateProfile, nextDayThreshold, eventUiBases, context, ...extraArgs),
            businessHourSegs: this.sliceBusinessHours(props.businessHours, dateProfile, nextDayThreshold, context, ...extraArgs),
            fgEventSegs: eventSegs.fg,
            bgEventSegs: eventSegs.bg,
            eventDrag: this.sliceEventDrag(props.eventDrag, eventUiBases, dateProfile, nextDayThreshold, ...extraArgs),
            eventResize: this.sliceEventResize(props.eventResize, eventUiBases, dateProfile, nextDayThreshold, ...extraArgs),
            eventSelection: props.eventSelection
        }; // TODO: give interactionSegs?
    }
    sliceNowDate(date, dateProfile, nextDayThreshold, context, ...extraArgs) {
        return this._sliceDateSpan({
            range: {
                start: date,
                end: $5913100b2ed0f596$export$136fd86de524d3c2(date, 1)
            },
            allDay: false
        }, dateProfile, nextDayThreshold, {}, context, ...extraArgs);
    }
    _sliceBusinessHours(businessHours, dateProfile, nextDayThreshold, context, ...extraArgs) {
        if (!businessHours) return [];
        return this._sliceEventStore($5913100b2ed0f596$var$expandRecurring(businessHours, $5913100b2ed0f596$var$computeActiveRange(dateProfile, Boolean(nextDayThreshold)), context), {}, dateProfile, nextDayThreshold, ...extraArgs).bg;
    }
    _sliceEventStore(eventStore, eventUiBases, dateProfile, nextDayThreshold, ...extraArgs) {
        if (eventStore) {
            let rangeRes = $5913100b2ed0f596$export$c9170ad7d4cd7e57(eventStore, eventUiBases, $5913100b2ed0f596$var$computeActiveRange(dateProfile, Boolean(nextDayThreshold)), nextDayThreshold);
            return {
                bg: this.sliceEventRanges(rangeRes.bg, extraArgs),
                fg: this.sliceEventRanges(rangeRes.fg, extraArgs)
            };
        }
        return {
            bg: [],
            fg: []
        };
    }
    _sliceInteraction(interaction, eventUiBases, dateProfile, nextDayThreshold, ...extraArgs) {
        if (!interaction) return null;
        let rangeRes = $5913100b2ed0f596$export$c9170ad7d4cd7e57(interaction.mutatedEvents, eventUiBases, $5913100b2ed0f596$var$computeActiveRange(dateProfile, Boolean(nextDayThreshold)), nextDayThreshold);
        return {
            segs: this.sliceEventRanges(rangeRes.fg, extraArgs),
            affectedInstances: interaction.affectedEvents.instances,
            isEvent: interaction.isEvent
        };
    }
    _sliceDateSpan(dateSpan, dateProfile, nextDayThreshold, eventUiBases, context, ...extraArgs) {
        if (!dateSpan) return [];
        let activeRange = $5913100b2ed0f596$var$computeActiveRange(dateProfile, Boolean(nextDayThreshold));
        let activeDateSpanRange = $5913100b2ed0f596$export$ae1af26003f05816(dateSpan.range, activeRange);
        if (activeDateSpanRange) {
            dateSpan = Object.assign(Object.assign({}, dateSpan), {
                range: activeDateSpanRange
            });
            let eventRange = $5913100b2ed0f596$var$fabricateEventRange(dateSpan, eventUiBases, context);
            let segs = this.sliceRange(dateSpan.range, ...extraArgs);
            for (let seg of segs)seg.eventRange = eventRange;
            return segs;
        }
        return [];
    }
    /*
    "complete" seg means it has component and eventRange
    */ sliceEventRanges(eventRanges, extraArgs) {
        let segs = [];
        for (let eventRange of eventRanges)segs.push(...this.sliceEventRange(eventRange, extraArgs));
        return segs;
    }
    /*
    "complete" seg means it has component and eventRange
    */ sliceEventRange(eventRange, extraArgs) {
        let dateRange = eventRange.range;
        // hack to make multi-day events that are being force-displayed as list-items to take up only one day
        if (this.forceDayIfListItem && eventRange.ui.display === "list-item") dateRange = {
            start: dateRange.start,
            end: $5913100b2ed0f596$export$625550452a3fa3ec(dateRange.start, 1)
        };
        let segs = this.sliceRange(dateRange, ...extraArgs);
        for (let seg of segs){
            seg.eventRange = eventRange;
            seg.isStart = eventRange.isStart && seg.isStart;
            seg.isEnd = eventRange.isEnd && seg.isEnd;
        }
        return segs;
    }
}
/*
for incorporating slotMinTime/slotMaxTime if appropriate
TODO: should be part of DateProfile!
TimelineDateProfile already does this btw
*/ function $5913100b2ed0f596$var$computeActiveRange(dateProfile, isComponentAllDay) {
    let range = dateProfile.activeRange;
    if (isComponentAllDay) return range;
    return {
        start: $5913100b2ed0f596$export$136fd86de524d3c2(range.start, dateProfile.slotMinTime.milliseconds),
        end: $5913100b2ed0f596$export$136fd86de524d3c2(range.end, dateProfile.slotMaxTime.milliseconds - 864e5)
    };
}
// high-level segmenting-aware tester functions
// ------------------------------------------------------------------------------------------------------------------------
function $5913100b2ed0f596$export$c667925124dac624(interaction, dateProfile, context) {
    let { instances: instances } = interaction.mutatedEvents;
    for(let instanceId in instances){
        if (!$5913100b2ed0f596$export$4ae495d48253603d(dateProfile.validRange, instances[instanceId].range)) return false;
    }
    return $5913100b2ed0f596$var$isNewPropsValid({
        eventDrag: interaction
    }, context); // HACK: the eventDrag props is used for ALL interactions
}
function $5913100b2ed0f596$export$c69d65aa55814164(dateSelection, dateProfile, context) {
    if (!$5913100b2ed0f596$export$4ae495d48253603d(dateProfile.validRange, dateSelection.range)) return false;
    return $5913100b2ed0f596$var$isNewPropsValid({
        dateSelection: dateSelection
    }, context);
}
function $5913100b2ed0f596$var$isNewPropsValid(newProps, context) {
    let calendarState = context.getCurrentData();
    let props = Object.assign({
        businessHours: calendarState.businessHours,
        dateSelection: "",
        eventStore: calendarState.eventStore,
        eventUiBases: calendarState.eventUiBases,
        eventSelection: "",
        eventDrag: null,
        eventResize: null
    }, newProps);
    return (context.pluginHooks.isPropsValid || $5913100b2ed0f596$export$545a72cc0d3f00b0)(props, context);
}
function $5913100b2ed0f596$export$545a72cc0d3f00b0(state, context, dateSpanMeta = {}, filterConfig) {
    if (state.eventDrag && !$5913100b2ed0f596$var$isInteractionPropsValid(state, context, dateSpanMeta, filterConfig)) return false;
    if (state.dateSelection && !$5913100b2ed0f596$var$isDateSelectionPropsValid(state, context, dateSpanMeta, filterConfig)) return false;
    return true;
}
// Moving Event Validation
// ------------------------------------------------------------------------------------------------------------------------
function $5913100b2ed0f596$var$isInteractionPropsValid(state, context, dateSpanMeta, filterConfig) {
    let currentState = context.getCurrentData();
    let interaction = state.eventDrag; // HACK: the eventDrag props is used for ALL interactions
    let subjectEventStore = interaction.mutatedEvents;
    let subjectDefs = subjectEventStore.defs;
    let subjectInstances = subjectEventStore.instances;
    let subjectConfigs = $5913100b2ed0f596$var$compileEventUis(subjectDefs, interaction.isEvent ? state.eventUiBases : {
        "": currentState.selectionConfig
    });
    if (filterConfig) subjectConfigs = $5913100b2ed0f596$export$407448d2b89b1813(subjectConfigs, filterConfig);
    // exclude the subject events. TODO: exclude defs too?
    let otherEventStore = $5913100b2ed0f596$var$excludeInstances(state.eventStore, interaction.affectedEvents.instances);
    let otherDefs = otherEventStore.defs;
    let otherInstances = otherEventStore.instances;
    let otherConfigs = $5913100b2ed0f596$var$compileEventUis(otherDefs, state.eventUiBases);
    for(let subjectInstanceId in subjectInstances){
        let subjectInstance = subjectInstances[subjectInstanceId];
        let subjectRange = subjectInstance.range;
        let subjectConfig = subjectConfigs[subjectInstance.defId];
        let subjectDef = subjectDefs[subjectInstance.defId];
        // constraint
        if (!$5913100b2ed0f596$var$allConstraintsPass(subjectConfig.constraints, subjectRange, otherEventStore, state.businessHours, context)) return false;
        // overlap
        let { eventOverlap: eventOverlap } = context.options;
        let eventOverlapFunc = typeof eventOverlap === "function" ? eventOverlap : null;
        for(let otherInstanceId in otherInstances){
            let otherInstance = otherInstances[otherInstanceId];
            // intersect! evaluate
            if ($5913100b2ed0f596$export$ad4aebacdcaf47f8(subjectRange, otherInstance.range)) {
                let otherOverlap = otherConfigs[otherInstance.defId].overlap;
                // consider the other event's overlap. only do this if the subject event is a "real" event
                if (otherOverlap === false && interaction.isEvent) return false;
                if (subjectConfig.overlap === false) return false;
                if (eventOverlapFunc && !eventOverlapFunc(new $5913100b2ed0f596$export$34aec0b863436764(context, otherDefs[otherInstance.defId], otherInstance), new $5913100b2ed0f596$export$34aec0b863436764(context, subjectDef, subjectInstance))) return false;
            }
        }
        // allow (a function)
        let calendarEventStore = currentState.eventStore; // need global-to-calendar, not local to component (splittable)state
        for (let subjectAllow of subjectConfig.allows){
            let subjectDateSpan = Object.assign(Object.assign({}, dateSpanMeta), {
                range: subjectInstance.range,
                allDay: subjectDef.allDay
            });
            let origDef = calendarEventStore.defs[subjectDef.defId];
            let origInstance = calendarEventStore.instances[subjectInstanceId];
            let eventApi;
            if (origDef) eventApi = new $5913100b2ed0f596$export$34aec0b863436764(context, origDef, origInstance);
            else eventApi = new $5913100b2ed0f596$export$34aec0b863436764(context, subjectDef); // no instance, because had no dates
            if (!subjectAllow($5913100b2ed0f596$var$buildDateSpanApiWithContext(subjectDateSpan, context), eventApi)) return false;
        }
    }
    return true;
}
// Date Selection Validation
// ------------------------------------------------------------------------------------------------------------------------
function $5913100b2ed0f596$var$isDateSelectionPropsValid(state, context, dateSpanMeta, filterConfig) {
    let relevantEventStore = state.eventStore;
    let relevantDefs = relevantEventStore.defs;
    let relevantInstances = relevantEventStore.instances;
    let selection = state.dateSelection;
    let selectionRange = selection.range;
    let { selectionConfig: selectionConfig } = context.getCurrentData();
    if (filterConfig) selectionConfig = filterConfig(selectionConfig);
    // constraint
    if (!$5913100b2ed0f596$var$allConstraintsPass(selectionConfig.constraints, selectionRange, relevantEventStore, state.businessHours, context)) return false;
    // overlap
    let { selectOverlap: selectOverlap } = context.options;
    let selectOverlapFunc = typeof selectOverlap === "function" ? selectOverlap : null;
    for(let relevantInstanceId in relevantInstances){
        let relevantInstance = relevantInstances[relevantInstanceId];
        // intersect! evaluate
        if ($5913100b2ed0f596$export$ad4aebacdcaf47f8(selectionRange, relevantInstance.range)) {
            if (selectionConfig.overlap === false) return false;
            if (selectOverlapFunc && !selectOverlapFunc(new $5913100b2ed0f596$export$34aec0b863436764(context, relevantDefs[relevantInstance.defId], relevantInstance), null)) return false;
        }
    }
    // allow (a function)
    for (let selectionAllow of selectionConfig.allows){
        let fullDateSpan = Object.assign(Object.assign({}, dateSpanMeta), selection);
        if (!selectionAllow($5913100b2ed0f596$var$buildDateSpanApiWithContext(fullDateSpan, context), null)) return false;
    }
    return true;
}
// Constraint Utils
// ------------------------------------------------------------------------------------------------------------------------
function $5913100b2ed0f596$var$allConstraintsPass(constraints, subjectRange, otherEventStore, businessHoursUnexpanded, context) {
    for (let constraint of constraints){
        if (!$5913100b2ed0f596$var$anyRangesContainRange($5913100b2ed0f596$var$constraintToRanges(constraint, subjectRange, otherEventStore, businessHoursUnexpanded, context), subjectRange)) return false;
    }
    return true;
}
function $5913100b2ed0f596$var$constraintToRanges(constraint, subjectRange, otherEventStore, businessHoursUnexpanded, context) {
    if (constraint === "businessHours") return $5913100b2ed0f596$var$eventStoreToRanges($5913100b2ed0f596$var$expandRecurring(businessHoursUnexpanded, subjectRange, context));
    if (typeof constraint === "string") return $5913100b2ed0f596$var$eventStoreToRanges($5913100b2ed0f596$var$filterEventStoreDefs(otherEventStore, (eventDef)=>eventDef.groupId === constraint));
    if (typeof constraint === "object" && constraint) return $5913100b2ed0f596$var$eventStoreToRanges($5913100b2ed0f596$var$expandRecurring(constraint, subjectRange, context));
    return []; // if it's false
}
// TODO: move to event-store file?
function $5913100b2ed0f596$var$eventStoreToRanges(eventStore) {
    let { instances: instances } = eventStore;
    let ranges = [];
    for(let instanceId in instances)ranges.push(instances[instanceId].range);
    return ranges;
}
// TODO: move to geom file?
function $5913100b2ed0f596$var$anyRangesContainRange(outerRanges, innerRange) {
    for (let outerRange of outerRanges){
        if ($5913100b2ed0f596$export$4ae495d48253603d(outerRange, innerRange)) return true;
    }
    return false;
}
const $5913100b2ed0f596$var$VISIBLE_HIDDEN_RE = /^(visible|hidden)$/;
class $5913100b2ed0f596$export$807f1ba34db587c7 extends $5913100b2ed0f596$export$ef35774e6d314e91 {
    constructor(){
        super(...arguments);
        this.handleEl = (el)=>{
            this.el = el;
            $5913100b2ed0f596$export$8743009a87fcb00f(this.props.elRef, el);
        };
    }
    render() {
        let { props: props } = this;
        let { liquid: liquid, liquidIsAbsolute: liquidIsAbsolute } = props;
        let isAbsolute = liquid && liquidIsAbsolute;
        let className = [
            "fc-scroller"
        ];
        if (liquid) {
            if (liquidIsAbsolute) className.push("fc-scroller-liquid-absolute");
            else className.push("fc-scroller-liquid");
        }
        return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("div", {
            ref: this.handleEl,
            className: className.join(" "),
            style: {
                overflowX: props.overflowX,
                overflowY: props.overflowY,
                left: isAbsolute && -(props.overcomeLeft || 0) || "",
                right: isAbsolute && -(props.overcomeRight || 0) || "",
                bottom: isAbsolute && -(props.overcomeBottom || 0) || "",
                marginLeft: !isAbsolute && -(props.overcomeLeft || 0) || "",
                marginRight: !isAbsolute && -(props.overcomeRight || 0) || "",
                marginBottom: !isAbsolute && -(props.overcomeBottom || 0) || "",
                maxHeight: props.maxHeight || ""
            }
        }, props.children);
    }
    needsXScrolling() {
        if ($5913100b2ed0f596$var$VISIBLE_HIDDEN_RE.test(this.props.overflowX)) return false;
        // testing scrollWidth>clientWidth is unreliable cross-browser when pixel heights aren't integers.
        // much more reliable to see if children are taller than the scroller, even tho doesn't account for
        // inner-child margins and absolute positioning
        let { el: el } = this;
        let realClientWidth = this.el.getBoundingClientRect().width - this.getYScrollbarWidth();
        let { children: children } = el;
        for(let i = 0; i < children.length; i += 1){
            let childEl = children[i];
            if (childEl.getBoundingClientRect().width > realClientWidth) return true;
        }
        return false;
    }
    needsYScrolling() {
        if ($5913100b2ed0f596$var$VISIBLE_HIDDEN_RE.test(this.props.overflowY)) return false;
        // testing scrollHeight>clientHeight is unreliable cross-browser when pixel heights aren't integers.
        // much more reliable to see if children are taller than the scroller, even tho doesn't account for
        // inner-child margins and absolute positioning
        let { el: el } = this;
        let realClientHeight = this.el.getBoundingClientRect().height - this.getXScrollbarWidth();
        let { children: children } = el;
        for(let i = 0; i < children.length; i += 1){
            let childEl = children[i];
            if (childEl.getBoundingClientRect().height > realClientHeight) return true;
        }
        return false;
    }
    getXScrollbarWidth() {
        if ($5913100b2ed0f596$var$VISIBLE_HIDDEN_RE.test(this.props.overflowX)) return 0;
        return this.el.offsetHeight - this.el.clientHeight; // only works because we guarantee no borders. TODO: add to CSS with important?
    }
    getYScrollbarWidth() {
        if ($5913100b2ed0f596$var$VISIBLE_HIDDEN_RE.test(this.props.overflowY)) return 0;
        return this.el.offsetWidth - this.el.clientWidth; // only works because we guarantee no borders. TODO: add to CSS with important?
    }
}
/*
TODO: somehow infer OtherArgs from masterCallback?
TODO: infer RefType from masterCallback if provided
*/ class $5913100b2ed0f596$export$49e6ee724f7f1ace {
    constructor(masterCallback){
        this.masterCallback = masterCallback;
        this.currentMap = {};
        this.depths = {};
        this.callbackMap = {};
        this.handleValue = (val, key)=>{
            let { depths: depths, currentMap: currentMap } = this;
            let removed = false;
            let added = false;
            if (val !== null) {
                // for bug... ACTUALLY: can probably do away with this now that callers don't share numeric indices anymore
                removed = key in currentMap;
                currentMap[key] = val;
                depths[key] = (depths[key] || 0) + 1;
                added = true;
            } else {
                depths[key] -= 1;
                if (!depths[key]) {
                    delete currentMap[key];
                    delete this.callbackMap[key];
                    removed = true;
                }
            }
            if (this.masterCallback) {
                if (removed) this.masterCallback(null, String(key));
                if (added) this.masterCallback(val, String(key));
            }
        };
    }
    createRef(key) {
        let refCallback = this.callbackMap[key];
        if (!refCallback) refCallback = this.callbackMap[key] = (val)=>{
            this.handleValue(val, String(key));
        };
        return refCallback;
    }
    // TODO: check callers that don't care about order. should use getAll instead
    // NOTE: this method has become less valuable now that we are encouraged to map order by some other index
    // TODO: provide ONE array-export function, buildArray, which fails on non-numeric indexes. caller can manipulate and "collect"
    collect(startIndex, endIndex, step) {
        return $5913100b2ed0f596$export$91477dc880baac21(this.currentMap, startIndex, endIndex, step);
    }
    getAll() {
        return $5913100b2ed0f596$export$90a7f3efeed30595(this.currentMap);
    }
}
function $5913100b2ed0f596$export$f5339a28e56d1baf(chunkEls) {
    let shrinkCells = $5913100b2ed0f596$export$9f4f30ee63539e24(chunkEls, ".fc-scrollgrid-shrink");
    let largestWidth = 0;
    for (let shrinkCell of shrinkCells)largestWidth = Math.max(largestWidth, $5913100b2ed0f596$var$computeSmallestCellWidth(shrinkCell));
    return Math.ceil(largestWidth); // <table> elements work best with integers. round up to ensure contents fits
}
function $5913100b2ed0f596$export$4f33f238a5c1ad77(props, sectionConfig) {
    return props.liquid && sectionConfig.liquid; // does the section do liquid-height? (need to have whole scrollgrid liquid-height as well)
}
function $5913100b2ed0f596$export$7fe88b5920ffddd2(props, sectionConfig) {
    return sectionConfig.maxHeight != null || // if its possible for the height to max out, we might need scrollbars
    $5913100b2ed0f596$export$4f33f238a5c1ad77(props, sectionConfig); // if the section is liquid height, it might condense enough to require scrollbars
}
// TODO: ONLY use `arg`. force out internal function to use same API
function $5913100b2ed0f596$export$df7c425476ed4f2(sectionConfig, chunkConfig, arg, isHeader) {
    let { expandRows: expandRows } = arg;
    let content = typeof chunkConfig.content === "function" ? chunkConfig.content(arg) : (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("table", {
        role: "presentation",
        className: [
            chunkConfig.tableClassName,
            sectionConfig.syncRowHeights ? "fc-scrollgrid-sync-table" : ""
        ].join(" "),
        style: {
            minWidth: arg.tableMinWidth,
            width: arg.clientWidth,
            height: expandRows ? arg.clientHeight : ""
        }
    }, arg.tableColGroupNode, (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)(isHeader ? "thead" : "tbody", {
        role: "presentation"
    }, typeof chunkConfig.rowContent === "function" ? chunkConfig.rowContent(arg) : chunkConfig.rowContent));
    return content;
}
function $5913100b2ed0f596$export$4ad369a19af21c23(cols0, cols1) {
    return $5913100b2ed0f596$export$23f2a1d2818174ef(cols0, cols1, $5913100b2ed0f596$export$a9c23c6ac3fc3eca);
}
function $5913100b2ed0f596$export$101619b11a34a0bd(cols, shrinkWidth) {
    let colNodes = [];
    /*
    for ColProps with spans, it would have been great to make a single <col span="">
    HOWEVER, Chrome was getting messing up distributing the width to <td>/<th> elements with colspans.
    SOLUTION: making individual <col> elements makes Chrome behave.
    */ for (let colProps of cols){
        let span = colProps.span || 1;
        for(let i = 0; i < span; i += 1)colNodes.push((0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("col", {
            style: {
                width: colProps.width === "shrink" ? $5913100b2ed0f596$export$1ec7a8278ebd1290(shrinkWidth) : colProps.width || "",
                minWidth: colProps.minWidth || ""
            }
        }));
    }
    return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("colgroup", {}, ...colNodes);
}
function $5913100b2ed0f596$export$1ec7a8278ebd1290(shrinkWidth) {
    /* why 4? if we do 0, it will kill any border, which are needed for computeSmallestCellWidth
    4 accounts for 2 2-pixel borders. TODO: better solution? */ return shrinkWidth == null ? 4 : shrinkWidth;
}
function $5913100b2ed0f596$export$65ab0ebced932b79(cols) {
    for (let col of cols){
        if (col.width === "shrink") return true;
    }
    return false;
}
function $5913100b2ed0f596$export$60e660859c376841(liquid, context) {
    let classNames = [
        "fc-scrollgrid",
        context.theme.getClass("table")
    ];
    if (liquid) classNames.push("fc-scrollgrid-liquid");
    return classNames;
}
function $5913100b2ed0f596$export$df838d0240c938cf(sectionConfig, wholeTableVGrow) {
    let classNames = [
        "fc-scrollgrid-section",
        `fc-scrollgrid-section-${sectionConfig.type}`,
        sectionConfig.className
    ];
    if (wholeTableVGrow && sectionConfig.liquid && sectionConfig.maxHeight == null) classNames.push("fc-scrollgrid-section-liquid");
    if (sectionConfig.isSticky) classNames.push("fc-scrollgrid-section-sticky");
    return classNames;
}
function $5913100b2ed0f596$export$89e9012e902952b6(arg) {
    return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("div", {
        className: "fc-scrollgrid-sticky-shim",
        style: {
            width: arg.clientWidth,
            minWidth: arg.tableMinWidth
        }
    });
}
function $5913100b2ed0f596$export$a1edd97dd51cd48d(options) {
    let { stickyHeaderDates: stickyHeaderDates } = options;
    if (stickyHeaderDates == null || stickyHeaderDates === "auto") stickyHeaderDates = options.height === "auto" || options.viewHeight === "auto";
    return stickyHeaderDates;
}
function $5913100b2ed0f596$export$54c4fabc2291e9c0(options) {
    let { stickyFooterScrollbar: stickyFooterScrollbar } = options;
    if (stickyFooterScrollbar == null || stickyFooterScrollbar === "auto") stickyFooterScrollbar = options.height === "auto" || options.viewHeight === "auto";
    return stickyFooterScrollbar;
}
class $5913100b2ed0f596$export$add49c223b9ce4ea extends $5913100b2ed0f596$export$ef35774e6d314e91 {
    constructor(){
        super(...arguments);
        this.processCols = $5913100b2ed0f596$export$df995fae86a55f06((a)=>a, $5913100b2ed0f596$export$4ad369a19af21c23); // so we get same `cols` props every time
        // yucky to memoize VNodes, but much more efficient for consumers
        this.renderMicroColGroup = $5913100b2ed0f596$export$df995fae86a55f06($5913100b2ed0f596$export$101619b11a34a0bd);
        this.scrollerRefs = new $5913100b2ed0f596$export$49e6ee724f7f1ace();
        this.scrollerElRefs = new $5913100b2ed0f596$export$49e6ee724f7f1ace(this._handleScrollerEl.bind(this));
        this.state = {
            shrinkWidth: null,
            forceYScrollbars: false,
            scrollerClientWidths: {},
            scrollerClientHeights: {}
        };
        // TODO: can do a really simple print-view. dont need to join rows
        this.handleSizing = ()=>{
            this.safeSetState(Object.assign({
                shrinkWidth: this.computeShrinkWidth()
            }, this.computeScrollerDims()));
        };
    }
    render() {
        let { props: props, state: state, context: context } = this;
        let sectionConfigs = props.sections || [];
        let cols = this.processCols(props.cols);
        let microColGroupNode = this.renderMicroColGroup(cols, state.shrinkWidth);
        let classNames = $5913100b2ed0f596$export$60e660859c376841(props.liquid, context);
        if (props.collapsibleWidth) classNames.push("fc-scrollgrid-collapsible");
        // TODO: make DRY
        let configCnt = sectionConfigs.length;
        let configI = 0;
        let currentConfig;
        let headSectionNodes = [];
        let bodySectionNodes = [];
        let footSectionNodes = [];
        while(configI < configCnt && (currentConfig = sectionConfigs[configI]).type === "header"){
            headSectionNodes.push(this.renderSection(currentConfig, microColGroupNode, true));
            configI += 1;
        }
        while(configI < configCnt && (currentConfig = sectionConfigs[configI]).type === "body"){
            bodySectionNodes.push(this.renderSection(currentConfig, microColGroupNode, false));
            configI += 1;
        }
        while(configI < configCnt && (currentConfig = sectionConfigs[configI]).type === "footer"){
            footSectionNodes.push(this.renderSection(currentConfig, microColGroupNode, true));
            configI += 1;
        }
        // firefox bug: when setting height on table and there is a thead or tfoot,
        // the necessary height:100% on the liquid-height body section forces the *whole* table to be taller. (bug #5524)
        // use getCanVGrowWithinCell as a way to detect table-stupid firefox.
        // if so, use a simpler dom structure, jam everything into a lone tbody.
        let isBuggy = !$5913100b2ed0f596$export$667d3bf0c5f83305();
        const roleAttrs = {
            role: "rowgroup"
        };
        return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("table", {
            role: "grid",
            className: classNames.join(" "),
            style: {
                height: props.height
            }
        }, Boolean(!isBuggy && headSectionNodes.length) && (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("thead", roleAttrs, ...headSectionNodes), Boolean(!isBuggy && bodySectionNodes.length) && (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("tbody", roleAttrs, ...bodySectionNodes), Boolean(!isBuggy && footSectionNodes.length) && (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("tfoot", roleAttrs, ...footSectionNodes), isBuggy && (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("tbody", roleAttrs, ...headSectionNodes, ...bodySectionNodes, ...footSectionNodes));
    }
    renderSection(sectionConfig, microColGroupNode, isHeader) {
        if ("outerContent" in sectionConfig) return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)((0, $450fc775b2f7950e$export$ffb0004e005737fa), {
            key: sectionConfig.key
        }, sectionConfig.outerContent);
        return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("tr", {
            key: sectionConfig.key,
            role: "presentation",
            className: $5913100b2ed0f596$export$df838d0240c938cf(sectionConfig, this.props.liquid).join(" ")
        }, this.renderChunkTd(sectionConfig, microColGroupNode, sectionConfig.chunk, isHeader));
    }
    renderChunkTd(sectionConfig, microColGroupNode, chunkConfig, isHeader) {
        if ("outerContent" in chunkConfig) return chunkConfig.outerContent;
        let { props: props } = this;
        let { forceYScrollbars: forceYScrollbars, scrollerClientWidths: scrollerClientWidths, scrollerClientHeights: scrollerClientHeights } = this.state;
        let needsYScrolling = $5913100b2ed0f596$export$7fe88b5920ffddd2(props, sectionConfig); // TODO: do lazily. do in section config?
        let isLiquid = $5913100b2ed0f596$export$4f33f238a5c1ad77(props, sectionConfig);
        // for `!props.liquid` - is WHOLE scrollgrid natural height?
        // TODO: do same thing in advanced scrollgrid? prolly not b/c always has horizontal scrollbars
        let overflowY = !props.liquid ? "visible" : forceYScrollbars ? "scroll" : !needsYScrolling ? "hidden" : "auto";
        let sectionKey = sectionConfig.key;
        let content = $5913100b2ed0f596$export$df7c425476ed4f2(sectionConfig, chunkConfig, {
            tableColGroupNode: microColGroupNode,
            tableMinWidth: "",
            clientWidth: !props.collapsibleWidth && scrollerClientWidths[sectionKey] !== undefined ? scrollerClientWidths[sectionKey] : null,
            clientHeight: scrollerClientHeights[sectionKey] !== undefined ? scrollerClientHeights[sectionKey] : null,
            expandRows: sectionConfig.expandRows,
            syncRowHeights: false,
            rowSyncHeights: [],
            reportRowHeightChange: ()=>{}
        }, isHeader);
        return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)(isHeader ? "th" : "td", {
            ref: chunkConfig.elRef,
            role: "presentation"
        }, (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("div", {
            className: `fc-scroller-harness${isLiquid ? " fc-scroller-harness-liquid" : ""}`
        }, (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)($5913100b2ed0f596$export$807f1ba34db587c7, {
            ref: this.scrollerRefs.createRef(sectionKey),
            elRef: this.scrollerElRefs.createRef(sectionKey),
            overflowY: overflowY,
            overflowX: !props.liquid ? "visible" : "hidden" /* natural height? */ ,
            maxHeight: sectionConfig.maxHeight,
            liquid: isLiquid,
            liquidIsAbsolute: true
        }, content)));
    }
    _handleScrollerEl(scrollerEl, key) {
        let section = $5913100b2ed0f596$var$getSectionByKey(this.props.sections, key);
        if (section) $5913100b2ed0f596$export$8743009a87fcb00f(section.chunk.scrollerElRef, scrollerEl);
    }
    componentDidMount() {
        this.handleSizing();
        this.context.addResizeHandler(this.handleSizing);
    }
    componentDidUpdate() {
        // TODO: need better solution when state contains non-sizing things
        this.handleSizing();
    }
    componentWillUnmount() {
        this.context.removeResizeHandler(this.handleSizing);
    }
    computeShrinkWidth() {
        return $5913100b2ed0f596$export$65ab0ebced932b79(this.props.cols) ? $5913100b2ed0f596$export$f5339a28e56d1baf(this.scrollerElRefs.getAll()) : 0;
    }
    computeScrollerDims() {
        let scrollbarWidth = $5913100b2ed0f596$export$c7ca7e4bc4f8a16e();
        let { scrollerRefs: scrollerRefs, scrollerElRefs: scrollerElRefs } = this;
        let forceYScrollbars = false;
        let scrollerClientWidths = {};
        let scrollerClientHeights = {};
        for(let sectionKey in scrollerRefs.currentMap){
            let scroller = scrollerRefs.currentMap[sectionKey];
            if (scroller && scroller.needsYScrolling()) {
                forceYScrollbars = true;
                break;
            }
        }
        for (let section of this.props.sections){
            let sectionKey = section.key;
            let scrollerEl = scrollerElRefs.currentMap[sectionKey];
            if (scrollerEl) {
                let harnessEl = scrollerEl.parentNode; // TODO: weird way to get this. need harness b/c doesn't include table borders
                scrollerClientWidths[sectionKey] = Math.floor(harnessEl.getBoundingClientRect().width - (forceYScrollbars ? scrollbarWidth.y // use global because scroller might not have scrollbars yet but will need them in future
                 : 0));
                scrollerClientHeights[sectionKey] = Math.floor(harnessEl.getBoundingClientRect().height);
            }
        }
        return {
            forceYScrollbars: forceYScrollbars,
            scrollerClientWidths: scrollerClientWidths,
            scrollerClientHeights: scrollerClientHeights
        };
    }
}
$5913100b2ed0f596$export$add49c223b9ce4ea.addStateEquality({
    scrollerClientWidths: $5913100b2ed0f596$export$a9c23c6ac3fc3eca,
    scrollerClientHeights: $5913100b2ed0f596$export$a9c23c6ac3fc3eca
});
function $5913100b2ed0f596$var$getSectionByKey(sections, key) {
    for (let section of sections){
        if (section.key === key) return section;
    }
    return null;
}
class $5913100b2ed0f596$export$1343a74baacb0543 extends $5913100b2ed0f596$export$ef35774e6d314e91 {
    constructor(){
        super(...arguments);
        this.handleEl = (el)=>{
            this.el = el;
            if (el) $5913100b2ed0f596$var$setElSeg(el, this.props.seg);
        };
    }
    render() {
        const { props: props, context: context } = this;
        const { options: options } = context;
        const { seg: seg } = props;
        const { eventRange: eventRange } = seg;
        const { ui: ui } = eventRange;
        const renderProps = {
            event: new $5913100b2ed0f596$export$34aec0b863436764(context, eventRange.def, eventRange.instance),
            view: context.viewApi,
            timeText: props.timeText,
            textColor: ui.textColor,
            backgroundColor: ui.backgroundColor,
            borderColor: ui.borderColor,
            isDraggable: !props.disableDragging && $5913100b2ed0f596$var$computeSegDraggable(seg, context),
            isStartResizable: !props.disableResizing && $5913100b2ed0f596$var$computeSegStartResizable(seg, context),
            isEndResizable: !props.disableResizing && $5913100b2ed0f596$var$computeSegEndResizable(seg),
            isMirror: Boolean(props.isDragging || props.isResizing || props.isDateSelecting),
            isStart: Boolean(seg.isStart),
            isEnd: Boolean(seg.isEnd),
            isPast: Boolean(props.isPast),
            isFuture: Boolean(props.isFuture),
            isToday: Boolean(props.isToday),
            isSelected: Boolean(props.isSelected),
            isDragging: Boolean(props.isDragging),
            isResizing: Boolean(props.isResizing)
        };
        return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)($5913100b2ed0f596$export$e7094788287c5e9b, Object.assign({}, props /* contains children */ , {
            elRef: this.handleEl,
            elClasses: [
                ...$5913100b2ed0f596$var$getEventClassNames(renderProps),
                ...seg.eventRange.ui.classNames,
                ...props.elClasses || []
            ],
            renderProps: renderProps,
            generatorName: "eventContent",
            customGenerator: options.eventContent,
            defaultGenerator: props.defaultGenerator,
            classNameGenerator: options.eventClassNames,
            didMount: options.eventDidMount,
            willUnmount: options.eventWillUnmount
        }));
    }
    componentDidUpdate(prevProps) {
        if (this.el && this.props.seg !== prevProps.seg) $5913100b2ed0f596$var$setElSeg(this.el, this.props.seg);
    }
}
// should not be a purecomponent
class $5913100b2ed0f596$export$d92db8a7dc823bb0 extends $5913100b2ed0f596$export$ef35774e6d314e91 {
    render() {
        let { props: props, context: context } = this;
        let { options: options } = context;
        let { seg: seg } = props;
        let { ui: ui } = seg.eventRange;
        let timeFormat = options.eventTimeFormat || props.defaultTimeFormat;
        let timeText = $5913100b2ed0f596$export$993a080e5cb62d74(seg, timeFormat, context, props.defaultDisplayEventTime, props.defaultDisplayEventEnd);
        return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)($5913100b2ed0f596$export$1343a74baacb0543, Object.assign({}, props /* includes elRef */ , {
            elTag: "a",
            elStyle: {
                borderColor: ui.borderColor,
                backgroundColor: ui.backgroundColor
            },
            elAttrs: $5913100b2ed0f596$export$e0c3a065614c6254(seg, context),
            defaultGenerator: $5913100b2ed0f596$var$renderInnerContent$1,
            timeText: timeText
        }), (InnerContent, eventContentArg)=>(0, $450fc775b2f7950e$export$c8a8987d4410bf2d)((0, $450fc775b2f7950e$export$ffb0004e005737fa), null, (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)(InnerContent, {
                elTag: "div",
                elClasses: [
                    "fc-event-main"
                ],
                elStyle: {
                    color: eventContentArg.textColor
                }
            }), Boolean(eventContentArg.isStartResizable) && (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("div", {
                className: "fc-event-resizer fc-event-resizer-start"
            }), Boolean(eventContentArg.isEndResizable) && (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("div", {
                className: "fc-event-resizer fc-event-resizer-end"
            })));
    }
}
function $5913100b2ed0f596$var$renderInnerContent$1(innerProps) {
    return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("div", {
        className: "fc-event-main-frame"
    }, innerProps.timeText && (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("div", {
        className: "fc-event-time"
    }, innerProps.timeText), (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("div", {
        className: "fc-event-title-container"
    }, (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("div", {
        className: "fc-event-title fc-sticky"
    }, innerProps.event.title || (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)((0, $450fc775b2f7950e$export$ffb0004e005737fa), null, "\xa0"))));
}
const $5913100b2ed0f596$export$c1df809846363ebe = (props)=>(0, $450fc775b2f7950e$export$c8a8987d4410bf2d)($5913100b2ed0f596$export$e7c866399fa523f5.Consumer, null, (context)=>{
        let { options: options } = context;
        let renderProps = {
            isAxis: props.isAxis,
            date: context.dateEnv.toDate(props.date),
            view: context.viewApi
        };
        return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)($5913100b2ed0f596$export$e7094788287c5e9b, Object.assign({}, props /* includes children */ , {
            elTag: props.elTag || "div",
            renderProps: renderProps,
            generatorName: "nowIndicatorContent",
            customGenerator: options.nowIndicatorContent,
            classNameGenerator: options.nowIndicatorClassNames,
            didMount: options.nowIndicatorDidMount,
            willUnmount: options.nowIndicatorWillUnmount
        }));
    });
const $5913100b2ed0f596$var$DAY_NUM_FORMAT = $5913100b2ed0f596$export$d141bba7fdc215a3({
    day: "numeric"
});
class $5913100b2ed0f596$export$b975d55abac2bbe3 extends $5913100b2ed0f596$export$ef35774e6d314e91 {
    constructor(){
        super(...arguments);
        this.refineRenderProps = $5913100b2ed0f596$export$ebd11618f299a286($5913100b2ed0f596$var$refineRenderProps);
    }
    render() {
        let { props: props, context: context } = this;
        let { options: options } = context;
        let renderProps = this.refineRenderProps({
            date: props.date,
            dateProfile: props.dateProfile,
            todayRange: props.todayRange,
            isMonthStart: props.isMonthStart || false,
            showDayNumber: props.showDayNumber,
            extraRenderProps: props.extraRenderProps,
            viewApi: context.viewApi,
            dateEnv: context.dateEnv,
            monthStartFormat: options.monthStartFormat
        });
        return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)($5913100b2ed0f596$export$e7094788287c5e9b, Object.assign({}, props /* includes children */ , {
            elClasses: [
                ...$5913100b2ed0f596$export$527e9aa3390079e9(renderProps, context.theme),
                ...props.elClasses || []
            ],
            elAttrs: Object.assign(Object.assign({}, props.elAttrs), renderProps.isDisabled ? {} : {
                "data-date": $5913100b2ed0f596$export$5dbe06c6d8c68cfb(props.date)
            }),
            renderProps: renderProps,
            generatorName: "dayCellContent",
            customGenerator: options.dayCellContent,
            defaultGenerator: props.defaultGenerator,
            classNameGenerator: // don't use custom classNames if disabled
            renderProps.isDisabled ? undefined : options.dayCellClassNames,
            didMount: options.dayCellDidMount,
            willUnmount: options.dayCellWillUnmount
        }));
    }
}
function $5913100b2ed0f596$export$b02498c06ddfef28(options) {
    return Boolean(options.dayCellContent || $5913100b2ed0f596$var$hasCustomRenderingHandler("dayCellContent", options));
}
function $5913100b2ed0f596$var$refineRenderProps(raw) {
    let { date: date, dateEnv: dateEnv, dateProfile: dateProfile, isMonthStart: isMonthStart } = raw;
    let dayMeta = $5913100b2ed0f596$export$a17c37559e1db147(date, raw.todayRange, null, dateProfile);
    let dayNumberText = raw.showDayNumber ? dateEnv.format(date, isMonthStart ? raw.monthStartFormat : $5913100b2ed0f596$var$DAY_NUM_FORMAT) : "";
    return Object.assign(Object.assign(Object.assign({
        date: dateEnv.toDate(date),
        view: raw.viewApi
    }, dayMeta), {
        isMonthStart: isMonthStart,
        dayNumberText: dayNumberText
    }), raw.extraRenderProps);
}
class $5913100b2ed0f596$export$cd571ca6d1702b73 extends $5913100b2ed0f596$export$ef35774e6d314e91 {
    render() {
        let { props: props } = this;
        let { seg: seg } = props;
        return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)($5913100b2ed0f596$export$1343a74baacb0543, {
            elTag: "div",
            elClasses: [
                "fc-bg-event"
            ],
            elStyle: {
                backgroundColor: seg.eventRange.ui.backgroundColor
            },
            defaultGenerator: $5913100b2ed0f596$var$renderInnerContent,
            seg: seg,
            timeText: "",
            isDragging: false,
            isResizing: false,
            isDateSelecting: false,
            isSelected: false,
            isPast: props.isPast,
            isFuture: props.isFuture,
            isToday: props.isToday,
            disableDragging: true,
            disableResizing: true
        });
    }
}
function $5913100b2ed0f596$var$renderInnerContent(props) {
    let { title: title } = props.event;
    return title && (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("div", {
        className: "fc-event-title"
    }, props.event.title);
}
function $5913100b2ed0f596$export$87b6ab1c2cb8b955(fillType) {
    return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("div", {
        className: `fc-${fillType}`
    });
}
const $5913100b2ed0f596$export$a3c9165b94390bcd = (props)=>(0, $450fc775b2f7950e$export$c8a8987d4410bf2d)($5913100b2ed0f596$export$e7c866399fa523f5.Consumer, null, (context)=>{
        let { dateEnv: dateEnv, options: options } = context;
        let { date: date } = props;
        let format = options.weekNumberFormat || props.defaultFormat;
        let num = dateEnv.computeWeekNumber(date); // TODO: somehow use for formatting as well?
        let text = dateEnv.format(date, format);
        let renderProps = {
            num: num,
            text: text,
            date: date
        };
        return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)($5913100b2ed0f596$export$e7094788287c5e9b // why isn't WeekNumberContentArg being auto-detected?
        , Object.assign({}, props /* includes children */ , {
            renderProps: renderProps,
            generatorName: "weekNumberContent",
            customGenerator: options.weekNumberContent,
            defaultGenerator: $5913100b2ed0f596$var$renderInner,
            classNameGenerator: options.weekNumberClassNames,
            didMount: options.weekNumberDidMount,
            willUnmount: options.weekNumberWillUnmount
        }));
    });
function $5913100b2ed0f596$var$renderInner(innerProps) {
    return innerProps.text;
}
const $5913100b2ed0f596$var$PADDING_FROM_VIEWPORT = 10;
class $5913100b2ed0f596$var$Popover extends $5913100b2ed0f596$export$ef35774e6d314e91 {
    constructor(){
        super(...arguments);
        this.state = {
            titleId: $5913100b2ed0f596$export$a8550f7dbe79f93a()
        };
        this.handleRootEl = (el)=>{
            this.rootEl = el;
            if (this.props.elRef) $5913100b2ed0f596$export$8743009a87fcb00f(this.props.elRef, el);
        };
        // Triggered when the user clicks *anywhere* in the document, for the autoHide feature
        this.handleDocumentMouseDown = (ev)=>{
            // only hide the popover if the click happened outside the popover
            const target = $5913100b2ed0f596$export$738ab4df8bf92ae9(ev);
            if (!this.rootEl.contains(target)) this.handleCloseClick();
        };
        this.handleDocumentKeyDown = (ev)=>{
            if (ev.key === "Escape") this.handleCloseClick();
        };
        this.handleCloseClick = ()=>{
            let { onClose: onClose } = this.props;
            if (onClose) onClose();
        };
    }
    render() {
        let { theme: theme, options: options } = this.context;
        let { props: props, state: state } = this;
        let classNames = [
            "fc-popover",
            theme.getClass("popover")
        ].concat(props.extraClassNames || []);
        return (0, $a35043596f133777$export$d39a5bbd09211389)((0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("div", Object.assign({}, props.extraAttrs, {
            id: props.id,
            className: classNames.join(" "),
            "aria-labelledby": state.titleId,
            ref: this.handleRootEl
        }), (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("div", {
            className: "fc-popover-header " + theme.getClass("popoverHeader")
        }, (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("span", {
            className: "fc-popover-title",
            id: state.titleId
        }, props.title), (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("span", {
            className: "fc-popover-close " + theme.getIconClass("close"),
            title: options.closeHint,
            onClick: this.handleCloseClick
        })), (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("div", {
            className: "fc-popover-body " + theme.getClass("popoverContent")
        }, props.children)), props.parentEl);
    }
    componentDidMount() {
        document.addEventListener("mousedown", this.handleDocumentMouseDown);
        document.addEventListener("keydown", this.handleDocumentKeyDown);
        this.updateSize();
    }
    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleDocumentMouseDown);
        document.removeEventListener("keydown", this.handleDocumentKeyDown);
    }
    updateSize() {
        let { isRtl: isRtl } = this.context;
        let { alignmentEl: alignmentEl, alignGridTop: alignGridTop } = this.props;
        let { rootEl: rootEl } = this;
        let alignmentRect = $5913100b2ed0f596$var$computeClippedClientRect(alignmentEl);
        if (alignmentRect) {
            let popoverDims = rootEl.getBoundingClientRect();
            // position relative to viewport
            let popoverTop = alignGridTop ? $5913100b2ed0f596$export$3d8c2f653ac9d0b9(alignmentEl, ".fc-scrollgrid").getBoundingClientRect().top : alignmentRect.top;
            let popoverLeft = isRtl ? alignmentRect.right - popoverDims.width : alignmentRect.left;
            // constrain
            popoverTop = Math.max(popoverTop, $5913100b2ed0f596$var$PADDING_FROM_VIEWPORT);
            popoverLeft = Math.min(popoverLeft, document.documentElement.clientWidth - $5913100b2ed0f596$var$PADDING_FROM_VIEWPORT - popoverDims.width);
            popoverLeft = Math.max(popoverLeft, $5913100b2ed0f596$var$PADDING_FROM_VIEWPORT);
            let origin = rootEl.offsetParent.getBoundingClientRect();
            $5913100b2ed0f596$export$2ed0fc6709e59212(rootEl, {
                top: popoverTop - origin.top,
                left: popoverLeft - origin.left
            });
        }
    }
}
class $5913100b2ed0f596$var$MorePopover extends $5913100b2ed0f596$export$51b138e5a065c2bb {
    constructor(){
        super(...arguments);
        this.handleRootEl = (rootEl)=>{
            this.rootEl = rootEl;
            if (rootEl) this.context.registerInteractiveComponent(this, {
                el: rootEl,
                useEventCenter: false
            });
            else this.context.unregisterInteractiveComponent(this);
        };
    }
    render() {
        let { options: options, dateEnv: dateEnv } = this.context;
        let { props: props } = this;
        let { startDate: startDate, todayRange: todayRange, dateProfile: dateProfile } = props;
        let title = dateEnv.format(startDate, options.dayPopoverFormat);
        return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)($5913100b2ed0f596$export$b975d55abac2bbe3, {
            elRef: this.handleRootEl,
            date: startDate,
            dateProfile: dateProfile,
            todayRange: todayRange
        }, (InnerContent, renderProps, elAttrs)=>(0, $450fc775b2f7950e$export$c8a8987d4410bf2d)($5913100b2ed0f596$var$Popover, {
                elRef: elAttrs.ref,
                id: props.id,
                title: title,
                extraClassNames: [
                    "fc-more-popover"
                ].concat(elAttrs.className || []),
                extraAttrs: elAttrs /* TODO: make these time-based when not whole-day? */ ,
                parentEl: props.parentEl,
                alignmentEl: props.alignmentEl,
                alignGridTop: props.alignGridTop,
                onClose: props.onClose
            }, $5913100b2ed0f596$export$b02498c06ddfef28(options) && (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)(InnerContent, {
                elTag: "div",
                elClasses: [
                    "fc-more-popover-misc"
                ]
            }), props.children));
    }
    queryHit(positionLeft, positionTop, elWidth, elHeight) {
        let { rootEl: rootEl, props: props } = this;
        if (positionLeft >= 0 && positionLeft < elWidth && positionTop >= 0 && positionTop < elHeight) return {
            dateProfile: props.dateProfile,
            dateSpan: Object.assign({
                allDay: !props.forceTimed,
                range: {
                    start: props.startDate,
                    end: props.endDate
                }
            }, props.extraDateSpan),
            dayEl: rootEl,
            rect: {
                left: 0,
                top: 0,
                right: elWidth,
                bottom: elHeight
            },
            layer: 1
        };
        return null;
    }
}
class $5913100b2ed0f596$export$cbfbec548517f2b6 extends $5913100b2ed0f596$export$ef35774e6d314e91 {
    constructor(){
        super(...arguments);
        this.state = {
            isPopoverOpen: false,
            popoverId: $5913100b2ed0f596$export$a8550f7dbe79f93a()
        };
        this.handleLinkEl = (linkEl)=>{
            this.linkEl = linkEl;
            if (this.props.elRef) $5913100b2ed0f596$export$8743009a87fcb00f(this.props.elRef, linkEl);
        };
        this.handleClick = (ev)=>{
            let { props: props, context: context } = this;
            let { moreLinkClick: moreLinkClick } = context.options;
            let date = $5913100b2ed0f596$var$computeRange(props).start;
            function buildPublicSeg(seg) {
                let { def: def, instance: instance, range: range } = seg.eventRange;
                return {
                    event: new $5913100b2ed0f596$export$34aec0b863436764(context, def, instance),
                    start: context.dateEnv.toDate(range.start),
                    end: context.dateEnv.toDate(range.end),
                    isStart: seg.isStart,
                    isEnd: seg.isEnd
                };
            }
            if (typeof moreLinkClick === "function") moreLinkClick = moreLinkClick({
                date: date,
                allDay: Boolean(props.allDayDate),
                allSegs: props.allSegs.map(buildPublicSeg),
                hiddenSegs: props.hiddenSegs.map(buildPublicSeg),
                jsEvent: ev,
                view: context.viewApi
            });
            if (!moreLinkClick || moreLinkClick === "popover") this.setState({
                isPopoverOpen: true
            });
            else if (typeof moreLinkClick === "string") context.calendarApi.zoomTo(date, moreLinkClick);
        };
        this.handlePopoverClose = ()=>{
            this.setState({
                isPopoverOpen: false
            });
        };
    }
    render() {
        let { props: props, state: state } = this;
        return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)($5913100b2ed0f596$export$e7c866399fa523f5.Consumer, null, (context)=>{
            let { viewApi: viewApi, options: options, calendarApi: calendarApi } = context;
            let { moreLinkText: moreLinkText } = options;
            let { moreCnt: moreCnt } = props;
            let range = $5913100b2ed0f596$var$computeRange(props);
            let text = typeof moreLinkText === "function" // TODO: eventually use formatWithOrdinals
             ? moreLinkText.call(calendarApi, moreCnt) : `+${moreCnt} ${moreLinkText}`;
            let hint = $5913100b2ed0f596$export$342063e11d6c3cad(options.moreLinkHint, [
                moreCnt
            ], text);
            let renderProps = {
                num: moreCnt,
                shortText: `+${moreCnt}`,
                text: text,
                view: viewApi
            };
            return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)((0, $450fc775b2f7950e$export$ffb0004e005737fa), null, Boolean(props.moreCnt) && (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)($5913100b2ed0f596$export$e7094788287c5e9b, {
                elTag: props.elTag || "a",
                elRef: this.handleLinkEl,
                elClasses: [
                    ...props.elClasses || [],
                    "fc-more-link"
                ],
                elStyle: props.elStyle,
                elAttrs: Object.assign(Object.assign(Object.assign({}, props.elAttrs), $5913100b2ed0f596$var$createAriaClickAttrs(this.handleClick)), {
                    title: hint,
                    "aria-expanded": state.isPopoverOpen,
                    "aria-controls": state.isPopoverOpen ? state.popoverId : ""
                }),
                renderProps: renderProps,
                generatorName: "moreLinkContent",
                customGenerator: options.moreLinkContent,
                defaultGenerator: props.defaultGenerator || $5913100b2ed0f596$var$renderMoreLinkInner,
                classNameGenerator: options.moreLinkClassNames,
                didMount: options.moreLinkDidMount,
                willUnmount: options.moreLinkWillUnmount
            }, props.children), state.isPopoverOpen && (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)($5913100b2ed0f596$var$MorePopover, {
                id: state.popoverId,
                startDate: range.start,
                endDate: range.end,
                dateProfile: props.dateProfile,
                todayRange: props.todayRange,
                extraDateSpan: props.extraDateSpan,
                parentEl: this.parentEl,
                alignmentEl: props.alignmentElRef ? props.alignmentElRef.current : this.linkEl,
                alignGridTop: props.alignGridTop,
                forceTimed: props.forceTimed,
                onClose: this.handlePopoverClose
            }, props.popoverContent()));
        });
    }
    componentDidMount() {
        this.updateParentEl();
    }
    componentDidUpdate() {
        this.updateParentEl();
    }
    updateParentEl() {
        if (this.linkEl) this.parentEl = $5913100b2ed0f596$export$3d8c2f653ac9d0b9(this.linkEl, ".fc-view-harness");
    }
}
function $5913100b2ed0f596$var$renderMoreLinkInner(props) {
    return props.text;
}
function $5913100b2ed0f596$var$computeRange(props) {
    if (props.allDayDate) return {
        start: props.allDayDate,
        end: $5913100b2ed0f596$export$625550452a3fa3ec(props.allDayDate, 1)
    };
    let { hiddenSegs: hiddenSegs } = props;
    return {
        start: $5913100b2ed0f596$export$bde1ed0f60b38f2f(hiddenSegs),
        end: $5913100b2ed0f596$var$computeLatestSegEnd(hiddenSegs)
    };
}
function $5913100b2ed0f596$export$bde1ed0f60b38f2f(segs) {
    return segs.reduce($5913100b2ed0f596$var$pickEarliestStart).eventRange.range.start;
}
function $5913100b2ed0f596$var$pickEarliestStart(seg0, seg1) {
    return seg0.eventRange.range.start < seg1.eventRange.range.start ? seg0 : seg1;
}
function $5913100b2ed0f596$var$computeLatestSegEnd(segs) {
    return segs.reduce($5913100b2ed0f596$var$pickLatestEnd).eventRange.range.end;
}
function $5913100b2ed0f596$var$pickLatestEnd(seg0, seg1) {
    return seg0.eventRange.range.end > seg1.eventRange.range.end ? seg0 : seg1;
}
class $5913100b2ed0f596$var$Store {
    constructor(){
        this.handlers = [];
    }
    set(value) {
        this.currentValue = value;
        for (let handler of this.handlers)handler(value);
    }
    subscribe(handler) {
        this.handlers.push(handler);
        if (this.currentValue !== undefined) handler(this.currentValue);
    }
}
/*
Subscribers will get a LIST of CustomRenderings
*/ class $5913100b2ed0f596$export$aea64bc1b6f8f415 extends $5913100b2ed0f596$var$Store {
    constructor(){
        super(...arguments);
        this.map = new Map();
    }
    // for consistent order
    handle(customRendering) {
        const { map: map } = this;
        let updated = false;
        if (customRendering.isActive) {
            map.set(customRendering.id, customRendering);
            updated = true;
        } else if (map.has(customRendering.id)) {
            map.delete(customRendering.id);
            updated = true;
        }
        if (updated) this.set(map);
    }
}




const $641adb510ed163e1$export$794e7bef9c0b12d9 = [];
const $641adb510ed163e1$var$MINIMAL_RAW_EN_LOCALE = {
    code: "en",
    week: {
        dow: 0,
        doy: 4
    },
    direction: "ltr",
    buttonText: {
        prev: "prev",
        next: "next",
        prevYear: "prev year",
        nextYear: "next year",
        year: "year",
        today: "today",
        month: "month",
        week: "week",
        day: "day",
        list: "list"
    },
    weekText: "W",
    weekTextLong: "Week",
    closeHint: "Close",
    timeHint: "Time",
    eventHint: "Event",
    allDayText: "all-day",
    moreLinkText: "more",
    noEventsText: "No events to display"
};
const $641adb510ed163e1$var$RAW_EN_LOCALE = Object.assign(Object.assign({}, $641adb510ed163e1$var$MINIMAL_RAW_EN_LOCALE), {
    // Includes things we don't want other locales to inherit,
    // things that derive from other translatable strings.
    buttonHints: {
        prev: "Previous $0",
        next: "Next $0",
        today (buttonText, unit) {
            return unit === "day" ? "Today" : `This ${buttonText}`;
        }
    },
    viewHint: "$0 view",
    navLinkHint: "Go to $0",
    moreLinkHint (eventCnt) {
        return `Show ${eventCnt} more event${eventCnt === 1 ? "" : "s"}`;
    }
});
function $641adb510ed163e1$var$organizeRawLocales(explicitRawLocales) {
    let defaultCode = explicitRawLocales.length > 0 ? explicitRawLocales[0].code : "en";
    let allRawLocales = $641adb510ed163e1$export$794e7bef9c0b12d9.concat(explicitRawLocales);
    let rawLocaleMap = {
        en: $641adb510ed163e1$var$RAW_EN_LOCALE
    };
    for (let rawLocale of allRawLocales)rawLocaleMap[rawLocale.code] = rawLocale;
    return {
        map: rawLocaleMap,
        defaultCode: defaultCode
    };
}
function $641adb510ed163e1$var$buildLocale(inputSingular, available) {
    if (typeof inputSingular === "object" && !Array.isArray(inputSingular)) return $641adb510ed163e1$var$parseLocale(inputSingular.code, [
        inputSingular.code
    ], inputSingular);
    return $641adb510ed163e1$var$queryLocale(inputSingular, available);
}
function $641adb510ed163e1$var$queryLocale(codeArg, available) {
    let codes = [].concat(codeArg || []); // will convert to array
    let raw = $641adb510ed163e1$var$queryRawLocale(codes, available) || $641adb510ed163e1$var$RAW_EN_LOCALE;
    return $641adb510ed163e1$var$parseLocale(codeArg, codes, raw);
}
function $641adb510ed163e1$var$queryRawLocale(codes, available) {
    for(let i = 0; i < codes.length; i += 1){
        let parts = codes[i].toLocaleLowerCase().split("-");
        for(let j = parts.length; j > 0; j -= 1){
            let simpleId = parts.slice(0, j).join("-");
            if (available[simpleId]) return available[simpleId];
        }
    }
    return null;
}
function $641adb510ed163e1$var$parseLocale(codeArg, codes, raw) {
    let merged = (0, $5913100b2ed0f596$export$953cecd6e717a553)([
        $641adb510ed163e1$var$MINIMAL_RAW_EN_LOCALE,
        raw
    ], [
        "buttonText"
    ]);
    delete merged.code; // don't want this part of the options
    let { week: week } = merged;
    delete merged.week;
    return {
        codeArg: codeArg,
        codes: codes,
        week: week,
        simpleNumberFormat: new Intl.NumberFormat(codeArg),
        options: merged
    };
}
// TODO: easier way to add new hooks? need to update a million things
function $641adb510ed163e1$export$ae829ec7b2625219(input) {
    return {
        id: (0, $5913100b2ed0f596$export$39b482c5e57630a8)(),
        name: input.name,
        premiumReleaseDate: input.premiumReleaseDate ? new Date(input.premiumReleaseDate) : undefined,
        deps: input.deps || [],
        reducers: input.reducers || [],
        isLoadingFuncs: input.isLoadingFuncs || [],
        contextInit: [].concat(input.contextInit || []),
        eventRefiners: input.eventRefiners || {},
        eventDefMemberAdders: input.eventDefMemberAdders || [],
        eventSourceRefiners: input.eventSourceRefiners || {},
        isDraggableTransformers: input.isDraggableTransformers || [],
        eventDragMutationMassagers: input.eventDragMutationMassagers || [],
        eventDefMutationAppliers: input.eventDefMutationAppliers || [],
        dateSelectionTransformers: input.dateSelectionTransformers || [],
        datePointTransforms: input.datePointTransforms || [],
        dateSpanTransforms: input.dateSpanTransforms || [],
        views: input.views || {},
        viewPropsTransformers: input.viewPropsTransformers || [],
        isPropsValid: input.isPropsValid || null,
        externalDefTransforms: input.externalDefTransforms || [],
        viewContainerAppends: input.viewContainerAppends || [],
        eventDropTransformers: input.eventDropTransformers || [],
        componentInteractions: input.componentInteractions || [],
        calendarInteractions: input.calendarInteractions || [],
        themeClasses: input.themeClasses || {},
        eventSourceDefs: input.eventSourceDefs || [],
        cmdFormatter: input.cmdFormatter,
        recurringTypes: input.recurringTypes || [],
        namedTimeZonedImpl: input.namedTimeZonedImpl,
        initialView: input.initialView || "",
        elementDraggingImpl: input.elementDraggingImpl,
        optionChangeHandlers: input.optionChangeHandlers || {},
        scrollGridImpl: input.scrollGridImpl || null,
        listenerRefiners: input.listenerRefiners || {},
        optionRefiners: input.optionRefiners || {},
        propSetHandlers: input.propSetHandlers || {}
    };
}
function $641adb510ed163e1$var$buildPluginHooks(pluginDefs, globalDefs) {
    let currentPluginIds = {};
    let hooks = {
        premiumReleaseDate: undefined,
        reducers: [],
        isLoadingFuncs: [],
        contextInit: [],
        eventRefiners: {},
        eventDefMemberAdders: [],
        eventSourceRefiners: {},
        isDraggableTransformers: [],
        eventDragMutationMassagers: [],
        eventDefMutationAppliers: [],
        dateSelectionTransformers: [],
        datePointTransforms: [],
        dateSpanTransforms: [],
        views: {},
        viewPropsTransformers: [],
        isPropsValid: null,
        externalDefTransforms: [],
        viewContainerAppends: [],
        eventDropTransformers: [],
        componentInteractions: [],
        calendarInteractions: [],
        themeClasses: {},
        eventSourceDefs: [],
        cmdFormatter: null,
        recurringTypes: [],
        namedTimeZonedImpl: null,
        initialView: "",
        elementDraggingImpl: null,
        optionChangeHandlers: {},
        scrollGridImpl: null,
        listenerRefiners: {},
        optionRefiners: {},
        propSetHandlers: {}
    };
    function addDefs(defs) {
        for (let def of defs){
            const pluginName = def.name;
            const currentId = currentPluginIds[pluginName];
            if (currentId === undefined) {
                currentPluginIds[pluginName] = def.id;
                addDefs(def.deps);
                hooks = $641adb510ed163e1$var$combineHooks(hooks, def);
            } else if (currentId !== def.id) // different ID than the one already added
            console.warn(`Duplicate plugin '${pluginName}'`);
        }
    }
    if (pluginDefs) addDefs(pluginDefs);
    addDefs(globalDefs);
    return hooks;
}
function $641adb510ed163e1$var$buildBuildPluginHooks() {
    let currentOverrideDefs = [];
    let currentGlobalDefs = [];
    let currentHooks;
    return (overrideDefs, globalDefs)=>{
        if (!currentHooks || !(0, $5913100b2ed0f596$export$23f2a1d2818174ef)(overrideDefs, currentOverrideDefs) || !(0, $5913100b2ed0f596$export$23f2a1d2818174ef)(globalDefs, currentGlobalDefs)) currentHooks = $641adb510ed163e1$var$buildPluginHooks(overrideDefs, globalDefs);
        currentOverrideDefs = overrideDefs;
        currentGlobalDefs = globalDefs;
        return currentHooks;
    };
}
function $641adb510ed163e1$var$combineHooks(hooks0, hooks1) {
    return {
        premiumReleaseDate: $641adb510ed163e1$var$compareOptionalDates(hooks0.premiumReleaseDate, hooks1.premiumReleaseDate),
        reducers: hooks0.reducers.concat(hooks1.reducers),
        isLoadingFuncs: hooks0.isLoadingFuncs.concat(hooks1.isLoadingFuncs),
        contextInit: hooks0.contextInit.concat(hooks1.contextInit),
        eventRefiners: Object.assign(Object.assign({}, hooks0.eventRefiners), hooks1.eventRefiners),
        eventDefMemberAdders: hooks0.eventDefMemberAdders.concat(hooks1.eventDefMemberAdders),
        eventSourceRefiners: Object.assign(Object.assign({}, hooks0.eventSourceRefiners), hooks1.eventSourceRefiners),
        isDraggableTransformers: hooks0.isDraggableTransformers.concat(hooks1.isDraggableTransformers),
        eventDragMutationMassagers: hooks0.eventDragMutationMassagers.concat(hooks1.eventDragMutationMassagers),
        eventDefMutationAppliers: hooks0.eventDefMutationAppliers.concat(hooks1.eventDefMutationAppliers),
        dateSelectionTransformers: hooks0.dateSelectionTransformers.concat(hooks1.dateSelectionTransformers),
        datePointTransforms: hooks0.datePointTransforms.concat(hooks1.datePointTransforms),
        dateSpanTransforms: hooks0.dateSpanTransforms.concat(hooks1.dateSpanTransforms),
        views: Object.assign(Object.assign({}, hooks0.views), hooks1.views),
        viewPropsTransformers: hooks0.viewPropsTransformers.concat(hooks1.viewPropsTransformers),
        isPropsValid: hooks1.isPropsValid || hooks0.isPropsValid,
        externalDefTransforms: hooks0.externalDefTransforms.concat(hooks1.externalDefTransforms),
        viewContainerAppends: hooks0.viewContainerAppends.concat(hooks1.viewContainerAppends),
        eventDropTransformers: hooks0.eventDropTransformers.concat(hooks1.eventDropTransformers),
        calendarInteractions: hooks0.calendarInteractions.concat(hooks1.calendarInteractions),
        componentInteractions: hooks0.componentInteractions.concat(hooks1.componentInteractions),
        themeClasses: Object.assign(Object.assign({}, hooks0.themeClasses), hooks1.themeClasses),
        eventSourceDefs: hooks0.eventSourceDefs.concat(hooks1.eventSourceDefs),
        cmdFormatter: hooks1.cmdFormatter || hooks0.cmdFormatter,
        recurringTypes: hooks0.recurringTypes.concat(hooks1.recurringTypes),
        namedTimeZonedImpl: hooks1.namedTimeZonedImpl || hooks0.namedTimeZonedImpl,
        initialView: hooks0.initialView || hooks1.initialView,
        elementDraggingImpl: hooks0.elementDraggingImpl || hooks1.elementDraggingImpl,
        optionChangeHandlers: Object.assign(Object.assign({}, hooks0.optionChangeHandlers), hooks1.optionChangeHandlers),
        scrollGridImpl: hooks1.scrollGridImpl || hooks0.scrollGridImpl,
        listenerRefiners: Object.assign(Object.assign({}, hooks0.listenerRefiners), hooks1.listenerRefiners),
        optionRefiners: Object.assign(Object.assign({}, hooks0.optionRefiners), hooks1.optionRefiners),
        propSetHandlers: Object.assign(Object.assign({}, hooks0.propSetHandlers), hooks1.propSetHandlers)
    };
}
function $641adb510ed163e1$var$compareOptionalDates(date0, date1) {
    if (date0 === undefined) return date1;
    if (date1 === undefined) return date0;
    return new Date(Math.max(date0.valueOf(), date1.valueOf()));
}
class $641adb510ed163e1$var$StandardTheme extends (0, $5913100b2ed0f596$export$971d5caa766a69d7) {
}
$641adb510ed163e1$var$StandardTheme.prototype.classes = {
    root: "fc-theme-standard",
    tableCellShaded: "fc-cell-shaded",
    buttonGroup: "fc-button-group",
    button: "fc-button fc-button-primary",
    buttonActive: "fc-button-active"
};
$641adb510ed163e1$var$StandardTheme.prototype.baseIconClass = "fc-icon";
$641adb510ed163e1$var$StandardTheme.prototype.iconClasses = {
    close: "fc-icon-x",
    prev: "fc-icon-chevron-left",
    next: "fc-icon-chevron-right",
    prevYear: "fc-icon-chevrons-left",
    nextYear: "fc-icon-chevrons-right"
};
$641adb510ed163e1$var$StandardTheme.prototype.rtlIconClasses = {
    prev: "fc-icon-chevron-right",
    next: "fc-icon-chevron-left",
    prevYear: "fc-icon-chevrons-right",
    nextYear: "fc-icon-chevrons-left"
};
$641adb510ed163e1$var$StandardTheme.prototype.iconOverrideOption = "buttonIcons"; // TODO: make TS-friendly
$641adb510ed163e1$var$StandardTheme.prototype.iconOverrideCustomButtonOption = "icon";
$641adb510ed163e1$var$StandardTheme.prototype.iconOverridePrefix = "fc-icon-";
function $641adb510ed163e1$var$compileViewDefs(defaultConfigs, overrideConfigs) {
    let hash = {};
    let viewType;
    for(viewType in defaultConfigs)$641adb510ed163e1$var$ensureViewDef(viewType, hash, defaultConfigs, overrideConfigs);
    for(viewType in overrideConfigs)$641adb510ed163e1$var$ensureViewDef(viewType, hash, defaultConfigs, overrideConfigs);
    return hash;
}
function $641adb510ed163e1$var$ensureViewDef(viewType, hash, defaultConfigs, overrideConfigs) {
    if (hash[viewType]) return hash[viewType];
    let viewDef = $641adb510ed163e1$var$buildViewDef(viewType, hash, defaultConfigs, overrideConfigs);
    if (viewDef) hash[viewType] = viewDef;
    return viewDef;
}
function $641adb510ed163e1$var$buildViewDef(viewType, hash, defaultConfigs, overrideConfigs) {
    let defaultConfig = defaultConfigs[viewType];
    let overrideConfig = overrideConfigs[viewType];
    let queryProp = (name)=>defaultConfig && defaultConfig[name] !== null ? defaultConfig[name] : overrideConfig && overrideConfig[name] !== null ? overrideConfig[name] : null;
    let theComponent = queryProp("component");
    let superType = queryProp("superType");
    let superDef = null;
    if (superType) {
        if (superType === viewType) throw new Error("Can't have a custom view type that references itself");
        superDef = $641adb510ed163e1$var$ensureViewDef(superType, hash, defaultConfigs, overrideConfigs);
    }
    if (!theComponent && superDef) theComponent = superDef.component;
    if (!theComponent) return null; // don't throw a warning, might be settings for a single-unit view
    return {
        type: viewType,
        component: theComponent,
        defaults: Object.assign(Object.assign({}, superDef ? superDef.defaults : {}), defaultConfig ? defaultConfig.rawOptions : {}),
        overrides: Object.assign(Object.assign({}, superDef ? superDef.overrides : {}), overrideConfig ? overrideConfig.rawOptions : {})
    };
}
function $641adb510ed163e1$var$parseViewConfigs(inputs) {
    return (0, $5913100b2ed0f596$export$407448d2b89b1813)(inputs, $641adb510ed163e1$var$parseViewConfig);
}
function $641adb510ed163e1$var$parseViewConfig(input) {
    let rawOptions = typeof input === "function" ? {
        component: input
    } : input;
    let { component: component } = rawOptions;
    if (rawOptions.content) // TODO: remove content/classNames/didMount/etc from options?
    component = $641adb510ed163e1$var$createViewHookComponent(rawOptions);
    else if (component && !(component.prototype instanceof (0, $5913100b2ed0f596$export$ef35774e6d314e91))) // WHY?: people were using `component` property for `content`
    // TODO: converge on one setting name
    component = $641adb510ed163e1$var$createViewHookComponent(Object.assign(Object.assign({}, rawOptions), {
        content: component
    }));
    return {
        superType: rawOptions.type,
        component: component,
        rawOptions: rawOptions
    };
}
function $641adb510ed163e1$var$createViewHookComponent(options) {
    return (viewProps)=>(0, $450fc775b2f7950e$export$c8a8987d4410bf2d)((0, $5913100b2ed0f596$export$e7c866399fa523f5).Consumer, null, (context)=>(0, $450fc775b2f7950e$export$c8a8987d4410bf2d)((0, $5913100b2ed0f596$export$e7094788287c5e9b), {
                elTag: "div",
                elClasses: (0, $5913100b2ed0f596$export$8b22cf2602fb60ce)(context.viewSpec),
                renderProps: Object.assign(Object.assign({}, viewProps), {
                    nextDayThreshold: context.options.nextDayThreshold
                }),
                generatorName: undefined,
                customGenerator: options.content,
                classNameGenerator: options.classNames,
                didMount: options.didMount,
                willUnmount: options.willUnmount
            }));
}
function $641adb510ed163e1$var$buildViewSpecs(defaultInputs, optionOverrides, dynamicOptionOverrides, localeDefaults) {
    let defaultConfigs = $641adb510ed163e1$var$parseViewConfigs(defaultInputs);
    let overrideConfigs = $641adb510ed163e1$var$parseViewConfigs(optionOverrides.views);
    let viewDefs = $641adb510ed163e1$var$compileViewDefs(defaultConfigs, overrideConfigs);
    return (0, $5913100b2ed0f596$export$407448d2b89b1813)(viewDefs, (viewDef)=>$641adb510ed163e1$var$buildViewSpec(viewDef, overrideConfigs, optionOverrides, dynamicOptionOverrides, localeDefaults));
}
function $641adb510ed163e1$var$buildViewSpec(viewDef, overrideConfigs, optionOverrides, dynamicOptionOverrides, localeDefaults) {
    let durationInput = viewDef.overrides.duration || viewDef.defaults.duration || dynamicOptionOverrides.duration || optionOverrides.duration;
    let duration = null;
    let durationUnit = "";
    let singleUnit = "";
    let singleUnitOverrides = {};
    if (durationInput) {
        duration = $641adb510ed163e1$var$createDurationCached(durationInput);
        if (duration) {
            let denom = (0, $5913100b2ed0f596$export$db3b6bfb95261072)(duration);
            durationUnit = denom.unit;
            if (denom.value === 1) {
                singleUnit = durationUnit;
                singleUnitOverrides = overrideConfigs[durationUnit] ? overrideConfigs[durationUnit].rawOptions : {};
            }
        }
    }
    let queryButtonText = (optionsSubset)=>{
        let buttonTextMap = optionsSubset.buttonText || {};
        let buttonTextKey = viewDef.defaults.buttonTextKey;
        if (buttonTextKey != null && buttonTextMap[buttonTextKey] != null) return buttonTextMap[buttonTextKey];
        if (buttonTextMap[viewDef.type] != null) return buttonTextMap[viewDef.type];
        if (buttonTextMap[singleUnit] != null) return buttonTextMap[singleUnit];
        return null;
    };
    let queryButtonTitle = (optionsSubset)=>{
        let buttonHints = optionsSubset.buttonHints || {};
        let buttonKey = viewDef.defaults.buttonTextKey; // use same key as text
        if (buttonKey != null && buttonHints[buttonKey] != null) return buttonHints[buttonKey];
        if (buttonHints[viewDef.type] != null) return buttonHints[viewDef.type];
        if (buttonHints[singleUnit] != null) return buttonHints[singleUnit];
        return null;
    };
    return {
        type: viewDef.type,
        component: viewDef.component,
        duration: duration,
        durationUnit: durationUnit,
        singleUnit: singleUnit,
        optionDefaults: viewDef.defaults,
        optionOverrides: Object.assign(Object.assign({}, singleUnitOverrides), viewDef.overrides),
        buttonTextOverride: queryButtonText(dynamicOptionOverrides) || queryButtonText(optionOverrides) || // constructor-specified buttonText lookup hash takes precedence
        viewDef.overrides.buttonText,
        buttonTextDefault: queryButtonText(localeDefaults) || viewDef.defaults.buttonText || queryButtonText((0, $5913100b2ed0f596$export$f1e1789686576879)) || viewDef.type,
        // not DRY
        buttonTitleOverride: queryButtonTitle(dynamicOptionOverrides) || queryButtonTitle(optionOverrides) || viewDef.overrides.buttonHint,
        buttonTitleDefault: queryButtonTitle(localeDefaults) || viewDef.defaults.buttonHint || queryButtonTitle((0, $5913100b2ed0f596$export$f1e1789686576879))
    };
}
// hack to get memoization working
let $641adb510ed163e1$var$durationInputMap = {};
function $641adb510ed163e1$var$createDurationCached(durationInput) {
    let json = JSON.stringify(durationInput);
    let res = $641adb510ed163e1$var$durationInputMap[json];
    if (res === undefined) {
        res = (0, $5913100b2ed0f596$export$4368d992c4eafac0)(durationInput);
        $641adb510ed163e1$var$durationInputMap[json] = res;
    }
    return res;
}
function $641adb510ed163e1$var$reduceViewType(viewType, action) {
    switch(action.type){
        case "CHANGE_VIEW_TYPE":
            viewType = action.viewType;
    }
    return viewType;
}
function $641adb510ed163e1$var$reduceDynamicOptionOverrides(dynamicOptionOverrides, action) {
    switch(action.type){
        case "SET_OPTION":
            return Object.assign(Object.assign({}, dynamicOptionOverrides), {
                [action.optionName]: action.rawOptionValue
            });
        default:
            return dynamicOptionOverrides;
    }
}
function $641adb510ed163e1$var$reduceDateProfile(currentDateProfile, action, currentDate, dateProfileGenerator) {
    let dp;
    switch(action.type){
        case "CHANGE_VIEW_TYPE":
            return dateProfileGenerator.build(action.dateMarker || currentDate);
        case "CHANGE_DATE":
            return dateProfileGenerator.build(action.dateMarker);
        case "PREV":
            dp = dateProfileGenerator.buildPrev(currentDateProfile, currentDate);
            if (dp.isValid) return dp;
            break;
        case "NEXT":
            dp = dateProfileGenerator.buildNext(currentDateProfile, currentDate);
            if (dp.isValid) return dp;
            break;
    }
    return currentDateProfile;
}
function $641adb510ed163e1$var$initEventSources(calendarOptions, dateProfile, context) {
    let activeRange = dateProfile ? dateProfile.activeRange : null;
    return $641adb510ed163e1$var$addSources({}, $641adb510ed163e1$var$parseInitialSources(calendarOptions, context), activeRange, context);
}
function $641adb510ed163e1$var$reduceEventSources(eventSources, action, dateProfile, context) {
    let activeRange = dateProfile ? dateProfile.activeRange : null; // need this check?
    switch(action.type){
        case "ADD_EVENT_SOURCES":
            return $641adb510ed163e1$var$addSources(eventSources, action.sources, activeRange, context);
        case "REMOVE_EVENT_SOURCE":
            return $641adb510ed163e1$var$removeSource(eventSources, action.sourceId);
        case "PREV":
        case "NEXT":
        case "CHANGE_DATE":
        case "CHANGE_VIEW_TYPE":
            if (dateProfile) return $641adb510ed163e1$var$fetchDirtySources(eventSources, activeRange, context);
            return eventSources;
        case "FETCH_EVENT_SOURCES":
            return $641adb510ed163e1$var$fetchSourcesByIds(eventSources, action.sourceIds ? (0, $5913100b2ed0f596$export$2d1720544b23b823)(action.sourceIds) : $641adb510ed163e1$var$excludeStaticSources(eventSources, context), activeRange, action.isRefetch || false, context);
        case "RECEIVE_EVENTS":
        case "RECEIVE_EVENT_ERROR":
            return $641adb510ed163e1$var$receiveResponse(eventSources, action.sourceId, action.fetchId, action.fetchRange);
        case "REMOVE_ALL_EVENT_SOURCES":
            return {};
        default:
            return eventSources;
    }
}
function $641adb510ed163e1$var$reduceEventSourcesNewTimeZone(eventSources, dateProfile, context) {
    let activeRange = dateProfile ? dateProfile.activeRange : null; // need this check?
    return $641adb510ed163e1$var$fetchSourcesByIds(eventSources, $641adb510ed163e1$var$excludeStaticSources(eventSources, context), activeRange, true, context);
}
function $641adb510ed163e1$var$computeEventSourcesLoading(eventSources) {
    for(let sourceId in eventSources){
        if (eventSources[sourceId].isFetching) return true;
    }
    return false;
}
function $641adb510ed163e1$var$addSources(eventSourceHash, sources, fetchRange, context) {
    let hash = {};
    for (let source of sources)hash[source.sourceId] = source;
    if (fetchRange) hash = $641adb510ed163e1$var$fetchDirtySources(hash, fetchRange, context);
    return Object.assign(Object.assign({}, eventSourceHash), hash);
}
function $641adb510ed163e1$var$removeSource(eventSourceHash, sourceId) {
    return (0, $5913100b2ed0f596$export$dda1d9f60106f0e9)(eventSourceHash, (eventSource)=>eventSource.sourceId !== sourceId);
}
function $641adb510ed163e1$var$fetchDirtySources(sourceHash, fetchRange, context) {
    return $641adb510ed163e1$var$fetchSourcesByIds(sourceHash, (0, $5913100b2ed0f596$export$dda1d9f60106f0e9)(sourceHash, (eventSource)=>$641adb510ed163e1$var$isSourceDirty(eventSource, fetchRange, context)), fetchRange, false, context);
}
function $641adb510ed163e1$var$isSourceDirty(eventSource, fetchRange, context) {
    if (!$641adb510ed163e1$var$doesSourceNeedRange(eventSource, context)) return !eventSource.latestFetchId;
    return !context.options.lazyFetching || !eventSource.fetchRange || eventSource.isFetching || // always cancel outdated in-progress fetches
    fetchRange.start < eventSource.fetchRange.start || fetchRange.end > eventSource.fetchRange.end;
}
function $641adb510ed163e1$var$fetchSourcesByIds(prevSources, sourceIdHash, fetchRange, isRefetch, context) {
    let nextSources = {};
    for(let sourceId in prevSources){
        let source = prevSources[sourceId];
        if (sourceIdHash[sourceId]) nextSources[sourceId] = $641adb510ed163e1$var$fetchSource(source, fetchRange, isRefetch, context);
        else nextSources[sourceId] = source;
    }
    return nextSources;
}
function $641adb510ed163e1$var$fetchSource(eventSource, fetchRange, isRefetch, context) {
    let { options: options, calendarApi: calendarApi } = context;
    let sourceDef = context.pluginHooks.eventSourceDefs[eventSource.sourceDefId];
    let fetchId = (0, $5913100b2ed0f596$export$39b482c5e57630a8)();
    sourceDef.fetch({
        eventSource: eventSource,
        range: fetchRange,
        isRefetch: isRefetch,
        context: context
    }, (res)=>{
        let { rawEvents: rawEvents } = res;
        if (options.eventSourceSuccess) rawEvents = options.eventSourceSuccess.call(calendarApi, rawEvents, res.response) || rawEvents;
        if (eventSource.success) rawEvents = eventSource.success.call(calendarApi, rawEvents, res.response) || rawEvents;
        context.dispatch({
            type: "RECEIVE_EVENTS",
            sourceId: eventSource.sourceId,
            fetchId: fetchId,
            fetchRange: fetchRange,
            rawEvents: rawEvents
        });
    }, (error)=>{
        let errorHandled = false;
        if (options.eventSourceFailure) {
            options.eventSourceFailure.call(calendarApi, error);
            errorHandled = true;
        }
        if (eventSource.failure) {
            eventSource.failure(error);
            errorHandled = true;
        }
        if (!errorHandled) console.warn(error.message, error);
        context.dispatch({
            type: "RECEIVE_EVENT_ERROR",
            sourceId: eventSource.sourceId,
            fetchId: fetchId,
            fetchRange: fetchRange,
            error: error
        });
    });
    return Object.assign(Object.assign({}, eventSource), {
        isFetching: true,
        latestFetchId: fetchId
    });
}
function $641adb510ed163e1$var$receiveResponse(sourceHash, sourceId, fetchId, fetchRange) {
    let eventSource = sourceHash[sourceId];
    if (eventSource && // not already removed
    fetchId === eventSource.latestFetchId) return Object.assign(Object.assign({}, sourceHash), {
        [sourceId]: Object.assign(Object.assign({}, eventSource), {
            isFetching: false,
            fetchRange: fetchRange
        })
    });
    return sourceHash;
}
function $641adb510ed163e1$var$excludeStaticSources(eventSources, context) {
    return (0, $5913100b2ed0f596$export$dda1d9f60106f0e9)(eventSources, (eventSource)=>$641adb510ed163e1$var$doesSourceNeedRange(eventSource, context));
}
function $641adb510ed163e1$var$parseInitialSources(rawOptions, context) {
    let refiners = (0, $5913100b2ed0f596$export$35e795649ee09318)(context);
    let rawSources = [].concat(rawOptions.eventSources || []);
    let sources = []; // parsed
    if (rawOptions.initialEvents) rawSources.unshift(rawOptions.initialEvents);
    if (rawOptions.events) rawSources.unshift(rawOptions.events);
    for (let rawSource of rawSources){
        let source = (0, $5913100b2ed0f596$export$ffb5f4729a158638)(rawSource, context, refiners);
        if (source) sources.push(source);
    }
    return sources;
}
function $641adb510ed163e1$var$doesSourceNeedRange(eventSource, context) {
    let defs = context.pluginHooks.eventSourceDefs;
    return !defs[eventSource.sourceDefId].ignoreRange;
}
function $641adb510ed163e1$var$reduceDateSelection(currentSelection, action) {
    switch(action.type){
        case "UNSELECT_DATES":
            return null;
        case "SELECT_DATES":
            return action.selection;
        default:
            return currentSelection;
    }
}
function $641adb510ed163e1$var$reduceSelectedEvent(currentInstanceId, action) {
    switch(action.type){
        case "UNSELECT_EVENT":
            return "";
        case "SELECT_EVENT":
            return action.eventInstanceId;
        default:
            return currentInstanceId;
    }
}
function $641adb510ed163e1$var$reduceEventDrag(currentDrag, action) {
    let newDrag;
    switch(action.type){
        case "UNSET_EVENT_DRAG":
            return null;
        case "SET_EVENT_DRAG":
            newDrag = action.state;
            return {
                affectedEvents: newDrag.affectedEvents,
                mutatedEvents: newDrag.mutatedEvents,
                isEvent: newDrag.isEvent
            };
        default:
            return currentDrag;
    }
}
function $641adb510ed163e1$var$reduceEventResize(currentResize, action) {
    let newResize;
    switch(action.type){
        case "UNSET_EVENT_RESIZE":
            return null;
        case "SET_EVENT_RESIZE":
            newResize = action.state;
            return {
                affectedEvents: newResize.affectedEvents,
                mutatedEvents: newResize.mutatedEvents,
                isEvent: newResize.isEvent
            };
        default:
            return currentResize;
    }
}
function $641adb510ed163e1$var$parseToolbars(calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) {
    let header = calendarOptions.headerToolbar ? $641adb510ed163e1$var$parseToolbar(calendarOptions.headerToolbar, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) : null;
    let footer = calendarOptions.footerToolbar ? $641adb510ed163e1$var$parseToolbar(calendarOptions.footerToolbar, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) : null;
    return {
        header: header,
        footer: footer
    };
}
function $641adb510ed163e1$var$parseToolbar(sectionStrHash, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) {
    let sectionWidgets = {};
    let viewsWithButtons = [];
    let hasTitle = false;
    for(let sectionName in sectionStrHash){
        let sectionStr = sectionStrHash[sectionName];
        let sectionRes = $641adb510ed163e1$var$parseSection(sectionStr, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi);
        sectionWidgets[sectionName] = sectionRes.widgets;
        viewsWithButtons.push(...sectionRes.viewsWithButtons);
        hasTitle = hasTitle || sectionRes.hasTitle;
    }
    return {
        sectionWidgets: sectionWidgets,
        viewsWithButtons: viewsWithButtons,
        hasTitle: hasTitle
    };
}
/*
BAD: querying icons and text here. should be done at render time
*/ function $641adb510ed163e1$var$parseSection(sectionStr, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) {
    let isRtl = calendarOptions.direction === "rtl";
    let calendarCustomButtons = calendarOptions.customButtons || {};
    let calendarButtonTextOverrides = calendarOptionOverrides.buttonText || {};
    let calendarButtonText = calendarOptions.buttonText || {};
    let calendarButtonHintOverrides = calendarOptionOverrides.buttonHints || {};
    let calendarButtonHints = calendarOptions.buttonHints || {};
    let sectionSubstrs = sectionStr ? sectionStr.split(" ") : [];
    let viewsWithButtons = [];
    let hasTitle = false;
    let widgets = sectionSubstrs.map((buttonGroupStr)=>buttonGroupStr.split(",").map((buttonName)=>{
            if (buttonName === "title") {
                hasTitle = true;
                return {
                    buttonName: buttonName
                };
            }
            let customButtonProps;
            let viewSpec;
            let buttonClick;
            let buttonIcon; // only one of these will be set
            let buttonText; // "
            let buttonHint;
            // ^ for the title="" attribute, for accessibility
            if (customButtonProps = calendarCustomButtons[buttonName]) {
                buttonClick = (ev)=>{
                    if (customButtonProps.click) customButtonProps.click.call(ev.target, ev, ev.target); // TODO: use Calendar this context?
                };
                (buttonIcon = theme.getCustomButtonIconClass(customButtonProps)) || (buttonIcon = theme.getIconClass(buttonName, isRtl)) || (buttonText = customButtonProps.text);
                buttonHint = customButtonProps.hint || customButtonProps.text;
            } else if (viewSpec = viewSpecs[buttonName]) {
                viewsWithButtons.push(buttonName);
                buttonClick = ()=>{
                    calendarApi.changeView(buttonName);
                };
                (buttonText = viewSpec.buttonTextOverride) || (buttonIcon = theme.getIconClass(buttonName, isRtl)) || (buttonText = viewSpec.buttonTextDefault);
                let textFallback = viewSpec.buttonTextOverride || viewSpec.buttonTextDefault;
                buttonHint = (0, $5913100b2ed0f596$export$342063e11d6c3cad)(viewSpec.buttonTitleOverride || viewSpec.buttonTitleDefault || calendarOptions.viewHint, [
                    textFallback,
                    buttonName
                ], textFallback);
            } else if (calendarApi[buttonName]) {
                buttonClick = ()=>{
                    calendarApi[buttonName]();
                };
                (buttonText = calendarButtonTextOverrides[buttonName]) || (buttonIcon = theme.getIconClass(buttonName, isRtl)) || (buttonText = calendarButtonText[buttonName]); // everything else is considered default
                if (buttonName === "prevYear" || buttonName === "nextYear") {
                    let prevOrNext = buttonName === "prevYear" ? "prev" : "next";
                    buttonHint = (0, $5913100b2ed0f596$export$342063e11d6c3cad)(calendarButtonHintOverrides[prevOrNext] || calendarButtonHints[prevOrNext], [
                        calendarButtonText.year || "year",
                        "year"
                    ], calendarButtonText[buttonName]);
                } else buttonHint = (navUnit)=>(0, $5913100b2ed0f596$export$342063e11d6c3cad)(calendarButtonHintOverrides[buttonName] || calendarButtonHints[buttonName], [
                        calendarButtonText[navUnit] || navUnit,
                        navUnit
                    ], calendarButtonText[buttonName]);
            }
            return {
                buttonName: buttonName,
                buttonClick: buttonClick,
                buttonIcon: buttonIcon,
                buttonText: buttonText,
                buttonHint: buttonHint
            };
        }));
    return {
        widgets: widgets,
        viewsWithButtons: viewsWithButtons,
        hasTitle: hasTitle
    };
}
// always represents the current view. otherwise, it'd need to change value every time date changes
class $641adb510ed163e1$var$ViewImpl {
    constructor(type, getCurrentData, dateEnv){
        this.type = type;
        this.getCurrentData = getCurrentData;
        this.dateEnv = dateEnv;
    }
    get calendar() {
        return this.getCurrentData().calendarApi;
    }
    get title() {
        return this.getCurrentData().viewTitle;
    }
    get activeStart() {
        return this.dateEnv.toDate(this.getCurrentData().dateProfile.activeRange.start);
    }
    get activeEnd() {
        return this.dateEnv.toDate(this.getCurrentData().dateProfile.activeRange.end);
    }
    get currentStart() {
        return this.dateEnv.toDate(this.getCurrentData().dateProfile.currentRange.start);
    }
    get currentEnd() {
        return this.dateEnv.toDate(this.getCurrentData().dateProfile.currentRange.end);
    }
    getOption(name) {
        return this.getCurrentData().options[name]; // are the view-specific options
    }
}
let $641adb510ed163e1$var$eventSourceDef$2 = {
    ignoreRange: true,
    parseMeta (refined) {
        if (Array.isArray(refined.events)) return refined.events;
        return null;
    },
    fetch (arg, successCallback) {
        successCallback({
            rawEvents: arg.eventSource.meta
        });
    }
};
const $641adb510ed163e1$var$arrayEventSourcePlugin = $641adb510ed163e1$export$ae829ec7b2625219({
    name: "array-event-source",
    eventSourceDefs: [
        $641adb510ed163e1$var$eventSourceDef$2
    ]
});
let $641adb510ed163e1$var$eventSourceDef$1 = {
    parseMeta (refined) {
        if (typeof refined.events === "function") return refined.events;
        return null;
    },
    fetch (arg, successCallback, errorCallback) {
        const { dateEnv: dateEnv } = arg.context;
        const func = arg.eventSource.meta;
        (0, $5913100b2ed0f596$export$3b14a55fb2447963)(func.bind(null, (0, $5913100b2ed0f596$export$882b5998b3b9117c)(arg.range, dateEnv)), (rawEvents)=>successCallback({
                rawEvents: rawEvents
            }), errorCallback);
    }
};
const $641adb510ed163e1$var$funcEventSourcePlugin = $641adb510ed163e1$export$ae829ec7b2625219({
    name: "func-event-source",
    eventSourceDefs: [
        $641adb510ed163e1$var$eventSourceDef$1
    ]
});
const $641adb510ed163e1$var$JSON_FEED_EVENT_SOURCE_REFINERS = {
    method: String,
    extraParams: (0, $5913100b2ed0f596$export$7ccc53e8f1e7dfc5),
    startParam: String,
    endParam: String,
    timeZoneParam: String
};
let $641adb510ed163e1$var$eventSourceDef = {
    parseMeta (refined) {
        if (refined.url && (refined.format === "json" || !refined.format)) return {
            url: refined.url,
            format: "json",
            method: (refined.method || "GET").toUpperCase(),
            extraParams: refined.extraParams,
            startParam: refined.startParam,
            endParam: refined.endParam,
            timeZoneParam: refined.timeZoneParam
        };
        return null;
    },
    fetch (arg, successCallback, errorCallback) {
        const { meta: meta } = arg.eventSource;
        const requestParams = $641adb510ed163e1$var$buildRequestParams(meta, arg.range, arg.context);
        (0, $5913100b2ed0f596$export$43caf9889c228507)(meta.method, meta.url, requestParams).then(([rawEvents, response])=>{
            successCallback({
                rawEvents: rawEvents,
                response: response
            });
        }, errorCallback);
    }
};
const $641adb510ed163e1$var$jsonFeedEventSourcePlugin = $641adb510ed163e1$export$ae829ec7b2625219({
    name: "json-event-source",
    eventSourceRefiners: $641adb510ed163e1$var$JSON_FEED_EVENT_SOURCE_REFINERS,
    eventSourceDefs: [
        $641adb510ed163e1$var$eventSourceDef
    ]
});
function $641adb510ed163e1$var$buildRequestParams(meta, range, context) {
    let { dateEnv: dateEnv, options: options } = context;
    let startParam;
    let endParam;
    let timeZoneParam;
    let customRequestParams;
    let params = {};
    startParam = meta.startParam;
    if (startParam == null) startParam = options.startParam;
    endParam = meta.endParam;
    if (endParam == null) endParam = options.endParam;
    timeZoneParam = meta.timeZoneParam;
    if (timeZoneParam == null) timeZoneParam = options.timeZoneParam;
    // retrieve any outbound GET/POST data from the options
    if (typeof meta.extraParams === "function") // supplied as a function that returns a key/value object
    customRequestParams = meta.extraParams();
    else // probably supplied as a straight key/value object
    customRequestParams = meta.extraParams || {};
    Object.assign(params, customRequestParams);
    params[startParam] = dateEnv.formatIso(range.start);
    params[endParam] = dateEnv.formatIso(range.end);
    if (dateEnv.timeZone !== "local") params[timeZoneParam] = dateEnv.timeZone;
    return params;
}
const $641adb510ed163e1$var$SIMPLE_RECURRING_REFINERS = {
    daysOfWeek: (0, $5913100b2ed0f596$export$7ccc53e8f1e7dfc5),
    startTime: (0, $5913100b2ed0f596$export$4368d992c4eafac0),
    endTime: (0, $5913100b2ed0f596$export$4368d992c4eafac0),
    duration: (0, $5913100b2ed0f596$export$4368d992c4eafac0),
    startRecur: (0, $5913100b2ed0f596$export$7ccc53e8f1e7dfc5),
    endRecur: (0, $5913100b2ed0f596$export$7ccc53e8f1e7dfc5)
};
let $641adb510ed163e1$var$recurring = {
    parse (refined, dateEnv) {
        if (refined.daysOfWeek || refined.startTime || refined.endTime || refined.startRecur || refined.endRecur) {
            let recurringData = {
                daysOfWeek: refined.daysOfWeek || null,
                startTime: refined.startTime || null,
                endTime: refined.endTime || null,
                startRecur: refined.startRecur ? dateEnv.createMarker(refined.startRecur) : null,
                endRecur: refined.endRecur ? dateEnv.createMarker(refined.endRecur) : null
            };
            let duration;
            if (refined.duration) duration = refined.duration;
            if (!duration && refined.startTime && refined.endTime) duration = (0, $5913100b2ed0f596$export$2408f22a0fab9ae5)(refined.endTime, refined.startTime);
            return {
                allDayGuess: Boolean(!refined.startTime && !refined.endTime),
                duration: duration,
                typeData: recurringData
            };
        }
        return null;
    },
    expand (typeData, framingRange, dateEnv) {
        let clippedFramingRange = (0, $5913100b2ed0f596$export$ae1af26003f05816)(framingRange, {
            start: typeData.startRecur,
            end: typeData.endRecur
        });
        if (clippedFramingRange) return $641adb510ed163e1$var$expandRanges(typeData.daysOfWeek, typeData.startTime, clippedFramingRange, dateEnv);
        return [];
    }
};
const $641adb510ed163e1$var$simpleRecurringEventsPlugin = $641adb510ed163e1$export$ae829ec7b2625219({
    name: "simple-recurring-event",
    recurringTypes: [
        $641adb510ed163e1$var$recurring
    ],
    eventRefiners: $641adb510ed163e1$var$SIMPLE_RECURRING_REFINERS
});
function $641adb510ed163e1$var$expandRanges(daysOfWeek, startTime, framingRange, dateEnv) {
    let dowHash = daysOfWeek ? (0, $5913100b2ed0f596$export$2d1720544b23b823)(daysOfWeek) : null;
    let dayMarker = (0, $5913100b2ed0f596$export$9e5f44173e64f162)(framingRange.start);
    let endMarker = framingRange.end;
    let instanceStarts = [];
    while(dayMarker < endMarker){
        let instanceStart;
        // if everyday, or this particular day-of-week
        if (!dowHash || dowHash[dayMarker.getUTCDay()]) {
            if (startTime) instanceStart = dateEnv.add(dayMarker, startTime);
            else instanceStart = dayMarker;
            instanceStarts.push(instanceStart);
        }
        dayMarker = (0, $5913100b2ed0f596$export$625550452a3fa3ec)(dayMarker, 1);
    }
    return instanceStarts;
}
const $641adb510ed163e1$var$changeHandlerPlugin = $641adb510ed163e1$export$ae829ec7b2625219({
    name: "change-handler",
    optionChangeHandlers: {
        events (events, context) {
            $641adb510ed163e1$var$handleEventSources([
                events
            ], context);
        },
        eventSources: $641adb510ed163e1$var$handleEventSources
    }
});
/*
BUG: if `event` was supplied, all previously-given `eventSources` will be wiped out
*/ function $641adb510ed163e1$var$handleEventSources(inputs, context) {
    let unfoundSources = (0, $5913100b2ed0f596$export$90a7f3efeed30595)(context.getCurrentData().eventSources);
    if (unfoundSources.length === 1 && inputs.length === 1 && Array.isArray(unfoundSources[0]._raw) && Array.isArray(inputs[0])) {
        context.dispatch({
            type: "RESET_RAW_EVENTS",
            sourceId: unfoundSources[0].sourceId,
            rawEvents: inputs[0]
        });
        return;
    }
    let newInputs = [];
    for (let input of inputs){
        let inputFound = false;
        for(let i = 0; i < unfoundSources.length; i += 1)if (unfoundSources[i]._raw === input) {
            unfoundSources.splice(i, 1); // delete
            inputFound = true;
            break;
        }
        if (!inputFound) newInputs.push(input);
    }
    for (let unfoundSource of unfoundSources)context.dispatch({
        type: "REMOVE_EVENT_SOURCE",
        sourceId: unfoundSource.sourceId
    });
    for (let newInput of newInputs)context.calendarApi.addEventSource(newInput);
}
function $641adb510ed163e1$var$handleDateProfile(dateProfile, context) {
    context.emitter.trigger("datesSet", Object.assign(Object.assign({}, (0, $5913100b2ed0f596$export$882b5998b3b9117c)(dateProfile.activeRange, context.dateEnv)), {
        view: context.viewApi
    }));
}
function $641adb510ed163e1$var$handleEventStore(eventStore, context) {
    let { emitter: emitter } = context;
    if (emitter.hasHandlers("eventsSet")) emitter.trigger("eventsSet", (0, $5913100b2ed0f596$export$efccba1c4a2ef57b)(eventStore, context));
}
/*
this array is exposed on the root namespace so that UMD plugins can add to it.
see the rollup-bundles script.
*/ const $641adb510ed163e1$export$905153d94e0757fa = [
    $641adb510ed163e1$var$arrayEventSourcePlugin,
    $641adb510ed163e1$var$funcEventSourcePlugin,
    $641adb510ed163e1$var$jsonFeedEventSourcePlugin,
    $641adb510ed163e1$var$simpleRecurringEventsPlugin,
    $641adb510ed163e1$var$changeHandlerPlugin,
    $641adb510ed163e1$export$ae829ec7b2625219({
        name: "misc",
        isLoadingFuncs: [
            (state)=>$641adb510ed163e1$var$computeEventSourcesLoading(state.eventSources)
        ],
        propSetHandlers: {
            dateProfile: $641adb510ed163e1$var$handleDateProfile,
            eventStore: $641adb510ed163e1$var$handleEventStore
        }
    })
];
class $641adb510ed163e1$var$TaskRunner {
    constructor(runTaskOption, drainedOption){
        this.runTaskOption = runTaskOption;
        this.drainedOption = drainedOption;
        this.queue = [];
        this.delayedRunner = new (0, $5913100b2ed0f596$export$96f57966bedc81b4)(this.drain.bind(this));
    }
    request(task, delay) {
        this.queue.push(task);
        this.delayedRunner.request(delay);
    }
    pause(scope) {
        this.delayedRunner.pause(scope);
    }
    resume(scope, force) {
        this.delayedRunner.resume(scope, force);
    }
    drain() {
        let { queue: queue } = this;
        while(queue.length){
            let completedTasks = [];
            let task;
            while(task = queue.shift()){
                this.runTask(task);
                completedTasks.push(task);
            }
            this.drained(completedTasks);
        } // keep going, in case new tasks were added in the drained handler
    }
    runTask(task) {
        if (this.runTaskOption) this.runTaskOption(task);
    }
    drained(completedTasks) {
        if (this.drainedOption) this.drainedOption(completedTasks);
    }
}
// Computes what the title at the top of the calendarApi should be for this view
function $641adb510ed163e1$var$buildTitle(dateProfile, viewOptions, dateEnv) {
    let range;
    // for views that span a large unit of time, show the proper interval, ignoring stray days before and after
    if (/^(year|month)$/.test(dateProfile.currentRangeUnit)) range = dateProfile.currentRange;
    else range = dateProfile.activeRange;
    return dateEnv.formatRange(range.start, range.end, (0, $5913100b2ed0f596$export$d141bba7fdc215a3)(viewOptions.titleFormat || $641adb510ed163e1$var$buildTitleFormat(dateProfile)), {
        isEndExclusive: dateProfile.isRangeAllDay,
        defaultSeparator: viewOptions.titleRangeSeparator
    });
}
// Generates the format string that should be used to generate the title for the current date range.
// Attempts to compute the most appropriate format if not explicitly specified with `titleFormat`.
function $641adb510ed163e1$var$buildTitleFormat(dateProfile) {
    let { currentRangeUnit: currentRangeUnit } = dateProfile;
    if (currentRangeUnit === "year") return {
        year: "numeric"
    };
    if (currentRangeUnit === "month") return {
        year: "numeric",
        month: "long"
    }; // like "September 2014"
    let days = (0, $5913100b2ed0f596$export$4a5767248b18ef41)(dateProfile.currentRange.start, dateProfile.currentRange.end);
    if (days !== null && days > 1) // multi-day range. shorter, like "Sep 9 - 10 2014"
    return {
        year: "numeric",
        month: "short",
        day: "numeric"
    };
    // one day. longer, like "September 9 2014"
    return {
        year: "numeric",
        month: "long",
        day: "numeric"
    };
}
// in future refactor, do the redux-style function(state=initial) for initial-state
// also, whatever is happening in constructor, have it happen in action queue too
class $641adb510ed163e1$var$CalendarDataManager {
    constructor(props){
        this.computeCurrentViewData = (0, $5913100b2ed0f596$export$df995fae86a55f06)(this._computeCurrentViewData);
        this.organizeRawLocales = (0, $5913100b2ed0f596$export$df995fae86a55f06)($641adb510ed163e1$var$organizeRawLocales);
        this.buildLocale = (0, $5913100b2ed0f596$export$df995fae86a55f06)($641adb510ed163e1$var$buildLocale);
        this.buildPluginHooks = $641adb510ed163e1$var$buildBuildPluginHooks();
        this.buildDateEnv = (0, $5913100b2ed0f596$export$df995fae86a55f06)($641adb510ed163e1$var$buildDateEnv$1);
        this.buildTheme = (0, $5913100b2ed0f596$export$df995fae86a55f06)($641adb510ed163e1$var$buildTheme);
        this.parseToolbars = (0, $5913100b2ed0f596$export$df995fae86a55f06)($641adb510ed163e1$var$parseToolbars);
        this.buildViewSpecs = (0, $5913100b2ed0f596$export$df995fae86a55f06)($641adb510ed163e1$var$buildViewSpecs);
        this.buildDateProfileGenerator = (0, $5913100b2ed0f596$export$ebd11618f299a286)($641adb510ed163e1$var$buildDateProfileGenerator);
        this.buildViewApi = (0, $5913100b2ed0f596$export$df995fae86a55f06)($641adb510ed163e1$var$buildViewApi);
        this.buildViewUiProps = (0, $5913100b2ed0f596$export$ebd11618f299a286)($641adb510ed163e1$var$buildViewUiProps);
        this.buildEventUiBySource = (0, $5913100b2ed0f596$export$df995fae86a55f06)($641adb510ed163e1$var$buildEventUiBySource, (0, $5913100b2ed0f596$export$a9c23c6ac3fc3eca));
        this.buildEventUiBases = (0, $5913100b2ed0f596$export$df995fae86a55f06)($641adb510ed163e1$var$buildEventUiBases);
        this.parseContextBusinessHours = (0, $5913100b2ed0f596$export$ebd11618f299a286)($641adb510ed163e1$var$parseContextBusinessHours);
        this.buildTitle = (0, $5913100b2ed0f596$export$df995fae86a55f06)($641adb510ed163e1$var$buildTitle);
        this.emitter = new (0, $5913100b2ed0f596$export$d66501df72047452)();
        this.actionRunner = new $641adb510ed163e1$var$TaskRunner(this._handleAction.bind(this), this.updateData.bind(this));
        this.currentCalendarOptionsInput = {};
        this.currentCalendarOptionsRefined = {};
        this.currentViewOptionsInput = {};
        this.currentViewOptionsRefined = {};
        this.currentCalendarOptionsRefiners = {};
        this.optionsForRefining = [];
        this.optionsForHandling = [];
        this.getCurrentData = ()=>this.data;
        this.dispatch = (action)=>{
            this.actionRunner.request(action); // protects against recursive calls to _handleAction
        };
        this.props = props;
        this.actionRunner.pause();
        let dynamicOptionOverrides = {};
        let optionsData = this.computeOptionsData(props.optionOverrides, dynamicOptionOverrides, props.calendarApi);
        let currentViewType = optionsData.calendarOptions.initialView || optionsData.pluginHooks.initialView;
        let currentViewData = this.computeCurrentViewData(currentViewType, optionsData, props.optionOverrides, dynamicOptionOverrides);
        // wire things up
        // TODO: not DRY
        props.calendarApi.currentDataManager = this;
        this.emitter.setThisContext(props.calendarApi);
        this.emitter.setOptions(currentViewData.options);
        let currentDate = (0, $5913100b2ed0f596$export$2329c99376c9d0a4)(optionsData.calendarOptions, optionsData.dateEnv);
        let dateProfile = currentViewData.dateProfileGenerator.build(currentDate);
        if (!(0, $5913100b2ed0f596$export$7f8ddf7c7c20b3cd)(dateProfile.activeRange, currentDate)) currentDate = dateProfile.currentRange.start;
        let calendarContext = {
            dateEnv: optionsData.dateEnv,
            options: optionsData.calendarOptions,
            pluginHooks: optionsData.pluginHooks,
            calendarApi: props.calendarApi,
            dispatch: this.dispatch,
            emitter: this.emitter,
            getCurrentData: this.getCurrentData
        };
        // needs to be after setThisContext
        for (let callback of optionsData.pluginHooks.contextInit)callback(calendarContext);
        // NOT DRY
        let eventSources = $641adb510ed163e1$var$initEventSources(optionsData.calendarOptions, dateProfile, calendarContext);
        let initialState = {
            dynamicOptionOverrides: dynamicOptionOverrides,
            currentViewType: currentViewType,
            currentDate: currentDate,
            dateProfile: dateProfile,
            businessHours: this.parseContextBusinessHours(calendarContext),
            eventSources: eventSources,
            eventUiBases: {},
            eventStore: (0, $5913100b2ed0f596$export$9bb611d729802a56)(),
            renderableEventStore: (0, $5913100b2ed0f596$export$9bb611d729802a56)(),
            dateSelection: null,
            eventSelection: "",
            eventDrag: null,
            eventResize: null,
            selectionConfig: this.buildViewUiProps(calendarContext).selectionConfig
        };
        let contextAndState = Object.assign(Object.assign({}, calendarContext), initialState);
        for (let reducer of optionsData.pluginHooks.reducers)Object.assign(initialState, reducer(null, null, contextAndState));
        if ($641adb510ed163e1$var$computeIsLoading(initialState, calendarContext)) this.emitter.trigger("loading", true); // NOT DRY
        this.state = initialState;
        this.updateData();
        this.actionRunner.resume();
    }
    resetOptions(optionOverrides, changedOptionNames) {
        let { props: props } = this;
        if (changedOptionNames === undefined) props.optionOverrides = optionOverrides;
        else {
            props.optionOverrides = Object.assign(Object.assign({}, props.optionOverrides || {}), optionOverrides);
            this.optionsForRefining.push(...changedOptionNames);
        }
        if (changedOptionNames === undefined || changedOptionNames.length) this.actionRunner.request({
            type: "NOTHING"
        });
    }
    _handleAction(action) {
        let { props: props, state: state, emitter: emitter } = this;
        let dynamicOptionOverrides = $641adb510ed163e1$var$reduceDynamicOptionOverrides(state.dynamicOptionOverrides, action);
        let optionsData = this.computeOptionsData(props.optionOverrides, dynamicOptionOverrides, props.calendarApi);
        let currentViewType = $641adb510ed163e1$var$reduceViewType(state.currentViewType, action);
        let currentViewData = this.computeCurrentViewData(currentViewType, optionsData, props.optionOverrides, dynamicOptionOverrides);
        // wire things up
        // TODO: not DRY
        props.calendarApi.currentDataManager = this;
        emitter.setThisContext(props.calendarApi);
        emitter.setOptions(currentViewData.options);
        let calendarContext = {
            dateEnv: optionsData.dateEnv,
            options: optionsData.calendarOptions,
            pluginHooks: optionsData.pluginHooks,
            calendarApi: props.calendarApi,
            dispatch: this.dispatch,
            emitter: emitter,
            getCurrentData: this.getCurrentData
        };
        let { currentDate: currentDate, dateProfile: dateProfile } = state;
        if (this.data && this.data.dateProfileGenerator !== currentViewData.dateProfileGenerator) dateProfile = currentViewData.dateProfileGenerator.build(currentDate);
        currentDate = (0, $5913100b2ed0f596$export$b4171a6734a65d42)(currentDate, action);
        dateProfile = $641adb510ed163e1$var$reduceDateProfile(dateProfile, action, currentDate, currentViewData.dateProfileGenerator);
        if (action.type === "PREV" || // TODO: move this logic into DateProfileGenerator
        action.type === "NEXT" || // "
        !(0, $5913100b2ed0f596$export$7f8ddf7c7c20b3cd)(dateProfile.currentRange, currentDate)) currentDate = dateProfile.currentRange.start;
        let eventSources = $641adb510ed163e1$var$reduceEventSources(state.eventSources, action, dateProfile, calendarContext);
        let eventStore = (0, $5913100b2ed0f596$export$3466f893ebf79586)(state.eventStore, action, eventSources, dateProfile, calendarContext);
        let isEventsLoading = $641adb510ed163e1$var$computeEventSourcesLoading(eventSources); // BAD. also called in this func in computeIsLoading
        let renderableEventStore = isEventsLoading && !currentViewData.options.progressiveEventRendering ? state.renderableEventStore || eventStore : eventStore;
        let { eventUiSingleBase: eventUiSingleBase, selectionConfig: selectionConfig } = this.buildViewUiProps(calendarContext); // will memoize obj
        let eventUiBySource = this.buildEventUiBySource(eventSources);
        let eventUiBases = this.buildEventUiBases(renderableEventStore.defs, eventUiSingleBase, eventUiBySource);
        let newState = {
            dynamicOptionOverrides: dynamicOptionOverrides,
            currentViewType: currentViewType,
            currentDate: currentDate,
            dateProfile: dateProfile,
            eventSources: eventSources,
            eventStore: eventStore,
            renderableEventStore: renderableEventStore,
            selectionConfig: selectionConfig,
            eventUiBases: eventUiBases,
            businessHours: this.parseContextBusinessHours(calendarContext),
            dateSelection: $641adb510ed163e1$var$reduceDateSelection(state.dateSelection, action),
            eventSelection: $641adb510ed163e1$var$reduceSelectedEvent(state.eventSelection, action),
            eventDrag: $641adb510ed163e1$var$reduceEventDrag(state.eventDrag, action),
            eventResize: $641adb510ed163e1$var$reduceEventResize(state.eventResize, action)
        };
        let contextAndState = Object.assign(Object.assign({}, calendarContext), newState);
        for (let reducer of optionsData.pluginHooks.reducers)Object.assign(newState, reducer(state, action, contextAndState)); // give the OLD state, for old value
        let wasLoading = $641adb510ed163e1$var$computeIsLoading(state, calendarContext);
        let isLoading = $641adb510ed163e1$var$computeIsLoading(newState, calendarContext);
        // TODO: use propSetHandlers in plugin system
        if (!wasLoading && isLoading) emitter.trigger("loading", true);
        else if (wasLoading && !isLoading) emitter.trigger("loading", false);
        this.state = newState;
        if (props.onAction) props.onAction(action);
    }
    updateData() {
        let { props: props, state: state } = this;
        let oldData = this.data;
        let optionsData = this.computeOptionsData(props.optionOverrides, state.dynamicOptionOverrides, props.calendarApi);
        let currentViewData = this.computeCurrentViewData(state.currentViewType, optionsData, props.optionOverrides, state.dynamicOptionOverrides);
        let data = this.data = Object.assign(Object.assign(Object.assign({
            viewTitle: this.buildTitle(state.dateProfile, currentViewData.options, optionsData.dateEnv),
            calendarApi: props.calendarApi,
            dispatch: this.dispatch,
            emitter: this.emitter,
            getCurrentData: this.getCurrentData
        }, optionsData), currentViewData), state);
        let changeHandlers = optionsData.pluginHooks.optionChangeHandlers;
        let oldCalendarOptions = oldData && oldData.calendarOptions;
        let newCalendarOptions = optionsData.calendarOptions;
        if (oldCalendarOptions && oldCalendarOptions !== newCalendarOptions) {
            if (oldCalendarOptions.timeZone !== newCalendarOptions.timeZone) {
                // hack
                state.eventSources = data.eventSources = $641adb510ed163e1$var$reduceEventSourcesNewTimeZone(data.eventSources, state.dateProfile, data);
                state.eventStore = data.eventStore = (0, $5913100b2ed0f596$export$61196ced6d74a310)(data.eventStore, oldData.dateEnv, data.dateEnv);
                state.renderableEventStore = data.renderableEventStore = (0, $5913100b2ed0f596$export$61196ced6d74a310)(data.renderableEventStore, oldData.dateEnv, data.dateEnv);
            }
            for(let optionName in changeHandlers)if (this.optionsForHandling.indexOf(optionName) !== -1 || oldCalendarOptions[optionName] !== newCalendarOptions[optionName]) changeHandlers[optionName](newCalendarOptions[optionName], data);
        }
        this.optionsForHandling = [];
        if (props.onData) props.onData(data);
    }
    computeOptionsData(optionOverrides, dynamicOptionOverrides, calendarApi) {
        // TODO: blacklist options that are handled by optionChangeHandlers
        if (!this.optionsForRefining.length && optionOverrides === this.stableOptionOverrides && dynamicOptionOverrides === this.stableDynamicOptionOverrides) return this.stableCalendarOptionsData;
        let { refinedOptions: refinedOptions, pluginHooks: pluginHooks, localeDefaults: localeDefaults, availableLocaleData: availableLocaleData, extra: extra } = this.processRawCalendarOptions(optionOverrides, dynamicOptionOverrides);
        $641adb510ed163e1$var$warnUnknownOptions(extra);
        let dateEnv = this.buildDateEnv(refinedOptions.timeZone, refinedOptions.locale, refinedOptions.weekNumberCalculation, refinedOptions.firstDay, refinedOptions.weekText, pluginHooks, availableLocaleData, refinedOptions.defaultRangeSeparator);
        let viewSpecs = this.buildViewSpecs(pluginHooks.views, this.stableOptionOverrides, this.stableDynamicOptionOverrides, localeDefaults);
        let theme = this.buildTheme(refinedOptions, pluginHooks);
        let toolbarConfig = this.parseToolbars(refinedOptions, this.stableOptionOverrides, theme, viewSpecs, calendarApi);
        return this.stableCalendarOptionsData = {
            calendarOptions: refinedOptions,
            pluginHooks: pluginHooks,
            dateEnv: dateEnv,
            viewSpecs: viewSpecs,
            theme: theme,
            toolbarConfig: toolbarConfig,
            localeDefaults: localeDefaults,
            availableRawLocales: availableLocaleData.map
        };
    }
    // always called from behind a memoizer
    processRawCalendarOptions(optionOverrides, dynamicOptionOverrides) {
        let { locales: locales, locale: locale } = (0, $5913100b2ed0f596$export$3a1a48c8f6ef640e)([
            (0, $5913100b2ed0f596$export$f1e1789686576879),
            optionOverrides,
            dynamicOptionOverrides
        ]);
        let availableLocaleData = this.organizeRawLocales(locales);
        let availableRawLocales = availableLocaleData.map;
        let localeDefaults = this.buildLocale(locale || availableLocaleData.defaultCode, availableRawLocales).options;
        let pluginHooks = this.buildPluginHooks(optionOverrides.plugins || [], $641adb510ed163e1$export$905153d94e0757fa);
        let refiners = this.currentCalendarOptionsRefiners = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (0, $5913100b2ed0f596$export$a07804094c3ecf2d)), (0, $5913100b2ed0f596$export$c4ce752e73470fba)), (0, $5913100b2ed0f596$export$56c0d5a1e737357d)), pluginHooks.listenerRefiners), pluginHooks.optionRefiners);
        let extra = {};
        let raw = (0, $5913100b2ed0f596$export$3a1a48c8f6ef640e)([
            (0, $5913100b2ed0f596$export$f1e1789686576879),
            localeDefaults,
            optionOverrides,
            dynamicOptionOverrides
        ]);
        let refined = {};
        let currentRaw = this.currentCalendarOptionsInput;
        let currentRefined = this.currentCalendarOptionsRefined;
        let anyChanges = false;
        for(let optionName in raw){
            if (this.optionsForRefining.indexOf(optionName) === -1 && (raw[optionName] === currentRaw[optionName] || (0, $5913100b2ed0f596$export$3722cfe417b6ed86)[optionName] && optionName in currentRaw && (0, $5913100b2ed0f596$export$3722cfe417b6ed86)[optionName](currentRaw[optionName], raw[optionName]))) refined[optionName] = currentRefined[optionName];
            else if (refiners[optionName]) {
                refined[optionName] = refiners[optionName](raw[optionName]);
                anyChanges = true;
            } else extra[optionName] = currentRaw[optionName];
        }
        if (anyChanges) {
            this.currentCalendarOptionsInput = raw;
            this.currentCalendarOptionsRefined = refined;
            this.stableOptionOverrides = optionOverrides;
            this.stableDynamicOptionOverrides = dynamicOptionOverrides;
        }
        this.optionsForHandling.push(...this.optionsForRefining);
        this.optionsForRefining = [];
        return {
            rawOptions: this.currentCalendarOptionsInput,
            refinedOptions: this.currentCalendarOptionsRefined,
            pluginHooks: pluginHooks,
            availableLocaleData: availableLocaleData,
            localeDefaults: localeDefaults,
            extra: extra
        };
    }
    _computeCurrentViewData(viewType, optionsData, optionOverrides, dynamicOptionOverrides) {
        let viewSpec = optionsData.viewSpecs[viewType];
        if (!viewSpec) throw new Error(`viewType "${viewType}" is not available. Please make sure you've loaded all neccessary plugins`);
        let { refinedOptions: refinedOptions, extra: extra } = this.processRawViewOptions(viewSpec, optionsData.pluginHooks, optionsData.localeDefaults, optionOverrides, dynamicOptionOverrides);
        $641adb510ed163e1$var$warnUnknownOptions(extra);
        let dateProfileGenerator = this.buildDateProfileGenerator({
            dateProfileGeneratorClass: viewSpec.optionDefaults.dateProfileGeneratorClass,
            duration: viewSpec.duration,
            durationUnit: viewSpec.durationUnit,
            usesMinMaxTime: viewSpec.optionDefaults.usesMinMaxTime,
            dateEnv: optionsData.dateEnv,
            calendarApi: this.props.calendarApi,
            slotMinTime: refinedOptions.slotMinTime,
            slotMaxTime: refinedOptions.slotMaxTime,
            showNonCurrentDates: refinedOptions.showNonCurrentDates,
            dayCount: refinedOptions.dayCount,
            dateAlignment: refinedOptions.dateAlignment,
            dateIncrement: refinedOptions.dateIncrement,
            hiddenDays: refinedOptions.hiddenDays,
            weekends: refinedOptions.weekends,
            nowInput: refinedOptions.now,
            validRangeInput: refinedOptions.validRange,
            visibleRangeInput: refinedOptions.visibleRange,
            fixedWeekCount: refinedOptions.fixedWeekCount
        });
        let viewApi = this.buildViewApi(viewType, this.getCurrentData, optionsData.dateEnv);
        return {
            viewSpec: viewSpec,
            options: refinedOptions,
            dateProfileGenerator: dateProfileGenerator,
            viewApi: viewApi
        };
    }
    processRawViewOptions(viewSpec, pluginHooks, localeDefaults, optionOverrides, dynamicOptionOverrides) {
        let raw = (0, $5913100b2ed0f596$export$3a1a48c8f6ef640e)([
            (0, $5913100b2ed0f596$export$f1e1789686576879),
            viewSpec.optionDefaults,
            localeDefaults,
            optionOverrides,
            viewSpec.optionOverrides,
            dynamicOptionOverrides
        ]);
        let refiners = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (0, $5913100b2ed0f596$export$a07804094c3ecf2d)), (0, $5913100b2ed0f596$export$c4ce752e73470fba)), (0, $5913100b2ed0f596$export$56c0d5a1e737357d)), (0, $5913100b2ed0f596$export$db202ddc8be9136)), pluginHooks.listenerRefiners), pluginHooks.optionRefiners);
        let refined = {};
        let currentRaw = this.currentViewOptionsInput;
        let currentRefined = this.currentViewOptionsRefined;
        let anyChanges = false;
        let extra = {};
        for(let optionName in raw)if (raw[optionName] === currentRaw[optionName] || (0, $5913100b2ed0f596$export$3722cfe417b6ed86)[optionName] && (0, $5913100b2ed0f596$export$3722cfe417b6ed86)[optionName](raw[optionName], currentRaw[optionName])) refined[optionName] = currentRefined[optionName];
        else {
            if (raw[optionName] === this.currentCalendarOptionsInput[optionName] || (0, $5913100b2ed0f596$export$3722cfe417b6ed86)[optionName] && (0, $5913100b2ed0f596$export$3722cfe417b6ed86)[optionName](raw[optionName], this.currentCalendarOptionsInput[optionName])) {
                if (optionName in this.currentCalendarOptionsRefined) refined[optionName] = this.currentCalendarOptionsRefined[optionName];
            } else if (refiners[optionName]) refined[optionName] = refiners[optionName](raw[optionName]);
            else extra[optionName] = raw[optionName];
            anyChanges = true;
        }
        if (anyChanges) {
            this.currentViewOptionsInput = raw;
            this.currentViewOptionsRefined = refined;
        }
        return {
            rawOptions: this.currentViewOptionsInput,
            refinedOptions: this.currentViewOptionsRefined,
            extra: extra
        };
    }
}
function $641adb510ed163e1$var$buildDateEnv$1(timeZone, explicitLocale, weekNumberCalculation, firstDay, weekText, pluginHooks, availableLocaleData, defaultSeparator) {
    let locale = $641adb510ed163e1$var$buildLocale(explicitLocale || availableLocaleData.defaultCode, availableLocaleData.map);
    return new (0, $5913100b2ed0f596$export$25ce5a424b770e84)({
        calendarSystem: "gregory",
        timeZone: timeZone,
        namedTimeZoneImpl: pluginHooks.namedTimeZonedImpl,
        locale: locale,
        weekNumberCalculation: weekNumberCalculation,
        firstDay: firstDay,
        weekText: weekText,
        cmdFormatter: pluginHooks.cmdFormatter,
        defaultSeparator: defaultSeparator
    });
}
function $641adb510ed163e1$var$buildTheme(options, pluginHooks) {
    let ThemeClass = pluginHooks.themeClasses[options.themeSystem] || $641adb510ed163e1$var$StandardTheme;
    return new ThemeClass(options);
}
function $641adb510ed163e1$var$buildDateProfileGenerator(props) {
    let DateProfileGeneratorClass = props.dateProfileGeneratorClass || (0, $5913100b2ed0f596$export$3a6d5c9ae78a2c08);
    return new DateProfileGeneratorClass(props);
}
function $641adb510ed163e1$var$buildViewApi(type, getCurrentData, dateEnv) {
    return new $641adb510ed163e1$var$ViewImpl(type, getCurrentData, dateEnv);
}
function $641adb510ed163e1$var$buildEventUiBySource(eventSources) {
    return (0, $5913100b2ed0f596$export$407448d2b89b1813)(eventSources, (eventSource)=>eventSource.ui);
}
function $641adb510ed163e1$var$buildEventUiBases(eventDefs, eventUiSingleBase, eventUiBySource) {
    let eventUiBases = {
        "": eventUiSingleBase
    };
    for(let defId in eventDefs){
        let def = eventDefs[defId];
        if (def.sourceId && eventUiBySource[def.sourceId]) eventUiBases[defId] = eventUiBySource[def.sourceId];
    }
    return eventUiBases;
}
function $641adb510ed163e1$var$buildViewUiProps(calendarContext) {
    let { options: options } = calendarContext;
    return {
        eventUiSingleBase: (0, $5913100b2ed0f596$export$71cec2538cb2c617)({
            display: options.eventDisplay,
            editable: options.editable,
            startEditable: options.eventStartEditable,
            durationEditable: options.eventDurationEditable,
            constraint: options.eventConstraint,
            overlap: typeof options.eventOverlap === "boolean" ? options.eventOverlap : undefined,
            allow: options.eventAllow,
            backgroundColor: options.eventBackgroundColor,
            borderColor: options.eventBorderColor,
            textColor: options.eventTextColor,
            color: options.eventColor
        }, calendarContext),
        selectionConfig: (0, $5913100b2ed0f596$export$71cec2538cb2c617)({
            constraint: options.selectConstraint,
            overlap: typeof options.selectOverlap === "boolean" ? options.selectOverlap : undefined,
            allow: options.selectAllow
        }, calendarContext)
    };
}
function $641adb510ed163e1$var$computeIsLoading(state, context) {
    for (let isLoadingFunc of context.pluginHooks.isLoadingFuncs){
        if (isLoadingFunc(state)) return true;
    }
    return false;
}
function $641adb510ed163e1$var$parseContextBusinessHours(calendarContext) {
    return (0, $5913100b2ed0f596$export$78acf4525d8a74c4)(calendarContext.options.businessHours, calendarContext);
}
function $641adb510ed163e1$var$warnUnknownOptions(options, viewName) {
    for(let optionName in options)console.warn(`Unknown option '${optionName}'` + (viewName ? ` for view '${viewName}'` : ""));
}
class $641adb510ed163e1$var$ToolbarSection extends (0, $5913100b2ed0f596$export$ef35774e6d314e91) {
    render() {
        let children = this.props.widgetGroups.map((widgetGroup)=>this.renderWidgetGroup(widgetGroup));
        return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("div", {
            className: "fc-toolbar-chunk"
        }, ...children);
    }
    renderWidgetGroup(widgetGroup) {
        let { props: props } = this;
        let { theme: theme } = this.context;
        let children = [];
        let isOnlyButtons = true;
        for (let widget of widgetGroup){
            let { buttonName: buttonName, buttonClick: buttonClick, buttonText: buttonText, buttonIcon: buttonIcon, buttonHint: buttonHint } = widget;
            if (buttonName === "title") {
                isOnlyButtons = false;
                children.push((0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("h2", {
                    className: "fc-toolbar-title",
                    id: props.titleId
                }, props.title));
            } else {
                let isPressed = buttonName === props.activeButton;
                let isDisabled = !props.isTodayEnabled && buttonName === "today" || !props.isPrevEnabled && buttonName === "prev" || !props.isNextEnabled && buttonName === "next";
                let buttonClasses = [
                    `fc-${buttonName}-button`,
                    theme.getClass("button")
                ];
                if (isPressed) buttonClasses.push(theme.getClass("buttonActive"));
                children.push((0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("button", {
                    type: "button",
                    title: typeof buttonHint === "function" ? buttonHint(props.navUnit) : buttonHint,
                    disabled: isDisabled,
                    "aria-pressed": isPressed,
                    className: buttonClasses.join(" "),
                    onClick: buttonClick
                }, buttonText || (buttonIcon ? (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("span", {
                    className: buttonIcon,
                    role: "img"
                }) : "")));
            }
        }
        if (children.length > 1) {
            let groupClassName = isOnlyButtons && theme.getClass("buttonGroup") || "";
            return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("div", {
                className: groupClassName
            }, ...children);
        }
        return children[0];
    }
}
class $641adb510ed163e1$var$Toolbar extends (0, $5913100b2ed0f596$export$ef35774e6d314e91) {
    render() {
        let { model: model, extraClassName: extraClassName } = this.props;
        let forceLtr = false;
        let startContent;
        let endContent;
        let sectionWidgets = model.sectionWidgets;
        let centerContent = sectionWidgets.center;
        if (sectionWidgets.left) {
            forceLtr = true;
            startContent = sectionWidgets.left;
        } else startContent = sectionWidgets.start;
        if (sectionWidgets.right) {
            forceLtr = true;
            endContent = sectionWidgets.right;
        } else endContent = sectionWidgets.end;
        let classNames = [
            extraClassName || "",
            "fc-toolbar",
            forceLtr ? "fc-toolbar-ltr" : ""
        ];
        return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("div", {
            className: classNames.join(" ")
        }, this.renderSection("start", startContent || []), this.renderSection("center", centerContent || []), this.renderSection("end", endContent || []));
    }
    renderSection(key, widgetGroups) {
        let { props: props } = this;
        return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)($641adb510ed163e1$var$ToolbarSection, {
            key: key,
            widgetGroups: widgetGroups,
            title: props.title,
            navUnit: props.navUnit,
            activeButton: props.activeButton,
            isTodayEnabled: props.isTodayEnabled,
            isPrevEnabled: props.isPrevEnabled,
            isNextEnabled: props.isNextEnabled,
            titleId: props.titleId
        });
    }
}
class $641adb510ed163e1$var$ViewHarness extends (0, $5913100b2ed0f596$export$ef35774e6d314e91) {
    constructor(){
        super(...arguments);
        this.state = {
            availableWidth: null
        };
        this.handleEl = (el)=>{
            this.el = el;
            (0, $5913100b2ed0f596$export$8743009a87fcb00f)(this.props.elRef, el);
            this.updateAvailableWidth();
        };
        this.handleResize = ()=>{
            this.updateAvailableWidth();
        };
    }
    render() {
        let { props: props, state: state } = this;
        let { aspectRatio: aspectRatio } = props;
        let classNames = [
            "fc-view-harness",
            aspectRatio || props.liquid || props.height ? "fc-view-harness-active" // harness controls the height
             : "fc-view-harness-passive"
        ];
        let height = "";
        let paddingBottom = "";
        if (aspectRatio) {
            if (state.availableWidth !== null) height = state.availableWidth / aspectRatio;
            else // while waiting to know availableWidth, we can't set height to *zero*
            // because will cause lots of unnecessary scrollbars within scrollgrid.
            // BETTER: don't start rendering ANYTHING yet until we know container width
            // NOTE: why not always use paddingBottom? Causes height oscillation (issue 5606)
            paddingBottom = `${1 / aspectRatio * 100}%`;
        } else height = props.height || "";
        return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("div", {
            "aria-labelledby": props.labeledById,
            ref: this.handleEl,
            className: classNames.join(" "),
            style: {
                height: height,
                paddingBottom: paddingBottom
            }
        }, props.children);
    }
    componentDidMount() {
        this.context.addResizeHandler(this.handleResize);
    }
    componentWillUnmount() {
        this.context.removeResizeHandler(this.handleResize);
    }
    updateAvailableWidth() {
        if (this.el && // needed. but why?
        this.props.aspectRatio // aspectRatio is the only height setting that needs availableWidth
        ) this.setState({
            availableWidth: this.el.offsetWidth
        });
    }
}
/*
Detects when the user clicks on an event within a DateComponent
*/ class $641adb510ed163e1$var$EventClicking extends (0, $5913100b2ed0f596$export$dc98b0b04f4c7758) {
    constructor(settings){
        super(settings);
        this.handleSegClick = (ev, segEl)=>{
            let { component: component } = this;
            let { context: context } = component;
            let seg = (0, $5913100b2ed0f596$export$71511d61b312f219)(segEl);
            if (seg && // might be the <div> surrounding the more link
            component.isValidSegDownEl(ev.target)) {
                // our way to simulate a link click for elements that can't be <a> tags
                // grab before trigger fired in case trigger trashes DOM thru rerendering
                let hasUrlContainer = (0, $5913100b2ed0f596$export$3d8c2f653ac9d0b9)(ev.target, ".fc-event-forced-url");
                let url = hasUrlContainer ? hasUrlContainer.querySelector("a[href]").href : "";
                context.emitter.trigger("eventClick", {
                    el: segEl,
                    event: new (0, $5913100b2ed0f596$export$34aec0b863436764)(component.context, seg.eventRange.def, seg.eventRange.instance),
                    jsEvent: ev,
                    view: context.viewApi
                });
                if (url && !ev.defaultPrevented) window.location.href = url;
            }
        };
        this.destroy = (0, $5913100b2ed0f596$export$3c2fa207a37baaea)(settings.el, "click", ".fc-event", this.handleSegClick);
    }
}
/*
Triggers events and adds/removes core classNames when the user's pointer
enters/leaves event-elements of a component.
*/ class $641adb510ed163e1$var$EventHovering extends (0, $5913100b2ed0f596$export$dc98b0b04f4c7758) {
    constructor(settings){
        super(settings);
        // for simulating an eventMouseLeave when the event el is destroyed while mouse is over it
        this.handleEventElRemove = (el)=>{
            if (el === this.currentSegEl) this.handleSegLeave(null, this.currentSegEl);
        };
        this.handleSegEnter = (ev, segEl)=>{
            if ((0, $5913100b2ed0f596$export$71511d61b312f219)(segEl)) {
                this.currentSegEl = segEl;
                this.triggerEvent("eventMouseEnter", ev, segEl);
            }
        };
        this.handleSegLeave = (ev, segEl)=>{
            if (this.currentSegEl) {
                this.currentSegEl = null;
                this.triggerEvent("eventMouseLeave", ev, segEl);
            }
        };
        this.removeHoverListeners = (0, $5913100b2ed0f596$export$ce26c07117d59d6a)(settings.el, ".fc-event", this.handleSegEnter, this.handleSegLeave);
    }
    destroy() {
        this.removeHoverListeners();
    }
    triggerEvent(publicEvName, ev, segEl) {
        let { component: component } = this;
        let { context: context } = component;
        let seg = (0, $5913100b2ed0f596$export$71511d61b312f219)(segEl);
        if (!ev || component.isValidSegDownEl(ev.target)) context.emitter.trigger(publicEvName, {
            el: segEl,
            event: new (0, $5913100b2ed0f596$export$34aec0b863436764)(context, seg.eventRange.def, seg.eventRange.instance),
            jsEvent: ev,
            view: context.viewApi
        });
    }
}
class $641adb510ed163e1$var$CalendarContent extends (0, $5913100b2ed0f596$export$6559d589eb85fbb6) {
    constructor(){
        super(...arguments);
        this.buildViewContext = (0, $5913100b2ed0f596$export$df995fae86a55f06)((0, $5913100b2ed0f596$export$efca4cbe5dd06740));
        this.buildViewPropTransformers = (0, $5913100b2ed0f596$export$df995fae86a55f06)($641adb510ed163e1$var$buildViewPropTransformers);
        this.buildToolbarProps = (0, $5913100b2ed0f596$export$df995fae86a55f06)($641adb510ed163e1$var$buildToolbarProps);
        this.headerRef = (0, $450fc775b2f7950e$export$7d1e3a5e95ceca43)();
        this.footerRef = (0, $450fc775b2f7950e$export$7d1e3a5e95ceca43)();
        this.interactionsStore = {};
        // eslint-disable-next-line
        this.state = {
            viewLabelId: (0, $5913100b2ed0f596$export$a8550f7dbe79f93a)()
        };
        // Component Registration
        // -----------------------------------------------------------------------------------------------------------------
        this.registerInteractiveComponent = (component, settingsInput)=>{
            let settings = (0, $5913100b2ed0f596$export$2e2af4578d910ddf)(component, settingsInput);
            let DEFAULT_INTERACTIONS = [
                $641adb510ed163e1$var$EventClicking,
                $641adb510ed163e1$var$EventHovering
            ];
            let interactionClasses = DEFAULT_INTERACTIONS.concat(this.props.pluginHooks.componentInteractions);
            let interactions = interactionClasses.map((TheInteractionClass)=>new TheInteractionClass(settings));
            this.interactionsStore[component.uid] = interactions;
            (0, $5913100b2ed0f596$export$a93c5207d687da10)[component.uid] = settings;
        };
        this.unregisterInteractiveComponent = (component)=>{
            let listeners = this.interactionsStore[component.uid];
            if (listeners) {
                for (let listener of listeners)listener.destroy();
                delete this.interactionsStore[component.uid];
            }
            delete (0, $5913100b2ed0f596$export$a93c5207d687da10)[component.uid];
        };
        // Resizing
        // -----------------------------------------------------------------------------------------------------------------
        this.resizeRunner = new (0, $5913100b2ed0f596$export$96f57966bedc81b4)(()=>{
            this.props.emitter.trigger("_resize", true); // should window resizes be considered "forced" ?
            this.props.emitter.trigger("windowResize", {
                view: this.props.viewApi
            });
        });
        this.handleWindowResize = (ev)=>{
            let { options: options } = this.props;
            if (options.handleWindowResize && ev.target === window // avoid jqui events
            ) this.resizeRunner.request(options.windowResizeDelay);
        };
    }
    /*
    renders INSIDE of an outer div
    */ render() {
        let { props: props } = this;
        let { toolbarConfig: toolbarConfig, options: options } = props;
        let toolbarProps = this.buildToolbarProps(props.viewSpec, props.dateProfile, props.dateProfileGenerator, props.currentDate, (0, $5913100b2ed0f596$export$c3950d9923825c02)(props.options.now, props.dateEnv), props.viewTitle);
        let viewVGrow = false;
        let viewHeight = "";
        let viewAspectRatio;
        if (props.isHeightAuto || props.forPrint) viewHeight = "";
        else if (options.height != null) viewVGrow = true;
        else if (options.contentHeight != null) viewHeight = options.contentHeight;
        else viewAspectRatio = Math.max(options.aspectRatio, 0.5); // prevent from getting too tall
        let viewContext = this.buildViewContext(props.viewSpec, props.viewApi, props.options, props.dateProfileGenerator, props.dateEnv, props.theme, props.pluginHooks, props.dispatch, props.getCurrentData, props.emitter, props.calendarApi, this.registerInteractiveComponent, this.unregisterInteractiveComponent);
        let viewLabelId = toolbarConfig.header && toolbarConfig.header.hasTitle ? this.state.viewLabelId : undefined;
        return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)((0, $5913100b2ed0f596$export$e7c866399fa523f5).Provider, {
            value: viewContext
        }, toolbarConfig.header && (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)($641adb510ed163e1$var$Toolbar, Object.assign({
            ref: this.headerRef,
            extraClassName: "fc-header-toolbar",
            model: toolbarConfig.header,
            titleId: viewLabelId
        }, toolbarProps)), (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)($641adb510ed163e1$var$ViewHarness, {
            liquid: viewVGrow,
            height: viewHeight,
            aspectRatio: viewAspectRatio,
            labeledById: viewLabelId
        }, this.renderView(props), this.buildAppendContent()), toolbarConfig.footer && (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)($641adb510ed163e1$var$Toolbar, Object.assign({
            ref: this.footerRef,
            extraClassName: "fc-footer-toolbar",
            model: toolbarConfig.footer,
            titleId: ""
        }, toolbarProps)));
    }
    componentDidMount() {
        let { props: props } = this;
        this.calendarInteractions = props.pluginHooks.calendarInteractions.map((CalendarInteractionClass)=>new CalendarInteractionClass(props));
        window.addEventListener("resize", this.handleWindowResize);
        let { propSetHandlers: propSetHandlers } = props.pluginHooks;
        for(let propName in propSetHandlers)propSetHandlers[propName](props[propName], props);
    }
    componentDidUpdate(prevProps) {
        let { props: props } = this;
        let { propSetHandlers: propSetHandlers } = props.pluginHooks;
        for(let propName in propSetHandlers)if (props[propName] !== prevProps[propName]) propSetHandlers[propName](props[propName], props);
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this.handleWindowResize);
        this.resizeRunner.clear();
        for (let interaction of this.calendarInteractions)interaction.destroy();
        this.props.emitter.trigger("_unmount");
    }
    buildAppendContent() {
        let { props: props } = this;
        let children = props.pluginHooks.viewContainerAppends.map((buildAppendContent)=>buildAppendContent(props));
        return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)((0, $450fc775b2f7950e$export$ffb0004e005737fa), {}, ...children);
    }
    renderView(props) {
        let { pluginHooks: pluginHooks } = props;
        let { viewSpec: viewSpec } = props;
        let viewProps = {
            dateProfile: props.dateProfile,
            businessHours: props.businessHours,
            eventStore: props.renderableEventStore,
            eventUiBases: props.eventUiBases,
            dateSelection: props.dateSelection,
            eventSelection: props.eventSelection,
            eventDrag: props.eventDrag,
            eventResize: props.eventResize,
            isHeightAuto: props.isHeightAuto,
            forPrint: props.forPrint
        };
        let transformers = this.buildViewPropTransformers(pluginHooks.viewPropsTransformers);
        for (let transformer of transformers)Object.assign(viewProps, transformer.transform(viewProps, props));
        let ViewComponent = viewSpec.component;
        return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)(ViewComponent, Object.assign({}, viewProps));
    }
}
function $641adb510ed163e1$var$buildToolbarProps(viewSpec, dateProfile, dateProfileGenerator, currentDate, now, title) {
    // don't force any date-profiles to valid date profiles (the `false`) so that we can tell if it's invalid
    let todayInfo = dateProfileGenerator.build(now, undefined, false); // TODO: need `undefined` or else INFINITE LOOP for some reason
    let prevInfo = dateProfileGenerator.buildPrev(dateProfile, currentDate, false);
    let nextInfo = dateProfileGenerator.buildNext(dateProfile, currentDate, false);
    return {
        title: title,
        activeButton: viewSpec.type,
        navUnit: viewSpec.singleUnit,
        isTodayEnabled: todayInfo.isValid && !(0, $5913100b2ed0f596$export$7f8ddf7c7c20b3cd)(dateProfile.currentRange, now),
        isPrevEnabled: prevInfo.isValid,
        isNextEnabled: nextInfo.isValid
    };
}
// Plugin
// -----------------------------------------------------------------------------------------------------------------
function $641adb510ed163e1$var$buildViewPropTransformers(theClasses) {
    return theClasses.map((TheClass)=>new TheClass());
}
class $641adb510ed163e1$export$e1aef45b828286de extends (0, $5913100b2ed0f596$export$a9c996f45e5784d0) {
    constructor(el, optionOverrides = {}){
        super();
        this.isRendering = false;
        this.isRendered = false;
        this.currentClassNames = [];
        this.customContentRenderId = 0;
        this.handleAction = (action)=>{
            // actions we know we want to render immediately
            switch(action.type){
                case "SET_EVENT_DRAG":
                case "SET_EVENT_RESIZE":
                    this.renderRunner.tryDrain();
            }
        };
        this.handleData = (data)=>{
            this.currentData = data;
            this.renderRunner.request(data.calendarOptions.rerenderDelay);
        };
        this.handleRenderRequest = ()=>{
            if (this.isRendering) {
                this.isRendered = true;
                let { currentData: currentData } = this;
                (0, $5913100b2ed0f596$export$7910e0436ed8d1de)(()=>{
                    (0, $450fc775b2f7950e$export$b3890eb0ae9dca99)((0, $450fc775b2f7950e$export$c8a8987d4410bf2d)((0, $5913100b2ed0f596$export$555508cbc6add439), {
                        options: currentData.calendarOptions,
                        theme: currentData.theme,
                        emitter: currentData.emitter
                    }, (classNames, height, isHeightAuto, forPrint)=>{
                        this.setClassNames(classNames);
                        this.setHeight(height);
                        return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)((0, $5913100b2ed0f596$export$2219238a014317b0).Provider, {
                            value: this.customContentRenderId
                        }, (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)($641adb510ed163e1$var$CalendarContent, Object.assign({
                            isHeightAuto: isHeightAuto,
                            forPrint: forPrint
                        }, currentData)));
                    }), this.el);
                });
            } else if (this.isRendered) {
                this.isRendered = false;
                (0, $450fc775b2f7950e$export$b3890eb0ae9dca99)(null, this.el);
                this.setClassNames([]);
                this.setHeight("");
            }
        };
        (0, $5913100b2ed0f596$export$4c3d22f3d993c33f)(el);
        this.el = el;
        this.renderRunner = new (0, $5913100b2ed0f596$export$96f57966bedc81b4)(this.handleRenderRequest);
        new $641adb510ed163e1$var$CalendarDataManager({
            optionOverrides: optionOverrides,
            calendarApi: this,
            onAction: this.handleAction,
            onData: this.handleData
        });
    }
    render() {
        let wasRendering = this.isRendering;
        if (!wasRendering) this.isRendering = true;
        else this.customContentRenderId += 1;
        this.renderRunner.request();
        if (wasRendering) this.updateSize();
    }
    destroy() {
        if (this.isRendering) {
            this.isRendering = false;
            this.renderRunner.request();
        }
    }
    updateSize() {
        (0, $5913100b2ed0f596$export$7910e0436ed8d1de)(()=>{
            super.updateSize();
        });
    }
    batchRendering(func) {
        this.renderRunner.pause("batchRendering");
        func();
        this.renderRunner.resume("batchRendering");
    }
    pauseRendering() {
        this.renderRunner.pause("pauseRendering");
    }
    resumeRendering() {
        this.renderRunner.resume("pauseRendering", true);
    }
    resetOptions(optionOverrides, changedOptionNames) {
        this.currentDataManager.resetOptions(optionOverrides, changedOptionNames);
    }
    setClassNames(classNames) {
        if (!(0, $5913100b2ed0f596$export$23f2a1d2818174ef)(classNames, this.currentClassNames)) {
            let { classList: classList } = this.el;
            for (let className of this.currentClassNames)classList.remove(className);
            for (let className of classNames)classList.add(className);
            this.currentClassNames = classNames;
        }
    }
    setHeight(height) {
        (0, $5913100b2ed0f596$export$f787f51d84a910ad)(this.el, "height", height);
    }
}
function $641adb510ed163e1$export$3ae94a2503e890a1(dateInput, options = {}) {
    let dateEnv = $641adb510ed163e1$var$buildDateEnv(options);
    let formatter = (0, $5913100b2ed0f596$export$d141bba7fdc215a3)(options);
    let dateMeta = dateEnv.createMarkerMeta(dateInput);
    if (!dateMeta) return "";
    return dateEnv.format(dateMeta.marker, formatter, {
        forcedTzo: dateMeta.forcedTzo
    });
}
function $641adb510ed163e1$export$9b1080e2eec9158(startInput, endInput, options) {
    let dateEnv = $641adb510ed163e1$var$buildDateEnv(typeof options === "object" && options ? options : {}); // pass in if non-null object
    let formatter = (0, $5913100b2ed0f596$export$d141bba7fdc215a3)(options);
    let startMeta = dateEnv.createMarkerMeta(startInput);
    let endMeta = dateEnv.createMarkerMeta(endInput);
    if (!startMeta || !endMeta) return "";
    return dateEnv.formatRange(startMeta.marker, endMeta.marker, formatter, {
        forcedStartTzo: startMeta.forcedTzo,
        forcedEndTzo: endMeta.forcedTzo,
        isEndExclusive: options.isEndExclusive,
        defaultSeparator: (0, $5913100b2ed0f596$export$f1e1789686576879).defaultRangeSeparator
    });
}
// TODO: more DRY and optimized
function $641adb510ed163e1$var$buildDateEnv(settings) {
    let locale = $641adb510ed163e1$var$buildLocale(settings.locale || "en", $641adb510ed163e1$var$organizeRawLocales([]).map); // TODO: don't hardcode 'en' everywhere
    return new (0, $5913100b2ed0f596$export$25ce5a424b770e84)(Object.assign(Object.assign({
        timeZone: (0, $5913100b2ed0f596$export$f1e1789686576879).timeZone,
        calendarSystem: "gregory"
    }, settings), {
        locale: locale
    }));
}
// HELPERS
/*
if nextDayThreshold is specified, slicing is done in an all-day fashion.
you can get nextDayThreshold from context.nextDayThreshold
*/ function $641adb510ed163e1$export$3b384895d0cca0f2(props, allDay) {
    return (0, $5913100b2ed0f596$export$c9170ad7d4cd7e57)(props.eventStore, props.eventUiBases, props.dateProfile.activeRange, allDay ? props.nextDayThreshold : null).fg;
}
const $641adb510ed163e1$export$83d89fbfd8236492 = "6.1.13";




var $c854a69b4095b587$exports = {};
/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 * Portions Copyright (C) Philipp Kewisch, 2021 */ /* jshint ignore:start */ var $c854a69b4095b587$var$ICAL;
(function() {
    // CommonJS, where exports may be different each time.
    $c854a69b4095b587$var$ICAL = $c854a69b4095b587$exports;
})();
/* jshint ignore:end */ /* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 * Portions Copyright (C) Philipp Kewisch, 2011-2015 */ /**
 * The number of characters before iCalendar line folding should occur
 * @type {Number}
 * @default 75
 */ $c854a69b4095b587$var$ICAL.foldLength = 75;
/**
 * The character(s) to be used for a newline. The default value is provided by
 * rfc5545.
 * @type {String}
 * @default "\r\n"
 */ $c854a69b4095b587$var$ICAL.newLineChar = "\r\n";
/**
 * Helper functions used in various places within ical.js
 * @namespace
 */ $c854a69b4095b587$var$ICAL.helpers = {
    /**
   * Compiles a list of all referenced TZIDs in all subcomponents and
   * removes any extra VTIMEZONE subcomponents. In addition, if any TZIDs
   * are referenced by a component, but a VTIMEZONE does not exist,
   * an attempt will be made to generate a VTIMEZONE using ICAL.TimezoneService.
   *
   * @param {ICAL.Component} vcal     The top-level VCALENDAR component.
   * @return {ICAL.Component}         The ICAL.Component that was passed in.
   */ updateTimezones: function(vcal) {
        var allsubs, properties, vtimezones, reqTzid, i, tzid;
        if (!vcal || vcal.name !== "vcalendar") //not a top-level vcalendar component
        return vcal;
        //Store vtimezone subcomponents in an object reference by tzid.
        //Store properties from everything else in another array
        allsubs = vcal.getAllSubcomponents();
        properties = [];
        vtimezones = {};
        for(i = 0; i < allsubs.length; i++)if (allsubs[i].name === "vtimezone") {
            tzid = allsubs[i].getFirstProperty("tzid").getFirstValue();
            vtimezones[tzid] = allsubs[i];
        } else properties = properties.concat(allsubs[i].getAllProperties());
        //create an object with one entry for each required tz
        reqTzid = {};
        for(i = 0; i < properties.length; i++)if (tzid = properties[i].getParameter("tzid")) reqTzid[tzid] = true;
        //delete any vtimezones that are not on the reqTzid list.
        for(i in vtimezones)if (vtimezones.hasOwnProperty(i) && !reqTzid[i]) vcal.removeSubcomponent(vtimezones[i]);
        //create any missing, but registered timezones
        for(i in reqTzid)if (reqTzid.hasOwnProperty(i) && !vtimezones[i] && $c854a69b4095b587$var$ICAL.TimezoneService.has(i)) vcal.addSubcomponent($c854a69b4095b587$var$ICAL.TimezoneService.get(i).component);
        return vcal;
    },
    /**
   * Checks if the given type is of the number type and also NaN.
   *
   * @param {Number} number     The number to check
   * @return {Boolean}          True, if the number is strictly NaN
   */ isStrictlyNaN: function(number) {
        return typeof number === "number" && isNaN(number);
    },
    /**
   * Parses a string value that is expected to be an integer, when the valid is
   * not an integer throws a decoration error.
   *
   * @param {String} string     Raw string input
   * @return {Number}           Parsed integer
   */ strictParseInt: function(string) {
        var result = parseInt(string, 10);
        if ($c854a69b4095b587$var$ICAL.helpers.isStrictlyNaN(result)) throw new Error('Could not extract integer from "' + string + '"');
        return result;
    },
    /**
   * Creates or returns a class instance of a given type with the initialization
   * data if the data is not already an instance of the given type.
   *
   * @example
   * var time = new ICAL.Time(...);
   * var result = ICAL.helpers.formatClassType(time, ICAL.Time);
   *
   * (result instanceof ICAL.Time)
   * // => true
   *
   * result = ICAL.helpers.formatClassType({}, ICAL.Time);
   * (result isntanceof ICAL.Time)
   * // => true
   *
   *
   * @param {Object} data       object initialization data
   * @param {Object} type       object type (like ICAL.Time)
   * @return {?}                An instance of the found type.
   */ formatClassType: function formatClassType(data, type) {
        if (typeof data === "undefined") return undefined;
        if (data instanceof type) return data;
        return new type(data);
    },
    /**
   * Identical to indexOf but will only match values when they are not preceded
   * by a backslash character.
   *
   * @param {String} buffer         String to search
   * @param {String} search         Value to look for
   * @param {Number} pos            Start position
   * @return {Number}               The position, or -1 if not found
   */ unescapedIndexOf: function(buffer, search, pos) {
        while((pos = buffer.indexOf(search, pos)) !== -1){
            if (pos > 0 && buffer[pos - 1] === "\\") pos += 1;
            else return pos;
        }
        return -1;
    },
    /**
   * Find the index for insertion using binary search.
   *
   * @param {Array} list            The list to search
   * @param {?} seekVal             The value to insert
   * @param {function(?,?)} cmpfunc The comparison func, that can
   *                                  compare two seekVals
   * @return {Number}               The insert position
   */ binsearchInsert: function(list, seekVal, cmpfunc) {
        if (!list.length) return 0;
        var low = 0, high = list.length - 1, mid, cmpval;
        while(low <= high){
            mid = low + Math.floor((high - low) / 2);
            cmpval = cmpfunc(seekVal, list[mid]);
            if (cmpval < 0) high = mid - 1;
            else if (cmpval > 0) low = mid + 1;
            else break;
        }
        if (cmpval < 0) return mid; // insertion is displacing, so use mid outright.
        else if (cmpval > 0) return mid + 1;
        else return mid;
    },
    /**
   * Convenience function for debug output
   * @private
   */ dumpn: /* istanbul ignore next */ function() {
        if (!$c854a69b4095b587$var$ICAL.debug) return;
        if (typeof console !== "undefined" && "log" in console) $c854a69b4095b587$var$ICAL.helpers.dumpn = function consoleDumpn(input) {
            console.log(input);
        };
        else $c854a69b4095b587$var$ICAL.helpers.dumpn = function geckoDumpn(input) {
            dump(input + "\n");
        };
        $c854a69b4095b587$var$ICAL.helpers.dumpn(arguments[0]);
    },
    /**
   * Clone the passed object or primitive. By default a shallow clone will be
   * executed.
   *
   * @param {*} aSrc            The thing to clone
   * @param {Boolean=} aDeep    If true, a deep clone will be performed
   * @return {*}                The copy of the thing
   */ clone: function(aSrc, aDeep) {
        if (!aSrc || typeof aSrc != "object") return aSrc;
        else if (aSrc instanceof Date) return new Date(aSrc.getTime());
        else if ("clone" in aSrc) return aSrc.clone();
        else if (Array.isArray(aSrc)) {
            var arr = [];
            for(var i = 0; i < aSrc.length; i++)arr.push(aDeep ? $c854a69b4095b587$var$ICAL.helpers.clone(aSrc[i], true) : aSrc[i]);
            return arr;
        } else {
            var obj = {};
            for(var name in aSrc)// uses prototype method to allow use of Object.create(null);
            /* istanbul ignore else */ if (Object.prototype.hasOwnProperty.call(aSrc, name)) {
                if (aDeep) obj[name] = $c854a69b4095b587$var$ICAL.helpers.clone(aSrc[name], true);
                else obj[name] = aSrc[name];
            }
            return obj;
        }
    },
    /**
   * Performs iCalendar line folding. A line ending character is inserted and
   * the next line begins with a whitespace.
   *
   * @example
   * SUMMARY:This line will be fold
   *  ed right in the middle of a word.
   *
   * @param {String} aLine      The line to fold
   * @return {String}           The folded line
   */ foldline: function foldline(aLine) {
        var result = "";
        var line = aLine || "", pos = 0, line_length = 0;
        //pos counts position in line for the UTF-16 presentation
        //line_length counts the bytes for the UTF-8 presentation
        while(line.length){
            var cp = line.codePointAt(pos);
            if (cp < 128) ++line_length;
            else if (cp < 2048) line_length += 2; //needs 2 UTF-8 bytes
            else if (cp < 65536) line_length += 3;
            else line_length += 4; //cp is less than 1114112
            if (line_length < $c854a69b4095b587$var$ICAL.foldLength + 1) pos += cp > 65535 ? 2 : 1;
            else {
                result += $c854a69b4095b587$var$ICAL.newLineChar + " " + line.substring(0, pos);
                line = line.substring(pos);
                pos = line_length = 0;
            }
        }
        return result.substr($c854a69b4095b587$var$ICAL.newLineChar.length + 1);
    },
    /**
   * Pads the given string or number with zeros so it will have at least two
   * characters.
   *
   * @param {String|Number} data    The string or number to pad
   * @return {String}               The number padded as a string
   */ pad2: function pad(data) {
        if (typeof data !== "string") {
            // handle fractions.
            if (typeof data === "number") data = parseInt(data);
            data = String(data);
        }
        var len = data.length;
        switch(len){
            case 0:
                return "00";
            case 1:
                return "0" + data;
            default:
                return data;
        }
    },
    /**
   * Truncates the given number, correctly handling negative numbers.
   *
   * @param {Number} number     The number to truncate
   * @return {Number}           The truncated number
   */ trunc: function trunc(number) {
        return number < 0 ? Math.ceil(number) : Math.floor(number);
    },
    /**
   * Poor-man's cross-browser inheritance for JavaScript. Doesn't support all
   * the features, but enough for our usage.
   *
   * @param {Function} base     The base class constructor function.
   * @param {Function} child    The child class constructor function.
   * @param {Object} extra      Extends the prototype with extra properties
   *                              and methods
   */ inherits: function(base, child, extra) {
        function F() {}
        F.prototype = base.prototype;
        child.prototype = new F();
        if (extra) $c854a69b4095b587$var$ICAL.helpers.extend(extra, child.prototype);
    },
    /**
   * Poor-man's cross-browser object extension. Doesn't support all the
   * features, but enough for our usage. Note that the target's properties are
   * not overwritten with the source properties.
   *
   * @example
   * var child = ICAL.helpers.extend(parent, {
   *   "bar": 123
   * });
   *
   * @param {Object} source     The object to extend
   * @param {Object} target     The object to extend with
   * @return {Object}           Returns the target.
   */ extend: function(source, target) {
        for(var key in source){
            var descr = Object.getOwnPropertyDescriptor(source, key);
            if (descr && !Object.getOwnPropertyDescriptor(target, key)) Object.defineProperty(target, key, descr);
        }
        return target;
    }
};
/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 * Portions Copyright (C) Philipp Kewisch, 2011-2015 */ /** @namespace ICAL */ /**
 * This symbol is further described later on
 * @ignore
 */ $c854a69b4095b587$var$ICAL.design = function() {
    "use strict";
    var FROM_ICAL_NEWLINE = /\\\\|\\;|\\,|\\[Nn]/g;
    var TO_ICAL_NEWLINE = /\\|;|,|\n/g;
    var FROM_VCARD_NEWLINE = /\\\\|\\,|\\[Nn]/g;
    var TO_VCARD_NEWLINE = /\\|,|\n/g;
    function createTextType(fromNewline, toNewline) {
        var result = {
            matches: /.*/,
            fromICAL: function(aValue, structuredEscape) {
                return replaceNewline(aValue, fromNewline, structuredEscape);
            },
            toICAL: function(aValue, structuredEscape) {
                var regEx = toNewline;
                if (structuredEscape) regEx = new RegExp(regEx.source + "|" + structuredEscape);
                return aValue.replace(regEx, function(str) {
                    switch(str){
                        case "\\":
                            return "\\\\";
                        case ";":
                            return "\\;";
                        case ",":
                            return "\\,";
                        case "\n":
                            return "\\n";
                        /* istanbul ignore next */ default:
                            return str;
                    }
                });
            }
        };
        return result;
    }
    // default types used multiple times
    var DEFAULT_TYPE_TEXT = {
        defaultType: "text"
    };
    var DEFAULT_TYPE_TEXT_MULTI = {
        defaultType: "text",
        multiValue: ","
    };
    var DEFAULT_TYPE_TEXT_STRUCTURED = {
        defaultType: "text",
        structuredValue: ";"
    };
    var DEFAULT_TYPE_INTEGER = {
        defaultType: "integer"
    };
    var DEFAULT_TYPE_DATETIME_DATE = {
        defaultType: "date-time",
        allowedTypes: [
            "date-time",
            "date"
        ]
    };
    var DEFAULT_TYPE_DATETIME = {
        defaultType: "date-time"
    };
    var DEFAULT_TYPE_URI = {
        defaultType: "uri"
    };
    var DEFAULT_TYPE_UTCOFFSET = {
        defaultType: "utc-offset"
    };
    var DEFAULT_TYPE_RECUR = {
        defaultType: "recur"
    };
    var DEFAULT_TYPE_DATE_ANDOR_TIME = {
        defaultType: "date-and-or-time",
        allowedTypes: [
            "date-time",
            "date",
            "text"
        ]
    };
    function replaceNewlineReplace(string) {
        switch(string){
            case "\\\\":
                return "\\";
            case "\\;":
                return ";";
            case "\\,":
                return ",";
            case "\\n":
            case "\\N":
                return "\n";
            /* istanbul ignore next */ default:
                return string;
        }
    }
    function replaceNewline(value1, newline, structuredEscape) {
        // avoid regex when possible.
        if (value1.indexOf("\\") === -1) return value1;
        if (structuredEscape) newline = new RegExp(newline.source + "|\\\\" + structuredEscape);
        return value1.replace(newline, replaceNewlineReplace);
    }
    var commonProperties = {
        "categories": DEFAULT_TYPE_TEXT_MULTI,
        "url": DEFAULT_TYPE_URI,
        "version": DEFAULT_TYPE_TEXT,
        "uid": DEFAULT_TYPE_TEXT
    };
    var commonValues = {
        "boolean": {
            values: [
                "TRUE",
                "FALSE"
            ],
            fromICAL: function(aValue) {
                switch(aValue){
                    case "TRUE":
                        return true;
                    case "FALSE":
                        return false;
                    default:
                        //TODO: parser warning
                        return false;
                }
            },
            toICAL: function(aValue) {
                if (aValue) return "TRUE";
                return "FALSE";
            }
        },
        float: {
            matches: /^[+-]?\d+\.\d+$/,
            fromICAL: function(aValue) {
                var parsed = parseFloat(aValue);
                if ($c854a69b4095b587$var$ICAL.helpers.isStrictlyNaN(parsed)) // TODO: parser warning
                return 0.0;
                return parsed;
            },
            toICAL: function(aValue) {
                return String(aValue);
            }
        },
        integer: {
            fromICAL: function(aValue) {
                var parsed = parseInt(aValue);
                if ($c854a69b4095b587$var$ICAL.helpers.isStrictlyNaN(parsed)) return 0;
                return parsed;
            },
            toICAL: function(aValue) {
                return String(aValue);
            }
        },
        "utc-offset": {
            toICAL: function(aValue) {
                if (aValue.length < 7) // no seconds
                // -0500
                return aValue.substr(0, 3) + aValue.substr(4, 2);
                else // seconds
                // -050000
                return aValue.substr(0, 3) + aValue.substr(4, 2) + aValue.substr(7, 2);
            },
            fromICAL: function(aValue) {
                if (aValue.length < 6) // no seconds
                // -05:00
                return aValue.substr(0, 3) + ":" + aValue.substr(3, 2);
                else // seconds
                // -05:00:00
                return aValue.substr(0, 3) + ":" + aValue.substr(3, 2) + ":" + aValue.substr(5, 2);
            },
            decorate: function(aValue) {
                return $c854a69b4095b587$var$ICAL.UtcOffset.fromString(aValue);
            },
            undecorate: function(aValue) {
                return aValue.toString();
            }
        }
    };
    var icalParams = {
        // Although the syntax is DQUOTE uri DQUOTE, I don't think we should
        // enfoce anything aside from it being a valid content line.
        //
        // At least some params require - if multi values are used - DQUOTEs
        // for each of its values - e.g. delegated-from="uri1","uri2"
        // To indicate this, I introduced the new k/v pair
        // multiValueSeparateDQuote: true
        //
        // "ALTREP": { ... },
        // CN just wants a param-value
        // "CN": { ... }
        "cutype": {
            values: [
                "INDIVIDUAL",
                "GROUP",
                "RESOURCE",
                "ROOM",
                "UNKNOWN"
            ],
            allowXName: true,
            allowIanaToken: true
        },
        "delegated-from": {
            valueType: "cal-address",
            multiValue: ",",
            multiValueSeparateDQuote: true
        },
        "delegated-to": {
            valueType: "cal-address",
            multiValue: ",",
            multiValueSeparateDQuote: true
        },
        // "DIR": { ... }, // See ALTREP
        "encoding": {
            values: [
                "8BIT",
                "BASE64"
            ]
        },
        // "FMTTYPE": { ... }, // See ALTREP
        "fbtype": {
            values: [
                "FREE",
                "BUSY",
                "BUSY-UNAVAILABLE",
                "BUSY-TENTATIVE"
            ],
            allowXName: true,
            allowIanaToken: true
        },
        // "LANGUAGE": { ... }, // See ALTREP
        "member": {
            valueType: "cal-address",
            multiValue: ",",
            multiValueSeparateDQuote: true
        },
        "partstat": {
            // TODO These values are actually different per-component
            values: [
                "NEEDS-ACTION",
                "ACCEPTED",
                "DECLINED",
                "TENTATIVE",
                "DELEGATED",
                "COMPLETED",
                "IN-PROCESS"
            ],
            allowXName: true,
            allowIanaToken: true
        },
        "range": {
            values: [
                "THISANDFUTURE"
            ]
        },
        "related": {
            values: [
                "START",
                "END"
            ]
        },
        "reltype": {
            values: [
                "PARENT",
                "CHILD",
                "SIBLING"
            ],
            allowXName: true,
            allowIanaToken: true
        },
        "role": {
            values: [
                "REQ-PARTICIPANT",
                "CHAIR",
                "OPT-PARTICIPANT",
                "NON-PARTICIPANT"
            ],
            allowXName: true,
            allowIanaToken: true
        },
        "rsvp": {
            values: [
                "TRUE",
                "FALSE"
            ]
        },
        "sent-by": {
            valueType: "cal-address"
        },
        "tzid": {
            matches: /^\//
        },
        "value": {
            // since the value here is a 'type' lowercase is used.
            values: [
                "binary",
                "boolean",
                "cal-address",
                "date",
                "date-time",
                "duration",
                "float",
                "integer",
                "period",
                "recur",
                "text",
                "time",
                "uri",
                "utc-offset"
            ],
            allowXName: true,
            allowIanaToken: true
        }
    };
    // When adding a value here, be sure to add it to the parameter types!
    var icalValues = $c854a69b4095b587$var$ICAL.helpers.extend(commonValues, {
        text: createTextType(FROM_ICAL_NEWLINE, TO_ICAL_NEWLINE),
        uri: {
        },
        "binary": {
            decorate: function(aString) {
                return $c854a69b4095b587$var$ICAL.Binary.fromString(aString);
            },
            undecorate: function(aBinary) {
                return aBinary.toString();
            }
        },
        "cal-address": {
        },
        "date": {
            decorate: function(aValue, aProp) {
                if (design.strict) return $c854a69b4095b587$var$ICAL.Time.fromDateString(aValue, aProp);
                else return $c854a69b4095b587$var$ICAL.Time.fromString(aValue, aProp);
            },
            /**
       * undecorates a time object.
       */ undecorate: function(aValue) {
                return aValue.toString();
            },
            fromICAL: function(aValue) {
                // from: 20120901
                // to: 2012-09-01
                if (!design.strict && aValue.length >= 15) // This is probably a date-time, e.g. 20120901T130000Z
                return icalValues["date-time"].fromICAL(aValue);
                else return aValue.substr(0, 4) + "-" + aValue.substr(4, 2) + "-" + aValue.substr(6, 2);
            },
            toICAL: function(aValue) {
                // from: 2012-09-01
                // to: 20120901
                var len = aValue.length;
                if (len == 10) return aValue.substr(0, 4) + aValue.substr(5, 2) + aValue.substr(8, 2);
                else if (len >= 19) return icalValues["date-time"].toICAL(aValue);
                else //TODO: serialize warning?
                return aValue;
            }
        },
        "date-time": {
            fromICAL: function(aValue) {
                // from: 20120901T130000
                // to: 2012-09-01T13:00:00
                if (!design.strict && aValue.length == 8) // This is probably a date, e.g. 20120901
                return icalValues.date.fromICAL(aValue);
                else {
                    var result = aValue.substr(0, 4) + "-" + aValue.substr(4, 2) + "-" + aValue.substr(6, 2) + "T" + aValue.substr(9, 2) + ":" + aValue.substr(11, 2) + ":" + aValue.substr(13, 2);
                    if (aValue[15] && aValue[15] === "Z") result += "Z";
                    return result;
                }
            },
            toICAL: function(aValue) {
                // from: 2012-09-01T13:00:00
                // to: 20120901T130000
                var len = aValue.length;
                if (len == 10 && !design.strict) return icalValues.date.toICAL(aValue);
                else if (len >= 19) {
                    var result = aValue.substr(0, 4) + aValue.substr(5, 2) + // grab the (DDTHH) segment
                    aValue.substr(8, 5) + // MM
                    aValue.substr(14, 2) + // SS
                    aValue.substr(17, 2);
                    if (aValue[19] && aValue[19] === "Z") result += "Z";
                    return result;
                } else // TODO: error
                return aValue;
            },
            decorate: function(aValue, aProp) {
                if (design.strict) return $c854a69b4095b587$var$ICAL.Time.fromDateTimeString(aValue, aProp);
                else return $c854a69b4095b587$var$ICAL.Time.fromString(aValue, aProp);
            },
            undecorate: function(aValue) {
                return aValue.toString();
            }
        },
        duration: {
            decorate: function(aValue) {
                return $c854a69b4095b587$var$ICAL.Duration.fromString(aValue);
            },
            undecorate: function(aValue) {
                return aValue.toString();
            }
        },
        period: {
            fromICAL: function(string) {
                var parts = string.split("/");
                parts[0] = icalValues["date-time"].fromICAL(parts[0]);
                if (!$c854a69b4095b587$var$ICAL.Duration.isValueString(parts[1])) parts[1] = icalValues["date-time"].fromICAL(parts[1]);
                return parts;
            },
            toICAL: function(parts) {
                if (!design.strict && parts[0].length == 10) parts[0] = icalValues.date.toICAL(parts[0]);
                else parts[0] = icalValues["date-time"].toICAL(parts[0]);
                if (!$c854a69b4095b587$var$ICAL.Duration.isValueString(parts[1])) {
                    if (!design.strict && parts[1].length == 10) parts[1] = icalValues.date.toICAL(parts[1]);
                    else parts[1] = icalValues["date-time"].toICAL(parts[1]);
                }
                return parts.join("/");
            },
            decorate: function(aValue, aProp) {
                return $c854a69b4095b587$var$ICAL.Period.fromJSON(aValue, aProp, !design.strict);
            },
            undecorate: function(aValue) {
                return aValue.toJSON();
            }
        },
        recur: {
            fromICAL: function(string) {
                return $c854a69b4095b587$var$ICAL.Recur._stringToData(string, true);
            },
            toICAL: function(data) {
                var str = "";
                for(var k in data){
                    /* istanbul ignore if */ if (!Object.prototype.hasOwnProperty.call(data, k)) continue;
                    var val = data[k];
                    if (k == "until") {
                        if (val.length > 10) val = icalValues["date-time"].toICAL(val);
                        else val = icalValues.date.toICAL(val);
                    } else if (k == "wkst") {
                        if (typeof val === "number") val = $c854a69b4095b587$var$ICAL.Recur.numericDayToIcalDay(val);
                    } else if (Array.isArray(val)) val = val.join(",");
                    str += k.toUpperCase() + "=" + val + ";";
                }
                return str.substr(0, str.length - 1);
            },
            decorate: function decorate(aValue) {
                return $c854a69b4095b587$var$ICAL.Recur.fromData(aValue);
            },
            undecorate: function(aRecur) {
                return aRecur.toJSON();
            }
        },
        time: {
            fromICAL: function(aValue) {
                // from: MMHHSS(Z)?
                // to: HH:MM:SS(Z)?
                if (aValue.length < 6) // TODO: parser exception?
                return aValue;
                // HH::MM::SSZ?
                var result = aValue.substr(0, 2) + ":" + aValue.substr(2, 2) + ":" + aValue.substr(4, 2);
                if (aValue[6] === "Z") result += "Z";
                return result;
            },
            toICAL: function(aValue) {
                // from: HH:MM:SS(Z)?
                // to: MMHHSS(Z)?
                if (aValue.length < 8) //TODO: error
                return aValue;
                var result = aValue.substr(0, 2) + aValue.substr(3, 2) + aValue.substr(6, 2);
                if (aValue[8] === "Z") result += "Z";
                return result;
            }
        }
    });
    var icalProperties = $c854a69b4095b587$var$ICAL.helpers.extend(commonProperties, {
        "action": DEFAULT_TYPE_TEXT,
        "attach": {
            defaultType: "uri"
        },
        "attendee": {
            defaultType: "cal-address"
        },
        "calscale": DEFAULT_TYPE_TEXT,
        "class": DEFAULT_TYPE_TEXT,
        "comment": DEFAULT_TYPE_TEXT,
        "completed": DEFAULT_TYPE_DATETIME,
        "contact": DEFAULT_TYPE_TEXT,
        "created": DEFAULT_TYPE_DATETIME,
        "description": DEFAULT_TYPE_TEXT,
        "dtend": DEFAULT_TYPE_DATETIME_DATE,
        "dtstamp": DEFAULT_TYPE_DATETIME,
        "dtstart": DEFAULT_TYPE_DATETIME_DATE,
        "due": DEFAULT_TYPE_DATETIME_DATE,
        "duration": {
            defaultType: "duration"
        },
        "exdate": {
            defaultType: "date-time",
            allowedTypes: [
                "date-time",
                "date"
            ],
            multiValue: ","
        },
        "exrule": DEFAULT_TYPE_RECUR,
        "freebusy": {
            defaultType: "period",
            multiValue: ","
        },
        "geo": {
            defaultType: "float",
            structuredValue: ";"
        },
        "last-modified": DEFAULT_TYPE_DATETIME,
        "location": DEFAULT_TYPE_TEXT,
        "method": DEFAULT_TYPE_TEXT,
        "organizer": {
            defaultType: "cal-address"
        },
        "percent-complete": DEFAULT_TYPE_INTEGER,
        "priority": DEFAULT_TYPE_INTEGER,
        "prodid": DEFAULT_TYPE_TEXT,
        "related-to": DEFAULT_TYPE_TEXT,
        "repeat": DEFAULT_TYPE_INTEGER,
        "rdate": {
            defaultType: "date-time",
            allowedTypes: [
                "date-time",
                "date",
                "period"
            ],
            multiValue: ",",
            detectType: function(string) {
                if (string.indexOf("/") !== -1) return "period";
                return string.indexOf("T") === -1 ? "date" : "date-time";
            }
        },
        "recurrence-id": DEFAULT_TYPE_DATETIME_DATE,
        "resources": DEFAULT_TYPE_TEXT_MULTI,
        "request-status": DEFAULT_TYPE_TEXT_STRUCTURED,
        "rrule": DEFAULT_TYPE_RECUR,
        "sequence": DEFAULT_TYPE_INTEGER,
        "status": DEFAULT_TYPE_TEXT,
        "summary": DEFAULT_TYPE_TEXT,
        "transp": DEFAULT_TYPE_TEXT,
        "trigger": {
            defaultType: "duration",
            allowedTypes: [
                "duration",
                "date-time"
            ]
        },
        "tzoffsetfrom": DEFAULT_TYPE_UTCOFFSET,
        "tzoffsetto": DEFAULT_TYPE_UTCOFFSET,
        "tzurl": DEFAULT_TYPE_URI,
        "tzid": DEFAULT_TYPE_TEXT,
        "tzname": DEFAULT_TYPE_TEXT
    });
    // When adding a value here, be sure to add it to the parameter types!
    var vcardValues = $c854a69b4095b587$var$ICAL.helpers.extend(commonValues, {
        text: createTextType(FROM_VCARD_NEWLINE, TO_VCARD_NEWLINE),
        uri: createTextType(FROM_VCARD_NEWLINE, TO_VCARD_NEWLINE),
        date: {
            decorate: function(aValue) {
                return $c854a69b4095b587$var$ICAL.VCardTime.fromDateAndOrTimeString(aValue, "date");
            },
            undecorate: function(aValue) {
                return aValue.toString();
            },
            fromICAL: function(aValue) {
                if (aValue.length == 8) return icalValues.date.fromICAL(aValue);
                else if (aValue[0] == "-" && aValue.length == 6) return aValue.substr(0, 4) + "-" + aValue.substr(4);
                else return aValue;
            },
            toICAL: function(aValue) {
                if (aValue.length == 10) return icalValues.date.toICAL(aValue);
                else if (aValue[0] == "-" && aValue.length == 7) return aValue.substr(0, 4) + aValue.substr(5);
                else return aValue;
            }
        },
        time: {
            decorate: function(aValue) {
                return $c854a69b4095b587$var$ICAL.VCardTime.fromDateAndOrTimeString("T" + aValue, "time");
            },
            undecorate: function(aValue) {
                return aValue.toString();
            },
            fromICAL: function(aValue) {
                var splitzone = vcardValues.time._splitZone(aValue, true);
                var zone = splitzone[0], value1 = splitzone[1];
                //console.log("SPLIT: ",splitzone);
                if (value1.length == 6) value1 = value1.substr(0, 2) + ":" + value1.substr(2, 2) + ":" + value1.substr(4, 2);
                else if (value1.length == 4 && value1[0] != "-") value1 = value1.substr(0, 2) + ":" + value1.substr(2, 2);
                else if (value1.length == 5) value1 = value1.substr(0, 3) + ":" + value1.substr(3, 2);
                if (zone.length == 5 && (zone[0] == "-" || zone[0] == "+")) zone = zone.substr(0, 3) + ":" + zone.substr(3);
                return value1 + zone;
            },
            toICAL: function(aValue) {
                var splitzone = vcardValues.time._splitZone(aValue);
                var zone = splitzone[0], value1 = splitzone[1];
                if (value1.length == 8) value1 = value1.substr(0, 2) + value1.substr(3, 2) + value1.substr(6, 2);
                else if (value1.length == 5 && value1[0] != "-") value1 = value1.substr(0, 2) + value1.substr(3, 2);
                else if (value1.length == 6) value1 = value1.substr(0, 3) + value1.substr(4, 2);
                if (zone.length == 6 && (zone[0] == "-" || zone[0] == "+")) zone = zone.substr(0, 3) + zone.substr(4);
                return value1 + zone;
            },
            _splitZone: function(aValue, isFromIcal) {
                var lastChar = aValue.length - 1;
                var signChar = aValue.length - (isFromIcal ? 5 : 6);
                var sign = aValue[signChar];
                var zone, value1;
                if (aValue[lastChar] == "Z") {
                    zone = aValue[lastChar];
                    value1 = aValue.substr(0, lastChar);
                } else if (aValue.length > 6 && (sign == "-" || sign == "+")) {
                    zone = aValue.substr(signChar);
                    value1 = aValue.substr(0, signChar);
                } else {
                    zone = "";
                    value1 = aValue;
                }
                return [
                    zone,
                    value1
                ];
            }
        },
        "date-time": {
            decorate: function(aValue) {
                return $c854a69b4095b587$var$ICAL.VCardTime.fromDateAndOrTimeString(aValue, "date-time");
            },
            undecorate: function(aValue) {
                return aValue.toString();
            },
            fromICAL: function(aValue) {
                return vcardValues["date-and-or-time"].fromICAL(aValue);
            },
            toICAL: function(aValue) {
                return vcardValues["date-and-or-time"].toICAL(aValue);
            }
        },
        "date-and-or-time": {
            decorate: function(aValue) {
                return $c854a69b4095b587$var$ICAL.VCardTime.fromDateAndOrTimeString(aValue, "date-and-or-time");
            },
            undecorate: function(aValue) {
                return aValue.toString();
            },
            fromICAL: function(aValue) {
                var parts = aValue.split("T");
                return (parts[0] ? vcardValues.date.fromICAL(parts[0]) : "") + (parts[1] ? "T" + vcardValues.time.fromICAL(parts[1]) : "");
            },
            toICAL: function(aValue) {
                var parts = aValue.split("T");
                return vcardValues.date.toICAL(parts[0]) + (parts[1] ? "T" + vcardValues.time.toICAL(parts[1]) : "");
            }
        },
        timestamp: icalValues["date-time"],
        "language-tag": {
            matches: /^[a-zA-Z0-9-]+$/ // Could go with a more strict regex here
        }
    });
    var vcardParams = {
        "type": {
            valueType: "text",
            multiValue: ","
        },
        "value": {
            // since the value here is a 'type' lowercase is used.
            values: [
                "text",
                "uri",
                "date",
                "time",
                "date-time",
                "date-and-or-time",
                "timestamp",
                "boolean",
                "integer",
                "float",
                "utc-offset",
                "language-tag"
            ],
            allowXName: true,
            allowIanaToken: true
        }
    };
    var vcardProperties = $c854a69b4095b587$var$ICAL.helpers.extend(commonProperties, {
        "adr": {
            defaultType: "text",
            structuredValue: ";",
            multiValue: ","
        },
        "anniversary": DEFAULT_TYPE_DATE_ANDOR_TIME,
        "bday": DEFAULT_TYPE_DATE_ANDOR_TIME,
        "caladruri": DEFAULT_TYPE_URI,
        "caluri": DEFAULT_TYPE_URI,
        "clientpidmap": DEFAULT_TYPE_TEXT_STRUCTURED,
        "email": DEFAULT_TYPE_TEXT,
        "fburl": DEFAULT_TYPE_URI,
        "fn": DEFAULT_TYPE_TEXT,
        "gender": DEFAULT_TYPE_TEXT_STRUCTURED,
        "geo": DEFAULT_TYPE_URI,
        "impp": DEFAULT_TYPE_URI,
        "key": DEFAULT_TYPE_URI,
        "kind": DEFAULT_TYPE_TEXT,
        "lang": {
            defaultType: "language-tag"
        },
        "logo": DEFAULT_TYPE_URI,
        "member": DEFAULT_TYPE_URI,
        "n": {
            defaultType: "text",
            structuredValue: ";",
            multiValue: ","
        },
        "nickname": DEFAULT_TYPE_TEXT_MULTI,
        "note": DEFAULT_TYPE_TEXT,
        "org": {
            defaultType: "text",
            structuredValue: ";"
        },
        "photo": DEFAULT_TYPE_URI,
        "related": DEFAULT_TYPE_URI,
        "rev": {
            defaultType: "timestamp"
        },
        "role": DEFAULT_TYPE_TEXT,
        "sound": DEFAULT_TYPE_URI,
        "source": DEFAULT_TYPE_URI,
        "tel": {
            defaultType: "uri",
            allowedTypes: [
                "uri",
                "text"
            ]
        },
        "title": DEFAULT_TYPE_TEXT,
        "tz": {
            defaultType: "text",
            allowedTypes: [
                "text",
                "utc-offset",
                "uri"
            ]
        },
        "xml": DEFAULT_TYPE_TEXT
    });
    var vcard3Values = $c854a69b4095b587$var$ICAL.helpers.extend(commonValues, {
        binary: icalValues.binary,
        date: vcardValues.date,
        "date-time": vcardValues["date-time"],
        "phone-number": {
        },
        uri: icalValues.uri,
        text: icalValues.text,
        time: icalValues.time,
        vcard: icalValues.text,
        "utc-offset": {
            toICAL: function(aValue) {
                return aValue.substr(0, 7);
            },
            fromICAL: function(aValue) {
                return aValue.substr(0, 7);
            },
            decorate: function(aValue) {
                return $c854a69b4095b587$var$ICAL.UtcOffset.fromString(aValue);
            },
            undecorate: function(aValue) {
                return aValue.toString();
            }
        }
    });
    var vcard3Params = {
        "type": {
            valueType: "text",
            multiValue: ","
        },
        "value": {
            // since the value here is a 'type' lowercase is used.
            values: [
                "text",
                "uri",
                "date",
                "date-time",
                "phone-number",
                "time",
                "boolean",
                "integer",
                "float",
                "utc-offset",
                "vcard",
                "binary"
            ],
            allowXName: true,
            allowIanaToken: true
        }
    };
    var vcard3Properties = $c854a69b4095b587$var$ICAL.helpers.extend(commonProperties, {
        fn: DEFAULT_TYPE_TEXT,
        n: {
            defaultType: "text",
            structuredValue: ";",
            multiValue: ","
        },
        nickname: DEFAULT_TYPE_TEXT_MULTI,
        photo: {
            defaultType: "binary",
            allowedTypes: [
                "binary",
                "uri"
            ]
        },
        bday: {
            defaultType: "date-time",
            allowedTypes: [
                "date-time",
                "date"
            ],
            detectType: function(string) {
                return string.indexOf("T") === -1 ? "date" : "date-time";
            }
        },
        adr: {
            defaultType: "text",
            structuredValue: ";",
            multiValue: ","
        },
        label: DEFAULT_TYPE_TEXT,
        tel: {
            defaultType: "phone-number"
        },
        email: DEFAULT_TYPE_TEXT,
        mailer: DEFAULT_TYPE_TEXT,
        tz: {
            defaultType: "utc-offset",
            allowedTypes: [
                "utc-offset",
                "text"
            ]
        },
        geo: {
            defaultType: "float",
            structuredValue: ";"
        },
        title: DEFAULT_TYPE_TEXT,
        role: DEFAULT_TYPE_TEXT,
        logo: {
            defaultType: "binary",
            allowedTypes: [
                "binary",
                "uri"
            ]
        },
        agent: {
            defaultType: "vcard",
            allowedTypes: [
                "vcard",
                "text",
                "uri"
            ]
        },
        org: DEFAULT_TYPE_TEXT_STRUCTURED,
        note: DEFAULT_TYPE_TEXT_MULTI,
        prodid: DEFAULT_TYPE_TEXT,
        rev: {
            defaultType: "date-time",
            allowedTypes: [
                "date-time",
                "date"
            ],
            detectType: function(string) {
                return string.indexOf("T") === -1 ? "date" : "date-time";
            }
        },
        "sort-string": DEFAULT_TYPE_TEXT,
        sound: {
            defaultType: "binary",
            allowedTypes: [
                "binary",
                "uri"
            ]
        },
        class: DEFAULT_TYPE_TEXT,
        key: {
            defaultType: "binary",
            allowedTypes: [
                "binary",
                "text"
            ]
        }
    });
    /**
   * iCalendar design set
   * @type {ICAL.design.designSet}
   */ var icalSet = {
        value: icalValues,
        param: icalParams,
        property: icalProperties
    };
    /**
   * vCard 4.0 design set
   * @type {ICAL.design.designSet}
   */ var vcardSet = {
        value: vcardValues,
        param: vcardParams,
        property: vcardProperties
    };
    /**
   * vCard 3.0 design set
   * @type {ICAL.design.designSet}
   */ var vcard3Set = {
        value: vcard3Values,
        param: vcard3Params,
        property: vcard3Properties
    };
    /**
   * The design data, used by the parser to determine types for properties and
   * other metadata needed to produce correct jCard/jCal data.
   *
   * @alias ICAL.design
   * @namespace
   */ var design = {
        /**
     * A designSet describes value, parameter and property data. It is used by
     * ther parser and stringifier in components and properties to determine they
     * should be represented.
     *
     * @typedef {Object} designSet
     * @memberOf ICAL.design
     * @property {Object} value       Definitions for value types, keys are type names
     * @property {Object} param       Definitions for params, keys are param names
     * @property {Object} property    Defintions for properties, keys are property names
     */ /**
     * Can be set to false to make the parser more lenient.
     */ strict: true,
        /**
     * The default set for new properties and components if none is specified.
     * @type {ICAL.design.designSet}
     */ defaultSet: icalSet,
        /**
     * The default type for unknown properties
     * @type {String}
     */ defaultType: "unknown",
        /**
     * Holds the design set for known top-level components
     *
     * @type {Object}
     * @property {ICAL.design.designSet} vcard       vCard VCARD
     * @property {ICAL.design.designSet} vevent      iCalendar VEVENT
     * @property {ICAL.design.designSet} vtodo       iCalendar VTODO
     * @property {ICAL.design.designSet} vjournal    iCalendar VJOURNAL
     * @property {ICAL.design.designSet} valarm      iCalendar VALARM
     * @property {ICAL.design.designSet} vtimezone   iCalendar VTIMEZONE
     * @property {ICAL.design.designSet} daylight    iCalendar DAYLIGHT
     * @property {ICAL.design.designSet} standard    iCalendar STANDARD
     *
     * @example
     * var propertyName = 'fn';
     * var componentDesign = ICAL.design.components.vcard;
     * var propertyDetails = componentDesign.property[propertyName];
     * if (propertyDetails.defaultType == 'text') {
     *   // Yep, sure is...
     * }
     */ components: {
            vcard: vcardSet,
            vcard3: vcard3Set,
            vevent: icalSet,
            vtodo: icalSet,
            vjournal: icalSet,
            valarm: icalSet,
            vtimezone: icalSet,
            daylight: icalSet,
            standard: icalSet
        },
        /**
     * The design set for iCalendar (rfc5545/rfc7265) components.
     * @type {ICAL.design.designSet}
     */ icalendar: icalSet,
        /**
     * The design set for vCard (rfc6350/rfc7095) components.
     * @type {ICAL.design.designSet}
     */ vcard: vcardSet,
        /**
     * The design set for vCard (rfc2425/rfc2426/rfc7095) components.
     * @type {ICAL.design.designSet}
     */ vcard3: vcard3Set,
        /**
     * Gets the design set for the given component name.
     *
     * @param {String} componentName        The name of the component
     * @return {ICAL.design.designSet}      The design set for the component
     */ getDesignSet: function(componentName) {
            var isInDesign = componentName && componentName in design.components;
            return isInDesign ? design.components[componentName] : design.defaultSet;
        }
    };
    return design;
}();
/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 * Portions Copyright (C) Philipp Kewisch, 2011-2015 */ /**
 * Contains various functions to convert jCal and jCard data back into
 * iCalendar and vCard.
 * @namespace
 */ $c854a69b4095b587$var$ICAL.stringify = function() {
    "use strict";
    var LINE_ENDING = "\r\n";
    var DEFAULT_VALUE_TYPE = "unknown";
    var design = $c854a69b4095b587$var$ICAL.design;
    var helpers = $c854a69b4095b587$var$ICAL.helpers;
    /**
   * Convert a full jCal/jCard array into a iCalendar/vCard string.
   *
   * @function ICAL.stringify
   * @variation function
   * @param {Array} jCal    The jCal/jCard document
   * @return {String}       The stringified iCalendar/vCard document
   */ function stringify(jCal) {
        if (typeof jCal[0] == "string") // This is a single component
        jCal = [
            jCal
        ];
        var i = 0;
        var len = jCal.length;
        var result = "";
        for(; i < len; i++)result += stringify.component(jCal[i]) + LINE_ENDING;
        return result;
    }
    /**
   * Converts an jCal component array into a ICAL string.
   * Recursive will resolve sub-components.
   *
   * Exact component/property order is not saved all
   * properties will come before subcomponents.
   *
   * @function ICAL.stringify.component
   * @param {Array} component
   *        jCal/jCard fragment of a component
   * @param {ICAL.design.designSet} designSet
   *        The design data to use for this component
   * @return {String}       The iCalendar/vCard string
   */ stringify.component = function(component, designSet) {
        var name = component[0].toUpperCase();
        var result = "BEGIN:" + name + LINE_ENDING;
        var props = component[1];
        var propIdx = 0;
        var propLen = props.length;
        var designSetName = component[0];
        // rfc6350 requires that in vCard 4.0 the first component is the VERSION
        // component with as value 4.0, note that 3.0 does not have this requirement.
        if (designSetName === "vcard" && component[1].length > 0 && !(component[1][0][0] === "version" && component[1][0][3] === "4.0")) designSetName = "vcard3";
        designSet = designSet || design.getDesignSet(designSetName);
        for(; propIdx < propLen; propIdx++)result += stringify.property(props[propIdx], designSet) + LINE_ENDING;
        // Ignore subcomponents if none exist, e.g. in vCard.
        var comps = component[2] || [];
        var compIdx = 0;
        var compLen = comps.length;
        for(; compIdx < compLen; compIdx++)result += stringify.component(comps[compIdx], designSet) + LINE_ENDING;
        result += "END:" + name;
        return result;
    };
    /**
   * Converts a single jCal/jCard property to a iCalendar/vCard string.
   *
   * @function ICAL.stringify.property
   * @param {Array} property
   *        jCal/jCard property array
   * @param {ICAL.design.designSet} designSet
   *        The design data to use for this property
   * @param {Boolean} noFold
   *        If true, the line is not folded
   * @return {String}       The iCalendar/vCard string
   */ stringify.property = function(property, designSet, noFold) {
        var name = property[0].toUpperCase();
        var jsName = property[0];
        var params = property[1];
        var line = name;
        var paramName;
        for(paramName in params){
            var value1 = params[paramName];
            /* istanbul ignore else */ if (params.hasOwnProperty(paramName)) {
                var multiValue = paramName in designSet.param && designSet.param[paramName].multiValue;
                if (multiValue && Array.isArray(value1)) {
                    if (designSet.param[paramName].multiValueSeparateDQuote) multiValue = '"' + multiValue + '"';
                    value1 = value1.map(stringify._rfc6868Unescape);
                    value1 = stringify.multiValue(value1, multiValue, "unknown", null, designSet);
                } else value1 = stringify._rfc6868Unescape(value1);
                line += ";" + paramName.toUpperCase();
                line += "=" + stringify.propertyValue(value1);
            }
        }
        if (property.length === 3) // If there are no values, we must assume a blank value
        return line + ":";
        var valueType = property[2];
        if (!designSet) designSet = design.defaultSet;
        var propDetails;
        var multiValue = false;
        var structuredValue = false;
        var isDefault = false;
        if (jsName in designSet.property) {
            propDetails = designSet.property[jsName];
            if ("multiValue" in propDetails) multiValue = propDetails.multiValue;
            if ("structuredValue" in propDetails && Array.isArray(property[3])) structuredValue = propDetails.structuredValue;
            if ("defaultType" in propDetails) {
                if (valueType === propDetails.defaultType) isDefault = true;
            } else if (valueType === DEFAULT_VALUE_TYPE) isDefault = true;
        } else if (valueType === DEFAULT_VALUE_TYPE) isDefault = true;
        // push the VALUE property if type is not the default
        // for the current property.
        if (!isDefault) // value will never contain ;/:/, so we don't escape it here.
        line += ";VALUE=" + valueType.toUpperCase();
        line += ":";
        if (multiValue && structuredValue) line += stringify.multiValue(property[3], structuredValue, valueType, multiValue, designSet, structuredValue);
        else if (multiValue) line += stringify.multiValue(property.slice(3), multiValue, valueType, null, designSet, false);
        else if (structuredValue) line += stringify.multiValue(property[3], structuredValue, valueType, null, designSet, structuredValue);
        else line += stringify.value(property[3], valueType, designSet, false);
        return noFold ? line : $c854a69b4095b587$var$ICAL.helpers.foldline(line);
    };
    /**
   * Handles escaping of property values that may contain:
   *
   *    COLON (:), SEMICOLON (;), or COMMA (,)
   *
   * If any of the above are present the result is wrapped
   * in double quotes.
   *
   * @function ICAL.stringify.propertyValue
   * @param {String} value      Raw property value
   * @return {String}           Given or escaped value when needed
   */ stringify.propertyValue = function(value1) {
        if (helpers.unescapedIndexOf(value1, ",") === -1 && helpers.unescapedIndexOf(value1, ":") === -1 && helpers.unescapedIndexOf(value1, ";") === -1) return value1;
        return '"' + value1 + '"';
    };
    /**
   * Converts an array of ical values into a single
   * string based on a type and a delimiter value (like ",").
   *
   * @function ICAL.stringify.multiValue
   * @param {Array} values      List of values to convert
   * @param {String} delim      Used to join the values (",", ";", ":")
   * @param {String} type       Lowecase ical value type
   *        (like boolean, date-time, etc..)
   * @param {?String} innerMulti If set, each value will again be processed
   *        Used for structured values
   * @param {ICAL.design.designSet} designSet
   *        The design data to use for this property
   *
   * @return {String}           iCalendar/vCard string for value
   */ stringify.multiValue = function(values, delim, type, innerMulti, designSet, structuredValue) {
        var result = "";
        var len = values.length;
        var i = 0;
        for(; i < len; i++){
            if (innerMulti && Array.isArray(values[i])) result += stringify.multiValue(values[i], innerMulti, type, null, designSet, structuredValue);
            else result += stringify.value(values[i], type, designSet, structuredValue);
            if (i !== len - 1) result += delim;
        }
        return result;
    };
    /**
   * Processes a single ical value runs the associated "toICAL" method from the
   * design value type if available to convert the value.
   *
   * @function ICAL.stringify.value
   * @param {String|Number} value       A formatted value
   * @param {String} type               Lowercase iCalendar/vCard value type
   *  (like boolean, date-time, etc..)
   * @return {String}                   iCalendar/vCard value for single value
   */ stringify.value = function(value1, type, designSet, structuredValue) {
        if (type in designSet.value && "toICAL" in designSet.value[type]) return designSet.value[type].toICAL(value1, structuredValue);
        return value1;
    };
    /**
   * Internal helper for rfc6868. Exposing this on ICAL.stringify so that
   * hackers can disable the rfc6868 parsing if the really need to.
   *
   * @param {String} val        The value to unescape
   * @return {String}           The escaped value
   */ stringify._rfc6868Unescape = function(val) {
        return val.replace(/[\n^"]/g, function(x) {
            return RFC6868_REPLACE_MAP[x];
        });
    };
    var RFC6868_REPLACE_MAP = {
        '"': "^'",
        "\n": "^n",
        "^": "^^"
    };
    return stringify;
}();
/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 * Portions Copyright (C) Philipp Kewisch, 2011-2015 */ /**
 * Contains various functions to parse iCalendar and vCard data.
 * @namespace
 */ $c854a69b4095b587$var$ICAL.parse = function() {
    "use strict";
    var CHAR = /[^ \t]/;
    var MULTIVALUE_DELIMITER = ",";
    var VALUE_DELIMITER = ":";
    var PARAM_DELIMITER = ";";
    var PARAM_NAME_DELIMITER = "=";
    var DEFAULT_VALUE_TYPE = "unknown";
    var DEFAULT_PARAM_TYPE = "text";
    var design = $c854a69b4095b587$var$ICAL.design;
    var helpers = $c854a69b4095b587$var$ICAL.helpers;
    /**
   * An error that occurred during parsing.
   *
   * @param {String} message        The error message
   * @memberof ICAL.parse
   * @extends {Error}
   * @class
   */ function ParserError(message) {
        this.message = message;
        this.name = "ParserError";
        try {
            throw new Error();
        } catch (e) {
            if (e.stack) {
                var split = e.stack.split("\n");
                split.shift();
                this.stack = split.join("\n");
            }
        }
    }
    ParserError.prototype = Error.prototype;
    /**
   * Parses iCalendar or vCard data into a raw jCal object. Consult
   * documentation on the {@tutorial layers|layers of parsing} for more
   * details.
   *
   * @function ICAL.parse
   * @variation function
   * @todo Fix the API to be more clear on the return type
   * @param {String} input      The string data to parse
   * @return {Object|Object[]}  A single jCal object, or an array thereof
   */ function parser(input) {
        var state = {};
        var root = state.component = [];
        state.stack = [
            root
        ];
        parser._eachLine(input, function(err, line) {
            parser._handleContentLine(line, state);
        });
        // when there are still items on the stack
        // throw a fatal error, a component was not closed
        // correctly in that case.
        if (state.stack.length > 1) throw new ParserError("invalid ical body. component began but did not end");
        state = null;
        return root.length == 1 ? root[0] : root;
    }
    /**
   * Parse an iCalendar property value into the jCal for a single property
   *
   * @function ICAL.parse.property
   * @param {String} str
   *   The iCalendar property string to parse
   * @param {ICAL.design.designSet=} designSet
   *   The design data to use for this property
   * @return {Object}
   *   The jCal Object containing the property
   */ parser.property = function(str, designSet) {
        var state = {
            component: [
                [],
                []
            ],
            designSet: designSet || design.defaultSet
        };
        parser._handleContentLine(str, state);
        return state.component[1][0];
    };
    /**
   * Convenience method to parse a component. You can use ICAL.parse() directly
   * instead.
   *
   * @function ICAL.parse.component
   * @see ICAL.parse(function)
   * @param {String} str    The iCalendar component string to parse
   * @return {Object}       The jCal Object containing the component
   */ parser.component = function(str) {
        return parser(str);
    };
    // classes & constants
    parser.ParserError = ParserError;
    /**
   * The state for parsing content lines from an iCalendar/vCard string.
   *
   * @private
   * @memberof ICAL.parse
   * @typedef {Object} parserState
   * @property {ICAL.design.designSet} designSet    The design set to use for parsing
   * @property {ICAL.Component[]} stack             The stack of components being processed
   * @property {ICAL.Component} component           The currently active component
   */ /**
   * Handles a single line of iCalendar/vCard, updating the state.
   *
   * @private
   * @function ICAL.parse._handleContentLine
   * @param {String} line               The content line to process
   * @param {ICAL.parse.parserState}    The current state of the line parsing
   */ parser._handleContentLine = function(line, state) {
        // break up the parts of the line
        var valuePos = line.indexOf(VALUE_DELIMITER);
        var paramPos = line.indexOf(PARAM_DELIMITER);
        var lastParamIndex;
        var lastValuePos;
        // name of property or begin/end
        var name;
        var value1;
        // params is only overridden if paramPos !== -1.
        // we can't do params = params || {} later on
        // because it sacrifices ops.
        var params = {};
        /**
     * Different property cases
     *
     *
     * 1. RRULE:FREQ=foo
     *    // FREQ= is not a param but the value
     *
     * 2. ATTENDEE;ROLE=REQ-PARTICIPANT;
     *    // ROLE= is a param because : has not happened yet
     */ // when the parameter delimiter is after the
        // value delimiter then it is not a parameter.
        if (paramPos !== -1 && valuePos !== -1) // when the parameter delimiter is after the
        // value delimiter then it is not a parameter.
        {
            if (paramPos > valuePos) paramPos = -1;
        }
        var parsedParams;
        if (paramPos !== -1) {
            name = line.substring(0, paramPos).toLowerCase();
            parsedParams = parser._parseParameters(line.substring(paramPos), 0, state.designSet);
            if (parsedParams[2] == -1) throw new ParserError("Invalid parameters in '" + line + "'");
            params = parsedParams[0];
            lastParamIndex = parsedParams[1].length + parsedParams[2] + paramPos;
            if ((lastValuePos = line.substring(lastParamIndex).indexOf(VALUE_DELIMITER)) !== -1) value1 = line.substring(lastParamIndex + lastValuePos + 1);
            else throw new ParserError("Missing parameter value in '" + line + "'");
        } else if (valuePos !== -1) {
            // without parmeters (BEGIN:VCAENDAR, CLASS:PUBLIC)
            name = line.substring(0, valuePos).toLowerCase();
            value1 = line.substring(valuePos + 1);
            if (name === "begin") {
                var newComponent = [
                    value1.toLowerCase(),
                    [],
                    []
                ];
                if (state.stack.length === 1) state.component.push(newComponent);
                else state.component[2].push(newComponent);
                state.stack.push(state.component);
                state.component = newComponent;
                if (!state.designSet) state.designSet = design.getDesignSet(state.component[0]);
                return;
            } else if (name === "end") {
                state.component = state.stack.pop();
                return;
            }
        // If it is not begin/end, then this is a property with an empty value,
        // which should be considered valid.
        } else /**
       * Invalid line.
       * The rational to throw an error is we will
       * never be certain that the rest of the file
       * is sane and it is unlikely that we can serialize
       * the result correctly either.
       */ throw new ParserError('invalid line (no token ";" or ":") "' + line + '"');
        var valueType;
        var multiValue = false;
        var structuredValue = false;
        var propertyDetails;
        if (name in state.designSet.property) {
            propertyDetails = state.designSet.property[name];
            if ("multiValue" in propertyDetails) multiValue = propertyDetails.multiValue;
            if ("structuredValue" in propertyDetails) structuredValue = propertyDetails.structuredValue;
            if (value1 && "detectType" in propertyDetails) valueType = propertyDetails.detectType(value1);
        }
        // attempt to determine value
        if (!valueType) {
            if (!("value" in params)) {
                if (propertyDetails) valueType = propertyDetails.defaultType;
                else valueType = DEFAULT_VALUE_TYPE;
            } else // possible to avoid this?
            valueType = params.value.toLowerCase();
        }
        delete params.value;
        /**
     * Note on `var result` juggling:
     *
     * I observed that building the array in pieces has adverse
     * effects on performance, so where possible we inline the creation.
     * It is a little ugly but resulted in ~2000 additional ops/sec.
     */ var result;
        if (multiValue && structuredValue) {
            value1 = parser._parseMultiValue(value1, structuredValue, valueType, [], multiValue, state.designSet, structuredValue);
            result = [
                name,
                params,
                valueType,
                value1
            ];
        } else if (multiValue) {
            result = [
                name,
                params,
                valueType
            ];
            parser._parseMultiValue(value1, multiValue, valueType, result, null, state.designSet, false);
        } else if (structuredValue) {
            value1 = parser._parseMultiValue(value1, structuredValue, valueType, [], null, state.designSet, structuredValue);
            result = [
                name,
                params,
                valueType,
                value1
            ];
        } else {
            value1 = parser._parseValue(value1, valueType, state.designSet, false);
            result = [
                name,
                params,
                valueType,
                value1
            ];
        }
        // rfc6350 requires that in vCard 4.0 the first component is the VERSION
        // component with as value 4.0, note that 3.0 does not have this requirement.
        if (state.component[0] === "vcard" && state.component[1].length === 0 && !(name === "version" && value1 === "4.0")) state.designSet = design.getDesignSet("vcard3");
        state.component[1].push(result);
    };
    /**
   * Parse a value from the raw value into the jCard/jCal value.
   *
   * @private
   * @function ICAL.parse._parseValue
   * @param {String} value          Original value
   * @param {String} type           Type of value
   * @param {Object} designSet      The design data to use for this value
   * @return {Object} varies on type
   */ parser._parseValue = function(value1, type, designSet, structuredValue) {
        if (type in designSet.value && "fromICAL" in designSet.value[type]) return designSet.value[type].fromICAL(value1, structuredValue);
        return value1;
    };
    /**
   * Parse parameters from a string to object.
   *
   * @function ICAL.parse._parseParameters
   * @private
   * @param {String} line           A single unfolded line
   * @param {Numeric} start         Position to start looking for properties
   * @param {Object} designSet      The design data to use for this property
   * @return {Object} key/value pairs
   */ parser._parseParameters = function(line, start, designSet) {
        var lastParam = start;
        var pos = 0;
        var delim = PARAM_NAME_DELIMITER;
        var result = {};
        var name, lcname;
        var value1, valuePos = -1;
        var type, multiValue, mvdelim;
        // find the next '=' sign
        // use lastParam and pos to find name
        // check if " is used if so get value from "->"
        // then increment pos to find next ;
        while(pos !== false && (pos = helpers.unescapedIndexOf(line, delim, pos + 1)) !== -1){
            name = line.substr(lastParam + 1, pos - lastParam - 1);
            if (name.length == 0) throw new ParserError("Empty parameter name in '" + line + "'");
            lcname = name.toLowerCase();
            mvdelim = false;
            multiValue = false;
            if (lcname in designSet.param && designSet.param[lcname].valueType) type = designSet.param[lcname].valueType;
            else type = DEFAULT_PARAM_TYPE;
            if (lcname in designSet.param) {
                multiValue = designSet.param[lcname].multiValue;
                if (designSet.param[lcname].multiValueSeparateDQuote) mvdelim = parser._rfc6868Escape('"' + multiValue + '"');
            }
            var nextChar = line[pos + 1];
            if (nextChar === '"') {
                valuePos = pos + 2;
                pos = helpers.unescapedIndexOf(line, '"', valuePos);
                if (multiValue && pos != -1) {
                    var extendedValue = true;
                    while(extendedValue)if (line[pos + 1] == multiValue && line[pos + 2] == '"') pos = helpers.unescapedIndexOf(line, '"', pos + 3);
                    else extendedValue = false;
                }
                if (pos === -1) throw new ParserError('invalid line (no matching double quote) "' + line + '"');
                value1 = line.substr(valuePos, pos - valuePos);
                lastParam = helpers.unescapedIndexOf(line, PARAM_DELIMITER, pos);
                if (lastParam === -1) pos = false;
            } else {
                valuePos = pos + 1;
                // move to next ";"
                var nextPos = helpers.unescapedIndexOf(line, PARAM_DELIMITER, valuePos);
                var propValuePos = helpers.unescapedIndexOf(line, VALUE_DELIMITER, valuePos);
                if (propValuePos !== -1 && nextPos > propValuePos) {
                    // this is a delimiter in the property value, let's stop here
                    nextPos = propValuePos;
                    pos = false;
                } else if (nextPos === -1) {
                    // no ";"
                    if (propValuePos === -1) nextPos = line.length;
                    else nextPos = propValuePos;
                    pos = false;
                } else {
                    lastParam = nextPos;
                    pos = nextPos;
                }
                value1 = line.substr(valuePos, nextPos - valuePos);
            }
            value1 = parser._rfc6868Escape(value1);
            if (multiValue) {
                var delimiter = mvdelim || multiValue;
                value1 = parser._parseMultiValue(value1, delimiter, type, [], null, designSet);
            } else value1 = parser._parseValue(value1, type, designSet);
            if (multiValue && lcname in result) {
                if (Array.isArray(result[lcname])) result[lcname].push(value1);
                else result[lcname] = [
                    result[lcname],
                    value1
                ];
            } else result[lcname] = value1;
        }
        return [
            result,
            value1,
            valuePos
        ];
    };
    /**
   * Internal helper for rfc6868. Exposing this on ICAL.parse so that
   * hackers can disable the rfc6868 parsing if the really need to.
   *
   * @function ICAL.parse._rfc6868Escape
   * @param {String} val        The value to escape
   * @return {String}           The escaped value
   */ parser._rfc6868Escape = function(val) {
        return val.replace(/\^['n^]/g, function(x) {
            return RFC6868_REPLACE_MAP[x];
        });
    };
    var RFC6868_REPLACE_MAP = {
        "^'": '"',
        "^n": "\n",
        "^^": "^"
    };
    /**
   * Parse a multi value string. This function is used either for parsing
   * actual multi-value property's values, or for handling parameter values. It
   * can be used for both multi-value properties and structured value properties.
   *
   * @private
   * @function ICAL.parse._parseMultiValue
   * @param {String} buffer     The buffer containing the full value
   * @param {String} delim      The multi-value delimiter
   * @param {String} type       The value type to be parsed
   * @param {Array.<?>} result        The array to append results to, varies on value type
   * @param {String} innerMulti The inner delimiter to split each value with
   * @param {ICAL.design.designSet} designSet   The design data for this value
   * @return {?|Array.<?>}            Either an array of results, or the first result
   */ parser._parseMultiValue = function(buffer, delim, type, result, innerMulti, designSet, structuredValue) {
        var pos = 0;
        var lastPos = 0;
        var value1;
        if (delim.length === 0) return buffer;
        // split each piece
        while((pos = helpers.unescapedIndexOf(buffer, delim, lastPos)) !== -1){
            value1 = buffer.substr(lastPos, pos - lastPos);
            if (innerMulti) value1 = parser._parseMultiValue(value1, innerMulti, type, [], null, designSet, structuredValue);
            else value1 = parser._parseValue(value1, type, designSet, structuredValue);
            result.push(value1);
            lastPos = pos + delim.length;
        }
        // on the last piece take the rest of string
        value1 = buffer.substr(lastPos);
        if (innerMulti) value1 = parser._parseMultiValue(value1, innerMulti, type, [], null, designSet, structuredValue);
        else value1 = parser._parseValue(value1, type, designSet, structuredValue);
        result.push(value1);
        return result.length == 1 ? result[0] : result;
    };
    /**
   * Process a complete buffer of iCalendar/vCard data line by line, correctly
   * unfolding content. Each line will be processed with the given callback
   *
   * @private
   * @function ICAL.parse._eachLine
   * @param {String} buffer                         The buffer to process
   * @param {function(?String, String)} callback    The callback for each line
   */ parser._eachLine = function(buffer, callback) {
        var len = buffer.length;
        var lastPos = buffer.search(CHAR);
        var pos = lastPos;
        var line;
        var firstChar;
        var newlineOffset;
        do {
            pos = buffer.indexOf("\n", lastPos) + 1;
            if (pos > 1 && buffer[pos - 2] === "\r") newlineOffset = 2;
            else newlineOffset = 1;
            if (pos === 0) {
                pos = len;
                newlineOffset = 0;
            }
            firstChar = buffer[lastPos];
            if (firstChar === " " || firstChar === "	") // add to line
            line += buffer.substr(lastPos + 1, pos - lastPos - (newlineOffset + 1));
            else {
                if (line) callback(null, line);
                // push line
                line = buffer.substr(lastPos, pos - lastPos - newlineOffset);
            }
            lastPos = pos;
        }while (pos !== len);
        // extra ending line
        line = line.trim();
        if (line.length) callback(null, line);
    };
    return parser;
}();
/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 * Portions Copyright (C) Philipp Kewisch, 2011-2015 */ /**
 * This symbol is further described later on
 * @ignore
 */ $c854a69b4095b587$var$ICAL.Component = function() {
    "use strict";
    var PROPERTY_INDEX = 1;
    var COMPONENT_INDEX = 2;
    var NAME_INDEX = 0;
    /**
   * @classdesc
   * Wraps a jCal component, adding convenience methods to add, remove and
   * update subcomponents and properties.
   *
   * @class
   * @alias ICAL.Component
   * @param {Array|String} jCal         Raw jCal component data OR name of new
   *                                      component
   * @param {ICAL.Component} parent     Parent component to associate
   */ function Component(jCal, parent) {
        if (typeof jCal === "string") // jCal spec (name, properties, components)
        jCal = [
            jCal,
            [],
            []
        ];
        // mostly for legacy reasons.
        this.jCal = jCal;
        this.parent = parent || null;
    }
    Component.prototype = {
        /**
     * Hydrated properties are inserted into the _properties array at the same
     * position as in the jCal array, so it is possible that the array contains
     * undefined values for unhydrdated properties. To avoid iterating the
     * array when checking if all properties have been hydrated, we save the
     * count here.
     *
     * @type {Number}
     * @private
     */ _hydratedPropertyCount: 0,
        /**
     * The same count as for _hydratedPropertyCount, but for subcomponents
     *
     * @type {Number}
     * @private
     */ _hydratedComponentCount: 0,
        /**
     * The name of this component
     * @readonly
     */ get name () {
            return this.jCal[NAME_INDEX];
        },
        /**
     * The design set for this component, e.g. icalendar vs vcard
     *
     * @type {ICAL.design.designSet}
     * @private
     */ get _designSet () {
            var parentDesign = this.parent && this.parent._designSet;
            return parentDesign || $c854a69b4095b587$var$ICAL.design.getDesignSet(this.name);
        },
        _hydrateComponent: function(index) {
            if (!this._components) {
                this._components = [];
                this._hydratedComponentCount = 0;
            }
            if (this._components[index]) return this._components[index];
            var comp = new Component(this.jCal[COMPONENT_INDEX][index], this);
            this._hydratedComponentCount++;
            return this._components[index] = comp;
        },
        _hydrateProperty: function(index) {
            if (!this._properties) {
                this._properties = [];
                this._hydratedPropertyCount = 0;
            }
            if (this._properties[index]) return this._properties[index];
            var prop = new $c854a69b4095b587$var$ICAL.Property(this.jCal[PROPERTY_INDEX][index], this);
            this._hydratedPropertyCount++;
            return this._properties[index] = prop;
        },
        /**
     * Finds first sub component, optionally filtered by name.
     *
     * @param {String=} name        Optional name to filter by
     * @return {?ICAL.Component}     The found subcomponent
     */ getFirstSubcomponent: function(name) {
            if (name) {
                var i = 0;
                var comps = this.jCal[COMPONENT_INDEX];
                var len = comps.length;
                for(; i < len; i++)if (comps[i][NAME_INDEX] === name) {
                    var result = this._hydrateComponent(i);
                    return result;
                }
            } else {
                if (this.jCal[COMPONENT_INDEX].length) return this._hydrateComponent(0);
            }
            // ensure we return a value (strict mode)
            return null;
        },
        /**
     * Finds all sub components, optionally filtering by name.
     *
     * @param {String=} name            Optional name to filter by
     * @return {ICAL.Component[]}       The found sub components
     */ getAllSubcomponents: function(name) {
            var jCalLen = this.jCal[COMPONENT_INDEX].length;
            var i = 0;
            if (name) {
                var comps = this.jCal[COMPONENT_INDEX];
                var result = [];
                for(; i < jCalLen; i++)if (name === comps[i][NAME_INDEX]) result.push(this._hydrateComponent(i));
                return result;
            } else {
                if (!this._components || this._hydratedComponentCount !== jCalLen) for(; i < jCalLen; i++)this._hydrateComponent(i);
                return this._components || [];
            }
        },
        /**
     * Returns true when a named property exists.
     *
     * @param {String} name     The property name
     * @return {Boolean}        True, when property is found
     */ hasProperty: function(name) {
            var props = this.jCal[PROPERTY_INDEX];
            var len = props.length;
            var i = 0;
            for(; i < len; i++){
                // 0 is property name
                if (props[i][NAME_INDEX] === name) return true;
            }
            return false;
        },
        /**
     * Finds the first property, optionally with the given name.
     *
     * @param {String=} name        Lowercase property name
     * @return {?ICAL.Property}     The found property
     */ getFirstProperty: function(name) {
            if (name) {
                var i = 0;
                var props = this.jCal[PROPERTY_INDEX];
                var len = props.length;
                for(; i < len; i++)if (props[i][NAME_INDEX] === name) {
                    var result = this._hydrateProperty(i);
                    return result;
                }
            } else {
                if (this.jCal[PROPERTY_INDEX].length) return this._hydrateProperty(0);
            }
            return null;
        },
        /**
     * Returns first property's value, if available.
     *
     * @param {String=} name    Lowercase property name
     * @return {?String}        The found property value.
     */ getFirstPropertyValue: function(name) {
            var prop = this.getFirstProperty(name);
            if (prop) return prop.getFirstValue();
            return null;
        },
        /**
     * Get all properties in the component, optionally filtered by name.
     *
     * @param {String=} name        Lowercase property name
     * @return {ICAL.Property[]}    List of properties
     */ getAllProperties: function(name) {
            var jCalLen = this.jCal[PROPERTY_INDEX].length;
            var i = 0;
            if (name) {
                var props = this.jCal[PROPERTY_INDEX];
                var result = [];
                for(; i < jCalLen; i++)if (name === props[i][NAME_INDEX]) result.push(this._hydrateProperty(i));
                return result;
            } else {
                if (!this._properties || this._hydratedPropertyCount !== jCalLen) for(; i < jCalLen; i++)this._hydrateProperty(i);
                return this._properties || [];
            }
        },
        _removeObjectByIndex: function(jCalIndex, cache, index) {
            cache = cache || [];
            // remove cached version
            if (cache[index]) {
                var obj = cache[index];
                if ("parent" in obj) obj.parent = null;
            }
            cache.splice(index, 1);
            // remove it from the jCal
            this.jCal[jCalIndex].splice(index, 1);
        },
        _removeObject: function(jCalIndex, cache, nameOrObject) {
            var i = 0;
            var objects = this.jCal[jCalIndex];
            var len = objects.length;
            var cached = this[cache];
            if (typeof nameOrObject === "string") {
                for(; i < len; i++)if (objects[i][NAME_INDEX] === nameOrObject) {
                    this._removeObjectByIndex(jCalIndex, cached, i);
                    return true;
                }
            } else if (cached) {
                for(; i < len; i++)if (cached[i] && cached[i] === nameOrObject) {
                    this._removeObjectByIndex(jCalIndex, cached, i);
                    return true;
                }
            }
            return false;
        },
        _removeAllObjects: function(jCalIndex, cache, name) {
            var cached = this[cache];
            // Unfortunately we have to run through all children to reset their
            // parent property.
            var objects = this.jCal[jCalIndex];
            var i = objects.length - 1;
            // descending search required because splice
            // is used and will effect the indices.
            for(; i >= 0; i--)if (!name || objects[i][NAME_INDEX] === name) this._removeObjectByIndex(jCalIndex, cached, i);
        },
        /**
     * Adds a single sub component.
     *
     * @param {ICAL.Component} component        The component to add
     * @return {ICAL.Component}                 The passed in component
     */ addSubcomponent: function(component) {
            if (!this._components) {
                this._components = [];
                this._hydratedComponentCount = 0;
            }
            if (component.parent) component.parent.removeSubcomponent(component);
            var idx = this.jCal[COMPONENT_INDEX].push(component.jCal);
            this._components[idx - 1] = component;
            this._hydratedComponentCount++;
            component.parent = this;
            return component;
        },
        /**
     * Removes a single component by name or the instance of a specific
     * component.
     *
     * @param {ICAL.Component|String} nameOrComp    Name of component, or component
     * @return {Boolean}                            True when comp is removed
     */ removeSubcomponent: function(nameOrComp) {
            var removed = this._removeObject(COMPONENT_INDEX, "_components", nameOrComp);
            if (removed) this._hydratedComponentCount--;
            return removed;
        },
        /**
     * Removes all components or (if given) all components by a particular
     * name.
     *
     * @param {String=} name            Lowercase component name
     */ removeAllSubcomponents: function(name) {
            var removed = this._removeAllObjects(COMPONENT_INDEX, "_components", name);
            this._hydratedComponentCount = 0;
            return removed;
        },
        /**
     * Adds an {@link ICAL.Property} to the component.
     *
     * @param {ICAL.Property} property      The property to add
     * @return {ICAL.Property}              The passed in property
     */ addProperty: function(property) {
            if (!(property instanceof $c854a69b4095b587$var$ICAL.Property)) throw new TypeError("must instance of ICAL.Property");
            if (!this._properties) {
                this._properties = [];
                this._hydratedPropertyCount = 0;
            }
            if (property.parent) property.parent.removeProperty(property);
            var idx = this.jCal[PROPERTY_INDEX].push(property.jCal);
            this._properties[idx - 1] = property;
            this._hydratedPropertyCount++;
            property.parent = this;
            return property;
        },
        /**
     * Helper method to add a property with a value to the component.
     *
     * @param {String}               name         Property name to add
     * @param {String|Number|Object} value        Property value
     * @return {ICAL.Property}                    The created property
     */ addPropertyWithValue: function(name, value1) {
            var prop = new $c854a69b4095b587$var$ICAL.Property(name);
            prop.setValue(value1);
            this.addProperty(prop);
            return prop;
        },
        /**
     * Helper method that will update or create a property of the given name
     * and sets its value. If multiple properties with the given name exist,
     * only the first is updated.
     *
     * @param {String}               name         Property name to update
     * @param {String|Number|Object} value        Property value
     * @return {ICAL.Property}                    The created property
     */ updatePropertyWithValue: function(name, value1) {
            var prop = this.getFirstProperty(name);
            if (prop) prop.setValue(value1);
            else prop = this.addPropertyWithValue(name, value1);
            return prop;
        },
        /**
     * Removes a single property by name or the instance of the specific
     * property.
     *
     * @param {String|ICAL.Property} nameOrProp     Property name or instance to remove
     * @return {Boolean}                            True, when deleted
     */ removeProperty: function(nameOrProp) {
            var removed = this._removeObject(PROPERTY_INDEX, "_properties", nameOrProp);
            if (removed) this._hydratedPropertyCount--;
            return removed;
        },
        /**
     * Removes all properties associated with this component, optionally
     * filtered by name.
     *
     * @param {String=} name        Lowercase property name
     * @return {Boolean}            True, when deleted
     */ removeAllProperties: function(name) {
            var removed = this._removeAllObjects(PROPERTY_INDEX, "_properties", name);
            this._hydratedPropertyCount = 0;
            return removed;
        },
        /**
     * Returns the Object representation of this component. The returned object
     * is a live jCal object and should be cloned if modified.
     * @return {Object}
     */ toJSON: function() {
            return this.jCal;
        },
        /**
     * The string representation of this component.
     * @return {String}
     */ toString: function() {
            return $c854a69b4095b587$var$ICAL.stringify.component(this.jCal, this._designSet);
        }
    };
    /**
   * Create an {@link ICAL.Component} by parsing the passed iCalendar string.
   *
   * @param {String} str        The iCalendar string to parse
   */ Component.fromString = function(str) {
        return new Component($c854a69b4095b587$var$ICAL.parse.component(str));
    };
    return Component;
}();
/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 * Portions Copyright (C) Philipp Kewisch, 2011-2015 */ /**
 * This symbol is further described later on
 * @ignore
 */ $c854a69b4095b587$var$ICAL.Property = function() {
    "use strict";
    var NAME_INDEX = 0;
    var PROP_INDEX = 1;
    var TYPE_INDEX = 2;
    var VALUE_INDEX = 3;
    var design = $c854a69b4095b587$var$ICAL.design;
    /**
   * @classdesc
   * Provides a layer on top of the raw jCal object for manipulating a single
   * property, with its parameters and value.
   *
   * @description
   * It is important to note that mutations done in the wrapper
   * directly mutate the jCal object used to initialize.
   *
   * Can also be used to create new properties by passing
   * the name of the property (as a String).
   *
   * @class
   * @alias ICAL.Property
   * @param {Array|String} jCal         Raw jCal representation OR
   *  the new name of the property
   *
   * @param {ICAL.Component=} parent    Parent component
   */ function Property(jCal, parent) {
        this._parent = parent || null;
        if (typeof jCal === "string") {
            // We are creating the property by name and need to detect the type
            this.jCal = [
                jCal,
                {},
                design.defaultType
            ];
            this.jCal[TYPE_INDEX] = this.getDefaultType();
        } else this.jCal = jCal;
        this._updateType();
    }
    Property.prototype = {
        /**
     * The value type for this property
     * @readonly
     * @type {String}
     */ get type () {
            return this.jCal[TYPE_INDEX];
        },
        /**
     * The name of this property, in lowercase.
     * @readonly
     * @type {String}
     */ get name () {
            return this.jCal[NAME_INDEX];
        },
        /**
     * The parent component for this property.
     * @type {ICAL.Component}
     */ get parent () {
            return this._parent;
        },
        set parent (p){
            // Before setting the parent, check if the design set has changed. If it
            // has, we later need to update the type if it was unknown before.
            var designSetChanged = !this._parent || p && p._designSet != this._parent._designSet;
            this._parent = p;
            if (this.type == design.defaultType && designSetChanged) {
                this.jCal[TYPE_INDEX] = this.getDefaultType();
                this._updateType();
            }
            return p;
        },
        /**
     * The design set for this property, e.g. icalendar vs vcard
     *
     * @type {ICAL.design.designSet}
     * @private
     */ get _designSet () {
            return this.parent ? this.parent._designSet : design.defaultSet;
        },
        /**
     * Updates the type metadata from the current jCal type and design set.
     *
     * @private
     */ _updateType: function() {
            var designSet = this._designSet;
            if (this.type in designSet.value) {
                var designType = designSet.value[this.type];
                if ("decorate" in designSet.value[this.type]) this.isDecorated = true;
                else this.isDecorated = false;
                if (this.name in designSet.property) {
                    this.isMultiValue = "multiValue" in designSet.property[this.name];
                    this.isStructuredValue = "structuredValue" in designSet.property[this.name];
                }
            }
        },
        /**
     * Hydrate a single value. The act of hydrating means turning the raw jCal
     * value into a potentially wrapped object, for example {@link ICAL.Time}.
     *
     * @private
     * @param {Number} index        The index of the value to hydrate
     * @return {Object}             The decorated value.
     */ _hydrateValue: function(index) {
            if (this._values && this._values[index]) return this._values[index];
            // for the case where there is no value.
            if (this.jCal.length <= VALUE_INDEX + index) return null;
            if (this.isDecorated) {
                if (!this._values) this._values = [];
                return this._values[index] = this._decorate(this.jCal[VALUE_INDEX + index]);
            } else return this.jCal[VALUE_INDEX + index];
        },
        /**
     * Decorate a single value, returning its wrapped object. This is used by
     * the hydrate function to actually wrap the value.
     *
     * @private
     * @param {?} value         The value to decorate
     * @return {Object}         The decorated value
     */ _decorate: function(value1) {
            return this._designSet.value[this.type].decorate(value1, this);
        },
        /**
     * Undecorate a single value, returning its raw jCal data.
     *
     * @private
     * @param {Object} value         The value to undecorate
     * @return {?}                   The undecorated value
     */ _undecorate: function(value1) {
            return this._designSet.value[this.type].undecorate(value1, this);
        },
        /**
     * Sets the value at the given index while also hydrating it. The passed
     * value can either be a decorated or undecorated value.
     *
     * @private
     * @param {?} value             The value to set
     * @param {Number} index        The index to set it at
     */ _setDecoratedValue: function(value1, index) {
            if (!this._values) this._values = [];
            if (typeof value1 === "object" && "icaltype" in value1) {
                // decorated value
                this.jCal[VALUE_INDEX + index] = this._undecorate(value1);
                this._values[index] = value1;
            } else {
                // undecorated value
                this.jCal[VALUE_INDEX + index] = value1;
                this._values[index] = this._decorate(value1);
            }
        },
        /**
     * Gets a parameter on the property.
     *
     * @param {String}        name   Parameter name (lowercase)
     * @return {Array|String}        Parameter value
     */ getParameter: function(name) {
            if (name in this.jCal[PROP_INDEX]) return this.jCal[PROP_INDEX][name];
            else return undefined;
        },
        /**
     * Gets first parameter on the property.
     *
     * @param {String}        name   Parameter name (lowercase)
     * @return {String}        Parameter value
     */ getFirstParameter: function(name) {
            var parameters = this.getParameter(name);
            if (Array.isArray(parameters)) return parameters[0];
            return parameters;
        },
        /**
     * Sets a parameter on the property.
     *
     * @param {String}       name     The parameter name
     * @param {Array|String} value    The parameter value
     */ setParameter: function(name, value1) {
            var lcname = name.toLowerCase();
            if (typeof value1 === "string" && lcname in this._designSet.param && "multiValue" in this._designSet.param[lcname]) value1 = [
                value1
            ];
            this.jCal[PROP_INDEX][name] = value1;
        },
        /**
     * Removes a parameter
     *
     * @param {String} name     The parameter name
     */ removeParameter: function(name) {
            delete this.jCal[PROP_INDEX][name];
        },
        /**
     * Get the default type based on this property's name.
     *
     * @return {String}     The default type for this property
     */ getDefaultType: function() {
            var name = this.jCal[NAME_INDEX];
            var designSet = this._designSet;
            if (name in designSet.property) {
                var details = designSet.property[name];
                if ("defaultType" in details) return details.defaultType;
            }
            return design.defaultType;
        },
        /**
     * Sets type of property and clears out any existing values of the current
     * type.
     *
     * @param {String} type     New iCAL type (see design.*.values)
     */ resetType: function(type) {
            this.removeAllValues();
            this.jCal[TYPE_INDEX] = type;
            this._updateType();
        },
        /**
     * Finds the first property value.
     *
     * @return {String}         First property value
     */ getFirstValue: function() {
            return this._hydrateValue(0);
        },
        /**
     * Gets all values on the property.
     *
     * NOTE: this creates an array during each call.
     *
     * @return {Array}          List of values
     */ getValues: function() {
            var len = this.jCal.length - VALUE_INDEX;
            if (len < 1) // it is possible for a property to have no value.
            return [];
            var i = 0;
            var result = [];
            for(; i < len; i++)result[i] = this._hydrateValue(i);
            return result;
        },
        /**
     * Removes all values from this property
     */ removeAllValues: function() {
            if (this._values) this._values.length = 0;
            this.jCal.length = 3;
        },
        /**
     * Sets the values of the property.  Will overwrite the existing values.
     * This can only be used for multi-value properties.
     *
     * @param {Array} values    An array of values
     */ setValues: function(values) {
            if (!this.isMultiValue) throw new Error(this.name + ": does not not support mulitValue.\n" + "override isMultiValue");
            var len = values.length;
            var i = 0;
            this.removeAllValues();
            if (len > 0 && typeof values[0] === "object" && "icaltype" in values[0]) this.resetType(values[0].icaltype);
            if (this.isDecorated) for(; i < len; i++)this._setDecoratedValue(values[i], i);
            else for(; i < len; i++)this.jCal[VALUE_INDEX + i] = values[i];
        },
        /**
     * Sets the current value of the property. If this is a multi-value
     * property, all other values will be removed.
     *
     * @param {String|Object} value     New property value.
     */ setValue: function(value1) {
            this.removeAllValues();
            if (typeof value1 === "object" && "icaltype" in value1) this.resetType(value1.icaltype);
            if (this.isDecorated) this._setDecoratedValue(value1, 0);
            else this.jCal[VALUE_INDEX] = value1;
        },
        /**
     * Returns the Object representation of this component. The returned object
     * is a live jCal object and should be cloned if modified.
     * @return {Object}
     */ toJSON: function() {
            return this.jCal;
        },
        /**
     * The string representation of this component.
     * @return {String}
     */ toICALString: function() {
            return $c854a69b4095b587$var$ICAL.stringify.property(this.jCal, this._designSet, true);
        }
    };
    /**
   * Create an {@link ICAL.Property} by parsing the passed iCalendar string.
   *
   * @param {String} str                        The iCalendar string to parse
   * @param {ICAL.design.designSet=} designSet  The design data to use for this property
   * @return {ICAL.Property}                    The created iCalendar property
   */ Property.fromString = function(str, designSet) {
        return new Property($c854a69b4095b587$var$ICAL.parse.property(str, designSet));
    };
    return Property;
}();
/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 * Portions Copyright (C) Philipp Kewisch, 2011-2015 */ /**
 * This symbol is further described later on
 * @ignore
 */ $c854a69b4095b587$var$ICAL.UtcOffset = function() {
    /**
   * @classdesc
   * This class represents the "duration" value type, with various calculation
   * and manipulation methods.
   *
   * @class
   * @alias ICAL.UtcOffset
   * @param {Object} aData          An object with members of the utc offset
   * @param {Number=} aData.hours   The hours for the utc offset
   * @param {Number=} aData.minutes The minutes in the utc offset
   * @param {Number=} aData.factor  The factor for the utc-offset, either -1 or 1
   */ function UtcOffset(aData) {
        this.fromData(aData);
    }
    UtcOffset.prototype = {
        /**
     * The hours in the utc-offset
     * @type {Number}
     */ hours: 0,
        /**
     * The minutes in the utc-offset
     * @type {Number}
     */ minutes: 0,
        /**
     * The sign of the utc offset, 1 for positive offset, -1 for negative
     * offsets.
     * @type {Number}
     */ factor: 1,
        /**
     * The type name, to be used in the jCal object.
     * @constant
     * @type {String}
     * @default "utc-offset"
     */ icaltype: "utc-offset",
        /**
     * Returns a clone of the utc offset object.
     *
     * @return {ICAL.UtcOffset}     The cloned object
     */ clone: function() {
            return $c854a69b4095b587$var$ICAL.UtcOffset.fromSeconds(this.toSeconds());
        },
        /**
     * Sets up the current instance using members from the passed data object.
     *
     * @param {Object} aData          An object with members of the utc offset
     * @param {Number=} aData.hours   The hours for the utc offset
     * @param {Number=} aData.minutes The minutes in the utc offset
     * @param {Number=} aData.factor  The factor for the utc-offset, either -1 or 1
     */ fromData: function(aData) {
            if (aData) {
                for(var key in aData)/* istanbul ignore else */ if (aData.hasOwnProperty(key)) this[key] = aData[key];
            }
            this._normalize();
        },
        /**
     * Sets up the current instance from the given seconds value. The seconds
     * value is truncated to the minute. Offsets are wrapped when the world
     * ends, the hour after UTC+14:00 is UTC-12:00.
     *
     * @param {Number} aSeconds         The seconds to convert into an offset
     */ fromSeconds: function(aSeconds) {
            var secs = Math.abs(aSeconds);
            this.factor = aSeconds < 0 ? -1 : 1;
            this.hours = $c854a69b4095b587$var$ICAL.helpers.trunc(secs / 3600);
            secs -= this.hours * 3600;
            this.minutes = $c854a69b4095b587$var$ICAL.helpers.trunc(secs / 60);
            return this;
        },
        /**
     * Convert the current offset to a value in seconds
     *
     * @return {Number}                 The offset in seconds
     */ toSeconds: function() {
            return this.factor * (60 * this.minutes + 3600 * this.hours);
        },
        /**
     * Compare this utc offset with another one.
     *
     * @param {ICAL.UtcOffset} other        The other offset to compare with
     * @return {Number}                     -1, 0 or 1 for less/equal/greater
     */ compare: function icaltime_compare(other) {
            var a = this.toSeconds();
            var b = other.toSeconds();
            return (a > b) - (b > a);
        },
        _normalize: function() {
            // Range: 97200 seconds (with 1 hour inbetween)
            var secs = this.toSeconds();
            var factor = this.factor;
            while(secs < -43200)secs += 97200;
            while(secs > 50400)secs -= 97200;
            this.fromSeconds(secs);
            // Avoid changing the factor when on zero seconds
            if (secs == 0) this.factor = factor;
        },
        /**
     * The iCalendar string representation of this utc-offset.
     * @return {String}
     */ toICALString: function() {
            return $c854a69b4095b587$var$ICAL.design.icalendar.value["utc-offset"].toICAL(this.toString());
        },
        /**
     * The string representation of this utc-offset.
     * @return {String}
     */ toString: function toString() {
            return (this.factor == 1 ? "+" : "-") + $c854a69b4095b587$var$ICAL.helpers.pad2(this.hours) + ":" + $c854a69b4095b587$var$ICAL.helpers.pad2(this.minutes);
        }
    };
    /**
   * Creates a new {@link ICAL.UtcOffset} instance from the passed string.
   *
   * @param {String} aString    The string to parse
   * @return {ICAL.Duration}    The created utc-offset instance
   */ UtcOffset.fromString = function(aString) {
        // -05:00
        var options = {};
        //TODO: support seconds per rfc5545 ?
        options.factor = aString[0] === "+" ? 1 : -1;
        options.hours = $c854a69b4095b587$var$ICAL.helpers.strictParseInt(aString.substr(1, 2));
        options.minutes = $c854a69b4095b587$var$ICAL.helpers.strictParseInt(aString.substr(4, 2));
        return new $c854a69b4095b587$var$ICAL.UtcOffset(options);
    };
    /**
   * Creates a new {@link ICAL.UtcOffset} instance from the passed seconds
   * value.
   *
   * @param {Number} aSeconds       The number of seconds to convert
   */ UtcOffset.fromSeconds = function(aSeconds) {
        var instance = new UtcOffset();
        instance.fromSeconds(aSeconds);
        return instance;
    };
    return UtcOffset;
}();
/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 * Portions Copyright (C) Philipp Kewisch, 2011-2015 */ /**
 * This symbol is further described later on
 * @ignore
 */ $c854a69b4095b587$var$ICAL.Binary = function() {
    /**
   * @classdesc
   * Represents the BINARY value type, which contains extra methods for
   * encoding and decoding.
   *
   * @class
   * @alias ICAL.Binary
   * @param {String} aValue     The binary data for this value
   */ function Binary(aValue) {
        this.value = aValue;
    }
    Binary.prototype = {
        /**
     * The type name, to be used in the jCal object.
     * @default "binary"
     * @constant
     */ icaltype: "binary",
        /**
     * Base64 decode the current value
     *
     * @return {String}         The base64-decoded value
     */ decodeValue: function decodeValue() {
            return this._b64_decode(this.value);
        },
        /**
     * Encodes the passed parameter with base64 and sets the internal
     * value to the result.
     *
     * @param {String} aValue      The raw binary value to encode
     */ setEncodedValue: function setEncodedValue(aValue) {
            this.value = this._b64_encode(aValue);
        },
        _b64_encode: function base64_encode(data) {
            // http://kevin.vanzonneveld.net
            // +   original by: Tyler Akins (http://rumkin.com)
            // +   improved by: Bayron Guevara
            // +   improved by: Thunder.m
            // +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
            // +   bugfixed by: Pellentesque Malesuada
            // +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
            // +   improved by: Rafał Kukawski (http://kukawski.pl)
            // *     example 1: base64_encode('Kevin van Zonneveld');
            // *     returns 1: 'S2V2aW4gdmFuIFpvbm5ldmVsZA=='
            // mozilla has this native
            // - but breaks in 2.0.0.12!
            //if (typeof this.window['atob'] == 'function') {
            //    return atob(data);
            //}
            var b64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
            var o1, o2, o3, h1, h2, h3, h4, bits, i = 0, ac = 0, enc = "", tmp_arr = [];
            if (!data) return data;
            do {
                o1 = data.charCodeAt(i++);
                o2 = data.charCodeAt(i++);
                o3 = data.charCodeAt(i++);
                bits = o1 << 16 | o2 << 8 | o3;
                h1 = bits >> 18 & 0x3f;
                h2 = bits >> 12 & 0x3f;
                h3 = bits >> 6 & 0x3f;
                h4 = bits & 0x3f;
                // use hexets to index into b64, and append result to encoded string
                tmp_arr[ac++] = b64.charAt(h1) + b64.charAt(h2) + b64.charAt(h3) + b64.charAt(h4);
            }while (i < data.length);
            enc = tmp_arr.join("");
            var r = data.length % 3;
            return (r ? enc.slice(0, r - 3) : enc) + "===".slice(r || 3);
        },
        _b64_decode: function base64_decode(data) {
            // http://kevin.vanzonneveld.net
            // +   original by: Tyler Akins (http://rumkin.com)
            // +   improved by: Thunder.m
            // +      input by: Aman Gupta
            // +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
            // +   bugfixed by: Onno Marsman
            // +   bugfixed by: Pellentesque Malesuada
            // +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
            // +      input by: Brett Zamir (http://brett-zamir.me)
            // +   bugfixed by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
            // *     example 1: base64_decode('S2V2aW4gdmFuIFpvbm5ldmVsZA==');
            // *     returns 1: 'Kevin van Zonneveld'
            // mozilla has this native
            // - but breaks in 2.0.0.12!
            //if (typeof this.window['btoa'] == 'function') {
            //    return btoa(data);
            //}
            var b64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
            var o1, o2, o3, h1, h2, h3, h4, bits, i = 0, ac = 0, dec = "", tmp_arr = [];
            if (!data) return data;
            data += "";
            do {
                h1 = b64.indexOf(data.charAt(i++));
                h2 = b64.indexOf(data.charAt(i++));
                h3 = b64.indexOf(data.charAt(i++));
                h4 = b64.indexOf(data.charAt(i++));
                bits = h1 << 18 | h2 << 12 | h3 << 6 | h4;
                o1 = bits >> 16 & 0xff;
                o2 = bits >> 8 & 0xff;
                o3 = bits & 0xff;
                if (h3 == 64) tmp_arr[ac++] = String.fromCharCode(o1);
                else if (h4 == 64) tmp_arr[ac++] = String.fromCharCode(o1, o2);
                else tmp_arr[ac++] = String.fromCharCode(o1, o2, o3);
            }while (i < data.length);
            dec = tmp_arr.join("");
            return dec;
        },
        /**
     * The string representation of this value
     * @return {String}
     */ toString: function() {
            return this.value;
        }
    };
    /**
   * Creates a binary value from the given string.
   *
   * @param {String} aString        The binary value string
   * @return {ICAL.Binary}          The binary value instance
   */ Binary.fromString = function(aString) {
        return new Binary(aString);
    };
    return Binary;
}();
/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 * Portions Copyright (C) Philipp Kewisch, 2011-2015 */ (function() {
    /**
   * @classdesc
   * This class represents the "period" value type, with various calculation
   * and manipulation methods.
   *
   * @description
   * The passed data object cannot contain both and end date and a duration.
   *
   * @class
   * @param {Object} aData                  An object with members of the period
   * @param {ICAL.Time=} aData.start        The start of the period
   * @param {ICAL.Time=} aData.end          The end of the period
   * @param {ICAL.Duration=} aData.duration The duration of the period
   */ $c854a69b4095b587$var$ICAL.Period = function icalperiod(aData) {
        this.wrappedJSObject = this;
        if (aData && "start" in aData) {
            if (aData.start && !(aData.start instanceof $c854a69b4095b587$var$ICAL.Time)) throw new TypeError(".start must be an instance of ICAL.Time");
            this.start = aData.start;
        }
        if (aData && aData.end && aData.duration) throw new Error("cannot accept both end and duration");
        if (aData && "end" in aData) {
            if (aData.end && !(aData.end instanceof $c854a69b4095b587$var$ICAL.Time)) throw new TypeError(".end must be an instance of ICAL.Time");
            this.end = aData.end;
        }
        if (aData && "duration" in aData) {
            if (aData.duration && !(aData.duration instanceof $c854a69b4095b587$var$ICAL.Duration)) throw new TypeError(".duration must be an instance of ICAL.Duration");
            this.duration = aData.duration;
        }
    };
    $c854a69b4095b587$var$ICAL.Period.prototype = {
        /**
     * The start of the period
     * @type {ICAL.Time}
     */ start: null,
        /**
     * The end of the period
     * @type {ICAL.Time}
     */ end: null,
        /**
     * The duration of the period
     * @type {ICAL.Duration}
     */ duration: null,
        /**
     * The class identifier.
     * @constant
     * @type {String}
     * @default "icalperiod"
     */ icalclass: "icalperiod",
        /**
     * The type name, to be used in the jCal object.
     * @constant
     * @type {String}
     * @default "period"
     */ icaltype: "period",
        /**
     * Returns a clone of the duration object.
     *
     * @return {ICAL.Period}      The cloned object
     */ clone: function() {
            return $c854a69b4095b587$var$ICAL.Period.fromData({
                start: this.start ? this.start.clone() : null,
                end: this.end ? this.end.clone() : null,
                duration: this.duration ? this.duration.clone() : null
            });
        },
        /**
     * Calculates the duration of the period, either directly or by subtracting
     * start from end date.
     *
     * @return {ICAL.Duration}      The calculated duration
     */ getDuration: function duration() {
            if (this.duration) return this.duration;
            else return this.end.subtractDate(this.start);
        },
        /**
     * Calculates the end date of the period, either directly or by adding
     * duration to start date.
     *
     * @return {ICAL.Time}          The calculated end date
     */ getEnd: function() {
            if (this.end) return this.end;
            else {
                var end = this.start.clone();
                end.addDuration(this.duration);
                return end;
            }
        },
        /**
     * The string representation of this period.
     * @return {String}
     */ toString: function toString() {
            return this.start + "/" + (this.end || this.duration);
        },
        /**
     * The jCal representation of this period type.
     * @return {Object}
     */ toJSON: function() {
            return [
                this.start.toString(),
                (this.end || this.duration).toString()
            ];
        },
        /**
     * The iCalendar string representation of this period.
     * @return {String}
     */ toICALString: function() {
            return this.start.toICALString() + "/" + (this.end || this.duration).toICALString();
        }
    };
    /**
   * Creates a new {@link ICAL.Period} instance from the passed string.
   *
   * @param {String} str            The string to parse
   * @param {ICAL.Property} prop    The property this period will be on
   * @return {ICAL.Period}          The created period instance
   */ $c854a69b4095b587$var$ICAL.Period.fromString = function fromString(str, prop) {
        var parts = str.split("/");
        if (parts.length !== 2) throw new Error('Invalid string value: "' + str + '" must contain a "/" char.');
        var options = {
            start: $c854a69b4095b587$var$ICAL.Time.fromDateTimeString(parts[0], prop)
        };
        var end = parts[1];
        if ($c854a69b4095b587$var$ICAL.Duration.isValueString(end)) options.duration = $c854a69b4095b587$var$ICAL.Duration.fromString(end);
        else options.end = $c854a69b4095b587$var$ICAL.Time.fromDateTimeString(end, prop);
        return new $c854a69b4095b587$var$ICAL.Period(options);
    };
    /**
   * Creates a new {@link ICAL.Period} instance from the given data object.
   * The passed data object cannot contain both and end date and a duration.
   *
   * @param {Object} aData                  An object with members of the period
   * @param {ICAL.Time=} aData.start        The start of the period
   * @param {ICAL.Time=} aData.end          The end of the period
   * @param {ICAL.Duration=} aData.duration The duration of the period
   * @return {ICAL.Period}                  The period instance
   */ $c854a69b4095b587$var$ICAL.Period.fromData = function fromData(aData) {
        return new $c854a69b4095b587$var$ICAL.Period(aData);
    };
    /**
   * Returns a new period instance from the given jCal data array. The first
   * member is always the start date string, the second member is either a
   * duration or end date string.
   *
   * @param {Array<String,String>} aData    The jCal data array
   * @param {ICAL.Property} aProp           The property this jCal data is on
   * @param {Boolean} aLenient              If true, data value can be both date and date-time
   * @return {ICAL.Period}                  The period instance
   */ $c854a69b4095b587$var$ICAL.Period.fromJSON = function(aData, aProp, aLenient) {
        function fromDateOrDateTimeString(aValue, aProp) {
            if (aLenient) return $c854a69b4095b587$var$ICAL.Time.fromString(aValue, aProp);
            else return $c854a69b4095b587$var$ICAL.Time.fromDateTimeString(aValue, aProp);
        }
        if ($c854a69b4095b587$var$ICAL.Duration.isValueString(aData[1])) return $c854a69b4095b587$var$ICAL.Period.fromData({
            start: fromDateOrDateTimeString(aData[0], aProp),
            duration: $c854a69b4095b587$var$ICAL.Duration.fromString(aData[1])
        });
        else return $c854a69b4095b587$var$ICAL.Period.fromData({
            start: fromDateOrDateTimeString(aData[0], aProp),
            end: fromDateOrDateTimeString(aData[1], aProp)
        });
    };
})();
/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 * Portions Copyright (C) Philipp Kewisch, 2011-2015 */ (function() {
    var DURATION_LETTERS = /([PDWHMTS]{1,1})/;
    /**
   * @classdesc
   * This class represents the "duration" value type, with various calculation
   * and manipulation methods.
   *
   * @class
   * @alias ICAL.Duration
   * @param {Object} data               An object with members of the duration
   * @param {Number} data.weeks         Duration in weeks
   * @param {Number} data.days          Duration in days
   * @param {Number} data.hours         Duration in hours
   * @param {Number} data.minutes       Duration in minutes
   * @param {Number} data.seconds       Duration in seconds
   * @param {Boolean} data.isNegative   If true, the duration is negative
   */ $c854a69b4095b587$var$ICAL.Duration = function icalduration(data) {
        this.wrappedJSObject = this;
        this.fromData(data);
    };
    $c854a69b4095b587$var$ICAL.Duration.prototype = {
        /**
     * The weeks in this duration
     * @type {Number}
     * @default 0
     */ weeks: 0,
        /**
     * The days in this duration
     * @type {Number}
     * @default 0
     */ days: 0,
        /**
     * The days in this duration
     * @type {Number}
     * @default 0
     */ hours: 0,
        /**
     * The minutes in this duration
     * @type {Number}
     * @default 0
     */ minutes: 0,
        /**
     * The seconds in this duration
     * @type {Number}
     * @default 0
     */ seconds: 0,
        /**
     * The seconds in this duration
     * @type {Boolean}
     * @default false
     */ isNegative: false,
        /**
     * The class identifier.
     * @constant
     * @type {String}
     * @default "icalduration"
     */ icalclass: "icalduration",
        /**
     * The type name, to be used in the jCal object.
     * @constant
     * @type {String}
     * @default "duration"
     */ icaltype: "duration",
        /**
     * Returns a clone of the duration object.
     *
     * @return {ICAL.Duration}      The cloned object
     */ clone: function clone() {
            return $c854a69b4095b587$var$ICAL.Duration.fromData(this);
        },
        /**
     * The duration value expressed as a number of seconds.
     *
     * @return {Number}             The duration value in seconds
     */ toSeconds: function toSeconds() {
            var seconds = this.seconds + 60 * this.minutes + 3600 * this.hours + 86400 * this.days + 604800 * this.weeks;
            return this.isNegative ? -seconds : seconds;
        },
        /**
     * Reads the passed seconds value into this duration object. Afterwards,
     * members like {@link ICAL.Duration#days days} and {@link ICAL.Duration#weeks weeks} will be set up
     * accordingly.
     *
     * @param {Number} aSeconds     The duration value in seconds
     * @return {ICAL.Duration}      Returns this instance
     */ fromSeconds: function fromSeconds(aSeconds) {
            var secs = Math.abs(aSeconds);
            this.isNegative = aSeconds < 0;
            this.days = $c854a69b4095b587$var$ICAL.helpers.trunc(secs / 86400);
            // If we have a flat number of weeks, use them.
            if (this.days % 7 == 0) {
                this.weeks = this.days / 7;
                this.days = 0;
            } else this.weeks = 0;
            secs -= (this.days + 7 * this.weeks) * 86400;
            this.hours = $c854a69b4095b587$var$ICAL.helpers.trunc(secs / 3600);
            secs -= this.hours * 3600;
            this.minutes = $c854a69b4095b587$var$ICAL.helpers.trunc(secs / 60);
            secs -= this.minutes * 60;
            this.seconds = secs;
            return this;
        },
        /**
     * Sets up the current instance using members from the passed data object.
     *
     * @param {Object} aData               An object with members of the duration
     * @param {Number} aData.weeks         Duration in weeks
     * @param {Number} aData.days          Duration in days
     * @param {Number} aData.hours         Duration in hours
     * @param {Number} aData.minutes       Duration in minutes
     * @param {Number} aData.seconds       Duration in seconds
     * @param {Boolean} aData.isNegative   If true, the duration is negative
     */ fromData: function fromData(aData) {
            var propsToCopy = [
                "weeks",
                "days",
                "hours",
                "minutes",
                "seconds",
                "isNegative"
            ];
            for(var key in propsToCopy){
                /* istanbul ignore if */ if (!propsToCopy.hasOwnProperty(key)) continue;
                var prop = propsToCopy[key];
                if (aData && prop in aData) this[prop] = aData[prop];
                else this[prop] = 0;
            }
        },
        /**
     * Resets the duration instance to the default values, i.e. PT0S
     */ reset: function reset() {
            this.isNegative = false;
            this.weeks = 0;
            this.days = 0;
            this.hours = 0;
            this.minutes = 0;
            this.seconds = 0;
        },
        /**
     * Compares the duration instance with another one.
     *
     * @param {ICAL.Duration} aOther        The instance to compare with
     * @return {Number}                     -1, 0 or 1 for less/equal/greater
     */ compare: function compare(aOther) {
            var thisSeconds = this.toSeconds();
            var otherSeconds = aOther.toSeconds();
            return (thisSeconds > otherSeconds) - (thisSeconds < otherSeconds);
        },
        /**
     * Normalizes the duration instance. For example, a duration with a value
     * of 61 seconds will be normalized to 1 minute and 1 second.
     */ normalize: function normalize() {
            this.fromSeconds(this.toSeconds());
        },
        /**
     * The string representation of this duration.
     * @return {String}
     */ toString: function toString() {
            if (this.toSeconds() == 0) return "PT0S";
            else {
                var str = "";
                if (this.isNegative) str += "-";
                str += "P";
                if (this.weeks) str += this.weeks + "W";
                if (this.days) str += this.days + "D";
                if (this.hours || this.minutes || this.seconds) {
                    str += "T";
                    if (this.hours) str += this.hours + "H";
                    if (this.minutes) str += this.minutes + "M";
                    if (this.seconds) str += this.seconds + "S";
                }
                return str;
            }
        },
        /**
     * The iCalendar string representation of this duration.
     * @return {String}
     */ toICALString: function() {
            return this.toString();
        }
    };
    /**
   * Returns a new ICAL.Duration instance from the passed seconds value.
   *
   * @param {Number} aSeconds       The seconds to create the instance from
   * @return {ICAL.Duration}        The newly created duration instance
   */ $c854a69b4095b587$var$ICAL.Duration.fromSeconds = function icalduration_from_seconds(aSeconds) {
        return new $c854a69b4095b587$var$ICAL.Duration().fromSeconds(aSeconds);
    };
    /**
   * Internal helper function to handle a chunk of a duration.
   *
   * @param {String} letter type of duration chunk
   * @param {String} number numeric value or -/+
   * @param {Object} dict target to assign values to
   */ function parseDurationChunk(letter, number, object) {
        var type;
        switch(letter){
            case "P":
                if (number && number === "-") object.isNegative = true;
                else object.isNegative = false;
                break;
            case "D":
                type = "days";
                break;
            case "W":
                type = "weeks";
                break;
            case "H":
                type = "hours";
                break;
            case "M":
                type = "minutes";
                break;
            case "S":
                type = "seconds";
                break;
            default:
                // Not a valid chunk
                return 0;
        }
        if (type) {
            if (!number && number !== 0) throw new Error('invalid duration value: Missing number before "' + letter + '"');
            var num = parseInt(number, 10);
            if ($c854a69b4095b587$var$ICAL.helpers.isStrictlyNaN(num)) throw new Error('invalid duration value: Invalid number "' + number + '" before "' + letter + '"');
            object[type] = num;
        }
        return 1;
    }
    /**
   * Checks if the given string is an iCalendar duration value.
   *
   * @param {String} value      The raw ical value
   * @return {Boolean}          True, if the given value is of the
   *                              duration ical type
   */ $c854a69b4095b587$var$ICAL.Duration.isValueString = function(string) {
        return string[0] === "P" || string[1] === "P";
    };
    /**
   * Creates a new {@link ICAL.Duration} instance from the passed string.
   *
   * @param {String} aStr       The string to parse
   * @return {ICAL.Duration}    The created duration instance
   */ $c854a69b4095b587$var$ICAL.Duration.fromString = function icalduration_from_string(aStr) {
        var pos = 0;
        var dict = Object.create(null);
        var chunks = 0;
        while((pos = aStr.search(DURATION_LETTERS)) !== -1){
            var type = aStr[pos];
            var numeric = aStr.substr(0, pos);
            aStr = aStr.substr(pos + 1);
            chunks += parseDurationChunk(type, numeric, dict);
        }
        if (chunks < 2) // There must be at least a chunk with "P" and some unit chunk
        throw new Error('invalid duration value: Not enough duration components in "' + aStr + '"');
        return new $c854a69b4095b587$var$ICAL.Duration(dict);
    };
    /**
   * Creates a new ICAL.Duration instance from the given data object.
   *
   * @param {Object} aData               An object with members of the duration
   * @param {Number} aData.weeks         Duration in weeks
   * @param {Number} aData.days          Duration in days
   * @param {Number} aData.hours         Duration in hours
   * @param {Number} aData.minutes       Duration in minutes
   * @param {Number} aData.seconds       Duration in seconds
   * @param {Boolean} aData.isNegative   If true, the duration is negative
   * @return {ICAL.Duration}             The createad duration instance
   */ $c854a69b4095b587$var$ICAL.Duration.fromData = function icalduration_from_data(aData) {
        return new $c854a69b4095b587$var$ICAL.Duration(aData);
    };
})();
/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 * Portions Copyright (C) Philipp Kewisch, 2011-2012 */ (function() {
    var OPTIONS = [
        "tzid",
        "location",
        "tznames",
        "latitude",
        "longitude"
    ];
    /**
   * @classdesc
   * Timezone representation, created by passing in a tzid and component.
   *
   * @example
   * var vcalendar;
   * var timezoneComp = vcalendar.getFirstSubcomponent('vtimezone');
   * var tzid = timezoneComp.getFirstPropertyValue('tzid');
   *
   * var timezone = new ICAL.Timezone({
   *   component: timezoneComp,
   *   tzid
   * });
   *
   * @class
   * @param {ICAL.Component|Object} data options for class
   * @param {String|ICAL.Component} data.component
   *        If data is a simple object, then this member can be set to either a
   *        string containing the component data, or an already parsed
   *        ICAL.Component
   * @param {String} data.tzid      The timezone identifier
   * @param {String} data.location  The timezone locationw
   * @param {String} data.tznames   An alternative string representation of the
   *                                  timezone
   * @param {Number} data.latitude  The latitude of the timezone
   * @param {Number} data.longitude The longitude of the timezone
   */ $c854a69b4095b587$var$ICAL.Timezone = function icaltimezone(data) {
        this.wrappedJSObject = this;
        this.fromData(data);
    };
    $c854a69b4095b587$var$ICAL.Timezone.prototype = {
        /**
     * Timezone identifier
     * @type {String}
     */ tzid: "",
        /**
     * Timezone location
     * @type {String}
     */ location: "",
        /**
     * Alternative timezone name, for the string representation
     * @type {String}
     */ tznames: "",
        /**
     * The primary latitude for the timezone.
     * @type {Number}
     */ latitude: 0.0,
        /**
     * The primary longitude for the timezone.
     * @type {Number}
     */ longitude: 0.0,
        /**
     * The vtimezone component for this timezone.
     * @type {ICAL.Component}
     */ component: null,
        /**
     * The year this timezone has been expanded to. All timezone transition
     * dates until this year are known and can be used for calculation
     *
     * @private
     * @type {Number}
     */ expandedUntilYear: 0,
        /**
     * The class identifier.
     * @constant
     * @type {String}
     * @default "icaltimezone"
     */ icalclass: "icaltimezone",
        /**
     * Sets up the current instance using members from the passed data object.
     *
     * @param {ICAL.Component|Object} aData options for class
     * @param {String|ICAL.Component} aData.component
     *        If aData is a simple object, then this member can be set to either a
     *        string containing the component data, or an already parsed
     *        ICAL.Component
     * @param {String} aData.tzid      The timezone identifier
     * @param {String} aData.location  The timezone locationw
     * @param {String} aData.tznames   An alternative string representation of the
     *                                  timezone
     * @param {Number} aData.latitude  The latitude of the timezone
     * @param {Number} aData.longitude The longitude of the timezone
     */ fromData: function fromData(aData) {
            this.expandedUntilYear = 0;
            this.changes = [];
            if (aData instanceof $c854a69b4095b587$var$ICAL.Component) // Either a component is passed directly
            this.component = aData;
            else {
                // Otherwise the component may be in the data object
                if (aData && "component" in aData) {
                    if (typeof aData.component == "string") {
                        // If a string was passed, parse it as a component
                        var jCal = $c854a69b4095b587$var$ICAL.parse(aData.component);
                        this.component = new $c854a69b4095b587$var$ICAL.Component(jCal);
                    } else if (aData.component instanceof $c854a69b4095b587$var$ICAL.Component) // If it was a component already, then just set it
                    this.component = aData.component;
                    else // Otherwise just null out the component
                    this.component = null;
                }
                // Copy remaining passed properties
                for(var key in OPTIONS)/* istanbul ignore else */ if (OPTIONS.hasOwnProperty(key)) {
                    var prop = OPTIONS[key];
                    if (aData && prop in aData) this[prop] = aData[prop];
                }
            }
            // If we have a component but no TZID, attempt to get it from the
            // component's properties.
            if (this.component instanceof $c854a69b4095b587$var$ICAL.Component && !this.tzid) this.tzid = this.component.getFirstPropertyValue("tzid");
            return this;
        },
        /**
     * Finds the utcOffset the given time would occur in this timezone.
     *
     * @param {ICAL.Time} tt        The time to check for
     * @return {Number} utc offset in seconds
     */ utcOffset: function utcOffset(tt) {
            if (this == $c854a69b4095b587$var$ICAL.Timezone.utcTimezone || this == $c854a69b4095b587$var$ICAL.Timezone.localTimezone) return 0;
            this._ensureCoverage(tt.year);
            if (!this.changes.length) return 0;
            var tt_change = {
                year: tt.year,
                month: tt.month,
                day: tt.day,
                hour: tt.hour,
                minute: tt.minute,
                second: tt.second
            };
            var change_num = this._findNearbyChange(tt_change);
            var change_num_to_use = -1;
            var step = 1;
            // TODO: replace with bin search?
            for(;;){
                var change = $c854a69b4095b587$var$ICAL.helpers.clone(this.changes[change_num], true);
                if (change.utcOffset < change.prevUtcOffset) $c854a69b4095b587$var$ICAL.Timezone.adjust_change(change, 0, 0, 0, change.utcOffset);
                else $c854a69b4095b587$var$ICAL.Timezone.adjust_change(change, 0, 0, 0, change.prevUtcOffset);
                var cmp = $c854a69b4095b587$var$ICAL.Timezone._compare_change_fn(tt_change, change);
                if (cmp >= 0) change_num_to_use = change_num;
                else step = -1;
                if (step == -1 && change_num_to_use != -1) break;
                change_num += step;
                if (change_num < 0) return 0;
                if (change_num >= this.changes.length) break;
            }
            var zone_change = this.changes[change_num_to_use];
            var utcOffset_change = zone_change.utcOffset - zone_change.prevUtcOffset;
            if (utcOffset_change < 0 && change_num_to_use > 0) {
                var tmp_change = $c854a69b4095b587$var$ICAL.helpers.clone(zone_change, true);
                $c854a69b4095b587$var$ICAL.Timezone.adjust_change(tmp_change, 0, 0, 0, tmp_change.prevUtcOffset);
                if ($c854a69b4095b587$var$ICAL.Timezone._compare_change_fn(tt_change, tmp_change) < 0) {
                    var prev_zone_change = this.changes[change_num_to_use - 1];
                    var want_daylight = false; // TODO
                    if (zone_change.is_daylight != want_daylight && prev_zone_change.is_daylight == want_daylight) zone_change = prev_zone_change;
                }
            }
            // TODO return is_daylight?
            return zone_change.utcOffset;
        },
        _findNearbyChange: function icaltimezone_find_nearby_change(change) {
            // find the closest match
            var idx = $c854a69b4095b587$var$ICAL.helpers.binsearchInsert(this.changes, change, $c854a69b4095b587$var$ICAL.Timezone._compare_change_fn);
            if (idx >= this.changes.length) return this.changes.length - 1;
            return idx;
        },
        _ensureCoverage: function(aYear) {
            if ($c854a69b4095b587$var$ICAL.Timezone._minimumExpansionYear == -1) {
                var today = $c854a69b4095b587$var$ICAL.Time.now();
                $c854a69b4095b587$var$ICAL.Timezone._minimumExpansionYear = today.year;
            }
            var changesEndYear = aYear;
            if (changesEndYear < $c854a69b4095b587$var$ICAL.Timezone._minimumExpansionYear) changesEndYear = $c854a69b4095b587$var$ICAL.Timezone._minimumExpansionYear;
            changesEndYear += $c854a69b4095b587$var$ICAL.Timezone.EXTRA_COVERAGE;
            if (changesEndYear > $c854a69b4095b587$var$ICAL.Timezone.MAX_YEAR) changesEndYear = $c854a69b4095b587$var$ICAL.Timezone.MAX_YEAR;
            if (!this.changes.length || this.expandedUntilYear < aYear) {
                var subcomps = this.component.getAllSubcomponents();
                var compLen = subcomps.length;
                var compIdx = 0;
                for(; compIdx < compLen; compIdx++)this._expandComponent(subcomps[compIdx], changesEndYear, this.changes);
                this.changes.sort($c854a69b4095b587$var$ICAL.Timezone._compare_change_fn);
                this.expandedUntilYear = changesEndYear;
            }
        },
        _expandComponent: function(aComponent, aYear, changes) {
            if (!aComponent.hasProperty("dtstart") || !aComponent.hasProperty("tzoffsetto") || !aComponent.hasProperty("tzoffsetfrom")) return null;
            var dtstart = aComponent.getFirstProperty("dtstart").getFirstValue();
            var change;
            function convert_tzoffset(offset) {
                return offset.factor * (offset.hours * 3600 + offset.minutes * 60);
            }
            function init_changes() {
                var changebase = {};
                changebase.is_daylight = aComponent.name == "daylight";
                changebase.utcOffset = convert_tzoffset(aComponent.getFirstProperty("tzoffsetto").getFirstValue());
                changebase.prevUtcOffset = convert_tzoffset(aComponent.getFirstProperty("tzoffsetfrom").getFirstValue());
                return changebase;
            }
            if (!aComponent.hasProperty("rrule") && !aComponent.hasProperty("rdate")) {
                change = init_changes();
                change.year = dtstart.year;
                change.month = dtstart.month;
                change.day = dtstart.day;
                change.hour = dtstart.hour;
                change.minute = dtstart.minute;
                change.second = dtstart.second;
                $c854a69b4095b587$var$ICAL.Timezone.adjust_change(change, 0, 0, 0, -change.prevUtcOffset);
                changes.push(change);
            } else {
                var props = aComponent.getAllProperties("rdate");
                for(var rdatekey in props){
                    /* istanbul ignore if */ if (!props.hasOwnProperty(rdatekey)) continue;
                    var rdate = props[rdatekey];
                    var time = rdate.getFirstValue();
                    change = init_changes();
                    change.year = time.year;
                    change.month = time.month;
                    change.day = time.day;
                    if (time.isDate) {
                        change.hour = dtstart.hour;
                        change.minute = dtstart.minute;
                        change.second = dtstart.second;
                        if (dtstart.zone != $c854a69b4095b587$var$ICAL.Timezone.utcTimezone) $c854a69b4095b587$var$ICAL.Timezone.adjust_change(change, 0, 0, 0, -change.prevUtcOffset);
                    } else {
                        change.hour = time.hour;
                        change.minute = time.minute;
                        change.second = time.second;
                        if (time.zone != $c854a69b4095b587$var$ICAL.Timezone.utcTimezone) $c854a69b4095b587$var$ICAL.Timezone.adjust_change(change, 0, 0, 0, -change.prevUtcOffset);
                    }
                    changes.push(change);
                }
                var rrule = aComponent.getFirstProperty("rrule");
                if (rrule) {
                    rrule = rrule.getFirstValue();
                    change = init_changes();
                    if (rrule.until && rrule.until.zone == $c854a69b4095b587$var$ICAL.Timezone.utcTimezone) {
                        rrule.until.adjust(0, 0, 0, change.prevUtcOffset);
                        rrule.until.zone = $c854a69b4095b587$var$ICAL.Timezone.localTimezone;
                    }
                    var iterator = rrule.iterator(dtstart);
                    var occ;
                    while(occ = iterator.next()){
                        change = init_changes();
                        if (occ.year > aYear || !occ) break;
                        change.year = occ.year;
                        change.month = occ.month;
                        change.day = occ.day;
                        change.hour = occ.hour;
                        change.minute = occ.minute;
                        change.second = occ.second;
                        change.isDate = occ.isDate;
                        $c854a69b4095b587$var$ICAL.Timezone.adjust_change(change, 0, 0, 0, -change.prevUtcOffset);
                        changes.push(change);
                    }
                }
            }
            return changes;
        },
        /**
     * The string representation of this timezone.
     * @return {String}
     */ toString: function toString() {
            return this.tznames ? this.tznames : this.tzid;
        }
    };
    $c854a69b4095b587$var$ICAL.Timezone._compare_change_fn = function icaltimezone_compare_change_fn(a, b) {
        if (a.year < b.year) return -1;
        else if (a.year > b.year) return 1;
        if (a.month < b.month) return -1;
        else if (a.month > b.month) return 1;
        if (a.day < b.day) return -1;
        else if (a.day > b.day) return 1;
        if (a.hour < b.hour) return -1;
        else if (a.hour > b.hour) return 1;
        if (a.minute < b.minute) return -1;
        else if (a.minute > b.minute) return 1;
        if (a.second < b.second) return -1;
        else if (a.second > b.second) return 1;
        return 0;
    };
    /**
   * Convert the date/time from one zone to the next.
   *
   * @param {ICAL.Time} tt                  The time to convert
   * @param {ICAL.Timezone} from_zone       The source zone to convert from
   * @param {ICAL.Timezone} to_zone         The target zone to convert to
   * @return {ICAL.Time}                    The converted date/time object
   */ $c854a69b4095b587$var$ICAL.Timezone.convert_time = function icaltimezone_convert_time(tt, from_zone, to_zone) {
        if (tt.isDate || from_zone.tzid == to_zone.tzid || from_zone == $c854a69b4095b587$var$ICAL.Timezone.localTimezone || to_zone == $c854a69b4095b587$var$ICAL.Timezone.localTimezone) {
            tt.zone = to_zone;
            return tt;
        }
        var utcOffset = from_zone.utcOffset(tt);
        tt.adjust(0, 0, 0, -utcOffset);
        utcOffset = to_zone.utcOffset(tt);
        tt.adjust(0, 0, 0, utcOffset);
        return null;
    };
    /**
   * Creates a new ICAL.Timezone instance from the passed data object.
   *
   * @param {ICAL.Component|Object} aData options for class
   * @param {String|ICAL.Component} aData.component
   *        If aData is a simple object, then this member can be set to either a
   *        string containing the component data, or an already parsed
   *        ICAL.Component
   * @param {String} aData.tzid      The timezone identifier
   * @param {String} aData.location  The timezone locationw
   * @param {String} aData.tznames   An alternative string representation of the
   *                                  timezone
   * @param {Number} aData.latitude  The latitude of the timezone
   * @param {Number} aData.longitude The longitude of the timezone
   */ $c854a69b4095b587$var$ICAL.Timezone.fromData = function icaltimezone_fromData(aData) {
        var tt = new $c854a69b4095b587$var$ICAL.Timezone();
        return tt.fromData(aData);
    };
    /**
   * The instance describing the UTC timezone
   * @type {ICAL.Timezone}
   * @constant
   * @instance
   */ $c854a69b4095b587$var$ICAL.Timezone.utcTimezone = $c854a69b4095b587$var$ICAL.Timezone.fromData({
        tzid: "UTC"
    });
    /**
   * The instance describing the local timezone
   * @type {ICAL.Timezone}
   * @constant
   * @instance
   */ $c854a69b4095b587$var$ICAL.Timezone.localTimezone = $c854a69b4095b587$var$ICAL.Timezone.fromData({
        tzid: "floating"
    });
    /**
   * Adjust a timezone change object.
   * @private
   * @param {Object} change     The timezone change object
   * @param {Number} days       The extra amount of days
   * @param {Number} hours      The extra amount of hours
   * @param {Number} minutes    The extra amount of minutes
   * @param {Number} seconds    The extra amount of seconds
   */ $c854a69b4095b587$var$ICAL.Timezone.adjust_change = function icaltimezone_adjust_change(change, days, hours, minutes, seconds) {
        return $c854a69b4095b587$var$ICAL.Time.prototype.adjust.call(change, days, hours, minutes, seconds, change);
    };
    $c854a69b4095b587$var$ICAL.Timezone._minimumExpansionYear = -1;
    $c854a69b4095b587$var$ICAL.Timezone.MAX_YEAR = 2035; // TODO this is because of time_t, which we don't need. Still usefull?
    $c854a69b4095b587$var$ICAL.Timezone.EXTRA_COVERAGE = 5;
})();
/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 * Portions Copyright (C) Philipp Kewisch, 2011-2015 */ /**
 * This symbol is further described later on
 * @ignore
 */ $c854a69b4095b587$var$ICAL.TimezoneService = function() {
    var zones;
    /**
   * @classdesc
   * Singleton class to contain timezones.  Right now it is all manual registry in
   * the future we may use this class to download timezone information or handle
   * loading pre-expanded timezones.
   *
   * @namespace
   * @alias ICAL.TimezoneService
   */ var TimezoneService = {
        get count () {
            return Object.keys(zones).length;
        },
        reset: function() {
            zones = Object.create(null);
            var utc = $c854a69b4095b587$var$ICAL.Timezone.utcTimezone;
            zones.Z = utc;
            zones.UTC = utc;
            zones.GMT = utc;
        },
        /**
     * Checks if timezone id has been registered.
     *
     * @param {String} tzid     Timezone identifier (e.g. America/Los_Angeles)
     * @return {Boolean}        False, when not present
     */ has: function(tzid) {
            return !!zones[tzid];
        },
        /**
     * Returns a timezone by its tzid if present.
     *
     * @param {String} tzid     Timezone identifier (e.g. America/Los_Angeles)
     * @return {?ICAL.Timezone} The timezone, or null if not found
     */ get: function(tzid) {
            return zones[tzid];
        },
        /**
     * Registers a timezone object or component.
     *
     * @param {String=} name
     *        The name of the timezone. Defaults to the component's TZID if not
     *        passed.
     * @param {ICAL.Component|ICAL.Timezone} zone
     *        The initialized zone or vtimezone.
     */ register: function(name, timezone) {
            if (name instanceof $c854a69b4095b587$var$ICAL.Component) {
                if (name.name === "vtimezone") {
                    timezone = new $c854a69b4095b587$var$ICAL.Timezone(name);
                    name = timezone.tzid;
                }
            }
            if (timezone instanceof $c854a69b4095b587$var$ICAL.Timezone) zones[name] = timezone;
            else throw new TypeError("timezone must be ICAL.Timezone or ICAL.Component");
        },
        /**
     * Removes a timezone by its tzid from the list.
     *
     * @param {String} tzid     Timezone identifier (e.g. America/Los_Angeles)
     * @return {?ICAL.Timezone} The removed timezone, or null if not registered
     */ remove: function(tzid) {
            return delete zones[tzid];
        }
    };
    // initialize defaults
    TimezoneService.reset();
    return TimezoneService;
}();
/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 * Portions Copyright (C) Philipp Kewisch, 2011-2015 */ (function() {
    /**
   * @classdesc
   * iCalendar Time representation (similar to JS Date object).  Fully
   * independent of system (OS) timezone / time.  Unlike JS Date, the month
   * January is 1, not zero.
   *
   * @example
   * var time = new ICAL.Time({
   *   year: 2012,
   *   month: 10,
   *   day: 11
   *   minute: 0,
   *   second: 0,
   *   isDate: false
   * });
   *
   *
   * @alias ICAL.Time
   * @class
   * @param {Object} data           Time initialization
   * @param {Number=} data.year     The year for this date
   * @param {Number=} data.month    The month for this date
   * @param {Number=} data.day      The day for this date
   * @param {Number=} data.hour     The hour for this date
   * @param {Number=} data.minute   The minute for this date
   * @param {Number=} data.second   The second for this date
   * @param {Boolean=} data.isDate  If true, the instance represents a date (as
   *                                  opposed to a date-time)
   * @param {ICAL.Timezone} zone timezone this position occurs in
   */ $c854a69b4095b587$var$ICAL.Time = function icaltime(data, zone) {
        this.wrappedJSObject = this;
        var time = this._time = Object.create(null);
        /* time defaults */ time.year = 0;
        time.month = 1;
        time.day = 1;
        time.hour = 0;
        time.minute = 0;
        time.second = 0;
        time.isDate = false;
        this.fromData(data, zone);
    };
    $c854a69b4095b587$var$ICAL.Time._dowCache = {};
    $c854a69b4095b587$var$ICAL.Time._wnCache = {};
    $c854a69b4095b587$var$ICAL.Time.prototype = {
        /**
     * The class identifier.
     * @constant
     * @type {String}
     * @default "icaltime"
     */ icalclass: "icaltime",
        _cachedUnixTime: null,
        /**
     * The type name, to be used in the jCal object. This value may change and
     * is strictly defined by the {@link ICAL.Time#isDate isDate} member.
     * @readonly
     * @type {String}
     * @default "date-time"
     */ get icaltype () {
            return this.isDate ? "date" : "date-time";
        },
        /**
     * The timezone for this time.
     * @type {ICAL.Timezone}
     */ zone: null,
        /**
     * Internal uses to indicate that a change has been made and the next read
     * operation must attempt to normalize the value (for example changing the
     * day to 33).
     *
     * @type {Boolean}
     * @private
     */ _pendingNormalization: false,
        /**
     * Returns a clone of the time object.
     *
     * @return {ICAL.Time}              The cloned object
     */ clone: function() {
            return new $c854a69b4095b587$var$ICAL.Time(this._time, this.zone);
        },
        /**
     * Reset the time instance to epoch time
     */ reset: function icaltime_reset() {
            this.fromData($c854a69b4095b587$var$ICAL.Time.epochTime);
            this.zone = $c854a69b4095b587$var$ICAL.Timezone.utcTimezone;
        },
        /**
     * Reset the time instance to the given date/time values.
     *
     * @param {Number} year             The year to set
     * @param {Number} month            The month to set
     * @param {Number} day              The day to set
     * @param {Number} hour             The hour to set
     * @param {Number} minute           The minute to set
     * @param {Number} second           The second to set
     * @param {ICAL.Timezone} timezone  The timezone to set
     */ resetTo: function icaltime_resetTo(year, month, day, hour, minute, second, timezone) {
            this.fromData({
                year: year,
                month: month,
                day: day,
                hour: hour,
                minute: minute,
                second: second,
                zone: timezone
            });
        },
        /**
     * Set up the current instance from the Javascript date value.
     *
     * @param {?Date} aDate     The Javascript Date to read, or null to reset
     * @param {Boolean} useUTC  If true, the UTC values of the date will be used
     */ fromJSDate: function icaltime_fromJSDate(aDate, useUTC) {
            if (!aDate) this.reset();
            else if (useUTC) {
                this.zone = $c854a69b4095b587$var$ICAL.Timezone.utcTimezone;
                this.year = aDate.getUTCFullYear();
                this.month = aDate.getUTCMonth() + 1;
                this.day = aDate.getUTCDate();
                this.hour = aDate.getUTCHours();
                this.minute = aDate.getUTCMinutes();
                this.second = aDate.getUTCSeconds();
            } else {
                this.zone = $c854a69b4095b587$var$ICAL.Timezone.localTimezone;
                this.year = aDate.getFullYear();
                this.month = aDate.getMonth() + 1;
                this.day = aDate.getDate();
                this.hour = aDate.getHours();
                this.minute = aDate.getMinutes();
                this.second = aDate.getSeconds();
            }
            this._cachedUnixTime = null;
            return this;
        },
        /**
     * Sets up the current instance using members from the passed data object.
     *
     * @param {Object} aData            Time initialization
     * @param {Number=} aData.year      The year for this date
     * @param {Number=} aData.month     The month for this date
     * @param {Number=} aData.day       The day for this date
     * @param {Number=} aData.hour      The hour for this date
     * @param {Number=} aData.minute    The minute for this date
     * @param {Number=} aData.second    The second for this date
     * @param {Boolean=} aData.isDate   If true, the instance represents a date
     *                                    (as opposed to a date-time)
     * @param {ICAL.Timezone=} aZone    Timezone this position occurs in
     */ fromData: function fromData(aData, aZone) {
            if (aData) {
                for(var key in aData)/* istanbul ignore else */ if (Object.prototype.hasOwnProperty.call(aData, key)) {
                    // ical type cannot be set
                    if (key === "icaltype") continue;
                    this[key] = aData[key];
                }
            }
            if (aZone) this.zone = aZone;
            if (aData && !("isDate" in aData)) this.isDate = !("hour" in aData);
            else if (aData && "isDate" in aData) this.isDate = aData.isDate;
            if (aData && "timezone" in aData) {
                var zone = $c854a69b4095b587$var$ICAL.TimezoneService.get(aData.timezone);
                this.zone = zone || $c854a69b4095b587$var$ICAL.Timezone.localTimezone;
            }
            if (aData && "zone" in aData) this.zone = aData.zone;
            if (!this.zone) this.zone = $c854a69b4095b587$var$ICAL.Timezone.localTimezone;
            this._cachedUnixTime = null;
            return this;
        },
        /**
     * Calculate the day of week.
     * @param {ICAL.Time.weekDay=} aWeekStart
     *        The week start weekday, defaults to SUNDAY
     * @return {ICAL.Time.weekDay}
     */ dayOfWeek: function icaltime_dayOfWeek(aWeekStart) {
            var firstDow = aWeekStart || $c854a69b4095b587$var$ICAL.Time.SUNDAY;
            var dowCacheKey = (this.year << 12) + (this.month << 8) + (this.day << 3) + firstDow;
            if (dowCacheKey in $c854a69b4095b587$var$ICAL.Time._dowCache) return $c854a69b4095b587$var$ICAL.Time._dowCache[dowCacheKey];
            // Using Zeller's algorithm
            var q = this.day;
            var m = this.month + (this.month < 3 ? 12 : 0);
            var Y = this.year - (this.month < 3 ? 1 : 0);
            var h = q + Y + $c854a69b4095b587$var$ICAL.helpers.trunc((m + 1) * 26 / 10) + $c854a69b4095b587$var$ICAL.helpers.trunc(Y / 4);
            h += $c854a69b4095b587$var$ICAL.helpers.trunc(Y / 100) * 6 + $c854a69b4095b587$var$ICAL.helpers.trunc(Y / 400);
            // Normalize to 1 = wkst
            h = (h + 7 - firstDow) % 7 + 1;
            $c854a69b4095b587$var$ICAL.Time._dowCache[dowCacheKey] = h;
            return h;
        },
        /**
     * Calculate the day of year.
     * @return {Number}
     */ dayOfYear: function dayOfYear() {
            var is_leap = $c854a69b4095b587$var$ICAL.Time.isLeapYear(this.year) ? 1 : 0;
            var diypm = $c854a69b4095b587$var$ICAL.Time.daysInYearPassedMonth;
            return diypm[is_leap][this.month - 1] + this.day;
        },
        /**
     * Returns a copy of the current date/time, rewound to the start of the
     * week. The resulting ICAL.Time instance is of icaltype date, even if this
     * is a date-time.
     *
     * @param {ICAL.Time.weekDay=} aWeekStart
     *        The week start weekday, defaults to SUNDAY
     * @return {ICAL.Time}      The start of the week (cloned)
     */ startOfWeek: function startOfWeek(aWeekStart) {
            var firstDow = aWeekStart || $c854a69b4095b587$var$ICAL.Time.SUNDAY;
            var result = this.clone();
            result.day -= (this.dayOfWeek() + 7 - firstDow) % 7;
            result.isDate = true;
            result.hour = 0;
            result.minute = 0;
            result.second = 0;
            return result;
        },
        /**
     * Returns a copy of the current date/time, shifted to the end of the week.
     * The resulting ICAL.Time instance is of icaltype date, even if this is a
     * date-time.
     *
     * @param {ICAL.Time.weekDay=} aWeekStart
     *        The week start weekday, defaults to SUNDAY
     * @return {ICAL.Time}      The end of the week (cloned)
     */ endOfWeek: function endOfWeek(aWeekStart) {
            var firstDow = aWeekStart || $c854a69b4095b587$var$ICAL.Time.SUNDAY;
            var result = this.clone();
            result.day += (7 - this.dayOfWeek() + firstDow - $c854a69b4095b587$var$ICAL.Time.SUNDAY) % 7;
            result.isDate = true;
            result.hour = 0;
            result.minute = 0;
            result.second = 0;
            return result;
        },
        /**
     * Returns a copy of the current date/time, rewound to the start of the
     * month. The resulting ICAL.Time instance is of icaltype date, even if
     * this is a date-time.
     *
     * @return {ICAL.Time}      The start of the month (cloned)
     */ startOfMonth: function startOfMonth() {
            var result = this.clone();
            result.day = 1;
            result.isDate = true;
            result.hour = 0;
            result.minute = 0;
            result.second = 0;
            return result;
        },
        /**
     * Returns a copy of the current date/time, shifted to the end of the
     * month.  The resulting ICAL.Time instance is of icaltype date, even if
     * this is a date-time.
     *
     * @return {ICAL.Time}      The end of the month (cloned)
     */ endOfMonth: function endOfMonth() {
            var result = this.clone();
            result.day = $c854a69b4095b587$var$ICAL.Time.daysInMonth(result.month, result.year);
            result.isDate = true;
            result.hour = 0;
            result.minute = 0;
            result.second = 0;
            return result;
        },
        /**
     * Returns a copy of the current date/time, rewound to the start of the
     * year. The resulting ICAL.Time instance is of icaltype date, even if
     * this is a date-time.
     *
     * @return {ICAL.Time}      The start of the year (cloned)
     */ startOfYear: function startOfYear() {
            var result = this.clone();
            result.day = 1;
            result.month = 1;
            result.isDate = true;
            result.hour = 0;
            result.minute = 0;
            result.second = 0;
            return result;
        },
        /**
     * Returns a copy of the current date/time, shifted to the end of the
     * year.  The resulting ICAL.Time instance is of icaltype date, even if
     * this is a date-time.
     *
     * @return {ICAL.Time}      The end of the year (cloned)
     */ endOfYear: function endOfYear() {
            var result = this.clone();
            result.day = 31;
            result.month = 12;
            result.isDate = true;
            result.hour = 0;
            result.minute = 0;
            result.second = 0;
            return result;
        },
        /**
     * First calculates the start of the week, then returns the day of year for
     * this date. If the day falls into the previous year, the day is zero or negative.
     *
     * @param {ICAL.Time.weekDay=} aFirstDayOfWeek
     *        The week start weekday, defaults to SUNDAY
     * @return {Number}     The calculated day of year
     */ startDoyWeek: function startDoyWeek(aFirstDayOfWeek) {
            var firstDow = aFirstDayOfWeek || $c854a69b4095b587$var$ICAL.Time.SUNDAY;
            var delta = this.dayOfWeek() - firstDow;
            if (delta < 0) delta += 7;
            return this.dayOfYear() - delta;
        },
        /**
     * Get the dominical letter for the current year. Letters range from A - G
     * for common years, and AG to GF for leap years.
     *
     * @param {Number} yr           The year to retrieve the letter for
     * @return {String}             The dominical letter.
     */ getDominicalLetter: function() {
            return $c854a69b4095b587$var$ICAL.Time.getDominicalLetter(this.year);
        },
        /**
     * Finds the nthWeekDay relative to the current month (not day).  The
     * returned value is a day relative the month that this month belongs to so
     * 1 would indicate the first of the month and 40 would indicate a day in
     * the following month.
     *
     * @param {Number} aDayOfWeek   Day of the week see the day name constants
     * @param {Number} aPos         Nth occurrence of a given week day values
     *        of 1 and 0 both indicate the first weekday of that type. aPos may
     *        be either positive or negative
     *
     * @return {Number} numeric value indicating a day relative
     *                   to the current month of this time object
     */ nthWeekDay: function icaltime_nthWeekDay(aDayOfWeek, aPos) {
            var daysInMonth = $c854a69b4095b587$var$ICAL.Time.daysInMonth(this.month, this.year);
            var weekday;
            var pos = aPos;
            var start = 0;
            var otherDay = this.clone();
            if (pos >= 0) {
                otherDay.day = 1;
                // because 0 means no position has been given
                // 1 and 0 indicate the same day.
                if (pos != 0) // remove the extra numeric value
                pos--;
                // set current start offset to current day.
                start = otherDay.day;
                // find the current day of week
                var startDow = otherDay.dayOfWeek();
                // calculate the difference between current
                // day of the week and desired day of the week
                var offset = aDayOfWeek - startDow;
                // if the offset goes into the past
                // week we add 7 so it goes into the next
                // week. We only want to go forward in time here.
                if (offset < 0) // this is really important otherwise we would
                // end up with dates from in the past.
                offset += 7;
                // add offset to start so start is the same
                // day of the week as the desired day of week.
                start += offset;
                // because we are going to add (and multiply)
                // the numeric value of the day we subtract it
                // from the start position so not to add it twice.
                start -= aDayOfWeek;
                // set week day
                weekday = aDayOfWeek;
            } else {
                // then we set it to the last day in the current month
                otherDay.day = daysInMonth;
                // find the ends weekday
                var endDow = otherDay.dayOfWeek();
                pos++;
                weekday = endDow - aDayOfWeek;
                if (weekday < 0) weekday += 7;
                weekday = daysInMonth - weekday;
            }
            weekday += pos * 7;
            return start + weekday;
        },
        /**
     * Checks if current time is the nth weekday, relative to the current
     * month.  Will always return false when rule resolves outside of current
     * month.
     *
     * @param {ICAL.Time.weekDay} aDayOfWeek       Day of week to check
     * @param {Number} aPos                        Relative position
     * @return {Boolean}                           True, if it is the nth weekday
     */ isNthWeekDay: function(aDayOfWeek, aPos) {
            var dow = this.dayOfWeek();
            if (aPos === 0 && dow === aDayOfWeek) return true;
            // get pos
            var day = this.nthWeekDay(aDayOfWeek, aPos);
            if (day === this.day) return true;
            return false;
        },
        /**
     * Calculates the ISO 8601 week number. The first week of a year is the
     * week that contains the first Thursday. The year can have 53 weeks, if
     * January 1st is a Friday.
     *
     * Note there are regions where the first week of the year is the one that
     * starts on January 1st, which may offset the week number. Also, if a
     * different week start is specified, this will also affect the week
     * number.
     *
     * @see ICAL.Time.weekOneStarts
     * @param {ICAL.Time.weekDay} aWeekStart        The weekday the week starts with
     * @return {Number}                             The ISO week number
     */ weekNumber: function weekNumber(aWeekStart) {
            var wnCacheKey = (this.year << 12) + (this.month << 8) + (this.day << 3) + aWeekStart;
            if (wnCacheKey in $c854a69b4095b587$var$ICAL.Time._wnCache) return $c854a69b4095b587$var$ICAL.Time._wnCache[wnCacheKey];
            // This function courtesty of Julian Bucknall, published under the MIT license
            // http://www.boyet.com/articles/publishedarticles/calculatingtheisoweeknumb.html
            // plus some fixes to be able to use different week starts.
            var week1;
            var dt = this.clone();
            dt.isDate = true;
            var isoyear = this.year;
            if (dt.month == 12 && dt.day > 25) {
                week1 = $c854a69b4095b587$var$ICAL.Time.weekOneStarts(isoyear + 1, aWeekStart);
                if (dt.compare(week1) < 0) week1 = $c854a69b4095b587$var$ICAL.Time.weekOneStarts(isoyear, aWeekStart);
                else isoyear++;
            } else {
                week1 = $c854a69b4095b587$var$ICAL.Time.weekOneStarts(isoyear, aWeekStart);
                if (dt.compare(week1) < 0) week1 = $c854a69b4095b587$var$ICAL.Time.weekOneStarts(--isoyear, aWeekStart);
            }
            var daysBetween = dt.subtractDate(week1).toSeconds() / 86400;
            var answer = $c854a69b4095b587$var$ICAL.helpers.trunc(daysBetween / 7) + 1;
            $c854a69b4095b587$var$ICAL.Time._wnCache[wnCacheKey] = answer;
            return answer;
        },
        /**
     * Adds the duration to the current time. The instance is modified in
     * place.
     *
     * @param {ICAL.Duration} aDuration         The duration to add
     */ addDuration: function icaltime_add(aDuration) {
            var mult = aDuration.isNegative ? -1 : 1;
            // because of the duration optimizations it is much
            // more efficient to grab all the values up front
            // then set them directly (which will avoid a normalization call).
            // So we don't actually normalize until we need it.
            var second = this.second;
            var minute = this.minute;
            var hour = this.hour;
            var day = this.day;
            second += mult * aDuration.seconds;
            minute += mult * aDuration.minutes;
            hour += mult * aDuration.hours;
            day += mult * aDuration.days;
            day += mult * 7 * aDuration.weeks;
            this.second = second;
            this.minute = minute;
            this.hour = hour;
            this.day = day;
            this._cachedUnixTime = null;
        },
        /**
     * Subtract the date details (_excluding_ timezone).  Useful for finding
     * the relative difference between two time objects excluding their
     * timezone differences.
     *
     * @param {ICAL.Time} aDate     The date to substract
     * @return {ICAL.Duration}      The difference as a duration
     */ subtractDate: function icaltime_subtract(aDate) {
            var unixTime = this.toUnixTime() + this.utcOffset();
            var other = aDate.toUnixTime() + aDate.utcOffset();
            return $c854a69b4095b587$var$ICAL.Duration.fromSeconds(unixTime - other);
        },
        /**
     * Subtract the date details, taking timezones into account.
     *
     * @param {ICAL.Time} aDate  The date to subtract
     * @return {ICAL.Duration}  The difference in duration
     */ subtractDateTz: function icaltime_subtract_abs(aDate) {
            var unixTime = this.toUnixTime();
            var other = aDate.toUnixTime();
            return $c854a69b4095b587$var$ICAL.Duration.fromSeconds(unixTime - other);
        },
        /**
     * Compares the ICAL.Time instance with another one.
     *
     * @param {ICAL.Duration} aOther        The instance to compare with
     * @return {Number}                     -1, 0 or 1 for less/equal/greater
     */ compare: function icaltime_compare(other) {
            var a = this.toUnixTime();
            var b = other.toUnixTime();
            if (a > b) return 1;
            if (b > a) return -1;
            return 0;
        },
        /**
     * Compares only the date part of this instance with another one.
     *
     * @param {ICAL.Duration} other         The instance to compare with
     * @param {ICAL.Timezone} tz            The timezone to compare in
     * @return {Number}                     -1, 0 or 1 for less/equal/greater
     */ compareDateOnlyTz: function icaltime_compareDateOnlyTz(other, tz) {
            function cmp(attr) {
                return $c854a69b4095b587$var$ICAL.Time._cmp_attr(a, b, attr);
            }
            var a = this.convertToZone(tz);
            var b = other.convertToZone(tz);
            var rc = 0;
            if ((rc = cmp("year")) != 0) return rc;
            if ((rc = cmp("month")) != 0) return rc;
            if ((rc = cmp("day")) != 0) return rc;
            return rc;
        },
        /**
     * Convert the instance into another timezone. The returned ICAL.Time
     * instance is always a copy.
     *
     * @param {ICAL.Timezone} zone      The zone to convert to
     * @return {ICAL.Time}              The copy, converted to the zone
     */ convertToZone: function convertToZone(zone) {
            var copy = this.clone();
            var zone_equals = this.zone.tzid == zone.tzid;
            if (!this.isDate && !zone_equals) $c854a69b4095b587$var$ICAL.Timezone.convert_time(copy, this.zone, zone);
            copy.zone = zone;
            return copy;
        },
        /**
     * Calculates the UTC offset of the current date/time in the timezone it is
     * in.
     *
     * @return {Number}     UTC offset in seconds
     */ utcOffset: function utc_offset() {
            if (this.zone == $c854a69b4095b587$var$ICAL.Timezone.localTimezone || this.zone == $c854a69b4095b587$var$ICAL.Timezone.utcTimezone) return 0;
            else return this.zone.utcOffset(this);
        },
        /**
     * Returns an RFC 5545 compliant ical representation of this object.
     *
     * @return {String} ical date/date-time
     */ toICALString: function() {
            var string = this.toString();
            if (string.length > 10) return $c854a69b4095b587$var$ICAL.design.icalendar.value["date-time"].toICAL(string);
            else return $c854a69b4095b587$var$ICAL.design.icalendar.value.date.toICAL(string);
        },
        /**
     * The string representation of this date/time, in jCal form
     * (including : and - separators).
     * @return {String}
     */ toString: function toString() {
            var result = this.year + "-" + $c854a69b4095b587$var$ICAL.helpers.pad2(this.month) + "-" + $c854a69b4095b587$var$ICAL.helpers.pad2(this.day);
            if (!this.isDate) {
                result += "T" + $c854a69b4095b587$var$ICAL.helpers.pad2(this.hour) + ":" + $c854a69b4095b587$var$ICAL.helpers.pad2(this.minute) + ":" + $c854a69b4095b587$var$ICAL.helpers.pad2(this.second);
                if (this.zone === $c854a69b4095b587$var$ICAL.Timezone.utcTimezone) result += "Z";
            }
            return result;
        },
        /**
     * Converts the current instance to a Javascript date
     * @return {Date}
     */ toJSDate: function toJSDate() {
            if (this.zone == $c854a69b4095b587$var$ICAL.Timezone.localTimezone) {
                if (this.isDate) return new Date(this.year, this.month - 1, this.day);
                else return new Date(this.year, this.month - 1, this.day, this.hour, this.minute, this.second, 0);
            } else return new Date(this.toUnixTime() * 1000);
        },
        _normalize: function icaltime_normalize() {
            var isDate = this._time.isDate;
            if (this._time.isDate) {
                this._time.hour = 0;
                this._time.minute = 0;
                this._time.second = 0;
            }
            this.adjust(0, 0, 0, 0);
            return this;
        },
        /**
     * Adjust the date/time by the given offset
     *
     * @param {Number} aExtraDays       The extra amount of days
     * @param {Number} aExtraHours      The extra amount of hours
     * @param {Number} aExtraMinutes    The extra amount of minutes
     * @param {Number} aExtraSeconds    The extra amount of seconds
     * @param {Number=} aTime           The time to adjust, defaults to the
     *                                    current instance.
     */ adjust: function icaltime_adjust(aExtraDays, aExtraHours, aExtraMinutes, aExtraSeconds, aTime) {
            var minutesOverflow, hoursOverflow, daysOverflow = 0, yearsOverflow = 0;
            var second, minute, hour, day;
            var daysInMonth;
            var time = aTime || this._time;
            if (!time.isDate) {
                second = time.second + aExtraSeconds;
                time.second = second % 60;
                minutesOverflow = $c854a69b4095b587$var$ICAL.helpers.trunc(second / 60);
                if (time.second < 0) {
                    time.second += 60;
                    minutesOverflow--;
                }
                minute = time.minute + aExtraMinutes + minutesOverflow;
                time.minute = minute % 60;
                hoursOverflow = $c854a69b4095b587$var$ICAL.helpers.trunc(minute / 60);
                if (time.minute < 0) {
                    time.minute += 60;
                    hoursOverflow--;
                }
                hour = time.hour + aExtraHours + hoursOverflow;
                time.hour = hour % 24;
                daysOverflow = $c854a69b4095b587$var$ICAL.helpers.trunc(hour / 24);
                if (time.hour < 0) {
                    time.hour += 24;
                    daysOverflow--;
                }
            }
            // Adjust month and year first, because we need to know what month the day
            // is in before adjusting it.
            if (time.month > 12) yearsOverflow = $c854a69b4095b587$var$ICAL.helpers.trunc((time.month - 1) / 12);
            else if (time.month < 1) yearsOverflow = $c854a69b4095b587$var$ICAL.helpers.trunc(time.month / 12) - 1;
            time.year += yearsOverflow;
            time.month -= 12 * yearsOverflow;
            // Now take care of the days (and adjust month if needed)
            day = time.day + aExtraDays + daysOverflow;
            if (day > 0) for(;;){
                daysInMonth = $c854a69b4095b587$var$ICAL.Time.daysInMonth(time.month, time.year);
                if (day <= daysInMonth) break;
                time.month++;
                if (time.month > 12) {
                    time.year++;
                    time.month = 1;
                }
                day -= daysInMonth;
            }
            else while(day <= 0){
                if (time.month == 1) {
                    time.year--;
                    time.month = 12;
                } else time.month--;
                day += $c854a69b4095b587$var$ICAL.Time.daysInMonth(time.month, time.year);
            }
            time.day = day;
            this._cachedUnixTime = null;
            return this;
        },
        /**
     * Sets up the current instance from unix time, the number of seconds since
     * January 1st, 1970.
     *
     * @param {Number} seconds      The seconds to set up with
     */ fromUnixTime: function fromUnixTime(seconds) {
            this.zone = $c854a69b4095b587$var$ICAL.Timezone.utcTimezone;
            var epoch = $c854a69b4095b587$var$ICAL.Time.epochTime.clone();
            epoch.adjust(0, 0, 0, seconds);
            this.year = epoch.year;
            this.month = epoch.month;
            this.day = epoch.day;
            this.hour = epoch.hour;
            this.minute = epoch.minute;
            this.second = Math.floor(epoch.second);
            this._cachedUnixTime = null;
        },
        /**
     * Converts the current instance to seconds since January 1st 1970.
     *
     * @return {Number}         Seconds since 1970
     */ toUnixTime: function toUnixTime() {
            if (this._cachedUnixTime !== null) return this._cachedUnixTime;
            var offset = this.utcOffset();
            // we use the offset trick to ensure
            // that we are getting the actual UTC time
            var ms = Date.UTC(this.year, this.month - 1, this.day, this.hour, this.minute, this.second - offset);
            // seconds
            this._cachedUnixTime = ms / 1000;
            return this._cachedUnixTime;
        },
        /**
     * Converts time to into Object which can be serialized then re-created
     * using the constructor.
     *
     * @example
     * // toJSON will automatically be called
     * var json = JSON.stringify(mytime);
     *
     * var deserialized = JSON.parse(json);
     *
     * var time = new ICAL.Time(deserialized);
     *
     * @return {Object}
     */ toJSON: function() {
            var copy = [
                "year",
                "month",
                "day",
                "hour",
                "minute",
                "second",
                "isDate"
            ];
            var result = Object.create(null);
            var i = 0;
            var len = copy.length;
            var prop;
            for(; i < len; i++){
                prop = copy[i];
                result[prop] = this[prop];
            }
            if (this.zone) result.timezone = this.zone.tzid;
            return result;
        }
    };
    (function setupNormalizeAttributes() {
        // This needs to run before any instances are created!
        function defineAttr(attr) {
            Object.defineProperty($c854a69b4095b587$var$ICAL.Time.prototype, attr, {
                get: function getTimeAttr() {
                    if (this._pendingNormalization) {
                        this._normalize();
                        this._pendingNormalization = false;
                    }
                    return this._time[attr];
                },
                set: function setTimeAttr(val) {
                    // Check if isDate will be set and if was not set to normalize date.
                    // This avoids losing days when seconds, minutes and hours are zeroed
                    // what normalize will do when time is a date.
                    if (attr === "isDate" && val && !this._time.isDate) this.adjust(0, 0, 0, 0);
                    this._cachedUnixTime = null;
                    this._pendingNormalization = true;
                    this._time[attr] = val;
                    return val;
                }
            });
        }
        /* istanbul ignore else */ if ("defineProperty" in Object) {
            defineAttr("year");
            defineAttr("month");
            defineAttr("day");
            defineAttr("hour");
            defineAttr("minute");
            defineAttr("second");
            defineAttr("isDate");
        }
    })();
    /**
   * Returns the days in the given month
   *
   * @param {Number} month      The month to check
   * @param {Number} year       The year to check
   * @return {Number}           The number of days in the month
   */ $c854a69b4095b587$var$ICAL.Time.daysInMonth = function icaltime_daysInMonth(month, year) {
        var _daysInMonth = [
            0,
            31,
            28,
            31,
            30,
            31,
            30,
            31,
            31,
            30,
            31,
            30,
            31
        ];
        var days = 30;
        if (month < 1 || month > 12) return days;
        days = _daysInMonth[month];
        if (month == 2) days += $c854a69b4095b587$var$ICAL.Time.isLeapYear(year);
        return days;
    };
    /**
   * Checks if the year is a leap year
   *
   * @param {Number} year       The year to check
   * @return {Boolean}          True, if the year is a leap year
   */ $c854a69b4095b587$var$ICAL.Time.isLeapYear = function isLeapYear(year) {
        if (year <= 1752) return year % 4 == 0;
        else return year % 4 == 0 && year % 100 != 0 || year % 400 == 0;
    };
    /**
   * Create a new ICAL.Time from the day of year and year. The date is returned
   * in floating timezone.
   *
   * @param {Number} aDayOfYear     The day of year
   * @param {Number} aYear          The year to create the instance in
   * @return {ICAL.Time}            The created instance with the calculated date
   */ $c854a69b4095b587$var$ICAL.Time.fromDayOfYear = function icaltime_fromDayOfYear(aDayOfYear, aYear) {
        var year = aYear;
        var doy = aDayOfYear;
        var tt = new $c854a69b4095b587$var$ICAL.Time();
        tt.auto_normalize = false;
        var is_leap = $c854a69b4095b587$var$ICAL.Time.isLeapYear(year) ? 1 : 0;
        if (doy < 1) {
            year--;
            is_leap = $c854a69b4095b587$var$ICAL.Time.isLeapYear(year) ? 1 : 0;
            doy += $c854a69b4095b587$var$ICAL.Time.daysInYearPassedMonth[is_leap][12];
            return $c854a69b4095b587$var$ICAL.Time.fromDayOfYear(doy, year);
        } else if (doy > $c854a69b4095b587$var$ICAL.Time.daysInYearPassedMonth[is_leap][12]) {
            is_leap = $c854a69b4095b587$var$ICAL.Time.isLeapYear(year) ? 1 : 0;
            doy -= $c854a69b4095b587$var$ICAL.Time.daysInYearPassedMonth[is_leap][12];
            year++;
            return $c854a69b4095b587$var$ICAL.Time.fromDayOfYear(doy, year);
        }
        tt.year = year;
        tt.isDate = true;
        for(var month = 11; month >= 0; month--)if (doy > $c854a69b4095b587$var$ICAL.Time.daysInYearPassedMonth[is_leap][month]) {
            tt.month = month + 1;
            tt.day = doy - $c854a69b4095b587$var$ICAL.Time.daysInYearPassedMonth[is_leap][month];
            break;
        }
        tt.auto_normalize = true;
        return tt;
    };
    /**
   * Returns a new ICAL.Time instance from a date string, e.g 2015-01-02.
   *
   * @deprecated                Use {@link ICAL.Time.fromDateString} instead
   * @param {String} str        The string to create from
   * @return {ICAL.Time}        The date/time instance
   */ $c854a69b4095b587$var$ICAL.Time.fromStringv2 = function fromString(str) {
        return new $c854a69b4095b587$var$ICAL.Time({
            year: parseInt(str.substr(0, 4), 10),
            month: parseInt(str.substr(5, 2), 10),
            day: parseInt(str.substr(8, 2), 10),
            isDate: true
        });
    };
    /**
   * Returns a new ICAL.Time instance from a date string, e.g 2015-01-02.
   *
   * @param {String} aValue     The string to create from
   * @return {ICAL.Time}        The date/time instance
   */ $c854a69b4095b587$var$ICAL.Time.fromDateString = function(aValue) {
        // Dates should have no timezone.
        // Google likes to sometimes specify Z on dates
        // we specifically ignore that to avoid issues.
        // YYYY-MM-DD
        // 2012-10-10
        return new $c854a69b4095b587$var$ICAL.Time({
            year: $c854a69b4095b587$var$ICAL.helpers.strictParseInt(aValue.substr(0, 4)),
            month: $c854a69b4095b587$var$ICAL.helpers.strictParseInt(aValue.substr(5, 2)),
            day: $c854a69b4095b587$var$ICAL.helpers.strictParseInt(aValue.substr(8, 2)),
            isDate: true
        });
    };
    /**
   * Returns a new ICAL.Time instance from a date-time string, e.g
   * 2015-01-02T03:04:05. If a property is specified, the timezone is set up
   * from the property's TZID parameter.
   *
   * @param {String} aValue         The string to create from
   * @param {ICAL.Property=} prop   The property the date belongs to
   * @return {ICAL.Time}            The date/time instance
   */ $c854a69b4095b587$var$ICAL.Time.fromDateTimeString = function(aValue, prop) {
        if (aValue.length < 19) throw new Error('invalid date-time value: "' + aValue + '"');
        var zone;
        if (aValue[19] && aValue[19] === "Z") zone = "Z";
        else if (prop) zone = prop.getParameter("tzid");
        // 2012-10-10T10:10:10(Z)?
        var time = new $c854a69b4095b587$var$ICAL.Time({
            year: $c854a69b4095b587$var$ICAL.helpers.strictParseInt(aValue.substr(0, 4)),
            month: $c854a69b4095b587$var$ICAL.helpers.strictParseInt(aValue.substr(5, 2)),
            day: $c854a69b4095b587$var$ICAL.helpers.strictParseInt(aValue.substr(8, 2)),
            hour: $c854a69b4095b587$var$ICAL.helpers.strictParseInt(aValue.substr(11, 2)),
            minute: $c854a69b4095b587$var$ICAL.helpers.strictParseInt(aValue.substr(14, 2)),
            second: $c854a69b4095b587$var$ICAL.helpers.strictParseInt(aValue.substr(17, 2)),
            timezone: zone
        });
        return time;
    };
    /**
   * Returns a new ICAL.Time instance from a date or date-time string,
   *
   * @param {String} aValue         The string to create from
   * @param {ICAL.Property=} prop   The property the date belongs to
   * @return {ICAL.Time}            The date/time instance
   */ $c854a69b4095b587$var$ICAL.Time.fromString = function fromString(aValue, aProperty) {
        if (aValue.length > 10) return $c854a69b4095b587$var$ICAL.Time.fromDateTimeString(aValue, aProperty);
        else return $c854a69b4095b587$var$ICAL.Time.fromDateString(aValue);
    };
    /**
   * Creates a new ICAL.Time instance from the given Javascript Date.
   *
   * @param {?Date} aDate     The Javascript Date to read, or null to reset
   * @param {Boolean} useUTC  If true, the UTC values of the date will be used
   */ $c854a69b4095b587$var$ICAL.Time.fromJSDate = function fromJSDate(aDate, useUTC) {
        var tt = new $c854a69b4095b587$var$ICAL.Time();
        return tt.fromJSDate(aDate, useUTC);
    };
    /**
   * Creates a new ICAL.Time instance from the the passed data object.
   *
   * @param {Object} aData            Time initialization
   * @param {Number=} aData.year      The year for this date
   * @param {Number=} aData.month     The month for this date
   * @param {Number=} aData.day       The day for this date
   * @param {Number=} aData.hour      The hour for this date
   * @param {Number=} aData.minute    The minute for this date
   * @param {Number=} aData.second    The second for this date
   * @param {Boolean=} aData.isDate   If true, the instance represents a date
   *                                    (as opposed to a date-time)
   * @param {ICAL.Timezone=} aZone    Timezone this position occurs in
   */ $c854a69b4095b587$var$ICAL.Time.fromData = function fromData(aData, aZone) {
        var t = new $c854a69b4095b587$var$ICAL.Time();
        return t.fromData(aData, aZone);
    };
    /**
   * Creates a new ICAL.Time instance from the current moment.
   * The instance is “floating” - has no timezone relation.
   * To create an instance considering the time zone, call
   * ICAL.Time.fromJSDate(new Date(), true)
   * @return {ICAL.Time}
   */ $c854a69b4095b587$var$ICAL.Time.now = function icaltime_now() {
        return $c854a69b4095b587$var$ICAL.Time.fromJSDate(new Date(), false);
    };
    /**
   * Returns the date on which ISO week number 1 starts.
   *
   * @see ICAL.Time#weekNumber
   * @param {Number} aYear                  The year to search in
   * @param {ICAL.Time.weekDay=} aWeekStart The week start weekday, used for calculation.
   * @return {ICAL.Time}                    The date on which week number 1 starts
   */ $c854a69b4095b587$var$ICAL.Time.weekOneStarts = function weekOneStarts(aYear, aWeekStart) {
        var t = $c854a69b4095b587$var$ICAL.Time.fromData({
            year: aYear,
            month: 1,
            day: 1,
            isDate: true
        });
        var dow = t.dayOfWeek();
        var wkst = aWeekStart || $c854a69b4095b587$var$ICAL.Time.DEFAULT_WEEK_START;
        if (dow > $c854a69b4095b587$var$ICAL.Time.THURSDAY) t.day += 7;
        if (wkst > $c854a69b4095b587$var$ICAL.Time.THURSDAY) t.day -= 7;
        t.day -= dow - wkst;
        return t;
    };
    /**
   * Get the dominical letter for the given year. Letters range from A - G for
   * common years, and AG to GF for leap years.
   *
   * @param {Number} yr           The year to retrieve the letter for
   * @return {String}             The dominical letter.
   */ $c854a69b4095b587$var$ICAL.Time.getDominicalLetter = function(yr) {
        var LTRS = "GFEDCBA";
        var dom = (yr + (yr / 4 | 0) + (yr / 400 | 0) - (yr / 100 | 0) - 1) % 7;
        var isLeap = $c854a69b4095b587$var$ICAL.Time.isLeapYear(yr);
        if (isLeap) return LTRS[(dom + 6) % 7] + LTRS[dom];
        else return LTRS[dom];
    };
    /**
   * January 1st, 1970 as an ICAL.Time.
   * @type {ICAL.Time}
   * @constant
   * @instance
   */ $c854a69b4095b587$var$ICAL.Time.epochTime = $c854a69b4095b587$var$ICAL.Time.fromData({
        year: 1970,
        month: 1,
        day: 1,
        hour: 0,
        minute: 0,
        second: 0,
        isDate: false,
        timezone: "Z"
    });
    $c854a69b4095b587$var$ICAL.Time._cmp_attr = function _cmp_attr(a, b, attr) {
        if (a[attr] > b[attr]) return 1;
        if (a[attr] < b[attr]) return -1;
        return 0;
    };
    /**
   * The days that have passed in the year after a given month. The array has
   * two members, one being an array of passed days for non-leap years, the
   * other analog for leap years.
   * @example
   * var isLeapYear = ICAL.Time.isLeapYear(year);
   * var passedDays = ICAL.Time.daysInYearPassedMonth[isLeapYear][month];
   * @type {Array.<Array.<Number>>}
   */ $c854a69b4095b587$var$ICAL.Time.daysInYearPassedMonth = [
        [
            0,
            31,
            59,
            90,
            120,
            151,
            181,
            212,
            243,
            273,
            304,
            334,
            365
        ],
        [
            0,
            31,
            60,
            91,
            121,
            152,
            182,
            213,
            244,
            274,
            305,
            335,
            366
        ]
    ];
    /**
   * The weekday, 1 = SUNDAY, 7 = SATURDAY. Access via
   * ICAL.Time.MONDAY, ICAL.Time.TUESDAY, ...
   *
   * @typedef {Number} weekDay
   * @memberof ICAL.Time
   */ $c854a69b4095b587$var$ICAL.Time.SUNDAY = 1;
    $c854a69b4095b587$var$ICAL.Time.MONDAY = 2;
    $c854a69b4095b587$var$ICAL.Time.TUESDAY = 3;
    $c854a69b4095b587$var$ICAL.Time.WEDNESDAY = 4;
    $c854a69b4095b587$var$ICAL.Time.THURSDAY = 5;
    $c854a69b4095b587$var$ICAL.Time.FRIDAY = 6;
    $c854a69b4095b587$var$ICAL.Time.SATURDAY = 7;
    /**
   * The default weekday for the WKST part.
   * @constant
   * @default ICAL.Time.MONDAY
   */ $c854a69b4095b587$var$ICAL.Time.DEFAULT_WEEK_START = $c854a69b4095b587$var$ICAL.Time.MONDAY;
})();
/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 * Portions Copyright (C) Philipp Kewisch, 2015 */ (function() {
    /**
   * Describes a vCard time, which has slight differences to the ICAL.Time.
   * Properties can be null if not specified, for example for dates with
   * reduced accuracy or truncation.
   *
   * Note that currently not all methods are correctly re-implemented for
   * VCardTime. For example, comparison will have undefined results when some
   * members are null.
   *
   * Also, normalization is not yet implemented for this class!
   *
   * @alias ICAL.VCardTime
   * @class
   * @extends {ICAL.Time}
   * @param {Object} data                           The data for the time instance
   * @param {Number=} data.year                     The year for this date
   * @param {Number=} data.month                    The month for this date
   * @param {Number=} data.day                      The day for this date
   * @param {Number=} data.hour                     The hour for this date
   * @param {Number=} data.minute                   The minute for this date
   * @param {Number=} data.second                   The second for this date
   * @param {ICAL.Timezone|ICAL.UtcOffset} zone     The timezone to use
   * @param {String} icaltype                       The type for this date/time object
   */ $c854a69b4095b587$var$ICAL.VCardTime = function(data, zone, icaltype) {
        this.wrappedJSObject = this;
        var time = this._time = Object.create(null);
        time.year = null;
        time.month = null;
        time.day = null;
        time.hour = null;
        time.minute = null;
        time.second = null;
        this.icaltype = icaltype || "date-and-or-time";
        this.fromData(data, zone);
    };
    $c854a69b4095b587$var$ICAL.helpers.inherits($c854a69b4095b587$var$ICAL.Time, $c854a69b4095b587$var$ICAL.VCardTime, /** @lends ICAL.VCardTime */ {
        /**
     * The class identifier.
     * @constant
     * @type {String}
     * @default "vcardtime"
     */ icalclass: "vcardtime",
        /**
     * The type name, to be used in the jCal object.
     * @type {String}
     * @default "date-and-or-time"
     */ icaltype: "date-and-or-time",
        /**
     * The timezone. This can either be floating, UTC, or an instance of
     * ICAL.UtcOffset.
     * @type {ICAL.Timezone|ICAL.UtcOFfset}
     */ zone: null,
        /**
     * Returns a clone of the vcard date/time object.
     *
     * @return {ICAL.VCardTime}     The cloned object
     */ clone: function() {
            return new $c854a69b4095b587$var$ICAL.VCardTime(this._time, this.zone, this.icaltype);
        },
        _normalize: function() {
            return this;
        },
        /**
     * @inheritdoc
     */ utcOffset: function() {
            if (this.zone instanceof $c854a69b4095b587$var$ICAL.UtcOffset) return this.zone.toSeconds();
            else return $c854a69b4095b587$var$ICAL.Time.prototype.utcOffset.apply(this, arguments);
        },
        /**
     * Returns an RFC 6350 compliant representation of this object.
     *
     * @return {String}         vcard date/time string
     */ toICALString: function() {
            return $c854a69b4095b587$var$ICAL.design.vcard.value[this.icaltype].toICAL(this.toString());
        },
        /**
     * The string representation of this date/time, in jCard form
     * (including : and - separators).
     * @return {String}
     */ toString: function toString() {
            var p2 = $c854a69b4095b587$var$ICAL.helpers.pad2;
            var y = this.year, m = this.month, d = this.day;
            var h = this.hour, mm = this.minute, s = this.second;
            var hasYear = y !== null, hasMonth = m !== null, hasDay = d !== null;
            var hasHour = h !== null, hasMinute = mm !== null, hasSecond = s !== null;
            var datepart = (hasYear ? p2(y) + (hasMonth || hasDay ? "-" : "") : hasMonth || hasDay ? "--" : "") + (hasMonth ? p2(m) : "") + (hasDay ? "-" + p2(d) : "");
            var timepart = (hasHour ? p2(h) : "-") + (hasHour && hasMinute ? ":" : "") + (hasMinute ? p2(mm) : "") + (!hasHour && !hasMinute ? "-" : "") + (hasMinute && hasSecond ? ":" : "") + (hasSecond ? p2(s) : "");
            var zone;
            if (this.zone === $c854a69b4095b587$var$ICAL.Timezone.utcTimezone) zone = "Z";
            else if (this.zone instanceof $c854a69b4095b587$var$ICAL.UtcOffset) zone = this.zone.toString();
            else if (this.zone === $c854a69b4095b587$var$ICAL.Timezone.localTimezone) zone = "";
            else if (this.zone instanceof $c854a69b4095b587$var$ICAL.Timezone) {
                var offset = $c854a69b4095b587$var$ICAL.UtcOffset.fromSeconds(this.zone.utcOffset(this));
                zone = offset.toString();
            } else zone = "";
            switch(this.icaltype){
                case "time":
                    return timepart + zone;
                case "date-and-or-time":
                case "date-time":
                    return datepart + (timepart == "--" ? "" : "T" + timepart + zone);
                case "date":
                    return datepart;
            }
            return null;
        }
    });
    /**
   * Returns a new ICAL.VCardTime instance from a date and/or time string.
   *
   * @param {String} aValue     The string to create from
   * @param {String} aIcalType  The type for this instance, e.g. date-and-or-time
   * @return {ICAL.VCardTime}   The date/time instance
   */ $c854a69b4095b587$var$ICAL.VCardTime.fromDateAndOrTimeString = function(aValue, aIcalType) {
        function part(v, s, e) {
            return v ? $c854a69b4095b587$var$ICAL.helpers.strictParseInt(v.substr(s, e)) : null;
        }
        var parts = aValue.split("T");
        var dt = parts[0], tmz = parts[1];
        var splitzone = tmz ? $c854a69b4095b587$var$ICAL.design.vcard.value.time._splitZone(tmz) : [];
        var zone = splitzone[0], tm = splitzone[1];
        var stoi = $c854a69b4095b587$var$ICAL.helpers.strictParseInt;
        var dtlen = dt ? dt.length : 0;
        var tmlen = tm ? tm.length : 0;
        var hasDashDate = dt && dt[0] == "-" && dt[1] == "-";
        var hasDashTime = tm && tm[0] == "-";
        var o = {
            year: hasDashDate ? null : part(dt, 0, 4),
            month: hasDashDate && (dtlen == 4 || dtlen == 7) ? part(dt, 2, 2) : dtlen == 7 ? part(dt, 5, 2) : dtlen == 10 ? part(dt, 5, 2) : null,
            day: dtlen == 5 ? part(dt, 3, 2) : dtlen == 7 && hasDashDate ? part(dt, 5, 2) : dtlen == 10 ? part(dt, 8, 2) : null,
            hour: hasDashTime ? null : part(tm, 0, 2),
            minute: hasDashTime && tmlen == 3 ? part(tm, 1, 2) : tmlen > 4 ? hasDashTime ? part(tm, 1, 2) : part(tm, 3, 2) : null,
            second: tmlen == 4 ? part(tm, 2, 2) : tmlen == 6 ? part(tm, 4, 2) : tmlen == 8 ? part(tm, 6, 2) : null
        };
        if (zone == "Z") zone = $c854a69b4095b587$var$ICAL.Timezone.utcTimezone;
        else if (zone && zone[3] == ":") zone = $c854a69b4095b587$var$ICAL.UtcOffset.fromString(zone);
        else zone = null;
        return new $c854a69b4095b587$var$ICAL.VCardTime(o, zone, aIcalType);
    };
})();
/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 * Portions Copyright (C) Philipp Kewisch, 2011-2015 */ (function() {
    var DOW_MAP = {
        SU: $c854a69b4095b587$var$ICAL.Time.SUNDAY,
        MO: $c854a69b4095b587$var$ICAL.Time.MONDAY,
        TU: $c854a69b4095b587$var$ICAL.Time.TUESDAY,
        WE: $c854a69b4095b587$var$ICAL.Time.WEDNESDAY,
        TH: $c854a69b4095b587$var$ICAL.Time.THURSDAY,
        FR: $c854a69b4095b587$var$ICAL.Time.FRIDAY,
        SA: $c854a69b4095b587$var$ICAL.Time.SATURDAY
    };
    var REVERSE_DOW_MAP = {};
    for(var key in DOW_MAP)/* istanbul ignore else */ if (DOW_MAP.hasOwnProperty(key)) REVERSE_DOW_MAP[DOW_MAP[key]] = key;
    var COPY_PARTS = [
        "BYSECOND",
        "BYMINUTE",
        "BYHOUR",
        "BYDAY",
        "BYMONTHDAY",
        "BYYEARDAY",
        "BYWEEKNO",
        "BYMONTH",
        "BYSETPOS"
    ];
    /**
   * @classdesc
   * This class represents the "recur" value type, with various calculation
   * and manipulation methods.
   *
   * @class
   * @alias ICAL.Recur
   * @param {Object} data                               An object with members of the recurrence
   * @param {ICAL.Recur.frequencyValues=} data.freq     The frequency value
   * @param {Number=} data.interval                     The INTERVAL value
   * @param {ICAL.Time.weekDay=} data.wkst              The week start value
   * @param {ICAL.Time=} data.until                     The end of the recurrence set
   * @param {Number=} data.count                        The number of occurrences
   * @param {Array.<Number>=} data.bysecond             The seconds for the BYSECOND part
   * @param {Array.<Number>=} data.byminute             The minutes for the BYMINUTE part
   * @param {Array.<Number>=} data.byhour               The hours for the BYHOUR part
   * @param {Array.<String>=} data.byday                The BYDAY values
   * @param {Array.<Number>=} data.bymonthday           The days for the BYMONTHDAY part
   * @param {Array.<Number>=} data.byyearday            The days for the BYYEARDAY part
   * @param {Array.<Number>=} data.byweekno             The weeks for the BYWEEKNO part
   * @param {Array.<Number>=} data.bymonth              The month for the BYMONTH part
   * @param {Array.<Number>=} data.bysetpos             The positionals for the BYSETPOS part
   */ $c854a69b4095b587$var$ICAL.Recur = function icalrecur(data) {
        this.wrappedJSObject = this;
        this.parts = {};
        if (data && typeof data === "object") this.fromData(data);
    };
    $c854a69b4095b587$var$ICAL.Recur.prototype = {
        /**
     * An object holding the BY-parts of the recurrence rule
     * @type {Object}
     */ parts: null,
        /**
     * The interval value for the recurrence rule.
     * @type {Number}
     */ interval: 1,
        /**
     * The week start day
     *
     * @type {ICAL.Time.weekDay}
     * @default ICAL.Time.MONDAY
     */ wkst: $c854a69b4095b587$var$ICAL.Time.MONDAY,
        /**
     * The end of the recurrence
     * @type {?ICAL.Time}
     */ until: null,
        /**
     * The maximum number of occurrences
     * @type {?Number}
     */ count: null,
        /**
     * The frequency value.
     * @type {ICAL.Recur.frequencyValues}
     */ freq: null,
        /**
     * The class identifier.
     * @constant
     * @type {String}
     * @default "icalrecur"
     */ icalclass: "icalrecur",
        /**
     * The type name, to be used in the jCal object.
     * @constant
     * @type {String}
     * @default "recur"
     */ icaltype: "recur",
        /**
     * Create a new iterator for this recurrence rule. The passed start date
     * must be the start date of the event, not the start of the range to
     * search in.
     *
     * @example
     * var recur = comp.getFirstPropertyValue('rrule');
     * var dtstart = comp.getFirstPropertyValue('dtstart');
     * var iter = recur.iterator(dtstart);
     * for (var next = iter.next(); next; next = iter.next()) {
     *   if (next.compare(rangeStart) < 0) {
     *     continue;
     *   }
     *   console.log(next.toString());
     * }
     *
     * @param {ICAL.Time} aStart        The item's start date
     * @return {ICAL.RecurIterator}     The recurrence iterator
     */ iterator: function(aStart) {
            return new $c854a69b4095b587$var$ICAL.RecurIterator({
                rule: this,
                dtstart: aStart
            });
        },
        /**
     * Returns a clone of the recurrence object.
     *
     * @return {ICAL.Recur}      The cloned object
     */ clone: function clone() {
            return new $c854a69b4095b587$var$ICAL.Recur(this.toJSON());
        },
        /**
     * Checks if the current rule is finite, i.e. has a count or until part.
     *
     * @return {Boolean}        True, if the rule is finite
     */ isFinite: function isfinite() {
            return !!(this.count || this.until);
        },
        /**
     * Checks if the current rule has a count part, and not limited by an until
     * part.
     *
     * @return {Boolean}        True, if the rule is by count
     */ isByCount: function isbycount() {
            return !!(this.count && !this.until);
        },
        /**
     * Adds a component (part) to the recurrence rule. This is not a component
     * in the sense of {@link ICAL.Component}, but a part of the recurrence
     * rule, i.e. BYMONTH.
     *
     * @param {String} aType            The name of the component part
     * @param {Array|String} aValue     The component value
     */ addComponent: function addPart(aType, aValue) {
            var ucname = aType.toUpperCase();
            if (ucname in this.parts) this.parts[ucname].push(aValue);
            else this.parts[ucname] = [
                aValue
            ];
        },
        /**
     * Sets the component value for the given by-part.
     *
     * @param {String} aType        The component part name
     * @param {Array} aValues       The component values
     */ setComponent: function setComponent(aType, aValues) {
            this.parts[aType.toUpperCase()] = aValues.slice();
        },
        /**
     * Gets (a copy) of the requested component value.
     *
     * @param {String} aType        The component part name
     * @return {Array}              The component part value
     */ getComponent: function getComponent(aType) {
            var ucname = aType.toUpperCase();
            return ucname in this.parts ? this.parts[ucname].slice() : [];
        },
        /**
     * Retrieves the next occurrence after the given recurrence id. See the
     * guide on {@tutorial terminology} for more details.
     *
     * NOTE: Currently, this method iterates all occurrences from the start
     * date. It should not be called in a loop for performance reasons. If you
     * would like to get more than one occurrence, you can iterate the
     * occurrences manually, see the example on the
     * {@link ICAL.Recur#iterator iterator} method.
     *
     * @param {ICAL.Time} aStartTime        The start of the event series
     * @param {ICAL.Time} aRecurrenceId     The date of the last occurrence
     * @return {ICAL.Time}                  The next occurrence after
     */ getNextOccurrence: function getNextOccurrence(aStartTime, aRecurrenceId) {
            var iter = this.iterator(aStartTime);
            var next, cdt;
            do next = iter.next();
            while (next && next.compare(aRecurrenceId) <= 0);
            if (next && aRecurrenceId.zone) next.zone = aRecurrenceId.zone;
            return next;
        },
        /**
     * Sets up the current instance using members from the passed data object.
     *
     * @param {Object} data                               An object with members of the recurrence
     * @param {ICAL.Recur.frequencyValues=} data.freq     The frequency value
     * @param {Number=} data.interval                     The INTERVAL value
     * @param {ICAL.Time.weekDay=} data.wkst              The week start value
     * @param {ICAL.Time=} data.until                     The end of the recurrence set
     * @param {Number=} data.count                        The number of occurrences
     * @param {Array.<Number>=} data.bysecond             The seconds for the BYSECOND part
     * @param {Array.<Number>=} data.byminute             The minutes for the BYMINUTE part
     * @param {Array.<Number>=} data.byhour               The hours for the BYHOUR part
     * @param {Array.<String>=} data.byday                The BYDAY values
     * @param {Array.<Number>=} data.bymonthday           The days for the BYMONTHDAY part
     * @param {Array.<Number>=} data.byyearday            The days for the BYYEARDAY part
     * @param {Array.<Number>=} data.byweekno             The weeks for the BYWEEKNO part
     * @param {Array.<Number>=} data.bymonth              The month for the BYMONTH part
     * @param {Array.<Number>=} data.bysetpos             The positionals for the BYSETPOS part
     */ fromData: function(data) {
            for(var key in data){
                var uckey = key.toUpperCase();
                if (uckey in partDesign) {
                    if (Array.isArray(data[key])) this.parts[uckey] = data[key];
                    else this.parts[uckey] = [
                        data[key]
                    ];
                } else this[key] = data[key];
            }
            if (this.interval && typeof this.interval != "number") optionDesign.INTERVAL(this.interval, this);
            if (this.wkst && typeof this.wkst != "number") this.wkst = $c854a69b4095b587$var$ICAL.Recur.icalDayToNumericDay(this.wkst);
            if (this.until && !(this.until instanceof $c854a69b4095b587$var$ICAL.Time)) this.until = $c854a69b4095b587$var$ICAL.Time.fromString(this.until);
        },
        /**
     * The jCal representation of this recurrence type.
     * @return {Object}
     */ toJSON: function() {
            var res = Object.create(null);
            res.freq = this.freq;
            if (this.count) res.count = this.count;
            if (this.interval > 1) res.interval = this.interval;
            for(var k in this.parts){
                /* istanbul ignore if */ if (!this.parts.hasOwnProperty(k)) continue;
                var kparts = this.parts[k];
                if (Array.isArray(kparts) && kparts.length == 1) res[k.toLowerCase()] = kparts[0];
                else res[k.toLowerCase()] = $c854a69b4095b587$var$ICAL.helpers.clone(this.parts[k]);
            }
            if (this.until) res.until = this.until.toString();
            if ("wkst" in this && this.wkst !== $c854a69b4095b587$var$ICAL.Time.DEFAULT_WEEK_START) res.wkst = $c854a69b4095b587$var$ICAL.Recur.numericDayToIcalDay(this.wkst);
            return res;
        },
        /**
     * The string representation of this recurrence rule.
     * @return {String}
     */ toString: function icalrecur_toString() {
            // TODO retain order
            var str = "FREQ=" + this.freq;
            if (this.count) str += ";COUNT=" + this.count;
            if (this.interval > 1) str += ";INTERVAL=" + this.interval;
            for(var k in this.parts)/* istanbul ignore else */ if (this.parts.hasOwnProperty(k)) str += ";" + k + "=" + this.parts[k];
            if (this.until) str += ";UNTIL=" + this.until.toICALString();
            if ("wkst" in this && this.wkst !== $c854a69b4095b587$var$ICAL.Time.DEFAULT_WEEK_START) str += ";WKST=" + $c854a69b4095b587$var$ICAL.Recur.numericDayToIcalDay(this.wkst);
            return str;
        }
    };
    function parseNumericValue(type, min, max, value1) {
        var result = value1;
        if (value1[0] === "+") result = value1.substr(1);
        result = $c854a69b4095b587$var$ICAL.helpers.strictParseInt(result);
        if (min !== undefined && value1 < min) throw new Error(type + ': invalid value "' + value1 + '" must be > ' + min);
        if (max !== undefined && value1 > max) throw new Error(type + ': invalid value "' + value1 + '" must be < ' + min);
        return result;
    }
    /**
   * Convert an ical representation of a day (SU, MO, etc..)
   * into a numeric value of that day.
   *
   * @param {String} string     The iCalendar day name
   * @param {ICAL.Time.weekDay=} aWeekStart
   *        The week start weekday, defaults to SUNDAY
   * @return {Number}           Numeric value of given day
   */ $c854a69b4095b587$var$ICAL.Recur.icalDayToNumericDay = function toNumericDay(string, aWeekStart) {
        //XXX: this is here so we can deal
        //     with possibly invalid string values.
        var firstDow = aWeekStart || $c854a69b4095b587$var$ICAL.Time.SUNDAY;
        return (DOW_MAP[string] - firstDow + 7) % 7 + 1;
    };
    /**
   * Convert a numeric day value into its ical representation (SU, MO, etc..)
   *
   * @param {Number} num        Numeric value of given day
   * @param {ICAL.Time.weekDay=} aWeekStart
   *        The week start weekday, defaults to SUNDAY
   * @return {String}           The ICAL day value, e.g SU,MO,...
   */ $c854a69b4095b587$var$ICAL.Recur.numericDayToIcalDay = function toIcalDay(num, aWeekStart) {
        //XXX: this is here so we can deal with possibly invalid number values.
        //     Also, this allows consistent mapping between day numbers and day
        //     names for external users.
        var firstDow = aWeekStart || $c854a69b4095b587$var$ICAL.Time.SUNDAY;
        var dow = num + firstDow - $c854a69b4095b587$var$ICAL.Time.SUNDAY;
        if (dow > 7) dow -= 7;
        return REVERSE_DOW_MAP[dow];
    };
    var VALID_DAY_NAMES = /^(SU|MO|TU|WE|TH|FR|SA)$/;
    var VALID_BYDAY_PART = /^([+-])?(5[0-3]|[1-4][0-9]|[1-9])?(SU|MO|TU|WE|TH|FR|SA)$/;
    /**
   * Possible frequency values for the FREQ part
   * (YEARLY, MONTHLY, WEEKLY, DAILY, HOURLY, MINUTELY, SECONDLY)
   *
   * @typedef {String} frequencyValues
   * @memberof ICAL.Recur
   */ var ALLOWED_FREQ = [
        "SECONDLY",
        "MINUTELY",
        "HOURLY",
        "DAILY",
        "WEEKLY",
        "MONTHLY",
        "YEARLY"
    ];
    var optionDesign = {
        FREQ: function(value1, dict, fmtIcal) {
            // yes this is actually equal or faster then regex.
            // upside here is we can enumerate the valid values.
            if (ALLOWED_FREQ.indexOf(value1) !== -1) dict.freq = value1;
            else throw new Error('invalid frequency "' + value1 + '" expected: "' + ALLOWED_FREQ.join(", ") + '"');
        },
        COUNT: function(value1, dict, fmtIcal) {
            dict.count = $c854a69b4095b587$var$ICAL.helpers.strictParseInt(value1);
        },
        INTERVAL: function(value1, dict, fmtIcal) {
            dict.interval = $c854a69b4095b587$var$ICAL.helpers.strictParseInt(value1);
            if (dict.interval < 1) // 0 or negative values are not allowed, some engines seem to generate
            // it though. Assume 1 instead.
            dict.interval = 1;
        },
        UNTIL: function(value1, dict, fmtIcal) {
            if (value1.length > 10) dict.until = $c854a69b4095b587$var$ICAL.design.icalendar.value["date-time"].fromICAL(value1);
            else dict.until = $c854a69b4095b587$var$ICAL.design.icalendar.value.date.fromICAL(value1);
            if (!fmtIcal) dict.until = $c854a69b4095b587$var$ICAL.Time.fromString(dict.until);
        },
        WKST: function(value1, dict, fmtIcal) {
            if (VALID_DAY_NAMES.test(value1)) dict.wkst = $c854a69b4095b587$var$ICAL.Recur.icalDayToNumericDay(value1);
            else throw new Error('invalid WKST value "' + value1 + '"');
        }
    };
    var partDesign = {
        BYSECOND: parseNumericValue.bind(this, "BYSECOND", 0, 60),
        BYMINUTE: parseNumericValue.bind(this, "BYMINUTE", 0, 59),
        BYHOUR: parseNumericValue.bind(this, "BYHOUR", 0, 23),
        BYDAY: function(value1) {
            if (VALID_BYDAY_PART.test(value1)) return value1;
            else throw new Error('invalid BYDAY value "' + value1 + '"');
        },
        BYMONTHDAY: parseNumericValue.bind(this, "BYMONTHDAY", -31, 31),
        BYYEARDAY: parseNumericValue.bind(this, "BYYEARDAY", -366, 366),
        BYWEEKNO: parseNumericValue.bind(this, "BYWEEKNO", -53, 53),
        BYMONTH: parseNumericValue.bind(this, "BYMONTH", 1, 12),
        BYSETPOS: parseNumericValue.bind(this, "BYSETPOS", -366, 366)
    };
    /**
   * Creates a new {@link ICAL.Recur} instance from the passed string.
   *
   * @param {String} string         The string to parse
   * @return {ICAL.Recur}           The created recurrence instance
   */ $c854a69b4095b587$var$ICAL.Recur.fromString = function(string) {
        var data = $c854a69b4095b587$var$ICAL.Recur._stringToData(string, false);
        return new $c854a69b4095b587$var$ICAL.Recur(data);
    };
    /**
   * Creates a new {@link ICAL.Recur} instance using members from the passed
   * data object.
   *
   * @param {Object} aData                              An object with members of the recurrence
   * @param {ICAL.Recur.frequencyValues=} aData.freq    The frequency value
   * @param {Number=} aData.interval                    The INTERVAL value
   * @param {ICAL.Time.weekDay=} aData.wkst             The week start value
   * @param {ICAL.Time=} aData.until                    The end of the recurrence set
   * @param {Number=} aData.count                       The number of occurrences
   * @param {Array.<Number>=} aData.bysecond            The seconds for the BYSECOND part
   * @param {Array.<Number>=} aData.byminute            The minutes for the BYMINUTE part
   * @param {Array.<Number>=} aData.byhour              The hours for the BYHOUR part
   * @param {Array.<String>=} aData.byday               The BYDAY values
   * @param {Array.<Number>=} aData.bymonthday          The days for the BYMONTHDAY part
   * @param {Array.<Number>=} aData.byyearday           The days for the BYYEARDAY part
   * @param {Array.<Number>=} aData.byweekno            The weeks for the BYWEEKNO part
   * @param {Array.<Number>=} aData.bymonth             The month for the BYMONTH part
   * @param {Array.<Number>=} aData.bysetpos            The positionals for the BYSETPOS part
   */ $c854a69b4095b587$var$ICAL.Recur.fromData = function(aData) {
        return new $c854a69b4095b587$var$ICAL.Recur(aData);
    };
    /**
   * Converts a recurrence string to a data object, suitable for the fromData
   * method.
   *
   * @param {String} string     The string to parse
   * @param {Boolean} fmtIcal   If true, the string is considered to be an
   *                              iCalendar string
   * @return {ICAL.Recur}       The recurrence instance
   */ $c854a69b4095b587$var$ICAL.Recur._stringToData = function(string, fmtIcal) {
        var dict = Object.create(null);
        // split is slower in FF but fast enough.
        // v8 however this is faster then manual split?
        var values = string.split(";");
        var len = values.length;
        for(var i = 0; i < len; i++){
            var parts = values[i].split("=");
            var ucname = parts[0].toUpperCase();
            var lcname = parts[0].toLowerCase();
            var name = fmtIcal ? lcname : ucname;
            var value1 = parts[1];
            if (ucname in partDesign) {
                var partArr = value1.split(",");
                var partArrIdx = 0;
                var partArrLen = partArr.length;
                for(; partArrIdx < partArrLen; partArrIdx++)partArr[partArrIdx] = partDesign[ucname](partArr[partArrIdx]);
                dict[name] = partArr.length == 1 ? partArr[0] : partArr;
            } else if (ucname in optionDesign) optionDesign[ucname](value1, dict, fmtIcal);
            else // Don't swallow unknown values. Just set them as they are.
            dict[lcname] = value1;
        }
        return dict;
    };
})();
/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 * Portions Copyright (C) Philipp Kewisch, 2011-2015 */ /**
 * This symbol is further described later on
 * @ignore
 */ $c854a69b4095b587$var$ICAL.RecurIterator = function() {
    /**
   * @classdesc
   * An iterator for a single recurrence rule. This class usually doesn't have
   * to be instanciated directly, the convenience method
   * {@link ICAL.Recur#iterator} can be used.
   *
   * @description
   * The options object may contain additional members when resuming iteration from a previous run
   *
   * @description
   * The options object may contain additional members when resuming iteration
   * from a previous run.
   *
   * @class
   * @alias ICAL.RecurIterator
   * @param {Object} options                The iterator options
   * @param {ICAL.Recur} options.rule       The rule to iterate.
   * @param {ICAL.Time} options.dtstart     The start date of the event.
   * @param {Boolean=} options.initialized  When true, assume that options are
   *        from a previously constructed iterator. Initialization will not be
   *        repeated.
   */ function icalrecur_iterator(options) {
        this.fromData(options);
    }
    icalrecur_iterator.prototype = {
        /**
     * True when iteration is finished.
     * @type {Boolean}
     */ completed: false,
        /**
     * The rule that is being iterated
     * @type {ICAL.Recur}
     */ rule: null,
        /**
     * The start date of the event being iterated.
     * @type {ICAL.Time}
     */ dtstart: null,
        /**
     * The last occurrence that was returned from the
     * {@link ICAL.RecurIterator#next} method.
     * @type {ICAL.Time}
     */ last: null,
        /**
     * The sequence number from the occurrence
     * @type {Number}
     */ occurrence_number: 0,
        /**
     * The indices used for the {@link ICAL.RecurIterator#by_data} object.
     * @type {Object}
     * @private
     */ by_indices: null,
        /**
     * If true, the iterator has already been initialized
     * @type {Boolean}
     * @private
     */ initialized: false,
        /**
     * The initializd by-data.
     * @type {Object}
     * @private
     */ by_data: null,
        /**
     * The expanded yeardays
     * @type {Array}
     * @private
     */ days: null,
        /**
     * The index in the {@link ICAL.RecurIterator#days} array.
     * @type {Number}
     * @private
     */ days_index: 0,
        /**
     * Initialize the recurrence iterator from the passed data object. This
     * method is usually not called directly, you can initialize the iterator
     * through the constructor.
     *
     * @param {Object} options                The iterator options
     * @param {ICAL.Recur} options.rule       The rule to iterate.
     * @param {ICAL.Time} options.dtstart     The start date of the event.
     * @param {Boolean=} options.initialized  When true, assume that options are
     *        from a previously constructed iterator. Initialization will not be
     *        repeated.
     */ fromData: function(options) {
            this.rule = $c854a69b4095b587$var$ICAL.helpers.formatClassType(options.rule, $c854a69b4095b587$var$ICAL.Recur);
            if (!this.rule) throw new Error("iterator requires a (ICAL.Recur) rule");
            this.dtstart = $c854a69b4095b587$var$ICAL.helpers.formatClassType(options.dtstart, $c854a69b4095b587$var$ICAL.Time);
            if (!this.dtstart) throw new Error("iterator requires a (ICAL.Time) dtstart");
            if (options.by_data) this.by_data = options.by_data;
            else this.by_data = $c854a69b4095b587$var$ICAL.helpers.clone(this.rule.parts, true);
            if (options.occurrence_number) this.occurrence_number = options.occurrence_number;
            this.days = options.days || [];
            if (options.last) this.last = $c854a69b4095b587$var$ICAL.helpers.formatClassType(options.last, $c854a69b4095b587$var$ICAL.Time);
            this.by_indices = options.by_indices;
            if (!this.by_indices) this.by_indices = {
                "BYSECOND": 0,
                "BYMINUTE": 0,
                "BYHOUR": 0,
                "BYDAY": 0,
                "BYMONTH": 0,
                "BYWEEKNO": 0,
                "BYMONTHDAY": 0
            };
            this.initialized = options.initialized || false;
            if (!this.initialized) this.init();
        },
        /**
     * Intialize the iterator
     * @private
     */ init: function icalrecur_iterator_init() {
            this.initialized = true;
            this.last = this.dtstart.clone();
            var parts = this.by_data;
            if ("BYDAY" in parts) // libical does this earlier when the rule is loaded, but we postpone to
            // now so we can preserve the original order.
            this.sort_byday_rules(parts.BYDAY);
            // If the BYYEARDAY appares, no other date rule part may appear
            if ("BYYEARDAY" in parts) {
                if ("BYMONTH" in parts || "BYWEEKNO" in parts || "BYMONTHDAY" in parts || "BYDAY" in parts) throw new Error("Invalid BYYEARDAY rule");
            }
            // BYWEEKNO and BYMONTHDAY rule parts may not both appear
            if ("BYWEEKNO" in parts && "BYMONTHDAY" in parts) throw new Error("BYWEEKNO does not fit to BYMONTHDAY");
            // For MONTHLY recurrences (FREQ=MONTHLY) neither BYYEARDAY nor
            // BYWEEKNO may appear.
            if (this.rule.freq == "MONTHLY" && ("BYYEARDAY" in parts || "BYWEEKNO" in parts)) throw new Error("For MONTHLY recurrences neither BYYEARDAY nor BYWEEKNO may appear");
            // For WEEKLY recurrences (FREQ=WEEKLY) neither BYMONTHDAY nor
            // BYYEARDAY may appear.
            if (this.rule.freq == "WEEKLY" && ("BYYEARDAY" in parts || "BYMONTHDAY" in parts)) throw new Error("For WEEKLY recurrences neither BYMONTHDAY nor BYYEARDAY may appear");
            // BYYEARDAY may only appear in YEARLY rules
            if (this.rule.freq != "YEARLY" && "BYYEARDAY" in parts) throw new Error("BYYEARDAY may only appear in YEARLY rules");
            this.last.second = this.setup_defaults("BYSECOND", "SECONDLY", this.dtstart.second);
            this.last.minute = this.setup_defaults("BYMINUTE", "MINUTELY", this.dtstart.minute);
            this.last.hour = this.setup_defaults("BYHOUR", "HOURLY", this.dtstart.hour);
            this.last.day = this.setup_defaults("BYMONTHDAY", "DAILY", this.dtstart.day);
            this.last.month = this.setup_defaults("BYMONTH", "MONTHLY", this.dtstart.month);
            if (this.rule.freq == "WEEKLY") {
                if ("BYDAY" in parts) {
                    var bydayParts = this.ruleDayOfWeek(parts.BYDAY[0], this.rule.wkst);
                    var pos = bydayParts[0];
                    var dow = bydayParts[1];
                    var wkdy = dow - this.last.dayOfWeek(this.rule.wkst);
                    if (this.last.dayOfWeek(this.rule.wkst) < dow && wkdy >= 0 || wkdy < 0) // Initial time is after first day of BYDAY data
                    this.last.day += wkdy;
                } else {
                    var dayName = $c854a69b4095b587$var$ICAL.Recur.numericDayToIcalDay(this.dtstart.dayOfWeek());
                    parts.BYDAY = [
                        dayName
                    ];
                }
            }
            if (this.rule.freq == "YEARLY") {
                for(;;){
                    this.expand_year_days(this.last.year);
                    if (this.days.length > 0) break;
                    this.increment_year(this.rule.interval);
                }
                this._nextByYearDay();
            }
            if (this.rule.freq == "MONTHLY" && this.has_by_data("BYDAY")) {
                var tempLast = null;
                var initLast = this.last.clone();
                var daysInMonth = $c854a69b4095b587$var$ICAL.Time.daysInMonth(this.last.month, this.last.year);
                // Check every weekday in BYDAY with relative dow and pos.
                for(var i in this.by_data.BYDAY){
                    /* istanbul ignore if */ if (!this.by_data.BYDAY.hasOwnProperty(i)) continue;
                    this.last = initLast.clone();
                    var bydayParts = this.ruleDayOfWeek(this.by_data.BYDAY[i]);
                    var pos = bydayParts[0];
                    var dow = bydayParts[1];
                    var dayOfMonth = this.last.nthWeekDay(dow, pos);
                    // If |pos| >= 6, the byday is invalid for a monthly rule.
                    if (pos >= 6 || pos <= -6) throw new Error("Malformed values in BYDAY part");
                    // If a Byday with pos=+/-5 is not in the current month it
                    // must be searched in the next months.
                    if (dayOfMonth > daysInMonth || dayOfMonth <= 0) {
                        // Skip if we have already found a "last" in this month.
                        if (tempLast && tempLast.month == initLast.month) continue;
                        while(dayOfMonth > daysInMonth || dayOfMonth <= 0){
                            this.increment_month();
                            daysInMonth = $c854a69b4095b587$var$ICAL.Time.daysInMonth(this.last.month, this.last.year);
                            dayOfMonth = this.last.nthWeekDay(dow, pos);
                        }
                    }
                    this.last.day = dayOfMonth;
                    if (!tempLast || this.last.compare(tempLast) < 0) tempLast = this.last.clone();
                }
                this.last = tempLast.clone();
                //XXX: This feels like a hack, but we need to initialize
                //     the BYMONTHDAY case correctly and byDayAndMonthDay handles
                //     this case. It accepts a special flag which will avoid incrementing
                //     the initial value without the flag days that match the start time
                //     would be missed.
                if (this.has_by_data("BYMONTHDAY")) this._byDayAndMonthDay(true);
                if (this.last.day > daysInMonth || this.last.day == 0) throw new Error("Malformed values in BYDAY part");
            } else if (this.has_by_data("BYMONTHDAY")) {
                if (this.last.day < 0) {
                    var daysInMonth = $c854a69b4095b587$var$ICAL.Time.daysInMonth(this.last.month, this.last.year);
                    this.last.day = daysInMonth + this.last.day + 1;
                }
            }
        },
        /**
     * Retrieve the next occurrence from the iterator.
     * @return {ICAL.Time}
     */ next: function icalrecur_iterator_next() {
            var before = this.last ? this.last.clone() : null;
            if (this.rule.count && this.occurrence_number >= this.rule.count || this.rule.until && this.last.compare(this.rule.until) > 0) {
                //XXX: right now this is just a flag and has no impact
                //     we can simplify the above case to check for completed later.
                this.completed = true;
                return null;
            }
            if (this.occurrence_number == 0 && this.last.compare(this.dtstart) >= 0) {
                // First of all, give the instance that was initialized
                this.occurrence_number++;
                return this.last;
            }
            var valid;
            do {
                valid = 1;
                switch(this.rule.freq){
                    case "SECONDLY":
                        this.next_second();
                        break;
                    case "MINUTELY":
                        this.next_minute();
                        break;
                    case "HOURLY":
                        this.next_hour();
                        break;
                    case "DAILY":
                        this.next_day();
                        break;
                    case "WEEKLY":
                        this.next_week();
                        break;
                    case "MONTHLY":
                        valid = this.next_month();
                        break;
                    case "YEARLY":
                        this.next_year();
                        break;
                    default:
                        return null;
                }
            }while (!this.check_contracting_rules() || this.last.compare(this.dtstart) < 0 || !valid);
            // TODO is this valid?
            if (this.last.compare(before) == 0) throw new Error("Same occurrence found twice, protecting you from death by recursion");
            if (this.rule.until && this.last.compare(this.rule.until) > 0) {
                this.completed = true;
                return null;
            } else {
                this.occurrence_number++;
                return this.last;
            }
        },
        next_second: function next_second() {
            return this.next_generic("BYSECOND", "SECONDLY", "second", "minute");
        },
        increment_second: function increment_second(inc) {
            return this.increment_generic(inc, "second", 60, "minute");
        },
        next_minute: function next_minute() {
            return this.next_generic("BYMINUTE", "MINUTELY", "minute", "hour", "next_second");
        },
        increment_minute: function increment_minute(inc) {
            return this.increment_generic(inc, "minute", 60, "hour");
        },
        next_hour: function next_hour() {
            return this.next_generic("BYHOUR", "HOURLY", "hour", "monthday", "next_minute");
        },
        increment_hour: function increment_hour(inc) {
            this.increment_generic(inc, "hour", 24, "monthday");
        },
        next_day: function next_day() {
            var has_by_day = "BYDAY" in this.by_data;
            var this_freq = this.rule.freq == "DAILY";
            if (this.next_hour() == 0) return 0;
            if (this_freq) this.increment_monthday(this.rule.interval);
            else this.increment_monthday(1);
            return 0;
        },
        next_week: function next_week() {
            var end_of_data = 0;
            if (this.next_weekday_by_week() == 0) return end_of_data;
            if (this.has_by_data("BYWEEKNO")) {
                var idx = ++this.by_indices.BYWEEKNO;
                if (this.by_indices.BYWEEKNO == this.by_data.BYWEEKNO.length) {
                    this.by_indices.BYWEEKNO = 0;
                    end_of_data = 1;
                }
                // HACK should be first month of the year
                this.last.month = 1;
                this.last.day = 1;
                var week_no = this.by_data.BYWEEKNO[this.by_indices.BYWEEKNO];
                this.last.day += 7 * week_no;
                if (end_of_data) this.increment_year(1);
            } else // Jump to the next week
            this.increment_monthday(7 * this.rule.interval);
            return end_of_data;
        },
        /**
     * Normalize each by day rule for a given year/month.
     * Takes into account ordering and negative rules
     *
     * @private
     * @param {Number} year         Current year.
     * @param {Number} month        Current month.
     * @param {Array}  rules        Array of rules.
     *
     * @return {Array} sorted and normalized rules.
     *                 Negative rules will be expanded to their
     *                 correct positive values for easier processing.
     */ normalizeByMonthDayRules: function(year, month, rules) {
            var daysInMonth = $c854a69b4095b587$var$ICAL.Time.daysInMonth(month, year);
            // XXX: This is probably bad for performance to allocate
            //      a new array for each month we scan, if possible
            //      we should try to optimize this...
            var newRules = [];
            var ruleIdx = 0;
            var len = rules.length;
            var rule;
            for(; ruleIdx < len; ruleIdx++){
                rule = rules[ruleIdx];
                // if this rule falls outside of given
                // month discard it.
                if (Math.abs(rule) > daysInMonth) continue;
                // negative case
                if (rule < 0) // we add (not subtract it is a negative number)
                // one from the rule because 1 === last day of month
                rule = daysInMonth + (rule + 1);
                else if (rule === 0) continue;
                // only add unique items...
                if (newRules.indexOf(rule) === -1) newRules.push(rule);
            }
            // unique and sort
            return newRules.sort(function(a, b) {
                return a - b;
            });
        },
        /**
     * NOTES:
     * We are given a list of dates in the month (BYMONTHDAY) (23, etc..)
     * Also we are given a list of days (BYDAY) (MO, 2SU, etc..) when
     * both conditions match a given date (this.last.day) iteration stops.
     *
     * @private
     * @param {Boolean=} isInit     When given true will not increment the
     *                                current day (this.last).
     */ _byDayAndMonthDay: function(isInit) {
            var byMonthDay; // setup in initMonth
            var byDay = this.by_data.BYDAY;
            var date;
            var dateIdx = 0;
            var dateLen; // setup in initMonth
            var dayLen = byDay.length;
            // we are not valid by default
            var dataIsValid = 0;
            var daysInMonth;
            var self = this;
            // we need a copy of this, because a DateTime gets normalized
            // automatically if the day is out of range. At some points we
            // set the last day to 0 to start counting.
            var lastDay = this.last.day;
            function initMonth() {
                daysInMonth = $c854a69b4095b587$var$ICAL.Time.daysInMonth(self.last.month, self.last.year);
                byMonthDay = self.normalizeByMonthDayRules(self.last.year, self.last.month, self.by_data.BYMONTHDAY);
                dateLen = byMonthDay.length;
                // For the case of more than one occurrence in one month
                // we have to be sure to start searching after the last
                // found date or at the last BYMONTHDAY, unless we are
                // initializing the iterator because in this case we have
                // to consider the last found date too.
                while(byMonthDay[dateIdx] <= lastDay && !(isInit && byMonthDay[dateIdx] == lastDay) && dateIdx < dateLen - 1)dateIdx++;
            }
            function nextMonth() {
                // since the day is incremented at the start
                // of the loop below, we need to start at 0
                lastDay = 0;
                self.increment_month();
                dateIdx = 0;
                initMonth();
            }
            initMonth();
            // should come after initMonth
            if (isInit) lastDay -= 1;
            // Use a counter to avoid an infinite loop with malformed rules.
            // Stop checking after 4 years so we consider also a leap year.
            var monthsCounter = 48;
            while(!dataIsValid && monthsCounter){
                monthsCounter--;
                // increment the current date. This is really
                // important otherwise we may fall into the infinite
                // loop trap. The initial date takes care of the case
                // where the current date is the date we are looking
                // for.
                date = lastDay + 1;
                if (date > daysInMonth) {
                    nextMonth();
                    continue;
                }
                // find next date
                var next = byMonthDay[dateIdx++];
                // this logic is dependant on the BYMONTHDAYS
                // being in order (which is done by #normalizeByMonthDayRules)
                if (next >= date) // if the next month day is in the future jump to it.
                lastDay = next;
                else {
                    // in this case the 'next' monthday has past
                    // we must move to the month.
                    nextMonth();
                    continue;
                }
                // Now we can loop through the day rules to see
                // if one matches the current month date.
                for(var dayIdx = 0; dayIdx < dayLen; dayIdx++){
                    var parts = this.ruleDayOfWeek(byDay[dayIdx]);
                    var pos = parts[0];
                    var dow = parts[1];
                    this.last.day = lastDay;
                    if (this.last.isNthWeekDay(dow, pos)) {
                        // when we find the valid one we can mark
                        // the conditions as met and break the loop.
                        // (Because we have this condition above
                        //  it will also break the parent loop).
                        dataIsValid = 1;
                        break;
                    }
                }
                // It is completely possible that the combination
                // cannot be matched in the current month.
                // When we reach the end of possible combinations
                // in the current month we iterate to the next one.
                // since dateIdx is incremented right after getting
                // "next", we don't need dateLen -1 here.
                if (!dataIsValid && dateIdx === dateLen) {
                    nextMonth();
                    continue;
                }
            }
            if (monthsCounter <= 0) // Checked 4 years without finding a Byday that matches
            // a Bymonthday. Maybe the rule is not correct.
            throw new Error("Malformed values in BYDAY combined with BYMONTHDAY parts");
            return dataIsValid;
        },
        next_month: function next_month() {
            var this_freq = this.rule.freq == "MONTHLY";
            var data_valid = 1;
            if (this.next_hour() == 0) return data_valid;
            if (this.has_by_data("BYDAY") && this.has_by_data("BYMONTHDAY")) data_valid = this._byDayAndMonthDay();
            else if (this.has_by_data("BYDAY")) {
                var daysInMonth = $c854a69b4095b587$var$ICAL.Time.daysInMonth(this.last.month, this.last.year);
                var setpos = 0;
                var setpos_total = 0;
                if (this.has_by_data("BYSETPOS")) {
                    var last_day = this.last.day;
                    for(var day = 1; day <= daysInMonth; day++){
                        this.last.day = day;
                        if (this.is_day_in_byday(this.last)) {
                            setpos_total++;
                            if (day <= last_day) setpos++;
                        }
                    }
                    this.last.day = last_day;
                }
                data_valid = 0;
                for(var day = this.last.day + 1; day <= daysInMonth; day++){
                    this.last.day = day;
                    if (this.is_day_in_byday(this.last)) {
                        if (!this.has_by_data("BYSETPOS") || this.check_set_position(++setpos) || this.check_set_position(setpos - setpos_total - 1)) {
                            data_valid = 1;
                            break;
                        }
                    }
                }
                if (day > daysInMonth) {
                    this.last.day = 1;
                    this.increment_month();
                    if (this.is_day_in_byday(this.last)) {
                        if (!this.has_by_data("BYSETPOS") || this.check_set_position(1)) data_valid = 1;
                    } else data_valid = 0;
                }
            } else if (this.has_by_data("BYMONTHDAY")) {
                this.by_indices.BYMONTHDAY++;
                if (this.by_indices.BYMONTHDAY >= this.by_data.BYMONTHDAY.length) {
                    this.by_indices.BYMONTHDAY = 0;
                    this.increment_month();
                }
                var daysInMonth = $c854a69b4095b587$var$ICAL.Time.daysInMonth(this.last.month, this.last.year);
                var day = this.by_data.BYMONTHDAY[this.by_indices.BYMONTHDAY];
                if (day < 0) day = daysInMonth + day + 1;
                if (day > daysInMonth) {
                    this.last.day = 1;
                    data_valid = this.is_day_in_byday(this.last);
                } else this.last.day = day;
            } else {
                this.increment_month();
                var daysInMonth = $c854a69b4095b587$var$ICAL.Time.daysInMonth(this.last.month, this.last.year);
                if (this.by_data.BYMONTHDAY[0] > daysInMonth) data_valid = 0;
                else this.last.day = this.by_data.BYMONTHDAY[0];
            }
            return data_valid;
        },
        next_weekday_by_week: function next_weekday_by_week() {
            var end_of_data = 0;
            if (this.next_hour() == 0) return end_of_data;
            if (!this.has_by_data("BYDAY")) return 1;
            for(;;){
                var tt = new $c854a69b4095b587$var$ICAL.Time();
                this.by_indices.BYDAY++;
                if (this.by_indices.BYDAY == Object.keys(this.by_data.BYDAY).length) {
                    this.by_indices.BYDAY = 0;
                    end_of_data = 1;
                }
                var coded_day = this.by_data.BYDAY[this.by_indices.BYDAY];
                var parts = this.ruleDayOfWeek(coded_day);
                var dow = parts[1];
                dow -= this.rule.wkst;
                if (dow < 0) dow += 7;
                tt.year = this.last.year;
                tt.month = this.last.month;
                tt.day = this.last.day;
                var startOfWeek = tt.startDoyWeek(this.rule.wkst);
                if (dow + startOfWeek < 1) {
                    // The selected date is in the previous year
                    if (!end_of_data) continue;
                }
                var next = $c854a69b4095b587$var$ICAL.Time.fromDayOfYear(startOfWeek + dow, this.last.year);
                /**
         * The normalization horrors below are due to
         * the fact that when the year/month/day changes
         * it can effect the other operations that come after.
         */ this.last.year = next.year;
                this.last.month = next.month;
                this.last.day = next.day;
                return end_of_data;
            }
        },
        next_year: function next_year() {
            if (this.next_hour() == 0) return 0;
            if (++this.days_index == this.days.length) {
                this.days_index = 0;
                do {
                    this.increment_year(this.rule.interval);
                    this.expand_year_days(this.last.year);
                }while (this.days.length == 0);
            }
            this._nextByYearDay();
            return 1;
        },
        _nextByYearDay: function _nextByYearDay() {
            var doy = this.days[this.days_index];
            var year = this.last.year;
            if (doy < 1) {
                // Time.fromDayOfYear(doy, year) indexes relative to the
                // start of the given year. That is different from the
                // semantics of BYYEARDAY where negative indexes are an
                // offset from the end of the given year.
                doy += 1;
                year += 1;
            }
            var next = $c854a69b4095b587$var$ICAL.Time.fromDayOfYear(doy, year);
            this.last.day = next.day;
            this.last.month = next.month;
        },
        /**
     * @param dow (eg: '1TU', '-1MO')
     * @param {ICAL.Time.weekDay=} aWeekStart The week start weekday
     * @return [pos, numericDow] (eg: [1, 3]) numericDow is relative to aWeekStart
     */ ruleDayOfWeek: function ruleDayOfWeek(dow, aWeekStart) {
            var matches = dow.match(/([+-]?[0-9])?(MO|TU|WE|TH|FR|SA|SU)/);
            if (matches) {
                var pos = parseInt(matches[1] || 0, 10);
                dow = $c854a69b4095b587$var$ICAL.Recur.icalDayToNumericDay(matches[2], aWeekStart);
                return [
                    pos,
                    dow
                ];
            } else return [
                0,
                0
            ];
        },
        next_generic: function next_generic(aRuleType, aInterval, aDateAttr, aFollowingAttr, aPreviousIncr) {
            var has_by_rule = aRuleType in this.by_data;
            var this_freq = this.rule.freq == aInterval;
            var end_of_data = 0;
            if (aPreviousIncr && this[aPreviousIncr]() == 0) return end_of_data;
            if (has_by_rule) {
                this.by_indices[aRuleType]++;
                var idx = this.by_indices[aRuleType];
                var dta = this.by_data[aRuleType];
                if (this.by_indices[aRuleType] == dta.length) {
                    this.by_indices[aRuleType] = 0;
                    end_of_data = 1;
                }
                this.last[aDateAttr] = dta[this.by_indices[aRuleType]];
            } else if (this_freq) this["increment_" + aDateAttr](this.rule.interval);
            if (has_by_rule && end_of_data && this_freq) this["increment_" + aFollowingAttr](1);
            return end_of_data;
        },
        increment_monthday: function increment_monthday(inc) {
            for(var i = 0; i < inc; i++){
                var daysInMonth = $c854a69b4095b587$var$ICAL.Time.daysInMonth(this.last.month, this.last.year);
                this.last.day++;
                if (this.last.day > daysInMonth) {
                    this.last.day -= daysInMonth;
                    this.increment_month();
                }
            }
        },
        increment_month: function increment_month() {
            this.last.day = 1;
            if (this.has_by_data("BYMONTH")) {
                this.by_indices.BYMONTH++;
                if (this.by_indices.BYMONTH == this.by_data.BYMONTH.length) {
                    this.by_indices.BYMONTH = 0;
                    this.increment_year(1);
                }
                this.last.month = this.by_data.BYMONTH[this.by_indices.BYMONTH];
            } else {
                if (this.rule.freq == "MONTHLY") this.last.month += this.rule.interval;
                else this.last.month++;
                this.last.month--;
                var years = $c854a69b4095b587$var$ICAL.helpers.trunc(this.last.month / 12);
                this.last.month %= 12;
                this.last.month++;
                if (years != 0) this.increment_year(years);
            }
        },
        increment_year: function increment_year(inc) {
            this.last.year += inc;
        },
        increment_generic: function increment_generic(inc, aDateAttr, aFactor, aNextIncrement) {
            this.last[aDateAttr] += inc;
            var nextunit = $c854a69b4095b587$var$ICAL.helpers.trunc(this.last[aDateAttr] / aFactor);
            this.last[aDateAttr] %= aFactor;
            if (nextunit != 0) this["increment_" + aNextIncrement](nextunit);
        },
        has_by_data: function has_by_data(aRuleType) {
            return aRuleType in this.rule.parts;
        },
        expand_year_days: function expand_year_days(aYear) {
            var t = new $c854a69b4095b587$var$ICAL.Time();
            this.days = [];
            // We need our own copy with a few keys set
            var parts = {};
            var rules = [
                "BYDAY",
                "BYWEEKNO",
                "BYMONTHDAY",
                "BYMONTH",
                "BYYEARDAY"
            ];
            for(var p1 in rules)/* istanbul ignore else */ if (rules.hasOwnProperty(p1)) {
                var part = rules[p1];
                if (part in this.rule.parts) parts[part] = this.rule.parts[part];
            }
            if ("BYMONTH" in parts && "BYWEEKNO" in parts) {
                var valid = 1;
                var validWeeks = {};
                t.year = aYear;
                t.isDate = true;
                for(var monthIdx = 0; monthIdx < this.by_data.BYMONTH.length; monthIdx++){
                    var month = this.by_data.BYMONTH[monthIdx];
                    t.month = month;
                    t.day = 1;
                    var first_week = t.weekNumber(this.rule.wkst);
                    t.day = $c854a69b4095b587$var$ICAL.Time.daysInMonth(month, aYear);
                    var last_week = t.weekNumber(this.rule.wkst);
                    for(monthIdx = first_week; monthIdx < last_week; monthIdx++)validWeeks[monthIdx] = 1;
                }
                for(var weekIdx = 0; weekIdx < this.by_data.BYWEEKNO.length && valid; weekIdx++){
                    var weekno = this.by_data.BYWEEKNO[weekIdx];
                    if (weekno < 52) valid &= validWeeks[weekIdx];
                    else valid = 0;
                }
                if (valid) delete parts.BYMONTH;
                else delete parts.BYWEEKNO;
            }
            var partCount = Object.keys(parts).length;
            if (partCount == 0) {
                var t1 = this.dtstart.clone();
                t1.year = this.last.year;
                this.days.push(t1.dayOfYear());
            } else if (partCount == 1 && "BYMONTH" in parts) for(var monthkey in this.by_data.BYMONTH){
                /* istanbul ignore if */ if (!this.by_data.BYMONTH.hasOwnProperty(monthkey)) continue;
                var t2 = this.dtstart.clone();
                t2.year = aYear;
                t2.month = this.by_data.BYMONTH[monthkey];
                t2.isDate = true;
                this.days.push(t2.dayOfYear());
            }
            else if (partCount == 1 && "BYMONTHDAY" in parts) for(var monthdaykey in this.by_data.BYMONTHDAY){
                /* istanbul ignore if */ if (!this.by_data.BYMONTHDAY.hasOwnProperty(monthdaykey)) continue;
                var t3 = this.dtstart.clone();
                var day_ = this.by_data.BYMONTHDAY[monthdaykey];
                if (day_ < 0) {
                    var daysInMonth = $c854a69b4095b587$var$ICAL.Time.daysInMonth(t3.month, aYear);
                    day_ = day_ + daysInMonth + 1;
                }
                t3.day = day_;
                t3.year = aYear;
                t3.isDate = true;
                this.days.push(t3.dayOfYear());
            }
            else if (partCount == 2 && "BYMONTHDAY" in parts && "BYMONTH" in parts) for(var monthkey in this.by_data.BYMONTH){
                /* istanbul ignore if */ if (!this.by_data.BYMONTH.hasOwnProperty(monthkey)) continue;
                var month_ = this.by_data.BYMONTH[monthkey];
                var daysInMonth = $c854a69b4095b587$var$ICAL.Time.daysInMonth(month_, aYear);
                for(var monthdaykey in this.by_data.BYMONTHDAY){
                    /* istanbul ignore if */ if (!this.by_data.BYMONTHDAY.hasOwnProperty(monthdaykey)) continue;
                    var day_ = this.by_data.BYMONTHDAY[monthdaykey];
                    if (day_ < 0) day_ = day_ + daysInMonth + 1;
                    t.day = day_;
                    t.month = month_;
                    t.year = aYear;
                    t.isDate = true;
                    this.days.push(t.dayOfYear());
                }
            }
            else if (partCount == 1 && "BYWEEKNO" in parts) ;
            else if (partCount == 2 && "BYWEEKNO" in parts && "BYMONTHDAY" in parts) ;
            else if (partCount == 1 && "BYDAY" in parts) this.days = this.days.concat(this.expand_by_day(aYear));
            else if (partCount == 2 && "BYDAY" in parts && "BYMONTH" in parts) {
                for(var monthkey in this.by_data.BYMONTH){
                    /* istanbul ignore if */ if (!this.by_data.BYMONTH.hasOwnProperty(monthkey)) continue;
                    var month = this.by_data.BYMONTH[monthkey];
                    var daysInMonth = $c854a69b4095b587$var$ICAL.Time.daysInMonth(month, aYear);
                    t.year = aYear;
                    t.month = this.by_data.BYMONTH[monthkey];
                    t.day = 1;
                    t.isDate = true;
                    var first_dow = t.dayOfWeek();
                    var doy_offset = t.dayOfYear() - 1;
                    t.day = daysInMonth;
                    var last_dow = t.dayOfWeek();
                    if (this.has_by_data("BYSETPOS")) {
                        var set_pos_counter = 0;
                        var by_month_day = [];
                        for(var day = 1; day <= daysInMonth; day++){
                            t.day = day;
                            if (this.is_day_in_byday(t)) by_month_day.push(day);
                        }
                        for(var spIndex = 0; spIndex < by_month_day.length; spIndex++)if (this.check_set_position(spIndex + 1) || this.check_set_position(spIndex - by_month_day.length)) this.days.push(doy_offset + by_month_day[spIndex]);
                    } else for(var daycodedkey in this.by_data.BYDAY){
                        /* istanbul ignore if */ if (!this.by_data.BYDAY.hasOwnProperty(daycodedkey)) continue;
                        var coded_day = this.by_data.BYDAY[daycodedkey];
                        var bydayParts = this.ruleDayOfWeek(coded_day);
                        var pos = bydayParts[0];
                        var dow = bydayParts[1];
                        var month_day;
                        var first_matching_day = (dow + 7 - first_dow) % 7 + 1;
                        var last_matching_day = daysInMonth - (last_dow + 7 - dow) % 7;
                        if (pos == 0) for(var day = first_matching_day; day <= daysInMonth; day += 7)this.days.push(doy_offset + day);
                        else if (pos > 0) {
                            month_day = first_matching_day + (pos - 1) * 7;
                            if (month_day <= daysInMonth) this.days.push(doy_offset + month_day);
                        } else {
                            month_day = last_matching_day + (pos + 1) * 7;
                            if (month_day > 0) this.days.push(doy_offset + month_day);
                        }
                    }
                }
                // Return dates in order of occurrence (1,2,3,...) instead
                // of by groups of weekdays (1,8,15,...,2,9,16,...).
                this.days.sort(function(a, b) {
                    return a - b;
                }); // Comparator function allows to sort numbers.
            } else if (partCount == 2 && "BYDAY" in parts && "BYMONTHDAY" in parts) {
                var expandedDays = this.expand_by_day(aYear);
                for(var daykey in expandedDays){
                    /* istanbul ignore if */ if (!expandedDays.hasOwnProperty(daykey)) continue;
                    var day = expandedDays[daykey];
                    var tt = $c854a69b4095b587$var$ICAL.Time.fromDayOfYear(day, aYear);
                    if (this.by_data.BYMONTHDAY.indexOf(tt.day) >= 0) this.days.push(day);
                }
            } else if (partCount == 3 && "BYDAY" in parts && "BYMONTHDAY" in parts && "BYMONTH" in parts) {
                var expandedDays = this.expand_by_day(aYear);
                for(var daykey in expandedDays){
                    /* istanbul ignore if */ if (!expandedDays.hasOwnProperty(daykey)) continue;
                    var day = expandedDays[daykey];
                    var tt = $c854a69b4095b587$var$ICAL.Time.fromDayOfYear(day, aYear);
                    if (this.by_data.BYMONTH.indexOf(tt.month) >= 0 && this.by_data.BYMONTHDAY.indexOf(tt.day) >= 0) this.days.push(day);
                }
            } else if (partCount == 2 && "BYDAY" in parts && "BYWEEKNO" in parts) {
                var expandedDays = this.expand_by_day(aYear);
                for(var daykey in expandedDays){
                    /* istanbul ignore if */ if (!expandedDays.hasOwnProperty(daykey)) continue;
                    var day = expandedDays[daykey];
                    var tt = $c854a69b4095b587$var$ICAL.Time.fromDayOfYear(day, aYear);
                    var weekno = tt.weekNumber(this.rule.wkst);
                    if (this.by_data.BYWEEKNO.indexOf(weekno)) this.days.push(day);
                }
            } else if (partCount == 3 && "BYDAY" in parts && "BYWEEKNO" in parts && "BYMONTHDAY" in parts) ;
            else if (partCount == 1 && "BYYEARDAY" in parts) this.days = this.days.concat(this.by_data.BYYEARDAY);
            else this.days = [];
            return 0;
        },
        expand_by_day: function expand_by_day(aYear) {
            var days_list = [];
            var tmp = this.last.clone();
            tmp.year = aYear;
            tmp.month = 1;
            tmp.day = 1;
            tmp.isDate = true;
            var start_dow = tmp.dayOfWeek();
            tmp.month = 12;
            tmp.day = 31;
            tmp.isDate = true;
            var end_dow = tmp.dayOfWeek();
            var end_year_day = tmp.dayOfYear();
            for(var daykey in this.by_data.BYDAY){
                /* istanbul ignore if */ if (!this.by_data.BYDAY.hasOwnProperty(daykey)) continue;
                var day = this.by_data.BYDAY[daykey];
                var parts = this.ruleDayOfWeek(day);
                var pos = parts[0];
                var dow = parts[1];
                if (pos == 0) {
                    var tmp_start_doy = (dow + 7 - start_dow) % 7 + 1;
                    for(var doy = tmp_start_doy; doy <= end_year_day; doy += 7)days_list.push(doy);
                } else if (pos > 0) {
                    var first;
                    if (dow >= start_dow) first = dow - start_dow + 1;
                    else first = dow - start_dow + 8;
                    days_list.push(first + (pos - 1) * 7);
                } else {
                    var last;
                    pos = -pos;
                    if (dow <= end_dow) last = end_year_day - end_dow + dow;
                    else last = end_year_day - end_dow + dow - 7;
                    days_list.push(last - (pos - 1) * 7);
                }
            }
            return days_list;
        },
        is_day_in_byday: function is_day_in_byday(tt) {
            for(var daykey in this.by_data.BYDAY){
                /* istanbul ignore if */ if (!this.by_data.BYDAY.hasOwnProperty(daykey)) continue;
                var day = this.by_data.BYDAY[daykey];
                var parts = this.ruleDayOfWeek(day);
                var pos = parts[0];
                var dow = parts[1];
                var this_dow = tt.dayOfWeek();
                if (pos == 0 && dow == this_dow || tt.nthWeekDay(dow, pos) == tt.day) return 1;
            }
            return 0;
        },
        /**
     * Checks if given value is in BYSETPOS.
     *
     * @private
     * @param {Numeric} aPos position to check for.
     * @return {Boolean} false unless BYSETPOS rules exist
     *                   and the given value is present in rules.
     */ check_set_position: function check_set_position(aPos) {
            if (this.has_by_data("BYSETPOS")) {
                var idx = this.by_data.BYSETPOS.indexOf(aPos);
                // negative numbers are not false-y
                return idx !== -1;
            }
            return false;
        },
        sort_byday_rules: function icalrecur_sort_byday_rules(aRules) {
            for(var i = 0; i < aRules.length; i++)for(var j = 0; j < i; j++){
                var one = this.ruleDayOfWeek(aRules[j], this.rule.wkst)[1];
                var two = this.ruleDayOfWeek(aRules[i], this.rule.wkst)[1];
                if (one > two) {
                    var tmp = aRules[i];
                    aRules[i] = aRules[j];
                    aRules[j] = tmp;
                }
            }
        },
        check_contract_restriction: function check_contract_restriction(aRuleType, v) {
            var indexMapValue = icalrecur_iterator._indexMap[aRuleType];
            var ruleMapValue = icalrecur_iterator._expandMap[this.rule.freq][indexMapValue];
            var pass = false;
            if (aRuleType in this.by_data && ruleMapValue == icalrecur_iterator.CONTRACT) {
                var ruleType = this.by_data[aRuleType];
                for(var bydatakey in ruleType){
                    /* istanbul ignore else */ if (ruleType.hasOwnProperty(bydatakey)) {
                        if (ruleType[bydatakey] == v) {
                            pass = true;
                            break;
                        }
                    }
                }
            } else // Not a contracting byrule or has no data, test passes
            pass = true;
            return pass;
        },
        check_contracting_rules: function check_contracting_rules() {
            var dow = this.last.dayOfWeek();
            var weekNo = this.last.weekNumber(this.rule.wkst);
            var doy = this.last.dayOfYear();
            return this.check_contract_restriction("BYSECOND", this.last.second) && this.check_contract_restriction("BYMINUTE", this.last.minute) && this.check_contract_restriction("BYHOUR", this.last.hour) && this.check_contract_restriction("BYDAY", $c854a69b4095b587$var$ICAL.Recur.numericDayToIcalDay(dow)) && this.check_contract_restriction("BYWEEKNO", weekNo) && this.check_contract_restriction("BYMONTHDAY", this.last.day) && this.check_contract_restriction("BYMONTH", this.last.month) && this.check_contract_restriction("BYYEARDAY", doy);
        },
        setup_defaults: function setup_defaults(aRuleType, req, deftime) {
            var indexMapValue = icalrecur_iterator._indexMap[aRuleType];
            var ruleMapValue = icalrecur_iterator._expandMap[this.rule.freq][indexMapValue];
            if (ruleMapValue != icalrecur_iterator.CONTRACT) {
                if (!(aRuleType in this.by_data)) this.by_data[aRuleType] = [
                    deftime
                ];
                if (this.rule.freq != req) return this.by_data[aRuleType][0];
            }
            return deftime;
        },
        /**
     * Convert iterator into a serialize-able object.  Will preserve current
     * iteration sequence to ensure the seamless continuation of the recurrence
     * rule.
     * @return {Object}
     */ toJSON: function() {
            var result = Object.create(null);
            result.initialized = this.initialized;
            result.rule = this.rule.toJSON();
            result.dtstart = this.dtstart.toJSON();
            result.by_data = this.by_data;
            result.days = this.days;
            result.last = this.last.toJSON();
            result.by_indices = this.by_indices;
            result.occurrence_number = this.occurrence_number;
            return result;
        }
    };
    icalrecur_iterator._indexMap = {
        "BYSECOND": 0,
        "BYMINUTE": 1,
        "BYHOUR": 2,
        "BYDAY": 3,
        "BYMONTHDAY": 4,
        "BYYEARDAY": 5,
        "BYWEEKNO": 6,
        "BYMONTH": 7,
        "BYSETPOS": 8
    };
    icalrecur_iterator._expandMap = {
        "SECONDLY": [
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1
        ],
        "MINUTELY": [
            2,
            1,
            1,
            1,
            1,
            1,
            1,
            1
        ],
        "HOURLY": [
            2,
            2,
            1,
            1,
            1,
            1,
            1,
            1
        ],
        "DAILY": [
            2,
            2,
            2,
            1,
            1,
            1,
            1,
            1
        ],
        "WEEKLY": [
            2,
            2,
            2,
            2,
            3,
            3,
            1,
            1
        ],
        "MONTHLY": [
            2,
            2,
            2,
            2,
            2,
            3,
            3,
            1
        ],
        "YEARLY": [
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2
        ]
    };
    icalrecur_iterator.UNKNOWN = 0;
    icalrecur_iterator.CONTRACT = 1;
    icalrecur_iterator.EXPAND = 2;
    icalrecur_iterator.ILLEGAL = 3;
    return icalrecur_iterator;
}();
/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 * Portions Copyright (C) Philipp Kewisch, 2011-2015 */ /**
 * This symbol is further described later on
 * @ignore
 */ $c854a69b4095b587$var$ICAL.RecurExpansion = function() {
    function formatTime(item) {
        return $c854a69b4095b587$var$ICAL.helpers.formatClassType(item, $c854a69b4095b587$var$ICAL.Time);
    }
    function compareTime(a, b) {
        return a.compare(b);
    }
    function isRecurringComponent(comp) {
        return comp.hasProperty("rdate") || comp.hasProperty("rrule") || comp.hasProperty("recurrence-id");
    }
    /**
   * @classdesc
   * Primary class for expanding recurring rules.  Can take multiple rrules,
   * rdates, exdate(s) and iterate (in order) over each next occurrence.
   *
   * Once initialized this class can also be serialized saved and continue
   * iteration from the last point.
   *
   * NOTE: it is intended that this class is to be used
   *       with ICAL.Event which handles recurrence exceptions.
   *
   * @example
   * // assuming event is a parsed ical component
   * var event;
   *
   * var expand = new ICAL.RecurExpansion({
   *   component: event,
   *   dtstart: event.getFirstPropertyValue('dtstart')
   * });
   *
   * // remember there are infinite rules
   * // so it is a good idea to limit the scope
   * // of the iterations then resume later on.
   *
   * // next is always an ICAL.Time or null
   * var next;
   *
   * while (someCondition && (next = expand.next())) {
   *   // do something with next
   * }
   *
   * // save instance for later
   * var json = JSON.stringify(expand);
   *
   * //...
   *
   * // NOTE: if the component's properties have
   * //       changed you will need to rebuild the
   * //       class and start over. This only works
   * //       when the component's recurrence info is the same.
   * var expand = new ICAL.RecurExpansion(JSON.parse(json));
   *
   * @description
   * The options object can be filled with the specified initial values. It can
   * also contain additional members, as a result of serializing a previous
   * expansion state, as shown in the example.
   *
   * @class
   * @alias ICAL.RecurExpansion
   * @param {Object} options
   *        Recurrence expansion options
   * @param {ICAL.Time} options.dtstart
   *        Start time of the event
   * @param {ICAL.Component=} options.component
   *        Component for expansion, required if not resuming.
   */ function RecurExpansion(options) {
        this.ruleDates = [];
        this.exDates = [];
        this.fromData(options);
    }
    RecurExpansion.prototype = {
        /**
     * True when iteration is fully completed.
     * @type {Boolean}
     */ complete: false,
        /**
     * Array of rrule iterators.
     *
     * @type {ICAL.RecurIterator[]}
     * @private
     */ ruleIterators: null,
        /**
     * Array of rdate instances.
     *
     * @type {ICAL.Time[]}
     * @private
     */ ruleDates: null,
        /**
     * Array of exdate instances.
     *
     * @type {ICAL.Time[]}
     * @private
     */ exDates: null,
        /**
     * Current position in ruleDates array.
     * @type {Number}
     * @private
     */ ruleDateInc: 0,
        /**
     * Current position in exDates array
     * @type {Number}
     * @private
     */ exDateInc: 0,
        /**
     * Current negative date.
     *
     * @type {ICAL.Time}
     * @private
     */ exDate: null,
        /**
     * Current additional date.
     *
     * @type {ICAL.Time}
     * @private
     */ ruleDate: null,
        /**
     * Start date of recurring rules.
     *
     * @type {ICAL.Time}
     */ dtstart: null,
        /**
     * Last expanded time
     *
     * @type {ICAL.Time}
     */ last: null,
        /**
     * Initialize the recurrence expansion from the data object. The options
     * object may also contain additional members, see the
     * {@link ICAL.RecurExpansion constructor} for more details.
     *
     * @param {Object} options
     *        Recurrence expansion options
     * @param {ICAL.Time} options.dtstart
     *        Start time of the event
     * @param {ICAL.Component=} options.component
     *        Component for expansion, required if not resuming.
     */ fromData: function(options) {
            var start = $c854a69b4095b587$var$ICAL.helpers.formatClassType(options.dtstart, $c854a69b4095b587$var$ICAL.Time);
            if (!start) throw new Error(".dtstart (ICAL.Time) must be given");
            else this.dtstart = start;
            if (options.component) this._init(options.component);
            else {
                this.last = formatTime(options.last) || start.clone();
                if (!options.ruleIterators) throw new Error(".ruleIterators or .component must be given");
                this.ruleIterators = options.ruleIterators.map(function(item) {
                    return $c854a69b4095b587$var$ICAL.helpers.formatClassType(item, $c854a69b4095b587$var$ICAL.RecurIterator);
                });
                this.ruleDateInc = options.ruleDateInc;
                this.exDateInc = options.exDateInc;
                if (options.ruleDates) {
                    this.ruleDates = options.ruleDates.map(formatTime);
                    this.ruleDate = this.ruleDates[this.ruleDateInc];
                }
                if (options.exDates) {
                    this.exDates = options.exDates.map(formatTime);
                    this.exDate = this.exDates[this.exDateInc];
                }
                if (typeof options.complete !== "undefined") this.complete = options.complete;
            }
        },
        /**
     * Retrieve the next occurrence in the series.
     * @return {ICAL.Time}
     */ next: function() {
            var iter;
            var ruleOfDay;
            var next;
            var compare;
            var maxTries = 500;
            var currentTry = 0;
            while(true){
                if (currentTry++ > maxTries) throw new Error("max tries have occured, rule may be impossible to forfill.");
                next = this.ruleDate;
                iter = this._nextRecurrenceIter(this.last);
                // no more matches
                // because we increment the rule day or rule
                // _after_ we choose a value this should be
                // the only spot where we need to worry about the
                // end of events.
                if (!next && !iter) {
                    // there are no more iterators or rdates
                    this.complete = true;
                    break;
                }
                // no next rule day or recurrence rule is first.
                if (!next || iter && next.compare(iter.last) > 0) {
                    // must be cloned, recur will reuse the time element.
                    next = iter.last.clone();
                    // move to next so we can continue
                    iter.next();
                }
                // if the ruleDate is still next increment it.
                if (this.ruleDate === next) this._nextRuleDay();
                this.last = next;
                // check the negative rules
                if (this.exDate) {
                    compare = this.exDate.compare(this.last);
                    if (compare < 0) this._nextExDay();
                    // if the current rule is excluded skip it.
                    if (compare === 0) {
                        this._nextExDay();
                        continue;
                    }
                }
                //XXX: The spec states that after we resolve the final
                //     list of dates we execute exdate this seems somewhat counter
                //     intuitive to what I have seen most servers do so for now
                //     I exclude based on the original date not the one that may
                //     have been modified by the exception.
                return this.last;
            }
        },
        /**
     * Converts object into a serialize-able format. This format can be passed
     * back into the expansion to resume iteration.
     * @return {Object}
     */ toJSON: function() {
            function toJSON(item) {
                return item.toJSON();
            }
            var result = Object.create(null);
            result.ruleIterators = this.ruleIterators.map(toJSON);
            if (this.ruleDates) result.ruleDates = this.ruleDates.map(toJSON);
            if (this.exDates) result.exDates = this.exDates.map(toJSON);
            result.ruleDateInc = this.ruleDateInc;
            result.exDateInc = this.exDateInc;
            result.last = this.last.toJSON();
            result.dtstart = this.dtstart.toJSON();
            result.complete = this.complete;
            return result;
        },
        /**
     * Extract all dates from the properties in the given component. The
     * properties will be filtered by the property name.
     *
     * @private
     * @param {ICAL.Component} component        The component to search in
     * @param {String} propertyName             The property name to search for
     * @return {ICAL.Time[]}                    The extracted dates.
     */ _extractDates: function(component, propertyName) {
            function handleProp(prop) {
                idx = $c854a69b4095b587$var$ICAL.helpers.binsearchInsert(result, prop, compareTime);
                // ordered insert
                result.splice(idx, 0, prop);
            }
            var result = [];
            var props = component.getAllProperties(propertyName);
            var len = props.length;
            var i = 0;
            var prop;
            var idx;
            for(; i < len; i++)props[i].getValues().forEach(handleProp);
            return result;
        },
        /**
     * Initialize the recurrence expansion.
     *
     * @private
     * @param {ICAL.Component} component    The component to initialize from.
     */ _init: function(component) {
            this.ruleIterators = [];
            this.last = this.dtstart.clone();
            // to provide api consistency non-recurring
            // events can also use the iterator though it will
            // only return a single time.
            if (!isRecurringComponent(component)) {
                this.ruleDate = this.last.clone();
                this.complete = true;
                return;
            }
            if (component.hasProperty("rdate")) {
                this.ruleDates = this._extractDates(component, "rdate");
                // special hack for cases where first rdate is prior
                // to the start date. We only check for the first rdate.
                // This is mostly for google's crazy recurring date logic
                // (contacts birthdays).
                if (this.ruleDates[0] && this.ruleDates[0].compare(this.dtstart) < 0) {
                    this.ruleDateInc = 0;
                    this.last = this.ruleDates[0].clone();
                } else this.ruleDateInc = $c854a69b4095b587$var$ICAL.helpers.binsearchInsert(this.ruleDates, this.last, compareTime);
                this.ruleDate = this.ruleDates[this.ruleDateInc];
            }
            if (component.hasProperty("rrule")) {
                var rules = component.getAllProperties("rrule");
                var i = 0;
                var len = rules.length;
                var rule;
                var iter;
                for(; i < len; i++){
                    rule = rules[i].getFirstValue();
                    iter = rule.iterator(this.dtstart);
                    this.ruleIterators.push(iter);
                    // increment to the next occurrence so future
                    // calls to next return times beyond the initial iteration.
                    // XXX: I find this suspicious might be a bug?
                    iter.next();
                }
            }
            if (component.hasProperty("exdate")) {
                this.exDates = this._extractDates(component, "exdate");
                // if we have a .last day we increment the index to beyond it.
                this.exDateInc = $c854a69b4095b587$var$ICAL.helpers.binsearchInsert(this.exDates, this.last, compareTime);
                this.exDate = this.exDates[this.exDateInc];
            }
        },
        /**
     * Advance to the next exdate
     * @private
     */ _nextExDay: function() {
            this.exDate = this.exDates[++this.exDateInc];
        },
        /**
     * Advance to the next rule date
     * @private
     */ _nextRuleDay: function() {
            this.ruleDate = this.ruleDates[++this.ruleDateInc];
        },
        /**
     * Find and return the recurrence rule with the most recent event and
     * return it.
     *
     * @private
     * @return {?ICAL.RecurIterator}    Found iterator.
     */ _nextRecurrenceIter: function() {
            var iters = this.ruleIterators;
            if (iters.length === 0) return null;
            var len = iters.length;
            var iter;
            var iterTime;
            var iterIdx = 0;
            var chosenIter;
            // loop through each iterator
            for(; iterIdx < len; iterIdx++){
                iter = iters[iterIdx];
                iterTime = iter.last;
                // if iteration is complete
                // then we must exclude it from
                // the search and remove it.
                if (iter.completed) {
                    len--;
                    if (iterIdx !== 0) iterIdx--;
                    iters.splice(iterIdx, 1);
                    continue;
                }
                // find the most recent possible choice
                if (!chosenIter || chosenIter.last.compare(iterTime) > 0) // that iterator is saved
                chosenIter = iter;
            }
            // the chosen iterator is returned but not mutated
            // this iterator contains the most recent event.
            return chosenIter;
        }
    };
    return RecurExpansion;
}();
/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 * Portions Copyright (C) Philipp Kewisch, 2011-2015 */ /**
 * This symbol is further described later on
 * @ignore
 */ $c854a69b4095b587$var$ICAL.Event = function() {
    /**
   * @classdesc
   * ICAL.js is organized into multiple layers. The bottom layer is a raw jCal
   * object, followed by the component/property layer. The highest level is the
   * event representation, which this class is part of. See the
   * {@tutorial layers} guide for more details.
   *
   * @class
   * @alias ICAL.Event
   * @param {ICAL.Component=} component         The ICAL.Component to base this event on
   * @param {Object} options                    Options for this event
   * @param {Boolean} options.strictExceptions
   *          When true, will verify exceptions are related by their UUID
   * @param {Array<ICAL.Component|ICAL.Event>} options.exceptions
   *          Exceptions to this event, either as components or events. If not
   *            specified exceptions will automatically be set in relation of
   *            component's parent
   */ function Event(component, options) {
        if (!(component instanceof $c854a69b4095b587$var$ICAL.Component)) {
            options = component;
            component = null;
        }
        if (component) this.component = component;
        else this.component = new $c854a69b4095b587$var$ICAL.Component("vevent");
        this._rangeExceptionCache = Object.create(null);
        this.exceptions = Object.create(null);
        this.rangeExceptions = [];
        if (options && options.strictExceptions) this.strictExceptions = options.strictExceptions;
        if (options && options.exceptions) options.exceptions.forEach(this.relateException, this);
        else if (this.component.parent && !this.isRecurrenceException()) this.component.parent.getAllSubcomponents("vevent").forEach(function(event) {
            if (event.hasProperty("recurrence-id")) this.relateException(event);
        }, this);
    }
    Event.prototype = {
        THISANDFUTURE: "THISANDFUTURE",
        /**
     * List of related event exceptions.
     *
     * @type {ICAL.Event[]}
     */ exceptions: null,
        /**
     * When true, will verify exceptions are related by their UUID.
     *
     * @type {Boolean}
     */ strictExceptions: false,
        /**
     * Relates a given event exception to this object.  If the given component
     * does not share the UID of this event it cannot be related and will throw
     * an exception.
     *
     * If this component is an exception it cannot have other exceptions
     * related to it.
     *
     * @param {ICAL.Component|ICAL.Event} obj       Component or event
     */ relateException: function(obj) {
            if (this.isRecurrenceException()) throw new Error("cannot relate exception to exceptions");
            if (obj instanceof $c854a69b4095b587$var$ICAL.Component) obj = new $c854a69b4095b587$var$ICAL.Event(obj);
            if (this.strictExceptions && obj.uid !== this.uid) throw new Error("attempted to relate unrelated exception");
            var id = obj.recurrenceId.toString();
            // we don't sort or manage exceptions directly
            // here the recurrence expander handles that.
            this.exceptions[id] = obj;
            // index RANGE=THISANDFUTURE exceptions so we can
            // look them up later in getOccurrenceDetails.
            if (obj.modifiesFuture()) {
                var item = [
                    obj.recurrenceId.toUnixTime(),
                    id
                ];
                // we keep them sorted so we can find the nearest
                // value later on...
                var idx = $c854a69b4095b587$var$ICAL.helpers.binsearchInsert(this.rangeExceptions, item, compareRangeException);
                this.rangeExceptions.splice(idx, 0, item);
            }
        },
        /**
     * Checks if this record is an exception and has the RANGE=THISANDFUTURE
     * value.
     *
     * @return {Boolean}        True, when exception is within range
     */ modifiesFuture: function() {
            if (!this.component.hasProperty("recurrence-id")) return false;
            var range = this.component.getFirstProperty("recurrence-id").getParameter("range");
            return range === this.THISANDFUTURE;
        },
        /**
     * Finds the range exception nearest to the given date.
     *
     * @param {ICAL.Time} time usually an occurrence time of an event
     * @return {?ICAL.Event} the related event/exception or null
     */ findRangeException: function(time) {
            if (!this.rangeExceptions.length) return null;
            var utc = time.toUnixTime();
            var idx = $c854a69b4095b587$var$ICAL.helpers.binsearchInsert(this.rangeExceptions, [
                utc
            ], compareRangeException);
            idx -= 1;
            // occurs before
            if (idx < 0) return null;
            var rangeItem = this.rangeExceptions[idx];
            /* istanbul ignore next: sanity check only */ if (utc < rangeItem[0]) return null;
            return rangeItem[1];
        },
        /**
     * This object is returned by {@link ICAL.Event#getOccurrenceDetails getOccurrenceDetails}
     *
     * @typedef {Object} occurrenceDetails
     * @memberof ICAL.Event
     * @property {ICAL.Time} recurrenceId       The passed in recurrence id
     * @property {ICAL.Event} item              The occurrence
     * @property {ICAL.Time} startDate          The start of the occurrence
     * @property {ICAL.Time} endDate            The end of the occurrence
     */ /**
     * Returns the occurrence details based on its start time.  If the
     * occurrence has an exception will return the details for that exception.
     *
     * NOTE: this method is intend to be used in conjunction
     *       with the {@link ICAL.Event#iterator iterator} method.
     *
     * @param {ICAL.Time} occurrence time occurrence
     * @return {ICAL.Event.occurrenceDetails} Information about the occurrence
     */ getOccurrenceDetails: function(occurrence) {
            var id = occurrence.toString();
            var utcId = occurrence.convertToZone($c854a69b4095b587$var$ICAL.Timezone.utcTimezone).toString();
            var item;
            var result = {
                //XXX: Clone?
                recurrenceId: occurrence
            };
            if (id in this.exceptions) {
                item = result.item = this.exceptions[id];
                result.startDate = item.startDate;
                result.endDate = item.endDate;
                result.item = item;
            } else if (utcId in this.exceptions) {
                item = this.exceptions[utcId];
                result.startDate = item.startDate;
                result.endDate = item.endDate;
                result.item = item;
            } else {
                // range exceptions (RANGE=THISANDFUTURE) have a
                // lower priority then direct exceptions but
                // must be accounted for first. Their item is
                // always the first exception with the range prop.
                var rangeExceptionId = this.findRangeException(occurrence);
                var end;
                if (rangeExceptionId) {
                    var exception = this.exceptions[rangeExceptionId];
                    // range exception must modify standard time
                    // by the difference (if any) in start/end times.
                    result.item = exception;
                    var startDiff = this._rangeExceptionCache[rangeExceptionId];
                    if (!startDiff) {
                        var original = exception.recurrenceId.clone();
                        var newStart = exception.startDate.clone();
                        // zones must be same otherwise subtract may be incorrect.
                        original.zone = newStart.zone;
                        startDiff = newStart.subtractDate(original);
                        this._rangeExceptionCache[rangeExceptionId] = startDiff;
                    }
                    var start = occurrence.clone();
                    start.zone = exception.startDate.zone;
                    start.addDuration(startDiff);
                    end = start.clone();
                    end.addDuration(exception.duration);
                    result.startDate = start;
                    result.endDate = end;
                } else {
                    // no range exception standard expansion
                    end = occurrence.clone();
                    end.addDuration(this.duration);
                    result.endDate = end;
                    result.startDate = occurrence;
                    result.item = this;
                }
            }
            return result;
        },
        /**
     * Builds a recur expansion instance for a specific point in time (defaults
     * to startDate).
     *
     * @param {ICAL.Time} startTime     Starting point for expansion
     * @return {ICAL.RecurExpansion}    Expansion object
     */ iterator: function(startTime) {
            return new $c854a69b4095b587$var$ICAL.RecurExpansion({
                component: this.component,
                dtstart: startTime || this.startDate
            });
        },
        /**
     * Checks if the event is recurring
     *
     * @return {Boolean}        True, if event is recurring
     */ isRecurring: function() {
            var comp = this.component;
            return comp.hasProperty("rrule") || comp.hasProperty("rdate");
        },
        /**
     * Checks if the event describes a recurrence exception. See
     * {@tutorial terminology} for details.
     *
     * @return {Boolean}    True, if the event describes a recurrence exception
     */ isRecurrenceException: function() {
            return this.component.hasProperty("recurrence-id");
        },
        /**
     * Returns the types of recurrences this event may have.
     *
     * Returned as an object with the following possible keys:
     *
     *    - YEARLY
     *    - MONTHLY
     *    - WEEKLY
     *    - DAILY
     *    - MINUTELY
     *    - SECONDLY
     *
     * @return {Object.<ICAL.Recur.frequencyValues, Boolean>}
     *          Object of recurrence flags
     */ getRecurrenceTypes: function() {
            var rules = this.component.getAllProperties("rrule");
            var i = 0;
            var len = rules.length;
            var result = Object.create(null);
            for(; i < len; i++){
                var value1 = rules[i].getFirstValue();
                result[value1.freq] = true;
            }
            return result;
        },
        /**
     * The uid of this event
     * @type {String}
     */ get uid () {
            return this._firstProp("uid");
        },
        set uid (value){
            this._setProp("uid", value);
        },
        /**
     * The start date
     * @type {ICAL.Time}
     */ get startDate () {
            return this._firstProp("dtstart");
        },
        set startDate (value){
            this._setTime("dtstart", value);
        },
        /**
     * The end date. This can be the result directly from the property, or the
     * end date calculated from start date and duration. Setting the property
     * will remove any duration properties.
     * @type {ICAL.Time}
     */ get endDate () {
            var endDate = this._firstProp("dtend");
            if (!endDate) {
                var duration = this._firstProp("duration");
                endDate = this.startDate.clone();
                if (duration) endDate.addDuration(duration);
                else if (endDate.isDate) endDate.day += 1;
            }
            return endDate;
        },
        set endDate (value){
            if (this.component.hasProperty("duration")) this.component.removeProperty("duration");
            this._setTime("dtend", value);
        },
        /**
     * The duration. This can be the result directly from the property, or the
     * duration calculated from start date and end date. Setting the property
     * will remove any `dtend` properties.
     * @type {ICAL.Duration}
     */ get duration () {
            var duration1 = this._firstProp("duration");
            if (!duration1) return this.endDate.subtractDateTz(this.startDate);
            return duration1;
        },
        set duration (value){
            if (this.component.hasProperty("dtend")) this.component.removeProperty("dtend");
            this._setProp("duration", value);
        },
        /**
     * The location of the event.
     * @type {String}
     */ get location () {
            return this._firstProp("location");
        },
        set location (value){
            return this._setProp("location", value);
        },
        /**
     * The attendees in the event
     * @type {ICAL.Property[]}
     * @readonly
     */ get attendees () {
            //XXX: This is way lame we should have a better
            //     data structure for this later.
            return this.component.getAllProperties("attendee");
        },
        /**
     * The event summary
     * @type {String}
     */ get summary () {
            return this._firstProp("summary");
        },
        set summary (value){
            this._setProp("summary", value);
        },
        /**
     * The event description.
     * @type {String}
     */ get description () {
            return this._firstProp("description");
        },
        set description (value){
            this._setProp("description", value);
        },
        /**
     * The event color from [rfc7986](https://datatracker.ietf.org/doc/html/rfc7986)
     * @type {String}
     */ get color () {
            return this._firstProp("color");
        },
        set color (value){
            this._setProp("color", value);
        },
        /**
     * The organizer value as an uri. In most cases this is a mailto: uri, but
     * it can also be something else, like urn:uuid:...
     * @type {String}
     */ get organizer () {
            return this._firstProp("organizer");
        },
        set organizer (value){
            this._setProp("organizer", value);
        },
        /**
     * The sequence value for this event. Used for scheduling
     * see {@tutorial terminology}.
     * @type {Number}
     */ get sequence () {
            return this._firstProp("sequence");
        },
        set sequence (value){
            this._setProp("sequence", value);
        },
        /**
     * The recurrence id for this event. See {@tutorial terminology} for details.
     * @type {ICAL.Time}
     */ get recurrenceId () {
            return this._firstProp("recurrence-id");
        },
        set recurrenceId (value){
            this._setTime("recurrence-id", value);
        },
        /**
     * Set/update a time property's value.
     * This will also update the TZID of the property.
     *
     * TODO: this method handles the case where we are switching
     * from a known timezone to an implied timezone (one without TZID).
     * This does _not_ handle the case of moving between a known
     *  (by TimezoneService) timezone to an unknown timezone...
     *
     * We will not add/remove/update the VTIMEZONE subcomponents
     *  leading to invalid ICAL data...
     * @private
     * @param {String} propName     The property name
     * @param {ICAL.Time} time      The time to set
     */ _setTime: function(propName, time) {
            var prop = this.component.getFirstProperty(propName);
            if (!prop) {
                prop = new $c854a69b4095b587$var$ICAL.Property(propName);
                this.component.addProperty(prop);
            }
            // utc and local don't get a tzid
            if (time.zone === $c854a69b4095b587$var$ICAL.Timezone.localTimezone || time.zone === $c854a69b4095b587$var$ICAL.Timezone.utcTimezone) // remove the tzid
            prop.removeParameter("tzid");
            else prop.setParameter("tzid", time.zone.tzid);
            prop.setValue(time);
        },
        _setProp: function(name, value1) {
            this.component.updatePropertyWithValue(name, value1);
        },
        _firstProp: function(name) {
            return this.component.getFirstPropertyValue(name);
        },
        /**
     * The string representation of this event.
     * @return {String}
     */ toString: function() {
            return this.component.toString();
        }
    };
    function compareRangeException(a, b) {
        if (a[0] > b[0]) return 1;
        if (b[0] > a[0]) return -1;
        return 0;
    }
    return Event;
}();
/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 * Portions Copyright (C) Philipp Kewisch, 2011-2015 */ /**
 * This symbol is further described later on
 * @ignore
 */ $c854a69b4095b587$var$ICAL.ComponentParser = function() {
    /**
   * @classdesc
   * The ComponentParser is used to process a String or jCal Object,
   * firing callbacks for various found components, as well as completion.
   *
   * @example
   * var options = {
   *   // when false no events will be emitted for type
   *   parseEvent: true,
   *   parseTimezone: true
   * };
   *
   * var parser = new ICAL.ComponentParser(options);
   *
   * parser.onevent(eventComponent) {
   *   //...
   * }
   *
   * // ontimezone, etc...
   *
   * parser.oncomplete = function() {
   *
   * };
   *
   * parser.process(stringOrComponent);
   *
   * @class
   * @alias ICAL.ComponentParser
   * @param {Object=} options        Component parser options
   * @param {Boolean} options.parseEvent        Whether events should be parsed
   * @param {Boolean} options.parseTimezeone    Whether timezones should be parsed
   */ function ComponentParser(options) {
        if (typeof options === "undefined") options = {};
        var key;
        for(key in options)/* istanbul ignore else */ if (options.hasOwnProperty(key)) this[key] = options[key];
    }
    ComponentParser.prototype = {
        /**
     * When true, parse events
     *
     * @type {Boolean}
     */ parseEvent: true,
        /**
     * When true, parse timezones
     *
     * @type {Boolean}
     */ parseTimezone: true,
        /* SAX like events here for reference */ /**
     * Fired when parsing is complete
     * @callback
     */ oncomplete: /* istanbul ignore next */ function() {},
        /**
     * Fired if an error occurs during parsing.
     *
     * @callback
     * @param {Error} err details of error
     */ onerror: /* istanbul ignore next */ function(err) {},
        /**
     * Fired when a top level component (VTIMEZONE) is found
     *
     * @callback
     * @param {ICAL.Timezone} component     Timezone object
     */ ontimezone: /* istanbul ignore next */ function(component) {},
        /**
     * Fired when a top level component (VEVENT) is found.
     *
     * @callback
     * @param {ICAL.Event} component    Top level component
     */ onevent: /* istanbul ignore next */ function(component) {},
        /**
     * Process a string or parse ical object.  This function itself will return
     * nothing but will start the parsing process.
     *
     * Events must be registered prior to calling this method.
     *
     * @param {ICAL.Component|String|Object} ical      The component to process,
     *        either in its final form, as a jCal Object, or string representation
     */ process: function(ical) {
            //TODO: this is sync now in the future we will have a incremental parser.
            if (typeof ical === "string") ical = $c854a69b4095b587$var$ICAL.parse(ical);
            if (!(ical instanceof $c854a69b4095b587$var$ICAL.Component)) ical = new $c854a69b4095b587$var$ICAL.Component(ical);
            var components = ical.getAllSubcomponents();
            var i = 0;
            var len = components.length;
            var component;
            for(; i < len; i++){
                component = components[i];
                switch(component.name){
                    case "vtimezone":
                        if (this.parseTimezone) {
                            var tzid = component.getFirstPropertyValue("tzid");
                            if (tzid) this.ontimezone(new $c854a69b4095b587$var$ICAL.Timezone({
                                tzid: tzid,
                                component: component
                            }));
                        }
                        break;
                    case "vevent":
                        if (this.parseEvent) this.onevent(new $c854a69b4095b587$var$ICAL.Event(component));
                        break;
                    default:
                        continue;
                }
            }
            //XXX: ideally we should do a "nextTick" here
            //     so in all cases this is actually async.
            this.oncomplete();
        }
    };
    return ComponentParser;
}();


/* eslint-disable */ class $a168f87f13e0ca2a$var$IcalExpander {
    constructor(opts){
        this.maxIterations = opts.maxIterations != null ? opts.maxIterations : 1000;
        this.skipInvalidDates = opts.skipInvalidDates != null ? opts.skipInvalidDates : false;
        this.jCalData = $c854a69b4095b587$exports.parse(opts.ics);
        this.component = new $c854a69b4095b587$exports.Component(this.jCalData);
        this.events = this.component.getAllSubcomponents("vevent").map((vevent)=>new $c854a69b4095b587$exports.Event(vevent));
        if (this.skipInvalidDates) this.events = this.events.filter((evt)=>{
            try {
                evt.startDate.toJSDate();
                evt.endDate.toJSDate();
                return true;
            } catch (err) {
                // skipping events with invalid time
                return false;
            }
        });
    }
    between(after, before) {
        function isEventWithinRange(startTime, endTime) {
            return (!after || endTime >= after.getTime()) && (!before || startTime <= before.getTime());
        }
        function getTimes(eventOrOccurrence) {
            const startTime = eventOrOccurrence.startDate.toJSDate().getTime();
            let endTime = eventOrOccurrence.endDate.toJSDate().getTime();
            // If it is an all day event, the end date is set to 00:00 of the next day
            // So we need to make it be 23:59:59 to compare correctly with the given range
            if (eventOrOccurrence.endDate.isDate && endTime > startTime) endTime -= 1;
            return {
                startTime: startTime,
                endTime: endTime
            };
        }
        const exceptions = [];
        this.events.forEach((event)=>{
            if (event.isRecurrenceException()) exceptions.push(event);
        });
        const ret = {
            events: [],
            occurrences: []
        };
        this.events.filter((e)=>!e.isRecurrenceException()).forEach((event)=>{
            const exdates = [];
            event.component.getAllProperties("exdate").forEach((exdateProp)=>{
                const exdate = exdateProp.getFirstValue();
                exdates.push(exdate.toJSDate().getTime());
            });
            // Recurring event is handled differently
            if (event.isRecurring()) {
                const iterator = event.iterator();
                let next;
                let i = 0;
                do {
                    i += 1;
                    next = iterator.next();
                    if (next) {
                        const occurrence = event.getOccurrenceDetails(next);
                        const { startTime: startTime, endTime: endTime } = getTimes(occurrence);
                        const isOccurrenceExcluded = exdates.indexOf(startTime) !== -1;
                        // TODO check that within same day?
                        const exception = exceptions.find((ex)=>ex.uid === event.uid && ex.recurrenceId.toJSDate().getTime() === occurrence.startDate.toJSDate().getTime());
                        // We have passed the max date, stop
                        if (before && startTime > before.getTime()) break;
                        // Check that we are within our range
                        if (isEventWithinRange(startTime, endTime)) {
                            if (exception) ret.events.push(exception);
                            else if (!isOccurrenceExcluded) ret.occurrences.push(occurrence);
                        }
                    }
                }while (next && (!this.maxIterations || i < this.maxIterations));
                return;
            }
            // Non-recurring event:
            const { startTime: startTime, endTime: endTime } = getTimes(event);
            if (isEventWithinRange(startTime, endTime)) ret.events.push(event);
        });
        return ret;
    }
    before(before) {
        return this.between(undefined, before);
    }
    after(after) {
        return this.between(after);
    }
    all() {
        return this.between();
    }
}
const $a168f87f13e0ca2a$var$eventSourceDef = {
    parseMeta (refined) {
        if (refined.url && refined.format === "ics") return {
            url: refined.url,
            format: "ics"
        };
        return null;
    },
    fetch (arg, successCallback, errorCallback) {
        let meta = arg.eventSource.meta;
        let { internalState: internalState } = meta;
        /*
        NOTE: isRefetch is a HACK. we would do the recurring-expanding in a separate plugin hook,
        but we couldn't leverage built-in allDay-guessing, among other things.
        */ if (!internalState || arg.isRefetch) internalState = meta.internalState = {
            response: null,
            iCalExpanderPromise: fetch(meta.url, {
                method: "GET"
            }).then((response)=>{
                return response.text().then((icsText)=>{
                    internalState.response = response;
                    return new $a168f87f13e0ca2a$var$IcalExpander({
                        ics: icsText,
                        skipInvalidDates: true
                    });
                });
            })
        };
        internalState.iCalExpanderPromise.then((iCalExpander)=>{
            successCallback({
                rawEvents: $a168f87f13e0ca2a$var$expandICalEvents(iCalExpander, arg.range),
                response: internalState.response
            });
        }, errorCallback);
    }
};
function $a168f87f13e0ca2a$var$expandICalEvents(iCalExpander, range) {
    // expand the range. because our `range` is timeZone-agnostic UTC
    // or maybe because ical.js always produces dates in local time? i forget
    let rangeStart = (0, $5913100b2ed0f596$export$625550452a3fa3ec)(range.start, -1);
    let rangeEnd = (0, $5913100b2ed0f596$export$625550452a3fa3ec)(range.end, 1);
    let iCalRes = iCalExpander.between(rangeStart, rangeEnd); // end inclusive. will give extra results
    let expanded = [];
    // TODO: instead of using startDate/endDate.toString to communicate allDay,
    // we can query startDate/endDate.isDate. More efficient to avoid formatting/reparsing.
    // single events
    for (let iCalEvent of iCalRes.events)expanded.push(Object.assign(Object.assign({}, $a168f87f13e0ca2a$var$buildNonDateProps(iCalEvent)), {
        start: iCalEvent.startDate.toString(),
        end: $a168f87f13e0ca2a$var$specifiesEnd(iCalEvent) && iCalEvent.endDate ? iCalEvent.endDate.toString() : null
    }));
    // recurring event instances
    for (let iCalOccurence of iCalRes.occurrences){
        let iCalEvent = iCalOccurence.item;
        expanded.push(Object.assign(Object.assign({}, $a168f87f13e0ca2a$var$buildNonDateProps(iCalEvent)), {
            start: iCalOccurence.startDate.toString(),
            end: $a168f87f13e0ca2a$var$specifiesEnd(iCalEvent) && iCalOccurence.endDate ? iCalOccurence.endDate.toString() : null
        }));
    }
    return expanded;
}
function $a168f87f13e0ca2a$var$buildNonDateProps(iCalEvent) {
    return {
        title: iCalEvent.summary,
        url: $a168f87f13e0ca2a$var$extractEventUrl(iCalEvent),
        extendedProps: {
            location: iCalEvent.location,
            organizer: iCalEvent.organizer,
            description: iCalEvent.description
        }
    };
}
function $a168f87f13e0ca2a$var$extractEventUrl(iCalEvent) {
    let urlProp = iCalEvent.component.getFirstProperty("url");
    return urlProp ? urlProp.getFirstValue() : "";
}
function $a168f87f13e0ca2a$var$specifiesEnd(iCalEvent) {
    return Boolean(iCalEvent.component.getFirstProperty("dtend")) || Boolean(iCalEvent.component.getFirstProperty("duration"));
}
var $a168f87f13e0ca2a$export$2e2bcd8739ae039 = (0, $641adb510ed163e1$export$ae829ec7b2625219)({
    name: "@fullcalendar/icalendar",
    eventSourceDefs: [
        $a168f87f13e0ca2a$var$eventSourceDef
    ]
});





/* An abstract class for the daygrid views, as well as month view. Renders one or more rows of day cells.
----------------------------------------------------------------------------------------------------------------------*/ // It is a manager for a Table subcomponent, which does most of the heavy lifting.
// It is responsible for managing width/height.
class $19ee8ec6199ec2ec$export$b3c27e869d856b7 extends (0, $5913100b2ed0f596$export$51b138e5a065c2bb) {
    constructor(){
        super(...arguments);
        this.headerElRef = (0, $450fc775b2f7950e$export$7d1e3a5e95ceca43)();
    }
    renderSimpleLayout(headerRowContent, bodyContent) {
        let { props: props, context: context } = this;
        let sections = [];
        let stickyHeaderDates = (0, $5913100b2ed0f596$export$a1edd97dd51cd48d)(context.options);
        if (headerRowContent) sections.push({
            type: "header",
            key: "header",
            isSticky: stickyHeaderDates,
            chunk: {
                elRef: this.headerElRef,
                tableClassName: "fc-col-header",
                rowContent: headerRowContent
            }
        });
        sections.push({
            type: "body",
            key: "body",
            liquid: true,
            chunk: {
                content: bodyContent
            }
        });
        return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)((0, $5913100b2ed0f596$export$e9316ff9106cdb75), {
            elClasses: [
                "fc-daygrid"
            ],
            viewSpec: context.viewSpec
        }, (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)((0, $5913100b2ed0f596$export$add49c223b9ce4ea), {
            liquid: !props.isHeightAuto && !props.forPrint,
            collapsibleWidth: props.forPrint,
            cols: [],
            sections: sections
        }));
    }
    renderHScrollLayout(headerRowContent, bodyContent, colCnt, dayMinWidth) {
        let ScrollGrid = this.context.pluginHooks.scrollGridImpl;
        if (!ScrollGrid) throw new Error("No ScrollGrid implementation");
        let { props: props, context: context } = this;
        let stickyHeaderDates = !props.forPrint && (0, $5913100b2ed0f596$export$a1edd97dd51cd48d)(context.options);
        let stickyFooterScrollbar = !props.forPrint && (0, $5913100b2ed0f596$export$54c4fabc2291e9c0)(context.options);
        let sections = [];
        if (headerRowContent) sections.push({
            type: "header",
            key: "header",
            isSticky: stickyHeaderDates,
            chunks: [
                {
                    key: "main",
                    elRef: this.headerElRef,
                    tableClassName: "fc-col-header",
                    rowContent: headerRowContent
                }
            ]
        });
        sections.push({
            type: "body",
            key: "body",
            liquid: true,
            chunks: [
                {
                    key: "main",
                    content: bodyContent
                }
            ]
        });
        if (stickyFooterScrollbar) sections.push({
            type: "footer",
            key: "footer",
            isSticky: true,
            chunks: [
                {
                    key: "main",
                    content: (0, $5913100b2ed0f596$export$89e9012e902952b6)
                }
            ]
        });
        return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)((0, $5913100b2ed0f596$export$e9316ff9106cdb75), {
            elClasses: [
                "fc-daygrid"
            ],
            viewSpec: context.viewSpec
        }, (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)(ScrollGrid, {
            liquid: !props.isHeightAuto && !props.forPrint,
            forPrint: props.forPrint,
            collapsibleWidth: props.forPrint,
            colGroups: [
                {
                    cols: [
                        {
                            span: colCnt,
                            minWidth: dayMinWidth
                        }
                    ]
                }
            ],
            sections: sections
        }));
    }
}
function $19ee8ec6199ec2ec$var$splitSegsByRow(segs, rowCnt) {
    let byRow = [];
    for(let i = 0; i < rowCnt; i += 1)byRow[i] = [];
    for (let seg of segs)byRow[seg.row].push(seg);
    return byRow;
}
function $19ee8ec6199ec2ec$var$splitSegsByFirstCol(segs, colCnt) {
    let byCol = [];
    for(let i = 0; i < colCnt; i += 1)byCol[i] = [];
    for (let seg of segs)byCol[seg.firstCol].push(seg);
    return byCol;
}
function $19ee8ec6199ec2ec$var$splitInteractionByRow(ui, rowCnt) {
    let byRow = [];
    if (!ui) for(let i = 0; i < rowCnt; i += 1)byRow[i] = null;
    else {
        for(let i = 0; i < rowCnt; i += 1)byRow[i] = {
            affectedInstances: ui.affectedInstances,
            isEvent: ui.isEvent,
            segs: []
        };
        for (let seg of ui.segs)byRow[seg.row].segs.push(seg);
    }
    return byRow;
}
const $19ee8ec6199ec2ec$var$DEFAULT_TABLE_EVENT_TIME_FORMAT = (0, $5913100b2ed0f596$export$d141bba7fdc215a3)({
    hour: "numeric",
    minute: "2-digit",
    omitZeroMinute: true,
    meridiem: "narrow"
});
function $19ee8ec6199ec2ec$var$hasListItemDisplay(seg) {
    let { display: display } = seg.eventRange.ui;
    return display === "list-item" || display === "auto" && !seg.eventRange.def.allDay && seg.firstCol === seg.lastCol && // can't be multi-day
    seg.isStart && // "
    seg.isEnd // "
    ;
}
class $19ee8ec6199ec2ec$var$TableBlockEvent extends (0, $5913100b2ed0f596$export$ef35774e6d314e91) {
    render() {
        let { props: props } = this;
        return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)((0, $5913100b2ed0f596$export$d92db8a7dc823bb0), Object.assign({}, props, {
            elClasses: [
                "fc-daygrid-event",
                "fc-daygrid-block-event",
                "fc-h-event"
            ],
            defaultTimeFormat: $19ee8ec6199ec2ec$var$DEFAULT_TABLE_EVENT_TIME_FORMAT,
            defaultDisplayEventEnd: props.defaultDisplayEventEnd,
            disableResizing: !props.seg.eventRange.def.allDay
        }));
    }
}
class $19ee8ec6199ec2ec$var$TableListItemEvent extends (0, $5913100b2ed0f596$export$ef35774e6d314e91) {
    render() {
        let { props: props, context: context } = this;
        let { options: options } = context;
        let { seg: seg } = props;
        let timeFormat = options.eventTimeFormat || $19ee8ec6199ec2ec$var$DEFAULT_TABLE_EVENT_TIME_FORMAT;
        let timeText = (0, $5913100b2ed0f596$export$993a080e5cb62d74)(seg, timeFormat, context, true, props.defaultDisplayEventEnd);
        return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)((0, $5913100b2ed0f596$export$1343a74baacb0543), Object.assign({}, props, {
            elTag: "a",
            elClasses: [
                "fc-daygrid-event",
                "fc-daygrid-dot-event"
            ],
            elAttrs: (0, $5913100b2ed0f596$export$e0c3a065614c6254)(props.seg, context),
            defaultGenerator: $19ee8ec6199ec2ec$var$renderInnerContent,
            timeText: timeText,
            isResizing: false,
            isDateSelecting: false
        }));
    }
}
function $19ee8ec6199ec2ec$var$renderInnerContent(renderProps) {
    return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)((0, $450fc775b2f7950e$export$ffb0004e005737fa), null, (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("div", {
        className: "fc-daygrid-event-dot",
        style: {
            borderColor: renderProps.borderColor || renderProps.backgroundColor
        }
    }), renderProps.timeText && (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("div", {
        className: "fc-event-time"
    }, renderProps.timeText), (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("div", {
        className: "fc-event-title"
    }, renderProps.event.title || (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)((0, $450fc775b2f7950e$export$ffb0004e005737fa), null, "\xa0")));
}
class $19ee8ec6199ec2ec$var$TableCellMoreLink extends (0, $5913100b2ed0f596$export$ef35774e6d314e91) {
    constructor(){
        super(...arguments);
        this.compileSegs = (0, $5913100b2ed0f596$export$df995fae86a55f06)($19ee8ec6199ec2ec$var$compileSegs);
    }
    render() {
        let { props: props } = this;
        let { allSegs: allSegs, invisibleSegs: invisibleSegs } = this.compileSegs(props.singlePlacements);
        return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)((0, $5913100b2ed0f596$export$cbfbec548517f2b6), {
            elClasses: [
                "fc-daygrid-more-link"
            ],
            dateProfile: props.dateProfile,
            todayRange: props.todayRange,
            allDayDate: props.allDayDate,
            moreCnt: props.moreCnt,
            allSegs: allSegs,
            hiddenSegs: invisibleSegs,
            alignmentElRef: props.alignmentElRef,
            alignGridTop: props.alignGridTop,
            extraDateSpan: props.extraDateSpan,
            popoverContent: ()=>{
                let isForcedInvisible = (props.eventDrag ? props.eventDrag.affectedInstances : null) || (props.eventResize ? props.eventResize.affectedInstances : null) || {};
                return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)((0, $450fc775b2f7950e$export$ffb0004e005737fa), null, allSegs.map((seg)=>{
                    let instanceId = seg.eventRange.instance.instanceId;
                    return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("div", {
                        className: "fc-daygrid-event-harness",
                        key: instanceId,
                        style: {
                            visibility: isForcedInvisible[instanceId] ? "hidden" : ""
                        }
                    }, $19ee8ec6199ec2ec$var$hasListItemDisplay(seg) ? (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)($19ee8ec6199ec2ec$var$TableListItemEvent, Object.assign({
                        seg: seg,
                        isDragging: false,
                        isSelected: instanceId === props.eventSelection,
                        defaultDisplayEventEnd: false
                    }, (0, $5913100b2ed0f596$export$6dabbe08653f866f)(seg, props.todayRange))) : (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)($19ee8ec6199ec2ec$var$TableBlockEvent, Object.assign({
                        seg: seg,
                        isDragging: false,
                        isResizing: false,
                        isDateSelecting: false,
                        isSelected: instanceId === props.eventSelection,
                        defaultDisplayEventEnd: false
                    }, (0, $5913100b2ed0f596$export$6dabbe08653f866f)(seg, props.todayRange))));
                }));
            }
        });
    }
}
function $19ee8ec6199ec2ec$var$compileSegs(singlePlacements) {
    let allSegs = [];
    let invisibleSegs = [];
    for (let placement of singlePlacements){
        allSegs.push(placement.seg);
        if (!placement.isVisible) invisibleSegs.push(placement.seg);
    }
    return {
        allSegs: allSegs,
        invisibleSegs: invisibleSegs
    };
}
const $19ee8ec6199ec2ec$var$DEFAULT_WEEK_NUM_FORMAT = (0, $5913100b2ed0f596$export$d141bba7fdc215a3)({
    week: "narrow"
});
class $19ee8ec6199ec2ec$var$TableCell extends (0, $5913100b2ed0f596$export$51b138e5a065c2bb) {
    constructor(){
        super(...arguments);
        this.rootElRef = (0, $450fc775b2f7950e$export$7d1e3a5e95ceca43)();
        this.state = {
            dayNumberId: (0, $5913100b2ed0f596$export$a8550f7dbe79f93a)()
        };
        this.handleRootEl = (el)=>{
            (0, $5913100b2ed0f596$export$8743009a87fcb00f)(this.rootElRef, el);
            (0, $5913100b2ed0f596$export$8743009a87fcb00f)(this.props.elRef, el);
        };
    }
    render() {
        let { context: context, props: props, state: state, rootElRef: rootElRef } = this;
        let { options: options, dateEnv: dateEnv } = context;
        let { date: date, dateProfile: dateProfile } = props;
        // TODO: memoize this?
        const isMonthStart = props.showDayNumber && $19ee8ec6199ec2ec$var$shouldDisplayMonthStart(date, dateProfile.currentRange, dateEnv);
        return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)((0, $5913100b2ed0f596$export$b975d55abac2bbe3), {
            elTag: "td",
            elRef: this.handleRootEl,
            elClasses: [
                "fc-daygrid-day",
                ...props.extraClassNames || []
            ],
            elAttrs: Object.assign(Object.assign(Object.assign({}, props.extraDataAttrs), props.showDayNumber ? {
                "aria-labelledby": state.dayNumberId
            } : {}), {
                role: "gridcell"
            }),
            defaultGenerator: $19ee8ec6199ec2ec$var$renderTopInner,
            date: date,
            dateProfile: dateProfile,
            todayRange: props.todayRange,
            showDayNumber: props.showDayNumber,
            isMonthStart: isMonthStart,
            extraRenderProps: props.extraRenderProps
        }, (InnerContent, renderProps)=>(0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("div", {
                ref: props.innerElRef,
                className: "fc-daygrid-day-frame fc-scrollgrid-sync-inner",
                style: {
                    minHeight: props.minHeight
                }
            }, props.showWeekNumber && (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)((0, $5913100b2ed0f596$export$a3c9165b94390bcd), {
                elTag: "a",
                elClasses: [
                    "fc-daygrid-week-number"
                ],
                elAttrs: (0, $5913100b2ed0f596$export$8c78c7c36408ea29)(context, date, "week"),
                date: date,
                defaultFormat: $19ee8ec6199ec2ec$var$DEFAULT_WEEK_NUM_FORMAT
            }), !renderProps.isDisabled && (props.showDayNumber || (0, $5913100b2ed0f596$export$b02498c06ddfef28)(options) || props.forceDayTop) ? (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("div", {
                className: "fc-daygrid-day-top"
            }, (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)(InnerContent, {
                elTag: "a",
                elClasses: [
                    "fc-daygrid-day-number",
                    isMonthStart && "fc-daygrid-month-start"
                ],
                elAttrs: Object.assign(Object.assign({}, (0, $5913100b2ed0f596$export$8c78c7c36408ea29)(context, date)), {
                    id: state.dayNumberId
                })
            })) : props.showDayNumber ? // for creating correct amount of space (see issue #7162)
            (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("div", {
                className: "fc-daygrid-day-top",
                style: {
                    visibility: "hidden"
                }
            }, (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("a", {
                className: "fc-daygrid-day-number"
            }, "\xa0")) : undefined, (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("div", {
                className: "fc-daygrid-day-events",
                ref: props.fgContentElRef
            }, props.fgContent, (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("div", {
                className: "fc-daygrid-day-bottom",
                style: {
                    marginTop: props.moreMarginTop
                }
            }, (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)($19ee8ec6199ec2ec$var$TableCellMoreLink, {
                allDayDate: date,
                singlePlacements: props.singlePlacements,
                moreCnt: props.moreCnt,
                alignmentElRef: rootElRef,
                alignGridTop: !props.showDayNumber,
                extraDateSpan: props.extraDateSpan,
                dateProfile: props.dateProfile,
                eventSelection: props.eventSelection,
                eventDrag: props.eventDrag,
                eventResize: props.eventResize,
                todayRange: props.todayRange
            }))), (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("div", {
                className: "fc-daygrid-day-bg"
            }, props.bgContent)));
    }
}
function $19ee8ec6199ec2ec$var$renderTopInner(props) {
    return props.dayNumberText || (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)((0, $450fc775b2f7950e$export$ffb0004e005737fa), null, "\xa0");
}
function $19ee8ec6199ec2ec$var$shouldDisplayMonthStart(date, currentRange, dateEnv) {
    const { start: currentStart, end: currentEnd } = currentRange;
    const currentEndIncl = (0, $5913100b2ed0f596$export$136fd86de524d3c2)(currentEnd, -1);
    const currentFirstYear = dateEnv.getYear(currentStart);
    const currentFirstMonth = dateEnv.getMonth(currentStart);
    const currentLastYear = dateEnv.getYear(currentEndIncl);
    const currentLastMonth = dateEnv.getMonth(currentEndIncl);
    // spans more than one month?
    return !(currentFirstYear === currentLastYear && currentFirstMonth === currentLastMonth) && Boolean(// first date in current view?
    date.valueOf() === currentStart.valueOf() || // a month-start that's within the current range?
    dateEnv.getDay(date) === 1 && date.valueOf() < currentEnd.valueOf());
}
function $19ee8ec6199ec2ec$var$generateSegKey(seg) {
    return seg.eventRange.instance.instanceId + ":" + seg.firstCol;
}
function $19ee8ec6199ec2ec$var$generateSegUid(seg) {
    return $19ee8ec6199ec2ec$var$generateSegKey(seg) + ":" + seg.lastCol;
}
function $19ee8ec6199ec2ec$var$computeFgSegPlacement(segs, dayMaxEvents, dayMaxEventRows, strictOrder, segHeights, maxContentHeight, cells) {
    let hierarchy = new $19ee8ec6199ec2ec$var$DayGridSegHierarchy((segEntry)=>{
        // TODO: more DRY with generateSegUid
        let segUid = segs[segEntry.index].eventRange.instance.instanceId + ":" + segEntry.span.start + ":" + (segEntry.span.end - 1);
        // if no thickness known, assume 1 (if 0, so small it always fits)
        return segHeights[segUid] || 1;
    });
    hierarchy.allowReslicing = true;
    hierarchy.strictOrder = strictOrder;
    if (dayMaxEvents === true || dayMaxEventRows === true) {
        hierarchy.maxCoord = maxContentHeight;
        hierarchy.hiddenConsumes = true;
    } else if (typeof dayMaxEvents === "number") hierarchy.maxStackCnt = dayMaxEvents;
    else if (typeof dayMaxEventRows === "number") {
        hierarchy.maxStackCnt = dayMaxEventRows;
        hierarchy.hiddenConsumes = true;
    }
    // create segInputs only for segs with known heights
    let segInputs = [];
    let unknownHeightSegs = [];
    for(let i = 0; i < segs.length; i += 1){
        let seg = segs[i];
        let segUid = $19ee8ec6199ec2ec$var$generateSegUid(seg);
        let eventHeight = segHeights[segUid];
        if (eventHeight != null) segInputs.push({
            index: i,
            span: {
                start: seg.firstCol,
                end: seg.lastCol + 1
            }
        });
        else unknownHeightSegs.push(seg);
    }
    let hiddenEntries = hierarchy.addSegs(segInputs);
    let segRects = hierarchy.toRects();
    let { singleColPlacements: singleColPlacements, multiColPlacements: multiColPlacements, leftoverMargins: leftoverMargins } = $19ee8ec6199ec2ec$var$placeRects(segRects, segs, cells);
    let moreCnts = [];
    let moreMarginTops = [];
    // add segs with unknown heights
    for (let seg of unknownHeightSegs){
        multiColPlacements[seg.firstCol].push({
            seg: seg,
            isVisible: false,
            isAbsolute: true,
            absoluteTop: 0,
            marginTop: 0
        });
        for(let col = seg.firstCol; col <= seg.lastCol; col += 1)singleColPlacements[col].push({
            seg: $19ee8ec6199ec2ec$var$resliceSeg(seg, col, col + 1, cells),
            isVisible: false,
            isAbsolute: false,
            absoluteTop: 0,
            marginTop: 0
        });
    }
    // add the hidden entries
    for(let col = 0; col < cells.length; col += 1)moreCnts.push(0);
    for (let hiddenEntry of hiddenEntries){
        let seg = segs[hiddenEntry.index];
        let hiddenSpan = hiddenEntry.span;
        multiColPlacements[hiddenSpan.start].push({
            seg: $19ee8ec6199ec2ec$var$resliceSeg(seg, hiddenSpan.start, hiddenSpan.end, cells),
            isVisible: false,
            isAbsolute: true,
            absoluteTop: 0,
            marginTop: 0
        });
        for(let col = hiddenSpan.start; col < hiddenSpan.end; col += 1){
            moreCnts[col] += 1;
            singleColPlacements[col].push({
                seg: $19ee8ec6199ec2ec$var$resliceSeg(seg, col, col + 1, cells),
                isVisible: false,
                isAbsolute: false,
                absoluteTop: 0,
                marginTop: 0
            });
        }
    }
    // deal with leftover margins
    for(let col = 0; col < cells.length; col += 1)moreMarginTops.push(leftoverMargins[col]);
    return {
        singleColPlacements: singleColPlacements,
        multiColPlacements: multiColPlacements,
        moreCnts: moreCnts,
        moreMarginTops: moreMarginTops
    };
}
// rects ordered by top coord, then left
function $19ee8ec6199ec2ec$var$placeRects(allRects, segs, cells) {
    let rectsByEachCol = $19ee8ec6199ec2ec$var$groupRectsByEachCol(allRects, cells.length);
    let singleColPlacements = [];
    let multiColPlacements = [];
    let leftoverMargins = [];
    for(let col = 0; col < cells.length; col += 1){
        let rects = rectsByEachCol[col];
        // compute all static segs in singlePlacements
        let singlePlacements = [];
        let currentHeight = 0;
        let currentMarginTop = 0;
        for (let rect of rects){
            let seg = segs[rect.index];
            singlePlacements.push({
                seg: $19ee8ec6199ec2ec$var$resliceSeg(seg, col, col + 1, cells),
                isVisible: true,
                isAbsolute: false,
                absoluteTop: rect.levelCoord,
                marginTop: rect.levelCoord - currentHeight
            });
            currentHeight = rect.levelCoord + rect.thickness;
        }
        // compute mixed static/absolute segs in multiPlacements
        let multiPlacements = [];
        currentHeight = 0;
        currentMarginTop = 0;
        for (let rect of rects){
            let seg = segs[rect.index];
            let isAbsolute = rect.span.end - rect.span.start > 1; // multi-column?
            let isFirstCol = rect.span.start === col;
            currentMarginTop += rect.levelCoord - currentHeight; // amount of space since bottom of previous seg
            currentHeight = rect.levelCoord + rect.thickness; // height will now be bottom of current seg
            if (isAbsolute) {
                currentMarginTop += rect.thickness;
                if (isFirstCol) multiPlacements.push({
                    seg: $19ee8ec6199ec2ec$var$resliceSeg(seg, rect.span.start, rect.span.end, cells),
                    isVisible: true,
                    isAbsolute: true,
                    absoluteTop: rect.levelCoord,
                    marginTop: 0
                });
            } else if (isFirstCol) {
                multiPlacements.push({
                    seg: $19ee8ec6199ec2ec$var$resliceSeg(seg, rect.span.start, rect.span.end, cells),
                    isVisible: true,
                    isAbsolute: false,
                    absoluteTop: rect.levelCoord,
                    marginTop: currentMarginTop
                });
                currentMarginTop = 0;
            }
        }
        singleColPlacements.push(singlePlacements);
        multiColPlacements.push(multiPlacements);
        leftoverMargins.push(currentMarginTop);
    }
    return {
        singleColPlacements: singleColPlacements,
        multiColPlacements: multiColPlacements,
        leftoverMargins: leftoverMargins
    };
}
function $19ee8ec6199ec2ec$var$groupRectsByEachCol(rects, colCnt) {
    let rectsByEachCol = [];
    for(let col = 0; col < colCnt; col += 1)rectsByEachCol.push([]);
    for (let rect of rects)for(let col = rect.span.start; col < rect.span.end; col += 1)rectsByEachCol[col].push(rect);
    return rectsByEachCol;
}
function $19ee8ec6199ec2ec$var$resliceSeg(seg, spanStart, spanEnd, cells) {
    if (seg.firstCol === spanStart && seg.lastCol === spanEnd - 1) return seg;
    let eventRange = seg.eventRange;
    let origRange = eventRange.range;
    let slicedRange = (0, $5913100b2ed0f596$export$ae1af26003f05816)(origRange, {
        start: cells[spanStart].date,
        end: (0, $5913100b2ed0f596$export$625550452a3fa3ec)(cells[spanEnd - 1].date, 1)
    });
    return Object.assign(Object.assign({}, seg), {
        firstCol: spanStart,
        lastCol: spanEnd - 1,
        eventRange: {
            def: eventRange.def,
            ui: Object.assign(Object.assign({}, eventRange.ui), {
                durationEditable: false
            }),
            instance: eventRange.instance,
            range: slicedRange
        },
        isStart: seg.isStart && slicedRange.start.valueOf() === origRange.start.valueOf(),
        isEnd: seg.isEnd && slicedRange.end.valueOf() === origRange.end.valueOf()
    });
}
class $19ee8ec6199ec2ec$var$DayGridSegHierarchy extends (0, $5913100b2ed0f596$export$2e63b696b2c9441b) {
    constructor(){
        super(...arguments);
        // config
        this.hiddenConsumes = false;
        // allows us to keep hidden entries in the hierarchy so they take up space
        this.forceHidden = {};
    }
    addSegs(segInputs) {
        const hiddenSegs = super.addSegs(segInputs);
        const { entriesByLevel: entriesByLevel } = this;
        const excludeHidden = (entry)=>!this.forceHidden[(0, $5913100b2ed0f596$export$eb84e45a33f6ba7c)(entry)];
        // remove the forced-hidden segs
        for(let level = 0; level < entriesByLevel.length; level += 1)entriesByLevel[level] = entriesByLevel[level].filter(excludeHidden);
        return hiddenSegs;
    }
    handleInvalidInsertion(insertion, entry, hiddenEntries) {
        const { entriesByLevel: entriesByLevel, forceHidden: forceHidden } = this;
        const { touchingEntry: touchingEntry, touchingLevel: touchingLevel, touchingLateral: touchingLateral } = insertion;
        // the entry that the new insertion is touching must be hidden
        if (this.hiddenConsumes && touchingEntry) {
            const touchingEntryId = (0, $5913100b2ed0f596$export$eb84e45a33f6ba7c)(touchingEntry);
            if (!forceHidden[touchingEntryId]) {
                if (this.allowReslicing) {
                    // split up the touchingEntry, reinsert it
                    const hiddenEntry = Object.assign(Object.assign({}, touchingEntry), {
                        span: (0, $5913100b2ed0f596$export$b2bcef12bcefba04)(touchingEntry.span, entry.span)
                    });
                    // reinsert the area that turned into a "more" link (so no other entries try to
                    // occupy the space) but mark it forced-hidden
                    const hiddenEntryId = (0, $5913100b2ed0f596$export$eb84e45a33f6ba7c)(hiddenEntry);
                    forceHidden[hiddenEntryId] = true;
                    entriesByLevel[touchingLevel][touchingLateral] = hiddenEntry;
                    hiddenEntries.push(hiddenEntry);
                    this.splitEntry(touchingEntry, entry, hiddenEntries);
                } else {
                    forceHidden[touchingEntryId] = true;
                    hiddenEntries.push(touchingEntry);
                }
            }
        }
        // will try to reslice...
        super.handleInvalidInsertion(insertion, entry, hiddenEntries);
    }
}
class $19ee8ec6199ec2ec$var$TableRow extends (0, $5913100b2ed0f596$export$51b138e5a065c2bb) {
    constructor(){
        super(...arguments);
        this.cellElRefs = new (0, $5913100b2ed0f596$export$49e6ee724f7f1ace)(); // the <td>
        this.frameElRefs = new (0, $5913100b2ed0f596$export$49e6ee724f7f1ace)(); // the fc-daygrid-day-frame
        this.fgElRefs = new (0, $5913100b2ed0f596$export$49e6ee724f7f1ace)(); // the fc-daygrid-day-events
        this.segHarnessRefs = new (0, $5913100b2ed0f596$export$49e6ee724f7f1ace)(); // indexed by "instanceId:firstCol"
        this.rootElRef = (0, $450fc775b2f7950e$export$7d1e3a5e95ceca43)();
        this.state = {
            framePositions: null,
            maxContentHeight: null,
            segHeights: {}
        };
        this.handleResize = (isForced)=>{
            if (isForced) this.updateSizing(true); // isExternal=true
        };
    }
    render() {
        let { props: props, state: state, context: context } = this;
        let { options: options } = context;
        let colCnt = props.cells.length;
        let businessHoursByCol = $19ee8ec6199ec2ec$var$splitSegsByFirstCol(props.businessHourSegs, colCnt);
        let bgEventSegsByCol = $19ee8ec6199ec2ec$var$splitSegsByFirstCol(props.bgEventSegs, colCnt);
        let highlightSegsByCol = $19ee8ec6199ec2ec$var$splitSegsByFirstCol(this.getHighlightSegs(), colCnt);
        let mirrorSegsByCol = $19ee8ec6199ec2ec$var$splitSegsByFirstCol(this.getMirrorSegs(), colCnt);
        let { singleColPlacements: singleColPlacements, multiColPlacements: multiColPlacements, moreCnts: moreCnts, moreMarginTops: moreMarginTops } = $19ee8ec6199ec2ec$var$computeFgSegPlacement((0, $5913100b2ed0f596$export$4d522598b426bb73)(props.fgEventSegs, options.eventOrder), props.dayMaxEvents, props.dayMaxEventRows, options.eventOrderStrict, state.segHeights, state.maxContentHeight, props.cells);
        let isForcedInvisible = props.eventDrag && props.eventDrag.affectedInstances || props.eventResize && props.eventResize.affectedInstances || {};
        return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("tr", {
            ref: this.rootElRef,
            role: "row"
        }, props.renderIntro && props.renderIntro(), props.cells.map((cell, col)=>{
            let normalFgNodes = this.renderFgSegs(col, props.forPrint ? singleColPlacements[col] : multiColPlacements[col], props.todayRange, isForcedInvisible);
            let mirrorFgNodes = this.renderFgSegs(col, $19ee8ec6199ec2ec$var$buildMirrorPlacements(mirrorSegsByCol[col], multiColPlacements), props.todayRange, {}, Boolean(props.eventDrag), Boolean(props.eventResize), false);
            return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)($19ee8ec6199ec2ec$var$TableCell, {
                key: cell.key,
                elRef: this.cellElRefs.createRef(cell.key),
                innerElRef: this.frameElRefs.createRef(cell.key),
                dateProfile: props.dateProfile,
                date: cell.date,
                showDayNumber: props.showDayNumbers,
                showWeekNumber: props.showWeekNumbers && col === 0,
                forceDayTop: props.showWeekNumbers /* even displaying weeknum for row, not necessarily day */ ,
                todayRange: props.todayRange,
                eventSelection: props.eventSelection,
                eventDrag: props.eventDrag,
                eventResize: props.eventResize,
                extraRenderProps: cell.extraRenderProps,
                extraDataAttrs: cell.extraDataAttrs,
                extraClassNames: cell.extraClassNames,
                extraDateSpan: cell.extraDateSpan,
                moreCnt: moreCnts[col],
                moreMarginTop: moreMarginTops[col],
                singlePlacements: singleColPlacements[col],
                fgContentElRef: this.fgElRefs.createRef(cell.key),
                fgContent: (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)((0, $450fc775b2f7950e$export$ffb0004e005737fa), null, (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)((0, $450fc775b2f7950e$export$ffb0004e005737fa), null, normalFgNodes), (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)((0, $450fc775b2f7950e$export$ffb0004e005737fa), null, mirrorFgNodes)),
                bgContent: (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)((0, $450fc775b2f7950e$export$ffb0004e005737fa), null, this.renderFillSegs(highlightSegsByCol[col], "highlight"), this.renderFillSegs(businessHoursByCol[col], "non-business"), this.renderFillSegs(bgEventSegsByCol[col], "bg-event")),
                minHeight: props.cellMinHeight
            });
        }));
    }
    componentDidMount() {
        this.updateSizing(true);
        this.context.addResizeHandler(this.handleResize);
    }
    componentDidUpdate(prevProps, prevState) {
        let currentProps = this.props;
        this.updateSizing(!(0, $5913100b2ed0f596$export$a9c23c6ac3fc3eca)(prevProps, currentProps));
    }
    componentWillUnmount() {
        this.context.removeResizeHandler(this.handleResize);
    }
    getHighlightSegs() {
        let { props: props } = this;
        if (props.eventDrag && props.eventDrag.segs.length) return props.eventDrag.segs;
        if (props.eventResize && props.eventResize.segs.length) return props.eventResize.segs;
        return props.dateSelectionSegs;
    }
    getMirrorSegs() {
        let { props: props } = this;
        if (props.eventResize && props.eventResize.segs.length) return props.eventResize.segs;
        return [];
    }
    renderFgSegs(col, segPlacements, todayRange, isForcedInvisible, isDragging, isResizing, isDateSelecting) {
        let { context: context } = this;
        let { eventSelection: eventSelection } = this.props;
        let { framePositions: framePositions } = this.state;
        let defaultDisplayEventEnd = this.props.cells.length === 1; // colCnt === 1
        let isMirror = isDragging || isResizing || isDateSelecting;
        let nodes = [];
        if (framePositions) for (let placement of segPlacements){
            let { seg: seg } = placement;
            let { instanceId: instanceId } = seg.eventRange.instance;
            let isVisible = placement.isVisible && !isForcedInvisible[instanceId];
            let isAbsolute = placement.isAbsolute;
            let left = "";
            let right = "";
            if (isAbsolute) {
                if (context.isRtl) {
                    right = 0;
                    left = framePositions.lefts[seg.lastCol] - framePositions.lefts[seg.firstCol];
                } else {
                    left = 0;
                    right = framePositions.rights[seg.firstCol] - framePositions.rights[seg.lastCol];
                }
            }
            /*
                known bug: events that are force to be list-item but span multiple days still take up space in later columns
                todo: in print view, for multi-day events, don't display title within non-start/end segs
                */ nodes.push((0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("div", {
                className: "fc-daygrid-event-harness" + (isAbsolute ? " fc-daygrid-event-harness-abs" : ""),
                key: $19ee8ec6199ec2ec$var$generateSegKey(seg),
                ref: isMirror ? null : this.segHarnessRefs.createRef($19ee8ec6199ec2ec$var$generateSegUid(seg)),
                style: {
                    visibility: isVisible ? "" : "hidden",
                    marginTop: isAbsolute ? "" : placement.marginTop,
                    top: isAbsolute ? placement.absoluteTop : "",
                    left: left,
                    right: right
                }
            }, $19ee8ec6199ec2ec$var$hasListItemDisplay(seg) ? (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)($19ee8ec6199ec2ec$var$TableListItemEvent, Object.assign({
                seg: seg,
                isDragging: isDragging,
                isSelected: instanceId === eventSelection,
                defaultDisplayEventEnd: defaultDisplayEventEnd
            }, (0, $5913100b2ed0f596$export$6dabbe08653f866f)(seg, todayRange))) : (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)($19ee8ec6199ec2ec$var$TableBlockEvent, Object.assign({
                seg: seg,
                isDragging: isDragging,
                isResizing: isResizing,
                isDateSelecting: isDateSelecting,
                isSelected: instanceId === eventSelection,
                defaultDisplayEventEnd: defaultDisplayEventEnd
            }, (0, $5913100b2ed0f596$export$6dabbe08653f866f)(seg, todayRange)))));
        }
        return nodes;
    }
    renderFillSegs(segs, fillType) {
        let { isRtl: isRtl } = this.context;
        let { todayRange: todayRange } = this.props;
        let { framePositions: framePositions } = this.state;
        let nodes = [];
        if (framePositions) for (let seg of segs){
            let leftRightCss = isRtl ? {
                right: 0,
                left: framePositions.lefts[seg.lastCol] - framePositions.lefts[seg.firstCol]
            } : {
                left: 0,
                right: framePositions.rights[seg.firstCol] - framePositions.rights[seg.lastCol]
            };
            nodes.push((0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("div", {
                key: (0, $5913100b2ed0f596$export$1314441b8d04e1d5)(seg.eventRange),
                className: "fc-daygrid-bg-harness",
                style: leftRightCss
            }, fillType === "bg-event" ? (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)((0, $5913100b2ed0f596$export$cd571ca6d1702b73), Object.assign({
                seg: seg
            }, (0, $5913100b2ed0f596$export$6dabbe08653f866f)(seg, todayRange))) : (0, $5913100b2ed0f596$export$87b6ab1c2cb8b955)(fillType)));
        }
        return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)((0, $450fc775b2f7950e$export$ffb0004e005737fa), {}, ...nodes);
    }
    updateSizing(isExternalSizingChange) {
        let { props: props, state: state, frameElRefs: frameElRefs } = this;
        if (!props.forPrint && props.clientWidth !== null // positioning ready?
        ) {
            if (isExternalSizingChange) {
                let frameEls = props.cells.map((cell)=>frameElRefs.currentMap[cell.key]);
                if (frameEls.length) {
                    let originEl = this.rootElRef.current;
                    let newPositionCache = new (0, $5913100b2ed0f596$export$7060da4b5db56fb9)(originEl, frameEls, true, false);
                    if (!state.framePositions || !state.framePositions.similarTo(newPositionCache)) this.setState({
                        framePositions: new (0, $5913100b2ed0f596$export$7060da4b5db56fb9)(originEl, frameEls, true, false)
                    });
                }
            }
            const oldSegHeights = this.state.segHeights;
            const newSegHeights = this.querySegHeights();
            const limitByContentHeight = props.dayMaxEvents === true || props.dayMaxEventRows === true;
            this.safeSetState({
                // HACK to prevent oscillations of events being shown/hidden from max-event-rows
                // Essentially, once you compute an element's height, never null-out.
                // TODO: always display all events, as visibility:hidden?
                segHeights: Object.assign(Object.assign({}, oldSegHeights), newSegHeights),
                maxContentHeight: limitByContentHeight ? this.computeMaxContentHeight() : null
            });
        }
    }
    querySegHeights() {
        let segElMap = this.segHarnessRefs.currentMap;
        let segHeights = {};
        // get the max height amongst instance segs
        for(let segUid in segElMap){
            let height = Math.round(segElMap[segUid].getBoundingClientRect().height);
            segHeights[segUid] = Math.max(segHeights[segUid] || 0, height);
        }
        return segHeights;
    }
    computeMaxContentHeight() {
        let firstKey = this.props.cells[0].key;
        let cellEl = this.cellElRefs.currentMap[firstKey];
        let fcContainerEl = this.fgElRefs.currentMap[firstKey];
        return cellEl.getBoundingClientRect().bottom - fcContainerEl.getBoundingClientRect().top;
    }
    getCellEls() {
        let elMap = this.cellElRefs.currentMap;
        return this.props.cells.map((cell)=>elMap[cell.key]);
    }
}
$19ee8ec6199ec2ec$var$TableRow.addStateEquality({
    segHeights: (0, $5913100b2ed0f596$export$a9c23c6ac3fc3eca)
});
function $19ee8ec6199ec2ec$var$buildMirrorPlacements(mirrorSegs, colPlacements) {
    if (!mirrorSegs.length) return [];
    let topsByInstanceId = $19ee8ec6199ec2ec$var$buildAbsoluteTopHash(colPlacements); // TODO: cache this at first render?
    return mirrorSegs.map((seg)=>({
            seg: seg,
            isVisible: true,
            isAbsolute: true,
            absoluteTop: topsByInstanceId[seg.eventRange.instance.instanceId],
            marginTop: 0
        }));
}
function $19ee8ec6199ec2ec$var$buildAbsoluteTopHash(colPlacements) {
    let topsByInstanceId = {};
    for (let placements of colPlacements)for (let placement of placements)topsByInstanceId[placement.seg.eventRange.instance.instanceId] = placement.absoluteTop;
    return topsByInstanceId;
}
class $19ee8ec6199ec2ec$export$d955b1c53830e05a extends (0, $5913100b2ed0f596$export$51b138e5a065c2bb) {
    constructor(){
        super(...arguments);
        this.splitBusinessHourSegs = (0, $5913100b2ed0f596$export$df995fae86a55f06)($19ee8ec6199ec2ec$var$splitSegsByRow);
        this.splitBgEventSegs = (0, $5913100b2ed0f596$export$df995fae86a55f06)($19ee8ec6199ec2ec$var$splitSegsByRow);
        this.splitFgEventSegs = (0, $5913100b2ed0f596$export$df995fae86a55f06)($19ee8ec6199ec2ec$var$splitSegsByRow);
        this.splitDateSelectionSegs = (0, $5913100b2ed0f596$export$df995fae86a55f06)($19ee8ec6199ec2ec$var$splitSegsByRow);
        this.splitEventDrag = (0, $5913100b2ed0f596$export$df995fae86a55f06)($19ee8ec6199ec2ec$var$splitInteractionByRow);
        this.splitEventResize = (0, $5913100b2ed0f596$export$df995fae86a55f06)($19ee8ec6199ec2ec$var$splitInteractionByRow);
        this.rowRefs = new (0, $5913100b2ed0f596$export$49e6ee724f7f1ace)();
    }
    render() {
        let { props: props, context: context } = this;
        let rowCnt = props.cells.length;
        let businessHourSegsByRow = this.splitBusinessHourSegs(props.businessHourSegs, rowCnt);
        let bgEventSegsByRow = this.splitBgEventSegs(props.bgEventSegs, rowCnt);
        let fgEventSegsByRow = this.splitFgEventSegs(props.fgEventSegs, rowCnt);
        let dateSelectionSegsByRow = this.splitDateSelectionSegs(props.dateSelectionSegs, rowCnt);
        let eventDragByRow = this.splitEventDrag(props.eventDrag, rowCnt);
        let eventResizeByRow = this.splitEventResize(props.eventResize, rowCnt);
        // for DayGrid view with many rows, force a min-height on cells so doesn't appear squished
        // choose 7 because a month view will have max 6 rows
        let cellMinHeight = rowCnt >= 7 && props.clientWidth ? props.clientWidth / context.options.aspectRatio / 6 : null;
        return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)((0, $5913100b2ed0f596$export$6e4b1d19c6e2e012), {
            unit: "day"
        }, (nowDate, todayRange)=>(0, $450fc775b2f7950e$export$c8a8987d4410bf2d)((0, $450fc775b2f7950e$export$ffb0004e005737fa), null, props.cells.map((cells, row)=>(0, $450fc775b2f7950e$export$c8a8987d4410bf2d)($19ee8ec6199ec2ec$var$TableRow, {
                    ref: this.rowRefs.createRef(row),
                    key: cells.length ? cells[0].date.toISOString() : row // in case there are no cells (like when resource view is loading)
                    ,
                    showDayNumbers: rowCnt > 1,
                    showWeekNumbers: props.showWeekNumbers,
                    todayRange: todayRange,
                    dateProfile: props.dateProfile,
                    cells: cells,
                    renderIntro: props.renderRowIntro,
                    businessHourSegs: businessHourSegsByRow[row],
                    eventSelection: props.eventSelection,
                    bgEventSegs: bgEventSegsByRow[row].filter($19ee8ec6199ec2ec$var$isSegAllDay),
                    fgEventSegs: fgEventSegsByRow[row],
                    dateSelectionSegs: dateSelectionSegsByRow[row],
                    eventDrag: eventDragByRow[row],
                    eventResize: eventResizeByRow[row],
                    dayMaxEvents: props.dayMaxEvents,
                    dayMaxEventRows: props.dayMaxEventRows,
                    clientWidth: props.clientWidth,
                    clientHeight: props.clientHeight,
                    cellMinHeight: cellMinHeight,
                    forPrint: props.forPrint
                }))));
    }
    componentDidMount() {
        this.registerInteractiveComponent();
    }
    componentDidUpdate() {
        // for if started with zero cells
        this.registerInteractiveComponent();
    }
    registerInteractiveComponent() {
        if (!this.rootEl) {
            // HACK: need a daygrid wrapper parent to do positioning
            // NOTE: a daygrid resource view w/o resources can have zero cells
            const firstCellEl = this.rowRefs.currentMap[0].getCellEls()[0];
            const rootEl = firstCellEl ? firstCellEl.closest(".fc-daygrid-body") : null;
            if (rootEl) {
                this.rootEl = rootEl;
                this.context.registerInteractiveComponent(this, {
                    el: rootEl,
                    isHitComboAllowed: this.props.isHitComboAllowed
                });
            }
        }
    }
    componentWillUnmount() {
        if (this.rootEl) {
            this.context.unregisterInteractiveComponent(this);
            this.rootEl = null;
        }
    }
    // Hit System
    // ----------------------------------------------------------------------------------------------------
    prepareHits() {
        this.rowPositions = new (0, $5913100b2ed0f596$export$7060da4b5db56fb9)(this.rootEl, this.rowRefs.collect().map((rowObj)=>rowObj.getCellEls()[0]), false, true);
        this.colPositions = new (0, $5913100b2ed0f596$export$7060da4b5db56fb9)(this.rootEl, this.rowRefs.currentMap[0].getCellEls(), true, false);
    }
    queryHit(positionLeft, positionTop) {
        let { colPositions: colPositions, rowPositions: rowPositions } = this;
        let col = colPositions.leftToIndex(positionLeft);
        let row = rowPositions.topToIndex(positionTop);
        if (row != null && col != null) {
            let cell = this.props.cells[row][col];
            return {
                dateProfile: this.props.dateProfile,
                dateSpan: Object.assign({
                    range: this.getCellRange(row, col),
                    allDay: true
                }, cell.extraDateSpan),
                dayEl: this.getCellEl(row, col),
                rect: {
                    left: colPositions.lefts[col],
                    right: colPositions.rights[col],
                    top: rowPositions.tops[row],
                    bottom: rowPositions.bottoms[row]
                },
                layer: 0
            };
        }
        return null;
    }
    getCellEl(row, col) {
        return this.rowRefs.currentMap[row].getCellEls()[col]; // TODO: not optimal
    }
    getCellRange(row, col) {
        let start = this.props.cells[row][col].date;
        let end = (0, $5913100b2ed0f596$export$625550452a3fa3ec)(start, 1);
        return {
            start: start,
            end: end
        };
    }
}
function $19ee8ec6199ec2ec$var$isSegAllDay(seg) {
    return seg.eventRange.def.allDay;
}
class $19ee8ec6199ec2ec$export$54ec01a60f47d33d extends (0, $5913100b2ed0f596$export$51b138e5a065c2bb) {
    constructor(){
        super(...arguments);
        this.elRef = (0, $450fc775b2f7950e$export$7d1e3a5e95ceca43)();
        this.needsScrollReset = false;
    }
    render() {
        let { props: props } = this;
        let { dayMaxEventRows: dayMaxEventRows, dayMaxEvents: dayMaxEvents, expandRows: expandRows } = props;
        let limitViaBalanced = dayMaxEvents === true || dayMaxEventRows === true;
        // if rows can't expand to fill fixed height, can't do balanced-height event limit
        // TODO: best place to normalize these options?
        if (limitViaBalanced && !expandRows) {
            limitViaBalanced = false;
            dayMaxEventRows = null;
            dayMaxEvents = null;
        }
        let classNames = [
            "fc-daygrid-body",
            limitViaBalanced ? "fc-daygrid-body-balanced" : "fc-daygrid-body-unbalanced",
            expandRows ? "" : "fc-daygrid-body-natural"
        ];
        return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("div", {
            ref: this.elRef,
            className: classNames.join(" "),
            style: {
                // these props are important to give this wrapper correct dimensions for interactions
                // TODO: if we set it here, can we avoid giving to inner tables?
                width: props.clientWidth,
                minWidth: props.tableMinWidth
            }
        }, (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("table", {
            role: "presentation",
            className: "fc-scrollgrid-sync-table",
            style: {
                width: props.clientWidth,
                minWidth: props.tableMinWidth,
                height: expandRows ? props.clientHeight : ""
            }
        }, props.colGroupNode, (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("tbody", {
            role: "presentation"
        }, (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)($19ee8ec6199ec2ec$export$d955b1c53830e05a, {
            dateProfile: props.dateProfile,
            cells: props.cells,
            renderRowIntro: props.renderRowIntro,
            showWeekNumbers: props.showWeekNumbers,
            clientWidth: props.clientWidth,
            clientHeight: props.clientHeight,
            businessHourSegs: props.businessHourSegs,
            bgEventSegs: props.bgEventSegs,
            fgEventSegs: props.fgEventSegs,
            dateSelectionSegs: props.dateSelectionSegs,
            eventSelection: props.eventSelection,
            eventDrag: props.eventDrag,
            eventResize: props.eventResize,
            dayMaxEvents: dayMaxEvents,
            dayMaxEventRows: dayMaxEventRows,
            forPrint: props.forPrint,
            isHitComboAllowed: props.isHitComboAllowed
        }))));
    }
    componentDidMount() {
        this.requestScrollReset();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.dateProfile !== this.props.dateProfile) this.requestScrollReset();
        else this.flushScrollReset();
    }
    requestScrollReset() {
        this.needsScrollReset = true;
        this.flushScrollReset();
    }
    flushScrollReset() {
        if (this.needsScrollReset && this.props.clientWidth // sizes computed?
        ) {
            const subjectEl = $19ee8ec6199ec2ec$var$getScrollSubjectEl(this.elRef.current, this.props.dateProfile);
            if (subjectEl) {
                const originEl = subjectEl.closest(".fc-daygrid-body");
                const scrollEl = originEl.closest(".fc-scroller");
                const scrollTop = subjectEl.getBoundingClientRect().top - originEl.getBoundingClientRect().top;
                scrollEl.scrollTop = scrollTop ? scrollTop + 1 : 0; // overcome border
            }
            this.needsScrollReset = false;
        }
    }
}
function $19ee8ec6199ec2ec$var$getScrollSubjectEl(containerEl, dateProfile) {
    let el;
    if (dateProfile.currentRangeUnit.match(/year|month/)) el = containerEl.querySelector(`[data-date="${(0, $5913100b2ed0f596$export$26a0a7676ca7aa04)(dateProfile.currentDate)}-01"]`);
    if (!el) el = containerEl.querySelector(`[data-date="${(0, $5913100b2ed0f596$export$5dbe06c6d8c68cfb)(dateProfile.currentDate)}"]`);
    return el;
}
class $19ee8ec6199ec2ec$export$eb38be9553e58392 extends (0, $5913100b2ed0f596$export$6b179bb11f7fd3a0) {
    constructor(){
        super(...arguments);
        this.forceDayIfListItem = true;
    }
    sliceRange(dateRange, dayTableModel) {
        return dayTableModel.sliceRange(dateRange);
    }
}
class $19ee8ec6199ec2ec$export$cd402b7558adf371 extends (0, $5913100b2ed0f596$export$51b138e5a065c2bb) {
    constructor(){
        super(...arguments);
        this.slicer = new $19ee8ec6199ec2ec$export$eb38be9553e58392();
        this.tableRef = (0, $450fc775b2f7950e$export$7d1e3a5e95ceca43)();
    }
    render() {
        let { props: props, context: context } = this;
        return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)($19ee8ec6199ec2ec$export$54ec01a60f47d33d, Object.assign({
            ref: this.tableRef
        }, this.slicer.sliceProps(props, props.dateProfile, props.nextDayThreshold, context, props.dayTableModel), {
            dateProfile: props.dateProfile,
            cells: props.dayTableModel.cells,
            colGroupNode: props.colGroupNode,
            tableMinWidth: props.tableMinWidth,
            renderRowIntro: props.renderRowIntro,
            dayMaxEvents: props.dayMaxEvents,
            dayMaxEventRows: props.dayMaxEventRows,
            showWeekNumbers: props.showWeekNumbers,
            expandRows: props.expandRows,
            headerAlignElRef: props.headerAlignElRef,
            clientWidth: props.clientWidth,
            clientHeight: props.clientHeight,
            forPrint: props.forPrint
        }));
    }
}
class $19ee8ec6199ec2ec$export$39eed66de95896e5 extends $19ee8ec6199ec2ec$export$b3c27e869d856b7 {
    constructor(){
        super(...arguments);
        this.buildDayTableModel = (0, $5913100b2ed0f596$export$df995fae86a55f06)($19ee8ec6199ec2ec$export$61e79f95d746b006);
        this.headerRef = (0, $450fc775b2f7950e$export$7d1e3a5e95ceca43)();
        this.tableRef = (0, $450fc775b2f7950e$export$7d1e3a5e95ceca43)();
    // can't override any lifecycle methods from parent
    }
    render() {
        let { options: options, dateProfileGenerator: dateProfileGenerator } = this.context;
        let { props: props } = this;
        let dayTableModel = this.buildDayTableModel(props.dateProfile, dateProfileGenerator);
        let headerContent = options.dayHeaders && (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)((0, $5913100b2ed0f596$export$ebc5e65867841cbe), {
            ref: this.headerRef,
            dateProfile: props.dateProfile,
            dates: dayTableModel.headerDates,
            datesRepDistinctDays: dayTableModel.rowCnt === 1
        });
        let bodyContent = (contentArg)=>(0, $450fc775b2f7950e$export$c8a8987d4410bf2d)($19ee8ec6199ec2ec$export$cd402b7558adf371, {
                ref: this.tableRef,
                dateProfile: props.dateProfile,
                dayTableModel: dayTableModel,
                businessHours: props.businessHours,
                dateSelection: props.dateSelection,
                eventStore: props.eventStore,
                eventUiBases: props.eventUiBases,
                eventSelection: props.eventSelection,
                eventDrag: props.eventDrag,
                eventResize: props.eventResize,
                nextDayThreshold: options.nextDayThreshold,
                colGroupNode: contentArg.tableColGroupNode,
                tableMinWidth: contentArg.tableMinWidth,
                dayMaxEvents: options.dayMaxEvents,
                dayMaxEventRows: options.dayMaxEventRows,
                showWeekNumbers: options.weekNumbers,
                expandRows: !props.isHeightAuto,
                headerAlignElRef: this.headerElRef,
                clientWidth: contentArg.clientWidth,
                clientHeight: contentArg.clientHeight,
                forPrint: props.forPrint
            });
        return options.dayMinWidth ? this.renderHScrollLayout(headerContent, bodyContent, dayTableModel.colCnt, options.dayMinWidth) : this.renderSimpleLayout(headerContent, bodyContent);
    }
}
function $19ee8ec6199ec2ec$export$61e79f95d746b006(dateProfile, dateProfileGenerator) {
    let daySeries = new (0, $5913100b2ed0f596$export$2538633961795d6b)(dateProfile.renderRange, dateProfileGenerator);
    return new (0, $5913100b2ed0f596$export$dabba94403d45c8e)(daySeries, /year|month|week/.test(dateProfile.currentRangeUnit));
}
class $19ee8ec6199ec2ec$export$9fcce6e2d16ec31d extends (0, $5913100b2ed0f596$export$3a6d5c9ae78a2c08) {
    // Computes the date range that will be rendered
    buildRenderRange(currentRange, currentRangeUnit, isRangeAllDay) {
        let renderRange = super.buildRenderRange(currentRange, currentRangeUnit, isRangeAllDay);
        let { props: props } = this;
        return $19ee8ec6199ec2ec$export$a2ad67969be9f247({
            currentRange: renderRange,
            snapToWeek: /^(year|month)$/.test(currentRangeUnit),
            fixedWeekCount: props.fixedWeekCount,
            dateEnv: props.dateEnv
        });
    }
}
function $19ee8ec6199ec2ec$export$a2ad67969be9f247(props) {
    let { dateEnv: dateEnv, currentRange: currentRange } = props;
    let { start: start, end: end } = currentRange;
    let endOfWeek;
    // year and month views should be aligned with weeks. this is already done for week
    if (props.snapToWeek) {
        start = dateEnv.startOfWeek(start);
        // make end-of-week if not already
        endOfWeek = dateEnv.startOfWeek(end);
        if (endOfWeek.valueOf() !== end.valueOf()) end = (0, $5913100b2ed0f596$export$31e67cf12fc9668)(endOfWeek, 1);
    }
    // ensure 6 weeks
    if (props.fixedWeekCount) {
        // TODO: instead of these date-math gymnastics (for multimonth view),
        // compute dateprofiles of all months, then use start of first and end of last.
        let lastMonthRenderStart = dateEnv.startOfWeek(dateEnv.startOfMonth((0, $5913100b2ed0f596$export$625550452a3fa3ec)(currentRange.end, -1)));
        let rowCnt = Math.ceil((0, $5913100b2ed0f596$export$62d08d6fa708df47)(lastMonthRenderStart, end));
        end = (0, $5913100b2ed0f596$export$31e67cf12fc9668)(end, 6 - rowCnt);
    }
    return {
        start: start,
        end: end
    };
}
var $19ee8ec6199ec2ec$var$css_248z = ':root{--fc-daygrid-event-dot-width:8px}.fc-daygrid-day-events:after,.fc-daygrid-day-events:before,.fc-daygrid-day-frame:after,.fc-daygrid-day-frame:before,.fc-daygrid-event-harness:after,.fc-daygrid-event-harness:before{clear:both;content:"";display:table}.fc .fc-daygrid-body{position:relative;z-index:1}.fc .fc-daygrid-day.fc-day-today{background-color:var(--fc-today-bg-color)}.fc .fc-daygrid-day-frame{min-height:100%;position:relative}.fc .fc-daygrid-day-top{display:flex;flex-direction:row-reverse}.fc .fc-day-other .fc-daygrid-day-top{opacity:.3}.fc .fc-daygrid-day-number{padding:4px;position:relative;z-index:4}.fc .fc-daygrid-month-start{font-size:1.1em;font-weight:700}.fc .fc-daygrid-day-events{margin-top:1px}.fc .fc-daygrid-body-balanced .fc-daygrid-day-events{left:0;position:absolute;right:0}.fc .fc-daygrid-body-unbalanced .fc-daygrid-day-events{min-height:2em;position:relative}.fc .fc-daygrid-body-natural .fc-daygrid-day-events{margin-bottom:1em}.fc .fc-daygrid-event-harness{position:relative}.fc .fc-daygrid-event-harness-abs{left:0;position:absolute;right:0;top:0}.fc .fc-daygrid-bg-harness{bottom:0;position:absolute;top:0}.fc .fc-daygrid-day-bg .fc-non-business{z-index:1}.fc .fc-daygrid-day-bg .fc-bg-event{z-index:2}.fc .fc-daygrid-day-bg .fc-highlight{z-index:3}.fc .fc-daygrid-event{margin-top:1px;z-index:6}.fc .fc-daygrid-event.fc-event-mirror{z-index:7}.fc .fc-daygrid-day-bottom{font-size:.85em;margin:0 2px}.fc .fc-daygrid-day-bottom:after,.fc .fc-daygrid-day-bottom:before{clear:both;content:"";display:table}.fc .fc-daygrid-more-link{border-radius:3px;cursor:pointer;line-height:1;margin-top:1px;max-width:100%;overflow:hidden;padding:2px;position:relative;white-space:nowrap;z-index:4}.fc .fc-daygrid-more-link:hover{background-color:rgba(0,0,0,.1)}.fc .fc-daygrid-week-number{background-color:var(--fc-neutral-bg-color);color:var(--fc-neutral-text-color);min-width:1.5em;padding:2px;position:absolute;text-align:center;top:0;z-index:5}.fc .fc-more-popover .fc-popover-body{min-width:220px;padding:10px}.fc-direction-ltr .fc-daygrid-event.fc-event-start,.fc-direction-rtl .fc-daygrid-event.fc-event-end{margin-left:2px}.fc-direction-ltr .fc-daygrid-event.fc-event-end,.fc-direction-rtl .fc-daygrid-event.fc-event-start{margin-right:2px}.fc-direction-ltr .fc-daygrid-more-link{float:left}.fc-direction-ltr .fc-daygrid-week-number{border-radius:0 0 3px 0;left:0}.fc-direction-rtl .fc-daygrid-more-link{float:right}.fc-direction-rtl .fc-daygrid-week-number{border-radius:0 0 0 3px;right:0}.fc-liquid-hack .fc-daygrid-day-frame{position:static}.fc-daygrid-event{border-radius:3px;font-size:var(--fc-small-font-size);position:relative;white-space:nowrap}.fc-daygrid-block-event .fc-event-time{font-weight:700}.fc-daygrid-block-event .fc-event-time,.fc-daygrid-block-event .fc-event-title{padding:1px}.fc-daygrid-dot-event{align-items:center;display:flex;padding:2px 0}.fc-daygrid-dot-event .fc-event-title{flex-grow:1;flex-shrink:1;font-weight:700;min-width:0;overflow:hidden}.fc-daygrid-dot-event.fc-event-mirror,.fc-daygrid-dot-event:hover{background:rgba(0,0,0,.1)}.fc-daygrid-dot-event.fc-event-selected:before{bottom:-10px;top:-10px}.fc-daygrid-event-dot{border:calc(var(--fc-daygrid-event-dot-width)/2) solid var(--fc-event-border-color);border-radius:calc(var(--fc-daygrid-event-dot-width)/2);box-sizing:content-box;height:0;margin:0 4px;width:0}.fc-direction-ltr .fc-daygrid-event .fc-event-time{margin-right:3px}.fc-direction-rtl .fc-daygrid-event .fc-event-time{margin-left:3px}';
(0, $5913100b2ed0f596$export$c373adc892eb6355)($19ee8ec6199ec2ec$var$css_248z);




var $2c4f17c4f7fb59ef$export$2e2bcd8739ae039 = (0, $641adb510ed163e1$export$ae829ec7b2625219)({
    name: "@fullcalendar/daygrid",
    initialView: "dayGridMonth",
    views: {
        dayGrid: {
            component: (0, $19ee8ec6199ec2ec$export$39eed66de95896e5),
            dateProfileGeneratorClass: (0, $19ee8ec6199ec2ec$export$9fcce6e2d16ec31d)
        },
        dayGridDay: {
            type: "dayGrid",
            duration: {
                days: 1
            }
        },
        dayGridWeek: {
            type: "dayGrid",
            duration: {
                weeks: 1
            }
        },
        dayGridMonth: {
            type: "dayGrid",
            duration: {
                months: 1
            },
            fixedWeekCount: true
        },
        dayGridYear: {
            type: "dayGrid",
            duration: {
                years: 1
            }
        }
    }
});





class $6c1350034e49c52e$var$ListViewHeaderRow extends (0, $5913100b2ed0f596$export$ef35774e6d314e91) {
    constructor(){
        super(...arguments);
        this.state = {
            textId: (0, $5913100b2ed0f596$export$a8550f7dbe79f93a)()
        };
    }
    render() {
        let { theme: theme, dateEnv: dateEnv, options: options, viewApi: viewApi } = this.context;
        let { cellId: cellId, dayDate: dayDate, todayRange: todayRange } = this.props;
        let { textId: textId } = this.state;
        let dayMeta = (0, $5913100b2ed0f596$export$a17c37559e1db147)(dayDate, todayRange);
        // will ever be falsy?
        let text = options.listDayFormat ? dateEnv.format(dayDate, options.listDayFormat) : "";
        // will ever be falsy? also, BAD NAME "alt"
        let sideText = options.listDaySideFormat ? dateEnv.format(dayDate, options.listDaySideFormat) : "";
        let renderProps = Object.assign({
            date: dateEnv.toDate(dayDate),
            view: viewApi,
            textId: textId,
            text: text,
            sideText: sideText,
            navLinkAttrs: (0, $5913100b2ed0f596$export$8c78c7c36408ea29)(this.context, dayDate),
            sideNavLinkAttrs: (0, $5913100b2ed0f596$export$8c78c7c36408ea29)(this.context, dayDate, "day", false)
        }, dayMeta);
        // TODO: make a reusable HOC for dayHeader (used in daygrid/timegrid too)
        return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)((0, $5913100b2ed0f596$export$e7094788287c5e9b), {
            elTag: "tr",
            elClasses: [
                "fc-list-day",
                ...(0, $5913100b2ed0f596$export$527e9aa3390079e9)(dayMeta, theme)
            ],
            elAttrs: {
                "data-date": (0, $5913100b2ed0f596$export$5dbe06c6d8c68cfb)(dayDate)
            },
            renderProps: renderProps,
            generatorName: "dayHeaderContent",
            customGenerator: options.dayHeaderContent,
            defaultGenerator: $6c1350034e49c52e$var$renderInnerContent,
            classNameGenerator: options.dayHeaderClassNames,
            didMount: options.dayHeaderDidMount,
            willUnmount: options.dayHeaderWillUnmount
        }, (InnerContent)=>(0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("th", {
                scope: "colgroup",
                colSpan: 3,
                id: cellId,
                "aria-labelledby": textId
            }, (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)(InnerContent, {
                elTag: "div",
                elClasses: [
                    "fc-list-day-cushion",
                    theme.getClass("tableCellShaded")
                ]
            })));
    }
}
function $6c1350034e49c52e$var$renderInnerContent(props) {
    return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)((0, $450fc775b2f7950e$export$ffb0004e005737fa), null, props.text && (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("a", Object.assign({
        id: props.textId,
        className: "fc-list-day-text"
    }, props.navLinkAttrs), props.text), props.sideText && /* not keyboard tabbable */ (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("a", Object.assign({
        "aria-hidden": true,
        className: "fc-list-day-side-text"
    }, props.sideNavLinkAttrs), props.sideText));
}
const $6c1350034e49c52e$var$DEFAULT_TIME_FORMAT = (0, $5913100b2ed0f596$export$d141bba7fdc215a3)({
    hour: "numeric",
    minute: "2-digit",
    meridiem: "short"
});
class $6c1350034e49c52e$var$ListViewEventRow extends (0, $5913100b2ed0f596$export$ef35774e6d314e91) {
    render() {
        let { props: props, context: context } = this;
        let { options: options } = context;
        let { seg: seg, timeHeaderId: timeHeaderId, eventHeaderId: eventHeaderId, dateHeaderId: dateHeaderId } = props;
        let timeFormat = options.eventTimeFormat || $6c1350034e49c52e$var$DEFAULT_TIME_FORMAT;
        return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)((0, $5913100b2ed0f596$export$1343a74baacb0543), Object.assign({}, props, {
            elTag: "tr",
            elClasses: [
                "fc-list-event",
                seg.eventRange.def.url && "fc-event-forced-url"
            ],
            defaultGenerator: ()=>$6c1350034e49c52e$var$renderEventInnerContent(seg, context),
            seg: seg,
            timeText: "",
            disableDragging: true,
            disableResizing: true
        }), (InnerContent, eventContentArg)=>(0, $450fc775b2f7950e$export$c8a8987d4410bf2d)((0, $450fc775b2f7950e$export$ffb0004e005737fa), null, $6c1350034e49c52e$var$buildTimeContent(seg, timeFormat, context, timeHeaderId, dateHeaderId), (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("td", {
                "aria-hidden": true,
                className: "fc-list-event-graphic"
            }, (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("span", {
                className: "fc-list-event-dot",
                style: {
                    borderColor: eventContentArg.borderColor || eventContentArg.backgroundColor
                }
            })), (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)(InnerContent, {
                elTag: "td",
                elClasses: [
                    "fc-list-event-title"
                ],
                elAttrs: {
                    headers: `${eventHeaderId} ${dateHeaderId}`
                }
            })));
    }
}
function $6c1350034e49c52e$var$renderEventInnerContent(seg, context) {
    let interactiveAttrs = (0, $5913100b2ed0f596$export$e0c3a065614c6254)(seg, context);
    return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("a", Object.assign({}, interactiveAttrs), seg.eventRange.def.title);
}
function $6c1350034e49c52e$var$buildTimeContent(seg, timeFormat, context, timeHeaderId, dateHeaderId) {
    let { options: options } = context;
    if (options.displayEventTime !== false) {
        let eventDef = seg.eventRange.def;
        let eventInstance = seg.eventRange.instance;
        let doAllDay = false;
        let timeText;
        if (eventDef.allDay) doAllDay = true;
        else if ((0, $5913100b2ed0f596$export$3d12bd131bb975d1)(seg.eventRange.range)) {
            if (seg.isStart) timeText = (0, $5913100b2ed0f596$export$993a080e5cb62d74)(seg, timeFormat, context, null, null, eventInstance.range.start, seg.end);
            else if (seg.isEnd) timeText = (0, $5913100b2ed0f596$export$993a080e5cb62d74)(seg, timeFormat, context, null, null, seg.start, eventInstance.range.end);
            else doAllDay = true;
        } else timeText = (0, $5913100b2ed0f596$export$993a080e5cb62d74)(seg, timeFormat, context);
        if (doAllDay) {
            let renderProps = {
                text: context.options.allDayText,
                view: context.viewApi
            };
            return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)((0, $5913100b2ed0f596$export$e7094788287c5e9b), {
                elTag: "td",
                elClasses: [
                    "fc-list-event-time"
                ],
                elAttrs: {
                    headers: `${timeHeaderId} ${dateHeaderId}`
                },
                renderProps: renderProps,
                generatorName: "allDayContent",
                customGenerator: options.allDayContent,
                defaultGenerator: $6c1350034e49c52e$var$renderAllDayInner,
                classNameGenerator: options.allDayClassNames,
                didMount: options.allDayDidMount,
                willUnmount: options.allDayWillUnmount
            });
        }
        return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("td", {
            className: "fc-list-event-time"
        }, timeText);
    }
    return null;
}
function $6c1350034e49c52e$var$renderAllDayInner(renderProps) {
    return renderProps.text;
}
/*
Responsible for the scroller, and forwarding event-related actions into the "grid".
*/ class $6c1350034e49c52e$export$84d0dd190d551cd1 extends (0, $5913100b2ed0f596$export$51b138e5a065c2bb) {
    constructor(){
        super(...arguments);
        this.computeDateVars = (0, $5913100b2ed0f596$export$df995fae86a55f06)($6c1350034e49c52e$var$computeDateVars);
        this.eventStoreToSegs = (0, $5913100b2ed0f596$export$df995fae86a55f06)(this._eventStoreToSegs);
        this.state = {
            timeHeaderId: (0, $5913100b2ed0f596$export$a8550f7dbe79f93a)(),
            eventHeaderId: (0, $5913100b2ed0f596$export$a8550f7dbe79f93a)(),
            dateHeaderIdRoot: (0, $5913100b2ed0f596$export$a8550f7dbe79f93a)()
        };
        this.setRootEl = (rootEl)=>{
            if (rootEl) this.context.registerInteractiveComponent(this, {
                el: rootEl
            });
            else this.context.unregisterInteractiveComponent(this);
        };
    }
    render() {
        let { props: props, context: context } = this;
        let { dayDates: dayDates, dayRanges: dayRanges } = this.computeDateVars(props.dateProfile);
        let eventSegs = this.eventStoreToSegs(props.eventStore, props.eventUiBases, dayRanges);
        return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)((0, $5913100b2ed0f596$export$e9316ff9106cdb75), {
            elRef: this.setRootEl,
            elClasses: [
                "fc-list",
                context.theme.getClass("table"),
                context.options.stickyHeaderDates !== false ? "fc-list-sticky" : ""
            ],
            viewSpec: context.viewSpec
        }, (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)((0, $5913100b2ed0f596$export$807f1ba34db587c7), {
            liquid: !props.isHeightAuto,
            overflowX: props.isHeightAuto ? "visible" : "hidden",
            overflowY: props.isHeightAuto ? "visible" : "auto"
        }, eventSegs.length > 0 ? this.renderSegList(eventSegs, dayDates) : this.renderEmptyMessage()));
    }
    renderEmptyMessage() {
        let { options: options, viewApi: viewApi } = this.context;
        let renderProps = {
            text: options.noEventsText,
            view: viewApi
        };
        return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)((0, $5913100b2ed0f596$export$e7094788287c5e9b), {
            elTag: "div",
            elClasses: [
                "fc-list-empty"
            ],
            renderProps: renderProps,
            generatorName: "noEventsContent",
            customGenerator: options.noEventsContent,
            defaultGenerator: $6c1350034e49c52e$var$renderNoEventsInner,
            classNameGenerator: options.noEventsClassNames,
            didMount: options.noEventsDidMount,
            willUnmount: options.noEventsWillUnmount
        }, (InnerContent)=>(0, $450fc775b2f7950e$export$c8a8987d4410bf2d)(InnerContent, {
                elTag: "div",
                elClasses: [
                    "fc-list-empty-cushion"
                ]
            }));
    }
    renderSegList(allSegs, dayDates) {
        let { theme: theme, options: options } = this.context;
        let { timeHeaderId: timeHeaderId, eventHeaderId: eventHeaderId, dateHeaderIdRoot: dateHeaderIdRoot } = this.state;
        let segsByDay = $6c1350034e49c52e$var$groupSegsByDay(allSegs); // sparse array
        return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)((0, $5913100b2ed0f596$export$6e4b1d19c6e2e012), {
            unit: "day"
        }, (nowDate, todayRange)=>{
            let innerNodes = [];
            for(let dayIndex = 0; dayIndex < segsByDay.length; dayIndex += 1){
                let daySegs = segsByDay[dayIndex];
                if (daySegs) {
                    let dayStr = (0, $5913100b2ed0f596$export$5dbe06c6d8c68cfb)(dayDates[dayIndex]);
                    let dateHeaderId = dateHeaderIdRoot + "-" + dayStr;
                    // append a day header
                    innerNodes.push((0, $450fc775b2f7950e$export$c8a8987d4410bf2d)($6c1350034e49c52e$var$ListViewHeaderRow, {
                        key: dayStr,
                        cellId: dateHeaderId,
                        dayDate: dayDates[dayIndex],
                        todayRange: todayRange
                    }));
                    daySegs = (0, $5913100b2ed0f596$export$4d522598b426bb73)(daySegs, options.eventOrder);
                    for (let seg of daySegs)innerNodes.push((0, $450fc775b2f7950e$export$c8a8987d4410bf2d)($6c1350034e49c52e$var$ListViewEventRow, Object.assign({
                        key: dayStr + ":" + seg.eventRange.instance.instanceId /* are multiple segs for an instanceId */ ,
                        seg: seg,
                        isDragging: false,
                        isResizing: false,
                        isDateSelecting: false,
                        isSelected: false,
                        timeHeaderId: timeHeaderId,
                        eventHeaderId: eventHeaderId,
                        dateHeaderId: dateHeaderId
                    }, (0, $5913100b2ed0f596$export$6dabbe08653f866f)(seg, todayRange, nowDate))));
                }
            }
            return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("table", {
                className: "fc-list-table " + theme.getClass("table")
            }, (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("thead", null, (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("tr", null, (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("th", {
                scope: "col",
                id: timeHeaderId
            }, options.timeHint), (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("th", {
                scope: "col",
                "aria-hidden": true
            }), (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("th", {
                scope: "col",
                id: eventHeaderId
            }, options.eventHint))), (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("tbody", null, innerNodes));
        });
    }
    _eventStoreToSegs(eventStore, eventUiBases, dayRanges) {
        return this.eventRangesToSegs((0, $5913100b2ed0f596$export$c9170ad7d4cd7e57)(eventStore, eventUiBases, this.props.dateProfile.activeRange, this.context.options.nextDayThreshold).fg, dayRanges);
    }
    eventRangesToSegs(eventRanges, dayRanges) {
        let segs = [];
        for (let eventRange of eventRanges)segs.push(...this.eventRangeToSegs(eventRange, dayRanges));
        return segs;
    }
    eventRangeToSegs(eventRange, dayRanges) {
        let { dateEnv: dateEnv } = this.context;
        let { nextDayThreshold: nextDayThreshold } = this.context.options;
        let range = eventRange.range;
        let allDay = eventRange.def.allDay;
        let dayIndex;
        let segRange;
        let seg;
        let segs = [];
        for(dayIndex = 0; dayIndex < dayRanges.length; dayIndex += 1){
            segRange = (0, $5913100b2ed0f596$export$ae1af26003f05816)(range, dayRanges[dayIndex]);
            if (segRange) {
                seg = {
                    component: this,
                    eventRange: eventRange,
                    start: segRange.start,
                    end: segRange.end,
                    isStart: eventRange.isStart && segRange.start.valueOf() === range.start.valueOf(),
                    isEnd: eventRange.isEnd && segRange.end.valueOf() === range.end.valueOf(),
                    dayIndex: dayIndex
                };
                segs.push(seg);
                // detect when range won't go fully into the next day,
                // and mutate the latest seg to the be the end.
                if (!seg.isEnd && !allDay && dayIndex + 1 < dayRanges.length && range.end < dateEnv.add(dayRanges[dayIndex + 1].start, nextDayThreshold)) {
                    seg.end = range.end;
                    seg.isEnd = true;
                    break;
                }
            }
        }
        return segs;
    }
}
function $6c1350034e49c52e$var$renderNoEventsInner(renderProps) {
    return renderProps.text;
}
function $6c1350034e49c52e$var$computeDateVars(dateProfile) {
    let dayStart = (0, $5913100b2ed0f596$export$9e5f44173e64f162)(dateProfile.renderRange.start);
    let viewEnd = dateProfile.renderRange.end;
    let dayDates = [];
    let dayRanges = [];
    while(dayStart < viewEnd){
        dayDates.push(dayStart);
        dayRanges.push({
            start: dayStart,
            end: (0, $5913100b2ed0f596$export$625550452a3fa3ec)(dayStart, 1)
        });
        dayStart = (0, $5913100b2ed0f596$export$625550452a3fa3ec)(dayStart, 1);
    }
    return {
        dayDates: dayDates,
        dayRanges: dayRanges
    };
}
// Returns a sparse array of arrays, segs grouped by their dayIndex
function $6c1350034e49c52e$var$groupSegsByDay(segs) {
    let segsByDay = []; // sparse array
    let i;
    let seg;
    for(i = 0; i < segs.length; i += 1){
        seg = segs[i];
        (segsByDay[seg.dayIndex] || (segsByDay[seg.dayIndex] = [])).push(seg);
    }
    return segsByDay;
}
var $6c1350034e49c52e$var$css_248z = ':root{--fc-list-event-dot-width:10px;--fc-list-event-hover-bg-color:#f5f5f5}.fc-theme-standard .fc-list{border:1px solid var(--fc-border-color)}.fc .fc-list-empty{align-items:center;background-color:var(--fc-neutral-bg-color);display:flex;height:100%;justify-content:center}.fc .fc-list-empty-cushion{margin:5em 0}.fc .fc-list-table{border-style:hidden;width:100%}.fc .fc-list-table tr>*{border-left:0;border-right:0}.fc .fc-list-sticky .fc-list-day>*{background:var(--fc-page-bg-color);position:sticky;top:0}.fc .fc-list-table thead{left:-10000px;position:absolute}.fc .fc-list-table tbody>tr:first-child th{border-top:0}.fc .fc-list-table th{padding:0}.fc .fc-list-day-cushion,.fc .fc-list-table td{padding:8px 14px}.fc .fc-list-day-cushion:after{clear:both;content:"";display:table}.fc-theme-standard .fc-list-day-cushion{background-color:var(--fc-neutral-bg-color)}.fc-direction-ltr .fc-list-day-text,.fc-direction-rtl .fc-list-day-side-text{float:left}.fc-direction-ltr .fc-list-day-side-text,.fc-direction-rtl .fc-list-day-text{float:right}.fc-direction-ltr .fc-list-table .fc-list-event-graphic{padding-right:0}.fc-direction-rtl .fc-list-table .fc-list-event-graphic{padding-left:0}.fc .fc-list-event.fc-event-forced-url{cursor:pointer}.fc .fc-list-event:hover td{background-color:var(--fc-list-event-hover-bg-color)}.fc .fc-list-event-graphic,.fc .fc-list-event-time{white-space:nowrap;width:1px}.fc .fc-list-event-dot{border:calc(var(--fc-list-event-dot-width)/2) solid var(--fc-event-border-color);border-radius:calc(var(--fc-list-event-dot-width)/2);box-sizing:content-box;display:inline-block;height:0;width:0}.fc .fc-list-event-title a{color:inherit;text-decoration:none}.fc .fc-list-event.fc-event-forced-url:hover a{text-decoration:underline}';
(0, $5913100b2ed0f596$export$c373adc892eb6355)($6c1350034e49c52e$var$css_248z);




const $3438b86bfd594539$var$OPTION_REFINERS = {
    listDayFormat: $3438b86bfd594539$var$createFalsableFormatter,
    listDaySideFormat: $3438b86bfd594539$var$createFalsableFormatter,
    noEventsClassNames: (0, $5913100b2ed0f596$export$7ccc53e8f1e7dfc5),
    noEventsContent: (0, $5913100b2ed0f596$export$7ccc53e8f1e7dfc5),
    noEventsDidMount: (0, $5913100b2ed0f596$export$7ccc53e8f1e7dfc5),
    noEventsWillUnmount: (0, $5913100b2ed0f596$export$7ccc53e8f1e7dfc5)
};
function $3438b86bfd594539$var$createFalsableFormatter(input) {
    return input === false ? null : (0, $5913100b2ed0f596$export$d141bba7fdc215a3)(input);
}
var $3438b86bfd594539$export$2e2bcd8739ae039 = (0, $641adb510ed163e1$export$ae829ec7b2625219)({
    name: "@fullcalendar/list",
    optionRefiners: $3438b86bfd594539$var$OPTION_REFINERS,
    views: {
        list: {
            component: (0, $6c1350034e49c52e$export$84d0dd190d551cd1),
            buttonTextKey: "list",
            listDayFormat: {
                month: "long",
                day: "numeric",
                year: "numeric"
            }
        },
        listDay: {
            type: "list",
            duration: {
                days: 1
            },
            listDayFormat: {
                weekday: "long"
            }
        },
        listWeek: {
            type: "list",
            duration: {
                weeks: 1
            },
            listDayFormat: {
                weekday: "long"
            },
            listDaySideFormat: {
                month: "long",
                day: "numeric",
                year: "numeric"
            }
        },
        listMonth: {
            type: "list",
            duration: {
                month: 1
            },
            listDaySideFormat: {
                weekday: "long"
            }
        },
        listYear: {
            type: "list",
            duration: {
                year: 1
            },
            listDaySideFormat: {
                weekday: "long"
            }
        }
    }
});




var $YChVI = parcelRequire("YChVI");

function $cc18fddd8a5815ce$export$a626ee2230ff198e(date, calendar) {
    if (!(calendar instanceof (0, $5913100b2ed0f596$export$a9c996f45e5784d0))) throw new Error("must supply a CalendarApi instance");
    let { dateEnv: dateEnv } = calendar.getCurrentData();
    return $cc18fddd8a5815ce$var$convertToMoment(date, dateEnv.timeZone, null, dateEnv.locale.codes[0]);
}
function $cc18fddd8a5815ce$export$f50946cb289988ad(fcDuration) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($YChVI))).duration(fcDuration); // moment accepts all the props that fc.Duration already has!
}
// Internal Utils
function $cc18fddd8a5815ce$var$convertToMoment(input, timeZone, timeZoneOffset, locale) {
    let mom;
    if (timeZone === "local") mom = (0, (/*@__PURE__*/$parcel$interopDefault($YChVI)))(input);
    else if (timeZone === "UTC") mom = (0, (/*@__PURE__*/$parcel$interopDefault($YChVI))).utc(input);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($YChVI))).tz) mom = (0, (/*@__PURE__*/$parcel$interopDefault($YChVI))).tz(input, timeZone);
    else {
        mom = (0, (/*@__PURE__*/$parcel$interopDefault($YChVI))).utc(input);
        if (timeZoneOffset != null) mom.utcOffset(timeZoneOffset);
    }
    mom.locale(locale);
    return mom;
}
function $cc18fddd8a5815ce$var$formatWithCmdStr(cmdStr, arg) {
    let cmd = $cc18fddd8a5815ce$var$parseCmdStr(cmdStr);
    if (arg.end) {
        let startMom = $cc18fddd8a5815ce$var$convertToMoment(arg.start.array, arg.timeZone, arg.start.timeZoneOffset, arg.localeCodes[0]);
        let endMom = $cc18fddd8a5815ce$var$convertToMoment(arg.end.array, arg.timeZone, arg.end.timeZoneOffset, arg.localeCodes[0]);
        return $cc18fddd8a5815ce$var$formatRange(cmd, $cc18fddd8a5815ce$var$createMomentFormatFunc(startMom), $cc18fddd8a5815ce$var$createMomentFormatFunc(endMom), arg.defaultSeparator);
    }
    return $cc18fddd8a5815ce$var$convertToMoment(arg.date.array, arg.timeZone, arg.date.timeZoneOffset, arg.localeCodes[0]).format(cmd.whole); // TODO: test for this
}
function $cc18fddd8a5815ce$var$createMomentFormatFunc(mom) {
    return (cmdStr)=>cmdStr ? mom.format(cmdStr) : "" // because calling with blank string results in ISO8601 :(
    ;
}
function $cc18fddd8a5815ce$var$parseCmdStr(cmdStr) {
    let parts = cmdStr.match(/^(.*?)\{(.*)\}(.*)$/); // TODO: lookbehinds for escape characters
    if (parts) {
        let middle = $cc18fddd8a5815ce$var$parseCmdStr(parts[2]);
        return {
            head: parts[1],
            middle: middle,
            tail: parts[3],
            whole: parts[1] + middle.whole + parts[3]
        };
    }
    return {
        head: null,
        middle: null,
        tail: null,
        whole: cmdStr
    };
}
function $cc18fddd8a5815ce$var$formatRange(cmd, formatStart, formatEnd, separator) {
    if (cmd.middle) {
        let startHead = formatStart(cmd.head);
        let startMiddle = $cc18fddd8a5815ce$var$formatRange(cmd.middle, formatStart, formatEnd, separator);
        let startTail = formatStart(cmd.tail);
        let endHead = formatEnd(cmd.head);
        let endMiddle = $cc18fddd8a5815ce$var$formatRange(cmd.middle, formatStart, formatEnd, separator);
        let endTail = formatEnd(cmd.tail);
        if (startHead === endHead && startTail === endTail) return startHead + (startMiddle === endMiddle ? startMiddle : startMiddle + separator + endMiddle) + startTail;
    }
    let startWhole = formatStart(cmd.whole);
    let endWhole = formatEnd(cmd.whole);
    if (startWhole === endWhole) return startWhole;
    return startWhole + separator + endWhole;
}
var $cc18fddd8a5815ce$export$2e2bcd8739ae039 = (0, $641adb510ed163e1$export$ae829ec7b2625219)({
    name: "@fullcalendar/moment",
    cmdFormatter: $cc18fddd8a5815ce$var$formatWithCmdStr
});


var $3344c5fbf4984a06$var$locale = {
    code: "en-us",
    noEventsText: "Events Loading ..."
};
function $3344c5fbf4984a06$var$load_calendar(view) {
    var header = {
        left: "",
        right: ""
    };
    if (view == "dayGridMonth") header = {
        left: "title",
        right: "prev,next today"
    };
    const calendarEl = document.getElementById("calendar-js");
    const calendar = new (0, $641adb510ed163e1$export$e1aef45b828286de)(calendarEl, {
        locale: $3344c5fbf4984a06$var$locale,
        plugins: [
            (0, $a168f87f13e0ca2a$export$2e2bcd8739ae039),
            (0, $2c4f17c4f7fb59ef$export$2e2bcd8739ae039),
            (0, $3438b86bfd594539$export$2e2bcd8739ae039),
            (0, $cc18fddd8a5815ce$export$2e2bcd8739ae039)
        ],
        initialView: view,
        eventSources: [
            {
                url: "https://faas-sfo3-7872a1dd.doserverless.co/api/v1/web/fn-67f34cf4-c3ed-479c-839e-2f7206029fcb/wildweb/calcache",
                format: "ics" // important!
            },
            {
                url: "https://api.called.app/rest/calendar/community/998",
                format: "ics"
            }
        ],
        contentHeight: "auto",
        height: "auto",
        headerToolbar: header,
        listDayFormat: "ddd, MMM Do",
        visibleRange: function(currentDate) {
            var startDate = new Date(currentDate.valueOf());
            var endDate = new Date(currentDate.valueOf());
            startDate.setDate(startDate.getDate());
            endDate.setDate(endDate.getDate() + 90);
            return {
                start: startDate,
                end: endDate
            };
        },
        eventClick: (info)=>{
            var e = info.event;
            var title = e.title + "<br>" + e.start.toLocaleDateString() + " " + e.start.toLocaleTimeString();
            title = title.replace(":00 ", " ");
            document.querySelector("#dialog h3").innerHTML = title;
            document.querySelector("#dialog section p").innerHTML = info.event.extendedProps.description || "<strong>no details found</strong>";
            document.querySelector("#dialog").showModal();
            setTimeout(()=>{
                document.querySelectorAll("#dialog section a").forEach((item)=>{
                    item.target = "_blank";
                });
            }, 0);
        }
    });
    calendar.render();
}
window.load_calendar = $3344c5fbf4984a06$var$load_calendar;

})();
//# sourceMappingURL=cal.js.map
